        (function rotateBrowserIdentityAfterLogout() {
            const currentUrl = new URL(window.location.href);
            if (currentUrl.searchParams.get('logged_out') !== '1') return;
            try {
                localStorage.removeItem('maplytics_token');
                localStorage.removeItem('maplytics_token_last_activity');
            } catch (error) {
                // Storage can be unavailable in private contexts.
            }
            currentUrl.searchParams.delete('logged_out');
            const cleanUrl = `${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}`;
            window.history.replaceState({}, '', cleanUrl || '/');
        })();

        // Configuration dynamique minimale injectée par le template. Le moteur
        // Home reste statique, minifié et cacheable entre deux navigations.
        const MAPLYTICS_BOOTSTRAP = typeof MAPLYTICS_HOME_PAGE_CONFIG !== 'undefined'
            ? MAPLYTICS_HOME_PAGE_CONFIG
            : {};
        const APP_CONFIG = {
            userFeatures: Array.isArray(MAPLYTICS_BOOTSTRAP.userFeatures)
                ? MAPLYTICS_BOOTSTRAP.userFeatures
                : [],
            userAccess: MAPLYTICS_BOOTSTRAP.userAccess || {},
            userId: MAPLYTICS_BOOTSTRAP.userId || null,
            userPlan: MAPLYTICS_BOOTSTRAP.userPlan || 'free',
            appShellV2: Boolean(MAPLYTICS_BOOTSTRAP.appShellV2),
            geoManagerV2: Boolean(MAPLYTICS_BOOTSTRAP.geoManagerV2),
            geoManagerV2Version: '20260925-c06-folder-render',
            geoManagerV2Css: '/static/css/geo-manager-v2.css?v=20260921-v28-compact-filters',
            geoManagerV2Js: '/static/js/geo-manager-v2/geo-manager-v2.js?v=20260925-c06-folder-render',
            enableLegacyAdminPanel: Boolean(MAPLYTICS_BOOTSTRAP.enableLegacyAdminPanel),
            // Helper pour vérifier si l'utilisateur a une feature
            hasFeature: function(featureCode) {
                return this.userFeatures.includes(featureCode);
            }
        };
        window.APP_CONFIG = APP_CONFIG;
        const homeNavigationReads = window.MaplyticsHomeBootstrap.createNavigationReadGuard();
        // This authority is used by controls bound during the initial script
        // evaluation.  It must exist before any of those controls call it;
        // defining it later creates a temporal-dead-zone error and leaves Home
        // only partially initialised for anonymous visitors.
        let connectedUserFeatures = [...APP_CONFIG.userFeatures];
        const hasFeature = (featureCode) => {
            if (connectedUserFeatures.length > 0) {
                return connectedUserFeatures.includes(featureCode);
            }
            return APP_CONFIG.userFeatures.includes(featureCode);
        };
        window.maplyticsHasFeature = hasFeature;
        const HOME_BROWSER_STORAGE = window.maplyticsHomeBrowserStorage || null;
        const HOME_ZONE_STORAGE_KEY = HOME_BROWSER_STORAGE?.zoneStorageKey
            || 'maplytics_zones_isochrone';
        const homeZonesStorage = HOME_BROWSER_STORAGE?.zoneStorage || Object.freeze({
            getItem: () => null,
            removeItem: () => {},
            setItem: () => {
                const error = new Error('Le stockage local attribué au compte est indisponible.');
                error.code = 'home_owner_storage_unavailable';
                throw error;
            },
        });
        const pageStorageFallbackScope = `page-${Date.now()}-${Math.random().toString(36).slice(2)}`;
        const scopedLocalStorageKey = (baseKey) => (
            HOME_BROWSER_STORAGE?.localKey?.(baseKey)
            || `${baseKey}:disabled:${pageStorageFallbackScope}`
        );
        const scopedSessionStorageKey = (baseKey) => (
            HOME_BROWSER_STORAGE?.sessionKey?.(baseKey)
            || `${baseKey}:disabled:${pageStorageFallbackScope}`
        );
        const DEBUG_MODE = MAPLYTICS_BOOTSTRAP.environment === 'development';
        const debugLog = (...args) => { if (DEBUG_MODE) console.log(...args); };
        window.debugLog = debugLog;
        debugLog('[Features] Chargées:', APP_CONFIG.userFeatures.length, 'features');

        window.leafletLoaded = typeof L !== 'undefined';
        const tabs = document.querySelectorAll('.tab-button');
        const panels = document.querySelectorAll('.tab-panel');
        const mapRegistry = {};

        function mapHasUsableViewport(map) {
            const container = map?.getContainer?.();
            if (!container?.isConnected) return false;
            const rect = container.getBoundingClientRect();
            return rect.width > 0 && rect.height > 0;
        }

        function afterMapLayout(callback, delay = 0) {
            const run = () => {
                window.requestAnimationFrame(() => {
                    window.requestAnimationFrame(callback);
                });
            };
            if (delay > 0) {
                window.setTimeout(run, delay);
            } else {
                run();
            }
        }

        function invalidateMapWhenVisible(map, delay = 0) {
            if (!map || typeof map.invalidateSize !== 'function') return;
            afterMapLayout(() => {
                if (mapHasUsableViewport(map)) {
                    map.invalidateSize({ animate: false });
                }
            }, delay);
        }

        function invalidateMapControllerWhenVisible(controller, delay = 0) {
            invalidateMapWhenVisible(controller?.map, delay);
        }

        function invalidateVisibleMaps(delay = 0) {
            afterMapLayout(() => {
                Object.values(mapRegistry).forEach((controller) => {
                    if (mapHasUsableViewport(controller?.map)) {
                        controller.map.invalidateSize({ animate: false });
                    }
                });
            }, delay);
        }

        window.invalidateVisibleMaps = invalidateVisibleMaps;

        const toolPanelController = window.MaplyticsHomeBootstrap.createToolPanelController({
            tabs,
            panels,
            mapRegistry,
            documentRef: document,
            locationRef: window.location,
            historyRef: window.history,
            ensurePanelMap: (panelType) => ensurePanelMap(panelType),
            ensureImportWorkspaceLoaded: () => ensureImportWorkspaceLoaded(),
            ensureGeoManagerLoaded: () => ensureGeoManagerV2Loaded(),
            invalidateMapController: invalidateMapControllerWhenVisible,
            showMessage: showAppMessage,
            setResultsSheet: (state) => setAppShellV2ResultsSheet?.(state),
            updateMobileTray: () => updateMobilePanelTray?.(),
        });
        const initialActivePanelId = toolPanelController.initialPanelId;
        const whiteZoneOpportunityId = toolPanelController.initialWhiteZoneOpportunityId;
        const loadToolPanelAssets = (...args) => toolPanelController.loadAssets(...args);
        const activateToolPanel = (...args) => toolPanelController.activate(...args);
        toolPanelController.bindTabs();

        initAppShellV2Interactions();

        const setFormLoading = (form, loading) => {
            const submitBtn = form.querySelector('button[type="submit"]');
            if (!submitBtn) return;
            const defaultLabel = submitBtn.dataset.label || submitBtn.textContent;
            submitBtn.dataset.label = defaultLabel;
            submitBtn.disabled = loading;
            submitBtn.textContent = loading ? 'Calcul en cours...' : defaultLabel;
        };

        const {
            formatDuration,
            renderSourceChip,
            renderTransportModeChip,
            formatValue,
            calculateStatistics,
            renderStatistics: renderHomeStatistics,
        } = window.MaplyticsHomeResults;
        const renderStatistics = (statsEl, statsGridEl, sourceDistEl, stats, isPremium = false) => {
            return renderHomeStatistics(statsEl, statsGridEl, sourceDistEl, stats, isPremium, PremiumGate);
        };

        const homeTablePresentation = window.MaplyticsHomeTablePresentation.create({
            documentRef: document,
            renderSourceChip,
            renderTransportModeChip,
            formatValue,
            debugLog,
            showMessage: showAppMessage,
        });
        const {
            resetTable,
            filterRows,
            applyAdvancedFilters,
            getFilterValues,
            resetFilters,
            renderTablePage,
            selectAllTableData,
            updateTableInfo,
        } = homeTablePresentation;
        const EXPORT_TABLE_COLUMN_LABELS = window.MaplyticsHomeTablePresentation.COLUMN_LABELS;
        const EXPORT_TABLE_DEMOGRAPHIC_COLUMNS = (
            window.MaplyticsHomeTablePresentation.DEMOGRAPHIC_COLUMNS
        );

        const tableControllers = {
            export: {
                table: document.getElementById('exportTable'),
                container: document.getElementById('exportTableContainer'),
                search: document.getElementById('exportTableSearch'),
                searchInput: document.getElementById('exportTableSearchInput'),
                info: document.getElementById('exportTableInfo'),
                pagination: document.getElementById('exportTablePagination'),
                prevBtn: document.getElementById('exportTablePrev'),
                nextBtn: document.getElementById('exportTableNext'),
                pageInfo: document.getElementById('exportTablePageInfo'),
                actions: document.getElementById('exportTableActions'),
                selectAllBtn: document.getElementById('exportSelectAllBtn'),
                allRows: [],
                filteredRows: [],
                currentPage: 1,
                rowsPerPage: window.innerWidth <= 768 ? 20 : 50, // Réduire sur mobile
                columns: [],
                isPremium: false, // Compatibilité: droit demographic_data effectif
            },
            import: {
                table: document.getElementById('importTable'),
                container: document.getElementById('importTableContainer'),
                search: document.getElementById('importTableSearch'),
                searchInput: document.getElementById('importTableSearchInput'),
                info: document.getElementById('importTableInfo'),
                pagination: document.getElementById('importTablePagination'),
                prevBtn: document.getElementById('importTablePrev'),
                nextBtn: document.getElementById('importTableNext'),
                pageInfo: document.getElementById('importTablePageInfo'),
                actions: document.getElementById('importTableActions'),
                selectAllBtn: document.getElementById('importSelectAllBtn'),
                allRows: [],
                filteredRows: [],
                currentPage: 1,
                rowsPerPage: window.innerWidth <= 768 ? 20 : 50, // Réduire sur mobile
                columns: [],
                isPremium: false, // Compatibilité: droit demographic_data effectif
            },
        };

        let activeVisualExportSurface = 'export';
        const importDetailedExportAdapter = window.MaplyticsDetailedExportSurface?.createAdapter({
            surface: 'import',
            getAllRows: () => tableControllers.import.allRows,
            getFilteredRows: () => tableControllers.import.filteredRows,
            getColumns: () => tableControllers.import.columns,
            getAdditionalPoints: () => {
                const manager = window.maplyticsImportCompetitorsManager;
                if (!manager) return [];
                const points = [];
                if (manager.visibleOnMap) {
                    const view = manager.getCompetitorView?.();
                    (Array.isArray(view?.competitors) ? view.competitors : []).forEach(
                        (competitor, index) => {
                            const latitude = Number(competitor?.lat ?? competitor?.latitude);
                            const longitude = Number(
                                competitor?.lon ?? competitor?.lng ?? competitor?.longitude,
                            );
                            if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) return;
                            points.push({
                                id: String(manager.competitorIdentity?.(competitor) || `competitor-${index + 1}`),
                                kind: 'competitor',
                                latitude,
                                longitude,
                                label: manager.competitorsNumbered
                                    ? String(competitor.visible_rank || index + 1)
                                    : `C${index + 1}`,
                                color: manager.competitorMarkerColor || '#dc2626',
                            });
                        },
                    );
                }
                if (manager.customPointsVisible !== false) {
                    (Array.isArray(manager.customPoints) ? manager.customPoints : [])
                        .filter((point) => point?.visible !== false)
                        .forEach((point, index) => {
                            const latitude = Number(point?.lat ?? point?.latitude);
                            const longitude = Number(point?.lon ?? point?.lng ?? point?.longitude);
                            if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) return;
                            points.push({
                                id: String(point?.id || `custom-${index + 1}`),
                                kind: 'custom',
                                latitude,
                                longitude,
                                label: String(point?.name || `P${index + 1}`).slice(0, 12),
                                color: point?.color || '#2563eb',
                            });
                        });
                }
                return points;
            },
        }) || null;
        window.maplyticsImportDetailedExportAdapter = importDetailedExportAdapter;

        const importVisualRuntime = () => {
            const engineAvailable = Boolean(
                window.MaplyticsMapVisualExport
                && window.MaplyticsVisualExportRenderer?.createExporter
                && importMapController?.captureVisualExportSnapshot,
            );
            if (!engineAvailable) {
                return {
                    available: false,
                    reason: 'Le moteur d’export visuel est indisponible. Rechargez la page.',
                };
            }
            const mode = document.getElementById('visualizationMode_importMap')?.value;
            const choropleth = importMapController?.getChoroplethSnapshot?.();
            if (
                mode === 'choropleth'
                && !['success', 'warning', 'empty'].includes(choropleth?.status)
            ) {
                return {
                    available: false,
                    reason: choropleth?.status === 'error'
                        ? choropleth.statusMessage
                        : 'La choroplèthe du dernier import est encore en préparation.',
                };
            }
            return {available: true, reason: ''};
        };

        let importDetailedExportBusy = false;
        let importDetailedExportError = '';
        const syncImportDetailedExportChoices = () => {
            if (!importDetailedExportAdapter) return null;
            const visualRuntime = importVisualRuntime();
            const state = importDetailedExportAdapter.getAvailability({
                excelAllowed: typeof window.maplyticsHasFeature === 'function'
                    && window.maplyticsHasFeature('export_excel'),
                visualRuntimeAvailable: visualRuntime.available,
                visualRuntimeReason: visualRuntime.reason,
            });
            window.MaplyticsDetailedExportSurface?.syncChoiceBand?.(
                'importDetailedExportChoices',
                [
                    {name: 'detail-xlsx', ...state.excel},
                    {name: 'visual-map', ...state.visual},
                ],
                {
                    busy: importDetailedExportBusy,
                    busyMessage: 'Préparation du classeur Import…',
                    errorMessage: importDetailedExportError,
                },
            );
            return state;
        };
        window.maplyticsSyncImportDetailedExportChoices = syncImportDetailedExportChoices;

        importDetailedExportAdapter?.subscribe?.((change) => {
            window.MaplyticsMultiZoneExcel?.invalidate?.(
                'import',
                change.hard
                    ? 'La source Import a changé. Validez le nouvel import avant de générer.'
                    : 'La vue Import a changé. Actualisez l’aperçu avant de générer.',
                {hard: change.hard},
            );
            if (activeVisualExportSurface === 'import') {
                if (change.hard) {
                    window.maplyticsVisualExportController?.sync?.(change.reason);
                } else {
                    window.maplyticsVisualExportController?.invalidate?.(change.reason);
                    window.maplyticsVisualExportController?.sync?.(change.reason);
                }
            }
            syncImportDetailedExportChoices();
            document.dispatchEvent(new CustomEvent('maplytics:import-export-state-changed', {
                detail: change,
            }));
        });

        const filteredExportRows = (panelName, format = 'table') => {
            const controller = tableControllers[panelName];
            if (!controller) return [];
            const source = Array.isArray(controller.filteredRows)
                ? controller.filteredRows
                : controller.allRows;
            const visibleColumns = Array.isArray(controller.columns)
                ? controller.columns
                : [];
            if (!Array.isArray(source) || !visibleColumns.length) return [];
            const allowedColumns = new Set(visibleColumns);
            if (format === 'geojson') {
                [
                    'geometry',
                    'lat',
                    'latitude',
                    'lon',
                    'lng',
                    'longitude',
                ].forEach((column) => allowedColumns.add(column));
            }
            const projection = panelName === 'export'
                ? window.maplyticsZonePresentationController?.getSnapshot?.()
                : null;
            const currentProjectionFingerprint = projection?.status === 'ready'
                ? String(projection.projectionFingerprint || '')
                : '';
            return source.map((row) => {
                const projected = Object.fromEntries(
                    [...allowedColumns]
                        .filter((column) => Object.prototype.hasOwnProperty.call(row, column))
                        .map((column) => [column, row[column]]),
                );
                if (
                    currentProjectionFingerprint
                    && allowedColumns.has('zone_projection_fingerprint')
                ) {
                    projected.zone_projection_fingerprint = currentProjectionFingerprint;
                }
                return projected;
            });
        };

        const focusExportZoneRecalculation = () => {
            zonesManager.switchTab('tab1');
            exportForm?.scrollIntoView?.({behavior: 'smooth', block: 'start'});
            window.setTimeout(() => {
                document.getElementById('exportQuery')?.focus?.({preventScroll: true});
            }, 250);
        };

        const openExportSavedAnalyses = () => {
            zonesManager.switchTab('tab5');
            window.setTimeout(() => {
                document.getElementById('historyContent')?.focus?.({preventScroll: true});
            }, 0);
        };

        const openMultiZoneExcelDialog = (trigger, surface = 'export') => {
            const resolvedSurface = surface === 'import' ? 'import' : 'export';
            const controller = tableControllers[resolvedSurface];
            const importSnapshot = resolvedSurface === 'import'
                ? importDetailedExportAdapter?.getWorkbookSnapshot?.()
                : null;
            const columns = importSnapshot?.columns || (
                Array.isArray(controller?.columns) ? [...controller.columns] : []
            );
            let filteredRows = importSnapshot?.filteredRows || (
                Array.isArray(controller?.filteredRows) ? controller.filteredRows : []
            );
            let allRows = importSnapshot?.allRows || (
                Array.isArray(controller?.allRows) ? controller.allRows : []
            );
            if (!window.MaplyticsMultiZoneExcel?.open) {
                showAppMessage(
                    'error',
                    'Export Excel indisponible',
                    'Le configurateur du classeur n’est pas chargé. Rechargez la page.',
                );
                return null;
            }
            const exclusivePresentation = () => {
                if (resolvedSurface !== 'export') {
                    return {available: false, reason: 'Les imports ne sont pas des ZDC imbriquées.'};
                }
                const snapshot = window.maplyticsZonePresentationController
                    ?.getSnapshot?.() || {};
                const available = zonesManager?.zones?.size > 1
                    && snapshot.exclusive?.available === true
                    && Boolean(snapshot.projectionFingerprint);
                return {
                    available,
                    reason: available
                        ? ''
                        : String(snapshot.exclusive?.reasons?.[0]
                            || 'Les zones doivent partager la même origine, le même transport et le même graphe.'),
                };
            };
            const currentZoneCatalog = (presentationMode = '') => {
                if (resolvedSurface === 'import') {
                    return importDetailedExportAdapter
                        ?.getWorkbookSnapshot?.().zoneCatalog || [];
                }
                if (typeof zonesManager === 'undefined' || !zonesManager?.zones) {
                    return [];
                }
                const snapshot = window.maplyticsZonePresentationController
                    ?.getSnapshot?.() || {};
                const snapshotMode = snapshot.mapMode === 'exclusive'
                    || snapshot.mode === 'exclusive'
                    ? 'exclusive'
                    : 'cumulative';
                const requestedMode = presentationMode === 'exclusive'
                    ? 'exclusive'
                    : presentationMode === 'cumulative'
                        ? 'cumulative'
                        : snapshotMode;
                const projectionMatches = snapshot.status === 'ready'
                    && snapshotMode === requestedMode
                    && snapshot.projection?.mode === requestedMode;
                const projectedCounts = new Map();
                (projectionMatches ? zonesManager.getAggregatedRowsForZones() : []).forEach((row) => {
                    const datasetRef = String(row?.zone_dataset_ref || '').trim();
                    if (!datasetRef) return;
                    projectedCounts.set(
                        datasetRef,
                        (projectedCounts.get(datasetRef) || 0) + 1,
                    );
                });
                return Array.from(zonesManager.zones.values()).map((zone) => {
                    const datasetRef = String(zone?.id || '').trim();
                    const isDistance = zone?.zoneType === 'isodistance';
                    const threshold = Number(zone?.minutes);
                    return {
                        dataset_ref: datasetRef,
                        label: String(zone?.name || 'Zone non renseignée'),
                        folder: String(zone?.folder || '').trim() || 'Sans dossier',
                        point_name: zonePointName(zone),
                        origin_address: zoneOriginAddress(zone),
                        mode_transport: zonesManager.resolveTransportMode(zone),
                        zone_type: String(zone?.zoneType || 'isochrone'),
                        duration_min: !isDistance && Number.isFinite(threshold)
                            ? threshold
                            : null,
                        distance_km: isDistance && Number.isFinite(threshold)
                            ? threshold
                            : null,
                        projected_row_count: projectedCounts.get(datasetRef) || 0,
                    };
                });
            };
            const currentSourceRefs = () => {
                if (resolvedSurface === 'import') {
                    return importDetailedExportAdapter
                        ?.getWorkbookSnapshot?.().sourceRefs || [];
                }
                if (typeof zonesManager === 'undefined' || !zonesManager?.zones) {
                    return [];
                }
                return Array.from(zonesManager.zones.values()).flatMap((zone) => {
                    const datasetRef = String(zone?.id || '').trim();
                    const source = zone?.pdfSource || (
                        zone?.data?.id || zone?.data?.job_id
                            ? {kind: 'job', job_id: zone.data.id || zone.data.job_id}
                            : null
                    );
                    const lifecycle = window.MaplyticsZonePresentation
                        ?.sourceLifecycle?.(source);
                    if (
                        !datasetRef
                        || source?.kind !== 'job'
                        || !source?.job_id
                        || lifecycle?.verifiable !== true
                    ) {
                        return [];
                    }
                    return [{
                        dataset_ref: datasetRef,
                        kind: 'job',
                        job_id: String(source.job_id),
                    }];
                });
            };
            const currentRows = (presentationMode = '') => {
                if (resolvedSurface === 'import') {
                    const snapshot = importDetailedExportAdapter?.getWorkbookSnapshot?.();
                    return {
                        filteredRows: snapshot?.filteredRows || [],
                        allRows: snapshot?.allRows || [],
                    };
                }
                const snapshot = window.maplyticsZonePresentationController
                    ?.getSnapshot?.() || {};
                const snapshotMode = snapshot.mapMode === 'exclusive'
                    || snapshot.mode === 'exclusive'
                    ? 'exclusive'
                    : 'cumulative';
                const requestedMode = presentationMode === 'exclusive'
                    ? 'exclusive'
                    : presentationMode === 'cumulative'
                        ? 'cumulative'
                        : snapshotMode;
                if (
                    snapshot.status !== 'ready'
                    || snapshotMode !== requestedMode
                    || snapshot.projection?.mode !== requestedMode
                ) {
                    return {filteredRows: [], allRows: []};
                }
                const projectedRows = zonesManager.getAggregatedRowsForZones();
                const currentFiltered = Array.isArray(controller.filteredRows)
                    ? controller.filteredRows
                    : [];
                const currentAll = Array.isArray(controller.allRows)
                    ? controller.allRows
                    : [];
                if (!currentFiltered.length || currentFiltered.length >= currentAll.length) {
                    return {filteredRows: projectedRows, allRows: projectedRows};
                }
                const allowed = new Set(currentFiltered.map((row) => (
                    window.MaplyticsZoneRowAllocation?.rowIdentity?.(row)
                )).filter(Boolean));
                return {
                    filteredRows: projectedRows.filter((row) => allowed.has(
                        window.MaplyticsZoneRowAllocation?.rowIdentity?.(row),
                    )),
                    allRows: projectedRows,
                };
            };
            const currentPresentation = () => {
                if (resolvedSurface === 'import') {
                    return {
                        mode: 'cumulative',
                        // Import n'applique pas la projection cumulative/exclusive
                        // des ZDC. Son empreinte visuelle ne doit donc pas être
                        // envoyée comme une empreinte SHA-256 de projection.
                        projectionFingerprint: '',
                    };
                }
                const snapshot = window.maplyticsZonePresentationController
                    ?.getSnapshot?.() || {};
                const projection = snapshot.projection || {};
                const certification = projection.certification || {};
                const measurementRows = Array.isArray(projection.zones)
                    ? projection.zones.flatMap((zone) => (
                        Array.isArray(zone?.rows) ? zone.rows : []
                    ))
                    : [];
                const uniqueValue = (field) => {
                    const values = Array.from(new Set(measurementRows
                        .map((row) => String(row?.[field] || '').trim())
                        .filter(Boolean)));
                    return values.length === 1 ? values[0] : '';
                };
                const snapshotMode = snapshot.mapMode === 'exclusive'
                    || snapshot.mode === 'exclusive'
                    ? 'exclusive'
                    : 'cumulative';
                const fingerprint = String(snapshot.projectionFingerprint || '').trim();
                const projectionMatches = snapshot.status === 'ready'
                    && snapshot.projection?.mode === snapshotMode
                    && fingerprint === String(
                        snapshot.projection?.projection_fingerprint || '',
                    ).trim()
                    && /^[0-9a-f]{64}$/i.test(fingerprint);
                return {
                    mode: snapshotMode,
                    status: String(snapshot.status || '').trim(),
                    recovery: {
                        available: snapshot.recovery?.available === true,
                        reason: String(snapshot.recovery?.reason || '').trim(),
                    },
                    projectionFingerprint: projectionMatches
                        ? fingerprint
                        : '',
                    exclusiveAvailable: snapshot.exclusive?.available === true,
                    exclusiveReason: String(
                        snapshot.exclusive?.reasons?.[0] || '',
                    ).trim(),
                    measurementCertification: {
                        version: certification.version || '',
                        status: certification.status || '',
                        certified_for_export: projectionMatches
                            && certification.certified_for_export === true,
                        routing_provider: uniqueValue('routing_provider'),
                        routing_graph_fingerprint: uniqueValue('routing_graph_fingerprint'),
                        commune_dataset_fingerprint: uniqueValue(
                            'commune_dataset_fingerprint',
                        ),
                    },
                };
            };
            const exclusive = exclusivePresentation();
            const actualPresentation = currentPresentation();
            if (resolvedSurface === 'export') {
                const initialRows = currentRows(actualPresentation.mode);
                filteredRows = initialRows.filteredRows.length
                    ? initialRows.filteredRows
                    : (Array.isArray(controller.filteredRows)
                        ? controller.filteredRows
                        : []);
                allRows = initialRows.allRows.length
                    ? initialRows.allRows
                    : (Array.isArray(controller.allRows)
                        ? controller.allRows
                        : []);
            }
            const desiredPresentationMode = resolvedSurface === 'export' && exclusive.available
                ? 'exclusive'
                : actualPresentation.mode;
            return window.MaplyticsMultiZoneExcel.open({
                surface: resolvedSurface,
                trigger,
                filteredRows,
                allRows,
                getCurrentRows: currentRows,
                zoneCatalog: currentZoneCatalog(actualPresentation.mode),
                getCurrentZoneCatalog: currentZoneCatalog,
                sourceRefs: currentSourceRefs(),
                getCurrentSourceRefs: currentSourceRefs,
                presentationMode: desiredPresentationMode,
                projectionFingerprint: actualPresentation.projectionFingerprint,
                measurementCertification: actualPresentation.measurementCertification,
                getCurrentPresentation: currentPresentation,
                requestPresentationMode: resolvedSurface === 'export'
                    ? async (mode) => {
                        const synced = await exportZonePresentationController
                            ?.syncSource?.('excel-presentation');
                        if (!synced) {
                            const current = exportZonePresentationController?.getSnapshot?.() || {};
                            throw new Error(
                                current.statusMessage
                                || 'Les zones ne peuvent pas être vérifiées pour cet export.',
                            );
                        }
                        const applied = await exportZonePresentationController?.setMode?.(mode);
                        const snapshot = exportZonePresentationController?.getSnapshot?.() || {};
                        const appliedMode = snapshot.mapMode === 'exclusive'
                            || snapshot.mode === 'exclusive'
                            ? 'exclusive'
                            : 'cumulative';
                        const fingerprint = String(snapshot.projectionFingerprint || '').trim();
                        if (
                            !applied
                            || snapshot.status !== 'ready'
                            || appliedMode !== mode
                            || snapshot.projection?.mode !== mode
                            || fingerprint !== String(
                                snapshot.projection?.projection_fingerprint || '',
                            ).trim()
                            || !/^[0-9a-f]{64}$/i.test(fingerprint)
                        ) {
                            throw new Error(
                                snapshot.statusMessage
                                || 'La présentation demandée ne peut pas être certifiée.',
                            );
                        }
                        return snapshot;
                    }
                    : null,
                onRecalculate: resolvedSurface === 'export'
                    ? focusExportZoneRecalculation
                    : null,
                onOpenHistory: resolvedSurface === 'export'
                    ? openExportSavedAnalyses
                    : null,
                presentationOptions: {
                    visible: resolvedSurface === 'export',
                    exclusiveAvailable: exclusive.available,
                    exclusiveReason: exclusive.reason,
                },
                columns,
                allowDemographics: Boolean(controller?.isPremium),
                columnLabels: EXPORT_TABLE_COLUMN_LABELS,
                title: importSnapshot?.title || 'Analyse multi-zone Maplytics',
            });
        };

        const waitForMultiZoneExcelRuntime = async () => {
            if (window.MaplyticsMultiZoneExcel?.open || document.readyState === 'complete') {
                return;
            }
            await new Promise((resolve) => {
                window.addEventListener('load', resolve, { once: true });
            });
        };

        const bindMultiZoneExcelLink = (link, surface = 'export') => {
            if (!link) return null;
            const resolvedSurface = surface === 'import' ? 'import' : 'export';
            const allowed = hasFeature('export_excel');
            link.hidden = false;
            link.classList.toggle('premium-disabled', !allowed);
            link.setAttribute('aria-disabled', allowed ? 'false' : 'true');
            link.style.pointerEvents = 'auto';
            link.style.cursor = allowed ? 'pointer' : 'not-allowed';
            link.dataset.multiZoneExcelSurface = resolvedSurface;
            if (link.dataset.multiZoneExcelBound === '1') return link;
            link.dataset.multiZoneExcelBound = '1';
            link.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopPropagation();
                if (!hasFeature('export_excel')) {
                    if (link.dataset.premiumNoticeBound !== '1') {
                        showPremiumNotice(
                            'l’export Excel',
                            'L’export Excel est inclus à partir du plan Étudiant.',
                        );
                    }
                    return;
                }
                openMultiZoneExcelDialog(link, resolvedSurface);
            });
            return link;
        };

        document.getElementById('legendExcelFallbackBtn')?.addEventListener('click', async (event) => {
            const trigger = event.currentTarget;
            await waitForMultiZoneExcelRuntime();
            if (!window.MaplyticsMultiZoneExcel?.open) {
                openMultiZoneExcelDialog(trigger);
                return;
            }
            const visualDialog = document.getElementById('legendCustomizationPanel');
            const returnTrigger = document.getElementById(
                activeVisualExportSurface === 'import'
                    ? 'importDetailedExcelBtn'
                    : 'customizeLegendBtn',
            ) || trigger;
            if (visualDialog?.open) visualDialog.close();
            openMultiZoneExcelDialog(returnTrigger, activeVisualExportSurface);
        });

        const bindFilteredExportLink = (link, format, panelName) => {
            if (!link) return;
            link.href = '#';
            link.removeAttribute('target');
            link.dataset.filteredExportFormat = format;
            link.dataset.filteredExportPanel = panelName;
            if (link.dataset.filteredExportBound === '1') return;
            link.dataset.filteredExportBound = '1';
            link.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopPropagation();
                const rows = filteredExportRows(panelName, format);
                if (!rows.length) {
                    showAppMessage(
                        'warning',
                        'Aucune donnée à exporter',
                        'Aucune ligne ne correspond aux filtres actuels.',
                    );
                    return;
                }
                window.exportVisibleDataset?.(format, rows);
            });
        };

        const setupTableController = (controller, columns, rows, prefix) => {
            // S'assurer qu'on a bien toutes les données
            debugLog(`[Table] Initialisation avec ${rows.length} lignes`);
            controller.allRows = rows;
            controller.filteredRows = rows;
            controller.currentPage = 1;
            controller.columns = columns;
            controller.prefix = prefix;
            controller.activeFilters = null;

            // Supprimer les anciens event listeners en clonant les éléments
            const newSearchInput = controller.searchInput.cloneNode(true);
            controller.searchInput.parentNode.replaceChild(newSearchInput, controller.searchInput);
            controller.searchInput = newSearchInput;

            const newPrevBtn = controller.prevBtn.cloneNode(true);
            controller.prevBtn.parentNode.replaceChild(newPrevBtn, controller.prevBtn);
            controller.prevBtn = newPrevBtn;

            const newNextBtn = controller.nextBtn.cloneNode(true);
            controller.nextBtn.parentNode.replaceChild(newNextBtn, controller.nextBtn);
            controller.nextBtn = newNextBtn;

            const newSelectAllBtn = controller.selectAllBtn.cloneNode(true);
            controller.selectAllBtn.parentNode.replaceChild(newSelectAllBtn, controller.selectAllBtn);
            controller.selectAllBtn = newSelectAllBtn;

            const applyFilters = () => {
                let filtered = controller.allRows;

                // Appliquer la recherche textuelle
                const searchTerm = controller.searchInput.value;
                filtered = filterRows(filtered, searchTerm, columns);

                // Appliquer les filtres avancés si actifs
                if (controller.activeFilters) {
                    filtered = applyAdvancedFilters(filtered, columns, controller.activeFilters);
                }

                controller.filteredRows = filtered;
                controller.currentPage = 1;
                renderTablePage(controller, columns);
                updateTableInfo(controller);

                // Mettre à jour les statistiques avec les données filtrées
                if (controller.updateStats) {
                    const stats = calculateStatistics(filtered);
                    controller.updateStats(stats);
                }
                if (prefix === 'import') {
                    importDetailedExportAdapter?.invalidate?.(
                        'import-filter-changed',
                        {hard: false},
                    );
                    document.dispatchEvent(new CustomEvent(
                        'maplytics:demographic-rows-changed',
                        {detail: {surface: 'import'}},
                    ));
                }
            };

            // Debouncer les filtres pour améliorer les performances (surtout sur mobile)
            let filterTimeout;
            const debouncedApplyFilters = () => {
                if (filterTimeout) clearTimeout(filterTimeout);
                const isMobile = window.innerWidth <= 768;
                filterTimeout = setTimeout(applyFilters, isMobile ? 300 : 150);
            };
            controller.searchInput.addEventListener('input', debouncedApplyFilters);

            // Gestion des filtres avancés
            const filtersToggle = document.getElementById(`${prefix}FiltersToggle`);
            const filtersContent = document.getElementById(`${prefix}FiltersContent`);
            const filtersToggleText = document.getElementById(`${prefix}FiltersToggleText`);
            const filterApplyBtn = document.getElementById(`${prefix}FilterApply`);
            const filterResetBtn = document.getElementById(`${prefix}FilterReset`);

            if (filtersToggle && filtersContent && filtersToggleText) {
                // Supprimer les anciens listeners en clonant l'élément
                const newFiltersToggle = filtersToggle.cloneNode(true);
                filtersToggle.parentNode.replaceChild(newFiltersToggle, filtersToggle);
                const newFiltersToggleText = document.getElementById(`${prefix}FiltersToggleText`);

                newFiltersToggle.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    const isExpanded = filtersContent.classList.contains('expanded');
                    if (isExpanded) {
                        filtersContent.classList.remove('expanded');
                        if (newFiltersToggleText) newFiltersToggleText.textContent = 'Afficher';
                    } else {
                        filtersContent.classList.add('expanded');
                        if (newFiltersToggleText) newFiltersToggleText.textContent = 'Masquer';
                    }
                });
            }

            if (filterApplyBtn) {
                filterApplyBtn.addEventListener('click', () => {
                    controller.activeFilters = getFilterValues(prefix);
                    applyFilters();
                });
            }

            if (filterResetBtn) {
                filterResetBtn.addEventListener('click', () => {
                    resetFilters(prefix);
                    controller.activeFilters = null;
                    applyFilters();
                });
            }

            controller.prevBtn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                if (controller.currentPage > 1) {
                    controller.currentPage--;
                    renderTablePage(controller, columns);
                }
            });

            controller.nextBtn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                const totalPages = Math.ceil(controller.filteredRows.length / controller.rowsPerPage);
                if (controller.currentPage < totalPages) {
                    controller.currentPage++;
                    renderTablePage(controller, columns);
                }
            });

            controller.selectAllBtn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                if (controller.selectAllBtn.disabled || controller.selectAllBtn.classList.contains('premium-disabled')) {
                    showPremiumNotice('la sélection complète du tableau', 'La sélection complète du tableau est incluse à partir du plan Étudiant.');
                    return;
                }
                selectAllTableData(controller);
            });

            renderTablePage(controller, columns);
            updateTableInfo(controller);
        };

        const populateTable = (tableEl, columns = [], rows = []) => {
            const workspaceGeneration = tableEl.id === 'exportTable'
                ? homeWorkspaceResetGeneration
                : null;
            // Utiliser requestAnimationFrame pour éviter les blocages de rendu sur mobile
            requestAnimationFrame(() => {
                if (
                    workspaceGeneration !== null
                    && workspaceGeneration !== homeWorkspaceResetGeneration
                ) return;
                _doPopulateTable(tableEl, columns, rows);
            });
        };

        const _doPopulateTable = (tableEl, columns = [], rows = []) => {
            resetTable(tableEl);
            const isExport = tableEl.id === 'exportTable';
            const controller = isExport ? tableControllers.export : tableControllers.import;
            const prefix = isExport ? 'export' : 'import';
            const notifyDemographicRowsChanged = () => {
                document.dispatchEvent(new CustomEvent(
                    'maplytics:demographic-rows-changed',
                    { detail: { surface: prefix } },
                ));
            };
            if (!columns.length || !rows.length) {
                controller.allRows = [];
                controller.filteredRows = [];
                controller.columns = [];
                notifyDemographicRowsChanged();
                return;
            }

            const thead = tableEl.querySelector('thead');
            const headerRow = document.createElement('tr');

            // Initialiser l'état de tri si nécessaire
            if (!controller.sortState) {
                controller.sortState = { column: null, direction: 'asc' };
            }

            // Noms d'affichage des colonnes
            const columnLabels = EXPORT_TABLE_COLUMN_LABELS;

            // Colonnes premium (données démographiques)
            const premiumColumns = ['revenus', 'population', 'menages', 'logement_maison', 'logement_appartement', 'age_moyen'];

            // Filtrer les colonnes dupliquées (zone_chalandise vs zone_de_chalandise)
            const filteredColumns = [];
            const hasZoneDeChalandise = columns.includes('zone_de_chalandise');
            columns.forEach(col => {
                // Ignorer zone_chalandise si zone_de_chalandise existe
                if (col === 'zone_chalandise' && hasZoneDeChalandise) {
                    return;
                }
                filteredColumns.push(col);
            });

            // Utiliser les colonnes filtrées pour l'affichage
            const displayColumns = (
                prefix === 'import' && !controller.isPremium
                    ? filteredColumns.filter((col) => !premiumColumns.includes(col))
                    : filteredColumns
            );

            displayColumns.forEach((col) => {
                const th = document.createElement('th');
                const label = columnLabels[col] || col;

                // Ajouter badge premium si nécessaire
                if (isExport && premiumColumns.includes(col)) {
                    const labelSpan = document.createElement('span');
                    labelSpan.textContent = label;
                    const premiumBadge = document.createElement('span');
                    premiumBadge.textContent = '⭐';
                    premiumBadge.title = 'Réservé aux plans Pro, Business ou Réseau';
                    premiumBadge.style.cssText = 'margin-left: 4px; font-size: 0.8em; opacity: 0.7; color: #f59e0b;';
                    th.appendChild(labelSpan);
                    th.appendChild(premiumBadge);
                } else {
                    th.textContent = label;
                }
                th.style.cursor = 'pointer';
                th.style.userSelect = 'none';
                th.style.position = 'relative';
                th.style.paddingRight = '20px';

                // Indicateur de tri
                const sortIndicator = document.createElement('span');
                sortIndicator.style.position = 'absolute';
                sortIndicator.style.right = '5px';
                sortIndicator.style.fontSize = '0.8em';
                sortIndicator.style.opacity = '0.5';

                const updateSortIndicator = () => {
                    if (controller.sortState.column === col) {
                        sortIndicator.textContent = controller.sortState.direction === 'asc' ? '↑' : '↓';
                        sortIndicator.style.opacity = '1';
                    } else {
                        sortIndicator.textContent = '↕';
                        sortIndicator.style.opacity = '0.3';
                    }
                };
                updateSortIndicator();
                th.appendChild(sortIndicator);

                // Event listener pour le tri
                th.addEventListener('click', () => {
                    if (controller.sortState.column === col) {
                        // Inverser la direction
                        controller.sortState.direction = controller.sortState.direction === 'asc' ? 'desc' : 'asc';
                    } else {
                        controller.sortState.column = col;
                        controller.sortState.direction = 'asc';
                    }

                    // Trier les lignes
                    controller.filteredRows.sort((a, b) => {
                        let valA = a[col];
                        let valB = b[col];

                        // Gérer les valeurs null/undefined
                        if (valA == null) valA = '';
                        if (valB == null) valB = '';

                        // Convertir en nombres si possible
                        const numA = parseFloat(valA);
                        const numB = parseFloat(valB);
                        const isNumeric = !isNaN(numA) && !isNaN(numB) && String(valA).trim() !== '' && String(valB).trim() !== '';

                        if (isNumeric) {
                            return controller.sortState.direction === 'asc' ? numA - numB : numB - numA;
                        } else {
                            // Tri alphabétique
                            const strA = String(valA).toLowerCase();
                            const strB = String(valB).toLowerCase();
                            if (controller.sortState.direction === 'asc') {
                                return strA < strB ? -1 : strA > strB ? 1 : 0;
                            } else {
                                return strA > strB ? -1 : strA < strB ? 1 : 0;
                            }
                        }
                    });

                    // Réinitialiser à la page 1
                    controller.currentPage = 1;

                    // Mettre à jour l'affichage avec les colonnes filtrées
                    renderTablePage(controller, displayColumns);
                    if (prefix === 'import') {
                        importDetailedExportAdapter?.invalidate?.(
                            'import-sort-changed',
                            {hard: false},
                        );
                    }

                    // Mettre à jour tous les indicateurs
                    headerRow.querySelectorAll('th').forEach((thEl, idx) => {
                        if (idx < displayColumns.length) {
                            const indicator = thEl.querySelector('span[style*="position: absolute"]');
                            if (indicator) {
                                if (displayColumns[idx] === col) {
                                    indicator.textContent = controller.sortState.direction === 'asc' ? '↑' : '↓';
                                    indicator.style.opacity = '1';
                                } else {
                                    indicator.textContent = '↕';
                                    indicator.style.opacity = '0.3';
                                }
                            }
                        }
                    });
                });

                headerRow.appendChild(th);
            });
            thead.appendChild(headerRow);

            // Mettre à jour les colonnes du controller avec les colonnes filtrées
            controller.columns = displayColumns;

            controller.container.hidden = false;
            controller.search.hidden = false;
            controller.actions.hidden = false;
            document.getElementById(`${prefix}Filters`).hidden = false;
            controller.searchInput.value = '';

            setupTableController(controller, displayColumns, rows, prefix);
            notifyDemographicRowsChanged();
        };

        const IMPORT_UNMATCHED_PREVIEW_LIMIT = 100;
        const IMPORT_MAP_RENDER_CHUNK_SIZE = 40;

        const updateUnmatchedList = (listEl, unmatched = []) => {
            listEl.replaceChildren();
            if (!unmatched.length) {
                const li = document.createElement('li');
                li.textContent = 'Aucune ligne manquante.';
                li.style.background = 'rgba(16, 185, 129, 0.12)';
                li.style.borderColor = 'rgba(16, 185, 129, 0.4)';
                listEl.appendChild(li);
                return;
            }
            const fragment = document.createDocumentFragment();
            unmatched.slice(0, IMPORT_UNMATCHED_PREVIEW_LIMIT).forEach((item) => {
                const li = document.createElement('li');
                li.textContent = `${item.input_nom_commune || 'Commune inconnue'} – ${item.input_code_postal || ''}`;
                fragment.appendChild(li);
            });
            if (unmatched.length > IMPORT_UNMATCHED_PREVIEW_LIMIT) {
                const li = document.createElement('li');
                li.className = 'import-unmatched-summary';
                li.textContent = `${unmatched.length - IMPORT_UNMATCHED_PREVIEW_LIMIT} ligne(s) supplémentaire(s) sont disponibles dans le fichier des lignes introuvables.`;
                fragment.appendChild(li);
            }
            listEl.appendChild(fragment);
        };

        const createMapController = ({ mapId, latInputId, lonInputId, queryInputId, searchBtnId, badgeId }) => {
            const mapElement = document.getElementById(mapId);
            if (!mapElement) {
                console.error(`Élément de carte introuvable: ${mapId}`);
                return null;
            }
            if (typeof L === 'undefined') {
                console.error('Leaflet n\'est pas chargé');
                return null;
            }
            let map;
            try {
                mapElement.replaceChildren();
                map = L.map(mapId, {
                    preferCanvas: true,
                    zoomSnap: 1,
                    zoomDelta: 1,
                    // The shared layout observer below owns map resizes and skips
                    // inactive tabs. Leaflet's global listener also resizes hidden
                    // sibling maps when Firefox leaves fullscreen.
                    trackResize: false,
                }).setView([46.8, 2.5], 6);
            } catch (error) {
                console.error(`Erreur lors de l'initialisation de la carte ${mapId}:`, error);
                return null;
            }
            let basemapStatus = { state: 'initial', message: '' };
            const basemapSwitcher = window.MaplyticsMapLayers?.createSwitcher(map, {
                mapId,
                onStatus: (nextStatus) => {
                    basemapStatus = nextStatus;
                    const status = document.getElementById(`basemapStatus_${mapId}`);
                    if (status) {
                        status.dataset.state = nextStatus.state;
                        status.textContent = nextStatus.message;
                    }
                    const select = document.getElementById(`basemapSelect_${mapId}`);
                    if (select && nextStatus.state !== 'loading') {
                        select.value = basemapSwitcher?.getActiveId?.() || window.MaplyticsMapLayers.DEFAULT_ID;
                    }
                }
            });
            let administrativeBoundaryStatus = { state: 'initial', message: '' };
            let administrativeBoundaryController = null;
            administrativeBoundaryController = window.MaplyticsAdministrativeBoundaries?.createController(map, {
                mapId,
                onStatus: (nextStatus) => {
                    administrativeBoundaryStatus = nextStatus;
                    const status = document.getElementById(`administrativeBoundaryStatus_${mapId}`);
                    if (status) {
                        status.dataset.state = nextStatus.state;
                        status.textContent = nextStatus.message;
                    }
                    const select = document.getElementById(`administrativeBoundarySelect_${mapId}`);
                    if (select && nextStatus.state !== 'loading') {
                        select.value = administrativeBoundaryController?.getActiveLevel?.()
                            || window.MaplyticsAdministrativeBoundaries.DEFAULT_LEVEL;
                        window.MaplyticsAdministrativeBoundaries.renderStyleControls?.(
                            administrativeBoundaryController,
                            {
                                fieldset: document.getElementById(`administrativeBoundaryStyle_${mapId}`),
                                presetSelect: document.getElementById(`administrativeBoundaryPreset_${mapId}`),
                                colorInput: document.getElementById(`administrativeBoundaryColor_${mapId}`),
                                opacityInput: document.getElementById(`administrativeBoundaryOpacity_${mapId}`),
                                opacityOutput: document.getElementById(`administrativeBoundaryOpacityValue_${mapId}`),
                            },
                        );
                    }
                    if (nextStatus.state === 'error') {
                        window.MaplyticsNotice?.error?.(nextStatus.message, { title: 'Carte' });
                    }
                },
            }) || null;

            let marker = null;
            let geoLayer = null;
            let simpleRenderGeneration = 0;
            let interactionRequestGeneration = 0;
            let reverseGeocodeAbort = null;
            let searchGeocodeAbort = null;
            let markerReplacementCallback = null;
            let legendControl = null;
            let kpiBadgeControl = null;
            let originContextControl = null;
            let kpiBadgeCollapsed = false;
            let kpiLayoutObserver = null;
            let toggleMapFullscreen = () => null;
            // Gestion des zones multiples
            const zonesLayers = new Map(); // zoneId -> { layer, color, name, opacity }
            const zoneCenterMarkers = new Map(); // pointKey -> { marker, zoneIds, visible }
            const zoneCenterKeys = new Map(); // zoneId -> pointKey
            const coordinatePointKey = (lat, lon) => (
                `${Number(lat).toFixed(6)},${Number(lon).toFixed(6)}`
            );
            const hasZoneCenterAt = (lat, lon) => {
                if (!Number.isFinite(Number(lat)) || !Number.isFinite(Number(lon))) return false;
                const key = coordinatePointKey(lat, lon);
                return zoneCenterMarkers.has(key) || Array.from(zoneCenterMarkers.values()).some(
                    (point) => point.coordinateKey === key,
                );
            };
            const syncSelectionMarkerVisibility = () => {
                if (!marker) return;
                const position = marker.getLatLng?.();
                const overlapsZoneCenter = position
                    ? hasZoneCenterAt(position.lat, position.lng)
                    : false;
                if (overlapsZoneCenter && map.hasLayer(marker)) {
                    map.removeLayer(marker);
                } else if (!overlapsZoneCenter && !map.hasLayer(marker)) {
                    marker.addTo(map);
                }
            };
            // Gestion des contours des communes (surcouche)
            let communeBordersLayer = null;
            // Modes de visualisation
            let visualizationMode = 'normal'; // 'normal', 'filled', 'outline', 'choropleth'
            let isochroneGeometryMode = 'presentation'; // rendu uniquement, jamais persisté
            let isochroneGeometryRequestGeneration = 0;
            let isochroneGeometryAbort = null;
            let geometryRefreshScheduled = false;
            let simpleCanonicalGeoJson = null;
            let simpleRenderOptions = {};
            const isochroneRenderContracts = new Map();
            let showCommuneCentroids = false;
            let visualizationRetry = null;
            let visualExportRevision = 0;
            let choroplethController = null;
            let scheduleChoroplethRefresh = () => {};
            const mapVisualSurface = mapId === 'importMap' ? 'import' : 'export';
            const syncActiveVisualExport = (reason) => {
                if (activeVisualExportSurface === mapVisualSurface) {
                    window.maplyticsVisualExportController?.sync?.(reason);
                }
            };
            const invalidateVisualExport = (reason) => {
                visualExportRevision += 1;
                if (activeVisualExportSurface === mapVisualSurface) {
                    window.maplyticsVisualExportController?.invalidate?.(reason);
                }
            };
            map.on('moveend zoomend', () => invalidateVisualExport('map-viewport'));
            window.addEventListener('maplytics:basemap-changed', (event) => {
                if (event.detail?.sourceMapId === mapId) invalidateVisualExport('map-basemap');
            });
            window.addEventListener('maplytics:administrative-boundaries-changed', (event) => {
                invalidateVisualExport('map-boundaries');
            });

            const setVisualizationStatus = (state, message, retry = null) => {
                const status = document.getElementById(`visualizationStatus_${mapId}`);
                const retryButton = document.getElementById(`visualizationRetry_${mapId}`);
                visualizationRetry = typeof retry === 'function' ? retry : null;
                if (status) {
                    status.dataset.state = state;
                    status.textContent = message;
                }
                if (retryButton) {
                    retryButton.hidden = !visualizationRetry;
                }
            };

            const hasVisualizationGeometry = () => Boolean(
                geoLayer || Array.from(zonesLayers.values()).some((zone) => zone?.layer)
            );

            // Fonction pour obtenir le style selon le mode de visualisation
            const getVisualizationStyle = (baseColor, isCommune = false) => {
                switch (visualizationMode) {
                    case 'filled':
                        return {
                            color: baseColor,
                            weight: isCommune ? 1.5 : 2,
                            fillOpacity: isCommune ? 0.4 : 0.3,
                            fillColor: baseColor,
                            dashArray: isCommune ? null : '0'
                        };
                    case 'outline':
                        return {
                            color: baseColor,
                            weight: isCommune ? 2 : 3,
                            fillOpacity: 0,
                            fillColor: 'transparent',
                            dashArray: isCommune ? null : '8 4'
                        };
                    case 'choropleth':
                        return {
                            color: baseColor,
                            weight: isCommune ? 1 : 2,
                            fillOpacity: isCommune ? 0.25 : 0.2,
                            fillColor: baseColor,
                            dashArray: isCommune ? null : '4 4'
                        };
                    default: // 'normal'
                        return {
                            color: baseColor,
                            weight: isCommune ? 1.8 : 2.4,
                            fillOpacity: isCommune ? 0.2 : 0.18,
                            fillColor: baseColor,
                            dashArray: null
                        };
                }
            };

            const getIsochronePathStyle = (style, layerType, effectiveMode = 'provider') => {
                if (layerType !== 'isochrone') return style;
                const profile = window.MaplyticsIsochronePresentation?.applyVisualProfile?.(
                    style,
                    effectiveMode,
                );
                return profile?.style || {
                    ...style,
                    smoothFactor: 0,
                    lineJoin: 'miter',
                    lineCap: 'butt',
                };
            };

            const deriveIsochroneDisplay = (canonicalGeoJson) => {
                const hasIsochrone = Boolean(canonicalGeoJson?.features?.some(
                    (feature) => feature?.properties?.layer === 'isochrone'
                        && ['Polygon', 'MultiPolygon'].includes(feature?.geometry?.type)
                ));
                if (!hasIsochrone) {
                    return {
                        geojson: canonicalGeoJson,
                        requested_mode: isochroneGeometryMode,
                        effective_mode: 'not_applicable',
                        mode_label: 'Sans contour isochrone',
                        algorithm: null,
                        candidate_id: null,
                        passes: null,
                        score: null,
                        candidates: [],
                        metrics: [],
                        fallback_reason: null,
                    };
                }
                const adapter = window.MaplyticsIsochronePresentation;
                if (!adapter?.derive) {
                    return {
                        geojson: canonicalGeoJson,
                        requested_mode: isochroneGeometryMode,
                        effective_mode: 'provider',
                        mode_label: 'Précision fournisseur',
                        algorithm: null,
                        candidate_id: null,
                        passes: null,
                        score: null,
                        candidates: [],
                        metrics: [],
                        fallback_reason: 'presentation_adapter_unavailable',
                    };
                }
                const result = adapter.derive(canonicalGeoJson, {
                    mode: isochroneGeometryMode === 'territorial'
                        ? 'presentation'
                        : isochroneGeometryMode,
                });
                if (
                    isochroneGeometryMode === 'presentation'
                    && typeof adapter.requestSoftened === 'function'
                ) {
                    return {
                        ...result,
                        requested_mode: 'presentation',
                        fallback_reason: 'soft_presentation_pending',
                    };
                }
                if (isochroneGeometryMode !== 'territorial') return result;
                return {
                    ...result,
                    requested_mode: 'territorial',
                    fallback_reason: 'territorial_geometry_pending',
                };
            };

            const normalizeIsochroneGeometryMode = (mode) => (
                mapId === 'exportMap' && mode === 'territorial'
                    ? 'territorial'
                    : mode === 'provider'
                        ? 'provider'
                        : 'presentation'
            );

            const ISOCHRONE_FALLBACK_EXPLANATIONS = Object.freeze({
                presentation_outside_safety_limits:
                    'le contour lissé dépasserait les limites géométriques de sécurité',
                presentation_outside_geometry_limits:
                    'le contour lissé dépasserait les limites géométriques de sécurité',
                series_presentation_outside_safety_limits:
                    'la série complète ne peut pas être lissée sans dépasser les limites de sécurité',
                series_presentation_incomplete:
                    'la série complète ne possède pas une présentation lissée sûre',
                series_presentation_ambiguous_contours:
                    'la série contient des contours ambigus',
                ambiguous_isochrone_contours:
                    'le résultat contient plusieurs contours isochrones ambigus',
                presentation_no_roughness_improvement:
                    'aucune amélioration visuelle sûre n’a été trouvée',
                presentation_adapter_unavailable:
                    'le service de présentation n’est pas chargé',
                soft_presentation_adapter_unavailable:
                    'le service de présentation est temporairement indisponible',
                soft_presentation_service_unavailable:
                    'le service de présentation est temporairement indisponible',
                isochrone_visual_presentation_timeout:
                    'le service de présentation a dépassé son délai',
                isochrone_visual_presentation_failed:
                    'le service de présentation est temporairement indisponible',
                invalid_source_geometry:
                    'la géométrie fournisseur ne permet pas un lissage sûr',
                invalid_geometry:
                    'la géométrie lissée serait invalide',
                invalid_origin:
                    'l’origine ne permet pas de valider le contour lissé',
                area_variation:
                    'aucune intensité sûre ne reste dans la limite de 35 % d’aire ajoutée',
                holes_exceed_area_budget:
                    'un contour sans trou ajouterait à lui seul plus de 35 % de surface, même sans lissage',
                centroid_shift:
                    'le centre du contour serait trop déplacé',
                source_overlap:
                    'le contour lissé ne couvrirait pas assez la géométrie fournisseur',
                presentation_overlap:
                    'le contour lissé s’écarterait trop de la géométrie fournisseur',
                origin_not_preserved:
                    'le contour lissé ne conserverait pas l’origine',
                disconnected_presentation:
                    'le contour lissé serait discontinu',
                presentation_holes:
                    'des espaces non couverts subsistent aux intensités compatibles avec la surface',
                geometry_operation_failed:
                    'la géométrie n’a pas pu être transformée de façon sûre',
            });

            const summarizeIsochroneFallbacks = (contracts) => {
                const collected = window.MaplyticsIsochronePresentation
                    ?.collectRejectionReasons?.(contracts);
                const uniqueReasons = Array.isArray(collected)
                    ? collected
                    : [...new Set(contracts.map((item) => item?.fallback_reason).filter(Boolean))];
                const explanations = [...new Set(uniqueReasons.map((reason) => (
                    ISOCHRONE_FALLBACK_EXPLANATIONS[reason]
                    || (String(reason).includes('timeout')
                        ? 'le service de présentation a dépassé son délai'
                        : String(reason).includes('unavailable')
                            || String(reason).includes('failed')
                            ? 'le service de présentation est temporairement indisponible'
                            : 'le lissage n’a pas satisfait toutes les limites de sécurité')
                )))];
                return {
                    reasons: uniqueReasons,
                    explanation: explanations.slice(0, 2).join(' ; ')
                        || 'le lissage n’a pas satisfait toutes les limites de sécurité',
                };
            };

            const formatIsochroneFallbackStatus = (contract) => {
                const explanation = contract.fallback_explanation
                    || 'le lissage n’a pas satisfait toutes les limites de sécurité';
                if (['provider', 'mixed'].includes(contract.effective_mode)) {
                    const scope = contract.effective_mode === 'mixed'
                        ? ` pour ${contract.fallback_count} contour(s)`
                        : '';
                    return `Précision fournisseur utilisée${scope} : ${explanation}. Données et calculs inchangés.`;
                }
                return `Présentation adoucie locale utilisée : ${explanation}. Données et calculs inchangés.`;
            };

            const buildSoftPresentationResults = async (zoneSnapshots, generation) => {
                const adapter = window.MaplyticsIsochronePresentation;
                if (typeof adapter?.requestSoftened !== 'function') {
                    throw Object.assign(
                        new Error('Le service de présentation adoucie est indisponible.'),
                        {code: 'soft_presentation_adapter_unavailable'},
                    );
                }
                isochroneGeometryAbort?.abort?.();
                const abortController = typeof AbortController === 'function'
                    ? new AbortController()
                    : null;
                isochroneGeometryAbort = abortController;
                const results = await adapter.requestSoftened(zoneSnapshots, {
                    signal: abortController?.signal,
                });
                if (
                    generation !== isochroneGeometryRequestGeneration
                    || isochroneGeometryMode !== 'presentation'
                ) {
                    throw Object.assign(
                        new Error('La demande de présentation adoucie a été remplacée.'),
                        {code: 'soft_presentation_request_stale'},
                    );
                }
                return results;
            };

            const buildTerritorialPresentationResults = async (zoneSnapshots, generation) => {
                const adapter = window.MaplyticsIsochroneTerritorialPresentation;
                const geometryClient = window.MaplyticsCommuneGeometries;
                if (!adapter?.codesFromRows || !adapter?.compose || !geometryClient?.load) {
                    throw Object.assign(
                        new Error('La présentation territoriale est temporairement indisponible.'),
                        {code: 'territorial_adapter_unavailable'},
                    );
                }
                const isochroneSnapshots = zoneSnapshots.filter((snapshot) => (
                    snapshot.canonicalGeojson?.features?.some((feature) => (
                        feature?.properties?.layer === 'isochrone'
                        && ['Polygon', 'MultiPolygon'].includes(feature?.geometry?.type)
                    ))
                ));
                if (!isochroneSnapshots.length) return new Map();
                const rowsByZone = new Map();
                const allCodes = new Set();
                isochroneSnapshots.forEach((snapshot) => {
                    const zone = zonesManager?.zones?.get?.(snapshot.zoneId)
                        || zonesManager?.zones?.get?.(String(snapshot.zoneId));
                    const rows = Array.isArray(zone?.data?.rows) ? zone.data.rows : [];
                    rowsByZone.set(String(snapshot.zoneId), rows);
                    adapter.codesFromRows(rows).forEach((code) => allCodes.add(code));
                });
                if (!allCodes.size) {
                    throw Object.assign(
                        new Error(
                            'Aucune commune du résultat ne permet de construire la présentation territoriale.',
                        ),
                        {code: 'territorial_communes_unavailable'},
                    );
                }
                isochroneGeometryAbort?.abort?.();
                const abortController = typeof AbortController === 'function'
                    ? new AbortController()
                    : null;
                isochroneGeometryAbort = abortController;
                const communeGeoJson = await geometryClient.load([...allCodes], {
                    signal: abortController?.signal,
                });
                if (
                    generation !== isochroneGeometryRequestGeneration
                    || isochroneGeometryMode !== 'territorial'
                ) {
                    throw Object.assign(
                        new Error('La demande de présentation territoriale a été remplacée.'),
                        {code: 'territorial_request_stale'},
                    );
                }
                const results = new Map();
                isochroneSnapshots.forEach((snapshot) => {
                    const rows = rowsByZone.get(String(snapshot.zoneId)) || [];
                    try {
                        results.set(
                            String(snapshot.zoneId),
                            adapter.compose(rows, communeGeoJson),
                        );
                    } catch (error) {
                        results.set(String(snapshot.zoneId), {
                            ...deriveIsochroneDisplay(snapshot.canonicalGeojson),
                            requested_mode: 'territorial',
                            fallback_reason: error?.code || 'territorial_geometry_unavailable',
                        });
                    }
                });
                return results;
            };

            const syncIsochroneModeContract = () => {
                const contracts = Array.from(isochroneRenderContracts.values())
                    .filter((contract) => contract.effective_mode !== 'not_applicable');
                const effectiveModes = new Set(contracts.map((contract) => contract.effective_mode));
                const algorithms = new Set(contracts.map((contract) => contract.algorithm).filter(Boolean));
                const candidateIds = new Set(contracts.map((contract) => contract.candidate_id).filter(Boolean));
                const passes = new Set(contracts.map((contract) => contract.passes).filter(Number.isFinite));
                const effectiveMode = effectiveModes.size === 0
                    ? 'not_applicable'
                    : effectiveModes.size === 1
                        ? Array.from(effectiveModes)[0]
                        : 'mixed';
                const modeLabel = effectiveMode === 'presentation'
                    ? 'Présentation adoucie'
                    : effectiveMode === 'territorial'
                        ? 'Présentation territoriale'
                    : effectiveMode === 'provider'
                        ? 'Précision fournisseur'
                        : effectiveMode === 'mixed'
                            ? 'Présentation partielle — précision fournisseur appliquée aux contours hors limites'
                            : 'Sans contour isochrone';
                const geometrySource = effectiveMode === 'presentation'
                    ? 'provider-derived-display-only'
                    : effectiveMode === 'territorial'
                        ? 'result-commune-geometries-display-only'
                    : effectiveMode === 'mixed'
                        ? 'provider-with-bounded-display-derivatives'
                        : effectiveMode === 'provider'
                            ? 'provider'
                            : 'not_applicable';
                const metrics = contracts.flatMap((item) => (
                    Array.isArray(item.metrics) ? item.metrics : []
                ));
                const maxBoundaryShift = metrics.length
                    ? Math.max(...metrics.map((item) => Number(item.max_boundary_shift_m) || 0))
                    : 0;
                const maxAreaVariationPct = metrics.length
                    ? Math.max(...metrics.map((item) => Number(item.area_variation_ratio) || 0)) * 100
                    : 0;
                const smoothingRadius = metrics.length
                    ? Math.max(...metrics.map((item) => Number(item.smoothing_radius_m) || 0))
                    : 0;
                const holesRemoved = metrics.reduce((total, item) => (
                    total + Math.max(
                        0,
                        (Number(item.holes_before) || 0) - (Number(item.holes_after) || 0),
                    )
                ), 0);
                const requestedCommuneCount = contracts.reduce(
                    (total, item) => total + (Number(item.requested_commune_count) || 0),
                    0,
                );
                const renderedCommuneCount = contracts.reduce(
                    (total, item) => total + (Number(item.rendered_commune_count) || 0),
                    0,
                );
                const missingCommuneCount = contracts.reduce(
                    (total, item) => total + (Number(item.missing_commune_count) || 0),
                    0,
                );
                const fallbackSummary = summarizeIsochroneFallbacks(contracts);
                const contract = {
                    requested_mode: isochroneGeometryMode,
                    effective_mode: effectiveMode,
                    mode_label: modeLabel,
                    algorithm: algorithms.size === 1 ? Array.from(algorithms)[0] : null,
                    candidate_id: candidateIds.size === 1 ? Array.from(candidateIds)[0] : null,
                    passes: passes.size === 1 ? Array.from(passes)[0] : null,
                    geometry_source: geometrySource,
                    persisted: false,
                    used_for_aggregation: false,
                    fallback_count: contracts.filter((item) => item.fallback_reason).length,
                    fallback_reasons: fallbackSummary.reasons,
                    fallback_explanation: fallbackSummary.explanation,
                    visual_profile: effectiveMode === 'presentation'
                        ? 'soft-bounded'
                        : effectiveMode === 'territorial'
                            ? 'whole-result-communes'
                        : effectiveMode === 'mixed'
                            ? 'mixed-bounded-provider'
                            : effectiveMode === 'provider'
                                ? 'provider-exact'
                                : 'not-applicable',
                    max_boundary_shift_m: Number(maxBoundaryShift.toFixed(1)),
                    max_area_variation_pct: Number(maxAreaVariationPct.toFixed(2)),
                    smoothing_radius_m: Number(smoothingRadius.toFixed(1)),
                    holes_removed: holesRemoved,
                    requested_commune_count: requestedCommuneCount,
                    rendered_commune_count: renderedCommuneCount,
                    missing_commune_count: missingCommuneCount,
                };
                mapElement.dataset.isochroneGeometryMode = contract.effective_mode;
                mapElement.dataset.isochroneGeometryLabel = contract.mode_label;
                mapElement.dataset.isochroneGeometrySource = contract.geometry_source;
                mapElement.dataset.isochroneVisualProfile = contract.visual_profile;
                mapElement.dataset.isochroneMaxBoundaryShift = String(contract.max_boundary_shift_m);
                mapElement.dataset.isochroneMaxAreaVariation = String(contract.max_area_variation_pct);
                mapElement.dataset.isochroneTerritorialCommuneCount = String(
                    contract.rendered_commune_count,
                );
                const statuses = [
                    document.getElementById(`isochroneGeometryStatus_${mapId}`),
                ].filter(Boolean);
                statuses.forEach((status) => {
                    status.textContent = contract.effective_mode === 'not_applicable'
                        ? 'Aucun contour isochrone calculé. Lancez un calcul pour afficher un contour.'
                        : contract.effective_mode === 'territorial'
                            ? `${contract.mode_label} — ${contract.rendered_commune_count} géométrie(s) des communes réellement retenues${contract.missing_commune_count ? `, ${contract.missing_commune_count} indisponible(s)` : ''}. Leurs limites sont affichées en entier ; aucune commune n’est ajoutée ; données et calculs inchangés.`
                        : isochroneGeometryMode === 'territorial'
                            ? `Présentation territoriale partielle — ${contract.rendered_commune_count} géométrie(s) communale(s) affichée(s), précision fournisseur conservée pour ${contract.fallback_count} contour(s). Données et calculs inchangés.`
                        : contract.fallback_count
                            ? formatIsochroneFallbackStatus(contract)
                        : contract.effective_mode === 'presentation'
                            && ['adaptive-territorial-envelope-v4', 'adaptive-territorial-envelope-v5'].includes(contract.algorithm)
                            ? `${contract.mode_label} (par défaut) — enveloppe d’affichage continue et adaptative : extensions routières intégralement conservées, sans trou, dans la limite de 35 % d’aire ajoutée (rayon ${contract.smoothing_radius_m} m, aire Δ ${contract.max_area_variation_pct} %). Communes réellement couvertes, statistiques et exports certifiés inchangés.`
                        : contract.effective_mode === 'presentation'
                            && contract.algorithm === 'adaptive-territorial-envelope-v3'
                            ? `${contract.mode_label} (par défaut) — enveloppe d’affichage continue : les bras routiers étroits sont atténués et des espaces internes peuvent être comblés dans les limites contrôlées (rayon ${contract.smoothing_radius_m} m, aire Δ ${contract.max_area_variation_pct} %${contract.holes_removed ? `, ${contract.holes_removed} espace(s) interne(s) atténué(s)` : ''}). Communes réellement couvertes, statistiques et exports certifiés inchangés.`
                        : contract.effective_mode === 'presentation'
                            ? `${contract.mode_label} — forme adoucie pour l’affichage avec ${contract.passes || 1} passe(s) bornée(s) (déplacement max. ${contract.max_boundary_shift_m} m, aire Δ ${contract.max_area_variation_pct} %). Données et calculs inchangés.`
                            : `${contract.mode_label} — géométrie exacte reçue du fournisseur. Données et calculs inchangés.`;
                });
                [
                    document.getElementById(`isochroneGeometryMode_${mapId}`),
                ].filter(Boolean).forEach((select) => {
                    if (select.value !== isochroneGeometryMode) select.value = isochroneGeometryMode;
                });
                return contract;
            };

            const rememberIsochroneRenderContract = (key, result) => {
                isochroneRenderContracts.set(key, {
                    requested_mode: result.requested_mode,
                    effective_mode: result.effective_mode,
                    mode_label: result.mode_label,
                    algorithm: result.algorithm,
                    candidate_id: result.candidate_id,
                    passes: result.passes,
                    score: result.score,
                    candidates: result.candidates,
                    fallback_reason: result.fallback_reason,
                    metrics: result.metrics,
                    requested_commune_count: result.requested_commune_count,
                    rendered_commune_count: result.rendered_commune_count,
                    missing_commune_count: result.missing_commune_count,
                    geometry_source_checksum: result.geometry_source_checksum,
                    geometry_source_label: result.geometry_source_label,
                    geometry_source_vintage: result.geometry_source_vintage,
                    geojson: result.geojson,
                });
                const contract = syncIsochroneModeContract();
                syncActiveVisualExport('isochrone-render-contract');
                return contract;
            };

            const getIsochroneGeometryModeContract = (zoneId = null) => {
                if (zoneId && isochroneRenderContracts.has(zoneId)) {
                    const contract = isochroneRenderContracts.get(zoneId);
                    return {
                        ...contract,
                        geometry_source: contract.effective_mode === 'presentation'
                            ? 'provider-derived-display-only'
                            : contract.effective_mode === 'territorial'
                                ? 'result-commune-geometries-display-only'
                            : 'provider',
                        visual_profile: contract.effective_mode === 'presentation'
                            ? 'soft-bounded'
                            : contract.effective_mode === 'territorial'
                                ? 'whole-result-communes'
                            : 'provider-exact',
                        persisted: false,
                        used_for_aggregation: false,
                    };
                }
                return syncIsochroneModeContract();
            };

            const getVisualGeometrySnapshot = (zoneId = null) => {
                const serialize = (key, result) => result ? {
                    key,
                    geometry_requested_mode: result.requested_mode,
                    geometry_mode: result.effective_mode,
                    geometry_mode_label: result.mode_label,
                    geometry_algorithm: result.algorithm,
                    geometry_candidate_id: result.candidate_id,
                    geometry_passes: result.passes,
                    geometry_score: result.score,
                    geometry_source: result.effective_mode === 'presentation'
                        ? 'provider-derived-display-only'
                        : result.effective_mode === 'territorial'
                            ? 'result-commune-geometries-display-only'
                        : 'provider',
                    visual_profile: result.effective_mode === 'presentation'
                        ? 'soft-bounded'
                        : result.effective_mode === 'territorial'
                            ? 'whole-result-communes'
                        : 'provider-exact',
                    fallback_reason: result.fallback_reason,
                    requested_commune_count: result.requested_commune_count,
                    rendered_commune_count: result.rendered_commune_count,
                    missing_commune_count: result.missing_commune_count,
                    geometry_source_checksum: result.geometry_source_checksum,
                    metrics: result.metrics,
                    geojson: result.geojson,
                } : null;
                if (zoneId) {
                    return serialize(zoneId, zonesLayers.get(zoneId)?.presentationContract || null);
                }
                return {
                    contract: getIsochroneGeometryModeContract(),
                    simple: serialize('__simple__', isochroneRenderContracts.get('__simple__') || null),
                    zones: Array.from(zonesLayers.entries()).map(([key, zoneData]) => (
                        serialize(key, zoneData.presentationContract)
                    )).filter(Boolean),
                };
            };

            // Fonction pour mettre à jour les styles selon le mode
            const updateVisualizationStyles = async () => {
                if (visualizationMode === 'choropleth') {
                    return updateChoroplethVisualization(currentChoroplethField);
                }
                choroplethController?.deactivate?.();

                // Mettre à jour les zones multiples
                zonesLayers.forEach((zoneData, zoneId) => {
                    if (zoneData.layer) {
                        zoneData.layer.eachLayer((layer) => {
                            const feature = layer.feature;
                            if (feature && feature.properties) {
                                const layerType = feature.properties.layer;
                                const isCommune = layerType === 'communes';
                                const style = getVisualizationStyle(zoneData.color, isCommune);
                                layer.setStyle(getIsochronePathStyle(
                                    style,
                                    layerType,
                                    zoneData.presentationContract?.effective_mode,
                                ));
                            }
                        });
                    }
                });

                // Mettre à jour la couche simple
                if (geoLayer) {
                    geoLayer.eachLayer((layer) => {
                        const feature = layer.feature;
                        if (feature && feature.properties) {
                            const layerType = feature.properties.layer;
                            const isCommune = layerType === 'communes';
                            const baseColor = layerType === 'isochrone' ? '#2563eb' : '#7c3aed';
                            const style = getVisualizationStyle(baseColor, isCommune);
                            layer.setStyle(getIsochronePathStyle(
                                style,
                                layerType,
                                isochroneRenderContracts.get('__simple__')?.effective_mode,
                            ));
                        }
                    });
                }
                if (hasVisualizationGeometry()) {
                    setVisualizationStatus('success', 'Style appliqué. Utilisez « Masquer les options » pour revenir à la vue normale.');
                    return true;
                }
                setVisualizationStatus('empty', 'Aucune zone à mettre en forme. Lancez d’abord un calcul.');
                return false;
            };

            // Fonction pour calculer le centroïde d'un polygone (méthode améliorée)
            const calculateCentroid = (geometry) => {
                if (!geometry || !geometry.coordinates) return null;

                try {
                    let allCoords = [];

                    if (geometry.type === 'Polygon') {
                        // Prendre le premier ring (externe)
                        allCoords = geometry.coordinates[0];
                    } else if (geometry.type === 'MultiPolygon') {
                        // Prendre le premier polygone, premier ring
                        allCoords = geometry.coordinates[0][0];
                    } else {
                        return null;
                    }

                    if (allCoords.length === 0) return null;

                    // Calculer le centroïde géographique (moyenne des coordonnées)
                    let sumLon = 0, sumLat = 0, count = 0;
                    allCoords.forEach(coord => {
                        if (coord && coord.length >= 2) {
                            sumLon += coord[0]; // longitude
                            sumLat += coord[1]; // latitude
                            count++;
                        }
                    });

                    if (count === 0) return null;

                    return [sumLat / count, sumLon / count]; // [lat, lon] pour Leaflet
                } catch (e) {
                    console.warn('Erreur calcul centroïde:', e);
                    return null;
                }
            };

            // Fonction pour mettre à jour l'opacité d'une zone
            const updateZoneOpacity = (zoneId, opacity) => {
                const zoneData = zonesLayers.get(zoneId);
                if (zoneData && zoneData.layer) {
                    zoneData.opacity = opacity;
                    zoneData.layer.eachLayer((layer) => {
                        const feature = layer.feature;
                        if (feature && feature.properties) {
                            const layerType = feature.properties.layer;
                            const isCommune = layerType === 'communes';

                            // Obtenir le style de base selon le mode de visualisation
                            const baseStyle = getVisualizationStyle(zoneData.color, isCommune);

                            // Appliquer l'opacité personnalisée
                            layer.setStyle(getIsochronePathStyle({
                                color: baseStyle.color,
                                weight: baseStyle.weight,
                                fillColor: baseStyle.fillColor || zoneData.color,
                                fillOpacity: isCommune ? (baseStyle.fillOpacity || 0.2) * opacity : baseStyle.fillOpacity,
                                opacity: opacity,
                                dashArray: baseStyle.dashArray
                            }, layerType, zoneData.presentationContract?.effective_mode));
                        }
                    });
                    invalidateVisualExport('zone-opacity');
                }
            };

            const setZoneVisibility = (zoneId, visible) => {
                const zoneData = zonesLayers.get(zoneId);
                if (!zoneData?.layer) return false;
                const nextVisible = Boolean(visible);
                const visibilityChanged = (zoneData.visible !== false) !== nextVisible;
                zoneData.visible = nextVisible;
                if (nextVisible && !map.hasLayer(zoneData.layer)) {
                    zoneData.layer.addTo(map);
                } else if (!nextVisible && map.hasLayer(zoneData.layer)) {
                    map.removeLayer(zoneData.layer);
                }
                updateMapBounds(false);
                updateMapLegendMultiZones();
                if (visibilityChanged) {
                    window.maplyticsVisualExportController?.sync?.('zone-visibility');
                    scheduleChoroplethRefresh('zone-visibility');
                }
                return true;
            };

            // Fonction pour afficher/masquer les contours des communes (surcouche)
            // Affiche les contours de TOUTES les communes de la zone de chalandise, y compris entre les communes
            const toggleCommuneBorders = async (show) => {
                if (show) {
                    setVisualizationStatus('loading', 'Affichage des contours des communes en cours…');
                    try {
                        if (communeBordersLayer) {
                            communeBordersLayer.clearLayers();
                        } else {
                            communeBordersLayer = L.layerGroup().addTo(map);
                        }
                        const count = loadBordersFromDisplayedCommunes(new Set());
                        if (count === 0) {
                            communeBordersLayer.clearLayers();
                            map.removeLayer(communeBordersLayer);
                            communeBordersLayer = null;
                            showCommuneCentroids = false;
                            const checkbox = document.getElementById(`showCommuneBorders_${mapId}`);
                            if (checkbox) checkbox.checked = false;
                            setVisualizationStatus('empty', 'Aucune commune affichée dans le résultat courant. Lancez d’abord un calcul.');
                            return false;
                        }
                        setVisualizationStatus('success', `${count} contour(s) de commune affiché(s), sans chargement national.`);
                        return true;
                    } catch (error) {
                        console.warn('Erreur affichage des contours communaux:', error);
                        if (communeBordersLayer) {
                            communeBordersLayer.clearLayers();
                            map.removeLayer(communeBordersLayer);
                            communeBordersLayer = null;
                        }
                        showCommuneCentroids = false;
                        const checkbox = document.getElementById(`showCommuneBorders_${mapId}`);
                        if (checkbox) checkbox.checked = false;
                        setVisualizationStatus(
                            'error',
                            'Les contours n’ont pas pu être affichés. Réessayez.',
                            () => toggleCommuneBorders(true),
                        );
                        return false;
                    }
                }
                if (communeBordersLayer) {
                    communeBordersLayer.clearLayers();
                    map.removeLayer(communeBordersLayer);
                    communeBordersLayer = null;
                }
                setVisualizationStatus('success', 'Contours des communes masqués.');
                return true;
            };

            // Fonction de fallback : charger les contours depuis les communes déjà affichées
            const loadBordersFromDisplayedCommunes = (communeCodesInZones) => {
                const processedCodes = new Set();

                // Communes des zones multiples
                zonesLayers.forEach((zoneData, zoneId) => {
                    if (zoneData.layer) {
                        zoneData.layer.eachLayer((layer) => {
                            const feature = layer.feature;
                            if (feature && feature.properties && feature.properties.layer === 'communes') {
                                const codeInsee = feature.properties.code_insee || feature.properties.code_commune;
                                if (codeInsee && (!communeCodesInZones.size || communeCodesInZones.has(codeInsee)) && !processedCodes.has(codeInsee)) {
                                    processedCodes.add(codeInsee);

                                    const borderFeature = {
                                        type: 'Feature',
                                        geometry: feature.geometry,
                                        properties: feature.properties
                                    };

                                    const borderLayer = L.geoJSON(borderFeature, {
                                        style: {
                                            color: '#ef4444',
                                            weight: 2,
                                            fillOpacity: 0,
                                            fillColor: 'transparent',
                                            dashArray: '4 4',
                                            opacity: 0.8
                                        }
                                    });

                                    borderLayer.eachLayer((borderLayerItem) => {
                                        const communeName = feature.properties.nom_commune || 'Commune';
                                        borderLayerItem.bindTooltip(communeName, {
                                            permanent: false,
                                            direction: 'top',
                                            className: 'commune-border-tooltip'
                                        });
                                    });

                                    communeBordersLayer.addLayer(borderLayer);
                                }
                            }
                        });
                    }
                });

                // Communes de la couche simple
                if (geoLayer) {
                    geoLayer.eachLayer((layer) => {
                        const feature = layer.feature;
                        if (feature && feature.properties && feature.properties.layer === 'communes') {
                            const codeInsee = feature.properties.code_insee || feature.properties.code_commune;
                            if (codeInsee && (!communeCodesInZones.size || communeCodesInZones.has(codeInsee)) && !processedCodes.has(codeInsee)) {
                                processedCodes.add(codeInsee);

                                const borderFeature = {
                                    type: 'Feature',
                                    geometry: feature.geometry,
                                    properties: feature.properties
                                };

                                const borderLayer = L.geoJSON(borderFeature, {
                                    style: {
                                        color: '#ef4444',
                                        weight: 2,
                                        fillOpacity: 0,
                                        fillColor: 'transparent',
                                        dashArray: '4 4',
                                        opacity: 0.8
                                    }
                                });

                                borderLayer.eachLayer((borderLayerItem) => {
                                    const communeName = feature.properties.nom_commune || 'Commune';
                                    borderLayerItem.bindTooltip(communeName, {
                                        permanent: false,
                                        direction: 'top',
                                        className: 'commune-border-tooltip'
                                    });
                                });

                                communeBordersLayer.addLayer(borderLayer);
                            }
                        }
                    });
                }

                (window.debugLog || (() => {}))(`Contours des communes affichés (fallback): ${processedCodes.size} communes`);
                return processedCodes.size;
            };

            // La choroplèthe joint les lignes autorisées du résultat courant aux
            // seules géométries communales demandées. Le contrôleur extrait possède
            // l'unique couche Leaflet, les classes, la légende et le snapshot export.
            let currentChoroplethField = 'population';
            let currentChoroplethMeasure = 'value';
            let currentChoroplethScope = 'communes';
            let choroplethScopePreference = null;
            let syncChoroplethScopeAvailability = () => ({
                changed: false,
                zoneSeries: null,
            });
            let syncChoroplethMetricAvailability = () => {};

            const selectedChoroplethDataScope = () => {
                if (currentChoroplethScope === 'zones') return 'generated_zones';
                if (currentChoroplethScope === 'viewport') return 'viewport';
                return currentDemographicRows().length ? 'result_communes' : 'viewport';
            };

            const applyCurrentChoroplethScope = () => (
                currentChoroplethScope === 'viewport'
                    ? choroplethController?.setDataScope?.('viewport')
                    : choroplethController?.setScope?.(currentChoroplethScope)
            );

            const syncChoroplethControlStatus = (state, message, snapshot = null) => {
                const current = snapshot || choroplethController?.getSnapshot?.() || null;
                const tabStatus = document.getElementById(`choroplethTabStatus_${mapId}`);
                const panelStatus = document.getElementById(`choroplethPanelStatus_${mapId}`);
                const toggle = document.getElementById(`choroplethToggle_${mapId}`);
                if (tabStatus) {
                    tabStatus.dataset.state = state;
                    tabStatus.textContent = message;
                }
                if (panelStatus) {
                    panelStatus.dataset.state = state;
                    panelStatus.textContent = message;
                }
                if (toggle) {
                    const enabled = current?.active === true;
                    toggle.setAttribute('aria-pressed', String(enabled));
                    toggle.textContent = enabled ? 'Désactiver la carte' : 'Activer la carte';
                }
                const levelSelect = document.getElementById(`choroplethGeographicLevel_${mapId}`);
                if (levelSelect && current) {
                    levelSelect.disabled = currentChoroplethScope !== 'viewport';
                    levelSelect.title = levelSelect.disabled
                        ? 'Le niveau est déterminé par la source sélectionnée.'
                        : '';
                    if ([...levelSelect.options].some((option) => option.value === current.geographicLevel)) {
                        levelSelect.value = current.geographicLevel;
                    }
                }
                const renderSelect = document.getElementById(`choroplethRenderMode_${mapId}`);
                if (renderSelect && current) renderSelect.value = current.renderMode;
                const boundarySelect = document.getElementById(`choroplethBoundaries_${mapId}`);
                if (boundarySelect && current) boundarySelect.value = current.boundaries;
                const paletteSelect = document.getElementById(`choroplethPalette_${mapId}`);
                if (paletteSelect && current?.palette?.id) paletteSelect.value = current.palette.id;
                const legendModeSelect = document.getElementById(`choroplethLegendMode_${mapId}`);
                if (legendModeSelect && current?.legend?.mode) {
                    legendModeSelect.value = current.legend.mode;
                }
                const overlayOrderSelect = document.getElementById(`choroplethZoneOverlayOrder_${mapId}`);
                if (overlayOrderSelect && current?.zoneOverlay?.order) {
                    overlayOrderSelect.value = current.zoneOverlay.order;
                }
            };

            const currentDemographicRows = () => {
                const rows = [];
                const tableKey = mapId === 'importMap' ? 'import' : 'export';
                if (tableKey === 'export') {
                    const visibleZoneIds = [];
                    zonesLayers.forEach((zoneData, zoneId) => {
                        if (zoneData?.visible === false || !map.hasLayer(zoneData?.layer)) return;
                        visibleZoneIds.push(String(zoneId));
                    });
                    const visibleZones = visibleZoneIds.map(
                        (zoneId) => zonesManager?.zones?.get?.(zoneId),
                    ).filter(Boolean);
                    rows.push(...(zonesManager?.getAggregatedRowsForZones?.(visibleZones) || []));
                } else {
                    const tableRows = tableControllers?.import?.filteredRows;
                    if (Array.isArray(tableRows)) rows.push(...tableRows);
                }
                return rows;
            };

            const zoneMetricSeriesCache = new Map();
            const currentZoneMetricSeries = (requestedRole = 'stats') => {
                if (mapId !== 'exportMap' || !window.MaplyticsZoneMetricSeries) {
                    return null;
                }
                const role = requestedRole === 'map' ? 'map' : 'stats';
                const presentation = window.maplyticsZonePresentationController
                    ?.getSnapshot?.();
                const presentationState = Array.from(zonesManager?.zones?.entries?.() || [])
                    .map(([zoneId, zone]) => {
                        const rendered = zonesLayers.get(String(zoneId));
                        return [
                            String(zoneId),
                            String(zone?.name || ''),
                            zonePointName(zone),
                            String(rendered?.color || zone?.color || ''),
                            Boolean(rendered?.layer),
                            rendered?.visible !== false,
                            Number(zone?.data?.rows?.length || 0),
                            String(zone?.data?.job_id || zone?.data?.id || ''),
                        ];
                    });
                const cacheKey = JSON.stringify({
                    role,
                    status: presentation?.status || '',
                    mapMode: presentation?.mapMode || presentation?.mode || '',
                    viewMode: presentation?.viewMode || presentation?.mode || '',
                    generation: presentation?.generation || 0,
                    fingerprint: role === 'stats'
                        && presentation?.viewMode === 'comparison'
                        ? presentation?.statsProjectionFingerprint || ''
                        : presentation?.projectionFingerprint || '',
                    zones: presentationState,
                });
                const cached = zoneMetricSeriesCache.get(role);
                if (cacheKey === cached?.key) {
                    return cached.value;
                }
                let value = window.MaplyticsZoneMetricSeries.build(
                    presentation,
                    {
                        role,
                        getZone: (zoneId) => {
                            const normalizedZoneId = String(zoneId);
                            const zone = zonesManager?.zones?.get?.(normalizedZoneId);
                            const rendered = zonesLayers.get(normalizedZoneId);
                            return {
                                ...(zone || {}),
                                pointName: zonePointName(zone),
                                color: rendered?.color || zone?.color,
                                visible: Boolean(
                                    rendered?.layer
                                    && rendered.visible !== false
                                ),
                            };
                        },
                    },
                );
                if (
                    !value?.available
                    && role === 'map'
                    && presentation?.status !== 'loading'
                ) {
                    value = window.MaplyticsZoneMetricSeries.buildCurrentWorkspace?.(
                        Array.from(zonesManager?.zones?.entries?.() || []).map(([zoneId, zone]) => {
                            const rendered = zonesLayers.get(String(zoneId));
                            return {
                                id: String(zoneId),
                                name: String(zone?.name || zoneId),
                                pointName: zonePointName(zone),
                                color: rendered?.color || zone?.color,
                                visible: Boolean(rendered?.layer && rendered.visible !== false),
                                geometry: rendered?.canonicalGeojson || zone?.geojson || null,
                                rows: Array.isArray(zone?.data?.rows) ? zone.data.rows : [],
                            };
                        }),
                    ) || value;
                }
                zoneMetricSeriesCache.set(role, {key: cacheKey, value});
                return value;
            };
            const currentMapZoneMetricSeries = () => currentZoneMetricSeries('map');
            const currentStatsZoneMetricSeries = () => currentZoneMetricSeries('stats');
            if (mapId === 'exportMap') {
                window.maplyticsGetZoneMetricSeries = currentStatsZoneMetricSeries;
            }

            const zoneOverlayPaneName = `maplytics-zdc-overlay-${mapId}`;
            let currentZoneOverlayOrder = 'front';
            const ensureZoneOverlayPane = () => {
                let pane = map.getPane?.(zoneOverlayPaneName) || null;
                if (!pane && typeof map.createPane === 'function') {
                    pane = map.createPane(zoneOverlayPaneName);
                }
                if (pane?.style) pane.style.zIndex = currentZoneOverlayOrder === 'front' ? '450' : '300';
                return zoneOverlayPaneName;
            };

            const syncZoneBaseLayersForChoropleth = (snapshot) => {
                if (mapId !== 'exportMap') return;
                currentZoneOverlayOrder = snapshot?.zoneOverlay?.order === 'back' ? 'back' : 'front';
                const zoneOverlayPane = map.getPane?.(zoneOverlayPaneName);
                if (zoneOverlayPane?.style) {
                    zoneOverlayPane.style.zIndex = currentZoneOverlayOrder === 'front' ? '450' : '300';
                }
                const hideBaseZones = Boolean(
                    snapshot?.active
                    && snapshot?.scope === 'zones'
                    && snapshot?.featureCount > 0
                );
                zonesLayers.forEach((zoneData, zoneId) => {
                    if (!zoneData?.layer) return;
                    if (hideBaseZones) {
                        if (map.hasLayer(zoneData.layer)) map.removeLayer(zoneData.layer);
                    } else if (
                        zoneData.visible !== false
                        && !map.hasLayer(zoneData.layer)
                    ) {
                        zoneData.layer.addTo(map);
                    }
                    const overlayActive = Boolean(
                        snapshot?.active
                        && snapshot?.dataScope === 'result_communes'
                        && snapshot?.zoneOverlay?.visible
                    );
                    if (overlayActive) {
                        const baseOpacity = Number.isFinite(zoneData.choroplethBaseOpacity)
                            ? zoneData.choroplethBaseOpacity
                            : Number(zoneData.opacity ?? 1);
                        zoneData.choroplethBaseOpacity = baseOpacity;
                        updateZoneOpacity(String(zoneId), snapshot.zoneOverlay.opacity);
                        zoneData.opacity = baseOpacity;
                    } else if (Number.isFinite(zoneData.choroplethBaseOpacity)) {
                        updateZoneOpacity(String(zoneId), zoneData.choroplethBaseOpacity);
                        delete zoneData.choroplethBaseOpacity;
                    }
                });
            };

            if (window.MaplyticsHomeChoropleth && window.MaplyticsCommuneGeometries) {
                const initialZoneSeries = currentMapZoneMetricSeries();
                currentChoroplethScope = initialZoneSeries?.available
                    ? 'zones'
                    : 'communes';
                choroplethController = window.MaplyticsHomeChoropleth.create({
                    map,
                    L,
                    mapId,
                    surface: mapId === 'importMap' ? 'import' : 'export',
                    geometryClient: window.MaplyticsCommuneGeometries,
                    getRows: currentDemographicRows,
                    getZoneSeries: currentMapZoneMetricSeries,
                    defaultScope: currentChoroplethScope,
                    getMode: () => (
                        mapId === 'exportMap'
                            ? window.maplyticsZonePresentationController
                                ?.getSnapshot?.().mode
                                || 'cumulative'
                            : 'cumulative'
                    ),
                    getProjectionFingerprint: () => (
                        mapId === 'exportMap'
                            ? window.maplyticsZonePresentationController
                                ?.getSnapshot?.().projectionFingerprint || ''
                            : ''
                    ),
                    onStatus: (state, message, retry) => {
                        if (visualizationMode === 'choropleth') {
                            setVisualizationStatus(state, message, retry);
                        }
                        syncChoroplethControlStatus(state, message);
                        if (mapVisualSurface === 'import') {
                            syncImportDetailedExportChoices();
                        }
                    },
                    onChange: (reason, snapshot) => {
                        syncZoneBaseLayersForChoropleth(snapshot);
                        invalidateVisualExport(`choropleth-${reason}`);
                    },
                });
                syncChoroplethScopeAvailability = ({preferZones = false} = {}) => {
                    const scopeSelect = document.getElementById(`choroplethScope_${mapId}`);
                    const zoneOption = scopeSelect?.querySelector?.('option[value="zones"]');
                    const zoneSeries = currentMapZoneMetricSeries();
                    const zonesAvailable = mapId === 'exportMap' && zoneSeries?.available === true;
                    const generatedZoneCount = mapId === 'exportMap'
                        ? Number(zonesManager?.zones?.size || 0)
                        : 0;
                    const zonesSelectable = zonesAvailable || generatedZoneCount > 0;
                    const projectionLoading = mapId === 'exportMap'
                        && zoneSeries?.projectionStatus === 'loading';
                    if (zoneOption) {
                        zoneOption.disabled = !zonesSelectable;
                        zoneOption.title = zonesAvailable
                            ? ''
                            : zonesSelectable
                                ? (
                                    projectionLoading
                                        ? 'La projection ZDC est en cours de préparation.'
                                        : zoneSeries?.reason || 'La projection ZDC doit être recalculée.'
                                )
                                : 'Générez au moins une ZDC pour utiliser cette source.';
                    }
                    if (choroplethScopePreference === 'viewport') {
                        currentChoroplethScope = 'viewport';
                    } else {
                        currentChoroplethScope = window.MaplyticsZoneMetricSeries.resolveScope({
                            surface: mapVisualSurface,
                            current: currentChoroplethScope,
                            preference: choroplethScopePreference,
                            preferZones,
                            zonesAvailable: zonesSelectable,
                            projectionStatus: projectionLoading ? 'loading' : zoneSeries?.projectionStatus,
                        });
                    }
                    if (scopeSelect) scopeSelect.value = currentChoroplethScope;
                    return {
                        changed: choroplethController.getSnapshot().dataScope
                            !== selectedChoroplethDataScope(),
                        zoneSeries,
                    };
                };
                let refreshScheduled = false;
                scheduleChoroplethRefresh = (reason = 'dataset-change') => {
                    if (visualizationMode !== 'choropleth' || refreshScheduled) return;
                    refreshScheduled = true;
                    queueMicrotask(async () => {
                        refreshScheduled = false;
                        if (visualizationMode !== 'choropleth') return;
                        const scopeState = syncChoroplethScopeAvailability({
                            preferZones: true,
                        });
                        syncChoroplethMetricAvailability(scopeState.zoneSeries);
                        if (
                            choroplethController.getSnapshot().metric.id
                            !== currentChoroplethField
                        ) {
                            await Promise.resolve(
                                choroplethController.setMetric(currentChoroplethField),
                            );
                        }
                        if (scopeState.changed) {
                            syncZoneBaseLayersForChoropleth({
                                ...choroplethController.getSnapshot(),
                                scope: currentChoroplethScope,
                                featureCount: 0,
                            });
                            await Promise.resolve(applyCurrentChoroplethScope());
                        } else {
                            await choroplethController.refresh({ reason });
                        }
                    });
                };
                document.addEventListener('maplytics:demographic-rows-changed', (event) => {
                    const surface = mapId === 'importMap' ? 'import' : 'export';
                    if (event.detail?.surface === surface) {
                        scheduleChoroplethRefresh('dataset-change');
                    }
                });
                document.addEventListener('maplytics:zone-presentation-changed', () => {
                    if (mapId === 'exportMap') {
                        scheduleChoroplethRefresh('zone-presentation');
                    }
                });
                let choroplethViewportRefreshTimer = null;
                const scheduleViewportRefresh = () => {
                    const snapshot = choroplethController?.getSnapshot?.();
                    if (
                        visualizationMode !== 'choropleth'
                        || !snapshot?.active
                        || snapshot.dataScope !== 'viewport'
                    ) return;
                    if (choroplethViewportRefreshTimer) {
                        clearTimeout(choroplethViewportRefreshTimer);
                    }
                    choroplethViewportRefreshTimer = setTimeout(() => {
                        choroplethViewportRefreshTimer = null;
                        choroplethController?.refresh?.({ reason: 'viewport-change' });
                    }, 300);
                };
                map.on('moveend zoomend', scheduleViewportRefresh);
            }

            const updateChoroplethVisualization = async (field) => {
                currentChoroplethField = window.MaplyticsHomeChoropleth?.METRICS?.[field]
                    ? field
                    : 'population';
                if (!choroplethController) {
                    setVisualizationStatus(
                        'error',
                        'Le moteur de choroplèthe est indisponible. Rechargez la page.',
                    );
                    return false;
                }
                const hasDemographicAccess = typeof window.maplyticsHasFeature === 'function'
                    ? window.maplyticsHasFeature('demographic_data')
                    : hasFeature('demographic_data');
                if (!hasDemographicAccess) {
                    const denied = choroplethController.setAccessState?.('access_required')
                        || choroplethController.getSnapshot();
                    syncChoroplethControlStatus(
                        denied.status || 'warning',
                        denied.statusMessage
                            || 'Les cartes démographiques ne sont pas incluses dans votre accès actuel.',
                        denied,
                    );
                    return false;
                }
                choroplethController.setAccessState?.('available');
                if (choroplethController.getSnapshot().dataScope !== selectedChoroplethDataScope()) {
                    await Promise.resolve(
                        applyCurrentChoroplethScope(),
                    );
                }
                const current = choroplethController.getSnapshot();
                let snapshot = current.active
                    ? await Promise.resolve(
                        choroplethController.setMetric(currentChoroplethField),
                    )
                    : await choroplethController.activate({
                        metric: currentChoroplethField,
                    });
                snapshot = await Promise.resolve(
                    choroplethController.setMeasure(currentChoroplethMeasure),
                );
                return snapshot.active
                    && snapshot.featureCount > 0
                    && ['success', 'warning'].includes(snapshot.status);
            };
            const latInput = document.getElementById(latInputId);
            const lonInput = document.getElementById(lonInputId);
            const badge = document.getElementById(badgeId);
            const queryInput = document.getElementById(queryInputId);
            const searchBtn = document.getElementById(searchBtnId);

            const setMarker = (lat, lon, options = {}) => {
                if (marker) {
                    marker.setLatLng([lat, lon]);
                } else {
                    marker = L.marker([lat, lon]);
                }
                syncSelectionMarkerVisibility();
                latInput.value = lat;
                lonInput.value = lon;
                if (badge) {
                    badge.textContent = `Point sélectionné : ${lat.toFixed(5)}, ${lon.toFixed(5)}`;
                }
                document.dispatchEvent(new CustomEvent('maplytics:origin-marker-set', {
                    detail: { queryInputId, lat, lon, source: options.source || 'manual', statusMessage: options.statusMessage || null },
                }));
            };

            const clearMarker = () => {
                if (marker) {
                    map.removeLayer(marker);
                    marker = null;
                }
                if (latInput) latInput.value = '';
                if (lonInput) lonInput.value = '';
                if (badge) {
                    badge.textContent = 'Aucun point sélectionné';
                }
            };

            const cancelPendingInteractions = () => {
                interactionRequestGeneration += 1;
                markerReplacementCallback = null;
                map.getContainer()?.classList.remove('is-replacing-origin');
                reverseGeocodeAbort?.abort?.();
                searchGeocodeAbort?.abort?.();
                reverseGeocodeAbort = null;
                searchGeocodeAbort = null;
                if (queryInput) queryInput.disabled = false;
                if (searchBtn) {
                    searchBtn.disabled = false;
                    searchBtn.textContent = 'Chercher l\'adresse sur la carte';
                }
            };

            // Fonction de géocodage inverse (reverse geocoding)
            const reverseGeocode = async (lat, lng) => {
                const requestGeneration = interactionRequestGeneration;
                reverseGeocodeAbort?.abort?.();
                const controller = new AbortController();
                reverseGeocodeAbort = controller;
                try {
                    const response = await fetch(
                        `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}&zoom=18&addressdetails=1`,
                        {
                            signal: controller.signal,
                            headers: {
                                'User-Agent': 'Maplytics/1.0'
                            }
                        }
                    );
                    const data = await response.json();
                    if (requestGeneration !== interactionRequestGeneration) return null;
                    if (data && data.address) {
                        // Construire une adresse lisible
                        const address = data.address;
                        let addressString = '';

                        // Priorité : rue + numéro, puis ville, puis code postal
                        if (address.road) {
                            if (address.house_number) {
                                addressString += address.house_number + ' ';
                            }
                            addressString += address.road;
                        }

                        if (address.city || address.town || address.village) {
                            if (addressString) addressString += ', ';
                            addressString += address.city || address.town || address.village;
                        } else if (address.municipality) {
                            if (addressString) addressString += ', ';
                            addressString += address.municipality;
                        }

                        if (address.postcode) {
                            if (addressString) addressString += ' ' + address.postcode;
                            else addressString = address.postcode;
                        }

                        // Si on n'a rien trouvé, utiliser le display_name
                        if (!addressString && data.display_name) {
                            addressString = data.display_name.split(',')[0]; // Prendre juste la première partie
                        }

                        return addressString || null;
                    }
                    return null;
                } catch (error) {
                    if (error?.name === 'AbortError') return null;
                    console.error('Erreur lors du géocodage inverse:', error);
                    return null;
                } finally {
                    if (reverseGeocodeAbort === controller) reverseGeocodeAbort = null;
                }
            };

            map.on('click', async (event) => {
                const requestGeneration = interactionRequestGeneration;
                const replacementCallback = markerReplacementCallback;
                markerReplacementCallback = null;
                map.getContainer()?.classList.remove('is-replacing-origin');
                const { lat, lng } = event.latlng;
                const hasExistingZones = typeof zonesManager !== 'undefined' && zonesManager?.zones?.size > 0;
                setMarker(lat, lng, {
                    source: 'map-click',
                    statusMessage: hasExistingZones ? 'Nouveau point choisi - relancez le calcul' : 'Point défini',
                });

                // Remplir automatiquement le champ d'adresse avec le géocodage inverse
                if (queryInput) {
                    queryInput.value = 'Recherche...';
                    queryInput.disabled = true;

                    const address = await reverseGeocode(lat, lng);
                    if (requestGeneration !== interactionRequestGeneration) return;
                    if (address) {
                        queryInput.value = address;
                    } else {
                        queryInput.value = '';
                    }
                    if (queryInput.value) queryInput.dataset.selectedAddress = queryInput.value;
                    queryInput.disabled = false;
                }
                document.dispatchEvent(new CustomEvent('maplytics:origin-marker-address-resolved', {
                    detail: {queryInputId, lat, lon: lng, address: queryInput?.value || ''},
                }));
                replacementCallback?.({lat, lng, address: queryInput?.value || ''});
            });

            const beginMarkerReplacement = (callback) => {
                markerReplacementCallback = typeof callback === 'function' ? callback : () => {};
                const container = map.getContainer();
                container?.classList.add('is-replacing-origin');
                if (container && !container.hasAttribute('tabindex')) container.setAttribute('tabindex', '0');
                return true;
            };

            const styleGeoJson = (feature) => {
                const layer = feature?.properties?.layer;
                const isCommune = layer === 'communes';
                const baseColor = layer === 'isochrone' ? '#2563eb' : (isCommune ? '#7c3aed' : '#14b8a6');
                const style = getVisualizationStyle(baseColor, isCommune);
                return getIsochronePathStyle(
                    style,
                    layer,
                    isochroneRenderContracts.get('__simple__')?.effective_mode,
                );
            };

            const resetKpiReservedLayout = () => {
                kpiLayoutObserver?.disconnect?.();
                kpiLayoutObserver = null;
                const mapBox = map.getContainer()?.closest?.('.map-box');
                const panel = mapBox?.querySelector?.('.visualization-panel');
                if (
                    panel
                    && Object.prototype.hasOwnProperty.call(
                        panel.dataset,
                        'kpiOriginalMaxHeight',
                    )
                ) {
                    panel.style.maxHeight = panel.dataset.kpiOriginalMaxHeight;
                    delete panel.dataset.kpiOriginalMaxHeight;
                }
            };

            const syncKpiReservedLayout = (badgeElement) => {
                const mapElement = map.getContainer();
                const mapBox = mapElement?.closest?.('.map-box');
                const panel = mapBox?.querySelector?.('.visualization-panel');
                if (!mapElement || !panel || !badgeElement) return;
                if (!Object.prototype.hasOwnProperty.call(
                    panel.dataset,
                    'kpiOriginalMaxHeight',
                )) {
                    panel.dataset.kpiOriginalMaxHeight = panel.style.maxHeight || '';
                }
                const apply = () => requestAnimationFrame(() => {
                    if (!badgeElement.isConnected || !panel.isConnected) return;
                    const mapRect = mapElement.getBoundingClientRect();
                    const badgeRect = badgeElement.getBoundingClientRect();
                    const availableHeight = Math.max(
                        96,
                        Math.floor(badgeRect.top - mapRect.top - 16),
                    );
                    panel.style.maxHeight = `${availableHeight}px`;
                });
                apply();
                kpiLayoutObserver?.disconnect?.();
                if (typeof ResizeObserver === 'function') {
                    kpiLayoutObserver = new ResizeObserver(apply);
                    kpiLayoutObserver.observe(mapElement);
                    kpiLayoutObserver.observe(badgeElement);
                }
            };

            const updateKpiBadge = (zonesMap, filterZoneId = null) => {
                resetKpiReservedLayout();
                if (kpiBadgeControl) {
                    map.removeControl(kpiBadgeControl);
                    kpiBadgeControl = null;
                }
                if (!zonesMap || zonesMap.size === 0) return;

                const allRows = [];
                let badgeTitle = '📊 Zone de chalandise';
                if (filterZoneId && zonesMap.has(filterZoneId)) {
                    const zone = zonesMap.get(filterZoneId);
                    if (zone.data && zone.data.rows) {
                        zone.data.rows.forEach((row) => allRows.push(row));
                    }
                    badgeTitle = `📊 ${zone.name}`;
                } else {
                    zonesMap.forEach((zone) => {
                        if (zone.data && zone.data.rows) {
                            zone.data.rows.forEach((row) => allRows.push(row));
                        }
                    });
                }
                if (allRows.length === 0) return;

                const uniqueRows = window.MaplyticsZoneRowAllocation
                    ?.deduplicateRows?.(allRows) || allRows;
                const totalCommunes = uniqueRows.length;
                const totalPop = uniqueRows.reduce((s, r) => s + (parseFloat(r.population) || 0), 0);
                const totalMenages = uniqueRows.reduce((s, r) => s + (parseFloat(r.menages) || 0), 0);
                const revValues = uniqueRows.map(r => parseFloat(r.revenus) || 0).filter(v => v > 0);
                const avgRevenu = revValues.length > 0 ? revValues.reduce((a, b) => a + b, 0) / revValues.length : 0;

                kpiBadgeControl = L.control({ position: 'bottomright' });
                kpiBadgeControl.onAdd = () => {
                    const div = L.DomUtil.create('div', 'map-kpi-badge leaflet-control');
                    const surface = L.DomUtil.create('section', 'map-kpi-badge__surface', div);
                    const titleId = `mapKpiBadgeTitle_${mapId}`;
                    const contentId = `mapKpiBadgeContent_${mapId}`;
                    surface.setAttribute('aria-labelledby', titleId);
                    const header = L.DomUtil.create('div', 'map-kpi-badge__header', surface);
                    const title = L.DomUtil.create('span', 'map-kpi-badge__title', header);
                    title.id = titleId;
                    title.title = badgeTitle;
                    const toggle = L.DomUtil.create('button', 'map-kpi-badge__toggle', header);
                    toggle.type = 'button';
                    toggle.setAttribute('aria-controls', contentId);
                    const content = L.DomUtil.create('div', 'map-kpi-badge__content', surface);
                    content.id = contentId;

                    const appendMetric = (label, value, suffix) => {
                        const row = L.DomUtil.create('div', 'map-kpi-badge__metric', content);
                        row.append(document.createTextNode(`${label} `));
                        const strong = document.createElement('strong');
                        strong.textContent = String(value);
                        row.append(strong, document.createTextNode(suffix));
                    };
                    appendMetric('🏘️', totalCommunes, ' communes');
                    appendMetric('👥', Math.round(totalPop), ' habitants');
                    appendMetric('🏠', Math.round(totalMenages), ' ménages');
                    if (avgRevenu > 0) {
                        appendMetric('💰 Revenu moyen :', Math.round(avgRevenu), ' €');
                    }

                    const syncCollapsed = () => {
                        div.classList.toggle('map-kpi-badge--collapsed', kpiBadgeCollapsed);
                        div.dataset.collapsed = String(kpiBadgeCollapsed);
                        title.textContent = kpiBadgeCollapsed ? '📊 ZDC' : badgeTitle;
                        content.hidden = kpiBadgeCollapsed;
                        toggle.textContent = kpiBadgeCollapsed ? '+' : '−';
                        toggle.setAttribute('aria-expanded', String(!kpiBadgeCollapsed));
                        toggle.setAttribute(
                            'aria-label',
                            kpiBadgeCollapsed
                                ? 'Développer le récapitulatif de la zone'
                                : 'Réduire le récapitulatif de la zone',
                        );
                        toggle.title = toggle.getAttribute('aria-label');
                        syncKpiReservedLayout(div);
                    };
                    toggle.addEventListener('click', (event) => {
                        event.preventDefault();
                        event.stopPropagation();
                        kpiBadgeCollapsed = !kpiBadgeCollapsed;
                        syncCollapsed();
                    });
                    syncCollapsed();
                    L.DomEvent.disableClickPropagation(div);
                    L.DomEvent.disableScrollPropagation(div);
                    return div;
                };
                kpiBadgeControl.addTo(map);
            };

            const getOriginContextSnapshot = () => Array.from(zoneCenterMarkers.entries())
                .filter(([, point]) => point.visible !== false)
                .map(([pointKey, point]) => {
                    const contexts = Array.from(point.contexts?.values?.() || []);
                    const context = contexts[0] || {};
                    const resolution = context.resolution && typeof context.resolution === 'object'
                        ? context.resolution
                        : null;
                    const distance = Number(resolution?.distance_m);
                    return {
                        pointKey,
                        label: context.label || 'Point de départ',
                        approximate: Boolean(context.approximate),
                        zoneCount: point.zoneIds.size,
                        adjustmentDistanceM: Number.isFinite(distance) ? distance : null,
                        transportMode: String(resolution?.transport_mode || ''),
                        hasEffectiveOrigin: Boolean(resolution?.effective_origin),
                    };
                });

            const updateOriginContextControl = () => {
                if (originContextControl) {
                    map.removeControl(originContextControl);
                    originContextControl = null;
                }
                const contexts = getOriginContextSnapshot();
                if (!contexts.length) return;

                originContextControl = L.control({position: 'bottomleft'});
                originContextControl.onAdd = () => {
                    const div = L.DomUtil.create(
                        'div',
                        'home-origin-context leaflet-control',
                    );
                    div.setAttribute('role', 'status');
                    div.setAttribute('aria-live', 'polite');
                    const summary = document.createElement('p');
                    summary.className = 'home-origin-context__summary';
                    if (contexts.length === 1) {
                        const context = contexts[0];
                        const strong = document.createElement('strong');
                        strong.textContent = context.label;
                        summary.append(strong);
                        const zoneSuffix = context.zoneCount > 1
                            ? ` · ${context.zoneCount} zones`
                            : '';
                        summary.append(document.createTextNode(zoneSuffix));
                    } else {
                        summary.textContent = `${contexts.length} points de départ affichés`;
                    }

                    const explanation = document.createElement('p');
                    explanation.className = 'home-origin-context__explanation';
                    explanation.textContent = contexts.some((context) => context.approximate)
                        ? 'Un point importé peut être estimé depuis sa géométrie. Le contour reste celui des données source.'
                        : 'Le contour suit les voies accessibles et peut donc être asymétrique : le départ n’est pas le centre géométrique de la zone.';

                    const adjustedContexts = contexts.filter(
                        (context) => context.hasEffectiveOrigin
                            && Number.isFinite(context.adjustmentDistanceM)
                            && context.adjustmentDistanceM > 0.5,
                    );
                    div.append(summary, explanation);
                    if (adjustedContexts.length) {
                        const adjustment = document.createElement('p');
                        adjustment.className = 'home-origin-context__adjustment';
                        if (adjustedContexts.length === 1) {
                            adjustment.textContent = `Point métier conservé · départ routier ajusté de ${Math.max(1, Math.round(adjustedContexts[0].adjustmentDistanceM))} m.`;
                        } else {
                            adjustment.textContent = `${adjustedContexts.length} départs routiers ont été ajustés ; les points métier restent conservés.`;
                        }
                        div.append(adjustment);
                    }
                    window.MaplyticsLeafletControlDisclosure?.enhance?.(div, {
                        surface: mapVisualSurface,
                        controlKey: 'origin-context',
                        title: 'Départ et forme de la zone',
                    });
                    L.DomEvent.disableClickPropagation(div);
                    L.DomEvent.disableScrollPropagation(div);
                    return div;
                };
                originContextControl.addTo(map);
            };

            const removeZoneCenterMarker = (zoneId) => {
                const normalizedZoneId = String(zoneId || '');
                const pointKey = zoneCenterKeys.get(normalizedZoneId);
                if (!pointKey) return false;
                zoneCenterKeys.delete(normalizedZoneId);
                const point = zoneCenterMarkers.get(pointKey);
                if (!point) return false;
                point.zoneIds.delete(normalizedZoneId);
                point.contexts?.delete?.(normalizedZoneId);
                if (point.zoneIds.size > 0) {
                    updateOriginContextControl();
                    return true;
                }
                if (map.hasLayer(point.marker)) map.removeLayer(point.marker);
                zoneCenterMarkers.delete(pointKey);
                syncSelectionMarkerVisibility();
                updateOriginContextControl();
                return true;
            };

            const setPointVisibility = (pointKey, visible) => {
                const point = zoneCenterMarkers.get(String(pointKey || ''));
                if (!point) return false;
                const nextVisible = Boolean(visible);
                const changed = point.visible !== nextVisible;
                point.visible = nextVisible;
                if (nextVisible && !map.hasLayer(point.marker)) point.marker.addTo(map);
                else if (!nextVisible && map.hasLayer(point.marker)) map.removeLayer(point.marker);
                if (nextVisible) {
                    requestAnimationFrame(() => {
                        point.marker.getElement()?.style.setProperty(
                            '--home-origin-color',
                            point.style.color,
                        );
                    });
                }
                syncSelectionMarkerVisibility();
                if (changed) {
                    window.maplyticsVisualExportController?.sync?.('point-visibility');
                }
                updateOriginContextControl();
                return true;
            };

            const originMarkerIcon = (styleInput = {}) => {
                const style = window.MaplyticsOriginMarkerStyle.normalize(styleInput);
                const size = window.MaplyticsOriginMarkerStyle.pixelSize(style);
                return L.divIcon({
                    className: `home-zone-origin-marker home-zone-origin-marker--${style.size}`,
                    html: window.MaplyticsOriginMarkerStyle.iconMarkup(style),
                    iconSize: [size, size],
                    iconAnchor: [size / 2, size / 2],
                });
            };

            const applyOriginMarkerStyle = (point, styleInput = {}) => {
                const style = window.MaplyticsOriginMarkerStyle.normalize(styleInput);
                point.style = style;
                point.marker.setIcon(originMarkerIcon(style));
                requestAnimationFrame(() => {
                    point.marker.getElement()?.style.setProperty(
                        '--home-origin-color',
                        style.color,
                    );
                });
                return style;
            };

            const setZoneCenterMarker = (
                zoneId,
                origin,
                _color,
                name,
                requestedPointKey = '',
                visible = true,
                originStyle = null,
            ) => {
                const normalizedZoneId = String(zoneId || '').trim();
                const lat = Number(origin?.lat ?? origin?.latitude);
                const lon = Number(origin?.lon ?? origin?.lng ?? origin?.longitude);
                if (
                    !normalizedZoneId
                    || !Number.isFinite(lat)
                    || !Number.isFinite(lon)
                    || lat < -90
                    || lat > 90
                    || lon < -180
                    || lon > 180
                ) return null;
                const pointKey = String(requestedPointKey || `${lat.toFixed(6)},${lon.toFixed(6)}`);
                const previousPointKey = zoneCenterKeys.get(normalizedZoneId);
                if (previousPointKey && previousPointKey !== pointKey) {
                    removeZoneCenterMarker(normalizedZoneId);
                }
                const label = String(
                    origin?.display_name || origin?.label || name || 'Point de départ'
                ).trim()
                    || 'Point de départ';
                const style = window.MaplyticsOriginMarkerStyle.normalize(originStyle);
                let point = zoneCenterMarkers.get(pointKey);
                if (!point) {
                    const tooltip = document.createElement('span');
                    tooltip.textContent = label;
                    const marker = L.marker([lat, lon], {
                        keyboard: true,
                        title: `Point de départ : ${label}`,
                        alt: `Point de départ : ${label}`,
                        icon: originMarkerIcon(style),
                    });
                    marker.bindTooltip(tooltip, { direction: 'top', offset: [0, -10] });
                    point = {
                        marker,
                        zoneIds: new Set(),
                        contexts: new Map(),
                        visible: Boolean(visible),
                        coordinateKey: coordinatePointKey(lat, lon),
                        style,
                    };
                    zoneCenterMarkers.set(pointKey, point);
                    if (point.visible) marker.addTo(map);
                }
                applyOriginMarkerStyle(point, style);
                point.zoneIds.add(normalizedZoneId);
                point.contexts.set(normalizedZoneId, {
                    label,
                    approximate: Boolean(origin?.approximate),
                    resolution: origin?.origin_resolution || null,
                });
                zoneCenterKeys.set(normalizedZoneId, pointKey);
                syncSelectionMarkerVisibility();
                setPointVisibility(pointKey, visible);
                if (geoLayer || zonesLayers.size) updateMapBounds(false);
                return pointKey;
            };

            const clearZoneCenterMarkers = () => {
                zoneCenterMarkers.forEach((point) => {
                    if (map.hasLayer(point.marker)) map.removeLayer(point.marker);
                });
                zoneCenterMarkers.clear();
                zoneCenterKeys.clear();
                syncSelectionMarkerVisibility();
                if (originContextControl) {
                    map.removeControl(originContextControl);
                    originContextControl = null;
                }
            };

            const clearGeoJson = () => {
                simpleRenderGeneration += 1;
                isochroneGeometryRequestGeneration += 1;
                isochroneGeometryAbort?.abort?.();
                isochroneGeometryAbort = null;
                simpleCanonicalGeoJson = null;
                simpleRenderOptions = {};
                isochroneRenderContracts.clear();
                if (geoLayer) {
                    geoLayer.remove();
                    geoLayer = null;
                }
                // Supprimer toutes les zones
                zonesLayers.forEach((zoneData) => {
                    if (zoneData.layer) {
                        zoneData.layer.remove();
                    }
                });
                zonesLayers.clear();
                if (legendControl) {
                    map.removeControl(legendControl);
                    legendControl = null;
                }
                if (kpiBadgeControl) {
                    resetKpiReservedLayout();
                    map.removeControl(kpiBadgeControl);
                    kpiBadgeControl = null;
                }
                if (communeBordersLayer) {
                    communeBordersLayer.clearLayers();
                    map.removeLayer(communeBordersLayer);
                    communeBordersLayer = null;
                }
                choroplethController?.clear?.();
                showCommuneCentroids = false;
                const communeBordersToggle = document.getElementById(`showCommuneBorders_${mapId}`);
                if (communeBordersToggle) communeBordersToggle.checked = false;
                clearZoneCenterMarkers();
                syncIsochroneModeContract();
                syncActiveVisualExport('isochrone-clear');
                // NE PAS supprimer le marker - il doit rester visible
            };

            const finalizeSimpleGeoJsonRender = (geojson, shouldAnimate) => {
                if (!geoLayer) return;
                try {
                    const bounds = geoLayer.getBounds();
                    if (bounds.isValid()) {
                        if (marker) {
                            bounds.extend(marker.getLatLng());
                        }
                        map.fitBounds(bounds, {
                            padding: [50, 50],
                            maxZoom: 15,
                            animate: shouldAnimate
                        });
                    }
                } catch (error) {
                    console.warn('Impossible de calculer les bornes du GeoJSON', error);
                }
                updateMapLegend(geojson);
                syncActiveVisualExport('simple-map-rendered');
                document.dispatchEvent(new CustomEvent('maplytics:simple-map-rendered', {
                    detail: {mapId, surface: mapVisualSurface},
                }));
            };

            const scheduleGeometryPresentationRefresh = (presentationResult) => {
                const pendingMode = presentationResult?.fallback_reason === 'soft_presentation_pending'
                    ? 'presentation'
                    : presentationResult?.fallback_reason === 'territorial_geometry_pending'
                        ? 'territorial'
                        : null;
                if (
                    !pendingMode
                    || isochroneGeometryMode !== pendingMode
                ) return;
                // Any new canonical contour supersedes an older display request.
                // Abort it before coalescing the next refresh so a stale silhouette
                // can never replace newer zone layers.
                isochroneGeometryRequestGeneration += 1;
                isochroneGeometryAbort?.abort?.();
                isochroneGeometryAbort = null;
                if (geometryRefreshScheduled) return;
                geometryRefreshScheduled = true;
                queueMicrotask(() => {
                    geometryRefreshScheduled = false;
                    if (isochroneGeometryMode !== pendingMode) return;
                    setIsochroneGeometryMode(pendingMode, {force: true})
                        .catch((error) => {
                            console.warn(
                                'Impossible d’actualiser la présentation du contour',
                                error,
                            );
                        });
                });
            };

            const originAdjustmentStyle = (feature, fallbackStyle) => {
                if (feature?.properties?.layer !== 'origin_adjustment') {
                    return fallbackStyle;
                }
                return {
                    color: '#0f766e',
                    weight: 3,
                    opacity: 0.9,
                    fillOpacity: 0,
                    dashArray: '5 5',
                };
            };
            const originAdjustmentPoint = (feature, latlng) => {
                if (feature?.properties?.layer !== 'origin_effective') {
                    return L.marker(latlng);
                }
                return L.circleMarker(latlng, {
                    radius: 7,
                    color: '#ffffff',
                    weight: 2,
                    fillColor: '#0f766e',
                    fillOpacity: 1,
                });
            };
            const bindOriginAdjustmentLabel = (feature, layer) => {
                const label = feature?.properties?.label;
                if (!label || !layer?.bindTooltip) return;
                const distance = Number(feature?.properties?.origin_adjustment_distance_m);
                const suffix = Number.isFinite(distance) ? ` · ${Math.round(distance)} m` : '';
                layer.bindTooltip(`${label}${suffix}`, {direction: 'top'});
            };

            const renderGeoJson = (geojson, zoneId = null, zoneColor = null, zoneName = null, options = {}) => {
                if (!geojson || !geojson.features || !geojson.features.length) {
                    return;
                }
                scheduleChoroplethRefresh('map-render');
                const shouldAnimate = options.animate !== false && options.restoring !== true;
                const presentationResult = options.presentationResult
                    || deriveIsochroneDisplay(geojson);
                const displayGeoJson = presentationResult.geojson;

                // Si zoneId fourni, c'est une zone multiple
                if (zoneId && zoneColor) {
                    // Supprimer l'ancienne zone si elle existe
                    let previousVisibility = typeof options.visible === 'boolean'
                        ? options.visible
                        : true;
                    if (zonesLayers.has(zoneId)) {
                        const oldZone = zonesLayers.get(zoneId);
                        if (typeof options.visible !== 'boolean') {
                            previousVisibility = oldZone.visible !== false;
                        }
                        if (oldZone.layer) {
                            oldZone.layer.remove();
                        }
                        isochroneRenderContracts.delete(zoneId);
                    }

                    // Style personnalisé pour cette zone (utilise le mode de visualisation)
                    const zoneStyle = (feature) => {
                        const layer = feature?.properties?.layer;
                        const isCommune = layer === 'communes';
                        const style = getVisualizationStyle(zoneColor, isCommune);
                        return originAdjustmentStyle(feature, getIsochronePathStyle(
                            style,
                            layer,
                            presentationResult.effective_mode,
                        ));
                    };

                    const zoneLayer = L.geoJSON(displayGeoJson, {
                        style: zoneStyle,
                        pointToLayer: originAdjustmentPoint,
                        onEachFeature: bindOriginAdjustmentLabel,
                        pane: ensureZoneOverlayPane(),
                    }).addTo(map);
                    zonesLayers.set(zoneId, {
                        layer: zoneLayer,
                        color: zoneColor,
                        name: zoneName || `Zone ${zoneId}`,
                        opacity: 1.0, // Opacité par défaut
                        visible: previousVisibility,
                        canonicalGeojson: geojson,
                        presentationContract: presentationResult,
                    });
                    if (!previousVisibility) map.removeLayer(zoneLayer);
                    rememberIsochroneRenderContract(zoneId, presentationResult);

                    // Ajuster la vue pour toutes les zones
                    if (!options.deferBounds) {
                        updateMapBounds(shouldAnimate);
                        updateMapLegendMultiZones();
                    }
                    if (!options.presentationResult) {
                        scheduleGeometryPresentationRefresh(presentationResult);
                    }
                } else {
                    // Mode simple (une seule zone)
                    clearGeoJson();
                    simpleCanonicalGeoJson = geojson;
                    simpleRenderOptions = { ...options };
                    rememberIsochroneRenderContract('__simple__', presentationResult);
                    const features = displayGeoJson.features;
                    const useProgressiveRender = options.progressive === true
                        && features.length > IMPORT_MAP_RENDER_CHUNK_SIZE;
                    const simpleStyle = (feature) => originAdjustmentStyle(
                        feature,
                        styleGeoJson(feature),
                    );
                    if (!useProgressiveRender) {
                        geoLayer = L.geoJSON(displayGeoJson, {
                            style: simpleStyle,
                            pointToLayer: originAdjustmentPoint,
                            onEachFeature: bindOriginAdjustmentLabel,
                        }).addTo(map);
                        finalizeSimpleGeoJsonRender(displayGeoJson, shouldAnimate);
                        if (!options.presentationResult) {
                            scheduleGeometryPresentationRefresh(presentationResult);
                        }
                        return;
                    }

                    geoLayer = L.geoJSON(null, {
                        style: simpleStyle,
                        pointToLayer: originAdjustmentPoint,
                        onEachFeature: bindOriginAdjustmentLabel,
                    }).addTo(map);
                    const renderGeneration = simpleRenderGeneration;
                    let renderedCount = 0;
                    const renderNextChunk = () => {
                        if (
                            renderGeneration !== simpleRenderGeneration
                            || !geoLayer
                        ) {
                            return;
                        }
                        const nextFeatures = features.slice(
                            renderedCount,
                            renderedCount + IMPORT_MAP_RENDER_CHUNK_SIZE
                        );
                        geoLayer.addData({
                            type: 'FeatureCollection',
                            features: nextFeatures
                        });
                        renderedCount += nextFeatures.length;
                        if (renderedCount < features.length) {
                            requestAnimationFrame(renderNextChunk);
                            return;
                        }
                        finalizeSimpleGeoJsonRender(displayGeoJson, shouldAnimate);
                    };
                    requestAnimationFrame(renderNextChunk);
                    if (!options.presentationResult) {
                        scheduleGeometryPresentationRefresh(presentationResult);
                    }
                }
            };

            const setIsochroneGeometryMode = async (mode, modeOptions = {}) => {
                const nextMode = normalizeIsochroneGeometryMode(mode);
                if (
                    !modeOptions.force
                    && nextMode === isochroneGeometryMode
                    && isochroneRenderContracts.size
                ) {
                    return getIsochroneGeometryModeContract();
                }
                isochroneGeometryMode = nextMode;
                isochroneGeometryRequestGeneration += 1;
                const requestGeneration = isochroneGeometryRequestGeneration;
                isochroneGeometryAbort?.abort?.();
                isochroneGeometryAbort = null;
                const zoneSnapshots = Array.from(zonesLayers.entries()).map(([zoneId, zoneData]) => ({
                    zoneId,
                    canonicalGeojson: zoneData.canonicalGeojson,
                    color: zoneData.color,
                    name: zoneData.name,
                    opacity: zoneData.opacity,
                    visible: zoneData.visible !== false,
                    zoneType: zonesManager?.zones?.get?.(zoneId)?.zoneType
                        || zonesManager?.zones?.get?.(String(zoneId))?.zoneType
                        || 'isochrone',
                    origin: zonesManager?.zones?.get?.(zoneId)?.origin
                        || zonesManager?.zones?.get?.(String(zoneId))?.origin
                        || null,
                    transportMode: zonesManager?.zones?.get?.(zoneId)?.transportMode
                        || zonesManager?.zones?.get?.(String(zoneId))?.transportMode
                        || 'unknown',
                    threshold: zonesManager?.zones?.get?.(zoneId)?.minutes
                        ?? zonesManager?.zones?.get?.(String(zoneId))?.minutes
                        ?? null,
                })).filter((snapshot) => snapshot.canonicalGeojson);
                const simpleSnapshot = simpleCanonicalGeoJson;
                const simpleOptionsSnapshot = { ...simpleRenderOptions };
                const simpleIsochroneFeature = simpleSnapshot?.features?.find((feature) => (
                    feature?.properties?.layer === 'isochrone'
                    && ['Polygon', 'MultiPolygon'].includes(feature?.geometry?.type)
                ));
                const markerLocation = marker?.getLatLng?.();
                const simplePresentationSnapshot = simpleIsochroneFeature ? {
                    zoneId: 'simple-map',
                    canonicalGeojson: simpleSnapshot,
                    zoneType: 'isochrone',
                    origin: markerLocation ? {
                        lat: Number(markerLocation.lat),
                        lon: Number(markerLocation.lng),
                    } : null,
                    transportMode: String(
                        simpleIsochroneFeature?.properties?.transport_mode
                        || simpleIsochroneFeature?.properties?.profile
                        || 'unknown',
                    ),
                    threshold: Number(
                        simpleIsochroneFeature?.properties?.minutes
                        ?? simpleIsochroneFeature?.properties?.value
                        ?? NaN,
                    ),
                } : null;
                const presentationSnapshots = zoneSnapshots.length
                    ? zoneSnapshots
                    : simplePresentationSnapshot
                        ? [simplePresentationSnapshot]
                        : [];
                let softResults = null;
                let softFailure = null;
                let territorialResults = null;
                let territorialFailure = null;

                if (nextMode === 'presentation' && presentationSnapshots.length) {
                    const status = document.getElementById(`isochroneGeometryStatus_${mapId}`);
                    if (status) status.textContent = 'Préparation de la silhouette adoucie…';
                    setVisualizationStatus(
                        'loading',
                        'Adoucissement du contour en conservant les extensions routières…',
                    );
                    try {
                        softResults = await buildSoftPresentationResults(
                            presentationSnapshots,
                            requestGeneration,
                        );
                    } catch (error) {
                        if (
                            requestGeneration !== isochroneGeometryRequestGeneration
                            || error?.name === 'AbortError'
                            || error?.code === 'soft_presentation_request_stale'
                        ) return getIsochroneGeometryModeContract();
                        softFailure = error;
                        softResults = new Map(presentationSnapshots.map((snapshot) => {
                            const local = window.MaplyticsIsochronePresentation?.derive?.(
                                snapshot.canonicalGeojson,
                                {mode: 'presentation'},
                            ) || deriveIsochroneDisplay(snapshot.canonicalGeojson);
                            return [String(snapshot.zoneId), {
                                ...local,
                                fallback_reason: error?.code
                                    || 'soft_presentation_service_unavailable',
                            }];
                        }));
                    } finally {
                        if (requestGeneration === isochroneGeometryRequestGeneration) {
                            isochroneGeometryAbort = null;
                        }
                    }
                } else if (nextMode === 'territorial' && zoneSnapshots.length) {
                    const status = document.getElementById(`isochroneGeometryStatus_${mapId}`);
                    if (status) status.textContent = 'Chargement des communes du résultat courant…';
                    setVisualizationStatus(
                        'loading',
                        'Préparation du contour territorial à partir des communes du résultat…',
                    );
                    try {
                        territorialResults = await buildTerritorialPresentationResults(
                            zoneSnapshots,
                            requestGeneration,
                        );
                    } catch (error) {
                        if (
                            requestGeneration !== isochroneGeometryRequestGeneration
                            || error?.code === 'territorial_request_stale'
                            || error?.code === 'commune_geometry_request_aborted'
                        ) return getIsochroneGeometryModeContract();
                        isochroneGeometryMode = 'presentation';
                        territorialFailure = error;
                        const select = document.getElementById(`isochroneGeometryMode_${mapId}`);
                        if (select) select.value = 'presentation';
                    } finally {
                        if (requestGeneration === isochroneGeometryRequestGeneration) {
                            isochroneGeometryAbort = null;
                        }
                    }
                } else if (nextMode === 'territorial') {
                    isochroneGeometryMode = 'presentation';
                }

                const liveZoneSnapshots = zoneSnapshots.map((snapshot) => {
                    const live = zonesLayers.get(snapshot.zoneId);
                    if (!live || live.canonicalGeojson !== snapshot.canonicalGeojson) return null;
                    return {
                        ...snapshot,
                        color: live.color,
                        name: live.name,
                        opacity: live.opacity,
                        visible: live.visible !== false,
                    };
                }).filter(Boolean);
                if (liveZoneSnapshots.length) {
                    zonesLayers.forEach((zoneData) => zoneData.layer?.remove());
                    zonesLayers.clear();
                    isochroneRenderContracts.clear();
                    liveZoneSnapshots.forEach((snapshot) => {
                        renderGeoJson(
                            snapshot.canonicalGeojson,
                            snapshot.zoneId,
                            snapshot.color,
                            snapshot.name,
                            {
                                restoring: true,
                                animate: false,
                                deferBounds: true,
                                presentationResult: nextMode === 'territorial'
                                    ? territorialResults?.get(String(snapshot.zoneId))
                                    : nextMode === 'presentation'
                                        ? softResults?.get(String(snapshot.zoneId))
                                        : null,
                            },
                        );
                        updateZoneOpacity(snapshot.zoneId, snapshot.opacity);
                        setZoneVisibility(snapshot.zoneId, snapshot.visible);
                    });
                    updateMapBounds(false);
                    updateMapLegendMultiZones();
                } else if (simpleSnapshot) {
                    renderGeoJson(simpleSnapshot, null, null, null, {
                        ...simpleOptionsSnapshot,
                        restoring: true,
                        animate: false,
                        presentationResult: nextMode === 'presentation'
                            ? softResults?.get('simple-map')
                            : null,
                    });
                } else {
                    syncIsochroneModeContract();
                }
                if (visualizationMode === 'choropleth' && hasVisualizationGeometry()) {
                    await updateChoroplethVisualization(currentChoroplethField);
                }
                const contract = getIsochroneGeometryModeContract();
                if (liveZoneSnapshots.length || simpleSnapshot) {
                    if (softFailure) {
                        const geometryStatus = document.getElementById(
                            `isochroneGeometryStatus_${mapId}`,
                        );
                        const fallbackStatus = formatIsochroneFallbackStatus(contract);
                        if (geometryStatus) {
                            geometryStatus.textContent = fallbackStatus;
                        }
                        setVisualizationStatus(
                            'warning',
                            fallbackStatus,
                            () => setIsochroneGeometryMode('presentation', {force: true}),
                        );
                    } else if (territorialFailure) {
                        const geometryStatus = document.getElementById(
                            `isochroneGeometryStatus_${mapId}`,
                        );
                        if (geometryStatus) {
                            geometryStatus.textContent = `${territorialFailure.message || 'La présentation territoriale par communes est indisponible.'} Présentation adoucie conservée ; données et calculs inchangés.`;
                        }
                        setVisualizationStatus(
                            'warning',
                            `${territorialFailure.message || 'La présentation territoriale par communes est indisponible.'} Présentation adoucie conservée.`,
                            () => setIsochroneGeometryMode('territorial', {force: true}),
                        );
                    } else {
                        setVisualizationStatus(
                            contract.fallback_count || contract.missing_commune_count
                                ? 'warning'
                                : 'success',
                            `${contract.mode_label} appliquée aux contours isochrones.`,
                        );
                    }
                } else {
                    setVisualizationStatus('empty', 'Aucun contour isochrone à mettre en forme. Lancez d’abord un calcul.');
                }
                syncActiveVisualExport('isochrone-geometry-mode');
                return contract;
            };

            const removeZone = (zoneId) => {
                if (zonesLayers.has(zoneId)) {
                    isochroneGeometryRequestGeneration += 1;
                    isochroneGeometryAbort?.abort?.();
                    isochroneGeometryAbort = null;
                    const zoneData = zonesLayers.get(zoneId);
                    if (zoneData.layer) {
                        zoneData.layer.remove();
                    }
                    zonesLayers.delete(zoneId);
                    isochroneRenderContracts.delete(zoneId);
                    removeZoneCenterMarker(zoneId);
                    updateMapBounds();
                    updateMapLegendMultiZones();
                    syncIsochroneModeContract();
                    syncActiveVisualExport('isochrone-zone-removed');
                    scheduleChoroplethRefresh('zone-removed');
                    if (isochroneGeometryMode === 'presentation' && zonesLayers.size) {
                        scheduleGeometryPresentationRefresh({
                            fallback_reason: 'soft_presentation_pending',
                        });
                    }
                }
            };

            const updateMapBounds = (animate = true) => {
                const allBounds = [];
                if (geoLayer) {
                    try {
                        const bounds = geoLayer.getBounds();
                        if (bounds.isValid()) {
                            allBounds.push(bounds);
                        }
                    } catch (e) {
                        console.warn('Erreur bounds geoLayer:', e);
                    }
                }
                zonesLayers.forEach((zoneData) => {
                    if (zoneData.layer && zoneData.visible !== false) {
                        try {
                            const bounds = zoneData.layer.getBounds();
                            if (bounds.isValid()) {
                                allBounds.push(bounds);
                            }
                        } catch (e) {
                            console.warn('Erreur bounds zone:', e);
                        }
                    }
                });
                // Inclure le marker dans les bounds si présent
                if (marker) {
                    try {
                        const markerLatLng = marker.getLatLng();
                        const markerBounds = L.latLngBounds([markerLatLng, markerLatLng]);
                        if (markerBounds.isValid()) {
                            allBounds.push(markerBounds);
                        }
                    } catch (e) {
                        console.warn('Erreur bounds marker:', e);
                    }
                }
                zoneCenterMarkers.forEach((point) => {
                    if (point.visible === false || !map.hasLayer(point.marker)) return;
                    try {
                        const pointLatLng = point.marker.getLatLng();
                        const pointBounds = L.latLngBounds([pointLatLng, pointLatLng]);
                        if (pointBounds.isValid()) allBounds.push(pointBounds);
                    } catch (e) {
                        console.warn('Erreur bounds point de départ:', e);
                    }
                });
                if (allBounds.length > 0) {
                    try {
                        // Créer un groupe avec tous les bounds
                        const group = L.featureGroup();
                        allBounds.forEach(b => {
                            try {
                                const rect = L.rectangle(b);
                                group.addLayer(rect);
                            } catch (e) {
                                console.warn('Erreur création rectangle:', e);
                            }
                        });
                        const bounds = group.getBounds();
                        if (bounds.isValid()) {
                            // Padding plus important pour captures d'écran propres
                            const padding = [80, 80]; // Top/Bottom, Left/Right (augmenté pour plus d'espace)
                            // Zoom max pour éviter de zoomer trop
                            map.fitBounds(bounds, {
                                padding: padding,
                                maxZoom: 15,
                                animate: animate
                            });
                        }
                    } catch (e) {
                        console.warn('Erreur fitBounds:', e);
                    }
                }
            };

            const fitBoundsToZone = (zoneId) => {
                const zoneData = zonesLayers.get(zoneId);
                if (zoneData && zoneData.layer) {
                    try {
                        const bounds = zoneData.layer.getBounds();
                        if (bounds.isValid()) {
                            map.fitBounds(bounds, { padding: [60, 60], maxZoom: 15, animate: false });
                        }
                    } catch (e) {
                        console.warn('Erreur fitBoundsToZone:', e);
                    }
                }
            };

            const updateMapLegendMultiZones = () => {
                if (legendControl) {
                    map.removeControl(legendControl);
                    legendControl = null;
                }
                if (APP_CONFIG.appShellV2) return;
                const visibleZones = Array.from(zonesLayers.entries()).filter(
                    ([, zoneData]) => zoneData.visible !== false,
                );
                if (visibleZones.length === 0) return;

                const legend = L.control({ position: 'bottomright' });
                legend.onAdd = () => {
                    const div = L.DomUtil.create('div', 'map-legend');
                    div.style.cssText = 'background: var(--bg-surface, #18181b); color: var(--text, #fafafa); padding: 12px; border-radius: 8px; box-shadow: 0 4px 12px rgba(0,0,0,0.15); font-size: 12px; line-height: 1.8; max-width: 220px; border: 1px solid var(--border, #27272a);';
                    const header = document.createElement('div');
                    header.style.cssText = 'display:flex;justify-content:space-between;align-items:center;margin-bottom:10px;';
                    const title = document.createElement('strong');
                    title.style.cssText = 'color:var(--text,#fafafa);font-size:13px;font-weight:600;';
                    title.textContent = 'Zones de chalandise';
                    const customize = document.createElement('button');
                    customize.type = 'button';
                    customize.style.cssText = 'background:none;border:none;color:#2563eb;cursor:pointer;font-size:11px;padding:2px 6px;border-radius:4px;';
                    customize.title = 'Préparer un export visuel';
                    customize.setAttribute('aria-label', 'Préparer un export visuel');
                    customize.textContent = '🎨';
                    customize.addEventListener('click', (event) => {
                        event.stopPropagation();
                        window.openLegendCustomizationPanel?.(mapId, customize);
                    });
                    header.append(title, customize);
                    div.appendChild(header);
                    const geometryContract = getIsochroneGeometryModeContract();
                    const geometry = document.createElement('div');
                    geometry.dataset.isochroneGeometryLabel = '';
                    geometry.style.cssText = 'margin:-4px 0 8px;color:var(--muted,#71717a);';
                    geometry.textContent = `Contour : ${geometryContract.mode_label}`;
                    div.appendChild(geometry);
                    visibleZones.forEach(([, zoneData]) => {
                        const row = document.createElement('div');
                        row.style.cssText = 'margin-bottom:6px;display:flex;align-items:center;';
                        const swatch = document.createElement('span');
                        swatch.style.cssText = `display:inline-block;width:24px;height:3px;background:${zoneData.color};border:1px solid ${zoneData.color};margin-right:8px;border-radius:2px;`;
                        const label = document.createElement('span');
                        label.style.cssText = 'color:var(--text-secondary,#a1a1aa);flex:1;';
                        label.textContent = zoneData.name;
                        row.append(swatch, label);
                        div.appendChild(row);
                    });
                    return div;
                };
                legend.addTo(map);
                legendControl = legend;
            };

            const updateMapLegend = (geojson) => {
                if (legendControl) {
                    map.removeControl(legendControl);
                    legendControl = null;
                }
                if (APP_CONFIG.appShellV2) return;
                const hasIsochrone = geojson.features.some(f => f.properties?.layer === 'isochrone');
                const hasCommunes = geojson.features.some(f => f.properties?.layer === 'communes');
                if (!hasIsochrone && !hasCommunes) {
                    return;
                }
                const legend = L.control({ position: 'bottomright' });
                legend.onAdd = () => {
                    const div = L.DomUtil.create('div', 'map-legend');
                    div.style.cssText = 'background: var(--bg-surface, #18181b); color: var(--text, #fafafa); padding: 10px; border-radius: 5px; box-shadow: 0 2px 8px rgba(0,0,0,0.15); font-size: 12px; line-height: 1.6; border: 1px solid var(--border, #27272a);';
                    let html = '<strong style="display: block; margin-bottom: 8px; color: var(--text, #fafafa);">Légende</strong>';
                    if (hasIsochrone) {
                        const geometryContract = getIsochroneGeometryModeContract();
                        html += '<div style="margin-bottom: 6px;"><span style="display: inline-block; width: 20px; height: 2px; background: #2563eb; border: 1px dashed #2563eb; margin-right: 8px; vertical-align: middle;"></span> Isochrone (zone de temps)</div>';
                        html += `<div data-isochrone-geometry-label style="margin-bottom: 6px; color: var(--muted, #71717a);">Contour : ${geometryContract.mode_label}</div>`;
                    }
                    if (hasCommunes) {
                        html += '<div><span style="display: inline-block; width: 20px; height: 12px; background: #c4b5fd; border: 1px solid #7c3aed; margin-right: 8px; vertical-align: middle;"></span> Communes (zone de chalandise)</div>';
                    }
                    div.innerHTML = html;
                    return div;
                };
                legend.addTo(map);
                legendControl = legend;
            };

            if (searchBtn && searchBtn.dataset.addressOriginController !== 'shared') {
                searchBtn.addEventListener('click', async () => {
                    const query = queryInput.value.trim();
                    if (!query) {
                        alert('Veuillez saisir une adresse avant de rechercher.');
                        return;
                    }
                    searchBtn.disabled = true;
                    searchBtn.textContent = 'Recherche...';
                    const requestGeneration = interactionRequestGeneration;
                    searchGeocodeAbort?.abort?.();
                    const controller = new AbortController();
                    searchGeocodeAbort = controller;
                    try {
                        const response = await fetch(`/api/geocode?q=${encodeURIComponent(query)}`, {
                            signal: controller.signal,
                        });
                        if (requestGeneration !== interactionRequestGeneration) return;
                        if (!response.ok) {
                            alert('Adresse introuvable sur la carte.');
                        } else {
                            const { lat, lon } = await response.json();
                            if (requestGeneration !== interactionRequestGeneration) return;
                            map.setView([lat, lon], 12);
                            setMarker(lat, lon);
                        }
                    } catch (error) {
                        if (error?.name === 'AbortError') return;
                        alert("Impossible de rechercher l'adresse. Réessayez plus tard.");
                    } finally {
                        if (searchGeocodeAbort === controller) searchGeocodeAbort = null;
                        if (requestGeneration !== interactionRequestGeneration) return;
                        searchBtn.disabled = false;
                        searchBtn.textContent = 'Chercher l\'adresse sur la carte';
                    }
                });
            }

            const fullscreenWorkspaceController = (
                window.MaplyticsHomeFullscreenWorkspace.create({
                    map,
                    mapId,
                    documentRef: document,
                    windowRef: window,
                    resolveSettings: (section) => {
                        if (section === 'demographic') {
                            const heading = document.getElementById(
                                `choroplethSettingsTitle_${mapId}`,
                            );
                            return {
                                node: heading?.closest?.('.home-demographic-map-settings'),
                                target: heading,
                            };
                        }
                        const panel = document.getElementById(`visualizationPanel_${mapId}`);
                        const target = section === 'zones'
                            ? document.getElementById(`isochroneGeometryMode_${mapId}`)
                            : document.getElementById(`basemapSelect_${mapId}`);
                        const previousDisplay = panel?.style?.display;
                        showVisualizationPanel();
                        return {node: panel, target, previousDisplay};
                    },
                })
            );
            const removeFullscreenSidebar = () => fullscreenWorkspaceController.remove();
            const ensureFullscreenSidebar = (mapContainer) => (
                fullscreenWorkspaceController.ensure(mapContainer)
            );
            const openFullscreenSettings = (section = 'map', trigger = null) => (
                fullscreenWorkspaceController.openSettings(section, trigger)
            );

            // Contrôles personnalisés pour captures d'écran
            const createMapControls = () => {
                // mapId est accessible depuis la portée de createMapController
                const mapControls = L.control({ position: 'topright' });
                mapControls.onAdd = () => {
                    const div = L.DomUtil.create('div', 'map-custom-controls');
                    div.style.cssText = 'background: var(--bg-surface, rgba(255, 255, 255, 0.95)); backdrop-filter: blur(10px); border-radius: 10px; box-shadow: 0 4px 12px rgba(0,0,0,0.15); padding: 6px; display: flex; flex-direction: column; gap: 6px; z-index: 1000;';

                    // Bouton fit bounds
                    const fitBoundsBtn = L.DomUtil.create('button', 'map-control-btn');
                    fitBoundsBtn.type = 'button';
                    fitBoundsBtn.innerHTML = '🎯';
                    fitBoundsBtn.title = 'Ajuster la vue aux zones';
                    fitBoundsBtn.style.cssText = 'width: 44px; height: 44px; border: none; background: linear-gradient(135deg, #10b981 0%, #059669 100%); color: white; border-radius: 8px; cursor: pointer; font-size: 20px; transition: all 0.2s; display: flex; align-items: center; justify-content: center; box-shadow: 0 2px 4px rgba(0,0,0,0.1);';
                    fitBoundsBtn.onmouseover = () => {
                        fitBoundsBtn.style.transform = 'scale(1.1)';
                        fitBoundsBtn.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
                    };
                    fitBoundsBtn.onmouseout = () => {
                        fitBoundsBtn.style.transform = 'scale(1)';
                        fitBoundsBtn.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
                    };
                    L.DomEvent.on(fitBoundsBtn, 'click', (e) => {
                        L.DomEvent.stopPropagation(e);
                        e.preventDefault();
                        updateMapBounds(true);
                    });

                    // Bouton plein écran
                    const fullscreenBtn = L.DomUtil.create('button', 'map-control-btn');
                    fullscreenBtn.type = 'button';
                    fullscreenBtn.innerHTML = '⛶';
                    fullscreenBtn.title = 'Plein écran (pour captures d\'écran)';
                    fullscreenBtn.style.cssText = 'width: 44px; height: 44px; border: none; background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%); color: white; border-radius: 8px; cursor: pointer; font-size: 20px; transition: all 0.2s; display: flex; align-items: center; justify-content: center; box-shadow: 0 2px 4px rgba(0,0,0,0.1);';
                    fullscreenBtn.onmouseover = () => {
                        fullscreenBtn.style.transform = 'scale(1.1)';
                        fullscreenBtn.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
                    };
                    fullscreenBtn.onmouseout = () => {
                        fullscreenBtn.style.transform = 'scale(1)';
                        fullscreenBtn.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
                    };

                    // Gestion du plein écran
                    const mapElement = document.getElementById(mapId);
                    const mapContainer = mapElement ? mapElement.closest('.map-box') : null;
                    let isFullscreen = false;

                    const toggleFullscreen = () => {
                        if (!mapContainer) {
                            alert('Impossible d\'activer le plein écran : conteneur introuvable');
                            return;
                        }

                        if (!isFullscreen) {
                            // Entrer en plein écran
                            if (mapContainer.requestFullscreen) {
                                mapContainer.requestFullscreen();
                            } else if (mapContainer.webkitRequestFullscreen) {
                                mapContainer.webkitRequestFullscreen();
                            } else if (mapContainer.mozRequestFullScreen) {
                                mapContainer.mozRequestFullScreen();
                            } else if (mapContainer.msRequestFullscreen) {
                                mapContainer.msRequestFullscreen();
                            } else {
                                alert('Votre navigateur ne supporte pas le mode plein écran');
                                return;
                            }
                            fullscreenBtn.innerHTML = '⛶';
                            fullscreenBtn.title = 'Quitter le plein écran (ESC)';
                            isFullscreen = true;

                            // Ajuster la taille de la carte après un court délai
                            setTimeout(() => {
                                map.invalidateSize();
                                updateMapBounds(true);
                                // Afficher le panneau de contrôles visuels
                                showVisualizationPanel();
                                ensureFullscreenSidebar(mapContainer);
                            }, 200);
                        } else {
                            // Quitter le plein écran
                            if (document.exitFullscreen) {
                                document.exitFullscreen();
                            } else if (document.webkitExitFullscreen) {
                                document.webkitExitFullscreen();
                            } else if (document.mozCancelFullScreen) {
                                document.mozCancelFullScreen();
                            } else if (document.msExitFullscreen) {
                                document.msExitFullscreen();
                            }
                            fullscreenBtn.innerHTML = '⛶';
                            fullscreenBtn.title = 'Plein écran (pour captures d\'écran)';
                            isFullscreen = false;

                            // Ajuster la taille de la carte
                            setTimeout(() => {
                                map.invalidateSize();
                                hideVisualizationPanel();
                                removeFullscreenSidebar();
                            }, 200);
                        }
                    };

                    // Écouter les changements de plein écran
                    const fullscreenChangeHandler = () => {
                        const isCurrentlyFullscreen = !!(document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement);
                        if (!isCurrentlyFullscreen && isFullscreen) {
                            isFullscreen = false;
                            fullscreenBtn.innerHTML = '⛶';
                            fullscreenBtn.title = 'Plein écran (pour captures d\'écran)';
                            setTimeout(() => {
                                map.invalidateSize();
                                hideVisualizationPanel();
                                removeFullscreenSidebar();
                            }, 100);
                        }
                    };

                    document.addEventListener('fullscreenchange', fullscreenChangeHandler);
                    document.addEventListener('webkitfullscreenchange', fullscreenChangeHandler);
                    document.addEventListener('mozfullscreenchange', fullscreenChangeHandler);
                    document.addEventListener('msfullscreenchange', fullscreenChangeHandler);

                    L.DomEvent.on(fullscreenBtn, 'click', (e) => {
                        L.DomEvent.stopPropagation(e);
                        e.preventDefault();
                        toggleFullscreen();
                    });

                    div.appendChild(fitBoundsBtn);
                    div.appendChild(fullscreenBtn);

                    L.DomEvent.disableClickPropagation(div);
                    return div;
                };
                mapControls.addTo(map);
            };

            // Créer les contrôles personnalisés uniquement en layout legacy.
            // En V2, ces actions vivent dans le gestionnaire de zones pour éviter les chevauchements.
            if (!APP_CONFIG.appShellV2) {
                createMapControls();
            }

            const visualizationIconMarkup = `
                <svg data-visualization-icon viewBox="0 0 24 24" width="20" height="20"
                     fill="none" stroke="currentColor" stroke-width="2"
                     stroke-linecap="round" stroke-linejoin="round"
                     aria-hidden="true" focusable="false">
                    <path d="M4 7h10M18 7h2M4 17h2M10 17h10"></path>
                    <circle cx="16" cy="7" r="2"></circle>
                    <circle cx="8" cy="17" r="2"></circle>
                </svg>`;

            // Panneau de contrôles visuels partagé entre le flux normal et le plein écran.
            const createVisualizationPanel = () => {
                const panel = L.control({ position: 'topleft' });
                panel.onAdd = () => {
                    const div = L.DomUtil.create('div', 'visualization-panel');
                    div.id = `visualizationPanel_${mapId}`;
                    div.setAttribute('role', 'region');
                    div.setAttribute('aria-labelledby', `visualizationTitle_${mapId}`);
                    div.tabIndex = 0;
                    div.style.cssText = 'display: none; box-sizing: border-box; background: var(--bg-surface, #18181b); color: var(--text, #fafafa); backdrop-filter: blur(10px); border-radius: 12px; box-shadow: 0 8px 24px rgba(0,0,0,0.2); padding: 1rem; min-width: 280px; max-width: min(320px, calc(100vw - 32px)); max-height: calc(100vh - 48px); overflow-y: auto; overscroll-behavior: contain; touch-action: pan-y; -webkit-overflow-scrolling: touch; z-index: 2000; border: 1px solid var(--border, #27272a);';

                    div.innerHTML = `
                        <div>
                            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 0.75rem;">
                                <h3 id="visualizationTitle_${mapId}" style="margin: 0; display: flex; align-items: center; gap: 0.4rem; font-size: 1rem; color: var(--text, #fafafa); font-weight: 700;">${visualizationIconMarkup}<span>Options de visualisation</span></h3>
                                <button id="togglePanel_${mapId}" type="button" aria-controls="panelContent_${mapId}" aria-expanded="true" aria-label="Masquer le contenu du panneau" style="background: none; border: none; font-size: 1.2rem; cursor: pointer; color: var(--text-secondary, #a1a1aa); padding: 0; width: 24px; height: 24px; display: flex; align-items: center; justify-content: center;" title="Masquer le panneau">−</button>
                            </div>

                            <div id="panelContent_${mapId}">
                                <div class="map-layer-control-field">
                                    <label for="basemapSelect_${mapId}" class="map-layer-control-label">Fond de carte</label>
                                    <select id="basemapSelect_${mapId}" class="map-layer-control-select"></select>
                                    <p id="basemapStatus_${mapId}" class="map-layer-control-status" role="status" aria-live="polite" data-state="initial"></p>
                                </div>

                                <div class="map-layer-control-field">
                                    <label for="administrativeBoundarySelect_${mapId}" class="map-layer-control-label">Limites administratives</label>
                                    <select id="administrativeBoundarySelect_${mapId}" class="map-layer-control-select">
                                        <option value="none">Aucun</option>
                                        <option value="department">Départements</option>
                                        <option value="region">Régions</option>
                                    </select>
                                    <fieldset id="administrativeBoundaryStyle_${mapId}" class="map-layer-style-fieldset" disabled>
                                        <legend class="map-layer-style-legend">Style des limites</legend>
                                        <div class="map-layer-style-grid">
                                            <label for="administrativeBoundaryPreset_${mapId}" class="map-layer-style-control">
                                                <span>Contraste</span>
                                                <select id="administrativeBoundaryPreset_${mapId}" class="map-layer-control-select">
                                                    <option value="light">Fond clair</option>
                                                    <option value="aerial">Vue aérienne</option>
                                                    <option value="custom">Personnalisé</option>
                                                </select>
                                            </label>
                                            <label for="administrativeBoundaryColor_${mapId}" class="map-layer-style-control map-layer-style-color-control">
                                                <span>Couleur</span>
                                                <input id="administrativeBoundaryColor_${mapId}" class="map-layer-style-color" type="color" value="#475569" aria-label="Couleur des limites administratives">
                                            </label>
                                        </div>
                                        <div class="map-layer-style-opacity-row">
                                            <label for="administrativeBoundaryOpacity_${mapId}">Opacité du contour</label>
                                            <output id="administrativeBoundaryOpacityValue_${mapId}" for="administrativeBoundaryOpacity_${mapId}">90 %</output>
                                        </div>
                                        <input id="administrativeBoundaryOpacity_${mapId}" class="map-layer-style-opacity" type="range" min="0.25" max="1" step="0.05" value="0.9" aria-label="Opacité du contour administratif">
                                    </fieldset>
                                    <p id="administrativeBoundaryStatus_${mapId}" class="map-layer-control-status" role="status" aria-live="polite" data-state="initial">Limites administratives masquées.</p>
                                </div>

                                <div style="margin-bottom: 1rem;">
                                    <label for="isochroneGeometryMode_${mapId}" style="display: block; font-size: 0.85rem; color: var(--text-secondary, #a1a1aa); margin-bottom: 0.5rem; font-weight: 600;">Contour isochrone</label>
                                    <select id="isochroneGeometryMode_${mapId}" style="width: 100%; padding: 0.5rem; border: 1px solid var(--border, #27272a); border-radius: 6px; font-size: 0.9rem; background: var(--bg-elevated, #27272a); color: var(--text, #fafafa);">
                                        <option value="presentation">Contour lissé — présentation adoucie (par défaut)</option>
                                        ${mapId === 'exportMap' ? '<option value="territorial">Présentation territoriale (communes)</option>' : ''}
                                        <option value="provider">Précision fournisseur</option>
                                    </select>
                                    <p id="isochroneGeometryStatus_${mapId}" role="status" aria-live="polite" style="margin: 0.25rem 0 0 0; font-size: 0.75rem; color: var(--muted, #71717a);">Aucun contour isochrone calculé. Lancez un calcul pour afficher un contour.</p>
                                </div>

                                <section class="home-choropleth-panel-summary" aria-label="Carte démographique">
                                    <strong>Carte démographique</strong>
                                    <p id="choroplethPanelStatus_${mapId}">Inactive.</p>
                                    <button id="choroplethOpenSettings_${mapId}" type="button" class="ui-btn ui-btn-secondary">Réglages</button>
                                </section>

                                <div style="margin-bottom: 0.75rem;">
                                    <label style="display: flex; align-items: center; gap: 0.5rem; cursor: pointer; font-size: 0.9rem; color: var(--text, #fafafa);">
                                        <input type="checkbox" id="showCommuneBorders_${mapId}" style="width: 18px; height: 18px; cursor: pointer;">
                                        <span>Afficher les contours des communes</span>
                                    </label>
                                    <p style="margin: 0.25rem 0 0 0; font-size: 0.75rem; color: var(--muted, #71717a);">Affiche les périmètres de toutes les communes de la zone de chalandise en surcouche</p>
                                </div>

                                <div style="padding-top: 0.75rem; border-top: 1px solid var(--border, #27272a); font-size: 0.8rem; color: var(--muted, #71717a); line-height: 1.5;">
                                    <p id="visualizationStatus_${mapId}" data-state="initial" role="status" aria-live="polite" style="margin: 0 0 0.5rem;">Aucune option de visualisation appliquée.</p>
                                    <div style="display: flex; gap: 0.5rem; flex-wrap: wrap;">
                                        <button id="visualizationRetry_${mapId}" type="button" hidden>Réessayer</button>
                                        <button id="visualizationHide_${mapId}" type="button">Masquer les options</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    `;

                    // Event listeners
                    setTimeout(() => {
                        const modeSelect = document.getElementById(`visualizationMode_${mapId}`);
                        const basemapSelect = document.getElementById(`basemapSelect_${mapId}`);
                        const basemapStatusElement = document.getElementById(`basemapStatus_${mapId}`);
                        const administrativeBoundarySelect = document.getElementById(`administrativeBoundarySelect_${mapId}`);
                        const administrativeBoundaryStatusElement = document.getElementById(`administrativeBoundaryStatus_${mapId}`);
                        const administrativeBoundaryStyleFieldset = document.getElementById(`administrativeBoundaryStyle_${mapId}`);
                        const administrativeBoundaryPreset = document.getElementById(`administrativeBoundaryPreset_${mapId}`);
                        const administrativeBoundaryColor = document.getElementById(`administrativeBoundaryColor_${mapId}`);
                        const administrativeBoundaryOpacity = document.getElementById(`administrativeBoundaryOpacity_${mapId}`);
                        const administrativeBoundaryOpacityValue = document.getElementById(`administrativeBoundaryOpacityValue_${mapId}`);
                        const geometryModeSelect = document.getElementById(`isochroneGeometryMode_${mapId}`);
                        const centroidsCheckbox = document.getElementById(`showCentroids_${mapId}`);
                        const choroplethScopeSelect = document.getElementById(`choroplethScope_${mapId}`);
                        const choroplethGeographicLevelSelect = document.getElementById(`choroplethGeographicLevel_${mapId}`);
                        const choroplethDataSelect = document.getElementById(`choroplethData_${mapId}`);
                        const choroplethMeasureSelect = document.getElementById(`choroplethMeasure_${mapId}`);
                        const choroplethRenderModeSelect = document.getElementById(`choroplethRenderMode_${mapId}`);
                        const choroplethBoundariesSelect = document.getElementById(`choroplethBoundaries_${mapId}`);
                        const choroplethPaletteSelect = document.getElementById(`choroplethPalette_${mapId}`);
                        const choroplethLegendModeSelect = document.getElementById(`choroplethLegendMode_${mapId}`);
                        const choroplethOpacityInput = document.getElementById(`choroplethOpacity_${mapId}`);
                        const choroplethOpacityOutput = document.getElementById(`choroplethOpacityValue_${mapId}`);
                        const choroplethNoDataColor = document.getElementById(`choroplethNoDataColor_${mapId}`);
                        const choroplethZoneOverlayVisible = document.getElementById(`choroplethZoneOverlayVisible_${mapId}`);
                        const choroplethZoneOverlayOpacity = document.getElementById(`choroplethZoneOverlayOpacity_${mapId}`);
                        const choroplethZoneOverlayOpacityValue = document.getElementById(`choroplethZoneOverlayOpacityValue_${mapId}`);
                        const choroplethZoneOverlayOrder = document.getElementById(`choroplethZoneOverlayOrder_${mapId}`);
                        const choroplethOptions = document.getElementById(`choroplethOptions_${mapId}`);
                        const choroplethToggle = document.getElementById(`choroplethToggle_${mapId}`);
                        const choroplethOpenSettings = document.getElementById(`choroplethOpenSettings_${mapId}`);
                        const toggleBtn = document.getElementById(`togglePanel_${mapId}`);
                        const panelContent = document.getElementById(`panelContent_${mapId}`);
                        const retryBtn = document.getElementById(`visualizationRetry_${mapId}`);
                        const hideBtn = document.getElementById(`visualizationHide_${mapId}`);
                        syncChoroplethMetricAvailability = (zoneSeries = null) => {
                            const useZoneMetrics = currentChoroplethScope === 'zones';
                            const metricIds = Object.keys(
                                window.MaplyticsHomeChoropleth?.METRICS || {},
                            );
                            const metricAvailable = (metricId) => (
                                !useZoneMetrics
                                || (zoneSeries?.series || []).some(
                                    (zone) => zone.visible !== false
                                        && zone.geometryStatus === 'available'
                                        && zone.geometry
                                        && zone.metrics?.[metricId]?.status === 'available',
                                )
                            );
                            if (!metricAvailable(currentChoroplethField)) {
                                currentChoroplethField = metricIds.find(metricAvailable)
                                    || 'population';
                            }
                            if (!choroplethDataSelect) return currentChoroplethField;
                            [...choroplethDataSelect.options].forEach((option) => {
                                const metricStates = zoneSeries?.series?.map(
                                    (zone) => zone.metrics?.[option.value],
                                ) || [];
                                const available = metricAvailable(option.value);
                                option.disabled = !available;
                                option.title = available
                                    ? ''
                                    : (
                                        metricStates.find((metric) => metric?.reason)?.reason
                                        || 'Cette métrique est indisponible pour les zones générées.'
                                    );
                            });
                            choroplethDataSelect.value = currentChoroplethField;
                            const definition = window.MaplyticsHomeChoropleth?.METRICS?.[currentChoroplethField];
                            if (definition && !definition.allowedMeasures.includes(currentChoroplethMeasure)) {
                                currentChoroplethMeasure = definition.defaultMeasure;
                            }
                            if (choroplethMeasureSelect && definition) {
                                [...choroplethMeasureSelect.options].forEach((option) => {
                                    option.disabled = !definition.allowedMeasures.includes(option.value);
                                });
                                choroplethMeasureSelect.value = currentChoroplethMeasure;
                            }
                            return currentChoroplethField;
                        };

                        if (basemapSwitcher && basemapSelect) {
                            window.MaplyticsMapLayers.bindSelect(basemapSwitcher, basemapSelect, basemapStatusElement);
                            basemapStatusElement.dataset.state = basemapStatus.state;
                            basemapStatusElement.textContent = basemapStatus.message;
                        }

                        if (administrativeBoundaryController && administrativeBoundarySelect) {
                            window.MaplyticsAdministrativeBoundaries.bindSelect(
                                administrativeBoundaryController,
                                administrativeBoundarySelect,
                            );
                            window.MaplyticsAdministrativeBoundaries.bindStyleControls(
                                administrativeBoundaryController,
                                {
                                    fieldset: administrativeBoundaryStyleFieldset,
                                    presetSelect: administrativeBoundaryPreset,
                                    colorInput: administrativeBoundaryColor,
                                    opacityInput: administrativeBoundaryOpacity,
                                    opacityOutput: administrativeBoundaryOpacityValue,
                                },
                            );
                            if (administrativeBoundaryStatusElement) {
                                administrativeBoundaryStatusElement.dataset.state = administrativeBoundaryStatus.state;
                                administrativeBoundaryStatusElement.textContent = administrativeBoundaryStatus.message;
                            }
                        }

                        // Toggle masquer/afficher le panneau
                        if (toggleBtn && panelContent) {
                            let isCollapsed = false;
                            toggleBtn.addEventListener('click', () => {
                                isCollapsed = !isCollapsed;
                                panelContent.style.display = isCollapsed ? 'none' : 'block';
                                toggleBtn.textContent = isCollapsed ? '+' : '−';
                                toggleBtn.title = isCollapsed ? 'Afficher le panneau' : 'Masquer le panneau';
                                toggleBtn.setAttribute('aria-expanded', String(!isCollapsed));
                                toggleBtn.setAttribute(
                                    'aria-label',
                                    isCollapsed
                                        ? 'Afficher le contenu du panneau'
                                        : 'Masquer le contenu du panneau',
                                );
                            });
                        }

                        // Afficher/masquer les options de choroplèthe selon le mode
                        if (modeSelect && choroplethOptions) {
                            modeSelect.value = visualizationMode;
                            choroplethOptions.hidden = false;

                            modeSelect.addEventListener('change', async (e) => {
                                visualizationMode = e.target.value;
                                setVisualizationStatus('loading', 'Application du mode de visualisation…');
                                if (visualizationMode === 'choropleth') {
                                    const scopeState = syncChoroplethScopeAvailability({
                                        preferZones: true,
                                    });
                                    syncChoroplethMetricAvailability(scopeState.zoneSeries);
                                    if (scopeState.changed) {
                                        await Promise.resolve(applyCurrentChoroplethScope());
                                    }
                                }
                                await updateVisualizationStyles();
                                invalidateVisualExport('visualization-mode');
                            });
                        }

                        if (geometryModeSelect) {
                            geometryModeSelect.value = isochroneGeometryMode;
                            geometryModeSelect.addEventListener('change', (event) => {
                                setIsochroneGeometryMode(event.target.value);
                            });
                            syncIsochroneModeContract();
                        }

                        const initialScopeState = syncChoroplethScopeAvailability({
                            preferZones: true,
                        });
                        syncChoroplethMetricAvailability(initialScopeState.zoneSeries);
                        const initialChoroplethSnapshot = choroplethController?.getSnapshot?.();
                        if (initialChoroplethSnapshot) {
                            syncChoroplethControlStatus(
                                initialChoroplethSnapshot.status,
                                initialChoroplethSnapshot.statusMessage,
                                initialChoroplethSnapshot,
                            );
                        }

                        if (choroplethScopeSelect) {
                            choroplethScopeSelect.addEventListener('change', async (event) => {
                                choroplethScopePreference = event.target.value === 'zones'
                                    ? 'zones'
                                    : event.target.value === 'viewport'
                                        ? 'viewport'
                                        : 'communes';
                                currentChoroplethScope = choroplethScopePreference;
                                const scopeState = syncChoroplethScopeAvailability();
                                syncChoroplethMetricAvailability(scopeState.zoneSeries);
                                syncZoneBaseLayersForChoropleth({
                                    ...choroplethController?.getSnapshot?.(),
                                    scope: currentChoroplethScope,
                                    featureCount: 0,
                                });
                                await Promise.resolve(
                                    applyCurrentChoroplethScope(),
                                );
                                if (visualizationMode === 'choropleth') {
                                    await updateChoroplethVisualization(
                                        choroplethDataSelect?.value || currentChoroplethField,
                                    );
                                }
                            });
                        }

                        choroplethGeographicLevelSelect?.addEventListener('change', async (event) => {
                            await Promise.resolve(
                                choroplethController?.setGeographicLevel?.(event.target.value),
                            );
                        });

                        choroplethRenderModeSelect?.addEventListener('change', (event) => {
                            const nextMode = event.target.value === 'continuous'
                                ? 'continuous'
                                : 'classes';
                            choroplethController?.setRenderMode?.(nextMode);
                            const presetBoundaries = nextMode === 'continuous' ? 'hidden' : 'visible';
                            choroplethController?.setBoundaries?.(presetBoundaries);
                            if (choroplethBoundariesSelect) {
                                choroplethBoundariesSelect.value = presetBoundaries;
                            }
                            invalidateVisualExport('choropleth-render-mode');
                        });

                        choroplethBoundariesSelect?.addEventListener('change', (event) => {
                            choroplethController?.setBoundaries?.(event.target.value);
                            invalidateVisualExport('choropleth-boundaries');
                        });

                        choroplethToggle?.addEventListener('click', async () => {
                            const isActive = choroplethController?.getSnapshot?.().active === true;
                            visualizationMode = isActive ? 'normal' : 'choropleth';
                            if (modeSelect) modeSelect.value = visualizationMode;
                            await updateVisualizationStyles();
                            invalidateVisualExport('choropleth-toggle');
                        });

                        choroplethOpenSettings?.addEventListener('click', () => {
                            hideVisualizationPanel();
                            const tabId = mapId === 'importMap' ? 'importZonesMapsTab' : 'zonesMapsTab';
                            document.getElementById(tabId)?.click();
                            document.getElementById(`choroplethSettingsTitle_${mapId}`)?.focus?.();
                        });

                        if (choroplethDataSelect) {
                            choroplethDataSelect.addEventListener('change', async (e) => {
                                currentChoroplethField = e.target.value;
                                syncChoroplethMetricAvailability(currentMapZoneMetricSeries());
                                await updateChoroplethVisualization(e.target.value);
                            });
                        }

                        choroplethMeasureSelect?.addEventListener('change', async (event) => {
                            currentChoroplethMeasure = event.target.value;
                            await Promise.resolve(
                                choroplethController?.setMeasure?.(currentChoroplethMeasure),
                            );
                            invalidateVisualExport('choropleth-measure');
                        });

                        if (choroplethPaletteSelect) {
                            choroplethPaletteSelect.addEventListener('change', (event) => {
                                choroplethController?.setPalette?.(event.target.value);
                            });
                        }

                        choroplethLegendModeSelect?.addEventListener('change', (event) => {
                            choroplethController?.setLegendMode?.(event.target.value);
                            invalidateVisualExport('choropleth-legend-mode');
                        });

                        if (choroplethOpacityInput) {
                            const syncChoroplethOpacity = () => {
                                const value = Number(choroplethOpacityInput.value);
                                choroplethController?.setOpacity?.(value);
                                if (choroplethOpacityOutput) {
                                    choroplethOpacityOutput.value = `${Math.round(value * 100)} %`;
                                    choroplethOpacityOutput.textContent = `${Math.round(value * 100)} %`;
                                }
                            };
                            choroplethOpacityInput.addEventListener('input', syncChoroplethOpacity);
                        }

                        choroplethNoDataColor?.addEventListener('input', (event) => {
                            choroplethController?.setNoDataColor?.(event.target.value);
                            invalidateVisualExport('choropleth-no-data-color');
                        });

                        choroplethZoneOverlayVisible?.addEventListener('change', (event) => {
                            choroplethController?.setZoneOverlayVisible?.(event.target.checked);
                            invalidateVisualExport('choropleth-zone-overlay');
                        });
                        if (choroplethZoneOverlayOpacity) {
                            const syncZoneOverlayOpacity = () => {
                                const value = Number(choroplethZoneOverlayOpacity.value);
                                choroplethController?.setZoneOverlayOpacity?.(value);
                                if (choroplethZoneOverlayOpacityValue) {
                                    const text = `${Math.round(value * 100)} %`;
                                    choroplethZoneOverlayOpacityValue.value = text;
                                    choroplethZoneOverlayOpacityValue.textContent = text;
                                }
                                invalidateVisualExport('choropleth-zone-overlay-opacity');
                            };
                            choroplethZoneOverlayOpacity.addEventListener('input', syncZoneOverlayOpacity);
                        }
                        choroplethZoneOverlayOrder?.addEventListener('change', (event) => {
                            choroplethController?.setZoneOverlayOrder?.(event.target.value);
                            invalidateVisualExport('choropleth-zone-overlay-order');
                        });

                        retryBtn?.addEventListener('click', () => visualizationRetry?.());
                        hideBtn?.addEventListener('click', async () => {
                            visualizationMode = 'normal';
                            if (modeSelect) modeSelect.value = 'normal';
                            showCommuneCentroids = false;
                            const borders = document.getElementById(`showCommuneBorders_${mapId}`);
                            if (borders) borders.checked = false;
                            await toggleCommuneBorders(false);
                            await updateVisualizationStyles();
                            invalidateVisualExport('visualization-reset');
                            setVisualizationStatus('success', 'Options masquées; vue normale restaurée.');
                        });

                        const communeBordersCheckbox = document.getElementById(`showCommuneBorders_${mapId}`);
                        if (communeBordersCheckbox) {
                            communeBordersCheckbox.checked = showCommuneCentroids;
                            communeBordersCheckbox.addEventListener('change', async (e) => {
                                showCommuneCentroids = e.target.checked;
                                await toggleCommuneBorders(showCommuneCentroids);
                                invalidateVisualExport('commune-borders');
                            });
                        }
                    }, 100);

                    div.addEventListener('keydown', (event) => {
                        if (event.target !== div || event.altKey || event.ctrlKey || event.metaKey) {
                            return;
                        }
                        const pageStep = Math.max(44, Math.floor(div.clientHeight * 0.85));
                        const scrollTargets = {
                            ArrowDown: div.scrollTop + 44,
                            ArrowUp: div.scrollTop - 44,
                            PageDown: div.scrollTop + pageStep,
                            PageUp: div.scrollTop - pageStep,
                            Home: 0,
                            End: div.scrollHeight,
                            ' ': div.scrollTop + (event.shiftKey ? -pageStep : pageStep),
                        };
                        if (!Object.prototype.hasOwnProperty.call(scrollTargets, event.key)) return;
                        event.preventDefault();
                        event.stopPropagation();
                        div.scrollTo({ top: scrollTargets[event.key], behavior: 'auto' });
                    });
                    div.addEventListener('touchmove', (event) => {
                        event.stopPropagation();
                    }, { passive: true });
                    L.DomEvent.disableClickPropagation(div);
                    L.DomEvent.disableScrollPropagation(div);
                    return div;
                };
                return panel;
            };

            const visualizationPanel = createVisualizationPanel();

            const visualizationPanelType = mapId === 'importMap' ? 'import' : 'export';
            let visualizationLauncherButton = null;
            const fitVisualizationPanel = (panel) => {
                const mapElement = document.getElementById(mapId);
                if (!panel || !mapElement || getComputedStyle(panel).display === 'none') return;
                const panelTop = panel.getBoundingClientRect().top;
                const mapBottom = Math.min(
                    mapElement.getBoundingClientRect().bottom,
                    window.innerHeight,
                );
                const badge = mapElement.closest('.map-box')?.querySelector('.map-kpi-badge');
                const badgeRect = badge?.getBoundingClientRect?.();
                const reservedBottom = badgeRect?.height > 0
                    ? Math.max(10, Math.floor(mapBottom - badgeRect.top + 10))
                    : 10;
                const availableHeight = Math.max(
                    1,
                    Math.floor(mapBottom - panelTop - reservedBottom),
                );
                panel.style.maxHeight = `${availableHeight}px`;
            };
            const syncVisualizationLauncher = (expanded) => {
                if (typeof window.syncMapShellVisualizationLauncher === 'function') {
                    window.syncMapShellVisualizationLauncher(
                        visualizationPanelType,
                        expanded,
                    );
                }
                if (!visualizationLauncherButton) return;
                const label = expanded
                    ? 'Masquer les options de visualisation'
                    : 'Ouvrir les options de visualisation';
                visualizationLauncherButton.setAttribute('aria-expanded', String(expanded));
                visualizationLauncherButton.setAttribute('aria-label', label);
                visualizationLauncherButton.title = label;
            };

            // Fonctions pour afficher/masquer le panneau
            const showVisualizationPanel = () => {
                const fullscreenElement = (
                    document.fullscreenElement
                    || document.webkitFullscreenElement
                    || document.mozFullScreenElement
                    || document.msFullscreenElement
                    || null
                );
                const mapBox = document.getElementById(mapId)?.closest('.map-box') || null;
                if (APP_CONFIG.appShellV2 && fullscreenElement !== mapBox) {
                    if (typeof window.isAppShellSmallScreen === 'function'
                        && window.isAppShellSmallScreen()) {
                        window.setAppShellV2ResultsSheet?.('map');
                    } else {
                        window.setToolPanelState?.(visualizationPanelType, 'rail');
                    }
                }
                const panel = document.querySelector(`#${mapId}`).parentElement.querySelector('.visualization-panel');
                if (panel) {
                    panel.style.display = 'block';
                }
                syncVisualizationLauncher(true);
                afterMapLayout(() => {
                    if (!mapHasUsableViewport(map)) return;
                    fitVisualizationPanel(panel);
                    map.invalidateSize({ animate: false });
                    void administrativeBoundaryController?.syncPreference?.();
                });
            };

            const hideVisualizationPanel = () => {
                const panel = document.querySelector(`#${mapId}`).parentElement.querySelector('.visualization-panel');
                if (panel) {
                    if (panel.dataset.mapShellSuspendedBy) {
                        panel.dataset.mapShellPreviousDisplay = 'none';
                    } else {
                        panel.style.display = 'none';
                    }
                }
                syncVisualizationLauncher(false);
            };

            const createVisualizationLauncher = () => {
                const launcher = L.control({ position: 'topleft' });
                launcher.onAdd = () => {
                    const container = L.DomUtil.create(
                        'div',
                        'visualization-launcher leaflet-bar',
                    );
                    const button = L.DomUtil.create(
                        'button',
                        'visualization-launcher-button',
                        container,
                    );
                    visualizationLauncherButton = button;
                    button.type = 'button';
                    button.dataset.visualizationLauncher = mapId;
                    button.setAttribute('aria-controls', `visualizationPanel_${mapId}`);
                    button.innerHTML = visualizationIconMarkup;
                    syncVisualizationLauncher(false);
                    L.DomEvent.on(button, 'click', (event) => {
                        L.DomEvent.stopPropagation(event);
                        L.DomEvent.preventDefault(event);
                        const panel = document.getElementById(`visualizationPanel_${mapId}`);
                        const isOpen = panel && getComputedStyle(panel).display !== 'none';
                        if (isOpen) {
                            hideVisualizationPanel();
                        } else {
                            showVisualizationPanel();
                        }
                    });
                    L.DomEvent.disableClickPropagation(container);
                    L.DomEvent.disableScrollPropagation(container);
                    return container;
                };
                return launcher;
            };

            const visualizationLauncher = createVisualizationLauncher();
            if (APP_CONFIG.appShellV2) {
                visualizationLauncher.addTo(map);
            }
            visualizationPanel.addTo(map);

            const mapFullscreenContainer = document.getElementById(mapId)?.closest('.map-box') || null;
            let mapLayoutSyncPending = false;
            const syncMapViewportFromLayout = () => {
                if (mapLayoutSyncPending) return;
                mapLayoutSyncPending = true;
                afterMapLayout(() => {
                    mapLayoutSyncPending = false;
                    if (!mapHasUsableViewport(map)) return;
                    map.invalidateSize({ animate: false });
                    fitVisualizationPanel(document.getElementById(`visualizationPanel_${mapId}`));
                });
            };
            if (typeof ResizeObserver === 'function') {
                const mapResizeObserver = new ResizeObserver(syncMapViewportFromLayout);
                mapResizeObserver.observe(document.getElementById(mapId));
                if (mapFullscreenContainer) mapResizeObserver.observe(mapFullscreenContainer);
                map.maplyticsLayoutResizeObserver = mapResizeObserver;
            } else {
                window.addEventListener('resize', syncMapViewportFromLayout, { passive: true });
            }

            const currentFullscreenElement = () => (
                document.fullscreenElement
                || document.webkitFullscreenElement
                || document.mozFullScreenElement
                || document.msFullscreenElement
                || null
            );
            let ownsFullscreen = false;
            const syncVisualizationPanelWithFullscreen = () => {
                if (!APP_CONFIG.appShellV2) return;
                const isOwnFullscreen = currentFullscreenElement() === mapFullscreenContainer;
                if (isOwnFullscreen) {
                    if (ownsFullscreen) return;
                    ownsFullscreen = true;
                    afterMapLayout(() => {
                        if (!mapHasUsableViewport(map)) return;
                        map.invalidateSize({ animate: false });
                        updateMapBounds(true);
                        showVisualizationPanel();
                        ensureFullscreenSidebar(mapFullscreenContainer);
                    });
                    return;
                }
                if (!ownsFullscreen) return;
                ownsFullscreen = false;
                afterMapLayout(() => {
                    if (mapHasUsableViewport(map)) {
                        map.invalidateSize({ animate: false });
                    }
                    hideVisualizationPanel();
                    removeFullscreenSidebar();
                });
            };
            if (APP_CONFIG.appShellV2) {
                ['fullscreenchange', 'webkitfullscreenchange', 'mozfullscreenchange', 'MSFullscreenChange']
                    .forEach((eventName) => {
                        document.addEventListener(eventName, syncVisualizationPanelWithFullscreen);
                    });
            }

            toggleMapFullscreen = () => {
                const mapContainer = mapFullscreenContainer;
                if (!mapContainer) {
                    alert('Impossible d\'activer le plein écran : conteneur introuvable');
                    return null;
                }

                const fullscreenElement = currentFullscreenElement();
                if (!fullscreenElement) {
                    let fullscreenRequest = null;
                    if (mapContainer.requestFullscreen) {
                        fullscreenRequest = mapContainer.requestFullscreen();
                    } else if (mapContainer.webkitRequestFullscreen) {
                        fullscreenRequest = mapContainer.webkitRequestFullscreen();
                    } else if (mapContainer.mozRequestFullScreen) {
                        fullscreenRequest = mapContainer.mozRequestFullScreen();
                    } else if (mapContainer.msRequestFullscreen) {
                        fullscreenRequest = mapContainer.msRequestFullscreen();
                    } else {
                        alert('Votre navigateur ne supporte pas le mode plein écran');
                        return null;
                    }
                    Promise.resolve(fullscreenRequest).catch(() => {
                        ownsFullscreen = false;
                        window.MaplyticsNotice?.error?.(
                            'Le plein écran n’a pas pu être activé.',
                            { title: 'Carte' },
                        );
                    });
                    return true;
                }

                if (fullscreenElement !== mapContainer) return null;

                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitExitFullscreen) {
                    document.webkitExitFullscreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
                return false;
            };

            if (mapId === 'exportMap') syncIsochroneModeContract();

            const exportLayerStyle = (layer, fallback = {}) => ({
                color: layer?.options?.color || fallback.color || '#2563eb',
                fillColor: layer?.options?.fillColor || fallback.fillColor || fallback.color || '#2563eb',
                fillOpacity: layer?.options?.fillOpacity ?? fallback.fillOpacity ?? 0.18,
                opacity: layer?.options?.opacity ?? fallback.opacity ?? 0.95,
                weight: layer?.options?.weight ?? fallback.weight ?? 2,
                dashArray: layer?.options?.dashArray ?? fallback.dashArray ?? null,
                lineJoin: layer?.options?.lineJoin ?? fallback.lineJoin ?? 'miter',
                lineCap: layer?.options?.lineCap ?? fallback.lineCap ?? 'butt',
            });

            const appendExportLeafLayers = (target, layer, descriptor) => {
                if (!layer || (typeof map.hasLayer === 'function' && !map.hasLayer(layer))) return;
                if (layer.feature?.geometry && typeof layer.toGeoJSON === 'function') {
                    target.push({
                        ...descriptor,
                        geojson: layer.toGeoJSON(),
                        style: exportLayerStyle(layer, descriptor.style),
                    });
                    return;
                }
                if (typeof layer.eachLayer === 'function') {
                    layer.eachLayer((child) => appendExportLeafLayers(target, child, descriptor));
                }
            };

            const collectVisualExportLayers = (legendSnapshot) => {
                const layers = [];
                const boundaries = administrativeBoundaryController?.getExportSnapshot?.();
                if (boundaries?.geojson) {
                    layers.push({
                        id: `administrative:${boundaries.level || 'active'}`,
                        kind: 'administrative',
                        geojson: boundaries.geojson,
                        style: boundaries.style,
                    });
                }
                const territorySnapshot = window.maplyticsTerritoryContextControllers
                    ?.[mapVisualSurface]?.getVisualExportSnapshot?.();
                (territorySnapshot?.layers || []).forEach((layer) => layers.push(layer));
                if (
                    mapVisualSurface === 'import'
                    && geoLayer
                    && map.hasLayer(geoLayer)
                    && legendSnapshot.zones[0]?.id
                ) {
                    appendExportLeafLayers(layers, geoLayer, {
                        id: `zone:${legendSnapshot.zones[0].id}`,
                        kind: 'zone',
                        zoneId: legendSnapshot.zones[0].id,
                        style: {
                            color: '#2563eb',
                            fillColor: '#2563eb',
                            fillOpacity: 0.18,
                            opacity: 0.95,
                            weight: 2,
                        },
                    });
                }
                const appendVisibleZones = () => legendSnapshot.zones.forEach((zone) => {
                    const zoneData = zonesLayers.get(zone.id);
                    if (!zoneData?.layer || zoneData.visible === false || !map.hasLayer(zoneData.layer)) return;
                    appendExportLeafLayers(layers, zoneData.layer, {
                        id: `zone:${zone.id}`,
                        kind: 'zone',
                        zoneId: zone.id,
                        style: {
                            color: zoneData.color,
                            fillColor: zoneData.color,
                            fillOpacity: 0.18,
                            opacity: zoneData.opacity ?? 1,
                            weight: 2,
                        },
                    });
                });
                const choroplethSnapshot = choroplethController?.getSnapshot?.() || null;
                const zonesInFront = Boolean(
                    choroplethSnapshot?.active
                    && choroplethSnapshot?.dataScope === 'result_communes'
                    && choroplethSnapshot?.zoneOverlay?.visible
                    && choroplethSnapshot?.zoneOverlay?.order === 'front'
                );
                if (!zonesInFront) appendVisibleZones();
                choroplethController?.getExportLayers?.().forEach((layer) => {
                    layers.push(layer);
                });
                if (zonesInFront) appendVisibleZones();
                if (communeBordersLayer && map.hasLayer(communeBordersLayer)) {
                    appendExportLeafLayers(layers, communeBordersLayer, {
                        id: 'zone-overlay:commune-borders',
                        kind: 'zone-overlay',
                        style: {
                            color: '#ef4444',
                            fillColor: '#ef4444',
                            fillOpacity: 0,
                            opacity: 0.8,
                            weight: 2,
                            dashArray: '4 4',
                        },
                    });
                }
                return layers;
            };

            const captureVisualExportSnapshot = async (
                legendSnapshot,
                visualConfig = null,
                snapshotContext = {},
            ) => {
                if (!window.MaplyticsMapVisualExport?.captureMapSnapshot) {
                    throw new Error('Cette carte ne peut pas être exportée depuis ce parcours.');
                }
                const context = snapshotContext && typeof snapshotContext === 'object'
                    ? snapshotContext
                    : {};
                const boundaries = administrativeBoundaryController?.getExportSnapshot?.();
                const choroplethSnapshot = choroplethController?.getSnapshot?.() || null;
                const territorySnapshot = window.maplyticsTerritoryContextControllers
                    ?.[mapVisualSurface]?.getVisualExportSnapshot?.() || null;
                const requestPoints = typeof context.getPoints === 'function'
                    ? context.getPoints(legendSnapshot)
                    : [];
                return window.MaplyticsMapVisualExport.captureMapSnapshot({
                    map,
                    legendSnapshot,
                    contractVersion: window.MaplyticsMapVisualExport.HOME_MAP_SNAPSHOT_VERSION,
                    visualConfig,
                    sourceFingerprint: context.sourceFingerprint
                        || (choroplethSnapshot?.active
                            ? choroplethSnapshot.sourceFingerprint
                            : legendSnapshot.fingerprint),
                    surface: context.surface || (mapId === 'importMap' ? 'import' : 'export'),
                    mode: context.mode || 'cumulative',
                    includeAdditionalPoints: true,
                    captureRaster: () => basemapSwitcher?.captureViewportRaster?.(),
                    getVectorLayers: collectVisualExportLayers,
                    getPoints: () => [
                        ...(Array.isArray(requestPoints) ? requestPoints : []),
                        ...(territorySnapshot?.points || []),
                    ],
                    territorySnapshot,
                    getChoroplethSnapshot: typeof context.getChoroplethSnapshot === 'function'
                        ? context.getChoroplethSnapshot
                        : () => context.choroplethSnapshot ?? choroplethSnapshot,
                    getStateRevision: () => visualExportRevision,
                    getAdditionalAttributions: () => [
                        boundaries?.attribution,
                        choroplethController?.getAttribution?.(),
                        ...(territorySnapshot?.attributions || []),
                    ].filter(Boolean),
                    getLayerState: () => {
                        const center = map.getCenter();
                        return {
                            mapId,
                            center: [Number(center.lat.toFixed(6)), Number(center.lng.toFixed(6))],
                            zoom: map.getZoom(),
                            basemap: basemapSwitcher?.getSnapshot?.() || null,
                            boundaries: administrativeBoundaryController?.getSnapshot?.() || null,
                            visualizationMode,
                            choroplethFingerprint: choroplethSnapshot?.active
                                ? choroplethSnapshot.fingerprint
                                : null,
                            territoryFingerprint: territorySnapshot?.fingerprint || null,
                            isochroneGeometryMode,
                            zoneIds: legendSnapshot.zones.map((zone) => zone.id),
                            surface: mapVisualSurface,
                        };
                    },
                });
            };

            const capturePointVisualExportSnapshot = async (sourceSnapshot, points = []) => {
                if (mapId !== 'exportMap' || !window.MaplyticsMapVisualExport?.captureMapSnapshot) {
                    throw new Error('Cette carte ne peut pas être exportée depuis ce parcours.');
                }
                if (!sourceSnapshot?.fingerprint) {
                    throw new Error('Le snapshot de concurrence n’est plus disponible. Actualisez l’aperçu.');
                }
                const boundaries = administrativeBoundaryController?.getExportSnapshot?.();
                return window.MaplyticsMapVisualExport.captureMapSnapshot({
                    map,
                    legendSnapshot: {
                        fingerprint: sourceSnapshot.fingerprint,
                        zones: [],
                    },
                    captureRaster: () => basemapSwitcher?.captureViewportRaster?.(),
                    getVectorLayers: () => boundaries?.geojson ? [{
                        kind: 'administrative',
                        geojson: boundaries.geojson,
                        style: boundaries.style,
                    }] : [],
                    getPoints: () => points,
                    getAdditionalAttributions: () => boundaries?.attribution
                        ? [boundaries.attribution]
                        : [],
                    getLayerState: () => {
                        const center = map.getCenter();
                        return {
                            mapId,
                            center: [Number(center.lat.toFixed(6)), Number(center.lng.toFixed(6))],
                            zoom: map.getZoom(),
                            basemap: basemapSwitcher?.getSnapshot?.() || null,
                            boundaries: administrativeBoundaryController?.getSnapshot?.() || null,
                            sourceFingerprint: sourceSnapshot.fingerprint,
                            pointCount: points.length,
                        };
                    },
                });
            };

            return {
                map,
                renderGeoJson,
                clearGeoJson,
                removeZone,
                zonesLayers,
                updateMapBounds,
                updateMapLegendMultiZones,
                updateZoneOpacity,
                setZoneVisibility,
                setPointVisibility,
                getZoneCenterMarkerSnapshot: () => Array.from(zoneCenterMarkers.entries()).map(
                    ([pointKey, point]) => ({
                        pointKey,
                        style: {...point.style},
                        visible: point.visible,
                        zoneIds: Array.from(point.zoneIds),
                    }),
                ),
                getOriginContextSnapshot,
                setMarker,
                clearMarker,
                beginMarkerReplacement,
                cancelPendingInteractions,
                setZoneCenterMarker,
                removeZoneCenterMarker,
                clearZoneCenterMarkers,
                updateKpiBadge,
                fitBoundsToZone,
                setIsochroneGeometryMode,
                getIsochroneGeometryModeContract,
                getVisualGeometrySnapshot,
                getChoroplethLayer: () => choroplethController?.getLayer?.() || null,
                getChoroplethExportLayers: () => choroplethController?.getExportLayers?.() || [],
                getChoroplethSnapshot: () => choroplethController?.getSnapshot?.() || null,
                getChoroplethMetrics: () => choroplethController?.metricsSnapshot?.() || {},
                setChoroplethDataScope: (value) => choroplethController?.setDataScope?.(value) || null,
                setChoroplethGeographicLevel: (value) => choroplethController?.setGeographicLevel?.(value) || null,
                setChoroplethRenderMode: (value) => choroplethController?.setRenderMode?.(value) || null,
                setChoroplethBoundaries: (value) => choroplethController?.setBoundaries?.(value) || null,
                refreshChoropleth: (reason = 'external-refresh') => (
                    choroplethController?.refresh?.({ reason }) || null
                ),
                invalidateVisualExport,
                captureVisualExportSnapshot,
                capturePointVisualExportSnapshot,
                getBasemapSnapshot: () => basemapSwitcher?.getSnapshot?.() || null,
                getAdministrativeBoundariesSnapshot: () => administrativeBoundaryController?.getSnapshot?.() || null,
                getAdministrativeBoundariesMetrics: () => administrativeBoundaryController?.metricsSnapshot?.() || {},
                getAdministrativeBoundariesRenderedStyle: () => administrativeBoundaryController?.getRenderedStyle?.() || null,
                applyAdministrativeBoundaryStyle: (...args) => administrativeBoundaryController?.applyStyle?.(...args) || null,
                showVisualizationPanel,
                hideVisualizationPanel,
                openFullscreenSettings,
                toggleFullscreen: toggleMapFullscreen
            };
        };

        const exportForm = document.getElementById('exportForm');
        const exportLogs = document.getElementById('exportLogs');
        const exportSummary = document.getElementById('exportSummary');
        const exportTable = document.getElementById('exportTable');
        const exportDownload = document.getElementById('exportDownload');
        let exportExcelLink = document.getElementById('exportExcelLink');
        const importDownload = document.getElementById('importDownload');
        let importExcelLink = document.getElementById('importExcelLink');
        const importIsoLink = document.getElementById('importIsoLink');
        const exportIsoLink = document.getElementById('exportIsoLink');
        const exportQueryInput = document.getElementById('exportQuery');
        const exportLatitudeInput = document.getElementById('exportLatitude');
        const exportLongitudeInput = document.getElementById('exportLongitude');
        const exportAddressStatus = document.getElementById('exportAddressStatus');
        const exportAddressSuggestions = document.getElementById('exportAddressSuggestions');
        const exportRecenterZonePointBtn = document.getElementById('exportRecenterZonePointBtn');
        const exportSubmitButton = document.getElementById('exportSubmitBtn');
        let exportAddressOriginController = null;
        let importAddressOriginController = null;

        const EXPORT_ADDRESS_DEBOUNCE_MS = 140;
        const EXPORT_ADDRESS_CACHE_MAX = 24;
        const exportAddressSuggestionCache = new Map();

        const normalizeExportAddressQuery = (value) => String(value || '')
            .normalize('NFKD')
            .replace(/[\u0300-\u036f]/g, '')
            .trim()
            .toLowerCase()
            .replace(/\s+/g, ' ');

        const cachedExportAddressSuggestions = (query) => {
            const key = normalizeExportAddressQuery(query);
            if (!exportAddressSuggestionCache.has(key)) return null;
            const value = exportAddressSuggestionCache.get(key);
            exportAddressSuggestionCache.delete(key);
            exportAddressSuggestionCache.set(key, value);
            return value.map((item) => ({ ...item }));
        };

        const rememberExportAddressSuggestions = (query, suggestions) => {
            const key = normalizeExportAddressQuery(query);
            const value = (Array.isArray(suggestions) ? suggestions : [])
                .map((item) => ({ ...item }));
            exportAddressSuggestionCache.delete(key);
            exportAddressSuggestionCache.set(key, value);
            while (exportAddressSuggestionCache.size > EXPORT_ADDRESS_CACHE_MAX) {
                exportAddressSuggestionCache.delete(exportAddressSuggestionCache.keys().next().value);
            }
        };

        const findCompatibleExportAddressSuggestions = (query) => {
            const normalized = normalizeExportAddressQuery(query);
            const prefix = [...exportAddressSuggestionCache.keys()]
                .filter((key) => key.length >= 3 && normalized.startsWith(key))
                .sort((left, right) => right.length - left.length)[0];
            if (!prefix) return [];
            return (exportAddressSuggestionCache.get(prefix) || [])
                .filter((item) => normalizeExportAddressQuery(item?.label).includes(normalized))
                .map((item) => ({ ...item }));
        };

        let exportAddressDebounce = null;
        let exportAddressAbort = null;
        let exportAddressSuggestionsData = [];
        let exportAddressActiveIndex = -1;
        let isApplyingExportAddress = false;
        let exportCalculationInProgress = false;
        let exportJobGeneration = 0;
        let activeExportJob = null;
        let activeExportCreationRequest = null;

        const isValidExportAddressCoordinates = (latValue, lonValue) => {
            if (
                String(latValue ?? '').trim() === ''
                || String(lonValue ?? '').trim() === ''
            ) {
                return false;
            }
            const lat = Number(latValue);
            const lon = Number(lonValue);
            return Number.isFinite(lat)
                && Number.isFinite(lon)
                && lat >= -90
                && lat <= 90
                && lon >= -180
                && lon <= 180;
        };

        const hasValidExportAddressCoordinates = () => (
            isValidExportAddressCoordinates(
                exportLatitudeInput?.value,
                exportLongitudeInput?.value,
            )
        );

        const syncExportAddressSubmitState = () => {
            if (!exportSubmitButton) return;
            const canSubmit = hasValidExportAddressCoordinates()
                && !exportCalculationInProgress;
            exportSubmitButton.disabled = !canSubmit;
            exportSubmitButton.setAttribute('aria-disabled', canSubmit ? 'false' : 'true');
        };

        const setExportAddressStatus = (state = 'pending', message = 'Adresse à valider') => {
            if (!exportAddressStatus) return;
            exportAddressStatus.classList.toggle('is-ready', state === 'ready');
            exportAddressStatus.classList.toggle('is-error', state === 'error');
            exportAddressStatus.textContent = message;
            exportQueryInput?.setAttribute('aria-invalid', state === 'error' ? 'true' : 'false');
        };

        const hideExportAddressSuggestions = () => {
            if (exportAddressOriginController) {
                exportAddressOriginController.hideSuggestions();
                return;
            }
            if (!exportAddressSuggestions) return;
            exportAddressSuggestions.hidden = true;
            exportAddressSuggestions.innerHTML = '';
            exportAddressActiveIndex = -1;
            exportQueryInput?.removeAttribute('aria-activedescendant');
            exportQueryInput?.setAttribute('aria-expanded', 'false');
        };

        const updateExportAddressActiveSuggestion = () => {
            if (!exportAddressSuggestions) return;
            exportAddressSuggestions.querySelectorAll('.home-address-suggestion').forEach((item, index) => {
                const active = index === exportAddressActiveIndex;
                item.classList.toggle('is-active', active);
                item.setAttribute('aria-selected', active ? 'true' : 'false');
                if (active && exportQueryInput) {
                    exportQueryInput.setAttribute('aria-activedescendant', item.id);
                }
            });
        };

        const renderExportAddressSuggestions = (suggestions) => {
            if (!exportAddressSuggestions) return;
            exportAddressSuggestions.innerHTML = '';
            exportAddressSuggestionsData = (Array.isArray(suggestions) ? suggestions : [])
                .filter((suggestion) => isValidExportAddressCoordinates(
                    suggestion?.lat,
                    suggestion?.lon,
                ));
            exportAddressActiveIndex = -1;
            if (!exportAddressSuggestionsData.length) {
                hideExportAddressSuggestions();
                setExportAddressStatus('error', 'Adresse introuvable');
                syncExportAddressSubmitState();
                return;
            }
            exportAddressSuggestionsData.forEach((suggestion, index) => {
                const item = document.createElement('button');
                item.type = 'button';
                item.id = `exportAddressSuggestion_${index}`;
                item.className = 'home-address-suggestion';
                item.setAttribute('role', 'option');
                item.setAttribute('aria-selected', 'false');
                const label = document.createElement('span');
                label.textContent = suggestion.label || 'Adresse';
                item.appendChild(label);
                const metaParts = [suggestion.postcode, suggestion.city, suggestion.source].filter(Boolean);
                if (metaParts.length) {
                    const meta = document.createElement('small');
                    meta.textContent = metaParts.join(' · ');
                    item.appendChild(meta);
                }
                item.addEventListener('click', () => applyExportAddressSuggestion(suggestion));
                exportAddressSuggestions.appendChild(item);
            });
            exportAddressSuggestions.hidden = false;
            exportQueryInput?.setAttribute('aria-expanded', 'true');
            setExportAddressStatus(
                'pending',
                exportAddressSuggestionsData.length > 1
                    ? `${exportAddressSuggestionsData.length} adresses trouvées : sélectionnez la bonne`
                    : 'Sélectionnez la suggestion proposée',
            );
            syncExportAddressSubmitState();
        };

        const applyExportAddressSuggestion = async (suggestion, options = {}) => {
            const workspaceGeneration = homeWorkspaceResetGeneration;
            if (!suggestion) return false;
            const lat = Number(suggestion.lat);
            const lon = Number(suggestion.lon);
            if (!isValidExportAddressCoordinates(lat, lon)) {
                setExportAddressStatus('error', 'Coordonnées indisponibles');
                syncExportAddressSubmitState();
                return false;
            }
            isApplyingExportAddress = true;
            if (exportQueryInput && suggestion.label) {
                exportQueryInput.value = suggestion.label;
                exportQueryInput.dataset.selectedAddress = suggestion.label;
            }
            if (exportLatitudeInput) exportLatitudeInput.value = String(lat);
            if (exportLongitudeInput) exportLongitudeInput.value = String(lon);
            setExportAddressStatus('ready', 'Point défini');
            hideExportAddressSuggestions();
            isApplyingExportAddress = false;
            syncExportAddressSubmitState();
            trackHomeFunnelEvent('address_selected', {
                source: suggestion.source || 'unknown',
                surface: 'home-address',
                target: 'home-export-address',
            });

            await ensurePanelMap('export');
            if (workspaceGeneration !== homeWorkspaceResetGeneration) return false;
            if (exportMapController?.map && exportMapController?.setMarker) {
                exportMapController.map.setView([lat, lon], options.zoom || 12, { animate: false });
                exportMapController.setMarker(lat, lon, {
                    source: 'address-suggestion',
                    statusMessage: 'Point défini',
                });
            }
            return true;
        };

        const fetchExportAddressSuggestions = async (query) => {
            const cached = cachedExportAddressSuggestions(query);
            if (cached !== null) return cached;
            if (exportAddressAbort) {
                exportAddressAbort.abort();
            }
            const controller = new AbortController();
            exportAddressAbort = controller;
            const response = await fetch(`/api/geocode/suggest?q=${encodeURIComponent(query)}&limit=5`, {
                signal: controller.signal,
            });
            if (!response.ok) return [];
            const payload = await response.json();
            if (exportAddressAbort !== controller) return [];
            const suggestions = Array.isArray(payload.suggestions) ? payload.suggestions : [];
            rememberExportAddressSuggestions(query, suggestions);
            return suggestions;
        };

        const clearExportAddressCoordinates = () => {
            if (exportAddressOriginController) {
                exportAddressOriginController.clearCoordinates();
                return;
            }
            exportAddressAbort?.abort?.();
            exportAddressAbort = null;
            if (exportLatitudeInput) exportLatitudeInput.value = '';
            if (exportLongitudeInput) exportLongitudeInput.value = '';
            if (exportQueryInput) delete exportQueryInput.dataset.selectedAddress;
            exportMapController?.clearMarker?.();
            setExportAddressStatus('pending', 'Adresse à valider');
            syncExportAddressSubmitState();
        };

        function updateExportRecenterPointButton() {
            if (!exportRecenterZonePointBtn) return;
            if (exportCalculationInProgress) {
                exportRecenterZonePointBtn.hidden = true;
                return;
            }
            const hasZones = Boolean(typeof zonesManager !== 'undefined' && zonesManager?.zones?.size > 0);
            exportRecenterZonePointBtn.hidden = !hasZones;
        }

        function setExportCalculationBusy(isBusy) {
            exportCalculationInProgress = Boolean(isBusy);
            zonesManager?.setInteractionLocked?.(exportCalculationInProgress);
            syncAddZoneButtonState();
            updateExportRecenterPointButton();
            syncExportAddressSubmitState();
        }

        const homeFunnelTrackedOnce = {};
        const trackHomeFunnelEvent = (eventName, properties = {}) => {
            const surface = properties.surface || 'home-tool';
            const analyticsPayload = {
                surface,
                source_page: window.location.pathname,
            };
            ['feature_code', 'required_plan', 'user_status', 'plan', 'device_type', 'cta_label', 'format', 'checkout_type'].forEach((key) => {
                if (properties[key]) analyticsPayload[key] = properties[key];
            });
            window.Analytics?.track?.(eventName, analyticsPayload);
            window.MaplyticsPublicActions?.track?.(eventName, {
                target: properties.target || eventName,
                surface,
            });
        };
        const trackHomeFunnelEventOnce = (eventName, properties = {}) => {
            if (homeFunnelTrackedOnce[eventName]) return;
            homeFunnelTrackedOnce[eventName] = true;
            trackHomeFunnelEvent(eventName, properties);
        };

        async function recenterExportPointToLatestZone() {
            const workspaceGeneration = homeWorkspaceResetGeneration;
            const selected = zonesManager?.getLatestZoneOrigin?.();
            if (!selected?.origin) {
                setExportAddressStatus('error', 'Aucune zone à recentrer');
                return false;
            }
            const { zone, origin } = selected;
            const lat = Number(origin.lat);
            const lon = Number(origin.lon);
            if (!Number.isFinite(lat) || !Number.isFinite(lon)) {
                setExportAddressStatus('error', 'Centre de zone indisponible');
                return false;
            }
            await ensurePanelMap('export');
            if (workspaceGeneration !== homeWorkspaceResetGeneration) return false;
            if (exportLatitudeInput) exportLatitudeInput.value = String(lat);
            if (exportLongitudeInput) exportLongitudeInput.value = String(lon);
            if (exportQueryInput) {
                const label = origin.approximate
                    ? `Centre approximatif ${zone?.name || 'ZDC'}`
                    : (origin.label || exportQueryInput.value || `Centre ${zone?.name || 'ZDC'}`);
                exportQueryInput.value = label;
                exportQueryInput.dataset.selectedAddress = label;
            }
            hideExportAddressSuggestions();
            const statusMessage = origin.approximate
                ? 'Point replacé au centre approximatif'
                : 'Point replacé au centre de la zone';
            setExportAddressStatus('ready', statusMessage);
            syncExportAddressSubmitState();
            if (exportMapController?.map && exportMapController?.setMarker) {
                exportMapController.setMarker(lat, lon, {
                    source: 'zone-center-recenter',
                    statusMessage,
                });
                exportMapController.map.setView([lat, lon], 13, { animate: false });
            }
            return true;
        }

        if (exportQueryInput && !window.MaplyticsAddressOriginController?.create) {
            exportQueryInput.setAttribute('autocomplete', 'off');
            exportQueryInput.setAttribute('role', 'combobox');
            exportQueryInput.setAttribute('aria-autocomplete', 'list');
            exportQueryInput.setAttribute('aria-controls', 'exportAddressSuggestions');
            exportQueryInput.setAttribute('aria-expanded', 'false');
            exportQueryInput.setAttribute('aria-haspopup', 'listbox');
            exportQueryInput.setAttribute('aria-invalid', 'false');

            exportQueryInput.addEventListener('input', () => {
                if (isApplyingExportAddress) return;
                const query = exportQueryInput.value.trim();
                if (query.length > 0) {
                    trackHomeFunnelEventOnce('address_input_start', {
                        surface: 'home-address',
                        target: 'home-export-address',
                    });
                }
                const hasStoredCoordinates = Boolean(exportLatitudeInput?.value && exportLongitudeInput?.value);
                if (hasStoredCoordinates && (!exportQueryInput.dataset.selectedAddress || query !== exportQueryInput.dataset.selectedAddress)) {
                    clearExportAddressCoordinates();
                } else if (!exportLatitudeInput?.value || !exportLongitudeInput?.value) {
                    setExportAddressStatus('pending', 'Adresse à valider');
                }
                clearTimeout(exportAddressDebounce);
                exportAddressAbort?.abort?.();
                exportAddressAbort = null;
                if (query.length < 3) {
                    hideExportAddressSuggestions();
                    setExportAddressStatus(
                        'pending',
                        query.length ? 'Saisissez au moins 3 caractères' : 'Adresse à valider',
                    );
                    syncExportAddressSubmitState();
                    return;
                }
                const exactSuggestions = cachedExportAddressSuggestions(query);
                if (exactSuggestions !== null) {
                    renderExportAddressSuggestions(exactSuggestions);
                    return;
                }
                const compatibleSuggestions = findCompatibleExportAddressSuggestions(query);
                if (compatibleSuggestions.length) {
                    renderExportAddressSuggestions(compatibleSuggestions);
                }
                exportAddressDebounce = setTimeout(async () => {
                    try {
                        const suggestions = await fetchExportAddressSuggestions(query);
                        if (
                            normalizeExportAddressQuery(exportQueryInput?.value)
                            !== normalizeExportAddressQuery(query)
                        ) return;
                        renderExportAddressSuggestions(suggestions);
                    } catch (error) {
                        if (error?.name !== 'AbortError') {
                            hideExportAddressSuggestions();
                            setExportAddressStatus('error', 'Recherche temporairement indisponible');
                            syncExportAddressSubmitState();
                        }
                    }
                }, EXPORT_ADDRESS_DEBOUNCE_MS);
            });

            exportQueryInput.addEventListener('keydown', (event) => {
                if (!exportAddressSuggestions || exportAddressSuggestions.hidden || !exportAddressSuggestionsData.length) {
                    return;
                }
                if (event.key === 'ArrowDown') {
                    event.preventDefault();
                    exportAddressActiveIndex = Math.min(exportAddressActiveIndex + 1, exportAddressSuggestionsData.length - 1);
                    updateExportAddressActiveSuggestion();
                } else if (event.key === 'ArrowUp') {
                    event.preventDefault();
                    exportAddressActiveIndex = Math.max(exportAddressActiveIndex - 1, 0);
                    updateExportAddressActiveSuggestion();
                } else if (event.key === 'Enter' && exportAddressActiveIndex >= 0) {
                    event.preventDefault();
                    applyExportAddressSuggestion(exportAddressSuggestionsData[exportAddressActiveIndex]);
                } else if (event.key === 'Escape') {
                    hideExportAddressSuggestions();
                }
            });
        }

        if (window.MaplyticsAddressOriginController?.create) {
            exportAddressOriginController = window.MaplyticsAddressOriginController.create({
                input: exportQueryInput,
                latInput: exportLatitudeInput,
                lonInput: exportLongitudeInput,
                suggestions: exportAddressSuggestions,
                status: exportAddressStatus,
                searchButton: document.getElementById('exportSearchBtn'),
                suggestionIdPrefix: 'exportAddress',
                ensureMap: () => ensurePanelMap('export'),
                getMapController: () => exportMapController,
                onStateChange: syncExportAddressSubmitState,
                onInputStarted: () => {
                    trackHomeFunnelEventOnce('address_input_start', {
                        surface: 'home-address',
                        target: 'home-export-address',
                    });
                },
                onSelected: ({suggestion}) => {
                    trackHomeFunnelEvent('address_selected', {
                        source: suggestion?.source || 'unknown',
                        surface: 'home-address',
                        target: 'home-export-address',
                    });
                },
            });
        }

        document.addEventListener('click', (event) => {
            if (!exportAddressSuggestions || exportAddressSuggestions.hidden) return;
            if (exportAddressSuggestions.contains(event.target) || exportQueryInput?.contains(event.target)) return;
            hideExportAddressSuggestions();
        });

        document.addEventListener('maplytics:origin-marker-set', (event) => {
            if (event.detail?.queryInputId !== 'exportQuery') return;
            setExportAddressStatus('ready', event.detail?.statusMessage || 'Point défini');
            syncExportAddressSubmitState();
        });

        exportRecenterZonePointBtn?.addEventListener('click', () => {
            recenterExportPointToLatestZone();
        });
        syncExportAddressSubmitState();

        const exportMinutesInput = document.getElementById('exportMinutes');
        const exportTransportModeSelect = document.getElementById('exportTransportMode');
        const exportMinutesLimit = document.getElementById('exportMinutesLimit');
        const transportModeLabels = {
            'driving-car': 'voiture',
            'driving-hgv': 'poids lourds',
            'cycling-regular': 'vélo',
            'foot-walking': 'marche'
        };
        const syncIsochroneDurationLimit = () => {
            if (!exportMinutesInput) return;
            const zoneType = document.querySelector('input[name="zone_type"]:checked')?.value;
            if (zoneType !== 'isochrone') {
                exportMinutesInput.removeAttribute('max');
                if (exportMinutesLimit) exportMinutesLimit.textContent = '';
                return;
            }
            let limits = {};
            try {
                limits = JSON.parse(exportMinutesInput.dataset.transportLimits || '{}');
            } catch (_error) {
                limits = {};
            }
            const mode = exportTransportModeSelect?.value || 'driving-car';
            const limit = Number(limits[mode] || limits['driving-car'] || 90);
            exportMinutesInput.max = String(limit);
            if (exportMinutesLimit) {
                exportMinutesLimit.textContent = `Maximum : ${limit} min en ${transportModeLabels[mode] || 'transport sélectionné'}.`;
            }
        };
        exportTransportModeSelect?.addEventListener('change', syncIsochroneDurationLimit);
        syncIsochroneDurationLimit();

        // Toggle type de zone : isochrone ↔ isodistance
        document.querySelectorAll('input[name="zone_type"]').forEach(radio => {
            radio.addEventListener('change', () => {
                const isTime = radio.value === 'isochrone';
                const minutesInput = document.getElementById('exportMinutes');
                const minutesLabel = document.getElementById('exportMinutesLabel');
                const minutesTooltip = document.getElementById('exportMinutesTooltip');
                const minutesTooltipCopy = minutesTooltip?.querySelector('[data-help-tooltip-copy]');
                const transportGroup = document.getElementById('exportTransportMode')?.closest('div');
                const isoLabel = document.getElementById('zoneTypeIsochroneLabel');
                const distLabel = document.getElementById('zoneTypeIsodistanceLabel');

                if (isTime) {
                    minutesLabel.childNodes[0].textContent = 'Temps (minutes) ';
                    minutesInput.value = '15';
                    minutesInput.min = '1';
                    minutesInput.placeholder = '';
                    if (minutesTooltipCopy) minutesTooltipCopy.textContent = 'La durée définit le seuil de trajet de cette zone. Plus elle est élevée, plus le périmètre peut s’étendre.';
                    if (transportGroup) transportGroup.style.display = '';
                    isoLabel.style.border = '2px solid #2563eb';
                    isoLabel.style.background = '#eff6ff';
                    isoLabel.style.color = '#2563eb';
                    distLabel.style.border = '2px solid #e2e8f0';
                    distLabel.style.background = 'transparent';
                    distLabel.style.color = '#64748b';
                    syncIsochroneDurationLimit();
                } else {
                    minutesLabel.childNodes[0].textContent = 'Distance (km) ';
                    minutesInput.value = '10';
                    minutesInput.min = '1';
                    minutesInput.placeholder = 'Rayon en km';
                    if (minutesTooltipCopy) minutesTooltipCopy.textContent = 'Le rayon en kilomètres définit le seuil de distance de cette zone autour du point de départ.';
                    if (transportGroup) transportGroup.style.display = 'none';
                    distLabel.style.border = '2px solid #8b5cf6';
                    distLabel.style.background = '#f5f3ff';
                    distLabel.style.color = '#7c3aed';
                    isoLabel.style.border = '2px solid #e2e8f0';
                    isoLabel.style.background = 'transparent';
                    isoLabel.style.color = '#64748b';
                    syncIsochroneDurationLimit();
                }
            });
        });

        const importForm = document.getElementById('importForm');
        const importLogs = document.getElementById('importLogs');
        const importSummary = document.getElementById('importSummary');
        const importTable = document.getElementById('importTable');
        const importUnmatched = document.getElementById('importUnmatched');
        const unmatchedDownload = document.getElementById('unmatchedDownload');
        const importClearResultsBtn = document.getElementById('importClearResultsBtn');
        const importResetBtn = document.getElementById('importResetBtn');
        const importTemplateDownload = document.getElementById('importTemplateDownload');
        const importGuidedModeButtons = Array.from(
            document.querySelectorAll('[data-import-guided-mode]'),
        );
        const importGuidedValidationStatus = document.getElementById(
            'importGuidedValidationStatus',
        );
        const importGuidedResult = document.getElementById('importGuidedResult');
        const importGuidedResultSummary = document.getElementById(
            'importGuidedResultSummary',
        );
        const importGuidedResultsBtn = document.getElementById('importGuidedResultsBtn');
        const importDataTextarea = document.getElementById('importData');
        const importFileInput = document.getElementById('importFile');
        const importHeadersBtn = document.getElementById('importHeadersBtn');
        const importSampleBtn = document.getElementById('importSampleBtn');
        const importGrid = document.getElementById('importGrid');
        const importGridBody = importGrid.querySelector('tbody');
        const importGridInitialHtml = importGridBody.innerHTML;
        const gridAddRowBtn = document.getElementById('gridAddRowBtn');
        const gridClearBtn = document.getElementById('gridClearBtn');
        const gridApplyBtn = document.getElementById('gridApplyBtn');
        const moveImportActionToGuide = (element, slotId) => {
            const slot = document.getElementById(slotId);
            if (!element || !slot || element.parentElement === slot) return;
            slot.appendChild(element);
        };
        // Move the existing controls into the compact guide. The commune
        // review controller and reset handlers keep the same elements and IDs.
        moveImportActionToGuide(
            document.getElementById('importCommuneReviewOpenInline'),
            'importGuidedReviewSlot',
        );
        moveImportActionToGuide(importTemplateDownload, 'importGuidedTemplateSlot');
        moveImportActionToGuide(importResetBtn, 'importResetActionMount');
        moveImportActionToGuide(importClearResultsBtn, 'importClearResultActionMount');
        const TOOL_BRIDGE_CONTEXT_KEY = scopedSessionStorageKey('maplytics_tool_bridge_context_v1');
        const TOOL_RESULT_SNAPSHOT_KEY = scopedSessionStorageKey('maplytics_tool_result_snapshot_v1');
        const HOME_WORKSPACE_RESET_STORAGE_KEY = scopedLocalStorageKey('maplytics_home_workspace_reset_v1');
        const HOME_SCOPED_WORKSPACE_RESET_STORAGE_KEY = scopedLocalStorageKey('maplytics_home_scoped_workspace_reset_v1');
        const HOME_SCOPED_WORKSPACE_RESET_SCOPES = new Set(['zones', 'origin', 'competitors']);
        const TOOL_RESULT_SNAPSHOT_TTL_MS = 2 * 60 * 60 * 1000;
        const TOOL_RESULT_SNAPSHOT_MAX_BYTES = 750 * 1024;
        const TOOL_RESULT_SNAPSHOT_MAX_ROWS = 300;
        const TOOL_RESULT_SNAPSHOT_MAX_GEOJSON_BYTES = 250 * 1024;
        const TOOL_RESULT_REHYDRATION_TIMEOUT_MS = 15 * 1000;
        const ZONES_LOCAL_STORAGE_AUTO_RESTORE_MAX_BYTES = 900 * 1024;
        const ZONES_LOCAL_STORAGE_MAX_AUTO_ZONES = 3;
        const latestToolBridgeContext = { export: null, import: null };
        let toolResultRestorePromptShown = false;
        let zonesStorageRestorePromptShown = false;
        let toolResultRestoreInProgress = false;
        let homeWorkspaceResetGeneration = 0;
        const homeWorkspaceScopeResetGenerations = {
            zones: 0,
            origin: 0,
            competitors: 0,
        };

        function homeWorkspaceScopeResetGeneration(scope) {
            return Number(homeWorkspaceScopeResetGenerations[String(scope || '')] || 0);
        }

        function incrementHomeWorkspaceScopeResetGenerations(scopes) {
            (Array.isArray(scopes) ? scopes : []).forEach((scope) => {
                if (!HOME_SCOPED_WORKSPACE_RESET_SCOPES.has(scope)) return;
                homeWorkspaceScopeResetGenerations[scope] += 1;
            });
        }

        function isHomeWorkspaceReset() {
            try {
                return Boolean(localStorage.getItem(HOME_WORKSPACE_RESET_STORAGE_KEY));
            } catch (_error) {
                return false;
            }
        }

        function readHomeWorkspaceScopeResets() {
            try {
                const raw = JSON.parse(
                    localStorage.getItem(HOME_SCOPED_WORKSPACE_RESET_STORAGE_KEY) || '{}',
                );
                const scopes = Array.isArray(raw?.scopes)
                    ? raw.scopes.filter((scope) => HOME_SCOPED_WORKSPACE_RESET_SCOPES.has(scope))
                    : [];
                return {
                    schema_version: 2,
                    scopes: [...new Set(scopes)],
                    purge_scopes: [...new Set(
                        (Array.isArray(raw?.purge_scopes) ? raw.purge_scopes : [])
                            .filter((scope) => HOME_SCOPED_WORKSPACE_RESET_SCOPES.has(scope)),
                    )],
                    reset_at: String(raw?.reset_at || ''),
                };
            } catch (_error) {
                return { schema_version: 2, scopes: [], purge_scopes: [], reset_at: '' };
            }
        }

        function isHomeWorkspaceScopeReset(scope) {
            const normalized = String(scope || '');
            return isHomeWorkspaceReset()
                || readHomeWorkspaceScopeResets().scopes.includes(normalized);
        }

        function isHomeWorkspaceScopePayloadReset(scope) {
            const normalized = String(scope || '');
            return isHomeWorkspaceReset()
                || readHomeWorkspaceScopeResets().purge_scopes.includes(normalized);
        }

        function markHomeWorkspaceScopeResets(scopes, { purgePayload = false } = {}) {
            const normalizedScopes = [...new Set(
                (Array.isArray(scopes) ? scopes : [])
                    .map((scope) => String(scope || ''))
                    .filter((scope) => HOME_SCOPED_WORKSPACE_RESET_SCOPES.has(scope)),
            )];
            if (!normalizedScopes.length) return false;
            try {
                const current = readHomeWorkspaceScopeResets();
                localStorage.setItem(HOME_SCOPED_WORKSPACE_RESET_STORAGE_KEY, JSON.stringify({
                    schema_version: 2,
                    scopes: [...new Set([...current.scopes, ...normalizedScopes])],
                    purge_scopes: purgePayload
                        ? [...new Set([...current.purge_scopes, ...normalizedScopes])]
                        : current.purge_scopes,
                    reset_at: new Date().toISOString(),
                    tool_type: 'isochrone',
                }));
                incrementHomeWorkspaceScopeResetGenerations(normalizedScopes);
                if (normalizedScopes.some((scope) => scope === 'zones' || scope === 'origin')) {
                    homeWorkspaceResetGeneration += 1;
                }
                return true;
            } catch (error) {
                console.warn('[Home reset] marqueur ciblé indisponible:', error);
                return false;
            }
        }

        function markHomeWorkspaceScopeReset(scope) {
            return markHomeWorkspaceScopeResets([scope]);
        }

        function markHomeWorkspaceReset() {
            try {
                localStorage.removeItem(HOME_SCOPED_WORKSPACE_RESET_STORAGE_KEY);
                localStorage.setItem(HOME_WORKSPACE_RESET_STORAGE_KEY, JSON.stringify({
                    schema_version: 1,
                    reset_at: new Date().toISOString(),
                    tool_type: 'isochrone',
                }));
                incrementHomeWorkspaceScopeResetGenerations(
                    [...HOME_SCOPED_WORKSPACE_RESET_SCOPES],
                );
                homeWorkspaceResetGeneration += 1;
                return true;
            } catch (error) {
                console.warn('[Home reset] marqueur local indisponible:', error);
                return false;
            }
        }

        function clearHomeWorkspaceReset(toolType = 'isochrone', options = {}) {
            if (String(toolType || '') !== 'isochrone') return false;
            try {
                localStorage.removeItem(HOME_WORKSPACE_RESET_STORAGE_KEY);
                const requestedScopes = Array.isArray(options?.scopes)
                    ? options.scopes.filter((scope) => HOME_SCOPED_WORKSPACE_RESET_SCOPES.has(scope))
                    : [];
                if (requestedScopes.length) {
                    const retained = readHomeWorkspaceScopeResets().scopes.filter(
                        (scope) => !requestedScopes.includes(scope),
                    );
                    if (retained.length) {
                        const retainedPurgeScopes = readHomeWorkspaceScopeResets()
                            .purge_scopes.filter((scope) => retained.includes(scope));
                        localStorage.setItem(HOME_SCOPED_WORKSPACE_RESET_STORAGE_KEY, JSON.stringify({
                            schema_version: 2,
                            scopes: retained,
                            purge_scopes: retainedPurgeScopes,
                            reset_at: new Date().toISOString(),
                            tool_type: 'isochrone',
                        }));
                    } else {
                        localStorage.removeItem(HOME_SCOPED_WORKSPACE_RESET_STORAGE_KEY);
                    }
                } else {
                    localStorage.removeItem(HOME_SCOPED_WORKSPACE_RESET_STORAGE_KEY);
                }
                incrementHomeWorkspaceScopeResetGenerations(
                    requestedScopes.length
                        ? requestedScopes
                        : [...HOME_SCOPED_WORKSPACE_RESET_SCOPES],
                );
                homeWorkspaceResetGeneration += 1;
                return true;
            } catch (error) {
                console.warn('[Home reset] marqueur local non supprimé:', error);
                return false;
            }
        }

        window.maplyticsClearHomeWorkspaceReset = clearHomeWorkspaceReset;
        window.maplyticsHomeWorkspaceScopeReset = isHomeWorkspaceScopeReset;
        window.maplyticsHomeWorkspaceScopePayloadReset = isHomeWorkspaceScopePayloadReset;

        function getFieldValue(id) {
            return (document.getElementById(id)?.value || '').trim();
        }

        function getSelectedText(id) {
            const el = document.getElementById(id);
            return el?.selectedOptions?.[0]?.textContent?.trim() || el?.value || '';
        }

        function buildToolBridgeContext(panelType, data = {}, zone = null) {
            const isImport = panelType === 'import';
            const rowsCount = Number(data.total_rows || data.rows?.length || 0);
            const base = {
                source: panelType,
                timestamp: new Date().toISOString(),
                destination: null,
                count: rowsCount,
                communes_count: rowsCount,
                label: isImport ? 'Tableau de points importé' : (getFieldValue('exportQuery') || 'Zone calculée'),
            };

            if (isImport) {
                base.address = getFieldValue('importQuery') || base.label;
                base.lat = getFieldValue('importLatitude') || null;
                base.lon = getFieldValue('importLongitude') || null;
                base.mode = getSelectedText('importTransportMode') || null;
                base.zone_type = 'import-table';
                base.membership_status = 'explicit-destinations';
                base.points_count = rowsCount;
            } else {
                base.address = getFieldValue('exportQuery') || base.label;
                base.lat = getFieldValue('exportLatitude') || null;
                base.lon = getFieldValue('exportLongitude') || null;
                base.minutes = getFieldValue('exportMinutes') || null;
                base.mode = getSelectedText('exportTransportMode') || null;
                base.zone_type = document.querySelector('input[name="zone_type"]:checked')?.value || 'isochrone';
                base.zone_name = zone?.name || null;
                base.zones_count = typeof zonesManager !== 'undefined' && zonesManager?.zones ? zonesManager.zones.size : 1;
            }
            return base;
        }

        function summarizeToolBridgeContext(context) {
            if (!context) return 'Résultat prêt. Choisissez le bon outil selon votre prochaine décision.';
            const count = Number(context.communes_count || context.points_count || context.count || 0);
            const countText = count > 0
                ? `${count} ${context.source === 'import' ? 'lignes traitées' : 'communes trouvées'}`
                : 'résultat prêt';
            const areaText = context.address ? ` depuis ${context.address}` : '';
            const timeText = context.minutes ? ` · ${context.minutes} min` : '';
            return `${countText}${areaText}${timeText}.`;
        }

        function getToolBridgeRecommendation(panelType, context = {}) {
            const zonesCount = Number(context.zones_count || 0);
            const intent = String(context.intent || '').toLowerCase();
            if (panelType === 'import') {
                return {
                    destination: 'geoManager',
                    label: 'Recommandé : Geo Manager',
                    reason: 'Vos points peuvent devenir un réseau suivi avec dossiers, statuts et exports.'
                };
            }
            if (zonesCount > 1 || ['organiser', 'prospecter', 'reseau', 'réseau'].includes(intent)) {
                return {
                    destination: 'geoManager',
                    label: 'Recommandé : Geo Manager',
                    reason: 'Organisez plusieurs zones, points, dossiers et prospects SIRENE dans un espace dédié.'
                };
            }
            return {
                destination: 'table',
                label: 'Recommandé : vérifier les communes',
                reason: 'Consultez les communes couvertes et les indicateurs du résultat avant de poursuivre.'
            };
        }

        function applyToolBridgeRecommendation(bridge, panelType, context, isPaid) {
            if (!bridge) return;
            const recommendation = getToolBridgeRecommendation(panelType, context);
            bridge.dataset.bridgeRecommendedDestination = recommendation.destination;
            bridge.querySelectorAll('.is-recommended').forEach((el) => el.classList.remove('is-recommended'));
            bridge.querySelectorAll(`[data-bridge-card="${recommendation.destination}"], [data-bridge-preview="${recommendation.destination}"]`)
                .forEach((el) => el.classList.add('is-recommended'));
            const recommendationEl = bridge.querySelector('[data-tool-bridge-recommendation]');
            if (recommendationEl) {
                recommendationEl.textContent = isPaid
                    ? `Raccourci conseillé : ${recommendation.label.replace('Recommandé : ', '')}. ${recommendation.reason}`
                    : `${recommendation.label}. ${recommendation.reason}`;
            }
        }

        function revealToolBridgeAfterResult(panelType, bridge, options = {}) {
            if (!bridge) return;
            bridge.dataset.bridgeReady = 'true';
            // No page auto-scroll after calculation.
        }

        function scrollToToolBridgeFromUserAction(panelType = 'export') {
            if (!isProgrammaticScrollAllowed('user-click')) return;
            const bridge = document.getElementById(panelType === 'import' ? 'importToolBridge' : 'exportToolBridge');
            if (!bridge || bridge.hidden) return;
            const prefersReducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches;
            bridge.scrollIntoView({
                behavior: prefersReducedMotion ? 'auto' : 'smooth',
                block: 'start',
                inline: 'nearest',
            });
        }

        function persistToolBridgeContext(context) {
            try {
                sessionStorage.setItem(TOOL_BRIDGE_CONTEXT_KEY, JSON.stringify(context));
            } catch (error) {
                console.warn('[Tool bridge] contexte non sauvegardé:', error);
            }
        }

        function approximateJsonBytes(value) {
            if (value === undefined || value === null) return 0;
            try {
                return new Blob([JSON.stringify(value)]).size;
            } catch (error) {
                try {
                    return JSON.stringify(value).length;
                } catch (fallbackError) {
                    return 0;
                }
            }
        }

        function isEdgeBrowser() {
            const ua = navigator.userAgent || '';
            return /\bEdg(A|iOS)?\//.test(ua);
        }

        function runWhenBrowserIdle(callback, timeout = 700) {
            if (typeof window.requestIdleCallback === 'function') {
                return window.requestIdleCallback(callback, { timeout });
            }
            return window.setTimeout(callback, Math.min(timeout, 120));
        }

        function trackFrontendPerformanceEvent(action, options = {}) {
            try {
                window.MaplyticsPublicActions?.track?.(action, {
                    target: options.target || 'home-tool',
                    surface: options.surface || 'frontend-performance',
                });
            } catch (error) {
                // Performance monitoring must never affect the user flow.
            }
        }

        function getToolSnapshotWeight(snapshot) {
            const rows = Array.isArray(snapshot?.rows)
                ? snapshot.rows
                : (Array.isArray(snapshot?.calculation_data?.rows) ? snapshot.calculation_data.rows : []);
            const mapGeojson = snapshot?.map_geojson || snapshot?.calculation_data?.map_geojson || null;
            const unmatched = Array.isArray(snapshot?.unmatched) ? snapshot.unmatched : [];
            return {
                totalBytes: approximateJsonBytes(snapshot),
                rowsCount: rows.length,
                geojsonBytes: approximateJsonBytes(mapGeojson),
                unmatchedCount: unmatched.length,
            };
        }

        function shouldDeferToolSnapshotRestore(snapshot) {
            const weight = getToolSnapshotWeight(snapshot);
            if (snapshot?.compacted) {
                return { defer: true, reason: 'snapshot-compacted', weight };
            }
            if (isEdgeBrowser()) {
                return { defer: true, reason: 'edge-browser', weight };
            }
            if (weight.totalBytes > TOOL_RESULT_SNAPSHOT_MAX_BYTES) {
                return { defer: true, reason: 'snapshot-heavy', weight };
            }
            if (weight.rowsCount > TOOL_RESULT_SNAPSHOT_MAX_ROWS) {
                return { defer: true, reason: 'rows-heavy', weight };
            }
            if (weight.geojsonBytes > TOOL_RESULT_SNAPSHOT_MAX_GEOJSON_BYTES) {
                return { defer: true, reason: 'geojson-heavy', weight };
            }
            return { defer: false, reason: 'safe', weight };
        }

        function compactToolResultSnapshot(snapshot, reason = 'storage-guard') {
            const rows = Array.isArray(snapshot?.rows) ? snapshot.rows : [];
            const calculationRows = Array.isArray(snapshot?.calculation_data?.rows) ? snapshot.calculation_data.rows : [];
            const unmatched = Array.isArray(snapshot?.unmatched) ? snapshot.unmatched : [];
            const geojson = snapshot?.map_geojson || snapshot?.calculation_data?.map_geojson || null;
            const totalBytes = approximateJsonBytes(snapshot);
            const shouldDropRows = Math.max(rows.length, calculationRows.length) > TOOL_RESULT_SNAPSHOT_MAX_ROWS
                || (totalBytes > TOOL_RESULT_SNAPSHOT_MAX_BYTES && Math.max(rows.length, calculationRows.length) > 0);
            const shouldDropGeojson = approximateJsonBytes(geojson) > TOOL_RESULT_SNAPSHOT_MAX_GEOJSON_BYTES
                || (totalBytes > TOOL_RESULT_SNAPSHOT_MAX_BYTES && Boolean(geojson));
            const shouldDropUnmatched = unmatched.length > IMPORT_UNMATCHED_PREVIEW_LIMIT
                || (totalBytes > TOOL_RESULT_SNAPSHOT_MAX_BYTES && unmatched.length > 0);
            return {
                ...snapshot,
                compacted: true,
                compact_reason: reason,
                original_rows_count: Math.max(rows.length, calculationRows.length),
                original_geojson_bytes: approximateJsonBytes(geojson),
                original_unmatched_count: unmatched.length,
                rows: shouldDropRows ? [] : rows,
                unmatched: shouldDropUnmatched ? [] : unmatched,
                map_geojson: shouldDropGeojson ? null : snapshot.map_geojson,
                calculation_data: snapshot.calculation_data ? {
                    ...snapshot.calculation_data,
                    rows: shouldDropRows ? [] : calculationRows,
                    map_geojson: shouldDropGeojson ? null : snapshot.calculation_data.map_geojson,
                } : null,
            };
        }

        function createRestorePrompt({ id, title, text, actionLabel, onAction, onDismiss }) {
            const existing = document.getElementById(id);
            if (existing) existing.remove();
            const prompt = document.createElement('div');
            prompt.id = id;
            prompt.className = 'tool-restore-prompt';
            prompt.setAttribute('role', 'status');
            prompt.innerHTML = `
                <span class="tool-restore-prompt__copy">
                    <strong class="tool-restore-prompt__title">${title}</strong>
                    <span class="tool-restore-prompt__text">${text}</span>
                </span>
                <span class="tool-restore-prompt__actions">
                    <button type="button" class="tool-restore-prompt__button">${actionLabel}</button>
                    <button type="button" class="tool-restore-prompt__button tool-restore-prompt__button--ghost">Ignorer</button>
                </span>
            `;
            prompt.querySelector('.tool-restore-prompt__button')?.addEventListener('click', async () => {
                prompt.remove();
                await onAction?.();
            });
            prompt.querySelector('.tool-restore-prompt__button--ghost')?.addEventListener('click', () => {
                prompt.remove();
                onDismiss?.();
            });
            return prompt;
        }

        function isPaidToolBridgeUser(options = {}) {
            const usage = options.usage || {};
            if (options.is_premium === true || options.isPaid === true) return true;
            if (usage.is_premium === true || usage.limit === -1) return true;
            if (typeof connectedUserIsPremium !== 'undefined' && connectedUserIsPremium) return true;
            const plan = String(window.APP_CONFIG?.userPlan || APP_CONFIG?.userPlan || '').toLowerCase();
            return Boolean(plan && !['free', 'freemium', 'anonymous', 'null', 'none'].includes(plan));
        }

        function normalizeToolBridgePlanName(value) {
            return String(value || '')
                .trim()
                .toLowerCase()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '');
        }

        function getToolBridgeAudienceState(panelType, options = {}, isPaid = false) {
            const usage = options.usage || {};
            const usageCount = Number(usage.usage_count);
            const limit = Number(usage.limit);
            const planName = normalizeToolBridgePlanName(
                usage.plan_name
                || usage.plan_display_name
                || window.APP_CONFIG?.userPlan
                || APP_CONFIG?.userPlan
                || ''
            );
            const userStatus = limit === 5
                ? 'anonymous'
                : (limit === 10 || planName === 'freemium' || planName === 'free' ? 'freemium' : 'paid');
            const isNetwork = planName.includes('network') || planName.includes('reseau');
            const quotaReached = Number.isFinite(limit) && limit > 0 && Number.isFinite(usageCount) && usageCount >= limit;
            const remaining = Number.isFinite(limit) && limit > 0 && Number.isFinite(usageCount)
                ? Math.max(limit - usageCount, 0)
                : null;

            if (isNetwork) {
                return {
                    profile: 'network',
                    userStatus: 'paid',
                    quotaReached: false,
                    status: 'Plan Réseau',
                    title: 'Pilotez cette zone dans Geo Manager.',
                    copy: 'Ajoutez-la à votre logique multi-sites : points, dossiers, zones blanches, prospection et exports réseau.',
                    primary: {
                        label: 'Ouvrir Geo Manager',
                        href: '/?tab=geoManager&from=home_result_next_action',
                        event: 'geo_manager_cta_click',
                        destination: 'geoManager',
                        target: '/?tab=geoManager',
                        requiredPlan: 'network',
                        featureCode: 'geo_manager_access',
                    },
                    secondary: {
                        label: 'Exporter la zone',
                        href: '#main-zone-export-menu',
                        event: 'export_attempted',
                        destination: 'export',
                        target: '#main-zone-export-menu',
                        featureCode: 'export_csv',
                    },
                };
            }

            if (isPaid) {
                return {
                    profile: 'premium',
                    userStatus: 'paid',
                    quotaReached: false,
                    status: 'Compte payant',
                    title: 'Votre zone est prête pour exploitation.',
                    copy: 'Consultez les communes couvertes et exportez les données disponibles avec votre plan.',
                    primary: {
                        label: 'Exporter les données',
                        href: '#main-zone-export-menu',
                        event: 'export_attempted',
                        destination: 'export',
                        target: '#main-zone-export-menu',
                        featureCode: 'export_csv',
                    },
                    secondary: {
                        label: 'Voir les communes',
                        href: '#exportTableContainer',
                        event: 'public_cta_clicked',
                        destination: 'table',
                        target: '#exportTableContainer',
                    },
                };
            }

            if (limit === 10 && quotaReached) {
                return {
                    profile: 'freemium_limit',
                    userStatus: 'freemium',
                    quotaReached: true,
                    status: '10/10 compte gratuit',
                    title: 'Vous avez atteint la limite du compte gratuit.',
                    copy: 'Le résultat reste consultable. Pour continuer aujourd’hui, testez le Pass découverte si disponible ou passez sur Pro.',
                    viewEvents: ['quota_limit_view', 'locked_action_viewed'],
                    primary: {
                        label: 'Tester 7 jours pour 5 €',
                        href: '/pricing#discovery-pass-offer',
                        event: 'locked_action_clicked',
                        destination: 'pricing',
                        target: '/pricing#discovery-pass-offer',
                        requiredPlan: 'discovery_pass',
                        featureCode: 'daily_calculation_quota',
                    },
                    secondary: {
                        label: 'Voir l’offre Pro',
                        href: '/pricing?feature=unlimited_calculations#pro-plan',
                        event: 'pricing_cta_clicked',
                        destination: 'pricing',
                        target: '/pricing?feature=unlimited_calculations#pro-plan',
                        requiredPlan: 'pro',
                        featureCode: 'daily_calculation_quota',
                    },
                };
            }

            if (limit === 10) {
                const remainingCopy = remaining !== null ? `${remaining} calcul${remaining > 1 ? 's' : ''} gratuit${remaining > 1 ? 's' : ''} restant${remaining > 1 ? 's' : ''} aujourd’hui.` : 'Votre compte gratuit conserve vos analyses.';
                return {
                    profile: 'freemium',
                    userStatus: 'freemium',
                    quotaReached: false,
                    status: 'Compte gratuit',
                    title: 'Votre compte gratuit conserve cette analyse.',
                    copy: `${remainingCopy} Vous pouvez continuer vos tests ou regarder ce que les exports avancés ajoutent.`,
                    primary: {
                        label: 'Continuer avec une adresse',
                        href: '#exportForm',
                        event: 'public_cta_clicked',
                        destination: 'calculation',
                        target: '#exportForm',
                    },
                    secondary: {
                        label: 'Découvrir les exports',
                        href: '/pricing#plan-comparison',
                        event: 'pricing_cta_clicked',
                        destination: 'pricing',
                        target: '/pricing#plan-comparison',
                        requiredPlan: 'etudiant',
                        featureCode: 'export_excel',
                    },
                };
            }

            if (limit === 5 && quotaReached) {
                return {
                    profile: 'anonymous_limit',
                    userStatus: 'anonymous',
                    quotaReached: true,
                    status: '5/5 sans compte',
                    title: 'Vous avez utilisé vos 5 calculs sans compte.',
                    copy: 'Cette zone reste consultable. Créez un compte gratuit pour garder l’analyse et obtenir 5 calculs de plus aujourd’hui.',
                    viewEvents: ['quota_limit_view', 'locked_action_viewed'],
                    primary: {
                        label: 'Créer un compte gratuit',
                        href: '/auth/register?next=/',
                        event: 'signup_start',
                        destination: 'signup',
                        target: '/auth/register?next=/',
                        requiredPlan: 'free_account',
                        featureCode: 'daily_calculation_quota',
                    },
                    secondary: {
                        label: 'Voir ce que je débloque',
                        href: '/pricing?limit_reached=true#feature-unlock-education',
                        event: 'locked_action_clicked',
                        destination: 'pricing',
                        target: '/pricing?limit_reached=true#feature-unlock-education',
                        requiredPlan: 'free_account',
                        featureCode: 'daily_calculation_quota',
                    },
                };
            }

            return {
                profile: 'anonymous',
                userStatus: 'anonymous',
                quotaReached: false,
                status: 'Résultat gratuit',
                title: 'Cette zone montre votre premier périmètre exploitable.',
                copy: 'Consultez la carte et les communes couvertes. Créez un compte gratuit pour garder l’analyse et passer à 10 calculs/jour.',
                primary: {
                    label: 'Sauvegarder gratuitement',
                    href: '/auth/register?next=/',
                    event: 'signup_start',
                    destination: 'signup',
                    target: '/auth/register?next=/',
                    requiredPlan: 'free_account',
                    featureCode: 'analysis_history',
                },
                secondary: {
                    label: 'Voir les communes',
                    href: '#exportTableContainer',
                    event: 'public_cta_clicked',
                    destination: 'table',
                    target: '#exportTableContainer',
                },
            };
        }

        function applyToolBridgeLinkDecision(link, decision, state) {
            if (!link || !decision) return;
            link.textContent = decision.label;
            link.setAttribute('href', decision.href);
            link.dataset.bridgeDestination = decision.destination || '';
            link.setAttribute('data-analytics-event', decision.event || 'public_cta_clicked');
            link.setAttribute('data-analytics-surface', 'home-result-next-action');
            link.setAttribute('data-analytics-label', decision.label);
            link.setAttribute('data-analytics-target', decision.target || decision.href);
            link.setAttribute('data-analytics-user-status', state.userStatus || '');
            if (decision.requiredPlan) {
                link.setAttribute('data-analytics-required-plan', decision.requiredPlan);
            } else {
                link.removeAttribute('data-analytics-required-plan');
            }
            if (decision.featureCode) {
                link.setAttribute('data-analytics-feature-code', decision.featureCode);
            } else {
                link.removeAttribute('data-analytics-feature-code');
            }
            link.setAttribute('data-analytics-state', state.quotaReached ? 'quota_reached' : 'allowed');
        }

        function trackToolBridgeNextActionView(nextAction, state) {
            if (!nextAction || !state) return;
            const viewKey = `${state.profile}:${state.quotaReached ? 'quota' : 'allowed'}`;
            if (nextAction.dataset.trackedView === viewKey) return;
            nextAction.dataset.trackedView = viewKey;
            const viewEvents = Array.isArray(state.viewEvents) ? state.viewEvents : [];
            viewEvents.forEach((eventName) => {
                trackHomeFunnelEvent(eventName, {
                    surface: 'home-result-next-action',
                    feature_code: state.primary?.featureCode || 'result_next_action',
                    required_plan: state.primary?.requiredPlan || '',
                    user_status: state.userStatus || '',
                });
            });
        }

        function applyToolBridgeNextAction(bridge, panelType, context, options = {}, isPaid = false) {
            const nextAction = bridge?.querySelector('[data-tool-bridge-next-action]');
            if (!nextAction || panelType !== 'export') return;
            const state = getToolBridgeAudienceState(panelType, options, isPaid);
            nextAction.dataset.toolBridgeProfile = state.profile;
            const statusEl = nextAction.querySelector('[data-tool-bridge-next-status]');
            const titleEl = nextAction.querySelector('[data-tool-bridge-next-title]');
            const copyEl = nextAction.querySelector('[data-tool-bridge-next-copy]');
            if (statusEl) statusEl.textContent = state.status;
            if (titleEl) titleEl.textContent = state.title;
            if (copyEl) copyEl.textContent = state.copy;
            applyToolBridgeLinkDecision(nextAction.querySelector('[data-tool-bridge-primary-next]'), state.primary, state);
            applyToolBridgeLinkDecision(nextAction.querySelector('[data-tool-bridge-secondary-next]'), state.secondary, state);
            trackToolBridgeNextActionView(nextAction, state);
        }

        function configureToolBridgeAudience(bridge, panelType, options = {}) {
            const isPaid = isPaidToolBridgeUser(options);
            bridge.classList.toggle('is-premium-user', isPaid);
            bridge.dataset.bridgeAudience = isPaid ? 'paid' : 'public-freemium';

            const titleEl = bridge.querySelector('[data-tool-bridge-title]');
            const geoText = bridge.querySelector('[data-bridge-card="geoManager"] [data-bridge-card-text]');
            const geoCta = bridge.querySelector('[data-bridge-card="geoManager"] [data-bridge-card-cta]');
            const geoMeta = bridge.querySelector('[data-bridge-card="geoManager"] [data-bridge-card-meta]');

            if (isPaid) {
                if (titleEl) titleEl.textContent = 'Continuer avec vos outils';
                if (geoText) geoText.textContent = panelType === 'import'
                    ? 'Organisez ces points dans vos dossiers, statuts CRM, zones blanches et exports.'
                    : 'Retrouvez vos zones, points, dossiers, zones blanches et prospects dans Geo Manager.';
                if (geoCta) geoCta.textContent = 'Voir la démo Geo Manager';
                if (geoMeta) geoMeta.textContent = 'Disponible dans vos outils';
            } else {
                if (titleEl) titleEl.textContent = panelType === 'import' ? 'Exploiter vos points' : 'Exploiter cette zone';
                if (geoText) geoText.textContent = panelType === 'import'
                    ? 'Vos points peuvent devenir un réseau : dossiers, statuts CRM, zones blanches et exports.'
                    : 'Organisez plusieurs zones, points, dossiers et prospects SIRENE dans un espace dédié.';
                if (geoCta) geoCta.textContent = 'Voir la démo Geo Manager';
                if (geoMeta) geoMeta.textContent = panelType === 'import' ? 'Idéal après import tableau' : 'Pour réseaux et prospection';
            }

            return isPaid;
        }

        function setToolSnapshotForm(panelType, formData = {}) {
            const mappings = panelType === 'import'
                ? {
                    query: 'importQuery',
                    lat: 'importLatitude',
                    lon: 'importLongitude',
                    mode: 'importTransportMode',
                }
                : {
                    query: 'exportQuery',
                    lat: 'exportLatitude',
                    lon: 'exportLongitude',
                    minutes: 'exportMinutes',
                    mode: 'exportTransportMode',
                };
            Object.entries(mappings).forEach(([key, id]) => {
                const element = document.getElementById(id);
                if (element && formData[key] !== undefined && formData[key] !== null) {
                    element.value = formData[key];
                }
            });
            if (panelType === 'export' && formData.zone_type) {
                const radio = document.querySelector(`input[name="zone_type"][value="${formData.zone_type}"]`);
                if (radio) {
                    radio.checked = true;
                    radio.dispatchEvent(new Event('change', { bubbles: true }));
                }
            }
        }

        function collectToolSnapshotForm(panelType) {
            if (panelType === 'import') {
                return {
                    query: getFieldValue('importQuery'),
                    lat: getFieldValue('importLatitude'),
                    lon: getFieldValue('importLongitude'),
                    mode: getFieldValue('importTransportMode'),
                    zone_type: 'import-table',
                };
            }
            return {
                query: getFieldValue('exportQuery'),
                lat: getFieldValue('exportLatitude'),
                lon: getFieldValue('exportLongitude'),
                minutes: getFieldValue('exportMinutes'),
                mode: getFieldValue('exportTransportMode'),
                zone_type: document.querySelector('input[name="zone_type"]:checked')?.value || 'isochrone',
            };
        }

        function readToolResultSnapshot() {
            try {
                const raw = sessionStorage.getItem(TOOL_RESULT_SNAPSHOT_KEY);
                if (!raw) return null;
                const snapshot = JSON.parse(raw);
                if (!snapshot?.timestamp || Date.now() - Number(snapshot.timestamp) > TOOL_RESULT_SNAPSHOT_TTL_MS) {
                    sessionStorage.removeItem(TOOL_RESULT_SNAPSHOT_KEY);
                    return null;
                }
                return snapshot;
            } catch (error) {
                console.warn('[Tool bridge] snapshot illisible:', error);
                return null;
            }
        }

        function writeToolResultSnapshot(snapshot) {
            const initialWeight = getToolSnapshotWeight(snapshot);
            const snapshotToWrite = (
                initialWeight.totalBytes > TOOL_RESULT_SNAPSHOT_MAX_BYTES ||
                initialWeight.rowsCount > TOOL_RESULT_SNAPSHOT_MAX_ROWS ||
                initialWeight.geojsonBytes > TOOL_RESULT_SNAPSHOT_MAX_GEOJSON_BYTES ||
                initialWeight.unmatchedCount > IMPORT_UNMATCHED_PREVIEW_LIMIT
            )
                ? compactToolResultSnapshot(snapshot, 'write-threshold')
                : snapshot;
            if (snapshotToWrite !== snapshot) {
                trackFrontendPerformanceEvent('frontend_edge_guard_applied', {
                    target: `snapshot-compacted:${initialWeight.rowsCount}:${Math.round(initialWeight.totalBytes / 1024)}kb`,
                });
            }
            try {
                sessionStorage.setItem(TOOL_RESULT_SNAPSHOT_KEY, JSON.stringify(snapshotToWrite));
                return true;
            } catch (error) {
                try {
                    const compact = compactToolResultSnapshot(snapshotToWrite, 'session-storage-quota');
                    compact.rows = [];
                    compact.unmatched = [];
                    if (compact.calculation_data) compact.calculation_data.rows = [];
                    compact.map_geojson = null;
                    if (compact.calculation_data) compact.calculation_data.map_geojson = null;
                    sessionStorage.setItem(TOOL_RESULT_SNAPSHOT_KEY, JSON.stringify(compact));
                    trackFrontendPerformanceEvent('frontend_storage_restore_skipped', {
                        target: 'session-storage-quota',
                    });
                    return true;
                } catch (fallbackError) {
                    console.warn('[Tool bridge] snapshot non sauvegardé:', fallbackError);
                    return false;
                }
            }
        }

        function collectCurrentToolRows(panelType) {
            const controller = panelType === 'import' ? tableControllers.import : tableControllers.export;
            return {
                columns: Array.isArray(controller.columns) ? controller.columns : [],
                rows: Array.isArray(controller.allRows) ? controller.allRows : [],
                isPremium: Boolean(controller.isPremium),
            };
        }

        function saveToolResultSnapshot(panelType, details = {}) {
            const normalizedPanel = panelType === 'import' ? 'import' : 'export';
            const tableState = details.table || collectCurrentToolRows(normalizedPanel);
            const context = details.context || latestToolBridgeContext[normalizedPanel] || buildToolBridgeContext(normalizedPanel);
            const summaryEl = document.getElementById(normalizedPanel === 'import' ? 'importSummary' : 'exportSummary');
            const data = details.data || {};
            const snapshot = {
                version: 2,
                panelType: normalizedPanel,
                timestamp: Date.now(),
                job_id: details.job_id || data.id || data.job_id || null,
                scrollY: typeof details.scrollY === 'number' ? details.scrollY : window.scrollY,
                activePanel: getActivePanelType(),
                form: collectToolSnapshotForm(normalizedPanel),
                summary: summaryEl?.textContent || '',
                bridgeContext: context,
                usage: details.usage || data.usage || null,
                columns: tableState.columns?.length ? tableState.columns : (data.columns || []),
                rows: tableState.rows?.length ? tableState.rows : (data.rows || []),
                unmatched: normalizedPanel === 'import' ? (data.unmatched || []) : [],
                isPremium: hasFeature('demographic_data'),
                map_geojson: details.map_geojson || data.map_geojson || null,
                calculation_data: normalizedPanel === 'export' ? {
                    ...data,
                    columns: data.columns || tableState.columns || [],
                    rows: data.rows || tableState.rows || [],
                    map_geojson: details.map_geojson || data.map_geojson || null,
                } : null,
                zone: details.zone ? {
                    name: details.zone.name,
                    minutes: details.zone.minutes,
                    transportMode: details.zone.transportMode,
                    zoneType: details.zone.zoneType || context.zone_type || 'isochrone',
                    origin: details.zone.origin || null,
                } : null,
                files: {
                    csv: (normalizedPanel === 'import' ? importDownload : exportDownload)?.getAttribute('href') || null,
                    iso: (normalizedPanel === 'import' ? importIsoLink : exportIsoLink)?.getAttribute('href') || null,
                    unmatched: normalizedPanel === 'import'
                        ? unmatchedDownload?.getAttribute('href') || null
                        : null,
                    excelHidden: (normalizedPanel === 'import' ? importExcelLink : exportExcelLink)?.hidden ?? true,
                },
            };
            return writeToolResultSnapshot(snapshot);
        }

        function restoreDownloadLinksFromSnapshot(panelType, snapshot) {
            const csvLink = panelType === 'import' ? importDownload : exportDownload;
            const isoLink = panelType === 'import' ? importIsoLink : exportIsoLink;
            const excelLink = panelType === 'import' ? importExcelLink : exportExcelLink;
            if (csvLink && snapshot.files?.csv) {
                csvLink.href = snapshot.files.csv;
                csvLink.hidden = false;
            }
            if (isoLink && snapshot.files?.iso) {
                isoLink.href = snapshot.files.iso;
                isoLink.hidden = false;
            }
            if (
                panelType === 'import'
                && unmatchedDownload
                && snapshot.files?.unmatched
            ) {
                unmatchedDownload.href = snapshot.files.unmatched;
                unmatchedDownload.hidden = false;
            }
            if (excelLink) excelLink.hidden = Boolean(snapshot.files?.excelHidden);
        }

        async function rehydrateImportSnapshotFromJob(snapshot) {
            if (
                snapshot?.panelType !== 'import'
                || !snapshot?.compacted
                || !snapshot?.job_id
            ) {
                return snapshot;
            }

            const controller = new AbortController();
            const timeout = window.setTimeout(
                () => controller.abort(),
                TOOL_RESULT_REHYDRATION_TIMEOUT_MS
            );
            try {
                const token = getOrCreateToken();
                const response = await fetch(
                    `/jobs/${encodeURIComponent(snapshot.job_id)}`,
                    {
                        signal: controller.signal,
                        headers: token
                            ? { 'X-Maplytics-Usage-Token': token }
                            : {},
                    }
                );
                if (!response.ok) {
                    throw new Error(`HTTP ${response.status}`);
                }
                const job = await response.json();
                if (job.status !== 'done' || job.success === false) {
                    throw new Error('Import terminal indisponible');
                }
                return {
                    ...snapshot,
                    compacted: false,
                    rehydrated: true,
                    usage: job.usage || snapshot.usage,
                    columns: Array.isArray(job.columns) ? job.columns : [],
                    rows: Array.isArray(job.rows) ? job.rows : [],
                    unmatched: Array.isArray(job.unmatched) ? job.unmatched : [],
                    map_geojson: job.map_geojson || null,
                    files: {
                        ...snapshot.files,
                        csv: job.file ? `/download/${job.file}` : snapshot.files?.csv,
                        iso: job.iso_file ? `/download/${job.iso_file}` : snapshot.files?.iso,
                        unmatched: job.unmatched_file
                            ? `/download/${job.unmatched_file}`
                            : snapshot.files?.unmatched,
                    },
                };
            } catch (error) {
                console.warn('[Import] résultat complet non rechargé:', error?.name || 'Error');
                return {
                    ...snapshot,
                    rehydration_failed: true,
                };
            } finally {
                window.clearTimeout(timeout);
            }
        }

        function renderStatsFromSnapshot(panelType, snapshot) {
            const rows = Array.isArray(snapshot.rows) ? snapshot.rows : [];
            const stats = calculateStatistics(rows);
            const statsEl = document.getElementById(panelType === 'import' ? 'importStats' : 'exportStats');
            const statsGridEl = document.getElementById(panelType === 'import' ? 'importStatsGrid' : 'exportStatsGrid');
            const sourceDistEl = document.getElementById(panelType === 'import' ? 'importSourceDistribution' : 'exportSourceDistribution');
            if (statsEl && statsGridEl && sourceDistEl) {
                renderStatistics(
                    statsEl,
                    statsGridEl,
                    sourceDistEl,
                    stats,
                    hasFeature('demographic_data'),
                );
                statsEl.hidden = !stats?.hasData;
            }
        }

        function showDeferredToolRestorePrompt(snapshot, reason = 'snapshot-heavy') {
            if (toolResultRestorePromptShown) return;
            toolResultRestorePromptShown = true;
            const panelType = snapshot?.panelType === 'import' ? 'import' : 'export';
            const summaryEl = document.getElementById(panelType === 'import' ? 'importSummary' : 'exportSummary');
            const target = document.getElementById(panelType === 'import' ? 'importBridgeActions' : 'exportBridgeActions')
                || summaryEl
                || document.getElementById(panelType === 'import' ? 'importPanel' : 'exportPanel');
            if (!target?.parentElement) return;
            const weight = getToolSnapshotWeight(snapshot);
            const text = reason === 'edge-browser'
                ? 'Edge peut ralentir avec les gros résultats. La restauration est volontaire pour garder la page fluide.'
                : `Le dernier résultat est volumineux (${Math.round(weight.totalBytes / 1024)} Ko). Il est disponible sans être rendu automatiquement.`;
            const prompt = createRestorePrompt({
                id: `toolRestorePrompt-${panelType}`,
                title: 'Dernier résultat disponible',
                text,
                actionLabel: 'Restaurer',
                onAction: () => restoreToolResultSnapshot({ force: true, userInitiated: true }),
                onDismiss: () => {
                    toolResultRestorePromptShown = false;
                },
            });
            target.insertAdjacentElement('afterend', prompt);
            trackFrontendPerformanceEvent('frontend_storage_restore_skipped', {
                target: `tool-result:${reason}`,
                surface: `${panelType}-tool`,
            });
        }

        async function restoreToolResultSnapshot(options = {}) {
            if (options.userInitiated) {
                historyManager?.invalidateOpenIntent?.();
            }
            const restoreOpenSequence = historyManager?.openIntentSequence || 0;
            const restoreLeaseIsCurrent = () => (
                (historyManager?.openIntentSequence || 0) === restoreOpenSequence
            );
            if (!options.userInitiated && restoreOpenSequence > 0) return false;
            let snapshot = readToolResultSnapshot();
            if (!snapshot || !snapshot.panelType) return false;
            if (toolResultRestoreInProgress) return false;
            const panelType = snapshot.panelType === 'import' ? 'import' : 'export';
            if (
                !options.userInitiated
                && panelType === 'export'
                && (
                    isHomeWorkspaceScopeReset('zones')
                    || isHomeWorkspaceScopeReset('origin')
                )
            ) {
                return false;
            }
            const controller = panelType === 'import' ? tableControllers.import : tableControllers.export;
            const summaryEl = document.getElementById(panelType === 'import' ? 'importSummary' : 'exportSummary');
            const bridge = document.getElementById(panelType === 'import' ? 'importToolBridge' : 'exportToolBridge');
            const summaryIsDefault = !summaryEl?.textContent || summaryEl.textContent.includes('Aucun calcul lancé');
            const alreadyHasResult = controller.allRows?.length > 0 || !summaryIsDefault;
            const bridgeVisible = Boolean(bridge && !bridge.hidden);
            if (alreadyHasResult && bridgeVisible && !summaryIsDefault && !options.force) {
                return false;
            }
            const restoreGuard = shouldDeferToolSnapshotRestore(snapshot);
            if (!options.force && restoreGuard.defer) {
                showDeferredToolRestorePrompt(snapshot, restoreGuard.reason);
                return false;
            }

            toolResultRestoreInProgress = true;
            try {
                if (
                    panelType === 'import'
                    && options.userInitiated
                    && snapshot.compacted
                ) {
                    snapshot = await rehydrateImportSnapshotFromJob(snapshot);
                }
                if (!restoreLeaseIsCurrent()) {
                    return false;
                }
                await ensurePanelMap(panelType);
                if (!restoreLeaseIsCurrent()) {
                    return false;
                }
                historyManager?.clearOpenedAnalysis?.();
                document.querySelector(`.tab-button[data-target="${panelType === 'import' ? 'importPanel' : 'exportPanel'}"]`)?.click();
                setToolSnapshotForm(panelType, snapshot.form || {});
                if (summaryEl && snapshot.summary) {
                    summaryEl.textContent = snapshot.summary;
                }
                // Appliquer le droit courant avant tout rendu du tableau.
                controller.isPremium = hasFeature('demographic_data');

                if (panelType === 'export') {
                    if (snapshot.calculation_data?.rows?.length && typeof zonesManager !== 'undefined') {
                        const minutes = Number(snapshot.zone?.minutes || snapshot.form?.minutes || snapshot.bridgeContext?.minutes || 15);
                        const restoredZone = zonesManager.zones.size === 0
                            ? zonesManager.addZone(
                                minutes,
                                snapshot.calculation_data,
                                snapshot.map_geojson,
                                snapshot.zone?.transportMode || snapshot.form?.mode,
                                snapshot.form?.zone_type || 'isochrone',
                                {
                                    origin: normalizeZoneOrigin(snapshot.zone?.origin || snapshot.bridgeContext || snapshot.form, null, snapshot.map_geojson, snapshot.zone?.name || ''),
                                }
                            )
                            : null;
                        if (restoredZone && snapshot.map_geojson && exportMapController?.renderGeoJson) {
                            const renderGeneration = zonesManager.savedSnapshotRenderGeneration;
                            runWhenBrowserIdle(() => {
                                if (
                                    !restoreLeaseIsCurrent()
                                    ||
                                    renderGeneration !== zonesManager.savedSnapshotRenderGeneration
                                    || zonesManager.zones.get(restoredZone.id) !== restoredZone
                                ) {
                                    return;
                                }
                                exportMapController.renderGeoJson(snapshot.map_geojson, restoredZone.id, restoredZone.color, restoredZone.name, { restoring: true, animate: false });
                                zonesManager.renderZoneCenter(restoredZone);
                            });
                        }
                        zonesManager.updateTableWithZones?.();
                    } else if (snapshot.columns?.length && snapshot.rows?.length) {
                        _doPopulateTable(exportTable, snapshot.columns, snapshot.rows);
                    }
                    document.getElementById('exportFilters')?.removeAttribute('hidden');
                    updateExportBridgeActions({ usage: snapshot.usage, is_premium: snapshot.isPremium });
                } else {
                    if (snapshot.columns?.length && snapshot.rows?.length) {
                        _doPopulateTable(importTable, snapshot.columns, snapshot.rows);
                    }
                    if (snapshot.map_geojson && importMapController?.renderGeoJson) {
                        runWhenBrowserIdle(() => {
                            if (!restoreLeaseIsCurrent()) return;
                            importMapController.renderGeoJson(snapshot.map_geojson, null, null, null, {
                                restoring: true,
                                animate: false,
                                progressive: true
                            });
                        });
                    }
                    updateUnmatchedList(importUnmatched, snapshot.unmatched || []);
                    document.getElementById('importFilters')?.removeAttribute('hidden');
                }

                renderStatsFromSnapshot(panelType, snapshot);
                restoreDownloadLinksFromSnapshot(panelType, snapshot);
                if (snapshot.bridgeContext) {
                    showToolBridge(panelType, snapshot.bridgeContext, { usage: snapshot.usage, is_premium: snapshot.isPremium });
                }
                requestAnimationFrame(() => {
                    if (!restoreLeaseIsCurrent()) return;
                    window.scrollTo({ top: Number(snapshot.scrollY || 0), behavior: 'auto' });
                });
                const message = snapshot.rehydrated
                    ? 'Le résultat complet de votre import a été rechargé.'
                    : (
                        snapshot.compacted
                            ? 'Le résumé de votre dernier résultat a été restauré. Relancez le calcul si vous avez besoin du tableau complet.'
                            : 'Votre dernier résultat a été restauré.'
                    );
                showAppMessage?.('success', 'Résultat restauré', message);
                window.MaplyticsPublicActions?.track?.('bridge_result_restored', {
                    target: panelType,
                    surface: `${panelType}-tool`,
                });
                setResultsRailStatus(panelType, 'available');
                return true;
            } finally {
                toolResultRestoreInProgress = false;
            }
        }

        function updateExportBridgeActions(options = {}) {
            const actions = document.getElementById('exportBridgeActions');
            if (!actions) return;
            const exportBtn = document.getElementById('exportBridgeExportBtn');
            const downloadLink = document.getElementById('exportDownload');
            const statsBtn = document.getElementById('exportBridgeStatsBtn');
            const hasCsv = Boolean(downloadLink?.href && !downloadLink.hidden);

            actions.hidden = false;
            if (exportBtn) {
                exportBtn.disabled = !hasCsv;
                exportBtn.textContent = hasCsv ? 'Exporter CSV' : 'CSV bientôt prêt';
            }
            if (statsBtn) {
                statsBtn.disabled = false;
            }
        }

        function hideToolBridge(panelType) {
            const bridge = document.getElementById(panelType === 'import' ? 'importToolBridge' : 'exportToolBridge');
            if (bridge) bridge.hidden = true;
            if (panelType === 'export') {
                const actions = document.getElementById('exportBridgeActions');
                if (actions) actions.hidden = true;
            }
        }

        function showToolBridge(panelType, context, options = {}) {
            const bridge = document.getElementById(panelType === 'import' ? 'importToolBridge' : 'exportToolBridge');
            if (!bridge) return;
            latestToolBridgeContext[panelType] = context;
            const isPaid = configureToolBridgeAudience(bridge, panelType, options);
            const summaryEl = bridge.querySelector('[data-tool-bridge-summary]');
            if (summaryEl) {
                summaryEl.textContent = summarizeToolBridgeContext(context);
            }
            applyToolBridgeRecommendation(bridge, panelType, context, isPaid);
            applyToolBridgeNextAction(bridge, panelType, context, options, isPaid);
            if (panelType === 'export') {
                updateExportBridgeActions({ ...options, is_premium: isPaid });
            }
            bridge.hidden = false;
            revealToolBridgeAfterResult(panelType, bridge, options);
            window.MaplyticsPublicActions?.track?.('bridge_preview_expanded', {
                target: panelType,
                surface: `${panelType}-tool`,
            });
        }

        document.getElementById('exportBridgeExportBtn')?.addEventListener('click', () => {
            const downloadLink = document.getElementById('exportDownload');
            if (downloadLink?.href && !downloadLink.hidden) {
                downloadLink.click();
            }
        });

        document.getElementById('exportBridgeStatsBtn')?.addEventListener('click', () => {
            const statsEl = document.getElementById('exportStats');
            const statsContent = document.getElementById('exportStatsContent');
            const statsToggleText = document.getElementById('exportStatsToggleText');
            if (!statsEl) return;
            statsEl.hidden = false;
            statsContent?.classList.add('expanded');
            if (statsToggleText) statsToggleText.textContent = 'Masquer';
            if (isProgrammaticScrollAllowed('user-stats-click')) {
                statsEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }
        });

        document.addEventListener('click', (event) => {
            const action = event.target.closest?.('[data-tool-bridge-action]');
            if (!action) return;
            const bridge = action.closest('[data-tool-bridge]');
            const panelType = bridge?.dataset?.toolBridge || getActivePanelType();
            const context = latestToolBridgeContext[panelType] || buildToolBridgeContext(panelType);
            const destination = action.dataset.bridgeDestination || 'unknown';
            if (bridge?.dataset?.bridgeRecommendedDestination === destination) {
                window.MaplyticsPublicActions?.track?.('bridge_recommended_clicked', {
                    target: action.getAttribute('href') || destination,
                    surface: `${panelType}-tool`,
                });
            }
            saveToolResultSnapshot(panelType, {
                context,
                scrollY: window.scrollY,
            });
            persistToolBridgeContext({
                ...context,
                destination,
                timestamp: new Date().toISOString(),
            });
        }, true);

        const handleGridPaste = (event, cell) => {
            event.preventDefault();
            const text = (event.clipboardData || window.clipboardData).getData('text');
            if (!text) return;
            const rows = text.replace(/\r\n?/g, '\n').split('\n');
            while (rows.length && rows[rows.length - 1] === '') rows.pop();
            if (!rows.length) return;

            const existingRows = Array.from(importGridBody.children);
            let startIndex = existingRows.indexOf(cell.parentElement);
            if (startIndex < 0) startIndex = 0;
            const startColumnIndex = Array.from(cell.parentElement.cells)
                .indexOf(cell);

            rows.forEach((rowText, rowOffset) => {
                const values = rowText.split(/\t|;/);
                const targetIndex = startIndex + rowOffset;
                while (importGridBody.children.length <= targetIndex) {
                    addEditableRow();
                }
                const targetRow = importGridBody.children[targetIndex];
                values.forEach((value, colIdx) => {
                    const targetCell = targetRow.cells[startColumnIndex + colIdx];
                    if (targetCell) {
                        targetCell.textContent = value.trim();
                    }
                });
            });
            importGridBody.dispatchEvent(new Event('input', { bubbles: true }));
        };

        const addEditableRow = () => {
            const row = document.createElement('tr');
            row.innerHTML = '<td contenteditable="true"></td><td contenteditable="true"></td><td contenteditable="true"></td>';
            Array.from(row.cells).forEach((cell) => {
                cell.addEventListener('paste', (event) => handleGridPaste(event, cell));
            });
            importGridBody.appendChild(row);
            return row;
        };

        const attachGridHandlers = () => {
            Array.from(importGridBody.querySelectorAll('td')).forEach((cell) => {
                cell.addEventListener('paste', (event) => handleGridPaste(event, cell));
            });
        };

        attachGridHandlers();

        const exportProgress = {
            panelType: 'export',
            container: document.getElementById('exportProgress'),
            bar: document.getElementById('exportProgressBar'),
            label: document.getElementById('exportProgressLabel'),
        };
        const importProgress = {
            panelType: 'import',
            container: document.getElementById('importProgress'),
            bar: document.getElementById('importProgressBar'),
            label: document.getElementById('importProgressLabel'),
        };

        const RESULTS_RAIL_STATES = {
            empty: { icon: '○', label: 'Aucun résultat' },
            progress: { icon: '…', label: 'Calcul en cours' },
            available: { icon: '✓', label: 'Résultat disponible' },
            update: { icon: 'N', label: 'Nouveau résultat disponible' },
            review: { icon: '!', label: 'Validation de l’import à revoir' },
        };

        const setResultsRailStatus = (panelType, state = 'empty', label = '') => {
            const resolvedPanelType = panelType === 'import' ? 'import' : 'export';
            const panelId = resolvedPanelType === 'import' ? 'importPanel' : 'exportPanel';
            const panel = document.getElementById(panelId);
            const indicator = panel?.querySelector('[data-results-rail-indicator]');
            const status = document.getElementById(`${resolvedPanelType}ResultsRailStatus`);
            const contract = RESULTS_RAIL_STATES[state] || RESULTS_RAIL_STATES.empty;
            const resolvedState = RESULTS_RAIL_STATES[state] ? state : 'empty';
            const resolvedLabel = label || contract.label;
            if (indicator) {
                if (indicator.dataset.state !== resolvedState) {
                    indicator.dataset.state = resolvedState;
                }
                const icon = indicator.querySelector('[data-results-rail-icon]');
                if (icon && icon.textContent !== contract.icon) {
                    icon.textContent = contract.icon;
                }
            }
            if (status && status.textContent !== resolvedLabel) {
                status.textContent = resolvedLabel;
            }
            const resultsPanel = panel?.querySelector('.results-panel');
            if (resultsPanel && resultsPanel.dataset.resultsState !== resolvedState) {
                resultsPanel.dataset.resultsState = resolvedState;
            }
        };
        window.setResultsRailStatus = setResultsRailStatus;

        const panelHasAvailableResults = (panelType) => {
            const resolvedPanelType = panelType === 'import' ? 'import' : 'export';
            const controller = tableControllers?.[resolvedPanelType];
            if (Array.isArray(controller?.allRows) && controller.allRows.length > 0) {
                return true;
            }
            if (resolvedPanelType === 'export' && zonesManager?.zones?.size > 0) {
                return true;
            }
            const table = document.getElementById(
                resolvedPanelType === 'import' ? 'importTableContainer' : 'exportTableContainer',
            );
            const bridge = document.getElementById(
                resolvedPanelType === 'import' ? 'importToolBridge' : 'exportToolBridge',
            );
            const download = document.getElementById(
                resolvedPanelType === 'import' ? 'importDownload' : 'exportDownload',
            );
            return Boolean(
                (table && !table.hidden)
                || (bridge && !bridge.hidden)
                || (download && !download.hidden && download.getAttribute('href'))
            );
        };

        const syncResultsRailAvailability = (panelType) => {
            setResultsRailStatus(
                panelType,
                panelHasAvailableResults(panelType) ? 'available' : 'empty',
            );
        };

        const updateProgress = (controller, percent = 0, message = '') => {
            if (!controller || !controller.container || !controller.bar || !controller.label) return;
            controller.container.hidden = false;
            const pct = Math.min(1, Math.max(0, percent || 0));
            const pctRounded = Math.round(pct * 100);
            controller.bar.style.width = `${pctRounded}%`;

            // Améliorer l'affichage du message avec plus de détails
            let displayMessage = message || '';
            if (displayMessage) {
                // Extraire le dernier log pour afficher l'étape actuelle
                const logs = displayMessage.split('\n').filter(l => l.trim());
                const lastLog = logs[logs.length - 1] || displayMessage;
                // Limiter la longueur du message
                if (lastLog.length > 50) {
                    displayMessage = lastLog.substring(0, 47) + '...';
                } else {
                    displayMessage = lastLog;
                }
            }

            controller.label.textContent = `${pctRounded}%${displayMessage ? ' · ' + displayMessage : ''}`;
            controller.container.setAttribute('role', 'progressbar');
            controller.container.setAttribute('aria-label', controller.panelType === 'import'
                ? 'Progression de l’import'
                : 'Progression du calcul');
            controller.container.setAttribute('aria-valuemin', '0');
            controller.container.setAttribute('aria-valuemax', '100');
            controller.container.setAttribute('aria-valuenow', String(pctRounded));
            controller.container.setAttribute(
                'aria-valuetext',
                `${pctRounded}%${displayMessage ? ` · ${displayMessage}` : ''}`,
            );
            // Animation de la barre de progression
            controller.bar.style.transition = 'width 0.3s ease-out';
            setResultsRailStatus(controller.panelType, 'progress');
        };

        const hideProgress = (controller) => {
            if (!controller || !controller.container || !controller.bar || !controller.label) return;
            controller.container.hidden = true;
            controller.bar.style.width = '0%';
            controller.label.textContent = '0%';
            controller.container.setAttribute('aria-valuenow', '0');
            controller.container.setAttribute('aria-valuetext', '0%');
            const panelId = controller.panelType === 'import' ? 'importPanel' : 'exportPanel';
            const indicator = document.querySelector(
                `#${panelId} [data-results-rail-indicator]`,
            );
            if (indicator?.dataset.state === 'progress') {
                syncResultsRailAvailability(controller.panelType);
            }
        };

        window.updateResultsPanelProgress = (panelType, percent = 0, message = '') => {
            updateProgress(panelType === 'import' ? importProgress : exportProgress, percent, message);
        };
        window.hideResultsPanelProgress = (panelType) => {
            hideProgress(panelType === 'import' ? importProgress : exportProgress);
        };

        const getResultsState = (layoutGrid) => {
            if (!layoutGrid) return 'open';
            if (layoutGrid.classList.contains('results-rail')) return 'rail';
            if (layoutGrid.classList.contains('results-expanded')) return 'expanded';
            return 'open';
        };

        const invalidatePanelMap = (panelType, delay = 260) => {
            afterMapLayout(() => {
                const controller = panelType === 'import'
                    ? importMapController
                    : exportMapController;
                if (mapHasUsableViewport(controller?.map)) {
                    controller.map.invalidateSize({ animate: false });
                }
            }, delay);
        };

        const setResultsPanelState = (panelType, state = 'open', options = {}) => {
            const panelId = panelType === 'export' ? 'exportPanel' : 'importPanel';
            const panel = document.getElementById(panelId);
            if (!panel) return;

            const layoutGrid = panel.querySelector('.layout-grid');
            const resultsPanel = panel.querySelector('.results-panel');
            const btn = panel.querySelector('.toggle-panel-btn');
            const expandBtn = panel.querySelector('.expand-panel-btn');
            if (!layoutGrid || !resultsPanel || !btn) return;

            const nextState = ['rail', 'open', 'expanded'].includes(state) ? state : 'open';
            layoutGrid.classList.remove('results-rail', 'results-open', 'results-expanded');
            resultsPanel.classList.remove('results-rail', 'results-open', 'results-expanded');
            layoutGrid.classList.add(`results-${nextState}`);
            resultsPanel.classList.add(`results-${nextState}`);

            if (nextState !== 'rail') {
                resultsPanel.classList.remove('results-has-update');
                if (resultsPanel.dataset.resultsState === 'update') {
                    setResultsRailStatus(panelType, 'available');
                }
            }

            const labels = {
                rail: { icon: '‹', text: 'Ouvrir', title: 'Ouvrir les résultats', expanded: 'false' },
                open: { icon: '›', text: 'Réduire', title: 'Réduire les résultats en rail', expanded: 'true' },
                expanded: { icon: '›', text: 'Réduire', title: 'Réduire les résultats en rail', expanded: 'true' },
            };
            const label = labels[nextState];
            if (!btn.querySelector('.toggle-panel-icon') || !btn.querySelector('.toggle-panel-label')) {
                btn.innerHTML = '<span class="toggle-panel-icon" aria-hidden="true"></span><span class="toggle-panel-label"></span>';
            }
            const iconElement = btn.querySelector('.toggle-panel-icon');
            const labelElement = btn.querySelector('.toggle-panel-label');
            if (iconElement && labelElement) {
                iconElement.textContent = label.icon;
                labelElement.textContent = label.text;
            } else {
                btn.textContent = label.icon;
            }
            btn.setAttribute('aria-expanded', label.expanded);
            btn.setAttribute('title', label.title);
            btn.setAttribute('aria-label', label.title);
            if (expandBtn) {
                const isExpanded = nextState === 'expanded';
                const expandTitle = isExpanded ? 'Réduire la largeur des résultats' : 'Agrandir les résultats';
                expandBtn.textContent = isExpanded ? '↙' : '⤢';
                expandBtn.setAttribute('aria-pressed', String(isExpanded));
                expandBtn.setAttribute('title', expandTitle);
                expandBtn.setAttribute('aria-label', expandTitle);
            }
            if (options.persist) {
                window.persistAppShellPanelPreference?.(panelType, 'results', nextState);
            }
            invalidatePanelMap(panelType);
        };
        window.setResultsPanelState = setResultsPanelState;

        const revealResultsPanel = (panelType) => {
            const panelId = panelType === 'export' ? 'exportPanel' : 'importPanel';
            const layoutGrid = document.querySelector(`#${panelId} .layout-grid`);
            if (!layoutGrid || getResultsState(layoutGrid) !== 'rail') return;
            setResultsPanelState(panelType, 'open');
        };
        window.revealResultsPanel = revealResultsPanel;

        const markResultsPanelHasUpdate = (panelType) => {
            if (!APP_CONFIG.appShellV2 || !panelType) return;
            const panelId = panelType === 'export' ? 'exportPanel' : 'importPanel';
            const panel = document.getElementById(panelId);
            const layoutGrid = panel ? panel.querySelector('.layout-grid') : null;
            const resultsPanel = panel ? panel.querySelector('.results-panel') : null;
            if (!layoutGrid || !resultsPanel) return;
            setResultsRailStatus(panelType, 'update');
            if (isAppShellSmallScreen() && !resultsPanel.classList.contains('app-v2-sheet-open')) {
                resultsPanel.classList.add('results-has-update');
                document.querySelectorAll('.app-mobile-dock [data-mobile-jump="results"], .app-mobile-dock [data-mobile-jump="zones"]').forEach((button) => {
                    button.classList.add('has-update');
                });
                updateMobilePanelTray();
                return;
            }
            if (layoutGrid.classList.contains('results-rail')) {
                resultsPanel.classList.add('results-has-update');
            }
            updateMobilePanelTray();
        };

        const initResultsPanelStates = () => {
            if (!APP_CONFIG.appShellV2) return;
            ['export', 'import'].forEach((panelType) => {
                const panelId = panelType === 'export' ? 'exportPanel' : 'importPanel';
                const panel = document.getElementById(panelId);
                const layoutGrid = panel ? panel.querySelector('.layout-grid') : null;
                if (!layoutGrid) return;
                const initialState = window.getAppShellPanelPreference?.(
                    panelType,
                    'results',
                    'rail',
                ) || 'rail';
                setResultsPanelState(panelType, initialState);
            });
        };

        // Fonction toggle panel (V2: rail/ouvert/agrandi, legacy: masquer/afficher)
        function togglePanel(panelType) {
            const panelId = panelType === 'export' ? 'exportPanel' : 'importPanel';
            const panel = document.getElementById(panelId);
            if (!panel) return;

            const layoutGrid = panel.querySelector('.layout-grid');
            const btn = panel.querySelector('.toggle-panel-btn');
            if (!layoutGrid || !btn) return;

            if (APP_CONFIG.appShellV2) {
                if (isAppShellSmallScreen()) {
                    setAppShellV2ResultsSheet('map');
                    return;
                }
                const currentState = getResultsState(layoutGrid);
                const nextState = currentState === 'rail' ? 'open' : 'rail';
                setResultsPanelState(panelType, nextState, { persist: true });
                return;
            }

            layoutGrid.classList.toggle('panel-hidden');

            if (layoutGrid.classList.contains('panel-hidden')) {
                btn.textContent = '▶';
            } else {
                btn.textContent = '◀';
            }

            // Redimensionner uniquement la carte effectivement visible après l'animation.
            const controller = panelType === 'import'
                ? importMapController
                : exportMapController;
            invalidateMapControllerWhenVisible(controller, 300);
        }

        function toggleResultsExpansion(panelType) {
            if (!APP_CONFIG.appShellV2) return;
            const panelId = panelType === 'export' ? 'exportPanel' : 'importPanel';
            const panel = document.getElementById(panelId);
            const layoutGrid = panel ? panel.querySelector('.layout-grid') : null;
            if (!layoutGrid) return;
            const currentState = getResultsState(layoutGrid);
            setResultsPanelState(
                panelType,
                currentState === 'expanded' ? 'open' : 'expanded',
                { persist: true },
            );
        }

        function toggleToolPanel(panelType) {
            if (!APP_CONFIG.appShellV2) return;
            const panelId = panelType === 'export' ? 'exportPanel' : 'importPanel';
            const panel = document.getElementById(panelId);
            const layoutGrid = panel ? panel.querySelector('.layout-grid') : null;
            if (!layoutGrid) return;
            if (isAppShellSmallScreen()) {
                const toolManager = panel.querySelector('.tool-manager');
                setAppShellV2ResultsSheet(toolManager && toolManager.classList.contains('app-v2-sheet-open') ? 'map' : 'config');
                return;
            }
            window.setToolPanelState(
                panelType,
                layoutGrid.classList.contains('tool-rail') ? 'open' : 'rail',
                { persist: true },
            );
        }

        const initToolPanelStates = () => {
            if (!APP_CONFIG.appShellV2) return;
            const viewportMode = typeof getAppShellViewportMode === 'function'
                ? getAppShellViewportMode()
                : 'desktop';
            ['export', 'import'].forEach((panelType) => {
                const fallback = viewportMode === 'compact' ? 'rail' : 'open';
                const initialState = window.getAppShellPanelPreference?.(
                    panelType,
                    'tool',
                    fallback,
                ) || fallback;
                window.setToolPanelState(panelType, initialState, { persist: false });
            });
        };

        initToolPanelStates();
        initResultsPanelStates();

        // Initialiser les cartes après que le DOM soit chargé
        let exportMapController, importMapController;
        let leafletMapLoadPromise = null;
        let geoManagerV2LoadPromise = null;
        let importWorkspaceLoadPromise = null;
        const GEO_MANAGER_ASSET_VERSION = APP_CONFIG.geoManagerV2Version || '20260611-competitor-modal';
        const GEO_MANAGER_LOAD_TIMEOUT_MS = 15000;

        function withTimeout(promise, timeoutMs, message) {
            let timeoutId = null;
            const timeout = new Promise((_, reject) => {
                timeoutId = window.setTimeout(() => {
                    const error = new Error(message);
                    error.code = 'geo_manager_load_timeout';
                    reject(error);
                }, timeoutMs);
            });
            return Promise.race([promise, timeout]).finally(() => window.clearTimeout(timeoutId));
        }

        function markGeoManagerLoadError(message) {
            const panel = document.querySelector('[data-geo-manager-v2]');
            panel?.classList.remove('is-loading');
            const backend = panel?.querySelector?.('[data-geo-backend]');
            if (backend) {
                backend.textContent = 'Erreur chargement';
                backend.dataset.state = 'error';
            }
            const retry = () => {
                geoManagerV2LoadPromise = null;
                ensureGeoManagerV2Loaded({ force: true })
                    .then((geoManager) => geoManager?.reload?.())
                    .catch(() => null);
            };
            if (window.MaplyticsNotice?.show) {
                window.MaplyticsNotice.show({
                    type: 'error',
                    title: 'Géo Manager',
                    message,
                    persistent: true,
                    actions: [{ label: 'Réessayer', onClick: retry }],
                });
            } else if (window.MaplyticsNotice?.error) {
                window.MaplyticsNotice.error(message, { title: 'Géo Manager' });
            }
        }

        async function ensureLeafletForMaps(options = {}) {
            if (typeof L !== 'undefined') {
                window.leafletLoaded = true;
                return L;
            }
            if (!leafletMapLoadPromise) {
                leafletMapLoadPromise = window.MaplyticsLazyAssets
                    ?.ensureLeaflet(options)
                    .catch((error) => {
                        leafletMapLoadPromise = null;
                        throw error;
                    });
            }
            return leafletMapLoadPromise;
        }

        async function ensureGeoManagerV2Loaded(options = {}) {
            if (!APP_CONFIG.geoManagerV2) return null;
            if (!options.force && window.GeoManagerV2?.reload) {
                return window.GeoManagerV2;
            }
            if (options.force) {
                geoManagerV2LoadPromise = null;
            }
            if (!geoManagerV2LoadPromise) {
                const loader = window.MaplyticsLazyAssets?.ensureGeoManagerV2;
                if (typeof loader !== 'function') {
                    markGeoManagerLoadError('Le chargeur Géo Manager n’est pas disponible. Rechargez la page puis réessayez.');
                    return Promise.reject(new Error('Chargeur Géo Manager indisponible.'));
                }
                geoManagerV2LoadPromise = withTimeout(
                    loader(GEO_MANAGER_ASSET_VERSION),
                    GEO_MANAGER_LOAD_TIMEOUT_MS,
                    'Le Géo Manager met trop longtemps à charger. Réessayez dans quelques instants.'
                )
                    .then((geoManager) => {
                        const resolved = geoManager || window.GeoManagerV2;
                        if (!resolved?.reload) {
                            throw new Error('Module Géo Manager chargé mais non initialisé.');
                        }
                        return resolved;
                    })
                    .catch((error) => {
                        geoManagerV2LoadPromise = null;
                        console.error('Géo Manager V2 n’a pas pu être chargé:', error);
                        markGeoManagerLoadError(error.message || 'Géo Manager indisponible pour le moment. Réessayez dans quelques instants.');
                        throw error;
                    });
            }
            return geoManagerV2LoadPromise;
        }

        function ensureImportWorkspaceLoaded() {
            if (communeImportReview && importJourney) {
                return Promise.resolve({ communeImportReview, importJourney });
            }
            if (!importWorkspaceLoadPromise) {
                const loader = window.MaplyticsLazyAssets?.loadScript;
                if (typeof loader !== 'function') {
                    return Promise.reject(new Error('Chargeur de ressources Import indisponible.'));
                }
                importWorkspaceLoadPromise = Promise.all([
                    loader(
                        '/static/js/home/commune-import-review.js?v=20260827-startup-perf',
                        { id: 'commune-import-review-js', async: false },
                    ),
                    loader(
                        '/static/js/home/import-journey.js?v=20260827-startup-perf',
                        { id: 'import-journey-js', async: false },
                    ),
                ])
                    .then(() => initializeImportWorkspaceControllers())
                    .catch((error) => {
                        importWorkspaceLoadPromise = null;
                        throw error;
                    });
            }
            return importWorkspaceLoadPromise;
        }

        async function initMaps(panelType = 'all', read = null) {
            if (read && !await read.canApply()) return;
            await ensureLeafletForMaps({ heat: true });
            if (read && !await read.canApply()) return;

            if ((panelType === 'all' || panelType === 'export') && !exportMapController && document.getElementById('exportMap')) {
                const mapElement = document.getElementById('exportMap');
                // Vérifier que l'élément est visible ou au moins dans le DOM
                if (mapElement) {
                    try {
                        exportMapController = createMapController({
                            mapId: 'exportMap',
                            latInputId: 'exportLatitude',
                            lonInputId: 'exportLongitude',
                            queryInputId: 'exportQuery',
                            searchBtnId: 'exportSearchBtn',
                            badgeId: 'exportBadge',
                        });
                        if (exportMapController && exportMapController.map) {
                            mapRegistry.exportPanel = exportMapController;
                            (window.debugLog || (() => {}))('Carte exportMap initialisée');
                            window.maplyticsRefreshCompetitorMapAfterInit?.('export');
                            // Attendre une mise en page réelle et ne jamais invalider une carte masquée.
                            afterMapLayout(() => {
                                if (mapHasUsableViewport(exportMapController?.map)) {
                                    exportMapController.map.invalidateSize({ animate: false });
                                }
                                // Re-afficher les zones déjà chargées depuis localStorage
                                // (fix race condition: zones chargées avant init carte)
                                if (typeof zonesManager !== 'undefined' && zonesManager.renderAllZonesOnMap) {
                                    zonesManager.renderAllZonesOnMap();
                                }
                                window.maplyticsRefreshCompetitorMapAfterInit?.('export');
                            });
                        } else {
                            console.error('❌ Échec de l\'initialisation de exportMapController');
                        }
                    } catch (error) {
                        console.error('Erreur lors de l\'initialisation de exportMap:', error);
                    }
                }
            }

            if ((panelType === 'all' || panelType === 'import') && !importMapController && document.getElementById('importMap')) {
                const mapElement = document.getElementById('importMap');
                if (mapElement) {
                    try {
                        importMapController = createMapController({
                            mapId: 'importMap',
                            latInputId: 'importLatitude',
                            lonInputId: 'importLongitude',
                            queryInputId: 'importQuery',
                            searchBtnId: 'importSearchBtn',
                            badgeId: 'importBadge',
                        });
                        if (importMapController && importMapController.map) {
                            mapRegistry.importPanel = importMapController;
                            (window.debugLog || (() => {}))('Carte importMap initialisée');
                            syncImportDetailedExportChoices();
                            window.maplyticsRefreshCompetitorMapAfterInit?.('import');
                            // Attendre une mise en page réelle et ne jamais invalider une carte masquée.
                            afterMapLayout(() => {
                                if (mapHasUsableViewport(importMapController?.map)) {
                                    importMapController.map.invalidateSize({ animate: false });
                                }
                                window.maplyticsRefreshCompetitorMapAfterInit?.('import');
                            });
                        } else {
                            console.error('❌ Échec de l\'initialisation de importMapController');
                        }
                    } catch (error) {
                        console.error('Erreur lors de l\'initialisation de importMap:', error);
                    }
                }
            }
        }

        async function ensurePanelMap(panelType = 'export') {
            const read = homeNavigationReads.begin();
            try {
                await initMaps(panelType, read);
            } catch (error) {
                if (!await read.canApply()) return;
                console.error(`Erreur chargement carte ${panelType}:`, error);
                if (window.MaplyticsNotice?.warning) {
                    window.MaplyticsNotice.warning('La carte met plus de temps à charger. Vos calculs restent disponibles.');
                }
            } finally {
                read.end();
            }
        }

        function installLazyMapTriggers() {
            [
                ['export', 'exportPanel', 'exportForm', 'exportMap'],
                ['import', 'importPanel', 'importForm', 'importMap'],
            ].forEach(([panelType, panelId, formId, mapId]) => {
                const panel = document.getElementById(panelId);
                const form = document.getElementById(formId);
                const map = document.getElementById(mapId);
                const load = () => {
                    ensurePanelMap(panelType);
                    window.MaplyticsLazyAssets?.ensureChartJs?.();
                };

                panel?.querySelectorAll('input, select, textarea, button').forEach((element) => {
                    element.addEventListener('focus', load, { once: true, passive: true });
                });
                form?.addEventListener('submit', load, { capture: true });
                map?.addEventListener('click', load, { once: true });
            });
        }

        installLazyMapTriggers();

        if (window.MaplyticsAddressOriginController?.create) {
            importAddressOriginController = window.MaplyticsAddressOriginController.create({
                input: document.getElementById('importQuery'),
                latInput: document.getElementById('importLatitude'),
                lonInput: document.getElementById('importLongitude'),
                suggestions: document.getElementById('importAddressSuggestions'),
                status: document.getElementById('importAddressStatus'),
                searchButton: document.getElementById('importSearchBtn'),
                replaceButton: document.getElementById('importReplacePointBtn'),
                suggestionIdPrefix: 'importAddress',
                ensureMap: () => ensurePanelMap('import'),
                getMapController: () => importMapController,
                onSelected: ({suggestion}) => {
                    trackHomeFunnelEvent('address_selected', {
                        source: suggestion?.source || 'unknown',
                        surface: 'home-import-address',
                        target: 'home-import-address',
                    });
                },
            });
        }

        // Charger uniquement le cockpit actif au démarrage pour éviter les bascules visuelles et les assets inutiles.
        toolPanelController.scheduleInitialLoad();

        function getV2MapController(panelType) {
            return panelType === 'import' ? importMapController : exportMapController;
        }

        function bindV2MapTools() {
            if (!APP_CONFIG.appShellV2) return;
            [
                ['exportFitBoundsBtn', 'export', 'fit'],
                ['exportFullscreenBtn', 'export', 'fullscreen'],
                ['importFitBoundsBtn', 'import', 'fit'],
                ['importFullscreenBtn', 'import', 'fullscreen'],
            ].forEach(([buttonId, panelType, action]) => {
                const button = document.getElementById(buttonId);
                if (!button || button.dataset.bound === '1') return;
                button.dataset.bound = '1';
                button.addEventListener('click', () => {
                    const controller = getV2MapController(panelType);
                    if (!controller) return;
                    if (action === 'fit') {
                        controller.updateMapBounds?.(true);
                    } else if (action === 'fullscreen') {
                        controller.toggleFullscreen?.();
                    }
                });
            });
        }

        bindV2MapTools();

        function showDeferredZonesRestorePrompt(zonesData, reason = 'zones-heavy') {
            if (zonesStorageRestorePromptShown) return;
            zonesStorageRestorePromptShown = true;
            const zonesCount = Array.isArray(zonesData?.zones) ? zonesData.zones.length : 0;
            const summaryEl = document.getElementById('exportSummary');
            const target = document.getElementById('exportBridgeActions') || summaryEl || document.getElementById('exportPanel');
            if (!target?.parentElement) return;
            const prompt = createRestorePrompt({
                id: 'zonesStorageRestorePrompt',
                title: 'Zones sauvegardées disponibles',
                text: `${zonesCount || 'Plusieurs'} zone(s) sont sauvegardées. Elles ne sont pas rendues automatiquement pour éviter un ralentissement du navigateur.`,
                actionLabel: 'Afficher les zones',
                onAction: () => zonesManager.loadZonesFromLocalStorage({ force: true, userInitiated: true }),
                onDismiss: () => {
                    zonesStorageRestorePromptShown = false;
                },
            });
            target.insertAdjacentElement('afterend', prompt);
            trackFrontendPerformanceEvent('frontend_storage_restore_skipped', {
                target: `saved-zones:${reason}`,
                surface: 'export-tool',
            });
        }

        function showLegacyZonesRecoveryPrompt() {
            if (
                !HOME_BROWSER_STORAGE?.hasRecoverableLegacyZones?.()
                || homeZonesStorage.getItem(HOME_ZONE_STORAGE_KEY)
            ) {
                return false;
            }
            const target = document.getElementById('exportBridgeActions')
                || document.getElementById('exportSummary')
                || document.getElementById('exportPanel');
            if (!target?.parentElement) return false;
            const prompt = createRestorePrompt({
                id: 'legacyZonesRecoveryPrompt',
                title: 'Anciennes zones locales disponibles',
                text: 'Une sauvegarde créée avant la séparation des comptes est conservée sur ce navigateur. Récupérez-la uniquement si elle vous appartient.',
                actionLabel: 'Récupérer sur ce compte',
                onAction: () => {
                    const result = HOME_BROWSER_STORAGE.claimLatestLegacyZones?.();
                    if (!result?.ok) {
                        showAppMessage(
                            'error',
                            'Récupération indisponible',
                            'La sauvegarde historique est restée intacte. Rechargez la page puis réessayez.',
                        );
                        return false;
                    }
                    return zonesManager.loadZonesFromLocalStorage({
                        force: true,
                        userInitiated: true,
                    });
                },
            });
            target.insertAdjacentElement('afterend', prompt);
            return true;
        }

        function normalizeZoneHexColor(value, fallback = '#2563eb') {
            return /^#[0-9a-fA-F]{6}$/.test(String(value || '').trim())
                ? String(value).trim()
                : fallback;
        }

        function normalizeOriginMarkerStyle(value = null) {
            return window.MaplyticsOriginMarkerStyle?.normalize?.(value || {}) || {
                color: '#1f6feb',
                size: 'normal',
                symbol: 'dot',
            };
        }

        function parseCoordinate(value) {
            if (value === null || value === undefined) return null;
            if (typeof value === 'string' && !value.trim()) return null;
            const parsed = Number(value);
            return Number.isFinite(parsed) ? parsed : null;
        }

        function normalizeZoneMetadataText(value, maximum) {
            const normalized = String(value ?? '').trim().replace(/\s+/g, ' ');
            if (!normalized || normalized.length > maximum) return null;
            return normalized;
        }

        function zoneOriginAddress(zone) {
            return String(zone?.origin?.label || '').trim().replace(/\s+/g, ' ').slice(0, 500);
        }

        function zonePointName(zone) {
            return String(zone?.origin?.display_name || zoneOriginAddress(zone)
                || 'Point sans adresse enregistrée').trim().replace(/\s+/g, ' ').slice(0, 160);
        }

        function normalizeZoneOrigin(rawOrigin = null, fallbackOrigin = null, geojson = null, zoneName = '') {
            const candidates = [rawOrigin, fallbackOrigin].filter(Boolean);
            const displayName = candidates
                .map((candidate) => String(candidate?.display_name || '').trim().replace(/\s+/g, ' '))
                .find(Boolean) || '';
            for (const candidate of candidates) {
                const lat = parseCoordinate(candidate.lat ?? candidate.latitude);
                const lon = parseCoordinate(candidate.lon ?? candidate.lng ?? candidate.longitude);
                if (lat !== null && lon !== null) {
                    const originResolution = candidate.origin_resolution
                        && typeof candidate.origin_resolution === 'object'
                        ? candidate.origin_resolution
                        : null;
                    return {
                        lat,
                        lon,
                        label: candidate.label || candidate.query || candidate.address || zoneName || 'Centre de zone',
                        display_name: displayName,
                        source: candidate.source || 'saved_origin',
                        approximate: Boolean(candidate.approximate),
                        ...(originResolution ? {
                            origin_resolution: originResolution,
                            requested_origin: originResolution.requested_origin || null,
                            effective_origin: originResolution.effective_origin || null,
                        } : {}),
                    };
                }
            }
            const approximate = getGeoJsonApproximateCenter(geojson);
            if (approximate) {
                return {
                    ...approximate,
                    label: zoneName || 'Centre approximatif',
                    display_name: displayName,
                    source: 'geometry_centroid',
                    approximate: true,
                };
            }
            return null;
        }

        function originResolutionFromResult(data = {}, lifecycle = {}) {
            const accepted = lifecycle?.accepted?.origin_resolution;
            const zoneContext = data?.map_geojson?.maplytics_zone_context;
            const territoryContext = data?.map_geojson?.maplytics_territory_context;
            return accepted
                || zoneContext?.origin_resolution
                || territoryContext?.origin_resolution
                || null;
        }

        function originWithResolution(origin, resolution) {
            if (!origin || !resolution || typeof resolution !== 'object') return origin;
            const requested = resolution.requested_origin;
            const lat = parseCoordinate(requested?.lat);
            const lon = parseCoordinate(requested?.lng ?? requested?.lon);
            return {
                ...origin,
                ...(lat !== null && lon !== null ? {lat, lon} : {}),
                origin_resolution: resolution,
                requested_origin: resolution.requested_origin || null,
                effective_origin: resolution.effective_origin || null,
                approximate: false,
            };
        }

        function announceOriginResolution(resolution) {
            const status = String(resolution?.status || '');
            const distance = Number(resolution?.distance_m);
            if (!Number.isFinite(distance) || distance <= 0.5) return;
            const rounded = Math.max(1, Math.round(distance));
            const confirmed = status === 'confirmation_required';
            window.MaplyticsNotice?.info?.(
                `Le point métier est conservé. Le départ du calcul a été ${confirmed ? 'confirmé' : 'ajusté'} à ${rounded} m sur une voie accessible.`,
                {title: 'Départ routier ajusté', duration: 9000},
            );
        }

        function getGeoJsonApproximateCenter(geojson) {
            const coordinates = [];
            const collect = (value) => {
                if (!Array.isArray(value)) return;
                if (typeof value[0] === 'number' && typeof value[1] === 'number') {
                    const lon = Number(value[0]);
                    const lat = Number(value[1]);
                    if (Number.isFinite(lat) && Number.isFinite(lon)) {
                        coordinates.push([lat, lon]);
                    }
                    return;
                }
                value.forEach(collect);
            };
            const features = Array.isArray(geojson?.features) ? geojson.features : [];
            features.forEach((feature) => collect(feature?.geometry?.coordinates));
            if (!coordinates.length) return null;
            const bounds = coordinates.reduce((acc, [lat, lon]) => ({
                minLat: Math.min(acc.minLat, lat),
                maxLat: Math.max(acc.maxLat, lat),
                minLon: Math.min(acc.minLon, lon),
                maxLon: Math.max(acc.maxLon, lon),
            }), {
                minLat: Infinity,
                maxLat: -Infinity,
                minLon: Infinity,
                maxLon: -Infinity,
            });
            if (!Number.isFinite(bounds.minLat) || !Number.isFinite(bounds.minLon)) return null;
            return {
                lat: (bounds.minLat + bounds.maxLat) / 2,
                lon: (bounds.minLon + bounds.maxLon) / 2,
            };
        }

        let exportZonePresentationController = null;
        let zonePresentationSyncQueued = false;
        let homeWorkspaceResetTransactionActive = false;
        let homeZoneMutationVersion = 0;
        const emitHomeZoneMutation = (reason = 'zones-changed') => {
            const buildScopes = window.MaplyticsCompetitorSearch?.buildZoneScopeDefinitions;
            const makeFingerprint = window.MaplyticsCompetitorSearch?.fingerprint;
            const scopes = typeof buildScopes === 'function'
                ? buildScopes(Array.from(zonesManager?.zones?.values?.() || []))
                : [];
            const scopeFingerprints = Object.fromEntries(scopes.map((scope) => [
                scope.value,
                scope.fingerprint,
            ]));
            const fingerprint = typeof makeFingerprint === 'function'
                ? makeFingerprint({
                    schema_version: 'home_zone_mutation_v1',
                    scopes: Object.entries(scopeFingerprints),
                })
                : '';
            homeZoneMutationVersion += 1;
            document.dispatchEvent(new CustomEvent('maplytics:zones-mutated', {
                detail: {
                    schema_version: 'home_zone_mutation_v1',
                    version: homeZoneMutationVersion,
                    reason: String(reason || 'zones-changed'),
                    fingerprint,
                    zone_ids: Array.from(zonesManager?.zones?.keys?.() || []).map(String),
                    scope_fingerprints: scopeFingerprints,
                    territoryContext: window.MaplyticsCompetitorTerritory?.fromZoneScopes(scopes) || null,
                },
            }));
        };
        const scheduleZonePresentationSync = (reason = 'zones-changed') => {
            if (homeWorkspaceResetTransactionActive) return;
            emitHomeZoneMutation(reason);
            if (!exportZonePresentationController || zonePresentationSyncQueued) return;
            zonePresentationSyncQueued = true;
            queueMicrotask(() => {
                zonePresentationSyncQueued = false;
                exportZonePresentationController?.syncSource?.(reason);
            });
        };

        // Gestionnaire de zones multiples
        const zonesManager = {
            zones: new Map(), // zoneId -> { id, name, minutes, color, data, geojson }
            nextZoneId: 1,
            colors: ['#2563eb', '#7c3aed', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6', '#06b6d4', '#ec4899'],
            colorIndex: 0,
            editingZoneId: null,
            editFormSnapshot: null,
            pendingCreationRequest: null,
            hierarchyController: null,
            savedSnapshotRenderGeneration: 0,
            workspaceLoadGeneration: 0,
            metadataRenamePending: false,

            getNextColor() {
                const color = this.colors[this.colorIndex % this.colors.length];
                this.colorIndex++;
                return color;
            },

            normalizeColor(color) {
                return normalizeZoneHexColor(color, this.getNextColor());
            },

            resolveTransportMode(zone, fallback = 'driving-car') {
                const allowedModes = new Set([
                    'driving-car',
                    'driving-hgv',
                    'cycling-regular',
                    'foot-walking',
                ]);
                const candidate = zone?.transportMode
                    || zone?.transport_mode
                    || zone?.data?.transport_mode
                    || zone?.data?.metadata?.transport_mode
                    || fallback;
                return allowedModes.has(candidate) ? candidate : 'driving-car';
            },

            captureCurrentOrigin(source = 'calculation') {
                const label = document.getElementById('exportQuery')?.value || '';
                const lat = parseCoordinate(document.getElementById('exportLatitude')?.value);
                const lon = parseCoordinate(document.getElementById('exportLongitude')?.value);
                if (lat === null || lon === null) return null;
                return {
                    lat,
                    lon,
                    label,
                    source,
                    approximate: false,
                };
            },

            serializeZone(zone) {
                const {
                    metadataAnalysisId: _metadataAnalysisId,
                    ...serializableZone
                } = zone || {};
                return {
                    ...serializableZone,
                    id: zone.id,
                    name: zone.name,
                    minutes: zone.minutes,
                    color: normalizeZoneHexColor(zone.color, this.colors[0]),
                    data: zone.data,
                    geojson: zone.geojson,
                    transportMode: this.resolveTransportMode(zone),
                    zoneType: zone.zoneType || 'isochrone',
                    origin: zone.origin || null,
                    originStyle: normalizeOriginMarkerStyle(zone.originStyle),
                };
            },

            normalizeSavedZone(zoneData, fallback = {}) {
                const zoneId = zoneData.id || `zone_${this.nextZoneId}`;
                const name = zoneData.name || `${zoneData.minutes || fallback.minutes || 15} min`;
                const color = normalizeZoneHexColor(zoneData.color, this.colors[this.zones.size % this.colors.length]);
                const origin = normalizeZoneOrigin(
                    zoneData.origin,
                    fallback.origin,
                    zoneData.geojson,
                    name
                );
                const numericId = /^zone_(\d+)$/.exec(String(zoneId));
                if (numericId) {
                    this.nextZoneId = Math.max(this.nextZoneId, Number(numericId[1]) + 1);
                } else {
                    this.nextZoneId += 1;
                }
                return {
                    ...zoneData,
                    id: zoneId,
                    name,
                    minutes: zoneData.minutes || fallback.minutes || 15,
                    color,
                    data: zoneData.data,
                    geojson: zoneData.geojson,
                    transportMode: this.resolveTransportMode(
                        zoneData,
                        fallback.transportMode || 'driving-car',
                    ),
                    zoneType: zoneData.zoneType || zoneData.zone_type || fallback.zoneType || 'isochrone',
                    origin,
                    originStyle: normalizeOriginMarkerStyle(zoneData.originStyle),
                };
            },

            prepareSavedZonesSnapshot(zonesConfig) {
                const snapshotApi = window.MaplyticsSavedZoneSnapshot;
                if (!snapshotApi?.prepare) {
                    const error = new Error('Le préparateur de sauvegardes de zones est indisponible.');
                    error.code = 'saved_zone_snapshot_unavailable';
                    throw error;
                }
                const prepared = snapshotApi.prepare(zonesConfig);
                const fallbackOrigin = prepared.zones.length === 1
                    ? prepared.config.metadata?.origin
                    : null;
                const fallbackTransportMode = prepared.config.metadata?.transport_mode
                    || 'driving-car';
                let nextZoneId = 1;
                const zones = new Map();
                prepared.zones.forEach((entry) => {
                    const zoneData = entry.source;
                    const name = zoneData.name
                        || `${zoneData.minutes ?? 15} min`;
                    let origin = null;
                    if (entry.hasExplicitOrigin) {
                        origin = zoneData.origin === null
                            ? null
                            : normalizeZoneOrigin(
                                zoneData.origin,
                                fallbackOrigin,
                                zoneData.geojson,
                                name,
                            );
                    } else {
                        origin = normalizeZoneOrigin(
                            null,
                            fallbackOrigin,
                            zoneData.geojson,
                            name,
                        );
                    }
                    const numericId = /^zone_(\d+)$/.exec(String(entry.viewId));
                    nextZoneId = numericId
                        ? Math.max(nextZoneId, Number(numericId[1]) + 1)
                        : nextZoneId;
                    zones.set(entry.viewId, {
                        ...zoneData,
                        id: entry.viewId,
                        name,
                        minutes: zoneData.minutes ?? 15,
                        color: normalizeZoneHexColor(
                            zoneData.color,
                            this.colors[entry.sourceIndex % this.colors.length],
                        ),
                        data: zoneData.data,
                        geojson: zoneData.geojson,
                        transportMode: this.resolveTransportMode(
                            zoneData,
                            fallbackTransportMode,
                        ),
                        zoneType: zoneData.zoneType || zoneData.zone_type || 'isochrone',
                        origin,
                        originStyle: normalizeOriginMarkerStyle(zoneData.originStyle),
                    });
                });
                const originStyles = new Map();
                zones.forEach((zone) => {
                    const pointKey = window.MaplyticsHomeZoneHierarchy?.pointIdentity?.(zone)
                        || String(zone.id || 'point');
                    const sharedStyle = originStyles.get(pointKey)
                        || normalizeOriginMarkerStyle(zone.originStyle);
                    originStyles.set(pointKey, sharedStyle);
                    zone.originStyle = sharedStyle;
                });
                return Object.freeze({
                    rawConfig: prepared.config,
                    zones,
                    nextZoneId,
                    colorIndex: zones.size % this.colors.length,
                });
            },

            captureSavedZonesViewState() {
                const controller = tableControllers.export;
                const map = exportMapController?.map;
                const center = map?.getCenter?.();
                const layerState = new Map();
                exportMapController?.zonesLayers?.forEach((value, zoneId) => {
                    layerState.set(String(zoneId), {
                        visible: value?.visible !== false,
                        opacity: Number.isFinite(Number(value?.opacity))
                            ? Number(value.opacity)
                            : 1,
                    });
                });
                const fieldValue = (id) => document.getElementById(id)?.value ?? '';
                const hidden = (id) => Boolean(document.getElementById(id)?.hidden);
                const statsZoneSelect = document.getElementById('statsZoneSelect');
                const filterValues = getFilterValues('export');
                return {
                    zones: new Map(this.zones),
                    nextZoneId: this.nextZoneId,
                    colorIndex: this.colorIndex,
                    editingZoneId: this.editingZoneId,
                    editFormSnapshot: this.editFormSnapshot,
                    hierarchyState: this.hierarchyController?.captureState?.() || null,
                    editingAttribute: exportForm?.getAttribute('data-editing-zone-id') || null,
                    fields: {
                        transportMode: fieldValue('exportTransportMode'),
                        query: fieldValue('exportQuery'),
                        latitude: fieldValue('exportLatitude'),
                        longitude: fieldValue('exportLongitude'),
                        addressStatusText: exportAddressStatus?.textContent || '',
                        addressStatusClassName: exportAddressStatus?.className || '',
                        addressAriaInvalid: exportQueryInput?.getAttribute('aria-invalid'),
                        selectedAddress: exportQueryInput?.dataset.selectedAddress || null,
                        submitDisabled: Boolean(exportSubmitButton?.disabled),
                        submitAriaDisabled: exportSubmitButton?.getAttribute('aria-disabled'),
                    },
                    map: center ? {
                        center: [center.lat, center.lng],
                        zoom: map.getZoom(),
                        layers: layerState,
                    } : null,
                    table: {
                        allRows: Array.isArray(controller?.allRows) ? controller.allRows : [],
                        filteredRows: Array.isArray(controller?.filteredRows)
                            ? controller.filteredRows
                            : [],
                        columns: Array.isArray(controller?.columns) ? controller.columns : [],
                        currentPage: controller?.currentPage || 1,
                        activeFilters: controller?.activeFilters || null,
                        sortState: controller?.sortState ? { ...controller.sortState } : null,
                        searchValue: controller?.searchInput?.value || '',
                        containerHidden: Boolean(controller?.container?.hidden),
                        searchHidden: Boolean(controller?.search?.hidden),
                        actionsHidden: Boolean(controller?.actions?.hidden),
                        statsHidden: hidden('exportStats'),
                        filtersHidden: hidden('exportFilters'),
                        filterValues: {
                            ...filterValues,
                            zones: Array.isArray(filterValues.zones)
                                ? [...filterValues.zones]
                                : [],
                        },
                        statsZoneSelection: statsZoneSelect
                            ? Array.from(statsZoneSelect.selectedOptions).map(
                                (option) => option.value,
                            )
                            : [],
                    },
                    resetDisplay: document.getElementById('resetZonesBtn')?.style.display || '',
                };
            },

            removeRenderedSavedZones() {
                this.savedSnapshotRenderGeneration += 1;
                const renderedIds = Array.from(exportMapController?.zonesLayers?.keys?.() || []);
                renderedIds.forEach((zoneId) => exportMapController.removeZone(zoneId));
                exportMapController?.clearZoneCenterMarkers?.();
            },

            applySavedZonesMetadata(zonesConfig) {
                const metadata = zonesConfig?.metadata && typeof zonesConfig.metadata === 'object'
                    ? zonesConfig.metadata
                    : {};
                const transportMode = this.resolveTransportMode(
                    { transportMode: metadata.transport_mode },
                    'driving-car',
                );
                const transportSelect = document.getElementById('exportTransportMode');
                if (transportSelect) transportSelect.value = transportMode;

                const origin = metadata.origin && typeof metadata.origin === 'object'
                    ? metadata.origin
                    : null;
                const queryInput = document.getElementById('exportQuery');
                if (queryInput) queryInput.value = String(origin?.query || origin?.label || '');
                if (exportQueryInput) delete exportQueryInput.dataset.selectedAddress;
                const latInput = document.getElementById('exportLatitude');
                const lonInput = document.getElementById('exportLongitude');
                if (latInput) latInput.value = '';
                if (lonInput) lonInput.value = '';
                const savedCoordinate = (value) => (
                    value === null
                    || value === undefined
                    || String(value).trim() === ''
                        ? null
                        : parseCoordinate(value)
                );
                const lat = savedCoordinate(origin?.lat ?? origin?.latitude);
                const lon = savedCoordinate(origin?.lon ?? origin?.lng ?? origin?.longitude);
                if (lat !== null && lon !== null) {
                    if (exportQueryInput && queryInput?.value) {
                        exportQueryInput.dataset.selectedAddress = queryInput.value;
                    }
                    if (latInput) latInput.value = String(lat);
                    if (lonInput) lonInput.value = String(lon);
                    exportMapController?.setMarker?.(lat, lon, {
                        source: 'restore',
                        statusMessage: 'Point défini',
                    });
                    exportMapController?.map?.setView?.([lat, lon], 13, { animate: false });
                    return;
                }
                exportMapController?.clearMarker?.();
                setExportAddressStatus('pending', 'Adresse à valider');
                syncExportAddressSubmitState();
            },

            renderPreparedSavedZones(prepared, options = {}) {
                this.removeRenderedSavedZones();
                this.zones = new Map(prepared.zones);
                this.nextZoneId = prepared.nextZoneId;
                this.colorIndex = prepared.colorIndex;
                this.editingZoneId = null;
                this.editFormSnapshot = null;
                exportForm?.removeAttribute('data-editing-zone-id');

                this.zones.forEach((zone, zoneId) => {
                    if (!zone.geojson || !exportMapController) return;
                    exportMapController.renderGeoJson(
                        zone.geojson,
                        zoneId,
                        zone.color,
                        zone.name,
                        {
                            restoring: true,
                            animate: false,
                            deferBounds: true,
                            visible: this.hierarchyController?.isZoneVisible?.(zoneId) !== false,
                        },
                    );
                    this.renderZoneCenter(zone);
                });
                exportMapController?.updateMapBounds?.(false);
                exportMapController?.updateMapLegendMultiZones?.();
                this.applySavedZonesMetadata(prepared.rawConfig);
                if (Array.isArray(options.resetPresentationEntries)) {
                    this.forgetPresentationEntries(options.resetPresentationEntries);
                }
                this.renderZonesList();
                this.updateTabVisibility();
                this.updateSaveButtonVisibility();
                resetFilters('export');
                this._doUpdateTableWithZones({ synchronous: true });
                this.updateZoneFilter();
                this.renderAllZoneCenters();
                if (typeof statsManager !== 'undefined' && statsManager?.updateZonesSelect) {
                    statsManager.updateZonesSelect();
                }
                exportMapController?.updateKpiBadge?.(this.zones);
                this.updateExportSummary();
                const resetBtn = document.getElementById('resetZonesBtn');
                if (resetBtn) resetBtn.style.display = this.zones.size ? 'inline-block' : 'none';
                if (options.syncPresentation !== false) {
                    scheduleZonePresentationSync('saved-analysis-opened');
                }
            },

            restoreSavedZonesViewState(snapshot, options = {}) {
                if (snapshot.hierarchyState) {
                    this.hierarchyController?.restoreState?.(snapshot.hierarchyState);
                }
                const prepared = {
                    rawConfig: {
                        zones: Array.from(snapshot.zones.values()),
                        metadata: {
                            origin: {
                                query: snapshot.fields.query,
                                lat: snapshot.fields.latitude,
                                lon: snapshot.fields.longitude,
                            },
                            transport_mode: snapshot.fields.transportMode,
                        },
                    },
                    zones: snapshot.zones,
                    nextZoneId: snapshot.nextZoneId,
                    colorIndex: snapshot.colorIndex,
                };
                this.renderPreparedSavedZones(prepared, {
                    syncPresentation: options.syncPresentation,
                });
                if (exportAddressStatus) {
                    exportAddressStatus.textContent = snapshot.fields.addressStatusText;
                    exportAddressStatus.className = snapshot.fields.addressStatusClassName;
                }
                if (exportQueryInput) {
                    if (snapshot.fields.selectedAddress === null) {
                        delete exportQueryInput.dataset.selectedAddress;
                    } else {
                        exportQueryInput.dataset.selectedAddress = snapshot.fields.selectedAddress;
                    }
                    if (snapshot.fields.addressAriaInvalid === null) {
                        exportQueryInput.removeAttribute('aria-invalid');
                    } else {
                        exportQueryInput.setAttribute(
                            'aria-invalid',
                            snapshot.fields.addressAriaInvalid,
                        );
                    }
                }
                if (exportSubmitButton) {
                    exportSubmitButton.disabled = snapshot.fields.submitDisabled;
                    if (snapshot.fields.submitAriaDisabled === null) {
                        exportSubmitButton.removeAttribute('aria-disabled');
                    } else {
                        exportSubmitButton.setAttribute(
                            'aria-disabled',
                            snapshot.fields.submitAriaDisabled,
                        );
                    }
                }
                this.editingZoneId = snapshot.editingZoneId;
                this.editFormSnapshot = snapshot.editFormSnapshot;
                if (snapshot.editingAttribute) {
                    exportForm?.setAttribute('data-editing-zone-id', snapshot.editingAttribute);
                } else {
                    exportForm?.removeAttribute('data-editing-zone-id');
                }
                const controller = tableControllers.export;
                if (controller) {
                    controller.allRows = snapshot.table.allRows;
                    controller.filteredRows = snapshot.table.filteredRows;
                    controller.columns = snapshot.table.columns;
                    controller.currentPage = snapshot.table.currentPage;
                    controller.activeFilters = snapshot.table.activeFilters;
                    controller.sortState = snapshot.table.sortState;
                    if (controller.searchInput) {
                        controller.searchInput.value = snapshot.table.searchValue;
                    }
                    const filters = snapshot.table.filterValues || {};
                    const setValue = (id, value) => {
                        const element = document.getElementById(id);
                        if (element) element.value = value ?? '';
                    };
                    const setChecked = (id, checked) => {
                        const element = document.getElementById(id);
                        if (element) element.checked = Boolean(checked);
                    };
                    setValue('exportFilterTimeMin', filters.timeMin);
                    setValue('exportFilterTimeMax', filters.timeMax);
                    setValue('exportFilterDistMin', filters.distMin);
                    setValue('exportFilterDistMax', filters.distMax);
                    setValue('exportFilterPostal', filters.postal);
                    setValue('exportFilterCommune', filters.commune);
                    setChecked('exportFilterSourceDirections', filters.sourceDirections);
                    setChecked('exportFilterSourceMatrix', filters.sourceMatrix);
                    setChecked('exportFilterSourceUnavailable', filters.sourceUnavailable);
                    const zoneFilter = document.getElementById('exportFilterZone');
                    if (zoneFilter) {
                        const selected = new Set(filters.zones || []);
                        Array.from(zoneFilter.options).forEach((option) => {
                            option.selected = selected.has(option.value);
                        });
                    }
                    if (snapshot.table.columns.length) {
                        renderTablePage(controller, snapshot.table.columns);
                        updateTableInfo(controller);
                    }
                    if (typeof controller.updateStats === 'function') {
                        controller.updateStats(calculateStatistics(controller.filteredRows));
                    }
                    controller.container.hidden = snapshot.table.containerHidden;
                    controller.search.hidden = snapshot.table.searchHidden;
                    controller.actions.hidden = snapshot.table.actionsHidden;
                }
                const statsElement = document.getElementById('exportStats');
                const filtersElement = document.getElementById('exportFilters');
                if (statsElement) statsElement.hidden = snapshot.table.statsHidden;
                if (filtersElement) filtersElement.hidden = snapshot.table.filtersHidden;
                const statsZoneSelect = document.getElementById('statsZoneSelect');
                if (statsZoneSelect) {
                    const selected = new Set(snapshot.table.statsZoneSelection || []);
                    Array.from(statsZoneSelect.options).forEach((option) => {
                        option.selected = selected.has(option.value);
                    });
                }
                const resetBtn = document.getElementById('resetZonesBtn');
                if (resetBtn) resetBtn.style.display = snapshot.resetDisplay;
                if (snapshot.map && exportMapController?.map) {
                    snapshot.map.layers.forEach((layer, zoneId) => {
                        exportMapController.updateZoneOpacity?.(zoneId, layer.opacity);
                        exportMapController.setZoneVisibility?.(zoneId, layer.visible);
                        const opacityPercent = String(Math.round(layer.opacity * 100));
                        const opacityInput = document.getElementById(`opacity_${zoneId}`);
                        const opacityOutput = document.getElementById(`opacityValue_${zoneId}`);
                        if (opacityInput) opacityInput.value = opacityPercent;
                        if (opacityOutput) opacityOutput.textContent = `${opacityPercent}%`;
                    });
                    exportMapController.map.setView(
                        snapshot.map.center,
                        snapshot.map.zoom,
                        { animate: false },
                    );
                }
            },

            replaceZonesFromSavedSnapshot(prepared, options = {}) {
                const previous = this.captureSavedZonesViewState();
                try {
                    const resetPresentationEntries = options.resetPresentation
                        ? [
                            ...previous.zones.entries(),
                            ...prepared.zones.entries(),
                        ]
                        : null;
                    this.renderPreparedSavedZones(prepared, {
                        resetPresentationEntries,
                        syncPresentation: options.syncPresentation,
                    });
                    syncResultsRailAvailability('export');
                    return previous;
                } catch (error) {
                    try {
                        this.restoreSavedZonesViewState(previous, {
                            syncPresentation: false,
                        });
                    } catch (rollbackError) {
                        console.error('Rollback restauration zones incomplet:', rollbackError);
                    }
                    throw error;
                }
            },

            setInteractionLocked(locked) {
                const zonesList = document.getElementById('zonesList');
                if (zonesList) zonesList.inert = Boolean(locked);
                document.querySelectorAll(
                    '#zonesList [data-zone-control], #homeZoneEditDialog [data-zone-edit-submit]'
                ).forEach((control) => {
                    control.disabled = Boolean(locked)
                        || control.dataset.zoneIntrinsicDisabled === 'true';
                });
            },

            captureEditFormSnapshot() {
                const zoneType = document.querySelector('input[name="zone_type"]:checked')?.value || 'isochrone';
                return {
                    zoneType,
                    transportMode: exportTransportModeSelect?.value || 'driving-car',
                    value: exportMinutesInput?.value || '15',
                    query: exportQueryInput?.value || '',
                    latitude: exportLatitudeInput?.value || '',
                    longitude: exportLongitudeInput?.value || '',
                    addressStatusText: exportAddressStatus?.textContent || '',
                    addressStatusClassName: exportAddressStatus?.className || '',
                };
            },

            restoreEditFormSnapshot() {
                const snapshot = this.editFormSnapshot;
                this.editFormSnapshot = null;
                if (!snapshot) return false;
                const zoneTypeInput = document.querySelector(
                    `input[name="zone_type"][value="${snapshot.zoneType}"]`
                );
                if (zoneTypeInput) {
                    zoneTypeInput.checked = true;
                    zoneTypeInput.dispatchEvent(new Event('change', { bubbles: true }));
                }
                if (exportTransportModeSelect) {
                    exportTransportModeSelect.value = snapshot.transportMode;
                    exportTransportModeSelect.dispatchEvent(new Event('change', { bubbles: true }));
                }
                if (exportMinutesInput) {
                    exportMinutesInput.value = snapshot.value;
                    exportMinutesInput.dispatchEvent(new Event('input', { bubbles: true }));
                }
                if (exportQueryInput) exportQueryInput.value = snapshot.query;
                if (exportLatitudeInput) exportLatitudeInput.value = snapshot.latitude;
                if (exportLongitudeInput) exportLongitudeInput.value = snapshot.longitude;
                if (exportAddressStatus) {
                    exportAddressStatus.textContent = snapshot.addressStatusText;
                    exportAddressStatus.className = snapshot.addressStatusClassName;
                }
                syncExportAddressSubmitState();
                return true;
            },

            handleEditDialogCancelled(zoneId) {
                this.editingZoneId = null;
                this.editFormSnapshot = null;
                exportForm?.removeAttribute('data-editing-zone-id');
                this.renderZonesList();
                return Boolean(zoneId);
            },

            cancelEdit({ announce = false, restoreForm = false } = {}) {
                const zoneId = this.editingZoneId;
                if (!zoneId) return false;
                if (restoreForm) this.restoreEditFormSnapshot();
                else this.editFormSnapshot = null;
                this.editingZoneId = null;
                exportForm?.removeAttribute('data-editing-zone-id');
                this.renderZonesList();
                homeZoneEditController?.focusTrigger(zoneId);
                if (announce) {
                    showAppMessage(
                        'info',
                        'Modification annulée',
                        'La zone existante est restée inchangée.',
                    );
                }
                return true;
            },

            getTransportOptionAccess() {
                return Array.from(exportTransportModeSelect?.options || []).reduce((access, option) => {
                    access[option.value] = !option.disabled;
                    return access;
                }, {});
            },

            getCreationPoints() {
                const pointsByKey = new Map();
                const register = (origin, fallbackLabel = 'Point enregistré') => {
                    const normalized = normalizeZoneOrigin(origin, null, null, fallbackLabel);
                    if (!normalized) return;
                    const key = `${Number(normalized.lat).toFixed(6)},${Number(normalized.lon).toFixed(6)}`;
                    if (pointsByKey.has(key)) return;
                    pointsByKey.set(key, {
                        key,
                        lat: Number(normalized.lat),
                        lon: Number(normalized.lon),
                        label: normalized.label || fallbackLabel,
                        source: normalized.source || 'saved-zone',
                    });
                };
                register(this.captureCurrentOrigin('current-form'), 'Point actuel');
                this.zones.forEach((zone) => {
                    register(zone.origin, `Point de ${zone.name}`);
                });
                return Array.from(pointsByKey.values());
            },

            getZoneUniquenessKey(origin, transportMode, value) {
                const normalized = normalizeZoneOrigin(origin, null, null, 'Point');
                if (!normalized) return '';
                return [
                    Number(normalized.lat).toFixed(6),
                    Number(normalized.lon).toFixed(6),
                    transportMode || 'driving-car',
                    Number.parseInt(value, 10),
                ].join('|');
            },

            hasZoneFor(origin, transportMode, value) {
                const expected = this.getZoneUniquenessKey(origin, transportMode, value);
                if (!expected) return false;
                return Array.from(this.zones.values()).some((zone) => (
                    this.getZoneUniquenessKey(zone.origin, this.resolveTransportMode(zone), zone.minutes) === expected
                ));
            },

            consumeCreationRequest() {
                const request = this.pendingCreationRequest;
                this.pendingCreationRequest = null;
                return request;
            },

            runCreationThreshold(context) {
                if (this.pendingCreationRequest || exportCalculationInProgress) {
                    return Promise.reject(new Error('Un calcul est déjà en cours.'));
                }
                const point = normalizeZoneOrigin(context.point, null, null, 'Point sélectionné');
                const canonicalOption = exportTransportModeSelect?.querySelector(
                    `option[value="${context.transportMode}"]`
                );
                if (!point) return Promise.reject(new Error('Le point sélectionné est invalide.'));
                if (!canonicalOption || canonicalOption.disabled) {
                    return Promise.reject(new Error('Ce transport n’est pas disponible avec votre offre.'));
                }
                if (this.hasZoneFor(point, context.transportMode, context.value)) {
                    const error = new Error('Cette zone existe déjà pour ce point, ce transport et cette valeur.');
                    error.code = 'duplicate_zone';
                    return Promise.reject(error);
                }
                const zoneTypeInput = document.querySelector(
                    `input[name="zone_type"][value="${context.zoneType}"]`
                );
                if (zoneTypeInput) {
                    zoneTypeInput.checked = true;
                    zoneTypeInput.dispatchEvent(new Event('change', { bubbles: true }));
                }
                exportTransportModeSelect.value = context.transportMode;
                exportTransportModeSelect.dispatchEvent(new Event('change', { bubbles: true }));
                exportMinutesInput.value = String(context.value);
                exportMinutesInput.dispatchEvent(new Event('input', { bubbles: true }));
                exportQueryInput.value = point.label || 'Point sélectionné';
                exportQueryInput.dataset.selectedAddress = exportQueryInput.value;
                exportLatitudeInput.value = String(point.lat);
                exportLongitudeInput.value = String(point.lon);
                setExportAddressStatus('ready', 'Point défini');
                syncExportAddressSubmitState();

                return new Promise((resolve, reject) => {
                    this.pendingCreationRequest = { context: { ...context, point }, resolve, reject };
                    exportForm.requestSubmit();
                });
            },

            async createZonesFromDialog(payload, hooks = {}) {
                const thresholds = Array.isArray(payload?.thresholds) ? payload.thresholds : [];
                const results = [];
                const seen = new Set();
                for (const threshold of thresholds) {
                    const key = this.getZoneUniquenessKey(
                        payload.point,
                        payload.transportMode,
                        threshold.value,
                    );
                    if (!key || seen.has(key) || this.hasZoneFor(payload.point, payload.transportMode, threshold.value)) {
                        const message = 'Cette zone existe déjà pour ce point, ce transport et cette valeur.';
                        hooks.onStatus?.(threshold.id, 'error', message);
                        results.push({ id: threshold.id, ok: false, code: 'duplicate_zone', message });
                        continue;
                    }
                    seen.add(key);
                    if (this.zones.size >= 6) {
                        const message = 'La limite de six zones affichées est atteinte.';
                        hooks.onStatus?.(threshold.id, 'error', message);
                        results.push({ id: threshold.id, ok: false, code: 'zone_limit', message });
                        continue;
                    }
                    hooks.onStatus?.(threshold.id, 'running', 'Calcul en cours…');
                    const defaultName = payload.zoneType === 'isodistance'
                        ? `${threshold.value} km`
                        : `${threshold.value} min`;
                    const customName = String(payload.name || '').trim();
                    const zoneName = customName
                        ? (payload.multiple ? `${customName} — ${defaultName}` : customName)
                        : defaultName;
                    try {
                        const calculation = await this.runCreationThreshold({
                            point: payload.point,
                            zoneType: payload.zoneType,
                            transportMode: payload.transportMode,
                            value: threshold.value,
                            color: threshold.color,
                            folder: payload.folder,
                            name: zoneName,
                            thresholdId: threshold.id,
                            batchId: payload.batchId,
                            batchOrder: threshold.order,
                        });
                        const message = `Zone ${zoneName} créée`;
                        hooks.onStatus?.(threshold.id, 'success', message);
                        results.push({ id: threshold.id, ok: true, message, zoneId: calculation.zone?.id });
                    } catch (error) {
                        const message = error?.message || 'Le calcul de ce seuil a échoué.';
                        hooks.onStatus?.(threshold.id, 'error', message);
                        results.push({ id: threshold.id, ok: false, code: error?.code || 'calculation_failed', message });
                    }
                }
                return results;
            },

            openCreateDialog(trigger) {
                if (exportCalculationInProgress) {
                    showAppMessage('warning', 'Calcul en cours', 'Attendez la fin du calcul avant de créer une zone.');
                    return false;
                }
                const manager = window.maplyticsSavedAnalysisSurfaces?.export?.manager;
                if (manager?.isOpenedReadOnly?.()) {
                    showAppMessage('warning', 'Analyse en lecture seule', 'Cette analyse reçue ne peut pas être modifiée.');
                    return false;
                }
                if (this.zones.size >= 1 && typeof hasFeature === 'function' && !hasFeature('multi_zones')) {
                    showPremiumNotice('la comparaison multi-zones', 'La création de plusieurs zones nécessite le plan Starter ou supérieur.');
                    return false;
                }
                if (this.zones.size >= 6) {
                    showAppMessage('warning', 'Limite de zones atteinte', 'Vous ne pouvez pas créer plus de six zones simultanément.');
                    return false;
                }
                const points = this.getCreationPoints();
                if (!points.length) {
                    showAppMessage('warning', 'Point requis', 'Saisissez une adresse ou placez un point sur la carte avant de créer une zone.');
                    exportQueryInput?.focus();
                    return false;
                }
                if (!homeZoneCreateController) {
                    showAppMessage('error', 'Création indisponible', 'La fenêtre de création ne peut pas être ouverte. Rechargez la page.');
                    return false;
                }
                this.cancelEdit();
                return homeZoneCreateController.open({
                    trigger,
                    points,
                    selectedPointKey: points[0]?.key,
                    zoneType: document.querySelector('input[name="zone_type"]:checked')?.value || 'isochrone',
                    transportMode: exportTransportModeSelect?.value || 'driving-car',
                    transportOptionAccess: this.getTransportOptionAccess(),
                    value: exportMinutesInput?.value || 15,
                    color: this.colors[this.colorIndex % this.colors.length],
                    capacity: 6 - this.zones.size,
                });
            },

            beginEdit(zoneId) {
                if (exportCalculationInProgress) {
                    showAppMessage(
                        'warning',
                        'Calcul en cours',
                        'Attendez la fin du calcul avant de modifier une zone.',
                    );
                    return false;
                }
                const zone = this.zones.get(zoneId);
                if (!zone) return false;
                const origin = normalizeZoneOrigin(zone.origin, null, zone.geojson, zone.name);
                if (!homeZoneEditController) {
                    showAppMessage('error', 'Modification indisponible', 'La fenêtre de modification ne peut pas être ouverte. Rechargez la page.');
                    return false;
                }
                return homeZoneEditController.open({
                    zoneId,
                    zoneName: zone.name,
                    originLabel: origin?.label || '',
                    zoneType: zone.zoneType || 'isochrone',
                    transportMode: this.resolveTransportMode(zone),
                    transportOptionAccess: this.getTransportOptionAccess(),
                    value: zone.minutes || 15,
                    folder: zone.folder || '',
                });
            },

            submitEditDialog({ zoneId, zoneType, transportMode, value }) {
                const zone = this.zones.get(zoneId);
                const canonicalOption = exportTransportModeSelect?.querySelector(
                    `option[value="${transportMode}"]`
                );
                if (!zone || !canonicalOption || canonicalOption.disabled) {
                    showAppMessage(
                        'warning',
                        'Transport indisponible',
                        'Choisissez un mode de transport disponible avec votre offre.',
                    );
                    return false;
                }

                this.editFormSnapshot = this.captureEditFormSnapshot();
                this.editingZoneId = zoneId;
                exportForm?.setAttribute('data-editing-zone-id', zoneId);
                const zoneTypeInput = document.querySelector(
                    `input[name="zone_type"][value="${zoneType}"]`
                );
                if (zoneTypeInput) {
                    zoneTypeInput.checked = true;
                    zoneTypeInput.dispatchEvent(new Event('change', { bubbles: true }));
                }
                if (exportTransportModeSelect) {
                    exportTransportModeSelect.value = transportMode;
                    exportTransportModeSelect.dispatchEvent(new Event('change', { bubbles: true }));
                }
                if (exportMinutesInput) {
                    exportMinutesInput.value = String(value);
                    exportMinutesInput.dispatchEvent(new Event('input', { bubbles: true }));
                }

                const origin = normalizeZoneOrigin(zone.origin, null, zone.geojson, zone.name);
                if (origin) {
                    if (exportQueryInput) exportQueryInput.value = origin.label || '';
                    if (exportLatitudeInput) exportLatitudeInput.value = String(origin.lat);
                    if (exportLongitudeInput) exportLongitudeInput.value = String(origin.lon);
                    setExportAddressStatus('ready', 'Point défini');
                    syncExportAddressSubmitState();
                }

                this.renderZonesList();
                exportForm?.requestSubmit();
                return true;
            },

            requestEdit(zoneId) {
                const zone = this.zones.get(zoneId);
                if (!zone) return false;
                const manager = window.maplyticsSavedAnalysisSurfaces?.export?.manager;
                if (manager?.isOpenedReadOnly?.()) {
                    showAppMessage(
                        'warning',
                        'Analyse en lecture seule',
                        'Cette analyse reçue ne peut pas être modifiée.',
                    );
                    return false;
                }

                const confirmEdit = () => this.beginEdit(zoneId);
                if (manager?.openedAnalysisId) {
                    const message = (
                        `Modifier « ${zone.name} » recalculera cette zone dans l’analyse ouverte. `
                        + 'Son identité et son classement seront conservés.'
                    );
                    if (window.MaplyticsNotice?.show) {
                        window.MaplyticsNotice.show({
                            type: 'warning',
                            title: 'Modifier une zone enregistrée ?',
                            message,
                            persistent: true,
                            focus: true,
                            actions: [
                                { label: 'Modifier cette zone', onClick: confirmEdit },
                                { label: 'Annuler', variant: 'secondary' },
                            ],
                        });
                        return true;
                    }
                    return window.confirm(message) ? confirmEdit() : false;
                }
                return confirmEdit();
            },

            replaceZone(zoneId, minutes, data, geojson, transportMode, zoneType, options = {}) {
                const current = this.zones.get(zoneId);
                if (!current) return null;
                const updated = {
                    ...current,
                    id: current.id,
                    name: current.name,
                    color: current.color,
                    minutes,
                    data,
                    geojson,
                    transportMode: transportMode || this.resolveTransportMode(current),
                    zoneType: zoneType || current.zoneType || 'isochrone',
                    pdfSource: window.MaplyticsZonePresentation?.createJobSource?.(
                        data?.id || data?.job_id,
                        data,
                    ) || null,
                    origin: normalizeZoneOrigin(
                        options.origin || current.origin,
                        current.origin,
                        geojson,
                        current.name,
                    ),
                };
                this.zones.set(zoneId, updated);
                this.editingZoneId = null;
                this.editFormSnapshot = null;
                exportForm?.removeAttribute('data-editing-zone-id');
                this.renderZonesList();
                this.renderZoneCenter(updated);
                this.updateTabVisibility();
                this.updateSaveButtonVisibility();
                statsManager?.updateZonesSelect?.();
                this.saveZonesToLocalStorage();
                exportMapController?.updateKpiBadge?.(this.zones);
                scheduleZonePresentationSync('zone-recalculated');
                return updated;
            },

            getZoneMetadataAnalysisId(zone) {
                const directId = Number.parseInt(zone?.metadataAnalysisId, 10);
                if (Number.isInteger(directId) && directId > 0) return directId;
                const source = zone?.pdfSource;
                const sourceId = Number.parseInt(source?.analysis_id, 10);
                return source?.kind === 'saved_analysis'
                    && Number.isInteger(sourceId)
                    && sourceId > 0
                    ? sourceId
                    : null;
            },

            getOriginMarkerStyle(zone) {
                return normalizeOriginMarkerStyle(zone?.originStyle);
            },

            listOriginMarkerStyles() {
                const origins = new Map();
                this.zones.forEach((zone) => {
                    const key = window.MaplyticsHomeZoneHierarchy?.pointIdentity?.(zone)
                        || String(zone.id || 'point');
                    if (origins.has(key)) return;
                    origins.set(key, {
                        key,
                        label: zonePointName(zone),
                        style: this.getOriginMarkerStyle(zone),
                    });
                });
                return Array.from(origins.values());
            },

            updateOriginMarkerStyle(pointKey, styleInput = null) {
                const normalizedKey = String(pointKey || '');
                if (!normalizedKey) return false;
                const style = normalizeOriginMarkerStyle(styleInput);
                let changed = false;
                this.zones.forEach((zone) => {
                    const zonePointKey = window.MaplyticsHomeZoneHierarchy?.pointIdentity?.(zone)
                        || String(zone.id || 'point');
                    if (zonePointKey !== normalizedKey) return;
                    zone.originStyle = style;
                    this.renderZoneCenter(zone);
                    changed = true;
                });
                if (!changed) return false;
                this.saveZonesToLocalStorage();
                window.maplyticsVisualExportController?.sync?.('origin-marker-style');
                document.dispatchEvent(new CustomEvent('maplytics:origin-marker-style-changed', {
                    detail: {
                        pointKey: normalizedKey,
                        fingerprint: window.MaplyticsOriginMarkerStyle?.fingerprint?.(style) || '',
                    },
                }));
                return true;
            },

            renderZoneCenter(zone) {
                if (!zone?.origin || !exportMapController?.setZoneCenterMarker) return;
                const pointKey = window.MaplyticsHomeZoneHierarchy?.pointIdentity?.(zone)
                    || String(zone.id || 'point');
                const visible = this.hierarchyController?.isPointVisible?.(pointKey) !== false;
                exportMapController.setZoneCenterMarker(
                    zone.id,
                    zone.origin,
                    zone.color,
                    zone.name,
                    pointKey,
                    visible,
                    this.getOriginMarkerStyle(zone),
                );
            },

            renderAllZoneCenters() {
                this.zones.forEach((zone) => this.renderZoneCenter(zone));
            },

            applyStoredZoneVisibility(zoneId = null) {
                if (!this.hierarchyController) return;
                const entries = zoneId
                    ? [[zoneId, this.zones.get(zoneId)]]
                    : Array.from(this.zones.entries());
                this.hierarchyController.applyVisibility(
                    entries.filter(([, zone]) => Boolean(zone)),
                );
            },

            forgetPresentationEntries(entries) {
                const normalizedEntries = Array.isArray(entries) ? entries : [];
                this.hierarchyController?.forgetPresentation?.(normalizedEntries);
            },

            forgetRemovedZonePresentation(zoneIds) {
                const removedIds = new Set((zoneIds || []).map(String));
                const removedEntries = Array.from(this.zones.entries()).filter(
                    ([zoneId]) => removedIds.has(String(zoneId)),
                );
                const remainingPointKeys = new Set(Array.from(this.zones.entries())
                    .filter(([zoneId]) => !removedIds.has(String(zoneId)))
                    .map(([, zone]) => window.MaplyticsHomeZoneHierarchy?.pointIdentity?.(zone))
                    .filter(Boolean));
                const orphanPointKeys = Array.from(new Set(removedEntries
                    .map(([, zone]) => window.MaplyticsHomeZoneHierarchy?.pointIdentity?.(zone))
                    .filter((pointKey) => pointKey && !remainingPointKeys.has(pointKey))));
                this.hierarchyController?.forgetZoneVisibility?.(
                    Array.from(removedIds),
                    orphanPointKeys,
                );
            },

            getCanonicalAnalysisFolders() {
                const surface = window.maplyticsSavedAnalysisSurfaces?.export;
                if (!surface) return [];
                return typeof surface.uniqueFolders === 'function'
                    ? surface.uniqueFolders(surface.folders || [])
                    : Array.from(new Set(surface.folders || []));
            },

            zoneMetadataSnapshot(zone) {
                return {
                    name: String(zone?.name || '').trim().replace(/\s+/g, ' '),
                    folder: String(zone?.folder || '').trim().replace(/\s+/g, ' '),
                    origin_display_name: String(
                        zone?.origin?.display_name || ''
                    ).trim().replace(/\s+/g, ' '),
                };
            },

            cloneZonesForMetadata(zoneIds) {
                return new Map((zoneIds || []).map((zoneId) => {
                    const zone = this.zones.get(String(zoneId));
                    return [String(zoneId), zone ? {
                        ...zone,
                        origin: zone.origin ? { ...zone.origin } : zone.origin,
                    } : null];
                }));
            },

            restoreZoneMetadata(previousZones) {
                previousZones.forEach((previous, zoneId) => {
                    const current = this.zones.get(zoneId);
                    if (!current || !previous) return;
                    const next = {
                        ...current,
                        name: previous.name,
                        folder: previous.folder,
                    };
                    if (current.origin || previous.origin) {
                        next.origin = { ...(current.origin || {}) };
                        if (
                            previous.origin
                            && Object.prototype.hasOwnProperty.call(
                                previous.origin,
                                'display_name',
                            )
                        ) {
                            next.origin.display_name = previous.origin.display_name;
                        } else {
                            delete next.origin.display_name;
                        }
                    }
                    this.zones.set(zoneId, next);
                });
            },

            focusZoneRenameControl(kind, zoneId) {
                requestAnimationFrame(() => {
                    const control = Array.from(document.querySelectorAll(
                        '[data-zone-rename-kind], [data-zone-rename-editor]'
                    )).find((candidate) => (
                        String(candidate.dataset.zoneRenameKind
                            || candidate.dataset.zoneRenameEditor) === String(kind)
                        && String(candidate.dataset.zoneRenameTarget) === String(zoneId)
                    ));
                    control?.focus?.({ preventScroll: true });
                });
            },

            captureZoneMetadataTableState() {
                const controller = tableControllers.export;
                return {
                    searchValue: controller?.searchInput?.value || '',
                    activeFilters: controller?.activeFilters
                        ? { ...controller.activeFilters, zones: [
                            ...(controller.activeFilters.zones || []),
                        ] }
                        : null,
                    sortState: controller?.sortState
                        ? { ...controller.sortState }
                        : null,
                    currentPage: controller?.currentPage || 1,
                };
            },

            restoreZoneMetadataTableState(snapshot) {
                const controller = tableControllers.export;
                if (!controller || !snapshot || !Array.isArray(controller.allRows)) return;
                if (controller.searchInput) controller.searchInput.value = snapshot.searchValue;
                controller.activeFilters = snapshot.activeFilters;
                controller.sortState = snapshot.sortState;
                let rows = filterRows(
                    controller.allRows,
                    snapshot.searchValue,
                    controller.columns,
                );
                if (snapshot.activeFilters) {
                    rows = applyAdvancedFilters(
                        rows,
                        controller.columns,
                        snapshot.activeFilters,
                    );
                }
                const sortState = snapshot.sortState;
                if (sortState?.column && controller.columns.includes(sortState.column)) {
                    const direction = sortState.direction === 'desc' ? -1 : 1;
                    rows = [...rows].sort((left, right) => {
                        let leftValue = left[sortState.column];
                        let rightValue = right[sortState.column];
                        if (leftValue == null) leftValue = '';
                        if (rightValue == null) rightValue = '';
                        const leftNumber = Number.parseFloat(leftValue);
                        const rightNumber = Number.parseFloat(rightValue);
                        if (
                            Number.isFinite(leftNumber)
                            && Number.isFinite(rightNumber)
                            && String(leftValue).trim()
                            && String(rightValue).trim()
                        ) {
                            return direction * (leftNumber - rightNumber);
                        }
                        return direction * String(leftValue).localeCompare(
                            String(rightValue),
                            'fr',
                            { sensitivity: 'base' },
                        );
                    });
                }
                controller.filteredRows = rows;
                const pageCount = Math.max(1, Math.ceil(rows.length / controller.rowsPerPage));
                controller.currentPage = Math.min(snapshot.currentPage, pageCount);
                renderTablePage(controller, controller.columns);
                updateTableInfo(controller);
                if (typeof controller.updateStats === 'function') {
                    controller.updateStats(calculateStatistics(rows));
                }
            },

            getZoneRenameContext(zoneIds) {
                const ids = Array.from(new Set((zoneIds || []).map(String)));
                const zones = ids.map((zoneId) => this.zones.get(zoneId));
                const surface = window.maplyticsSavedAnalysisSurfaces?.export;
                const manager = surface?.manager;
                if (this.metadataRenamePending) {
                    return { enabled: false, reason: 'Un renommage est déjà en cours.' };
                }
                if (manager?.isOpenedReadOnly?.()) {
                    return { enabled: false, reason: 'Cette analyse reçue est en lecture seule.' };
                }
                if (!ids.length || zones.some((zone) => !zone)) {
                    return { enabled: false, reason: 'Une zone à renommer n’est plus disponible.' };
                }
                const analysisIdsByZone = zones.map((zone) => (
                    this.getZoneMetadataAnalysisId(zone)
                ));
                const attachedIds = analysisIdsByZone.filter(Number.isInteger);
                if (!attachedIds.length) {
                    return { enabled: true, analysisId: null, zones };
                }
                if (!surface?.connected || !manager || attachedIds.length !== zones.length) {
                    return {
                        enabled: false,
                        reason: 'Rouvrez cette analyse depuis Mes analyses avant de la renommer.',
                    };
                }
                const analysisIds = new Set(attachedIds);
                const analysisId = Array.from(analysisIds)[0];
                if (
                    analysisIds.size !== 1
                    || !Number.isInteger(analysisId)
                    || analysisId <= 0
                    || Number(manager.openedAnalysisId) !== analysisId
                ) {
                    return {
                        enabled: false,
                        reason: 'Ces zones ne proviennent pas de la même analyse ouverte.',
                    };
                }
                return { enabled: true, analysisId, zones };
            },

            resolveZoneMetadataTargets(kind, zoneIds) {
                const requested = Array.from(new Set((zoneIds || []).map(String)));
                const source = this.zones.get(requested[0]);
                if (!source) return [];
                if (kind === 'folder') {
                    const folderKey = String(source.folder || '').trim().toLocaleLowerCase('fr');
                    return Array.from(this.zones.entries())
                        .filter(([, zone]) => (
                            String(zone?.folder || '').trim().toLocaleLowerCase('fr') === folderKey
                        ))
                        .map(([zoneId]) => String(zoneId));
                }
                if (kind === 'point') {
                    const pointKey = window.MaplyticsHomeZoneHierarchy?.pointIdentity?.(source);
                    if (!pointKey) return [];
                    return Array.from(this.zones.entries())
                        .filter(([, zone]) => (
                            window.MaplyticsHomeZoneHierarchy?.pointIdentity?.(zone) === pointKey
                        ))
                        .map(([zoneId]) => String(zoneId));
                }
                return kind === 'zone' ? requested.slice(0, 1) : [];
            },

            syncZoneMetadataSurfaces(reason = 'zone-metadata-renamed') {
                const tableState = this.captureZoneMetadataTableState();
                const statsSelect = document.getElementById('statsZoneSelect');
                const activeStats = statsManager?.currentData
                    ? {
                        statType: statsManager.currentData.statType,
                        format: statsManager.currentData.format,
                    }
                    : null;
                const statsSelection = statsSelect
                    ? Array.from(statsSelect.selectedOptions).map((option) => option.value)
                    : [];
                this.zones.forEach((zone, zoneId) => {
                    const layer = exportMapController?.zonesLayers?.get(zoneId);
                    if (layer) layer.name = zone.name;
                });
                exportMapController?.clearZoneCenterMarkers?.();
                this.renderAllZoneCenters();
                exportMapController?.updateMapLegendMultiZones?.();
                this.renderZonesList();
                this._doUpdateTableWithZones({ synchronous: true });
                this.updateZoneFilter();
                this.restoreZoneMetadataTableState(tableState);
                statsManager?.updateZonesSelect?.();
                if (statsSelect && statsSelection.length) {
                    Array.from(statsSelect.options).forEach((option) => {
                        option.selected = statsSelection.includes(option.value);
                    });
                }
                if (activeStats?.statType) {
                    statsManager.renderStats(activeStats.statType, activeStats.format);
                }
                exportMapController?.updateKpiBadge?.(this.zones);
                this.updateExportSummary();
                this.saveZonesToLocalStorage();
                window.maplyticsVisualExportController?.sync?.(reason);
                scheduleZonePresentationSync(reason);
            },

            async renameZoneMetadata(kind, zoneIds, rawValue) {
                const maximum = kind === 'folder' ? 80 : 160;
                const value = normalizeZoneMetadataText(rawValue, maximum);
                if (!value) {
                    throw new Error(
                        `Le nom doit contenir entre 1 et ${maximum} caractères.`
                    );
                }
                const ids = this.resolveZoneMetadataTargets(kind, zoneIds);
                const context = this.getZoneRenameContext(ids);
                if (!context.enabled) throw new Error(context.reason);
                const previousZones = this.cloneZonesForMetadata(ids);
                const previousHierarchyState = this.hierarchyController?.captureState?.() || null;
                const expected = Object.fromEntries(ids.map((zoneId) => [
                    zoneId,
                    this.zoneMetadataSnapshot(this.zones.get(zoneId)),
                ]));
                const changes = Object.fromEntries(ids.map((zoneId) => {
                    const snapshot = { ...expected[zoneId] };
                    if (kind === 'folder') snapshot.folder = value;
                    else if (kind === 'point') snapshot.origin_display_name = value;
                    else snapshot.name = value;
                    return [zoneId, snapshot];
                }));
                if (ids.every((zoneId) => (
                    JSON.stringify(expected[zoneId]) === JSON.stringify(changes[zoneId])
                ))) return { zone_ids: ids, changed_zone_ids: [], unchanged: true };

                this.metadataRenamePending = true;
                let result = {
                    zone_ids: ids,
                    changed_zone_ids: ids,
                    unchanged: false,
                };
                let persistenceCommitted = false;
                try {
                    ids.forEach((zoneId) => {
                        const zone = this.zones.get(zoneId);
                        if (!zone) return;
                        const next = {
                            ...zone,
                            origin: zone.origin ? { ...zone.origin } : zone.origin,
                        };
                        if (kind === 'folder') next.folder = value;
                        else if (kind === 'point') {
                            next.origin = next.origin || {};
                            next.origin.display_name = value;
                        } else next.name = value;
                        this.zones.set(zoneId, next);
                    });
                    if (kind === 'folder') {
                        this.hierarchyController?.renameFolderKey?.(
                            expected[ids[0]]?.folder,
                            value,
                        );
                    }
                    this.syncZoneMetadataSurfaces('zone-metadata-optimistic');
                    if (context.analysisId) {
                        const manager = window.maplyticsSavedAnalysisSurfaces.export.manager;
                        result = await manager.updateAnalysisZoneMetadata(
                            context.analysisId,
                            expected,
                            changes,
                        );
                        if (!result || !Array.isArray(result.zone_ids)) {
                            throw new Error('Le serveur n’a pas confirmé le renommage.');
                        }
                        persistenceCommitted = true;
                        window.maplyticsSavedAnalysisSurfaces.export.refresh({ quiet: true })
                            .catch(() => console.warn('Rafraîchissement de Mes analyses différé.'));
                    } else {
                        persistenceCommitted = true;
                    }
                    this.metadataRenamePending = false;
                    try {
                        this.syncZoneMetadataSurfaces('zone-metadata-renamed');
                    } catch (syncError) {
                        console.warn(
                            'Renommage enregistré, synchronisation visuelle différée:',
                            syncError,
                        );
                        try {
                            this.syncZoneMetadataSurfaces(
                                'zone-metadata-renamed-recovery',
                            );
                        } catch (recoverySyncError) {
                            console.warn(
                                'Rendu complet post-renommage différé:',
                                recoverySyncError,
                            );
                            this.renderZonesList();
                            this.saveZonesToLocalStorage();
                            window.maplyticsVisualExportController?.sync?.(
                                'zone-metadata-renamed-recovery',
                            );
                        }
                        this.setInteractionLocked(false);
                        showAppMessage(
                            'warning',
                            'Renommage enregistré',
                            'Le nom est bien sauvegardé. Rechargez la page si un affichage n’est pas encore actualisé.',
                        );
                    }
                    this.focusZoneRenameControl(kind, ids[0]);
                    return result;
                } catch (error) {
                    if (persistenceCommitted) {
                        this.metadataRenamePending = false;
                        try {
                            this.syncZoneMetadataSurfaces(
                                'zone-metadata-renamed-recovery',
                            );
                            this.setInteractionLocked(false);
                        } catch (recoveryError) {
                            console.warn(
                                'Récupération visuelle post-renommage différée:',
                                recoveryError,
                            );
                            try {
                                this.renderZonesList();
                                this.setInteractionLocked(false);
                                this.saveZonesToLocalStorage();
                                window.maplyticsVisualExportController?.sync?.(
                                    'zone-metadata-renamed-recovery',
                                );
                            } catch (fallbackError) {
                                console.warn(
                                    'Rendu minimal post-renommage différé:',
                                    fallbackError,
                                );
                            }
                        }
                        this.focusZoneRenameControl(kind, ids[0]);
                        return result;
                    }
                    this.restoreZoneMetadata(previousZones);
                    if (previousHierarchyState) {
                        this.hierarchyController?.restoreState?.(previousHierarchyState);
                    }
                    this.metadataRenamePending = false;
                    try {
                        this.syncZoneMetadataSurfaces('zone-metadata-rollback');
                    } catch (rollbackError) {
                        console.error('Rollback visuel du renommage incomplet:', rollbackError);
                    }
                    this.focusZoneRenameControl(kind, ids[0]);
                    showAppMessage(
                        'error',
                        'Renommage non enregistré',
                        error?.message || 'Les noms précédents ont été restaurés.',
                    );
                    throw error;
                } finally {
                    this.metadataRenamePending = false;
                }
            },

            getZoneMoveContext(zoneIds) {
                const ids = Array.from(new Set((zoneIds || []).map(String)));
                const zones = ids.map((zoneId) => this.zones.get(zoneId));
                const surface = window.maplyticsSavedAnalysisSurfaces?.export;
                const manager = surface?.manager;
                if (!surface?.connected || !manager) {
                    return { enabled: false, reason: 'Connectez-vous pour classer une zone.' };
                }
                if (manager.isOpenedReadOnly?.()) {
                    return { enabled: false, reason: 'Cette analyse reçue est en lecture seule.' };
                }
                if (!ids.length || zones.some((zone) => !zone)) {
                    return { enabled: false, reason: 'Une zone sélectionnée n’est plus disponible.' };
                }
                const analysisIds = new Set();
                for (const zone of zones) {
                    const analysisId = this.getZoneMetadataAnalysisId(zone);
                    if (!analysisId) {
                        return {
                            enabled: false,
                            reason: 'Enregistrez d’abord cette analyse dans Mes analyses.',
                        };
                    }
                    analysisIds.add(analysisId);
                }
                if (analysisIds.size !== 1) {
                    return {
                        enabled: false,
                        reason: 'Ces zones proviennent de sauvegardes différentes.',
                    };
                }
                return { enabled: true, analysisId: Array.from(analysisIds)[0], zones };
            },

            async moveZonesToFolder(zoneIds, requestedFolder) {
                const context = this.getZoneMoveContext(zoneIds);
                if (!context.enabled) throw new Error(context.reason);
                const folders = this.getCanonicalAnalysisFolders();
                const rawFolder = String(requestedFolder || '').trim();
                const folder = rawFolder
                    ? folders.find((item) => item.localeCompare(
                        rawFolder, 'fr', { sensitivity: 'base' },
                    ) === 0)
                    : '';
                if (rawFolder && !folder) {
                    throw new Error('Choisissez un dossier existant dans Mes analyses.');
                }
                const ids = Array.from(new Set((zoneIds || []).map(String)));
                const expectedFolders = Object.fromEntries(ids.map((zoneId) => [
                    zoneId,
                    String(this.zones.get(zoneId)?.folder || '').trim(),
                ]));
                const manager = window.maplyticsSavedAnalysisSurfaces.export.manager;
                const result = await manager.moveAnalysisZones(
                    context.analysisId,
                    ids,
                    folder,
                    expectedFolders,
                );
                if (!result || !Array.isArray(result.zone_ids)) {
                    throw new Error('Le serveur n’a pas confirmé le déplacement.');
                }
                ids.forEach((zoneId) => {
                    const zone = this.zones.get(zoneId);
                    if (zone) zone.folder = result.folder || '';
                });
                this.saveZonesToLocalStorage();
                window.maplyticsSavedAnalysisSurfaces.export.refresh({ quiet: true })
                    .catch(() => console.warn('Rafraîchissement de Mes analyses différé.'));
                return result;
            },

            getLatestZoneOrigin() {
                const zones = Array.from(this.zones.values());
                const zone = zones[zones.length - 1] || null;
                if (!zone) return null;
                if (!zone.origin) {
                    zone.origin = normalizeZoneOrigin(null, null, zone.geojson, zone.name);
                }
                return zone.origin ? { zone, origin: zone.origin } : null;
            },

            syncZoneColorInputs() {
                this.zones.forEach((zone, zoneId) => {
                    zone.color = normalizeZoneHexColor(zone.color, this.colors[0]);
                    const input = document.getElementById(`color_${zoneId}`);
                    if (input && input.value !== zone.color) {
                        input.value = zone.color;
                    }
                });
            },

            addZone(minutes, data, geojson, transportMode = null, zoneType = 'isochrone', options = {}) {
                // Vérifier la feature multi_zones si l'utilisateur a déjà 1 zone
                if (this.zones.size >= 1) {
                    if (typeof hasFeature === 'function' && !hasFeature('multi_zones')) {
                        showPremiumNotice('la comparaison multi-zones', 'La création de plusieurs zones nécessite le plan Starter ou supérieur.');
                        return null;
                    }
                    // Limite max: 6 zones pour tous les plans
                    if (this.zones.size >= 6) {
                        showAppMessage('warning', 'Limite de zones atteinte', 'Vous ne pouvez pas créer plus de 6 zones simultanément.');
                        return null;
                    }
                }

                // Capturer le mode de transport utilisé pour cette zone
                const zoneTransportMode = transportMode || document.getElementById('exportTransportMode')?.value || 'driving-car';

                const zoneId = `zone_${this.nextZoneId++}`;
                const color = normalizeZoneHexColor(options.color, this.getNextColor());
                const defaultName = zoneType === 'isodistance' ? `${minutes} km` : `${minutes} min`;
                const name = String(options.name || '').trim() || defaultName;
                const origin = normalizeZoneOrigin(
                    options.origin || this.captureCurrentOrigin('calculation'),
                    null,
                    geojson,
                    name
                );
                const originPointKey = window.MaplyticsHomeZoneHierarchy?.pointIdentity?.({
                    id: zoneId,
                    origin,
                });
                const sharedOriginZone = Array.from(this.zones.values()).find((candidate) => (
                    window.MaplyticsHomeZoneHierarchy?.pointIdentity?.(candidate) === originPointKey
                ));
                const zone = {
                    id: zoneId,
                    name: name,
                    minutes: minutes,
                    color: color,
                    data: data,
                    geojson: geojson,
                    transportMode: zoneTransportMode,
                    zoneType,
                    pdfSource: window.MaplyticsZonePresentation?.createJobSource?.(
                        data?.id || data?.job_id,
                        data,
                    ) || null,
                    origin,
                    originStyle: normalizeOriginMarkerStyle(
                        options.originStyle || sharedOriginZone?.originStyle,
                    ),
                    folder: String(options.folder || '').trim(),
                    creationBatchId: options.batchId || null,
                    creationBatchOrder: Number.isInteger(options.batchOrder) ? options.batchOrder : null,
                };
                this.zones.set(zoneId, zone);
                if (zone.creationBatchId) {
                    const entries = Array.from(this.zones.entries());
                    const previous = entries.filter((entry) => entry[1].creationBatchId !== zone.creationBatchId);
                    const batch = entries
                        .filter((entry) => entry[1].creationBatchId === zone.creationBatchId)
                        .sort((left, right) => (
                            (left[1].creationBatchOrder ?? 0) - (right[1].creationBatchOrder ?? 0)
                        ));
                    this.zones = new Map([...previous, ...batch]);
                }
                this.renderZonesList();
                this.renderZoneCenter(zone);
                this.updateTabVisibility();
                this.updateSaveButtonVisibility();
                // Mettre à jour le sélecteur de zones pour les statistiques
                if (typeof statsManager !== 'undefined' && statsManager && statsManager.updateZonesSelect) {
                    statsManager.updateZonesSelect();
                }
                // Sauvegarder dans localStorage pour persistance après refresh
                this.saveZonesToLocalStorage();
                // Mettre à jour le badge KPIs sur la carte
                if (exportMapController && exportMapController.updateKpiBadge) {
                    exportMapController.updateKpiBadge(this.zones);
                }
                scheduleZonePresentationSync('zone-added');
                return zone;
            },

            removeZone(zoneId) {
                if (this.zones.has(zoneId)) {
                    if (this.editingZoneId === zoneId) {
                        this.editingZoneId = null;
                        this.editFormSnapshot = null;
                        exportForm?.removeAttribute('data-editing-zone-id');
                    }
                    this.forgetRemovedZonePresentation([zoneId]);
                    this.zones.delete(zoneId);
                    exportMapController.removeZone(zoneId);
                    exportMapController.removeZoneCenterMarker?.(zoneId);
                    this.renderZonesList();
                    this.updateTableWithZones();
                    this.updateTabVisibility();
                    this.updateSaveButtonVisibility();
                    // Mettre à jour le sélecteur de zones pour les statistiques
                    if (typeof statsManager !== 'undefined' && statsManager && statsManager.updateZonesSelect) {
                        statsManager.updateZonesSelect();
                    }
                    // Sauvegarder dans localStorage pour persistance après refresh
                    this.saveZonesToLocalStorage();
                    // Mettre à jour exportSummary
                    this.updateExportSummary();
                    // Mettre à jour le badge KPIs sur la carte
                    if (exportMapController && exportMapController.updateKpiBadge) {
                        exportMapController.updateKpiBadge(this.zones);
                    }
                    scheduleZonePresentationSync('zone-removed');
                    syncResultsRailAvailability('export');
                }
            },

            updateExportSummary() {
                const exportSummary = document.getElementById('exportSummary');
                if (!exportSummary) return;

                if (this.zones.size === 0) {
                    exportSummary.textContent = "Aucun calcul lancé pour l'instant.";
                    return;
                }

                // Calculer le total de communes
                const totalCommunes = this.getAggregatedRowsForZones().length;

                if (this.zones.size === 1) {
                    const zone = Array.from(this.zones.values())[0];
                    exportSummary.textContent = `${totalCommunes} communes trouvées dans la zone ${zone.name}.`;
                } else {
                    exportSummary.textContent = `${totalCommunes} communes au total dans ${this.zones.size} zones.`;
                }
            },

            renderZonesList() {
                const zonesList = document.getElementById('zonesList');
                if (!zonesList) return;
                syncAddZoneButtonState();

                if (this.zones.size === 0) {
                    const empty = document.createElement('p');
                    empty.className = 'home-empty-state__text';
                    empty.textContent = 'Aucune zone créée. Lancez un calcul pour créer votre première zone.';
                    zonesList.replaceChildren(empty);
                    return;
                }

                zonesList.replaceChildren();
                const zoneRows = new Map();
                this.zones.forEach((zone, zoneId) => {
                    zone.color = normalizeZoneHexColor(zone.color, this.colors[0]);
                    const zoneCard = document.createElement('article');
                    zoneCard.className = 'home-zone-row';
                    zoneCard.dataset.zoneId = zoneId;

                    // Récupérer l'opacité actuelle de la zone (avec vérification de sécurité)
                    let currentOpacity = 1.0;
                    if (exportMapController && exportMapController.zonesLayers) {
                        const zoneData = exportMapController.zonesLayers.get(zoneId);
                        currentOpacity = zoneData?.opacity ?? 1.0;
                    }

                    const main = document.createElement('div');
                    main.className = 'home-zone-row__main';

                    const colorLabel = document.createElement('label');
                    colorLabel.className = 'sr-only';
                    colorLabel.htmlFor = `color_${zoneId}`;
                    colorLabel.textContent = `Couleur de ${zone.name}`;
                    const colorInput = document.createElement('input');
                    colorInput.type = 'color';
                    colorInput.id = `color_${zoneId}`;
                    colorInput.value = zone.color;
                    colorInput.className = 'home-zone-row__color';
                    colorInput.dataset.zoneControl = '';
                    colorInput.title = 'Modifier la couleur';
                    colorInput.setAttribute('aria-label', `Couleur de ${zone.name}`);

                    const nameLabel = document.createElement('label');
                    nameLabel.className = 'sr-only';
                    nameLabel.htmlFor = `name_${zoneId}`;
                    nameLabel.textContent = `Nom de ${zone.name}`;
                    const nameInput = document.createElement('input');
                    nameInput.type = 'text';
                    nameInput.id = `name_${zoneId}`;
                    nameInput.value = zone.name;
                    nameInput.className = 'home-zone-row__name';
                    nameInput.dataset.zoneControl = '';
                    nameInput.dataset.zoneRenameKind = 'zone';
                    nameInput.dataset.zoneRenameTarget = String(zoneId);
                    nameInput.placeholder = 'Nom de la zone';
                    nameInput.maxLength = 160;
                    nameInput.setAttribute('aria-label', `Nom de ${zone.name}`);
                    const renameContext = this.getZoneRenameContext([zoneId]);
                    nameInput.disabled = renameContext.enabled === false;
                    nameInput.dataset.zoneIntrinsicDisabled = String(nameInput.disabled);
                    nameInput.title = nameInput.disabled
                        ? renameContext.reason || 'Renommage indisponible.'
                        : 'Renommer cette ZDC';
                    const renameHint = document.createElement('span');
                    renameHint.className = 'sr-only';
                    renameHint.id = `name_${zoneId}_status`;
                    renameHint.textContent = nameInput.disabled
                        ? renameContext.reason || 'Renommage indisponible.'
                        : 'Entrée valide le nom. Échap annule la modification.';
                    nameInput.setAttribute('aria-describedby', renameHint.id);

                    const meta = document.createElement('div');
                    meta.className = 'home-zone-row__meta';
                    const transport = document.createElement('span');
                    const transportMode = this.resolveTransportMode(zone);
                    const transportLabel = transportModeLabels[transportMode]
                        || 'transport';
                    transport.className = 'home-zone-row__transport';
                    const transportIcon = document.createElement('i');
                    const transportIconClasses = {
                        'driving-car': 'fa-car-side',
                        'driving-hgv': 'fa-truck',
                        'cycling-regular': 'fa-bicycle',
                        'foot-walking': 'fa-walking',
                    };
                    transportIcon.className = `fas ${transportIconClasses[transportMode] || 'fa-route'}`;
                    transportIcon.setAttribute('aria-hidden', 'true');
                    const transportAccessibleLabel = document.createElement('span');
                    transportAccessibleLabel.className = 'sr-only';
                    transportAccessibleLabel.textContent = `Transport : ${transportLabel}`;
                    transport.append(transportIcon, transportAccessibleLabel);
                    transport.title = `Transport : ${transportLabel}`;
                    const duration = document.createElement('span');
                    duration.className = 'home-zone-row__duration';
                    duration.textContent = zone.zoneType === 'isodistance'
                        ? `${zone.minutes} km`
                        : `${zone.minutes} min`;
                    duration.title = zone.zoneType === 'isodistance'
                        ? 'Distance de la zone'
                        : 'Durée de la zone';
                    meta.append(transport, duration);

                    const identity = document.createElement('div');
                    identity.className = 'home-zone-row__identity';
                    identity.append(nameLabel, nameInput, renameHint, meta);
                    main.append(colorLabel, colorInput, identity);

                    const actions = document.createElement('div');
                    actions.className = 'home-zone-row__actions';
                    const editButton = document.createElement('button');
                    editButton.type = 'button';
                    editButton.className = 'ghost-btn home-zone-edit-btn';
                    editButton.dataset.zoneAction = 'edit';
                    editButton.dataset.zoneId = zoneId;
                    editButton.dataset.zoneControl = '';
                    editButton.textContent = this.editingZoneId === zoneId ? 'Annuler' : 'Modifier';

                    const secondary = document.createElement('details');
                    secondary.className = 'home-zone-row__secondary';
                    const secondarySummary = document.createElement('summary');
                    secondarySummary.textContent = '⋯';
                    secondarySummary.setAttribute(
                        'aria-label',
                        `Actions secondaires pour ${zone.name}`,
                    );
                    secondarySummary.title = 'Actions secondaires';
                    const secondaryMenu = document.createElement('div');
                    secondaryMenu.className = 'home-zone-row__secondary-menu';

                    const communeCount = document.createElement('span');
                    communeCount.className = 'home-zone-row__communes';
                    const rowsCount = zone.data?.rows?.length || 0;
                    communeCount.textContent = `${rowsCount} commune${rowsCount > 1 ? 's' : ''}`;

                    const opacityLabel = document.createElement('label');
                    opacityLabel.className = 'home-zone-row__opacity';
                    opacityLabel.htmlFor = `opacity_${zoneId}`;
                    const opacityText = document.createElement('span');
                    opacityText.textContent = 'Opacité';
                    const opacitySlider = document.createElement('input');
                    opacitySlider.type = 'range';
                    opacitySlider.id = `opacity_${zoneId}`;
                    opacitySlider.min = '0';
                    opacitySlider.max = '100';
                    opacitySlider.value = String(Math.round(currentOpacity * 100));
                    opacitySlider.dataset.zoneControl = '';
                    const opacityValue = document.createElement('output');
                    opacityValue.id = `opacityValue_${zoneId}`;
                    opacityValue.setAttribute('for', `opacity_${zoneId}`);
                    opacityValue.textContent = `${Math.round(currentOpacity * 100)}%`;
                    opacityLabel.append(opacityText, opacitySlider, opacityValue);

                    const removeButton = document.createElement('button');
                    removeButton.type = 'button';
                    removeButton.className = 'ghost-btn home-zone-row__remove';
                    removeButton.dataset.zoneAction = 'remove';
                    removeButton.dataset.zoneId = zoneId;
                    removeButton.dataset.zoneControl = '';
                    removeButton.textContent = 'Supprimer';

                    secondaryMenu.append(editButton, communeCount, opacityLabel, removeButton);
                    secondary.append(secondarySummary, secondaryMenu);
                    actions.append(secondary);
                    zoneCard.append(main, actions);
                    zoneRows.set(String(zoneId), zoneCard);

                    // Event listener pour supprimer
                    removeButton.addEventListener('click', () => {
                        this.removeZone(zoneId);
                    });
                    editButton.addEventListener('click', () => {
                        this.hierarchyController?.closeActivePopover?.();
                        if (this.editingZoneId === zoneId) {
                            this.cancelEdit({ announce: true });
                            return;
                        }
                        this.requestEdit(zoneId);
                    });

                    // Event listener pour l'opacité
                    opacitySlider.addEventListener('input', (event) => {
                        const opacity = parseFloat(event.target.value) / 100;
                        opacityValue.textContent = `${event.target.value}%`;
                        exportMapController.updateZoneOpacity(zoneId, opacity);
                    });

                    // Event listener pour la couleur
                    colorInput.addEventListener('change', (event) => {
                        const newColor = event.target.value;
                        const currentZone = this.zones.get(zoneId);
                        if (currentZone) {
                            currentZone.color = newColor;
                            // Mettre à jour sur la carte
                            if (exportMapController.zonesLayers.has(zoneId)) {
                                const zoneData = exportMapController.zonesLayers.get(zoneId);
                                if (zoneData.layer) {
                                    zoneData.layer.setStyle({
                                        color: newColor,
                                        fillColor: newColor
                                    });
                                    zoneData.color = newColor;
                                }
                            }
                            // Mettre à jour la légende
                            exportMapController.updateMapLegendMultiZones();
                            this.renderZoneCenter(currentZone);
                            // Sauvegarder dans localStorage
                            this.saveZonesToLocalStorage();
                        }
                    });

                    // Event listener pour le nom
                    let nameCommitPending = false;
                    nameInput.addEventListener('input', () => {
                        nameInput.setCustomValidity('');
                        nameInput.removeAttribute('aria-invalid');
                    });
                    nameInput.addEventListener('blur', async (event) => {
                        if (nameCommitPending) return;
                        const newName = normalizeZoneMetadataText(event.target.value, 160);
                        if (!newName) {
                            event.target.value = zone.name;
                            event.target.setCustomValidity('');
                            event.target.removeAttribute('aria-invalid');
                            this.hierarchyController?.setStatus?.(
                                'Le nom de la ZDC ne peut pas être vide.',
                                'error',
                            );
                            return;
                        }
                        event.target.value = newName;
                        if (newName === zone.name) return;
                        nameCommitPending = true;
                        try {
                            await this.renameZoneMetadata('zone', [zoneId], newName);
                        } catch (_error) {
                            // The transactional helper restored every local surface.
                        }
                    });
                    nameInput.addEventListener('keydown', (event) => {
                        if (event.key === 'Enter') {
                            event.preventDefault();
                            const normalized = normalizeZoneMetadataText(
                                event.target.value,
                                160,
                            );
                            if (!normalized) {
                                event.target.setCustomValidity(
                                    'Le nom doit contenir entre 1 et 160 caractères.',
                                );
                                event.target.setAttribute('aria-invalid', 'true');
                                event.target.reportValidity();
                                return;
                            }
                            event.target.blur();
                        } else if (event.key === 'Escape') {
                            event.preventDefault();
                            event.target.value = zone.name;
                            event.target.setCustomValidity('');
                            event.target.removeAttribute('aria-invalid');
                            event.target.select();
                        }
                    });
                });
                const hierarchyApi = window.MaplyticsHomeZoneHierarchy;
                if (!this.hierarchyController && hierarchyApi?.createController) {
                    this.hierarchyController = hierarchyApi.createController({
                        storage: window.localStorage,
                        onZoneVisibility: (zoneId, visible) => {
                            exportMapController?.setZoneVisibility?.(zoneId, visible);
                        },
                        onPointVisibility: (pointKey, visible) => {
                            exportMapController?.setPointVisibility?.(pointKey, visible);
                        },
                        getCanonicalFolders: () => this.getCanonicalAnalysisFolders(),
                        canRename: (_kind, zoneIds) => this.getZoneRenameContext(zoneIds),
                        onRename: (kind, zoneIds, value) => (
                            this.renameZoneMetadata(kind, zoneIds, value)
                        ),
                        canMove: (zoneIds) => this.getZoneMoveContext(zoneIds),
                        onMove: (zoneIds, folder) => this.moveZonesToFolder(zoneIds, folder),
                        helpMount: document.getElementById('homeZoneHierarchyHelpMount'),
                        onOpenAnalyses: () => {
                            this.switchTab('tab5');
                            requestAnimationFrame(() => document.querySelector(
                                '#historyContent [data-history-search]',
                            )?.focus({ preventScroll: true }));
                        },
                        onOpenGeoManager: () => {
                            document.querySelector('[data-target="geoManagerPanel"]')?.click();
                        },
                    });
                }
                if (this.hierarchyController) {
                    this.hierarchyController.render(
                        zonesList,
                        Array.from(this.zones.entries()),
                        zoneRows,
                    );
                } else {
                    zonesList.replaceChildren(...zoneRows.values());
                }
                this.setInteractionLocked(
                    exportCalculationInProgress || this.metadataRenamePending,
                );
                const deferVisualExportSync = homeWorkspaceResetTransactionActive;
                requestAnimationFrame(() => {
                    this.syncZoneColorInputs();
                    if (!deferVisualExportSync) {
                        window.maplyticsVisualExportController?.sync?.('zones-rendered');
                    }
                });
            },

            updateTableWithZones() {
                // Fusionner toutes les zones dans un seul tableau avec colonne zone
                scheduleZonePresentationSync('table-source-change');
                if (this.zones.size === 0) {
                    this._doUpdateTableWithZones({ synchronous: true });
                    return;
                }

                // Utiliser requestAnimationFrame pour éviter les blocages de rendu sur mobile
                requestAnimationFrame(() => {
                    this._doUpdateTableWithZones();
                });
            },

            getZoneAggregationGroupKey(zone) {
                const transportMode = this.resolveTransportMode(zone);
                const zoneType = zone?.zoneType || zone?.zone_type || 'isochrone';
                const origin = normalizeZoneOrigin(
                    zone?.origin,
                    null,
                    null,
                    zone?.name || '',
                );
                const reliableOrigin = origin && !origin.approximate;
                const originKey = reliableOrigin
                    ? `origin:${Number(origin.lat).toFixed(6)},${Number(origin.lon).toFixed(6)}`
                    : 'origin:unknown';
                let calculationKey;
                if (reliableOrigin) {
                    // The canonical point remains stable across separate calculation dialogs.
                    calculationKey = 'calculation:origin';
                } else if (zone?.creationBatchId) {
                    calculationKey = `batch:${String(zone.creationBatchId)}`;
                } else {
                    // Approximate or missing origins cannot safely identify a calculation group.
                    calculationKey = `zone:${String(zone?.id || 'unknown')}`;
                }
                return [transportMode, zoneType, originKey, calculationKey].join('|');
            },

            resolveAggregatedRowZone(row, sortedZones, sourceZone) {
                const isDistance = sourceZone?.zoneType === 'isodistance';
                const rawBaseValue = isDistance
                    ? row?.geodesic_distance_meters
                    : row?.travel_duration_seconds;
                const baseValue = Number.parseFloat(rawBaseValue);
                if (!Number.isFinite(baseValue) || baseValue < 0) return null;
                const measuredValue = isDistance ? baseValue / 1000 : baseValue / 60;
                for (const zone of sortedZones) {
                    if ((zone?.zoneType === 'isodistance') !== isDistance) continue;
                    const threshold = Number(zone?.minutes);
                    if (Number.isFinite(threshold) && measuredValue <= threshold) {
                        return zone;
                    }
                }
                return null;
            },

            getAggregatedRowsForZones(
                zones = Array.from(this.zones.values()),
                options = {},
            ) {
                const selectedZones = Array.from(zones || []).filter(Boolean);
                const selectedIds = new Set(selectedZones.map((zone) => String(zone.id)));
                const presentation = exportZonePresentationController?.getSnapshot?.();
                const projectedZones = Array.isArray(presentation?.projection?.zones)
                    ? presentation.projection.zones.filter((zone) => (
                        selectedIds.has(String(zone.zone_id))
                    ))
                    : [];
                const useProjectedZones = projectedZones.length
                    && !(options.forceCumulative === true && presentation?.mode === 'exclusive');
                let sourceZones = useProjectedZones
                    ? projectedZones.map((projectedZone) => ({
                        projectedZone,
                        zone: this.zones.get(String(projectedZone.zone_id)),
                        rows: projectedZone.rows,
                    }))
                    : selectedZones.map((zone) => ({
                        projectedZone: null,
                        zone,
                        rows: Array.isArray(zone?.data?.rows) ? zone.data.rows : [],
                    }));
                if (
                    options.forceExclusive === true
                    && presentation?.mode !== 'exclusive'
                    && window.MaplyticsZoneRowAllocation?.allocateExclusive
                ) {
                    const allocations = window.MaplyticsZoneRowAllocation.allocateExclusive(
                        selectedZones.map((zone) => ({
                            zoneId: zone.id,
                            label: zone.name,
                            groupKey: this.getZoneAggregationGroupKey(zone),
                            threshold: zone.minutes,
                            unit: zone.zoneType === 'isodistance' ? 'km' : 'min',
                            rows: Array.isArray(zone?.data?.rows) ? zone.data.rows : [],
                        })),
                    );
                    sourceZones = allocations.map((allocation) => ({
                        projectedZone: {
                            zone_id: allocation.zoneId,
                            range_label: allocation.label,
                            range: allocation.range,
                            rows: allocation.rows,
                        },
                        zone: this.zones.get(String(allocation.zoneId)),
                        rows: allocation.rows,
                    }));
                }
                return sourceZones.flatMap(({projectedZone, zone, rows}) => {
                    if (!zone) return [];
                    const mode = options.forceExclusive === true
                        ? 'exclusive'
                        : options.forceCumulative === true
                            ? 'cumulative'
                        : projectedZone?.rows?.[0]?.zone_projection_mode
                        || presentation?.mode
                        || 'cumulative';
                    const label = mode === 'exclusive'
                        ? String(projectedZone?.range_label || zone.name)
                        : String(zone.name);
                    const range = projectedZone?.range || {};
                    return rows.map((row) => ({
                        ...row,
                        zone_chalandise: label,
                        zone_de_chalandise: label,
                        zone_dataset_ref: String(zone.id),
                        zone_folder: String(zone.folder || '').trim() || 'Sans dossier',
                        point_name: zonePointName(zone),
                        origin_address: zoneOriginAddress(zone),
                        mode_transport: this.resolveTransportMode(zone),
                        zone_projection_mode: mode,
                        zone_projection_label: String(
                            projectedZone?.range_label
                            || row?.zone_projection_label
                            || label,
                        ),
                        zone_projection_fingerprint: String(
                            presentation?.projectionFingerprint || '',
                        ),
                        zone_projection_lower: range.lower ?? 0,
                        zone_projection_upper: range.upper ?? zone.minutes,
                        zone_projection_unit: range.unit
                            || (zone.zoneType === 'isodistance' ? 'km' : 'min'),
                        ...(zone.zoneType === 'isodistance'
                            ? {zone_distance_km: zone.minutes}
                            : {zone_duration_min: zone.minutes}),
                    }));
                });
            },

            _doUpdateTableWithZones(options = {}) {
                const allColumns = new Set();
                this.zones.forEach((zone) => {
                    if (Array.isArray(zone?.data?.columns)) {
                        zone.data.columns.forEach((column) => allColumns.add(column));
                    }
                });
                const allRows = this.getAggregatedRowsForZones();

                const hierarchyColumns = [
                    'zone_chalandise',
                    'zone_folder',
                    'point_name',
                    'origin_address',
                    'zone_projection_mode',
                    'zone_projection_label',
                    'zone_projection_fingerprint',
                ];
                if (allColumns.size > 0) {
                    hierarchyColumns.forEach((column) => allColumns.add(column));
                }
                // Ajouter mode_transport aux colonnes
                if (allColumns.size > 0 && !allColumns.has('mode_transport')) {
                    allColumns.add('mode_transport');
                }

                if (allRows.length > 0) {
                    const columns = Array.from(allColumns);
                    // Mettre zone_chalandise après les colonnes principales, mode_transport à la fin
                    const mainCols = ['nom_commune', 'code_postal', 'code_insee'];
                    const otherCols = columns.filter(c => (
                        !mainCols.includes(c)
                        && !hierarchyColumns.includes(c)
                        && c !== 'mode_transport'
                    ));
                    const orderedColumns = [
                        ...mainCols.filter(c => allColumns.has(c)),
                        ...hierarchyColumns,
                        ...otherCols,
                        'mode_transport',
                    ];

                    const isPremium = hasFeature('demographic_data');
                    tableControllers.export.isPremium = isPremium;
                    if (options.synchronous) {
                        _doPopulateTable(exportTable, orderedColumns, allRows);
                    } else {
                        populateTable(exportTable, orderedColumns, allRows);
                    }

                    // Mettre à jour les stats
                    const stats = calculateStatistics(allRows);
                    const statsEl = document.getElementById('exportStats');
                    const statsGridEl = document.getElementById('exportStatsGrid');
                    const sourceDistEl = document.getElementById('exportSourceDistribution');
                    renderStatistics(statsEl, statsGridEl, sourceDistEl, stats, isPremium);

                    // S'assurer que le tableau est visible
                    tableControllers.export.container.hidden = false;
                    tableControllers.export.search.hidden = false;
                    tableControllers.export.actions.hidden = false;
                    document.getElementById('exportStats').hidden = false;
                    document.getElementById('exportFilters').hidden = false;

                    // Restaurer les liens de téléchargement CSV et GeoJSON
                    // Utiliser les données de la dernière zone (ou de n'importe quelle zone qui a un fichier)
                    const exportDownloadEl = document.getElementById('exportDownload');
                    const exportIsoLinkEl = document.getElementById('exportIsoLink');
                    const exportExcelLinkEl = document.getElementById('exportExcelLink');
                    const zonesArray = Array.from(this.zones.values());
                    const lastZoneWithFile = zonesArray.reverse().find(z => z.data && z.data.file);

                    if (lastZoneWithFile && lastZoneWithFile.data.file && exportDownloadEl) {
                        exportDownloadEl.hidden = false;
                        bindFilteredExportLink(exportDownloadEl, 'csv', 'export');
                    }
                    if (lastZoneWithFile && lastZoneWithFile.data.iso_file && exportIsoLinkEl) {
                        exportIsoLinkEl.hidden = false;
                        bindFilteredExportLink(exportIsoLinkEl, 'geojson', 'export');
                    }

                    // Garder un seul listener stable malgré les filtres et rerenders.
                    exportExcelLink = bindMultiZoneExcelLink(exportExcelLinkEl);
                } else {
                    // Si pas de données, cacher le tableau
                    resetTable(exportTable);
                    tableControllers.export.allRows = [];
                    tableControllers.export.filteredRows = [];
                    tableControllers.export.columns = [];
                    tableControllers.export.currentPage = 1;
                    tableControllers.export.updateStats = null;
                    tableControllers.export.container.hidden = true;
                    tableControllers.export.search.hidden = true;
                    tableControllers.export.actions.hidden = true;
                    document.getElementById('exportStats').hidden = true;
                    document.getElementById('exportFilters').hidden = true;
                    if (this.zones.size === 0) {
                        ['exportDownload', 'exportIsoLink', 'exportExcelLink'].forEach((id) => {
                            const link = document.getElementById(id);
                            if (!link) return;
                            link.hidden = true;
                            link.removeAttribute('href');
                            link.removeAttribute('data-job-id');
                        });
                        hideToolBridge('export');
                        latestToolBridgeContext.export = null;
                    }
                }
            },

            updateZoneFilter() {
                const zoneSelect = document.getElementById('exportFilterZone');
                if (!zoneSelect) return;

                // Sauvegarder la sélection actuelle
                const currentSelection = Array.from(zoneSelect.selectedOptions).map(opt => opt.value);

                // Vider et remplir avec les zones actuelles
                zoneSelect.innerHTML = '<option value="">Toutes les zones</option>';
                const projectedCounts = new Map();
                this.getAggregatedRowsForZones().forEach((row) => {
                    const datasetRef = String(row?.zone_dataset_ref || '').trim();
                    if (!datasetRef) return;
                    projectedCounts.set(
                        datasetRef,
                        (projectedCounts.get(datasetRef) || 0) + 1,
                    );
                });
                this.zones.forEach((zone) => {
                    const option = document.createElement('option');
                    const datasetRef = String(zone.id);
                    const projectedCount = projectedCounts.get(datasetRef) || 0;
                    option.value = datasetRef;
                    option.textContent = `${zone.name} (${projectedCount} commune${projectedCount > 1 ? 's' : ''})`;
                    zoneSelect.appendChild(option);
                });

                // Restaurer la sélection
                currentSelection.forEach(val => {
                    const option = Array.from(zoneSelect.options).find(opt => opt.value === val);
                    if (option) option.selected = true;
                });
            },

            clearAllZones({ detach = true, persist = true } = {}) {
                this.workspaceLoadGeneration += 1;
                this.savedSnapshotRenderGeneration += 1;
                if (detach) window.maplyticsClearOpenedAnalysis?.('isochrone');
                this.editingZoneId = null;
                this.editFormSnapshot = null;
                exportForm?.removeAttribute('data-editing-zone-id');
                this.forgetRemovedZonePresentation(Array.from(this.zones.keys()));
                this.zones.forEach((zone, zoneId) => {
                    exportMapController.removeZone(zoneId);
                });
                exportMapController.clearZoneCenterMarkers?.();
                this.zones.clear();
                this.colorIndex = 0;
                this.renderZonesList();
                resetTable(exportTable);
                document.getElementById('exportTableContainer').hidden = true;
                document.getElementById('exportStats').hidden = true;
                document.getElementById('exportFilters').hidden = true;
                this.updateTabVisibility();
                this.updateSaveButtonVisibility();
                // Mettre à jour le sélecteur de zones pour les statistiques
                if (typeof statsManager !== 'undefined' && statsManager && statsManager.updateZonesSelect) {
                    statsManager.updateZonesSelect();
                }
                // Mettre à jour exportSummary
                this.updateExportSummary();
                if (persist) this.saveZonesToLocalStorage();
                scheduleZonePresentationSync('zones-cleared');
                setResultsRailStatus('export', 'empty');
            },

            resetLocalWorkspace() {
                this.clearAllZones({ detach: false, persist: false });
                try {
                    homeZonesStorage.removeItem(HOME_ZONE_STORAGE_KEY);
                } catch (error) {
                    console.warn('[Home reset] zones locales non supprimées:', error);
                }
                resetFilters('export');
                const controller = tableControllers.export;
                controller.allRows = [];
                controller.filteredRows = [];
                controller.columns = [];
                controller.currentPage = 1;
                controller.activeFilters = null;
                controller.sortState = null;
                controller.updateStats = null;
                if (controller.searchInput) controller.searchInput.value = '';
                const filtersContent = document.getElementById('exportFiltersContent');
                const filtersToggleText = document.getElementById('exportFiltersToggleText');
                filtersContent?.classList.remove('expanded');
                if (filtersToggleText) filtersToggleText.textContent = 'Afficher';
                this.updateZoneFilter();
                statsManager?.destroy?.();
                statsManager?.updateZonesSelect?.();
                ['exportStatsGrid', 'exportSourceDistribution', 'statsDisplayArea'].forEach((id) => {
                    document.getElementById(id)?.replaceChildren();
                });
                return true;
            },

            updateSaveButtonVisibility() {
                const saveBtn = document.getElementById('saveZonesBtn');
                const hasZones = this.zones.size > 0;

                if (saveBtn) {
                    saveBtn.disabled = !hasZones;
                    saveBtn.setAttribute('aria-disabled', String(!hasZones));
                    saveBtn.title = hasZones
                        ? 'Enregistrer la zone dans Mes analyses'
                        : 'Lancez un calcul avant d’enregistrer une zone';
                }
                window.maplyticsSavedAnalysisSurfaces?.export?.updateAvailability();
                updateExportRecenterPointButton();
            },

            // ============================================
            // GESTION DES ONGLETS
            // ============================================

            initTabs() {
                // Event listeners pour les boutons d'onglets (scoped à #zonesManager uniquement)
                const tabButtons = document.querySelectorAll('#zonesManager [data-tab]');
                tabButtons.forEach(btn => {
                    btn.addEventListener('click', () => {
                        const tabId = btn.getAttribute('data-tab');
                        if (tabId && !btn.disabled) {
                            if (APP_CONFIG.appShellV2) {
                                revealResultsPanel('export');
                            }
                            this.switchTab(tabId);
                        }
                    });
                });

                // Initialiser la visibilité des onglets
                this.updateTabVisibility();
            },

            switchTab(tabId) {
                // Masquer tous les contenus d'onglets (scoped à #zonesManager uniquement)
                const allContents = document.querySelectorAll('#zonesManager .zones-tab-content');
                allContents.forEach(content => {
                    content.style.display = 'none';
                    content.classList.remove('active');
                });

                // Désactiver tous les boutons d'onglets (scoped à #zonesManager uniquement)
                const allTabs = document.querySelectorAll('#zonesManager [data-tab]');
                allTabs.forEach(tab => {
                    tab.classList.remove('active');
                    tab.style.borderBottomColor = 'transparent';
                    tab.style.color = '#64748b';
                    tab.style.fontWeight = '500';
                });

                // Activer l'onglet sélectionné (scoped à #zonesManager uniquement)
                const selectedTab = document.querySelector(`#zonesManager [data-tab="${tabId}"]`);

                if (tabId === 'tab5') {
                    window.maplyticsSavedAnalysisSurfaces?.export?.updateAvailability();
                }
                const selectedContent = document.getElementById(`${tabId}-content`);

                if (selectedTab && selectedContent) {
                    selectedTab.classList.add('active');
                    selectedTab.style.borderBottomColor = '#2563eb';
                    selectedTab.style.color = '#2563eb';
                    selectedTab.style.fontWeight = '600';

                    selectedContent.classList.remove('home-hidden');
                    selectedContent.style.display = 'block';
                    selectedContent.classList.add('active');
                    if (tabId === 'tabMaps') {
                        const mapId = 'exportMap';
                        window.requestAnimationFrame(() => {
                            document.getElementById(`choroplethSettingsTitle_${mapId}`)
                                ?.focus({ preventScroll: true });
                        });
                    }
                }
            },

            updateTabVisibility() {
                const hasZones = this.zones.size > 0;
                const tab2 = document.getElementById('zonesTab2');
                const tab3 = document.getElementById('zonesTab3');
                const tab5 = document.getElementById('zonesTab5');

                // Fonction helper pour gérer la visibilité d'un onglet
                const setTabVisibility = (tab, enabled) => {
                    if (!tab) return;
                    if (enabled) {
                        tab.style.opacity = '1';
                        tab.style.pointerEvents = 'auto';
                        tab.style.cursor = 'pointer';
                    } else {
                        tab.style.opacity = '0.5';
                        tab.style.pointerEvents = 'none';
                        tab.style.cursor = 'not-allowed';
                    }
                };

                // Les données/statistiques exigent une zone; l'historique reste
                // accessible après un refresh.
                setTabVisibility(tab2, hasZones);
                setTabVisibility(tab3, hasZones);
                setTabVisibility(tab5, true);
            },

            // ============================================
            // PERSISTENCE (Sauvegarder/Charger/Reset)
            // ============================================

            async saveZones() {
                if (this.zones.size === 0) {
                    alert('Aucune zone à sauvegarder.');
                    return false;
                }

                try {
                    // Préparer les données des zones
                    const zonesArray = Array.from(this.zones.values()).map((zone) => this.serializeZone(zone));

                    // Récupérer le point d'origine (depuis les inputs ou la première zone)
                    const originQuery = document.getElementById('exportQuery')?.value || '';
                    const originLat = document.getElementById('exportLatitude')?.value || null;
                    const originLon = document.getElementById('exportLongitude')?.value || null;
                    const transportMode = document.getElementById('exportTransportMode')?.value || 'driving-car';

                    const zonesData = {
                        zones: zonesArray,
                        metadata: {
                            tool_type: 'isochrone',
                            origin: {
                                query: originQuery,
                                lat: originLat ? parseFloat(originLat) : null,
                                lon: originLon ? parseFloat(originLon) : null
                            },
                            transport_mode: transportMode,
                            saved_at: new Date().toISOString()
                        }
                    };

                    const response = await fetch('/api/zones/save', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        credentials: 'include',
                        body: JSON.stringify({
                            tool_type: 'isochrone',
                            zones_data: zonesData
                        })
                    });

                    const result = await response.json();

                    if (result.success) {
                        // Afficher le bouton Reset
                        const resetBtn = document.getElementById('resetZonesBtn');
                        if (resetBtn) resetBtn.style.display = 'inline-block';

                        // Feedback visuel temporaire avec animation
                        const saveBtn = document.getElementById('saveZonesBtn');
                        if (saveBtn) {
                            const originalText = saveBtn.textContent;
                            saveBtn.textContent = '✓ Sauvegardé';
                            saveBtn.classList.add('btn-success-feedback');
                            setTimeout(() => {
                                saveBtn.textContent = originalText;
                                saveBtn.classList.remove('btn-success-feedback');
                            }, 2000);
                        }

                        return true;
                    } else {
                        alert('Erreur lors de la sauvegarde: ' + (result.error || 'Erreur inconnue'));
                        return false;
                    }
                } catch (error) {
                    console.error('Erreur sauvegarde zones:', error);
                    alert('Erreur lors de la sauvegarde. Vérifiez votre connexion.');
                    return false;
                }
            },

            /**
             * Agrège toutes les rows de toutes les zones pour l'export.
             * Ajoute zone_chalandise (nom personnalisé) et mode_transport à chaque row.
             * @returns {Array} Liste de tous les rows avec zone et mode de transport
             */
            getAllAggregatedRows() {
                return this.getAggregatedRowsForZones();
            },

            saveZonesToLocalStorage() {
                try {
                    const zonesArray = Array.from(this.zones.values()).map((zone) => this.serializeZone(zone));

                    const originQuery = document.getElementById('exportQuery')?.value || '';
                    const originLat = document.getElementById('exportLatitude')?.value || null;
                    const originLon = document.getElementById('exportLongitude')?.value || null;
                    const transportMode = document.getElementById('exportTransportMode')?.value || 'driving-car';

                    const zonesData = {
                        zones: zonesArray,
                        metadata: {
                            tool_type: 'isochrone',
                            origin: {
                                query: originQuery,
                                lat: originLat ? parseFloat(originLat) : null,
                                lon: originLon ? parseFloat(originLon) : null
                            },
                            transport_mode: transportMode,
                            saved_at: new Date().toISOString()
                        }
                    };

                    homeZonesStorage.setItem(HOME_ZONE_STORAGE_KEY, JSON.stringify(zonesData));
                    window.maplyticsVisualExportController?.sync?.('zones-saved');
                    window.dispatchEvent(new CustomEvent(
                        'maplytics:analysis-workspace-changed',
                        { detail: { toolType: 'isochrone', source: 'zones' } },
                    ));
                } catch (error) {
                    console.warn('Erreur sauvegarde localStorage:', error);
                }
            },

            loadZonesFromLocalStorage(options = {}) {
                try {
                    if (options.automatic && isHomeWorkspaceScopeReset('zones')) return false;
                    const restoreOpenSequence = historyManager?.openIntentSequence || 0;
                    if (options.automatic && restoreOpenSequence > 0) return false;
                    const saved = homeZonesStorage.getItem(HOME_ZONE_STORAGE_KEY);
                    if (!saved) return false;
                    if (!options.force && (isEdgeBrowser() || saved.length > ZONES_LOCAL_STORAGE_AUTO_RESTORE_MAX_BYTES)) {
                        try {
                            if (saved.length > ZONES_LOCAL_STORAGE_AUTO_RESTORE_MAX_BYTES) {
                                showDeferredZonesRestorePrompt({ zones: [] }, isEdgeBrowser() ? 'edge-browser' : 'storage-heavy');
                                return false;
                            }
                            const preview = JSON.parse(saved);
                            showDeferredZonesRestorePrompt(preview, isEdgeBrowser() ? 'edge-browser' : 'storage-heavy');
                        } catch (previewError) {
                            showDeferredZonesRestorePrompt({ zones: [] }, 'storage-heavy');
                        }
                        return false;
                    }

                    const zonesData = JSON.parse(saved);
                    if (
                        !zonesData
                        || typeof zonesData !== 'object'
                        || Array.isArray(zonesData)
                    ) {
                        return false;
                    }
                    const prepared = this.prepareSavedZonesSnapshot(zonesData);
                    if (
                        !options.force
                        && Array.isArray(zonesData.zones)
                        && zonesData.zones.length > ZONES_LOCAL_STORAGE_MAX_AUTO_ZONES
                    ) {
                        showDeferredZonesRestorePrompt(zonesData, 'too-many-zones');
                        return false;
                    }
                    if (
                        options.automatic
                        && (historyManager?.openIntentSequence || 0) !== restoreOpenSequence
                    ) {
                        return false;
                    }
                    if (options.userInitiated) {
                        window.maplyticsClearOpenedAnalysis?.('isochrone');
                    }
                    this.replaceZonesFromSavedSnapshot(prepared);
                    options.onLoaded?.(zonesData);
                    return true;
                } catch (error) {
                    console.warn('Erreur chargement localStorage:', error);
                    return false;
                }
            },

            // Re-afficher toutes les zones sur la carte (appelé après init de exportMapController)
            renderAllZonesOnMap() {
                if (!exportMapController) {
                    console.warn('renderAllZonesOnMap: exportMapController non initialisé');
                    return;
                }

                const renderGeneration = this.savedSnapshotRenderGeneration;
                let rendered = 0;
                this.zones.forEach((zone, zoneId) => {
                    if (zone.geojson) {
                        runWhenBrowserIdle(() => {
                            if (
                                renderGeneration !== this.savedSnapshotRenderGeneration
                                || this.zones.get(zoneId) !== zone
                            ) {
                                return;
                            }
                            exportMapController.renderGeoJson(
                                zone.geojson,
                                zoneId,
                                zone.color,
                                zone.name,
                                {
                                    restoring: true,
                                    animate: false,
                                    visible: this.hierarchyController
                                        ?.isZoneVisible?.(zoneId) !== false,
                                },
                            );
                            this.renderZoneCenter(zone);
                            this.applyStoredZoneVisibility(zoneId);
                        });
                        rendered++;
                    }
                });

                if (rendered > 0) {
                    (window.debugLog || (() => {}))(`${rendered} zone(s) restaurée(s) sur la carte après init`);
                    // Re-rendre la liste des zones maintenant que zonesLayers est disponible
                    this.renderZonesList();
                    this.updateTableWithZones();
                    this.updateTabVisibility();
                }
            },

            async loadZones({ automatic = false } = {}) {
                if (automatic && isHomeWorkspaceScopeReset('zones')) return false;
                const restoreOpenSequence = historyManager?.openIntentSequence || 0;
                const workspaceLoadGeneration = this.workspaceLoadGeneration;
                const resetGeneration = homeWorkspaceScopeResetGeneration('zones');
                if (automatic && restoreOpenSequence > 0) return false;
                // D'abord essayer de charger depuis localStorage (plus rapide)
                let localZonesData = null;
                const loadedFromLocal = this.loadZonesFromLocalStorage({
                    automatic,
                    onLoaded: (zonesData) => {
                        localZonesData = zonesData;
                    },
                });
                if (loadedFromLocal) {
                    (window.debugLog || (() => {}))('Zones restaurées depuis localStorage');
                }

                // Ensuite charger depuis le serveur si connecté (pour synchronisation)
                try {
                    const response = await fetch('/api/zones/load?tool_type=isochrone', {
                        method: 'GET',
                        credentials: 'include'
                    });

                    const result = await response.json();
                    if (
                        workspaceLoadGeneration !== this.workspaceLoadGeneration
                        || resetGeneration !== homeWorkspaceScopeResetGeneration('zones')
                        || (
                            automatic
                            && (
                                isHomeWorkspaceScopeReset('zones')
                                || (historyManager?.openIntentSequence || 0) !== restoreOpenSequence
                            )
                        )
                    ) {
                        return false;
                    }

                    if (result.success && result.zones_data) {
                        const zonesData = result.zones_data;
                        if (
                            !zonesData
                            || typeof zonesData !== 'object'
                            || Array.isArray(zonesData)
                        ) {
                            return false;
                        }
                        const selected = window.MaplyticsHomeWorkspaceDraft
                            ?.selectFreshestZoneSnapshot?.({
                                localSnapshot: loadedFromLocal ? localZonesData : null,
                                serverSnapshot: zonesData,
                            });
                        if (selected?.source === 'local') {
                            (window.debugLog || (() => {}))(
                                'Zones locales conservées car plus récentes que la sauvegarde serveur',
                            );
                            return true;
                        }
                        const prepared = this.prepareSavedZonesSnapshot(zonesData);
                        this.replaceZonesFromSavedSnapshot(prepared);
                        return true;
                    }

                    return false;
                } catch (error) {
                    console.error('Erreur chargement zones:', error);
                    return false;
                }
            },

            async resetZones() {
                const zoneCount = this.zones?.size || 0;
                const zoneLabel = zoneCount > 1 ? `${zoneCount} zones sauvegardées` : 'les zones sauvegardées';
                const message = `Supprimer définitivement ${zoneLabel} ?\n\nCette action efface les zones enregistrées sur votre compte pour cet outil et vide aussi l'analyse affichée. Pour seulement nettoyer la carte, utilisez "Effacer toutes les zones".`;
                if (!confirm(message)) {
                    return false;
                }

                try {
                    const response = await fetch('/api/zones/reset?tool_type=isochrone', {
                        method: 'DELETE',
                        credentials: 'include'
                    });

                    const result = await response.json();

                    if (result.success) {
                        // Supprimer les zones locales aussi
                        this.clearAllZones();

                        // Masquer le contrôle de réinitialisation historique s'il existe
                        const resetBtn = document.getElementById('resetZonesBtn');
                        if (resetBtn) resetBtn.style.display = 'none';

                        return true;
                    } else {
                        alert('Erreur lors de la suppression: ' + (result.error || 'Erreur inconnue'));
                        return false;
                    }
                } catch (error) {
                    console.error('Erreur reset zones:', error);
                    alert('Erreur lors de la suppression. Vérifiez votre connexion.');
                    return false;
                }
            }
        };

        const homeZoneCreateController = window.MaplyticsZoneCreateDialog?.create({
            colors: zonesManager.colors,
            getDurationLimits: () => {
                try {
                    return JSON.parse(exportMinutesInput?.dataset.transportLimits || '{}');
                } catch (_error) {
                    return {};
                }
            },
            getTransportOptionAccess: () => zonesManager.getTransportOptionAccess(),
            onSubmit: (payload, hooks) => zonesManager.createZonesFromDialog(payload, hooks),
            onCancel: () => false,
            onComplete: (createdRows) => {
                showAppMessage(
                    'success',
                    createdRows.length > 1 ? 'Zones créées' : 'Zone créée',
                    `${createdRows.length} calcul${createdRows.length > 1 ? 's ont' : ' a'} abouti.`,
                );
            },
            resolveTrigger: () => document.getElementById('addZoneBtn'),
        });

        const homeZoneEditController = window.MaplyticsZoneEditDialog?.create({
            getDurationLimits: () => {
                try {
                    return JSON.parse(exportMinutesInput?.dataset.transportLimits || '{}');
                } catch (_error) {
                    return {};
                }
            },
            transportLabels: transportModeLabels,
            onSubmit: (payload) => zonesManager.submitEditDialog(payload),
            onCancel: (zoneId) => zonesManager.handleEditDialogCancelled(zoneId),
            resolveTrigger: (zoneId) => document.querySelector(
                `.home-zone-row[data-zone-id="${zoneId}"] `
                + '.home-zone-row__secondary > summary'
            ),
        });

        const resolveVisualZoneSource = (zone) => {
            const metadata = zone?.data?.metadata || {};
            const featureProvider = zone?.geojson?.features?.find(
                (feature) => feature?.properties?.layer === 'isochrone'
            )?.properties?.provider;
            const source = metadata.isochrone_provider
                || metadata.routing_provider
                || metadata.provider
                || zone?.data?.provider
                || featureProvider;
            return source ? String(source) : 'Non disponible';
        };

        const exportVisualZones = () => Array.from(zonesManager.zones.entries()).map(([zoneId, zone]) => {
            const zoneLayer = exportMapController?.zonesLayers?.get(zoneId);
            const presentation = window.maplyticsZonePresentationController?.getSnapshot?.();
            const projectedZone = presentation?.projection?.zones?.find(
                (candidate) => String(candidate.zone_id) === String(zoneId),
            );
            const pointKey = window.MaplyticsHomeZoneHierarchy?.pointIdentity?.(zone)
                || String(zoneId);
            return {
                id: zoneId,
                name: presentation?.mode === 'exclusive' && projectedZone?.range_label
                    ? (
                        /^(?:zone(?:\s+de)?\s+)?\d+(?:[.,]\d+)?\s*(?:min|km)$/i.test(
                            String(zone.name || ''),
                        )
                            ? projectedZone.range_label
                            : `${zone.name} · ${projectedZone.range_label}`
                    )
                    : zone.name,
                folder: String(zone.folder || '').trim() || 'Sans dossier',
                pointName: zonePointName(zone),
                originAddress: zoneOriginAddress(zone),
                origin: zone.origin,
                originStyle: zonesManager.getOriginMarkerStyle(zone),
                pointKey,
                pointVisible: zonesManager.hierarchyController
                    ?.isPointVisible?.(pointKey) !== false,
                color: zone.color,
                transportMode: zonesManager.resolveTransportMode(zone),
                zoneType: zone.zoneType || 'isochrone',
                measureValue: zone.minutes,
                source: resolveVisualZoneSource(zone),
                visible: Boolean(
                    zoneLayer?.layer
                    && zoneLayer.visible !== false
                ),
            };
        });
        const activeImportVisualSnapshot = () => (
            importDetailedExportAdapter?.getVisualSnapshot?.() || {
                sourceFingerprint: '', mode: 'cumulative', zones: [], points: [],
            }
        );

        window.maplyticsVisualExportController = window.MaplyticsMapVisualExport?.createController({
            includeMapState: true,
            getZones: () => activeVisualExportSurface === 'import'
                ? activeImportVisualSnapshot().zones
                : exportVisualZones(),
            getGeometryContract: () => (
                activeVisualExportSurface === 'import'
                    ? importMapController?.getIsochroneGeometryModeContract?.()
                    : exportMapController?.getIsochroneGeometryModeContract?.()
            ) || {},
            getSourceFingerprint: () => activeVisualExportSurface === 'import'
                ? activeImportVisualSnapshot().sourceFingerprint
                : window.maplyticsZonePresentationController
                    ?.getSnapshot?.().projectionFingerprint || '',
            onInvalidated: ({ reason }) => {
                document.dispatchEvent(new CustomEvent('maplytics:visual-export-invalidated', {
                    detail: { reason, surface: activeVisualExportSurface },
                }));
            },
        }) || null;
        window.maplyticsVisualExportDialog = window.maplyticsVisualExportController
            ? window.MaplyticsMapVisualExport.createDialogController({
                legendController: window.maplyticsVisualExportController,
                exporter: window.MaplyticsVisualExportRenderer?.createExporter?.(),
                manageTrigger: false,
                getMapSnapshot: (previewState) => {
                    if (activeVisualExportSurface === 'import') {
                        const runtime = importVisualRuntime();
                        if (!runtime.available) throw new Error(runtime.reason);
                    }
                    const current = window.maplyticsVisualExportController.getSnapshot();
                    if (current.fingerprint !== previewState?.snapshot?.fingerprint) {
                        throw new Error('La carte a changé. Actualisez l’aperçu puis réessayez.');
                    }
                    const importSnapshot = activeImportVisualSnapshot();
                    const mapController = activeVisualExportSurface === 'import'
                        ? importMapController
                        : exportMapController;
                    return mapController?.captureVisualExportSnapshot?.(
                        current,
                        previewState.config,
                        {
                            surface: activeVisualExportSurface,
                            mode: activeVisualExportSurface === 'import'
                                ? importSnapshot.mode
                                : window.maplyticsZonePresentationController
                                    ?.getSnapshot?.().mode || 'cumulative',
                            sourceFingerprint: activeVisualExportSurface === 'import'
                                ? importSnapshot.sourceFingerprint
                                : window.maplyticsZonePresentationController
                                    ?.getSnapshot?.().projectionFingerprint
                                    || current.fingerprint,
                            getPoints: activeVisualExportSurface === 'import'
                                ? () => importSnapshot.points
                                : () => [],
                        },
                    );
                },
            })
            : null;
        const activateVisualExportSurface = (surface = 'export') => {
            activeVisualExportSurface = surface === 'import' ? 'import' : 'export';
            return window.maplyticsVisualExportController?.sync?.(
                `surface-${activeVisualExportSurface}`,
            );
        };
        window.maplyticsGetVisualExportAvailability = (surface = 'export') => {
            const resolvedSurface = surface === 'import' ? 'import' : 'export';
            if (resolvedSurface === 'import') {
                const visualRuntime = importVisualRuntime();
                return importDetailedExportAdapter?.getAvailability?.({
                    excelAllowed: typeof window.maplyticsHasFeature === 'function'
                        && window.maplyticsHasFeature('export_excel'),
                    visualRuntimeAvailable: visualRuntime.available,
                    visualRuntimeReason: visualRuntime.reason,
                }).visual || {available: false, reason: 'Import non disponible.'};
            }
            const zones = exportVisualZones().filter((zone) => zone.visible !== false);
            return zones.length && exportMapController?.captureVisualExportSnapshot
                ? {
                    available: true,
                    reason: `${zones.length} zone${zones.length > 1 ? 's' : ''} visible${zones.length > 1 ? 's' : ''}, prête${zones.length > 1 ? 's' : ''} pour l’aperçu PNG/SVG.`,
                }
                : {
                    available: false,
                    reason: 'Pré-requis : créez et affichez une zone sur la carte.',
                };
        };
        window.openLegendCustomizationPanel = (mapId = 'exportMap', trigger = null) => {
            const surface = mapId === 'importMap' ? 'import' : 'export';
            activateVisualExportSurface(surface);
            return window.maplyticsVisualExportDialog?.open?.(
                trigger || document.getElementById(
                    surface === 'import' ? 'importVisualMapBtn' : 'customizeLegendBtn',
                ),
            );
        };
        [
            ['customizeLegendBtn', 'exportMap'],
            ['importVisualMapBtn', 'importMap'],
        ].forEach(([buttonId, mapId]) => {
            const button = document.getElementById(buttonId);
            if (!button || button.dataset.visualExportBound === '1') return;
            button.dataset.visualExportBound = '1';
            button.addEventListener('click', (event) => {
                event.preventDefault();
                if (button.disabled) return;
                window.openLegendCustomizationPanel(mapId, button);
            });
        });

        // ============================================
        // HELPERS SIRENE — Enrichissement concurrents
        // ============================================
        const EFFECTIF_LABELS = {
            "00": "0 salarié", "01": "1-2 salariés", "02": "3-5 salariés",
            "03": "6-9 salariés", "11": "10-19 salariés", "12": "20-49 salariés",
            "21": "50-99 salariés", "22": "100-199 salariés", "31": "200-249 salariés",
            "32": "250-499 salariés", "41": "500-999 salariés", "42": "1000-1999 salariés",
            "51": "2000-4999 salariés", "52": "5000-9999 salariés", "53": "10000+ salariés"
        };
        const getEffectifLabel = (code) => EFFECTIF_LABELS[code] || '';
        const getCompanyAge = (dateCreation) => {
            if (!dateCreation) return null;
            const created = new Date(dateCreation);
            if (isNaN(created.getTime())) return null;
            return Math.floor((new Date() - created) / (365.25 * 24 * 60 * 60 * 1000));
        };

        // Score de saturation (B) : nombre de concurrents dans la zone
        const calculateSaturation = (count) => {
            if (count <= 3) return { level: 'low', label: 'Faible concurrence', emoji: '🟢', description: 'Peu de concurrents dans cette zone' };
            if (count <= 8) return { level: 'medium', label: 'Concurrence modérée', emoji: '🟡', description: 'Concurrence modérée dans cette zone' };
            return { level: 'high', label: 'Forte concurrence', emoji: '🔴', description: 'Zone très concurrentielle' };
        };
        const renderSaturationBadge = (count, gate) => {
            const sat = calculateSaturation(count);
            const detail = gate && gate.level === 'premium'
                ? `<span style="font-size: 0.8rem; color: #64748b; margin-left: 0.5rem;">${sat.description} (${count} concurrent${count > 1 ? 's' : ''})</span>`
                : '';
            return `<div style="display: flex; align-items: center; gap: 0.5rem; margin-bottom: 0.75rem;">
                <span class="saturation-badge saturation-badge--${sat.level}">${sat.emoji} ${sat.label}</span>${detail}
            </div>`;
        };

        // ============================================
        // COMPETITORS MANAGER (Onglet 2 Concurrents)
        // ============================================
        // Factory function pour créer un competitorsManager
        // Bug #4 Fix: Ajouter prefix comme 6ème paramètre pour les sélecteurs d'éléments
        const createCompetitorsManager = (toolType, mapControllerVar, latInputId, lonInputId, scopeSelector, prefix = '') => {
            return {
            prefix: prefix, // Bug #4 Fix: Stocker le prefix pour les sélecteurs
            competitors: [], // Liste des concurrents
            markersLayer: null, // LayerGroup Leaflet pour les markers
            competitorMarkerRegistry: new Map(), // Marqueurs Leaflet indexés, mis à jour sans recréer le layer
            visibleOnMap: false, // État de visibilité sur la carte
            competitorsNumbered: false,
            nextCompetitorDisplayReference: 1,
            competitorMarkerColor: window.MaplyticsCompetitorSearch.DEFAULT_COMPETITOR_MARKER_COLOR,
            competitorMarkerScale: 'normal',
            attractivenessLayer: null,
            attractivenessVisible: false,
            attractivenessResults: {},
            attractivenessSearchInfo: {},
            attractivenessSelectedCategories: [],
            attractivenessVisualEncoding: window.MaplyticsCompetitorVisualEncoding.normalize(),
            attractivenessSource: null,
            _attractPanel: null,
            _attractivenessModal: null,
            lastSearchResults: [],
            lastSearchInfo: {},
            lastCompetitorRouteOrigins: [],
            competitorSearchSnapshot: null,
            competitorFilterState: null,
            competitorWorkspaceController: window.MaplyticsCompetitorWorkspace.createController(),
            hiddenCompetitorIds: [],
            removedItems: [],
            _competitorSnapshotSaveTimer: null,
            _competitorSnapshotStale: false,
            _competitorSnapshotStaleTarget: '',
            _competitorSnapshotStaleRevision: 0,
            _competitorSnapshotStaleByTarget: {},
            _competitorSnapshotSyncHandler: null,
            _competitorRoutingRequest: null,
            _competitorRoutingAbortController: null,
            _competitorRoutingGeneration: 0,
            _applyingCompetitorRouting: false,
            _competitorRoutingCoordinator: null,
            competitorRoutingSnapshot: {
                schema_version: 'home_competitor_routing_snapshot_v3',
                fingerprint: '',
                status: 'idle',
                selected_ids: [],
                total: 0,
                processed: 0,
                succeeded: 0,
                failed: 0,
                batch_index: 0,
                batch_count: 0,
                rows: [],
                summary: null,
                calculated_at: null,
                last_failure: null,
                failed_batches: [],
                generation: 0,
            },
            _competitorSearchAbortController: null,
            _activeCompetitorSearchScope: null,
            _competitorScopeInvalidationMessage: '',
            _zoneScopeFingerprints: new Map(),
            _zoneScopeSyncHandler: null,
            competitorThreatScore: null,
            _competitorThreatScoreRequest: 0,
            _threatScoreConfiguration: null,
            _competitorSaveSequence: 0,
            _competitorSaveTail: Promise.resolve(),
            _competitorStateGeneration: 0,
            _workspaceRequestGeneration: 0,
            _competitorRestoreSequence: 0,
            _competitorRestoreAbortController: null,
            _competitorRestorePending: 0,
            _competitorRestoreTarget: '',
            _competitorRestoreTargetSequence: 0,
            _competitorPersistenceBlocked: false,
            _competitorActiveProjectId: '',
            _competitorTerritoryContext: null,
            _competitorTerritorySyncing: false,
            _competitorViewSnapshotDate: '',
            _competitorSnapshotSender: `home-${toolType}-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`,
            COMPETITOR_SEARCH_SNAPSHOT_SCHEMA: 'home_competitor_search_snapshot_v1',
            COMPETITOR_SEARCH_SNAPSHOT_MAX_RESULTS: 1000,
            COMPETITOR_SEARCH_SNAPSHOT_MAX_BYTES: 2 * 1024 * 1024,
            competitorFilterBuilder: null,
            ATTRACTIVENESS_CATEGORIES: {
                gsa:        { label: 'Grandes surfaces',  codes: ['47.11A','47.11B','47.11C','47.11D','47.11E','47.11F'], emoji: '🏪', color: '#ef4444', weight: 3 },
                pharmacy:   { label: 'Pharmacies',        codes: ['47.73Z'], emoji: '💊', color: '#10b981', weight: 2 },
                bank:       { label: 'Banques',           codes: ['64.19Z'], emoji: '🏦', color: '#3b82f6', weight: 1 },
                restaurant: { label: 'Restauration',      codes: ['56.10A'], emoji: '🍽️', color: '#f59e0b', weight: 1 },
                education:  { label: 'Éducation',         codes: ['85.20Z','85.31Z'], emoji: '🏫', color: '#8b5cf6', weight: 1 },
            },

            // Filtres concurrents. Aucun score de menace implicite sans catalogue validé.
            filterText: '',
            competitorViewFilters: {},

            // Points personnalisés (adresse/GPS manuels)
            customPoints: [],
            customPointsLayer: null,
            customPointsVisible: true,
            networkPointBatches: [],
            networkSelectedOrigin: null,
            networkRevision: 0,
            networkFingerprint: '',
            networkNextDisplayReference: 1,
            networkVisiblePointLimit: 200,
            selectMode: false,
            selectedPointIds: new Set(),
            pointFolders: [
                { id: 'default', name: 'Points personnalisés', parentId: null, color: '#2563eb' }
            ],
            POINT_ICONS: {
                'number': { emoji: '#', label: 'Numéroté' },
                'pin': { emoji: '📍', label: 'Pin' },
                'shop': { emoji: '🏪', label: 'Magasin' },
                'restaurant': { emoji: '🍽️', label: 'Restaurant' },
                'office': { emoji: '🏢', label: 'Bureau' },
                'star': { emoji: '⭐', label: 'Favori' },
                'warning': { emoji: '⚠️', label: 'Attention' },
                'home': { emoji: '🏠', label: 'Domicile' },
                'hospital': { emoji: '🏥', label: 'Santé' },
                'school': { emoji: '🏫', label: 'Éducation' },
                'factory': { emoji: '🏭', label: 'Usine' },
                'cart': { emoji: '🛒', label: 'Commerce' },
                'car': { emoji: '🚗', label: 'Auto' },
                'coffee': { emoji: '☕', label: 'Café' },
            },
            PRESET_COLORS: ['#ef4444', '#f59e0b', '#10b981', '#3b82f6', '#8b5cf6', '#ec4899', '#6b7280'],

            applyCompetitorWorkspaceSnapshot(snapshot) {
                if (!snapshot || snapshot.schema_version !== window.MaplyticsCompetitorWorkspace.SCHEMA) {
                    throw new Error('Snapshot workspace Concurrents invalide.');
                }
                this.competitors = snapshot.rows.map((row) => ({ ...row }));
                this.filterText = snapshot.filters.searchText || '';
                this.competitorViewFilters = window.MaplyticsCompetitorSearch.normalizeViewFilters({
                    ...snapshot.filters,
                    searchText: '',
                });
                this.visibleOnMap = snapshot.presentation.visible_on_map;
                this.competitorsNumbered = snapshot.presentation.numbered;
                this.competitorMarkerColor = snapshot.presentation.marker_color;
                this.competitorMarkerScale = snapshot.presentation.marker_scale;
                this.pointsLegendVisible = snapshot.presentation.legend_visible;
                this.hiddenCompetitorIds = [...snapshot.visibility.hidden_ids];
                this.removedItems = snapshot.removed.items.map((item) => ({ ...item }));
                this.competitorThreatScore = snapshot.score
                    ? JSON.parse(JSON.stringify(snapshot.score))
                    : null;
                return snapshot;
            },

            dispatchCompetitorWorkspace(action) {
                const invalidatingTypes = new Set([
                    'competitors/add',
                    'competitors/replace',
                    'competitors/remove',
                    'removed/restore',
                    'filters/set',
                    'hydrate',
                    'reset',
                ]);
                const actionTypes = action?.type === 'transaction'
                    ? (action.actions || []).map((entry) => String(entry?.type || ''))
                    : [String(action?.type || '')];
                const previousRoutingFingerprint = String(
                    this.competitorWorkspaceController.snapshot()?.view?.fingerprint || '',
                );
                const result = this.competitorWorkspaceController.dispatch(action);
                if (result.applied) {
                    // Any accepted workspace mutation is newer than an automatic
                    // restore that may still be in flight.  Track it centrally so
                    // a late server response can never replace user, project or
                    // browser-restored state.
                    this._competitorStateGeneration += 1;
                    this.applyCompetitorWorkspaceSnapshot(result.snapshot);
                }
                const nextRoutingFingerprint = String(result.snapshot?.view?.fingerprint || '');
                if (
                    result.applied
                    && !this._applyingCompetitorRouting
                    && actionTypes.some((type) => invalidatingTypes.has(type))
                    && previousRoutingFingerprint !== nextRoutingFingerprint
                ) {
                    this.invalidateCompetitorRoutingSnapshot(
                        'La liste ou le filtre des concurrents a changé.',
                    );
                }
                return result;
            },

            hydrateCompetitorWorkspace({ search = undefined } = {}) {
                const currentSearch = search === undefined
                    ? this.competitorWorkspaceController.snapshot().search
                    : search;
                return this.dispatchCompetitorWorkspace({
                    type: 'hydrate',
                    state: {
                        rows: this.competitors,
                        filters: {
                            ...(this.competitorViewFilters || {}),
                            searchText: this.filterText,
                        },
                        selectionIds: this.competitorWorkspaceController.snapshot().selection.ids,
                        hiddenIds: this.hiddenCompetitorIds,
                        removedItems: this.removedItems,
                        visibleOnMap: this.visibleOnMap,
                        numbered: this.competitorsNumbered,
                        markerColor: this.competitorMarkerColor,
                        markerScale: this.competitorMarkerScale,
                        legendVisible: this.pointsLegendVisible,
                        score: this.competitorThreatScore,
                        search: currentSearch,
                    },
                }).snapshot;
            },

            // Calcul distance vol d'oiseau (km)
            haversineDistance(lat1, lon1, lat2, lon2) {
                const R = 6371;
                const dLat = (lat2 - lat1) * Math.PI / 180;
                const dLon = (lon2 - lon1) * Math.PI / 180;
                const a = Math.sin(dLat/2)**2 + Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * Math.sin(dLon/2)**2;
                return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
            },

            normalizeSearchAreaGeojson(geojson) {
                if (!geojson || typeof geojson !== 'object') {
                    return null;
                }
                const normalizeFeature = (item) => {
                    if (!item || typeof item !== 'object') {
                        return [];
                    }
                    if (item.type === 'FeatureCollection') {
                        return (item.features || []).flatMap(normalizeFeature);
                    }
                    if (item.type === 'Feature') {
                        const geometryType = item.geometry?.type;
                        if (geometryType === 'Polygon' || geometryType === 'MultiPolygon') {
                            return [{
                                type: 'Feature',
                                properties: item.properties || {},
                                geometry: item.geometry,
                            }];
                        }
                        return [];
                    }
                    if (item.type === 'Polygon' || item.type === 'MultiPolygon') {
                        return [{ type: 'Feature', properties: {}, geometry: item }];
                    }
                    return [];
                };
                const features = normalizeFeature(geojson);
                return features.length ? { type: 'FeatureCollection', features } : null;
            },

            currentMapController() {
                return toolType === 'isochrone' ? exportMapController : importMapController;
            },

            referencePoint() {
                const lat = Number(document.getElementById(latInputId)?.value);
                const lon = Number(document.getElementById(lonInputId)?.value);
                if (!Number.isFinite(lat) || !Number.isFinite(lon)) return null;
                if (lat < -90 || lat > 90 || lon < -180 || lon > 180) return null;
                return {
                    lat,
                    lon,
                    label: document.getElementById(toolType === 'isochrone' ? 'exportQuery' : 'importQuery')?.value?.trim()
                        || 'Point de référence',
                };
            },

            competitorScopeDefinitions() {
                const baseParams = this.getSearchParams();
                const pointRadiusKm = Number(baseParams?.radiusKm || 50);
                const otherDefinitions = [{
                    value: 'viewport',
                    type: 'viewport',
                    label: 'Carte visible (par défaut)',
                    description: "Les limites visibles seront capturées exactement au lancement. Aucun rayon implicite n'est ajouté.",
                }];
                const origin = this.referencePoint();
                if (origin) {
                    otherDefinitions.push({
                        value: 'point:origin',
                        type: 'point',
                        label: `${origin.label} · rayon ${pointRadiusKm} km`,
                        description: `Recherche autour du point exact, dans un rayon explicite de ${pointRadiusKm} km.`,
                        point: origin,
                        radiusKm: pointRadiusKm,
                    });
                }
                (this.customPoints || []).forEach((point) => {
                    const lat = Number(point?.lat);
                    const lon = Number(point?.lon ?? point?.lng);
                    if (!Number.isFinite(lat) || !Number.isFinite(lon)) return;
                    if (lat < -90 || lat > 90 || lon < -180 || lon > 180) return;
                    otherDefinitions.push({
                        value: `point:${point.id}`,
                        type: 'point',
                        label: `${point.name || 'Point'} · rayon ${pointRadiusKm} km`,
                        description: `Recherche autour du point exact, dans un rayon explicite de ${pointRadiusKm} km.`,
                        point: { lat, lon, label: point.name || 'Point' },
                        radiusKm: pointRadiusKm,
                    });
                });
                if (toolType !== 'isochrone') return otherDefinitions;

                const zoneDefinitions = window.MaplyticsCompetitorSearch.buildZoneScopeDefinitions(
                    Array.from(zonesManager.zones.values()),
                );
                if (!zoneDefinitions.length) return otherDefinitions;
                const priorityZones = zoneDefinitions
                    .filter((item) => ['zdc_union', 'zdc'].includes(item.type))
                    .map((item) => ({
                        ...item,
                        groupLabel: 'ZDC prioritaires',
                        preferred: item.type === 'zdc_union',
                    }));
                const secondary = [
                    ...otherDefinitions.map((item) => ({
                        ...item,
                        label: item.type === 'viewport' ? 'Carte visible' : item.label,
                    })),
                    ...zoneDefinitions.filter((item) => item.type === 'folder'),
                ].map((item) => ({ ...item, groupLabel: 'Autres périmètres' }));
                return [...priorityZones, ...secondary];
            },

            competitorScopeOptions() {
                return this.competitorScopeDefinitions().map(({ value, type, label, description, fingerprint, groupLabel, preferred }) => ({
                    value,
                    type,
                    label,
                    description,
                    fingerprint,
                    groupLabel,
                    preferred,
                }));
            },

            resolveCompetitorScope(value) {
                const selected = this.competitorScopeDefinitions().find((item) => item.value === value);
                if (!selected) {
                    throw new Error('Ce périmètre n’est plus disponible. Choisissez-en un autre.');
                }
                if (selected.type === 'viewport') {
                    const map = this.currentMapController()?.map;
                    const bounds = map?.getBounds?.();
                    const center = map?.getCenter?.();
                    if (!bounds?.isValid?.() || !center) {
                        throw new Error('La carte n’est pas encore prête. Attendez son affichage puis réessayez.');
                    }
                    const southWest = bounds.getSouthWest();
                    const northEast = bounds.getNorthEast();
                    const values = [southWest.lat, southWest.lng, northEast.lat, northEast.lng, center.lat, center.lng];
                    if (!values.every(Number.isFinite)) {
                        throw new Error('La zone visible de la carte est invalide.');
                    }
                    const geometry = {
                        type: 'Feature',
                        properties: { source: 'viewport' },
                        geometry: {
                            type: 'Polygon',
                            coordinates: [[
                                [southWest.lng, southWest.lat],
                                [northEast.lng, southWest.lat],
                                [northEast.lng, northEast.lat],
                                [southWest.lng, northEast.lat],
                                [southWest.lng, southWest.lat],
                            ]],
                        },
                    };
                    const radiusKm = Math.max(0.1, Math.min(
                        50,
                        Math.ceil(this.haversineDistance(center.lat, center.lng, northEast.lat, northEast.lng) * 100) / 100,
                    ));
                    return {
                        value: selected.value,
                        type: selected.type,
                        label: 'Carte visible',
                        lat: center.lat,
                        lon: center.lng,
                        radiusKm,
                        searchAreaGeojson: geometry,
                        searchScope: { type: 'viewport', label: 'Carte visible' },
                    };
                }
                if (selected.type === 'point') {
                    const point = selected.point;
                    if (!point || !Number.isFinite(point.lat) || !Number.isFinite(point.lon)) {
                        throw new Error('Les coordonnées de ce point ne sont plus disponibles.');
                    }
                    return {
                        value: selected.value,
                        type: selected.type,
                        label: point.label || 'Point',
                        lat: point.lat,
                        lon: point.lon,
                        radiusKm: selected.radiusKm,
                        searchAreaGeojson: null,
                        searchScope: {
                            type: 'point',
                            label: point.label || 'Point',
                            geometry: { type: 'Point', coordinates: [point.lon, point.lat] },
                        },
                    };
                }
                const geometry = this.normalizeSearchAreaGeojson(selected.geometry);
                const point = selected.point || getGeoJsonApproximateCenter(geometry);
                if (!geometry || !point || !Number.isFinite(Number(point.lat)) || !Number.isFinite(Number(point.lon))) {
                    throw new Error('La géométrie exacte de ce périmètre n’est plus disponible.');
                }
                return {
                    value: selected.value,
                    type: selected.type,
                    label: selected.label.replace(/^(ZDC|Dossier) · /, ''),
                    lat: Number(point.lat),
                    lon: Number(point.lon),
                    radiusKm: Number(this.getSearchParams()?.radiusKm || 50),
                    searchAreaGeojson: geometry,
                    searchScope: {
                        type: selected.type,
                        label: selected.label.replace(/^(ZDC|Dossier) · /, ''),
                        fingerprint: selected.fingerprint,
                    },
                };
            },

            escapeCompetitorText(value) {
                return String(value ?? '').replace(/[&<>"']/g, (char) => ({
                    '&': '&amp;',
                    '<': '&lt;',
                    '>': '&gt;',
                    '"': '&quot;',
                    "'": '&#39;'
                })[char]);
            },

            competitorIdentity(comp) {
                return window.MaplyticsCompetitorSearch.competitorIdentity(comp);
            },

            competitorRoutingRequestKey(origins, routeRows, viewFingerprint = '') {
                const normalizedOrigins = (Array.isArray(origins) ? origins : []).map((origin) => ({
                    id: String(origin?.id || ''),
                    lat: Number(origin?.lat),
                    lon: Number(origin?.lon ?? origin?.lng),
                }));
                const normalizedCompetitors = (Array.isArray(routeRows) ? routeRows : []).map((entry) => {
                    const competitor = entry?.comp || entry;
                    return {
                        id: this.competitorIdentity(competitor),
                        lat: Number(competitor?.lat ?? competitor?.latitude),
                        lon: Number(competitor?.lon ?? competitor?.lng ?? competitor?.longitude),
                    };
                });
                return JSON.stringify({
                    view_fingerprint: String(viewFingerprint || ''),
                    origins: normalizedOrigins,
                    competitors: normalizedCompetitors,
                });
            },

            setCompetitorRoutingSnapshot(patch = {}) {
                const previous = this.competitorRoutingSnapshot || {};
                const next = {
                    schema_version: 'home_competitor_routing_snapshot_v3',
                    fingerprint: String(patch.fingerprint ?? previous.fingerprint ?? ''),
                    status: String(patch.status || previous.status || 'idle'),
                    selected_ids: Array.isArray(patch.selected_ids)
                        ? [...patch.selected_ids]
                        : Array.isArray(previous.selected_ids) ? [...previous.selected_ids] : [],
                    total: Number(patch.total ?? previous.total ?? 0),
                    processed: Number(patch.processed ?? previous.processed ?? 0),
                    succeeded: Number(patch.succeeded ?? previous.succeeded ?? 0),
                    failed: Number(patch.failed ?? previous.failed ?? 0),
                    batch_index: Number(patch.batch_index ?? previous.batch_index ?? 0),
                    batch_count: Number(patch.batch_count ?? previous.batch_count ?? 0),
                    rows: Array.isArray(patch.rows)
                        ? patch.rows.map((row) => ({ ...row }))
                        : Array.isArray(previous.rows) ? previous.rows.map((row) => ({ ...row })) : [],
                    summary: Object.prototype.hasOwnProperty.call(patch, 'summary')
                        ? (patch.summary ? { ...patch.summary } : null)
                        : (previous.summary ? { ...previous.summary } : null),
                    calculated_at: Object.prototype.hasOwnProperty.call(patch, 'calculated_at')
                        ? patch.calculated_at
                        : previous.calculated_at || null,
                    last_failure: Object.prototype.hasOwnProperty.call(patch, 'last_failure')
                        ? (patch.last_failure ? { ...patch.last_failure } : null)
                        : (previous.last_failure ? { ...previous.last_failure } : null),
                    failed_batches: Array.isArray(patch.failed_batches)
                        ? patch.failed_batches.map((batch) => ({ ...batch }))
                        : Array.isArray(previous.failed_batches)
                            ? previous.failed_batches.map((batch) => ({ ...batch }))
                            : [],
                    generation: Number(patch.generation ?? previous.generation ?? 0),
                };
                this.competitorRoutingSnapshot = next;
                return next;
            },

            invalidateCompetitorRoutingSnapshot(reason = 'Le contexte routier a changé.') {
                this._competitorRoutingGeneration += 1;
                this._competitorRoutingAbortController?.abort?.();
                this._competitorRoutingAbortController = null;
                this._competitorRoutingRequest = null;
                const previous = this.competitorRoutingSnapshot || {};
                if (previous.status === 'idle' && !previous.fingerprint) return previous;
                return this.setCompetitorRoutingSnapshot({
                    status: 'stale',
                    generation: this._competitorRoutingGeneration,
                    last_failure: {
                        code: 'COMPETITOR_ROUTE_CONTEXT_CHANGED',
                        reason: 'context_changed',
                        action: 'retry',
                        action_label: 'Recalculer',
                        message: String(reason || 'Le contexte routier a changé.'),
                        failed_at: new Date().toISOString(),
                    },
                });
            },

            competitorRoutingSnapshotText() {
                const snapshot = this.competitorRoutingSnapshot || {};
                const summary = snapshot.summary || {};
                if (snapshot.status === 'running') {
                    return `Calcul Valhalla ${Number(snapshot.processed || 0)}/${Number(snapshot.total || 0)}`
                        + (snapshot.batch_count
                            ? ` · lot ${Math.min(Number(snapshot.batch_index || 1), Number(snapshot.batch_count))}/${Number(snapshot.batch_count)}`
                            : '');
                }
                if (snapshot.status === 'partial') {
                    return `${Number(snapshot.succeeded || 0)}/${Number(snapshot.total || 0)} concurrents calculés`
                        + ` · ${Number(snapshot.failed || 0)} en échec · relancer les lots échoués`;
                }
                if (snapshot.status === 'cancelled') return 'Calcul routier annulé.';
                if (snapshot.status === 'available') {
                    const reachable = Number(summary.reachable || 0);
                    const unreachable = Number(summary.unreachable || 0);
                    return `${reachable} trajet${reachable > 1 ? 's' : ''} calculé${reachable > 1 ? 's' : ''}`
                        + (unreachable ? ` · ${unreachable} injoignable${unreachable > 1 ? 's' : ''}` : '');
                }
                if (snapshot.status === 'empty') return 'Aucun concurrent inclus à calculer.';
                if (snapshot.status === 'stale') return 'Trajets à recalculer après modification de la vue.';
                if (snapshot.status === 'error') {
                    return snapshot.rows?.length
                        ? 'Dernier résultat conservé · nouveau calcul en échec.'
                        : 'Calcul routier indisponible.';
                }
                return 'Trajets voiture non calculés.';
            },

            normalizeCompetitorRoutingFailure(payload, status = 0) {
                const source = payload && typeof payload === 'object' ? payload : {};
                const actionLabels = {
                    retry: 'Réessayer',
                    reduce_selection: 'Réduire la sélection',
                    reduce_or_correct_selection: 'Corriger ou réduire la sélection',
                    correct_point: 'Corriger le point',
                    change_mode: 'Changer de mode',
                };
                const action = String(source.action || 'retry');
                return {
                    code: String(source.code || 'COMPETITOR_ROUTE_UNAVAILABLE'),
                    reason: String(source.reason || 'provider_unavailable'),
                    action,
                    action_label: String(
                        source.action_label
                        || source.recommended_action_label
                        || actionLabels[action]
                        || 'Réessayer',
                    ),
                    message: String(source.error || source.message || 'Calcul routier indisponible.'),
                    http_status: Number(status) || null,
                    failed_at: new Date().toISOString(),
                };
            },

            competitorRoadMeasure(value) {
                if (value === null || value === undefined || value === '') return null;
                const numeric = Number(value);
                return Number.isFinite(numeric) && numeric >= 0 ? numeric : null;
            },

            competitorRouteOriginState(origin) {
                const label = String(origin?.origin_label || origin?.origin_id || 'Origine');
                const distance = this.competitorRoadMeasure(origin?.road_distance_km);
                const duration = this.competitorRoadMeasure(origin?.road_duration_minutes);
                if (
                    origin?.routing_status === 'available'
                    && distance !== null
                    && duration !== null
                ) {
                    return `${label}: Disponible`;
                }
                const message = String(
                    origin?.unreachable_message
                    || 'Aucun chemin routier utilisable n’a été trouvé.',
                );
                const action = String(
                    origin?.recommended_action_label
                    || 'Réessayer après avoir vérifié le point et le périmètre.',
                );
                return `${label}: Injoignable — ${message} · Action : ${action}`;
            },

            competitorRoutingFreshnessText(routing) {
                const calculatedAt = String(routing?.calculated_at || '');
                if (!calculatedAt || !Array.isArray(routing?.origins) || !routing.origins.length) {
                    return '';
                }
                const parsed = new Date(calculatedAt);
                if (Number.isNaN(parsed.getTime())) return '';
                return `Dernier résultat valide : ${parsed.toLocaleString('fr-FR')}`;
            },

            competitorRoutingFailureText(routing) {
                const failure = routing?.last_failure;
                if (!failure || typeof failure !== 'object') return '';
                const hasPrevious = Array.isArray(routing?.origins) && routing.origins.length > 0;
                const prefix = hasPrevious
                    ? 'Ancien résultat conservé'
                    : 'Calcul routier indisponible';
                const message = String(failure.message || 'Le calcul routier a échoué.');
                const action = String(failure.action_label || 'Réessayer');
                return `${prefix} — ${message} · Action : ${action}`;
            },

            ensureCompetitorDisplayReferences() {
                const rows = window.MaplyticsCompetitorSearch
                    .assignStableDisplayReferences(this.competitors, {
                        minimumReference: this.nextCompetitorDisplayReference,
                    });
                if (rows.some((row, index) => row !== this.competitors[index])) {
                    this.dispatchCompetitorWorkspace({
                        type: 'competitors/replace',
                        rows,
                        preserveScore: true,
                    });
                }
                const highestReference = this.competitors.reduce(
                    (current, competitor) => Math.max(
                        current,
                        Number(competitor?.display_reference) || 0,
                    ),
                    0,
                );
                this.nextCompetitorDisplayReference = Math.max(
                    Number(this.nextCompetitorDisplayReference) || 1,
                    highestReference + 1,
                );
                return this.competitors;
            },

            setCompetitorMarkerColor(value, { persist = false } = {}) {
                const nextColor = window.MaplyticsCompetitorSearch.normalizeMarkerColor(value);
                const changed = nextColor !== this.competitorMarkerColor;
                if (changed) {
                    this.dispatchCompetitorWorkspace({
                        type: 'presentation/set',
                        patch: { markerColor: nextColor },
                    });
                }
                this.syncCompetitorMarkerColorControl();
                if (!changed) {
                    if (persist) this.saveCompetitors({ quiet: true });
                    return nextColor;
                }
                this.refreshCompetitorViewSurfaces();
                if (persist) this.saveCompetitors({ quiet: true });
                return nextColor;
            },

            syncCompetitorMarkerColorControl() {
                const input = document.querySelector(
                    `${scopeSelector} .competitor-marker-color-input`,
                );
                if (input) input.value = this.competitorMarkerColor;
            },

            setCompetitorMarkerScale(value, { persist = false } = {}) {
                const nextScale = window.MaplyticsCompetitorVisualEncoding
                    .normalizePresentationScale(value);
                const changed = nextScale !== this.competitorMarkerScale;
                if (changed) {
                    this.dispatchCompetitorWorkspace({
                        type: 'presentation/set',
                        patch: { markerScale: nextScale },
                    });
                    this.refreshCompetitorViewSurfaces();
                    if (this.attractivenessVisible) this.showAttractivenessResults();
                    window.maplyticsCompetitorVisualExportDialog?.invalidate?.(
                        'competitor-marker-scale-changed',
                    );
                }
                this.syncCompetitorMarkerScaleControl();
                if (persist) this.saveCompetitors({ quiet: true });
                return nextScale;
            },

            syncCompetitorMarkerScaleControl() {
                const selector = toolType === 'isochrone'
                    ? `${scopeSelector} [data-competitor-marker-scale], #competitorVisualMarkerScale`
                    : `${scopeSelector} [data-competitor-marker-scale]`;
                const controls = document.querySelectorAll(selector);
                controls.forEach((control) => {
                    if (control.value !== this.competitorMarkerScale) {
                        control.value = this.competitorMarkerScale;
                    }
                });
            },

            setCompetitorSaveStatus(state, message, { revision = null, savedAt = '' } = {}) {
                if (revision !== null && revision !== this._competitorSaveSequence) return false;
                const badge = document.querySelector(`${scopeSelector} .save-status-badge`);
                if (!badge) return false;
                badge.dataset.state = String(state || 'idle');
                badge.textContent = String(message || 'État de sauvegarde indisponible');
                badge.style.opacity = '1';
                badge.style.color = ({
                    saving: '#2563eb',
                    saved: '#047857',
                    restored: '#047857',
                    error: '#b91c1c',
                    conflict: '#b91c1c',
                })[state] || '#64748b';
                if (savedAt) badge.dataset.savedAt = String(savedAt);
                else delete badge.dataset.savedAt;
                const retry = document.querySelector(
                    `${scopeSelector} [data-competitor-save-retry]`,
                );
                if (retry) {
                    retry.hidden = state !== 'error';
                    retry.disabled = state === 'saving';
                    if (state === 'error') {
                        const disclosure = retry.closest('details');
                        if (disclosure) disclosure.open = true;
                    }
                }
                return true;
            },

            competitorSnapshotMetadata() {
                const snapshot = this.competitorSearchSnapshot;
                const searchInfo = snapshot?.search_info && typeof snapshot.search_info === 'object'
                    ? snapshot.search_info
                    : {};
                const snapshotDate = String(
                    this._competitorViewSnapshotDate || snapshot?.saved_at || '',
                ).trim();
                const validDate = snapshotDate && !Number.isNaN(Date.parse(snapshotDate))
                    ? snapshotDate
                    : '';
                const source = String(
                    searchInfo.source_label || searchInfo.source || '',
                ).trim() || 'Non disponible';
                const completeness = searchInfo.results_truncated === true
                    ? 'Partielle'
                    : searchInfo.results_truncated === false
                        ? 'Complète selon la source'
                        : 'Non disponible';
                return {
                    snapshotDate: validDate,
                    dateLabel: validDate
                        ? new Date(validDate).toLocaleString('fr-FR')
                        : 'Non disponible',
                    source,
                    completeness,
                };
            },

            updateCompetitorSnapshotMetadata() {
                const node = document.querySelector(
                    `${scopeSelector} .competitor-snapshot-metadata`,
                );
                if (!node) return false;
                const metadata = this.competitorSnapshotMetadata();
                node.dataset.snapshotDate = metadata.snapshotDate;
                node.dataset.snapshotSource = metadata.source;
                node.dataset.snapshotCompleteness = metadata.completeness;
                node.textContent = `Vue : ${metadata.dateLabel} · Source : ${metadata.source} · Complétude : ${metadata.completeness}`;
                return true;
            },

            competitorPersistenceTarget(projectId = null) {
                const selectedProjectId = projectId === null
                    ? String(this._competitorActiveProjectId || '')
                    : String(projectId || '');
                return selectedProjectId
                    ? `project:${selectedProjectId}`
                    : `generic:${toolType}`;
            },

            competitorSnapshotStorageKey(target = this.competitorPersistenceTarget()) {
                return `maplytics_competitor_snapshot_signal:${toolType}:${encodeURIComponent(target)}`;
            },

            competitorTargetStaleRevision(target) {
                return Number(this._competitorSnapshotStaleByTarget?.[String(target || '')] || 0);
            },

            isCompetitorTargetStale(target) {
                return this.competitorTargetStaleRevision(target) > 0;
            },

            markCompetitorTargetStale(target) {
                const normalizedTarget = String(target || '');
                if (!normalizedTarget) return 0;
                this._competitorSnapshotStaleRevision += 1;
                this._competitorSnapshotStaleByTarget[normalizedTarget] = (
                    this._competitorSnapshotStaleRevision
                );
                this._competitorSnapshotStale = true;
                this._competitorSnapshotStaleTarget = normalizedTarget;
                return this._competitorSnapshotStaleRevision;
            },

            clearCompetitorTargetStale(target, expectedRevision = null) {
                const normalizedTarget = String(target || '');
                const currentRevision = this.competitorTargetStaleRevision(normalizedTarget);
                if (
                    expectedRevision !== null
                    && currentRevision !== Number(expectedRevision || 0)
                ) return false;
                delete this._competitorSnapshotStaleByTarget[normalizedTarget];
                const remainingTargets = Object.keys(this._competitorSnapshotStaleByTarget);
                this._competitorSnapshotStale = remainingTargets.length > 0;
                this._competitorSnapshotStaleTarget = remainingTargets.at(-1) || '';
                return true;
            },

            competitorSnapshotFingerprint(snapshot) {
                const fingerprint = window.MaplyticsCompetitorSearch?.fingerprint;
                if (typeof fingerprint !== 'function') return '';
                return fingerprint({
                    query: snapshot.query,
                    result_ids: snapshot.results.map((item) => this.competitorIdentity(item)),
                    search_info: snapshot.search_info,
                    modal_state: snapshot.modal_state,
                });
            },

            initCompetitorSnapshotSync() {
                if (this._competitorSnapshotSyncHandler) return;
                this._competitorSnapshotSyncHandler = (event) => {
                    if (!event.newValue) return;
                    const possibleTargets = [
                        this.competitorPersistenceTarget(),
                        this._competitorRestoreTarget,
                    ].filter((target, index, targets) => target && targets.indexOf(target) === index);
                    const matchedTarget = possibleTargets.find(
                        (target) => event.key === this.competitorSnapshotStorageKey(target),
                    );
                    if (!matchedTarget) return;
                    try {
                        const signal = JSON.parse(event.newValue);
                        if (
                            signal?.sender === this._competitorSnapshotSender
                            || !signal?.write_id
                            || signal?.target !== matchedTarget
                        ) return;
                        this.markCompetitorTargetStale(matchedTarget);
                        this.competitorFilterBuilder?.setStatus?.(
                            'Une version plus récente a été sauvegardée dans un autre onglet. Actualisez avant de modifier.',
                            'error',
                        );
                        this.setCompetitorSaveStatus('conflict', 'Conflit · actualiser');
                    } catch (_error) {
                        // A malformed metadata-only signal is ignored; no product state is read from it.
                    }
                };
                window.addEventListener('storage', this._competitorSnapshotSyncHandler);
            },

            currentCompetitorTerritory() {
                const api = window.MaplyticsCompetitorTerritory;
                if (!api) return null;
                return toolType === 'isochrone'
                    ? api.fromZoneScopes(this.competitorScopeDefinitions())
                    : api.normalize(importDetailedExportAdapter?.getState?.().territoryContext);
            },

            observeCompetitorTerritory(current) {
                const api = window.MaplyticsCompetitorTerritory;
                if (!api || this._competitorTerritorySyncing) return false;
                const hasResults = Boolean(this.competitors?.length || this.lastSearchResults?.length
                    || this.competitorSearchSnapshot || this.removedItems?.some(item => item.kind === 'competitor')
                    || Object.keys(this.attractivenessResults || {}).length);
                const change = api.transition(this._competitorTerritoryContext, current, hasResults);
                if (change === 'empty') {
                    // Keep the explicitly retained listing, not a request whose
                    // territory was just removed. A new valid ZDC will compare
                    // against the retained binding, not an invented empty one.
                    if (this._competitorTerritoryContext) {
                        this._competitorSearchAbortController?.abort?.();
                        clearTimeout(this._competitorSnapshotSaveTimer);
                        this._competitorSnapshotSaveTimer = null;
                        const search = this.competitorWorkspaceController?.snapshot?.().search;
                        if (search?.status === 'loading') {
                            this.dispatchCompetitorWorkspace({ type: 'search/error', generation: search.generation,
                                error: 'Recherche annulée : le territoire a été retiré.' });
                            this.competitorFilterBuilder?.setStatus?.('Recherche annulée : définissez le nouveau territoire.', 'info');
                        }
                        this._workspaceRequestGeneration += 1;
                        this._competitorRestoreSequence += 1;
                        this._competitorStateGeneration += 1;
                        this._competitorSaveSequence += 1;
                        if (this._competitorRestorePending) {
                            this._competitorRestorePending = 0;
                            this._competitorRestoreTarget = '';
                            this._competitorRestoreTargetSequence = 0;
                            this.setCompetitorSaveStatus('idle', 'Chargement annulé · territoire retiré');
                        }
                    }
                    return false;
                }
                if (change === 'same' || change === 'extend') return false;
                if (change === 'replace' && !hasResults
                    && this._competitorStateGeneration === 0
                    && !this._competitorRestorePending
                    && this.competitorWorkspaceController.snapshot().search?.status !== 'loading') {
                    // Bootstrap can restore local zones before the server's
                    // authoritative zones. An untouched, empty listing has no
                    // result to detach: do not manufacture a user mutation
                    // that would block the pending automatic server fallback.
                    this._competitorTerritoryContext = api.normalize(current);
                    return false;
                }
                if (change === 'replace') {
                    const preferences = {
                        numbered: this.competitorsNumbered,
                        markerColor: this.competitorMarkerColor,
                        markerScale: this.competitorMarkerScale,
                    };
                    const criteria = this.competitorFilterBuilder?.state?.snapshot?.();
                    const categories = [...this.attractivenessSelectedCategories];
                    const encoding = { ...this.attractivenessVisualEncoding };
                    const retainedRemoved = api.withoutTerritorialResults({ removedItems: this.removedItems }).removedItems;
                    this._competitorTerritorySyncing = true;
                    try {
                        // This only detaches the current display and pending writes.
                        // Saved analyses and independent network points are not deleted.
                        this.resetLocalWorkspace({ preserveCustomPoints: true });
                        this.dispatchCompetitorWorkspace({ type: 'presentation/set', patch: preferences });
                        if (retainedRemoved.length) this.dispatchCompetitorWorkspace({ type: 'removed/add', items: retainedRemoved });
                        if (criteria) this.competitorFilterBuilder?.state?.restore?.(criteria);
                        this.attractivenessSelectedCategories = categories;
                        this.attractivenessVisualEncoding = encoding;
                        this.syncCompetitorsNumberingButton();
                        this.syncCompetitorMarkerColorControl();
                        this.syncCompetitorMarkerScaleControl();
                        this.renderCompetitorsList();
                    } finally {
                        this._competitorTerritorySyncing = false;
                    }
                    this.competitorFilterBuilder?.setStatus?.(
                        'Le territoire a changé. Relancez la recherche ; les analyses sauvegardées et les points réseau sont conservés.',
                        'info',
                    );
                }
                this._competitorTerritoryContext = api.normalize(current);
                return change === 'replace';
            },

            initCompetitorTerritorySync() {
                if (this._competitorTerritoryListener) return;
                this._competitorTerritoryContext = this.currentCompetitorTerritory();
                this._competitorTerritoryListener = event => {
                    if (toolType === 'isochrone') {
                        if (event?.detail?.schema_version !== 'home_zone_mutation_v1') return;
                        this.observeCompetitorTerritory(Object.hasOwn(event.detail, 'territoryContext')
                            ? event.detail.territoryContext : this.currentCompetitorTerritory());
                    } else if (event?.detail?.surface === 'import' && event.detail.hard) {
                        this.observeCompetitorTerritory(event.detail.state?.territoryContext);
                    }
                };
                document.addEventListener(toolType === 'isochrone'
                    ? 'maplytics:zones-mutated' : 'maplytics:import-export-state-changed', this._competitorTerritoryListener);
            },

            currentZoneScopeFingerprints() {
                return new Map(this.competitorScopeDefinitions()
                    .filter((scope) => ['zdc', 'zdc_union', 'folder'].includes(scope.type))
                    .map((scope) => [scope.value, scope.fingerprint]));
            },

            initZoneScopeSync() {
                if (toolType !== 'isochrone' || this._zoneScopeSyncHandler) return false;
                this._zoneScopeFingerprints = this.currentZoneScopeFingerprints();
                this._zoneScopeSyncHandler = (event) => {
                    if (event?.detail?.schema_version !== 'home_zone_mutation_v1') return;
                    this.invalidateCompetitorRoutingSnapshot(
                        'Une origine ou un périmètre de zone a changé.',
                    );
                    const previous = this._zoneScopeFingerprints;
                    const current = this.currentZoneScopeFingerprints();
                    const changed = (value, expectedFingerprint = '') => {
                        const normalized = String(value || '');
                        if (!previous.has(normalized) && !expectedFingerprint) return false;
                        const before = String(expectedFingerprint || previous.get(normalized) || '');
                        const after = String(current.get(normalized) || '');
                        return !after || Boolean(before && before !== after);
                    };
                    const activeScope = this._activeCompetitorSearchScope;
                    const activeIsZoneScope = ['zdc', 'zdc_union', 'folder'].includes(
                        activeScope?.type,
                    );
                    if (
                        activeIsZoneScope
                        && changed(activeScope.value, activeScope.searchScope?.fingerprint)
                    ) {
                        this._competitorScopeInvalidationMessage = (
                            'La zone utilisée par la recherche a été supprimée ou modifiée. '
                            + 'Choisissez un périmètre actualisé.'
                        );
                        this._competitorSearchAbortController?.abort?.();
                        this._workspaceRequestGeneration += 1;
                        if (Number.isFinite(Number(activeScope.workspaceGeneration))) {
                            this.dispatchCompetitorWorkspace({
                                type: 'search/error',
                                generation: activeScope.workspaceGeneration,
                                error: this._competitorScopeInvalidationMessage,
                            });
                        }
                    }
                    const selectedValue = this.competitorFilterBuilder?.getScopeValue?.() || '';
                    if (selectedValue && previous.has(selectedValue) && changed(selectedValue)) {
                        this.competitorFilterBuilder.invalidateScope(
                            'Ce périmètre a été supprimé ou modifié. Choisissez un périmètre actualisé.',
                        );
                    } else {
                        this.competitorFilterBuilder?.refreshScopes?.();
                    }
                    this._zoneScopeFingerprints = current;
                    const snapshotSource = this.competitorSearchSnapshot
                        ? this.competitorSnapshotSourceState(this.competitorSearchSnapshot)
                        : null;
                    if (snapshotSource && !snapshotSource.available) {
                        this.competitorFilterBuilder?.setStatus?.(
                            snapshotSource.message || 'Le périmètre enregistré a changé.',
                            'error',
                        );
                    }
                };
                document.addEventListener('maplytics:zones-mutated', this._zoneScopeSyncHandler);
                return true;
            },

            broadcastCompetitorSnapshot(savedAt = '', target = this.competitorPersistenceTarget()) {
                const snapshot = this.competitorSearchSnapshot;
                try {
                    localStorage.setItem(this.competitorSnapshotStorageKey(target), JSON.stringify({
                        write_id: `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`,
                        target,
                        snapshot_id: snapshot?.snapshot_id || '',
                        saved_at: String(savedAt || snapshot?.saved_at || ''),
                        sender: this._competitorSnapshotSender,
                    }));
                } catch (_error) {
                    // Server persistence remains canonical if local metadata signaling is unavailable.
                }
            },

            normalizeCompetitorModalFilters(rawFilters) {
                const source = rawFilters && typeof rawFilters === 'object' ? rawFilters : {};
                const list = (key) => Array.from(new Set(
                    (Array.isArray(source[key]) ? source[key] : [])
                        .slice(0, 80)
                        .map((value) => String(value).trim().slice(0, 120))
                        .filter(Boolean),
                ));
                const text = (key, max = 180) => String(source[key] || '').trim().slice(0, max);
                return {
                    excludedKeywords: text('excludedKeywords', 500),
                    sortKey: ['source_order', 'distance_km', 'name', 'city', 'naf_code', 'activity', 'date_creation', 'tranche_effectif']
                        .includes(source.sortKey) ? source.sortKey : 'distance_km',
                    sortDir: source.sortDir === 'desc' ? 'desc' : 'asc',
                    effectifFilter: list('effectifFilter'),
                    nafFilter: list('nafFilter'),
                    cityFilter: list('cityFilter'),
                    statusFilter: list('statusFilter'),
                    originFilter: list('originFilter'),
                    createdAfter: text('createdAfter', 10),
                    createdBefore: text('createdBefore', 10),
                    minDistance: text('minDistance', 20),
                    maxDistance: text('maxDistance', 20),
                    showExcluded: Boolean(source.showExcluded),
                    showCompetitors: source.showCompetitors !== false,
                    validCoordsOnly: Boolean(source.validCoordsOnly),
                    keywordsExpanded: Boolean(source.keywordsExpanded),
                };
            },

            normalizeCompetitorSearchSnapshot(rawSnapshot) {
                if (!rawSnapshot || typeof rawSnapshot !== 'object') return null;
                if (rawSnapshot.schema_version !== this.COMPETITOR_SEARCH_SNAPSHOT_SCHEMA) return null;
                const rawQuery = rawSnapshot.query;
                const rawScope = rawQuery?.scope;
                if (
                    !rawQuery
                    || !Array.isArray(rawQuery.criteria)
                    || !rawQuery.criteria.length
                    || !rawScope
                    || typeof rawScope !== 'object'
                    || !String(rawScope.value || '').trim()
                ) return null;
                let normalizedScope = rawScope;
                if (rawScope.type === 'multi_point') {
                    const rawOrigins = Array.isArray(rawScope.origins) ? rawScope.origins : [];
                    if (rawOrigins.length < 2 || rawOrigins.length > 5) return null;
                    const seenOrigins = new Set();
                    const origins = [];
                    for (const rawOrigin of rawOrigins) {
                        const value = String(rawOrigin?.value || '').trim();
                        const numericOrNaN = (rawValue) => (
                            rawValue === null || rawValue === undefined || rawValue === ''
                                ? Number.NaN
                                : Number(rawValue)
                        );
                        const lat = numericOrNaN(rawOrigin?.lat);
                        const lon = numericOrNaN(rawOrigin?.lon);
                        const radiusKm = numericOrNaN(rawOrigin?.radiusKm);
                        const coordinates = rawOrigin?.searchScope?.geometry?.coordinates;
                        const pointLon = numericOrNaN(coordinates?.[0]);
                        const pointLat = numericOrNaN(coordinates?.[1]);
                        if (
                            !/^point:[A-Za-z0-9._~:%-]{1,100}$/.test(value)
                            || seenOrigins.has(value)
                            || !Number.isFinite(lat)
                            || !Number.isFinite(lon)
                            || !Number.isFinite(radiusKm)
                            || lat < -90 || lat > 90
                            || lon < -180 || lon > 180
                            || radiusKm < 0.1 || radiusKm > 150
                            || rawOrigin?.searchScope?.type !== 'point'
                            || !Array.isArray(coordinates)
                            || coordinates.length < 2
                            || !Number.isFinite(pointLon)
                            || !Number.isFinite(pointLat)
                            || Math.abs(pointLon - lon) > 1e-7
                            || Math.abs(pointLat - lat) > 1e-7
                        ) return null;
                        seenOrigins.add(value);
                        const label = String(rawOrigin.label || 'Point').trim().slice(0, 120) || 'Point';
                        origins.push({
                            value,
                            type: 'point',
                            label,
                            lat,
                            lon,
                            radiusKm,
                            searchAreaGeojson: null,
                            searchScope: {
                                type: 'point',
                                label,
                                geometry: { type: 'Point', coordinates: [lon, lat] },
                            },
                        });
                    }
                    normalizedScope = {
                        value: 'multi-point',
                        type: 'multi_point',
                        label: `${origins.length} points`,
                        origins,
                    };
                } else if (['zdc', 'zdc_union', 'folder'].includes(rawScope.type)) {
                    const relation = rawScope.searchScope?.relation === 'nearby'
                        ? 'nearby'
                        : 'strict';
                    const rawBuffer = Number(
                        rawScope.searchScope?.buffer_km
                        ?? rawScope.bufferKm
                        ?? 2,
                    );
                    if (relation === 'nearby' && ![1, 2, 5].includes(rawBuffer)) return null;
                    normalizedScope = {
                        ...rawScope,
                        relation,
                        bufferKm: relation === 'nearby' ? rawBuffer : 0,
                        searchScope: {
                            ...(rawScope.searchScope || {}),
                            relation,
                            buffer_km: relation === 'nearby' ? rawBuffer : 0,
                        },
                    };
                }
                const criteria = rawQuery.criteria.slice(0, 8).map((criterion) => {
                    const type = String(criterion?.type || '').trim().toLowerCase();
                    try {
                        const value = window.MaplyticsCompetitorSearch.normalize(type, criterion?.value);
                        return {
                            id: `${type}:${String(value).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')}`,
                            type,
                            value,
                            label: window.MaplyticsCompetitorSearch.TYPES[type],
                        };
                    } catch (_error) {
                        return null;
                    }
                }).filter(Boolean);
                if (!criteria.length) return null;
                const operator = String(rawQuery.operator || 'OR').toUpperCase();
                if (!['OR', 'AND'].includes(operator)) return null;
                if (
                    !Array.isArray(rawSnapshot.results)
                    || rawSnapshot.results.length > this.COMPETITOR_SEARCH_SNAPSHOT_MAX_RESULTS
                ) return null;
                const results = rawSnapshot.results.filter((item) => item && typeof item === 'object');
                if (!results.length) return null;
                const rawModalState = rawSnapshot.modal_state && typeof rawSnapshot.modal_state === 'object'
                    ? rawSnapshot.modal_state
                    : {};
                const selectedIds = Array.isArray(rawModalState.selected_ids)
                    ? rawModalState.selected_ids.slice(0, this.COMPETITOR_SEARCH_SNAPSHOT_MAX_RESULTS).map((value) => String(value).slice(0, 220))
                    : results.map((item) => this.competitorIdentity(item));
                const filters = this.normalizeCompetitorModalFilters(rawModalState.filters);
                const filteredDataset = window.MaplyticsCompetitorSearch.filterDataset(
                    results,
                    filters,
                );
                if (
                    rawModalState.dataset?.fingerprint
                    && rawModalState.dataset.fingerprint !== filteredDataset.fingerprint
                ) return null;
                const dataset = {
                    schema_version: filteredDataset.schema_version,
                    fingerprint: filteredDataset.fingerprint,
                    included_ids: filteredDataset.included_ids,
                    excluded: filteredDataset.excluded.map((entry) => ({
                        id: entry.id,
                        reasons: entry.reasons,
                    })),
                };
                try {
                    const normalized = JSON.parse(JSON.stringify({
                        schema_version: this.COMPETITOR_SEARCH_SNAPSHOT_SCHEMA,
                        snapshot_id: String(rawSnapshot.snapshot_id || '').slice(0, 100),
                        saved_at: (() => {
                            const value = String(rawSnapshot.saved_at || '').trim();
                            return value && !Number.isNaN(Date.parse(value)) ? value : '';
                        })(),
                        query: {
                            criteria,
                            operator,
                            scope: normalizedScope,
                        },
                        results,
                        search_info: rawSnapshot.search_info && typeof rawSnapshot.search_info === 'object'
                            ? rawSnapshot.search_info
                            : {},
                        modal_state: { filters, selected_ids: selectedIds, dataset },
                    }));
                    if (!normalized.snapshot_id) {
                        normalized.snapshot_id = `snapshot-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
                    }
                    const expectedFingerprint = this.competitorSnapshotFingerprint(normalized);
                    if (
                        rawSnapshot.filter_fingerprint
                        && rawSnapshot.filter_fingerprint !== expectedFingerprint
                    ) {
                        const legacyFingerprint = this.competitorSnapshotFingerprint({
                            ...normalized,
                            modal_state: { filters, selected_ids: selectedIds },
                        });
                        if (
                            rawModalState.dataset
                            || rawSnapshot.filter_fingerprint !== legacyFingerprint
                        ) return null;
                    }
                    normalized.filter_fingerprint = expectedFingerprint;
                    if (new Blob([JSON.stringify(normalized)]).size > this.COMPETITOR_SEARCH_SNAPSHOT_MAX_BYTES) {
                        return null;
                    }
                    return normalized;
                } catch (_error) {
                    return null;
                }
            },

            competitorSnapshotSourceState(snapshot = this.competitorSearchSnapshot) {
                const scope = snapshot?.query?.scope;
                if (!scope) return { available: false, label: 'Source inconnue' };
                if (scope.type === 'multi_point') {
                    const storedOrigins = Array.isArray(scope.origins) ? scope.origins : [];
                    if (storedOrigins.length < 2) {
                        return {
                            available: false,
                            label: 'Origines incomplètes',
                            origins: [],
                            message: 'Les origines enregistrées sont incomplètes. Le snapshot reste consultable sans rattachement automatique.',
                        };
                    }
                    const definitions = this.competitorScopeDefinitions();
                    const originStates = storedOrigins.map((origin) => {
                        const exact = definitions.find((item) => item.value === origin.value && item.type === 'point');
                        const storedCoordinates = origin.searchScope?.geometry?.coordinates;
                        const samePoint = exact
                            && Array.isArray(storedCoordinates)
                            && storedCoordinates.length >= 2
                            && Number.isFinite(Number(exact.point?.lat))
                            && Number.isFinite(Number(exact.point?.lon))
                            && Math.abs(Number(storedCoordinates[0]) - Number(exact.point.lon)) <= 1e-7
                            && Math.abs(Number(storedCoordinates[1]) - Number(exact.point.lat)) <= 1e-7;
                        return {
                            value: origin.value,
                            label: origin.label || exact?.label || 'Point',
                            available: Boolean(samePoint),
                        };
                    });
                    const missing = originStates.filter((origin) => !origin.available);
                    return {
                        available: missing.length === 0,
                        label: `${storedOrigins.length} points`,
                        origins: originStates,
                        message: missing.length
                            ? `${missing.length} origine${missing.length > 1 ? 's' : ''} (${missing.map((item) => item.label).join(', ')}) ${missing.length > 1 ? 'ont' : 'a'} été supprimée${missing.length > 1 ? 's' : ''} ou modifiée${missing.length > 1 ? 's' : ''}. Le snapshot reste consultable sans rattachement automatique.`
                            : '',
                    };
                }
                if (scope.type === 'viewport' && scope.searchAreaGeojson) {
                    return { available: true, label: scope.label || 'Carte visible enregistrée' };
                }
                const exact = this.competitorScopeDefinitions().find(
                    (item) => item.value === scope.value,
                );
                if (
                    exact
                    && ['zdc', 'zdc_union', 'folder'].includes(scope.type)
                    && scope.searchScope?.fingerprint
                    && scope.searchScope.fingerprint !== exact.fingerprint
                ) {
                    return {
                        available: false,
                        label: scope.label || 'Périmètre modifié',
                        message: `La source « ${scope.label || 'enregistrée'} » a été modifiée. Choisissez un périmètre actualisé.`,
                    };
                }
                if (exact && scope.type === 'point') {
                    const storedCoordinates = scope.searchScope?.geometry?.coordinates;
                    const currentPoint = exact.point;
                    const samePoint = Array.isArray(storedCoordinates)
                        && storedCoordinates.length >= 2
                        && Number.isFinite(Number(currentPoint?.lat))
                        && Number.isFinite(Number(currentPoint?.lon))
                        && Math.abs(Number(storedCoordinates[0]) - Number(currentPoint.lon)) <= 1e-7
                        && Math.abs(Number(storedCoordinates[1]) - Number(currentPoint.lat)) <= 1e-7;
                    if (!samePoint) {
                        return {
                            available: false,
                            label: scope.label || 'Point modifié',
                            message: `Le point « ${scope.label || 'enregistré'} » a été supprimé ou modifié. Le snapshot reste consultable sans rattachement automatique.`,
                        };
                    }
                }
                return exact
                    ? { available: true, label: exact.label || scope.label || 'Périmètre' }
                    : {
                        available: false,
                        label: scope.label || 'Source supprimée',
                        message: `La source « ${scope.label || 'enregistrée'} » n’existe plus. Le snapshot reste consultable sans rattachement automatique.`,
                    };
            },

            setCompetitorSearchSnapshot(rawSnapshot, { restoreBuilder = false } = {}) {
                this.competitorSearchSnapshot = this.normalizeCompetitorSearchSnapshot(rawSnapshot);
                const snapshot = this.competitorSearchSnapshot;
                if (snapshot && restoreBuilder && this.competitorFilterBuilder?.state?.restore) {
                    try {
                        this.competitorFilterBuilder.state.restore(snapshot.query);
                        const source = this.competitorSnapshotSourceState(snapshot);
                        if (snapshot.query.scope?.type === 'multi_point') {
                            this.competitorFilterBuilder.setOrigins?.(snapshot.query.scope.origins);
                        } else if (source.available) {
                            this.competitorFilterBuilder.setScope(snapshot.query.scope.value);
                            this.competitorFilterBuilder.setSpatialRelation?.(
                                snapshot.query.scope.searchScope?.relation,
                                snapshot.query.scope.searchScope?.buffer_km,
                            );
                        }
                    } catch (error) {
                        console.warn('Snapshot concurrence chargé sans restauration du builder:', error.message);
                    }
                }
                const source = snapshot ? this.competitorSnapshotSourceState(snapshot) : null;
                this.competitorFilterBuilder?.setSnapshotAvailable?.(
                    Boolean(snapshot),
                    source?.label || '',
                );
                return snapshot;
            },

            scheduleCompetitorSnapshotSave({ immediate = false } = {}) {
                if (!connectedUserToken || !this.competitorSearchSnapshot) return;
                clearTimeout(this._competitorSnapshotSaveTimer);
                const ownerToken = connectedUserToken;
                const stateGeneration = this._competitorStateGeneration;
                const persist = () => ownerToken === connectedUserToken
                    && stateGeneration === this._competitorStateGeneration
                    && this.saveCompetitors({ quiet: true });
                if (immediate) {
                    persist();
                    return;
                }
                this._competitorSnapshotSaveTimer = setTimeout(persist, 350);
            },

            openCompetitorSearchSnapshot() {
                const snapshot = this.normalizeCompetitorSearchSnapshot(this.competitorSearchSnapshot);
                if (!snapshot) {
                    throw new Error('Aucune recherche sauvegardée n’est disponible.');
                }
                this.setCompetitorSearchSnapshot(snapshot, { restoreBuilder: true });
                const sourceState = this.competitorSnapshotSourceState(snapshot);
                this.showSearchResults(snapshot.results, 'structured', snapshot.query, {
                    search_info: snapshot.search_info,
                    restore_snapshot: snapshot,
                    source_state: sourceState,
                });
            },

            syncCompetitorMapButton() {
                const btn = document.querySelector(`${scopeSelector} #competitorToggleMapBtn, ${scopeSelector} #importCompetitorToggleMapBtn`);
                if (btn) {
                    btn.textContent = APP_CONFIG.appShellV2 ? (this.visibleOnMap ? 'Masquer' : 'Carte') : (this.visibleOnMap ? '👁️ Masquer sur la carte' : '👁️ Afficher sur la carte');
                    btn.setAttribute('aria-pressed', this.visibleOnMap ? 'true' : 'false');
                }
            },

            fitCompetitorsOnMap(competitors) {
                const mapController = toolType === 'isochrone' ? exportMapController : importMapController;
                if (!mapController?.map || typeof L === 'undefined') return;
                const latLngs = (competitors || [])
                    .map((comp) => [Number(comp.lat ?? comp.latitude), Number(comp.lon ?? comp.lng ?? comp.longitude)])
                    .filter(([lat, lon]) => Number.isFinite(lat) && Number.isFinite(lon));
                if (!latLngs.length) return;
                try {
                    const bounds = L.latLngBounds(latLngs);
                    if (bounds.isValid()) {
                        mapController.map.fitBounds(bounds, { padding: [24, 24], maxZoom: 14 });
                    }
                    invalidateMapControllerWhenVisible(mapController, 80);
                } catch (error) {
                    console.warn('Impossible de cadrer les concurrents sur la carte:', error);
                }
            },

            // Obtenir le point de référence (première zone) et le rayon max
            getSearchParams() {
                // Pour import-table, on utilise simplement les coordonnées du point de départ
                // Point de référence : coordonnées du point de départ
                const latInput = document.getElementById(latInputId);
                const lonInput = document.getElementById(lonInputId);
                if (!latInput || !lonInput || !latInput.value || !lonInput.value) {
                    return null;
                }

                const lat = parseFloat(latInput.value);
                const lon = parseFloat(lonInput.value);
                if (isNaN(lat) || isNaN(lon)) {
                    return null;
                }

                // Rayon : pour import-table, utiliser un rayon fixe de 50km (ou basé sur les données si disponible)
                // Pour isochrone, utiliser la zone maximale créée
                let radiusKm = 50; // Par défaut
                let searchAreaGeojson = null;
                if (toolType === 'isochrone') {
                    const zonesMap = zonesManager.zones;
                    if (zonesMap.size > 0) {
                        const zones = Array.from(zonesMap.values());
                        const maxZone = zones.reduce((current, zone) => (
                            Number(zone.minutes || 0) > Number(current?.minutes || 0) ? zone : current
                        ), zones[0]);
                        const minutes = Math.max(1, Math.min(90, Math.round(Number(maxZone?.minutes || 10))));
                        const transport = maxZone?.transport || maxZone?.profile || 'driving-car';
                        const speeds = { 'driving-car': 50, 'foot-walking': 5, 'cycling-regular': 15 };
                        const speed = speeds[transport] || speeds['driving-car'];
                        radiusKm = Math.max(0.1, Math.min(50, Math.round(((minutes / 60) * speed) * 100) / 100));
                        searchAreaGeojson = this.normalizeSearchAreaGeojson(maxZone?.geojson);
                    }
                }

                return { lat, lon, radiusKm, searchAreaGeojson };
            },

            // Initialiser le layerGroup pour les markers
            initMarkersLayer() {
                const mapController = toolType === 'isochrone' ? exportMapController : importMapController;
                if (!mapController || !mapController.map || typeof L === 'undefined') {
                    return;
                }

                if (!this.markersLayer) {
                    this.markersLayer = L.layerGroup().addTo(mapController.map);
                }
            },

            // Rechercher des concurrents
            async searchCompetitors(method, query) {
                const searchTerritoryContext = this.currentCompetitorTerritory?.() || null;
                const workspaceRequestGeneration = this._workspaceRequestGeneration;
                const ownerToken = connectedUserToken;
                const structuredSearch = method === 'structured'
                    && query
                    && typeof query === 'object';
                // Own the whole intent, including geocoding, before the first
                // await. Abort is best-effort; identity checks remain mandatory.
                const workspaceSearch = this.dispatchCompetitorWorkspace({
                    type: 'search/start',
                    query: structuredSearch ? query : { method, value: query },
                });
                if (!workspaceSearch.applied) {
                    return { success: false, error: 'Rechargez la page pour démarrer une nouvelle recherche.' };
                }
                if (structuredSearch) query = workspaceSearch.snapshot.search.query;
                this._competitorSearchAbortController?.abort?.();
                const competitorSearchAbortController = new AbortController();
                this._competitorSearchAbortController = competitorSearchAbortController;
                this._competitorScopeInvalidationMessage = '';
                this._activeCompetitorSearchScope = structuredSearch && query.scope
                    ? {
                        ...query.scope,
                        searchScope: query.scope.searchScope ? { ...query.scope.searchScope } : null,
                        workspaceGeneration: workspaceSearch.generation,
                    }
                    : null;
                const isCurrent = () => (
                    !competitorSearchAbortController.signal.aborted
                    && this._competitorSearchAbortController === competitorSearchAbortController
                    && workspaceRequestGeneration === this._workspaceRequestGeneration
                    && ownerToken === connectedUserToken
                    && workspaceSearch.generation === this.competitorWorkspaceController.snapshot().search.generation
                );
                const cancelled = () => ({ success: false, cancelled: true });
                const searchBtn = structuredSearch ? null : document.querySelector(
                    `${scopeSelector} #${this.prefix}competitorSearch${method.charAt(0).toUpperCase() + method.slice(1)}Btn`,
                );
                const buttonLease = {
                    label: searchBtn?._competitorSearchLease?.label ?? searchBtn?.textContent,
                };
                if (searchBtn) {
                    searchBtn._competitorSearchLease = buttonLease;
                    searchBtn.disabled = true;
                    searchBtn.textContent = 'Recherche...';
                }

                try {
                    const structuredOrigins = structuredSearch
                        && query.scope?.type === 'multi_point'
                        && Array.isArray(query.scope.origins)
                        ? query.scope.origins
                        : [];
                    const firstStructuredOrigin = structuredOrigins[0] || null;
                    let params = structuredSearch && query.scope
                        ? {
                            lat: query.scope.lat ?? firstStructuredOrigin?.lat,
                            lon: query.scope.lon ?? firstStructuredOrigin?.lon,
                            radiusKm: query.scope.radiusKm ?? firstStructuredOrigin?.radiusKm,
                            searchAreaGeojson: query.scope.searchAreaGeojson || null,
                            searchScope: query.scope.searchScope || null,
                        }
                        : this.getSearchParams();

                    // GPS single-field : parser "lat, lon" depuis query
                    if (method === 'gps' && query) {
                        const parts = query.split(',').map(s => parseFloat(s.trim()));
                        if (parts.length === 2 && !isNaN(parts[0]) && !isNaN(parts[1])) {
                            params = { lat: parts[0], lon: parts[1], radiusKm: params?.radiusKm || 10 };
                        } else {
                            throw new Error('Format GPS invalide. Utilisez : latitude, longitude (ex: 46.569, 1.500)');
                        }
                    }

                    // Adresse : géocoder d'abord, puis montrer sur la carte
                    if (method === 'address' && !params) {
                        try {
                            const geocodeResponse = await fetch(`/api/geocode?q=${encodeURIComponent(query)}`, {
                                signal: competitorSearchAbortController.signal,
                            });
                            if (!isCurrent()) return cancelled();
                            if (geocodeResponse.ok) {
                                const geoResult = await geocodeResponse.json();
                                if (!isCurrent()) return cancelled();
                                params = {
                                    lat: geoResult.lat,
                                    lon: geoResult.lon,
                                    radiusKm: 10
                                };
                                // Montrer la localisation géocodée sur la carte
                                const mapCtrl = toolType === 'isochrone' ? exportMapController : importMapController;
                                if (mapCtrl && mapCtrl.map && typeof L !== 'undefined') {
                                    // Supprimer l'ancien marqueur de recherche s'il existe
                                    if (this._searchMarker) { mapCtrl.map.removeLayer(this._searchMarker); }
                                    this._searchMarker = L.marker([params.lat, params.lon], {
                                        icon: L.divIcon({
                                            className: 'geocoded-search-marker',
                                            html: '<div style="background: #2563eb; width: 14px; height: 14px; border-radius: 50%; border: 2px solid white; box-shadow: 0 2px 6px rgba(0,0,0,0.4);"></div>',
                                            iconSize: [14, 14], iconAnchor: [7, 7]
                                        })
                                    }).addTo(mapCtrl.map);
                                    this._searchMarker.bindTooltip(`🔍 ${this.escapeCompetitorText(query)}`, { direction: 'top' });
                                    mapCtrl.map.setView([params.lat, params.lon], 14);
                                }
                            } else {
                                throw new Error('Adresse introuvable. Veuillez vérifier l\'adresse saisie.');
                            }
                        } catch (geocodeError) {
                            if (!isCurrent()) return cancelled();
                            throw geocodeError;
                        }
                    }

                    if (!params) {
                        if (toolType === 'import-table') {
                            throw new Error('Veuillez d\'abord importer un tableau et calculer les distances.');
                        } else {
                            throw new Error('Veuillez d\'abord créer au moins une zone de chalandise.');
                        }
                    }

                    // GA4: track competitor search
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({event: 'competitor_search', method: method});

                    const requestPayload = {
                        method: method,
                        query: structuredSearch ? '' : query,
                        lat: params.lat,
                        lon: params.lon,
                        radius_km: params.radiusKm || 10,
                        search_area_geojson: params.searchAreaGeojson || undefined,
                        search_scope: structuredSearch ? params.searchScope : undefined,
                        search_origins: structuredOrigins.length > 1
                            ? structuredOrigins.map((origin) => ({
                                id: origin.value,
                                label: origin.label,
                                lat: origin.lat,
                                lon: origin.lon,
                                radius_km: origin.radiusKm,
                                search_scope: origin.searchScope,
                            }))
                            : undefined,
                        ...(structuredSearch ? {
                            criteria: query.criteria.map(({ type, value }) => ({ type, value })),
                            operator: query.operator,
                        } : {}),
                    };
                    const response = await fetch('/api/competitors/search', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        credentials: 'include',
                        body: JSON.stringify(requestPayload),
                        signal: competitorSearchAbortController.signal,
                    });
                    if (!isCurrent()) return cancelled();

                    if (!response.ok) {
                        let errorMessage = `Erreur HTTP: ${response.status}`;
                        let errorData = {};
                        try {
                            errorData = await response.json();
                            errorMessage = errorData.error || errorData.detail || errorMessage;
                        } catch (e) {
                            // Si la réponse n'est pas du JSON
                        }
                        if (!isCurrent()) return cancelled();
                        if (response.status === 401 || response.status === 403) {
                            this.dispatchCompetitorWorkspace({
                                type: 'search/error', generation: workspaceSearch.generation, error: errorMessage,
                            });
                            handleAppApiError(response, errorData, errorMessage);
                            return { success: false, error: errorMessage };
                        }
                        throw new Error(errorMessage);
                    }

                    const result = await response.json();
                    if (!isCurrent()) return cancelled();
                    console.info('Recherche concurrents:', result.search_info || {}, `${result.count || 0} résultats`);

                    if (result.success && result.competitors) {
                        const accepted = this.dispatchCompetitorWorkspace({
                            type: 'search/success',
                            generation: workspaceSearch.generation,
                            results: result.competitors,
                            metadata: result.search_info || {},
                        });
                        if (!accepted.applied) return cancelled();
                        this._competitorTerritoryContext = searchTerritoryContext;
                        this.lastSearchResults = result.competitors || [];
                        this.lastSearchInfo = result.search_info || {};
                        this.lastCompetitorRouteOrigins = structuredSearch
                            ? this.competitorRouteOrigins(query.scope)
                            : this.competitorRouteOrigins({
                                id: `point:competitor-${toolType}-last-search`,
                                label: query || 'Origine de la recherche',
                                lat: params.lat,
                                lon: params.lon,
                                radius_km: params.radiusKm || 10,
                            });
                        if (structuredSearch) {
                            this.lastStructuredSearch = {
                                ...query,
                                criteria: query.criteria.map((criterion) => ({ ...criterion })),
                                scope: query.scope ? {
                                    ...query.scope,
                                    origins: structuredOrigins.map((origin) => ({ ...origin })),
                                } : null,
                            };
                        }
                        // Afficher les résultats (pour ajout à la liste)
                        this.showSearchResults(result.competitors, method, query, result);
                        return result;
                    } else {
                        const accepted = this.dispatchCompetitorWorkspace({
                            type: 'search/error',
                            generation: workspaceSearch.generation,
                            error: result.error || result.detail || 'Erreur inconnue',
                        });
                        if (!accepted.applied) return cancelled();
                        showAppMessage('error', 'Recherche impossible', result.error || result.detail || 'Erreur inconnue');
                        return result;
                    }
                } catch (error) {
                    if (!isCurrent() || error?.name === 'AbortError') return cancelled();
                    const accepted = this.dispatchCompetitorWorkspace({
                        type: 'search/error',
                        generation: workspaceSearch.generation,
                        error: error.message || 'Recherche impossible.',
                    });
                    if (!accepted.applied) return cancelled();
                    console.error('Erreur recherche concurrents:', error);
                    showAppMessage('error', 'Recherche impossible', error.message || 'Vérifiez votre connexion.');
                    return { success: false, error: error.message || 'Recherche impossible.' };
                } finally {
                    if (this._competitorSearchAbortController === competitorSearchAbortController) {
                        if (this.competitorWorkspaceController.snapshot().search.status === 'loading') {
                            this.dispatchCompetitorWorkspace({
                                type: 'search/error', generation: workspaceSearch.generation,
                                error: this._competitorScopeInvalidationMessage || 'La recherche a été annulée.',
                            });
                        }
                        this._competitorSearchAbortController = null;
                        this._activeCompetitorSearchScope = null;
                    }
                    // Restaurer le bouton
                    if (searchBtn?._competitorSearchLease === buttonLease) {
                        searchBtn.disabled = false;
                        searchBtn.textContent = buttonLease.label;
                        delete searchBtn._competitorSearchLease;
                    }
                }
            },

            competitorRouteOrigins(scope = undefined) {
                const selectedScope = scope === undefined
                    ? (this.competitorSearchSnapshot?.query?.scope || this.lastStructuredSearch?.scope || null)
                    : scope;
                const normalizeOrigin = (origin, index = 0) => {
                    const coordinates = origin?.searchScope?.geometry?.coordinates
                        || origin?.search_scope?.geometry?.coordinates
                        || origin?.geometry?.coordinates;
                    const lat = Number(origin?.lat ?? coordinates?.[1]);
                    const lon = Number(origin?.lon ?? coordinates?.[0]);
                    if (!Number.isFinite(lat) || !Number.isFinite(lon)) return null;
                    if (lat < -90 || lat > 90 || lon < -180 || lon > 180) return null;
                    const rawId = String(origin?.value || origin?.id || '').trim();
                    const id = /^point:[A-Za-z0-9._~:%-]{1,100}$/.test(rawId)
                        ? rawId
                        : `point:competitor-${toolType}-${index + 1}`;
                    const label = String(origin?.label || `Origine ${index + 1}`).trim().slice(0, 120)
                        || `Origine ${index + 1}`;
                    return {
                        id,
                        label,
                        lat,
                        lon,
                        radius_km: Math.max(0.1, Math.min(150, Number(origin?.radiusKm ?? origin?.radius_km ?? 50) || 50)),
                    };
                };
                if (selectedScope?.type === 'multi_point' && Array.isArray(selectedScope.origins)) {
                    return selectedScope.origins.slice(0, 5)
                        .map(normalizeOrigin)
                        .filter(Boolean);
                }
                const scopedOrigin = normalizeOrigin(selectedScope, 0);
                if (scopedOrigin) return [scopedOrigin];
                if (Array.isArray(this.lastCompetitorRouteOrigins) && this.lastCompetitorRouteOrigins.length) {
                    return this.lastCompetitorRouteOrigins.slice(0, 5).map((origin) => ({ ...origin }));
                }
                const reference = this.referencePoint();
                const fallback = normalizeOrigin({
                    id: `point:competitor-${toolType}-active`,
                    label: 'Point actif',
                    lat: reference?.lat,
                    lon: reference?.lon,
                    radius_km: 50,
                });
                return fallback ? [fallback] : [];
            },

            // Afficher les résultats de recherche
            showSearchResults(results, method, query, apiResult = {}) {
                if (results.length === 0) {
                    if (method === 'structured') {
                        return;
                    }
                    if (apiResult.modal_mode === 'review') {
                        alert('Aucun concurrent ajouté pour le moment.');
                        return;
                    }
                    const info = apiResult.search_info || {};
                    const radius = info.radius_km || '?';
                    const areaMode = info.area_mode;
                    if (
                        info.rate_limited
                        || info.source_status === 'rate_limited'
                        || info.source_status === 'unavailable'
                        || (info.source_status === 'partial' && info.message_user)
                    ) {
                        alert(`${info.message_user || 'La source SIRENE est temporairement limitée.'}\nRéessayez dans quelques minutes ou relancez la recherche plus tard.`);
                        return;
                    }
                    const scopeLabel = info.scope_label
                        ? `dans « ${info.scope_label} »${info.spatial_relation === 'nearby' ? ` et jusqu’à ${info.buffer_km || 2} km autour` : ''}`
                        : (areaMode === 'polygon' ? 'dans le périmètre choisi' : `dans un rayon de ${radius} km`);
                    alert(`Aucun concurrent trouvé ${scopeLabel}.\nEssayez de changer de secteur/code NAF ou de vérifier la zone active.`);
                    return;
                }

                const searchInfo = apiResult.search_info || {};
                const isReviewMode = apiResult.modal_mode === 'review';
                const totalReceived = results.length;
                const hasSpatialCounts = ['zdc', 'zdc_union', 'folder'].includes(
                    String(searchInfo.scope_type || ''),
                );
                const strictInsideCount = Number(searchInfo.strict_inside_count ?? totalReceived);
                const nearbyCount = Number(searchInfo.nearby_count ?? 0);
                const resultLimit = Number(searchInfo.result_limit || 0);
                const countIsExhaustive = searchInfo.count_is_exhaustive === true;
                const restoredSearchSnapshot = this.normalizeCompetitorSearchSnapshot(
                    apiResult.restore_snapshot,
                );
                const modeLabel = isReviewMode
                    ? 'Liste'
                    : (
                        searchInfo.spatial_relation === 'nearby'
                            ? `ZDC + ${searchInfo.buffer_km || 2} km`
                            : (searchInfo.scope_label || (searchInfo.area_mode === 'polygon' ? 'Périmètre strict' : 'Rayon'))
                    );
                const restoredSelectedIds = restoredSearchSnapshot
                    ? new Set(restoredSearchSnapshot.modal_state.selected_ids)
                    : null;
                const reviewRoutingSelectedIds = isReviewMode
                    ? new Set(Array.isArray(apiResult.route_selected_ids)
                        ? apiResult.route_selected_ids.map((id) => String(id || '')).filter(Boolean)
                        : [])
                    : null;
                const currentRemovedCompetitorIds = () => new Set(
                    this.competitorWorkspaceController.snapshot().removed.competitor_ids,
                );
                const initiallyRemovedIds = currentRemovedCompetitorIds();
                const selectedIndexes = new Set(results
                    .map((competitor, index) => (
                        !initiallyRemovedIds.has(this.competitorIdentity(competitor))
                        && (!restoredSelectedIds || restoredSelectedIds.has(this.competitorIdentity(competitor)))
                            ? index
                            : null
                    ))
                    .filter((index) => index !== null));
                const escape = (value) => this.escapeCompetitorText(value);
                const normalize = (value) => String(value || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
                const metaItems = [
                    searchInfo.source_label || '',
                    modeLabel,
                    searchInfo.area_mode !== 'polygon' && searchInfo.radius_km ? `Rayon ${searchInfo.radius_km} km` : '',
                    searchInfo.pages_fetched ? `${searchInfo.pages_fetched} page${searchInfo.pages_fetched > 1 ? 's' : ''} API` : '',
                    searchInfo.result_limit ? `Limite ${searchInfo.result_limit}` : '',
                    searchInfo.spatial_relation === 'nearby' ? `${nearbyCount} à proximité` : '',
                ].filter(Boolean);
                const structuredSnapshot = method === 'structured'
                    && query
                    && Array.isArray(query.criteria)
                    ? query
                    : null;
                const routeOrigins = isReviewMode
                    ? (
                        Array.isArray(apiResult.route_origins) && apiResult.route_origins.length
                            ? apiResult.route_origins.map((origin) => ({ ...origin }))
                            : this.competitorRouteOrigins()
                    )
                    : this.competitorRouteOrigins(structuredSnapshot?.scope || null);
                const structuredCriterionLabels = {
                    keyword: 'Mot-clé',
                    brand: 'Enseigne',
                    sector: 'Secteur',
                    naf: 'Code APE/NAF',
                    siren: 'SIREN/SIRET',
                };
                const sourceState = apiResult.source_state || (
                    restoredSearchSnapshot
                        ? this.competitorSnapshotSourceState(restoredSearchSnapshot)
                        : { available: true, label: structuredSnapshot?.scope?.label || '' }
                );
                const availableStructuredScopeOptions = structuredSnapshot
                    ? this.competitorScopeOptions()
                    : [];
                const isMultiOriginScope = structuredSnapshot?.scope?.type === 'multi_point';
                const structuredScopeValue = structuredSnapshot?.scope?.value || 'viewport';
                const structuredScopeOptions = (
                    structuredSnapshot
                    && sourceState.available === false
                    && !availableStructuredScopeOptions.some((item) => item.value === structuredScopeValue)
                )
                    ? [{
                        value: structuredScopeValue,
                        label: `Indisponible · ${sourceState.label || 'Source supprimée'}`,
                        disabled: true,
                    }, ...availableStructuredScopeOptions]
                    : availableStructuredScopeOptions;
                const structuredScopeControlHtml = isMultiOriginScope
                    ? `
                        <div class="home-competitor-modal-origin-summary" data-competitor-modal-origins>
                            <span>Origines</span>
                            <strong>${escape(`${structuredSnapshot.scope.origins?.length || 0} points cumulés`)}</strong>
                        </div>
                    `
                    : `
                        <label>
                            <span>Périmètre</span>
                            <select data-competitor-modal-scope>
                                ${structuredScopeOptions.map((item) => `
                                    <option value="${escape(item.value)}"${item.value === structuredScopeValue ? ' selected' : ''}${item.disabled ? ' disabled' : ''}>${escape(item.label)}</option>
                                `).join('')}
                            </select>
                        </label>
                    `;
                const structuredCriteriaHtml = structuredSnapshot
                    ? `
                        <section class="g2-wzo-modal-section home-competitor-modal-criteria" data-competitor-modal-criteria>
                            <div class="home-competitor-modal-criteria__heading">
                                <h5>Critères actifs</h5>
                                <div class="home-competitor-modal-criteria__controls">
                                    ${structuredScopeControlHtml}
                                    <label>
                                        <span>Correspondance</span>
                                        <select data-competitor-modal-operator>
                                            <option value="OR"${structuredSnapshot.operator === 'OR' ? ' selected' : ''}>Au moins un critère (OU)</option>
                                            <option value="AND"${structuredSnapshot.operator === 'AND' ? ' selected' : ''}>Tous les critères (ET)</option>
                                        </select>
                                    </label>
                                </div>
                            </div>
                            <div class="home-competitor-filter-tokens" role="list" aria-label="Critères actifs de la recherche">
                                ${structuredSnapshot.criteria.map((criterion) => {
                                    const label = structuredCriterionLabels[criterion.type] || criterion.type;
                                    return `
                                        <span class="home-competitor-filter-token" role="listitem">
                                            <span>${escape(label)} : ${escape(criterion.value)}</span>
                                            <button type="button"
                                                data-competitor-modal-remove="${escape(criterion.id || '')}"
                                                aria-label="Retirer ${escape(label)} ${escape(criterion.value)}">×</button>
                                        </span>
                                    `;
                                }).join('')}
                            </div>
                            <p class="home-competitor-modal-criteria__status" role="status">
                                Retirer un critère ou changer ET/OU relance la recherche sur le même périmètre.
                            </p>
                        </section>
                    `
                    : '';
                const rawField = (comp, keys) => {
                    for (const key of keys) {
                        const value = comp?.[key];
                        if (value !== undefined && value !== null && String(value).trim()) return String(value).trim();
                    }
                    return '';
                };
                const uniqueOptions = (keys) => Array.from(new Set(results
                    .map((comp) => rawField(comp, keys))
                    .filter(Boolean)))
                    .sort((a, b) => a.localeCompare(b, 'fr'))
                    .slice(0, 80);
                const normalizeMultiValues = (value) => (Array.isArray(value) ? value : String(value || '').split(','))
                    .map((item) => String(item || '').trim())
                    .filter(Boolean);
                const multiFilterHtml = (name, label, items, value = []) => {
                    const selected = new Set(normalizeMultiValues(value));
                    const choices = items.map((item) => (
                        item && typeof item === 'object'
                            ? { value: String(item.value || ''), label: String(item.label || item.value || '') }
                            : { value: String(item || ''), label: String(item || '') }
                    )).filter((item) => item.value);
                    return `
                        <div class="g2-wzo-multi-filter" data-wzo-multi-filter-panel="${escape(name)}">
                            <button type="button" class="g2-wzo-multi-filter-trigger" data-wzo-multi-filter-toggle="${escape(name)}" aria-expanded="false">
                                <span>${escape(label)}</span>
                                <strong data-wzo-multi-filter-summary="${escape(name)}">${selected.size ? `${selected.size} choisi(s)` : 'Tous'}</strong>
                            </button>
                            <div class="g2-wzo-multi-filter-options" data-wzo-multi-filter-menu="${escape(name)}" hidden>
                                ${choices.map((item) => `
                                    <label>
                                        <input type="checkbox" data-wzo-multi-filter="${escape(name)}" value="${escape(item.value)}"${selected.has(item.value) ? ' checked' : ''}>
                                        <span>${escape(item.label)}</span>
                                    </label>
                                `).join('') || '<p>Aucune valeur disponible.</p>'}
                            </div>
                        </div>
                    `;
                };
                const parseKeywords = (value) => String(value || '')
                    .split(',')
                    .map((item) => normalize(item).trim())
                    .filter(Boolean);
                const competitorNameText = (comp) => normalize([
                    comp.name,
                    comp.nom,
                    comp.denomination,
                    comp.denomination_usuelle,
                    comp.enseigne,
                ].filter(Boolean).join(' '));
                const keywordCandidateRows = () => {
                    const removedIds = currentRemovedCompetitorIds();
                    const seen = new Set();
                    return results.filter((competitor) => {
                        const identity = this.competitorIdentity(competitor);
                        if (!identity || removedIds.has(identity) || seen.has(identity)) {
                            return false;
                        }
                        seen.add(identity);
                        return true;
                    });
                };
                const keywordCountLabel = (count) => (
                    `${count} candidat${count > 1 ? 's' : ''}`
                );
                const keywordSuggestions = (filters = modalFilters) => {
                    const stopwords = new Set(['de', 'des', 'du', 'la', 'le', 'les', 'et', 'en', 'a', 'au', 'aux', 'sas', 'sarl', 'eurl', 'sa', 'societe']);
                    const words = new Set();
                    const rows = keywordCandidateRows();
                    rows.forEach((comp) => {
                        new Set(competitorNameText(comp).split(/[^a-z0-9]+/))
                            .forEach((word) => {
                                if (word.length >= 4 && !stopwords.has(word)) words.add(word);
                            });
                    });
                    return Array.from(words)
                        .map((word) => ({
                            word,
                            ...window.MaplyticsCompetitorSearch.keywordExclusionImpact(
                                rows,
                                filters,
                                word,
                            ),
                        }))
                        .filter((item) => item.active || item.count > 0)
                        .sort((a, b) => b.count - a.count || a.word.localeCompare(b.word, 'fr'))
                        .slice(0, 20);
                };
                const keywordButtonsHtml = (items, emptyHtml) => items.map((item) => {
                    const countLabel = keywordCountLabel(item.count);
                    const action = item.active ? 'Réintégrer' : 'Exclure';
                    const actionLabel = `${action} ${countLabel} pour le mot ${item.word}`;
                    return `
                        <button type="button" data-wzo-keyword-token="${escape(item.word)}" data-ui-action="toggle-sirene-keyword-exclusion" data-keyword-affected-count="${escape(item.count)}" class="${item.active ? 'is-active' : ''}" aria-pressed="${item.active ? 'true' : 'false'}" aria-label="${escape(actionLabel)}" title="${escape(actionLabel)}">
                            <span>${escape(item.word)}</span>
                            <em>${escape(countLabel)}</em>
                        </button>
                    `;
                }).join('') || emptyHtml;
                const effectifOptions = uniqueOptions(['tranche_effectif']);
                const nafOptions = uniqueOptions(['naf_code', 'code_naf']);
                const cityOptions = uniqueOptions(['city', 'ville']);
                const statusOptions = uniqueOptions(['statut', 'status', 'etat_administratif']);
                const originOptions = Array.from(new Map(results.flatMap((competitor) => (
                    Array.isArray(competitor.origins) ? competitor.origins : []
                )).map((origin) => [
                    String(origin.origin_id || ''),
                    {
                        value: String(origin.origin_id || ''),
                        label: String(origin.origin_label || origin.origin_id || 'Origine'),
                    },
                ])).values()).filter((origin) => origin.value);
                const defaultModalFilters = {
                    excludedKeywords: '',
                    sortKey: 'distance_km',
                    sortDir: 'asc',
                    effectifFilter: [],
                    nafFilter: [],
                    cityFilter: [],
                    statusFilter: [],
                    originFilter: [],
                    createdAfter: '',
                    createdBefore: '',
                    minDistance: '',
                    maxDistance: '',
                    showExcluded: false,
                    showCompetitors: true,
                    validCoordsOnly: false,
                    keywordsExpanded: false,
                };
                const restoredFilters = isReviewMode
                    ? (apiResult.view_filters || {})
                    : (restoredSearchSnapshot?.modal_state?.filters || {});
                let modalFilters = {
                    ...defaultModalFilters,
                    excludedKeywords: String(restoredFilters.excludedKeywords || '').slice(0, 500),
                    sortKey: ['source_order', 'distance_km', 'name', 'city', 'naf_code', 'activity', 'date_creation', 'tranche_effectif'].includes(restoredFilters.sortKey)
                        ? restoredFilters.sortKey
                        : defaultModalFilters.sortKey,
                    sortDir: restoredFilters.sortDir === 'desc' ? 'desc' : 'asc',
                    effectifFilter: normalizeMultiValues(restoredFilters.effectifFilter).slice(0, 80),
                    nafFilter: normalizeMultiValues(restoredFilters.nafFilter).slice(0, 80),
                    cityFilter: normalizeMultiValues(restoredFilters.cityFilter).slice(0, 80),
                    statusFilter: normalizeMultiValues(restoredFilters.statusFilter).slice(0, 80),
                    originFilter: normalizeMultiValues(restoredFilters.originFilter).slice(0, 5),
                    createdAfter: String(restoredFilters.createdAfter || '').slice(0, 10),
                    createdBefore: String(restoredFilters.createdBefore || '').slice(0, 10),
                    minDistance: String(restoredFilters.minDistance || '').slice(0, 16),
                    maxDistance: String(restoredFilters.maxDistance || '').slice(0, 16),
                    showExcluded: Boolean(restoredFilters.showExcluded),
                    showCompetitors: restoredFilters.showCompetitors !== false,
                    validCoordsOnly: Boolean(restoredFilters.validCoordsOnly),
                    keywordsExpanded: Boolean(restoredFilters.keywordsExpanded),
                };
                if (isReviewMode) {
                    modalFilters.searchText = String(restoredFilters.searchText || '').slice(0, 120);
                }
                const advancedFilterLabels = (filters = modalFilters) => {
                    const labels = [];
                    if (filters.excludedKeywords) labels.push('mots exclus');
                    if (filters.effectifFilter.length) labels.push(`effectif (${filters.effectifFilter.length})`);
                    if (filters.nafFilter.length) labels.push(`APE/NAF (${filters.nafFilter.length})`);
                    if (filters.cityFilter.length) labels.push(`commune (${filters.cityFilter.length})`);
                    if (filters.statusFilter.length) labels.push(`statut (${filters.statusFilter.length})`);
                    if (filters.createdAfter || filters.createdBefore) labels.push('date de création');
                    if (filters.minDistance || filters.maxDistance) labels.push('distance');
                    if (filters.showExcluded) labels.push('exclus visibles');
                    if (filters.validCoordsOnly) labels.push('coordonnées valides');
                    if (!isReviewMode && filters.showCompetitors === false) labels.push('carte masquée');
                    return labels;
                };
                const initialAdvancedLabels = advancedFilterLabels();
                const advancedPanelOpen = initialAdvancedLabels.length > 0
                    || this.competitorPanelPreferenceStore?.snapshot?.().advancedOpen === true;

                const modal = document.createElement('div');
                modal.className = 'competitor-search-modal';
                modal.dataset.competitorToolType = toolType;
                modal.setAttribute('role', 'presentation');

                const content = document.createElement('div');
                content.className = 'g2-wzo-modal geo-manager-white-zone-opportunity-modal';
                content.setAttribute('role', 'dialog');
                content.setAttribute('aria-modal', 'true');
                content.setAttribute(
                    'aria-label',
                    isReviewMode ? 'Revue des concurrents ajoutés' : 'Sélection des concurrents',
                );
                content.dataset.competitorModalMode = isReviewMode ? 'review' : 'candidate';
                content.tabIndex = -1;

                content.innerHTML = `
                    <header class="g2-wzo-modal-hero">
                        <div>
                            <span>Recherche concurrence</span>
                            <h4>${isReviewMode ? 'Voir les concurrents ajoutés' : 'Sélectionner les concurrents à ajouter'}</h4>
                            <p>
                                ${escape(totalReceived)} ${isReviewMode ? `concurrent${totalReceived > 1 ? 's' : ''} ajouté${totalReceived > 1 ? 's' : ''}` : `résultat${totalReceived > 1 ? 's' : ''} reçu${totalReceived > 1 ? 's' : ''}`}${metaItems.length ? ` · ${escape(metaItems.join(' · '))}` : ''}
                            </p>
                        </div>
                        <button type="button" id="closeCompetitorModal" class="g2-wzo-modal-close" aria-label="Fermer la sélection des concurrents">×</button>
                    </header>
                    ${sourceState.available === false ? `<div class="g2-wzo-modal-alert" role="alert" data-competitor-source-missing>${escape(sourceState.message || 'La source enregistrée n’existe plus. Le snapshot reste consultable sans rattachement automatique.')}</div>` : ''}
                    ${searchInfo.results_truncated ? `<div class="g2-wzo-modal-alert" data-competitor-count-warning>Affichage borné${resultLimit ? ` à ${escape(resultLimit)}` : ''} : le total réel peut être supérieur. Affinez le périmètre ou les critères.</div>` : (!countIsExhaustive && hasSpatialCounts && !isReviewMode ? '<div class="g2-wzo-modal-alert" data-competitor-count-warning>La source est partielle : les nombres affichés ne constituent pas un total exhaustif.</div>' : '')}
                    <section class="g2-wzo-modal-kpis" aria-label="Résumé recherche concurrence">
                        ${hasSpatialCounts ? `
                            <div class="g2-wzo-kpi"><span>${isReviewMode ? 'Ajoutés' : 'Affichés'}</span><strong data-competitor-displayed-count>${escape(totalReceived)}</strong></div>
                            <div class="g2-wzo-kpi"><span>Dans ZDC</span><strong data-competitor-inside-count>${escape(strictInsideCount)}</strong></div>
                            <div class="g2-wzo-kpi"><span>À proximité</span><strong data-competitor-nearby-count>${escape(nearbyCount)}</strong></div>
                            <div class="g2-wzo-kpi"><span>Limite</span><strong data-competitor-result-limit>${escape(resultLimit || 'Non précisée')}</strong></div>
                        ` : `
                            <div class="g2-wzo-kpi"><span>${isReviewMode ? 'Ajoutés' : 'Reçus'}</span><strong>${escape(totalReceived)}</strong></div>
                            <div class="g2-wzo-kpi"><span>Rayon</span><strong>${escape(searchInfo.radius_km || '-')} km</strong></div>
                            <div class="g2-wzo-kpi"><span>Source</span><strong>${escape(searchInfo.source_label || 'Non précisée')}</strong></div>
                            <div class="g2-wzo-kpi"><span>Mode</span><strong>${escape(modeLabel)}</strong></div>
                        `}
                    </section>
                    ${structuredCriteriaHtml}
                    <section class="g2-wzo-modal-section home-competitor-modal-filters" data-ui-section="white-zone-sirene-filters">
                        <h5>${isReviewMode ? 'Filtrer les concurrents ajoutés' : 'Filtrer les candidats SIRENE'}</h5>
                        <div class="home-competitor-modal-basic-filters" data-competitor-basic>
                            ${isReviewMode ? '<label><span>Nom, ville ou activité</span><input data-wzo-filter-input="searchText" value="" placeholder="ex: jardinerie, Orléans"></label>' : ''}
                            <label><span>Trier par</span><select data-wzo-filter-input="sortKey">
                                <option value="source_order">Ordre d’ajout</option>
                                <option value="distance_km">Distance de recherche</option>
                                <option value="name">Dénomination</option>
                                <option value="city">Commune</option>
                                <option value="naf_code">APE/NAF</option>
                                <option value="activity">Activité</option>
                                <option value="date_creation">Création</option>
                                <option value="tranche_effectif">Effectif</option>
                            </select></label>
                            <label><span>Ordre</span><select data-wzo-filter-input="sortDir">
                                <option value="asc">Croissant</option>
                                <option value="desc">Décroissant</option>
                            </select></label>
                            ${originOptions.length > 1 ? multiFilterHtml('originFilter', 'Origine', originOptions, modalFilters.originFilter) : ''}
                        </div>
                        <details class="home-competitor-modal-advanced" data-competitor-advanced${advancedPanelOpen ? ' open' : ''}>
                            <summary>
                                <span>Options avancées</span>
                                <strong data-competitor-advanced-summary>${initialAdvancedLabels.length ? `${initialAdvancedLabels.length} active(s)` : 'Aucune active'}</strong>
                            </summary>
                            <div class="g2-wzo-filterbar geo-manager-white-zone-sirene-filter-panel" data-ui-group="white-zone-sirene-filter-controls">
                                <label><span>Exclure mots-clés</span><input data-wzo-filter-input="excludedKeywords" value="" placeholder="ex: holding, siège, centrale"></label>
                                <button type="button" data-wzo-modal-action="keywords" data-ui-action="open-sirene-keyword-filter-modal" class="geo-v2-secondary-btn"><i class="fas fa-filter" aria-hidden="true"></i> Voir plus de mots</button>
                                <div class="g2-wzo-keyword-strip" aria-label="Top mots-clés SIRENE" data-legacy-keyword-strip></div>
                                ${multiFilterHtml('effectifFilter', 'Effectif', effectifOptions, modalFilters.effectifFilter)}
                                ${multiFilterHtml('nafFilter', 'APE/NAF', nafOptions, modalFilters.nafFilter)}
                                ${multiFilterHtml('cityFilter', 'Commune', cityOptions, modalFilters.cityFilter)}
                                ${statusOptions.length ? multiFilterHtml('statusFilter', 'Statut', statusOptions, modalFilters.statusFilter) : ''}
                                <label><span>Créé après</span><input type="date" data-wzo-filter-input="createdAfter" value=""></label>
                                <label><span>Créé avant</span><input type="date" data-wzo-filter-input="createdBefore" value=""></label>
                                <label><span>Distance recherche min</span><input inputmode="decimal" data-wzo-filter-input="minDistance" value="" placeholder="km"></label>
                                <label><span>Distance recherche max</span><input inputmode="decimal" data-wzo-filter-input="maxDistance" value="" placeholder="km"></label>
                                <label class="g2-wzo-filterbar-check">
                                    <input type="checkbox" data-wzo-filter-check="showExcluded">
                                    <span>Afficher les exclues dans la liste</span>
                                </label>
                                ${isReviewMode ? '' : `<label class="g2-wzo-filterbar-check">
                                    <input type="checkbox" data-wzo-filter-check="showCompetitors" checked>
                                    <span>Afficher concurrence SIRENE sur carte</span>
                                </label>`}
                                <label class="g2-wzo-filterbar-check">
                                    <input type="checkbox" data-wzo-filter-check="validCoordsOnly">
                                    <span>Coordonnées valides uniquement</span>
                                </label>
                            </div>
                        </details>
                        <p class="home-competitor-active-filter-summary" data-competitor-active-filter-summary>${initialAdvancedLabels.length ? `Filtres avancés actifs : ${escape(initialAdvancedLabels.join(', '))}.` : 'Aucun filtre avancé actif.'}</p>
                        <p class="home-competitor-modal-next-action" data-competitor-next-action><span id="filteredCompCount"></span> · ${isReviewMode ? 'Fermez pour appliquer cette vue à toutes les surfaces.' : 'Sélectionnez les candidats puis ajoutez-les.'}</p>
                        <p class="home-competitor-filter-base-note">Les filtres repartent toujours de la base complète (${escape(totalReceived)} ${isReviewMode ? 'concurrents ajoutés' : 'concurrents reçus'}). ${isReviewMode ? 'Cette vue pilote la liste, la carte, la légende, le score et les exports.' : 'Cette vue sert à sélectionner les concurrents à ajouter.'}</p>
                    </section>
                    <section class="g2-wzo-modal-section">
                        <h5>${isReviewMode ? 'Actions' : 'Sélection'}</h5>
                        <div class="g2-wzo-modal-actions">
                            ${isReviewMode ? '' : `
                                <button type="button" id="selectAllCompetitors" class="ghost-btn">Tout sélectionner</button>
                                <button type="button" id="deselectAllCompetitors" class="ghost-btn">Tout désélectionner</button>
                            `}
                            <button type="button" id="resetCompetitorFilters" class="ghost-btn">Réinitialiser filtres</button>
                            ${routeOrigins.length ? `
                                <button type="button" id="calculateCompetitorRoutes" class="ghost-btn"${isReviewMode && !reviewRoutingSelectedIds.size ? ' disabled' : ''}>
                                    Calculer les trajets voiture${isReviewMode ? ` (${escape(reviewRoutingSelectedIds.size)})` : ''}
                                </button>
                                <span id="competitorRouteStatus" role="status">Valhalla · ${escape(routeOrigins.length)} origine${routeOrigins.length > 1 ? 's' : ''} · ${isReviewMode ? `${escape(reviewRoutingSelectedIds.size)} sélectionné${reviewRoutingSelectedIds.size > 1 ? 's' : ''}` : 'sélection courante'} · 200 maximum par lots de 19</span>
                            ` : ''}
                            ${isReviewMode ? '' : `<span id="selectedCompCount" class="g2-wzo-selected-count">${results.length}/${results.length} sélectionnés</span>`}
                        </div>
                    </section>
                    <section class="g2-wzo-modal-section">
                        <h5>${isReviewMode ? 'Concurrents ajoutés' : 'Concurrents reçus'}</h5>
                        <div id="competitorSearchResultsList" class="g2-wzo-modal-list"></div>
                        <details class="g2-wzo-excluded-sirene" id="competitorSearchExcludedDetails" hidden>
                            <summary>Exclus par filtre (<span id="excludedCompCount">0</span>)</summary>
                            <div class="g2-wzo-modal-list" id="competitorSearchExcludedList"></div>
                        </details>
                    </section>
                    <footer class="g2-wzo-modal-footer">
                        ${isReviewMode ? '' : '<button type="button" id="cancelAddCompetitors" class="ghost-btn">Annuler</button>'}
                        <button type="button" id="confirmAddCompetitors" class="primary-btn">${isReviewMode ? 'Fermer' : 'Ajouter les concurrents sélectionnés'}</button>
                    </footer>
                `;

                modal.appendChild(content);
                const previousFocus = document.activeElement;
                const previousOverflow = document.body.style.overflow;
                document.body.style.overflow = 'hidden';
                document.body.appendChild(modal);

                const listEl = modal.querySelector('#competitorSearchResultsList');
                const excludedListEl = modal.querySelector('#competitorSearchExcludedList');
                const excludedDetailsEl = modal.querySelector('#competitorSearchExcludedDetails');
                const excludedCountEl = modal.querySelector('#excludedCompCount');
                const selectedCountEl = modal.querySelector('#selectedCompCount');
                const filteredCountEl = modal.querySelector('#filteredCompCount');
                const advancedDetails = modal.querySelector('[data-competitor-advanced]');
                const advancedSummary = modal.querySelector('[data-competitor-advanced-summary]');
                const activeFilterSummary = modal.querySelector('[data-competitor-active-filter-summary]');
                advancedDetails?.addEventListener('toggle', () => {
                    this.competitorPanelPreferenceStore?.update?.({
                        advancedOpen: advancedDetails.open,
                    });
                });
                const syncAdvancedFilterSummary = () => {
                    const labels = advancedFilterLabels();
                    if (advancedSummary) {
                        advancedSummary.textContent = labels.length
                            ? `${labels.length} active${labels.length > 1 ? 's' : ''}`
                            : 'Aucune active';
                    }
                    if (activeFilterSummary) {
                        activeFilterSummary.textContent = labels.length
                            ? `Filtres avancés actifs : ${labels.join(', ')}.`
                            : 'Aucun filtre avancé actif.';
                    }
                };
                const hasCoords = (comp) => Number.isFinite(Number(comp.lat ?? comp.latitude))
                    && Number.isFinite(Number(comp.lon ?? comp.lng ?? comp.longitude));
                const currentFilteredDataset = () => (
                    window.MaplyticsCompetitorSearch.filterDataset(results, modalFilters)
                );
                const currentFilteredIndexes = () => {
                    const dataset = currentFilteredDataset();
                    const removedIds = currentRemovedCompetitorIds();
                    const asRow = (entry) => ({
                        comp: entry.competitor,
                        index: entry.index,
                        reasons: entry.reasons,
                        removed: removedIds.has(entry.id),
                    });
                    const included = dataset.ordered_included.map(asRow).filter((row) => !row.removed);
                    const excluded = dataset.ordered_excluded.map(asRow).filter((row) => !row.removed);
                    const removed = dataset.entries.map(asRow).filter((row) => row.removed);
                    const visible = modalFilters.showExcluded
                        ? dataset.entries.map(asRow)
                        : [...included, ...removed];
                    return { visible, included, excluded, removed, dataset };
                };
                const mergeRoutingIntoWorkspace = () => {
                    const routingByIdentity = new Map(results.map((row) => [
                        this.competitorIdentity(row),
                        row.routing,
                    ]));
                    return this.competitorWorkspaceController.snapshot().rows.map((row) => {
                        const identity = this.competitorIdentity(row);
                        if (!routingByIdentity.has(identity)) return row;
                        return { ...row, routing: routingByIdentity.get(identity) };
                    });
                };

                const updateSelectedCount = () => {
                    if (!selectedCountEl) return;
                    const includedIndexes = currentFilteredIndexes().included.map(({ index }) => index);
                    const selectedIncluded = includedIndexes.filter((index) => selectedIndexes.has(index)).length;
                    selectedCountEl.textContent = `${selectedIncluded}/${includedIndexes.length} candidats gardés sélectionnés`;
                };

                const renderModalList = () => {
                    const {
                        visible: filtered,
                        included,
                        excluded,
                        removed,
                        dataset,
                    } = currentFilteredIndexes();
                    content.dataset.competitorViewFingerprint = dataset.fingerprint;
                        const rowHtml = ({ comp, index, reasons = [], removed = false }, selectable = true) => {
                        const effectif = getEffectifLabel(comp.tranche_effectif);
                        const nafDisplay = comp.naf_libelle || (comp.naf_code ? `NAF: ${comp.naf_code}` : '');
                        const distance = comp.distance_km !== undefined && comp.distance_km !== null ? `Recherche ${comp.distance_km} km` : '';
                        const spatialRelation = comp.spatial_relation === 'nearby'
                            ? 'À proximité de la ZDC'
                            : (comp.spatial_relation === 'inside' ? 'Dans la ZDC' : '');
                        const meta = [spatialRelation, nafDisplay, effectif, distance].filter(Boolean).join(' · ');
                        const provenance = (Array.isArray(comp.origins) ? comp.origins : []).map((origin) => {
                            const searchDistance = origin.distance_km;
                            const originDistance = searchDistance !== null
                                && searchDistance !== undefined
                                && Number.isFinite(Number(searchDistance))
                                ? `${Number(searchDistance).toFixed(2).replace(/\.00$/, '')} km`
                                : 'Non disponible';
                            return `${origin.origin_label || origin.origin_id || 'Origine'}: ${originDistance}`;
                        }).join(' · ');
                        const routing = (Array.isArray(comp.routing?.origins) ? comp.routing.origins : []).map((origin) => {
                            const roadDistance = this.competitorRoadMeasure(origin.road_distance_km);
                            const duration = this.competitorRoadMeasure(origin.road_duration_minutes);
                            if (
                                origin.routing_status !== 'available'
                                || roadDistance === null
                                || duration === null
                            ) {
                                return this.competitorRouteOriginState(origin);
                            }
                            const searchOrigin = (Array.isArray(comp.origins) ? comp.origins : []).find(
                                (item) => String(item.origin_id || '') === String(origin.origin_id || ''),
                            );
                            const searchDistance = Number(searchOrigin?.distance_km ?? comp.distance_km);
                            const delta = Number.isFinite(searchDistance)
                                ? ` · écart route/recherche ${(roadDistance - searchDistance) >= 0 ? '+' : ''}${(roadDistance - searchDistance).toFixed(2).replace(/\.00$/, '')} km`
                                : '';
                            return `${origin.origin_label || origin.origin_id || 'Origine'}: ${roadDistance.toFixed(2).replace(/\.00$/, '')} km · ${duration.toFixed(1).replace(/\.0$/, '')} min${delta}`;
                        }).join(' · ');
                        const routingFreshness = this.competitorRoutingFreshnessText(comp.routing);
                        const routingFailure = this.competitorRoutingFailureText(comp.routing);
                        return `
                            <label class="g2-wzo-modal-row ${removed ? 'is-removed' : reasons.length ? 'is-excluded' : 'is-competitor'}" data-competitor-review-id="${escape(this.competitorIdentity(comp))}" data-competitor-view-id="${escape(this.competitorIdentity(comp))}"${removed ? ' data-competitor-removed="true"' : ''}>
                                ${selectable && !isReviewMode && !removed ? `<input type="checkbox" class="competitor-checkbox" data-index="${index}" ${selectedIndexes.has(index) ? 'checked' : ''}>` : ''}
                                <span>
                                    <strong>${escape(comp.name || 'Nom inconnu')}</strong>
                                    <small>${escape([comp.address, comp.city, comp.postal_code].filter(Boolean).join(' '))}</small>
                                    ${meta ? `<small>${escape(meta)}</small>` : ''}
                                    ${provenance ? `<small data-competitor-origin-list>Distances de recherche : ${escape(provenance)}</small>` : ''}
                                    ${routing ? `<small data-competitor-routing-list>Trajets voiture : ${escape(routing)}</small>` : '<small data-competitor-routing-list>Trajets voiture : non calculés</small>'}
                                    ${routingFreshness ? `<small data-competitor-routing-freshness>${escape(routingFreshness)}</small>` : ''}
                                    ${routingFailure ? `<small data-competitor-routing-failure data-route-failure-code="${escape(comp.routing?.last_failure?.code || '')}">${escape(routingFailure)}</small>` : ''}
                                    ${removed ? '<small class="competitor-removed-candidate-status">Retiré manuellement · non réajouté</small>' : ''}
                                    ${reasons.length ? `<small>Exclu : ${escape(reasons.join(', '))}</small>` : ''}
                                </span>
                                <em>${hasCoords(comp) ? 'GPS' : 'sans GPS'}</em>
                            </label>
                        `;
                    };
                    if (filteredCountEl) {
                        const removedCount = removed.length;
                        filteredCountEl.textContent = (isReviewMode
                            ? `${included.length} concurrent${included.length > 1 ? 's' : ''} visible${included.length > 1 ? 's' : ''} · ${excluded.length} exclu${excluded.length > 1 ? 's' : ''} par filtre`
                            : `${included.length} candidat${included.length > 1 ? 's' : ''} gardé${included.length > 1 ? 's' : ''} · ${excluded.length} exclu${excluded.length > 1 ? 's' : ''} par filtre`)
                            + (removedCount ? ` · ${removedCount} retiré${removedCount > 1 ? 's' : ''}` : '');
                    }
                    if (excludedCountEl) excludedCountEl.textContent = String(excluded.length);
                    if (excludedDetailsEl) excludedDetailsEl.hidden = !excluded.length;
                    if (excludedListEl) {
                        excludedListEl.innerHTML = excluded.map((row) => rowHtml(row, false)).join('');
                    }
                    if (!listEl) return;
                    if (!filtered.length) {
                        listEl.innerHTML = '<div class="g2-analysis-empty">Aucun résultat ne correspond aux filtres.</div>';
                        updateSelectedCount();
                        return;
                    }
                    listEl.innerHTML = filtered.map((row) => rowHtml(row, row.reasons.length === 0)).join('');
                        listEl.querySelectorAll('.competitor-checkbox').forEach((checkbox) => {
                            checkbox.addEventListener('change', () => {
                                const index = Number(checkbox.dataset.index);
                                if (checkbox.checked) selectedIndexes.add(index);
                                else selectedIndexes.delete(index);
                                updateSelectedCount();
                                persistModalSnapshot();
                            });
                        });
                    updateSelectedCount();
                };

                const persistModalSnapshot = ({
                    immediate = false,
                    remote = false,
                } = {}) => {
                    if (isReviewMode) {
                        return this.applyCompetitorViewFilters(modalFilters);
                    }
                    if (!structuredSnapshot) return null;
                    const filteredDataset = currentFilteredDataset();
                    const snapshot = this.setCompetitorSearchSnapshot({
                        schema_version: this.COMPETITOR_SEARCH_SNAPSHOT_SCHEMA,
                        saved_at: new Date().toISOString(),
                        query: {
                            criteria: structuredSnapshot.criteria,
                            operator: structuredSnapshot.operator,
                            scope: structuredSnapshot.scope,
                        },
                        results,
                        search_info: searchInfo,
                        modal_state: {
                            filters: modalFilters,
                            selected_ids: Array.from(selectedIndexes)
                                .filter((index) => filteredDataset.ordered_included.some(
                                    (entry) => entry.index === index,
                                ))
                                .sort((a, b) => a - b)
                                .map((index) => this.competitorIdentity(results[index]))
                                .filter(Boolean),
                            dataset: {
                                schema_version: filteredDataset.schema_version,
                                fingerprint: filteredDataset.fingerprint,
                                included_ids: filteredDataset.included_ids,
                                excluded: filteredDataset.excluded.map((entry) => ({
                                    id: entry.id,
                                    reasons: entry.reasons,
                                })),
                            },
                        },
                    });
                    if (snapshot && remote) this.scheduleCompetitorSnapshotSave({ immediate });
                    return snapshot;
                };

                const currentRoutingDataset = () => {
                    const filtered = currentFilteredIndexes();
                    const included = filtered.included.filter(({ index, comp }) => (
                        isReviewMode
                            ? reviewRoutingSelectedIds.has(this.competitorIdentity(comp))
                            : selectedIndexes.has(index)
                    ));
                    const selectedIds = included.map(({ comp }) => this.competitorIdentity(comp));
                    const fingerprint = window.MaplyticsCompetitorSearch.fingerprint({
                        view_fingerprint: filtered.dataset.fingerprint,
                        selected_ids: selectedIds,
                    });
                    return {
                        ...filtered,
                        included,
                        dataset: {
                            ...filtered.dataset,
                            fingerprint,
                        },
                    };
                };

                const calculateRoadDistances = async () => {
                    const workspaceRequestGeneration = this._workspaceRequestGeneration;
                    const routeButton = modal.querySelector('#calculateCompetitorRoutes');
                    const routeStatus = modal.querySelector('#competitorRouteStatus');
                    const routeDataset = currentRoutingDataset();
                    const routeRows = routeDataset.included;
                    if (!routeButton || !routeStatus || !routeOrigins.length) return;
                    if (!routeRows.length) {
                        routeStatus.textContent = 'Aucun concurrent visible à calculer.';
                        this.setCompetitorRoutingSnapshot({
                            fingerprint: '',
                            status: 'empty',
                            rows: [],
                            summary: { competitors: 0, origins: routeOrigins.length },
                            calculated_at: null,
                            last_failure: null,
                        });
                        return;
                    }
                    if (routeRows.length > 200) {
                        routeStatus.textContent = `Réduisez la sélection à 200 concurrents maximum (${routeRows.length} actuellement).`;
                        return;
                    }
                    const requestKey = this.competitorRoutingRequestKey(
                        routeOrigins,
                        routeRows,
                        routeDataset.dataset.fingerprint,
                    );
                    if (
                        this._competitorRoutingRequest
                        && this._competitorRoutingRequest.key !== requestKey
                    ) {
                        routeStatus.textContent = 'Un calcul routier est déjà en cours pour une autre vue. Attendez sa fin puis relancez cette vue.';
                        return;
                    }
                    if (this._competitorRoutingRequest) {
                        routeStatus.textContent = 'Un calcul routier identique est déjà en cours…';
                        return;
                    }
                    routeButton.disabled = true;
                    delete routeStatus.dataset.routeCode;
                    delete routeStatus.dataset.routeReason;
                    routeStatus.textContent = 'Calcul routier Valhalla en cours…';
                    let activeRequest = null;
                    const requestGeneration = ++this._competitorRoutingGeneration;
                    const abortController = new AbortController();
                    this._competitorRoutingAbortController?.abort?.();
                    this._competitorRoutingAbortController = abortController;
                    this.setCompetitorRoutingSnapshot({
                        fingerprint: requestKey,
                        status: 'running',
                        selected_ids: routeRows.map(({ comp }) => this.competitorIdentity(comp)),
                        total: routeRows.length,
                        processed: 0,
                        succeeded: 0,
                        failed: 0,
                        batch_index: 0,
                        batch_count: Math.ceil(routeRows.length / 19),
                        rows: [],
                        summary: null,
                        calculated_at: null,
                        last_failure: null,
                        failed_batches: [],
                        generation: requestGeneration,
                    });
                    try {
                        const requestBatch = async (batchRows, batchIndex, {signal}) => {
                            const response = await fetch('/api/competitors/route-matrix', {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                credentials: 'include',
                                body: JSON.stringify({
                                    origins: routeOrigins,
                                    competitors: batchRows.map(({ comp }) => ({
                                        name: comp.name || comp.nom,
                                        siret: comp.siret,
                                        siren: comp.siren,
                                        lat: comp.lat ?? comp.latitude,
                                        lon: comp.lon ?? comp.lng ?? comp.longitude,
                                    })),
                                }),
                                signal,
                            });
                            let payload = {};
                            try {
                                payload = await response.json();
                            } catch (_error) {
                                payload = {};
                            }
                            if (!response.ok || !payload.success) {
                                const message = payload.error || `Erreur HTTP ${response.status}`;
                                if (response.status === 401 || response.status === 403) {
                                    handleAppApiError(response, payload, message);
                                }
                                const error = new Error(message);
                                if (response.status === 429) {
                                    const retryAfter = Number(response.headers.get('Retry-After') || 0);
                                    error.retryAfterMs = Number.isFinite(retryAfter) && retryAfter > 0
                                        ? retryAfter * 1000
                                        : 1000;
                                }
                                error.routeFailure = this.normalizeCompetitorRoutingFailure(
                                    payload,
                                    response.status,
                                );
                                throw error;
                            }
                            return payload;
                        };
                        if (
                            !this._competitorRoutingCoordinator
                            || this._competitorRoutingCoordinator.key !== requestKey
                        ) {
                            this._competitorRoutingCoordinator = {
                                key: requestKey,
                                coordinator: window.MaplyticsCompetitorRoutingBatches.createCoordinator({
                                    requestBatch,
                                }),
                            };
                        }
                        const promise = this._competitorRoutingCoordinator.coordinator.run({
                            rows: routeRows,
                            fingerprint: requestKey,
                            generation: requestGeneration,
                            signal: abortController.signal,
                            onProgress: (progress) => {
                                if (requestGeneration !== this._competitorRoutingGeneration) return;
                                this.setCompetitorRoutingSnapshot({
                                    ...progress,
                                    fingerprint: requestKey,
                                    status: 'running',
                                });
                                routeStatus.textContent = this.competitorRoutingSnapshotText();
                            },
                        });
                        activeRequest = {
                            key: requestKey,
                            promise,
                            generation: requestGeneration,
                            abortController,
                        };
                        this._competitorRoutingRequest = activeRequest;
                        const batchRun = await activeRequest.promise;
                        if (
                            workspaceRequestGeneration !== this._workspaceRequestGeneration
                            || requestGeneration !== this._competitorRoutingGeneration
                        ) return;
                        const liveDataset = currentRoutingDataset();
                        const liveRequestKey = this.competitorRoutingRequestKey(
                            routeOrigins,
                            liveDataset.included,
                            liveDataset.dataset.fingerprint,
                        );
                        if (!modal.isConnected || liveRequestKey !== requestKey) {
                            routeStatus.textContent = 'La vue a changé pendant le calcul. La réponse obsolète a été ignorée ; relancez sur la vue actuelle.';
                            return;
                        }
                        const successfulRouteRows = batchRun.successful.flatMap(
                            (batch) => batch.rows,
                        );
                        const firstPayload = batchRun.successful[0]?.payload || {};
                        const matrices = new Map(routeOrigins.map((origin) => [
                            String(origin.id || ''),
                            new Map(),
                        ]));
                        batchRun.successful.forEach(({ payload }) => {
                            (payload.origins || []).forEach((matrix) => {
                                const rowsById = matrices.get(String(matrix?.origin?.id || ''));
                                (matrix?.destinations || []).forEach((row) => {
                                    rowsById?.set(String(row.id || ''), row);
                                });
                            });
                        });
                        const nextRouting = new Map();
                        let reachable = 0;
                        let unreachable = 0;
                        const batchFailure = batchRun.failed_batches[0]?.error?.routeFailure || null;
                        const failedRouteRows = batchRun.failed_batches.flatMap(
                            (batch) => batch.rows,
                        );
                        const failedRowsHavePrevious = failedRouteRows.some(({ comp }) => (
                            Array.isArray(comp.routing?.origins) && comp.routing.origins.length > 0
                        ));
                        if (batchFailure) {
                            failedRouteRows.forEach(({ comp }) => {
                                const previous = comp.routing && typeof comp.routing === 'object'
                                    ? comp.routing
                                    : {};
                                comp.routing = {
                                    schema_version: previous.schema_version || 'competitor_route_matrix_v1',
                                    provider: previous.provider || 'valhalla',
                                    mode: previous.mode || 'car',
                                    calculated_at: previous.calculated_at || null,
                                    request_key: previous.request_key || null,
                                    origins: Array.isArray(previous.origins) ? previous.origins : [],
                                    last_failure: batchFailure,
                                };
                            });
                        }
                        for (const { comp } of successfulRouteRows) {
                            const competitorId = this.competitorIdentity(comp);
                            const originRows = routeOrigins.map((origin) => {
                                const row = matrices.get(String(origin.id))?.get(competitorId);
                                if (!row) {
                                    throw new Error('Réponse routière incomplète. Les mesures précédentes sont conservées.');
                                }
                                const roadDistance = this.competitorRoadMeasure(row.distance_km);
                                const roadDuration = this.competitorRoadMeasure(row.duration_min);
                                if (
                                    row.reachable
                                    && (
                                        roadDistance === null
                                        || roadDuration === null
                                    )
                                ) {
                                    const error = new Error('Réponse routière invalide. Les mesures précédentes sont conservées.');
                                    error.routeFailure = this.normalizeCompetitorRoutingFailure({
                                        code: 'COMPETITOR_ROUTE_INVALID_RESPONSE',
                                        reason: 'invalid_provider_response',
                                        action: 'retry',
                                        action_label: 'Réessayer',
                                        error: error.message,
                                    });
                                    throw error;
                                }
                                if (row.reachable) reachable += 1;
                                else unreachable += 1;
                                return {
                                    origin_id: origin.id,
                                    origin_label: origin.label,
                                    road_distance_km: row.reachable ? roadDistance : null,
                                    road_duration_minutes: row.reachable ? roadDuration : null,
                                    routing_status: row.reachable ? 'available' : 'unreachable',
                                    unreachable_reason: row.unreachable_reason || null,
                                    unreachable_message: row.unreachable_message || null,
                                    recommended_action: row.recommended_action || null,
                                    recommended_action_label: row.recommended_action_label || null,
                                };
                            });
                            nextRouting.set(competitorId, {
                                schema_version: firstPayload.schema_version || 'competitor_route_matrix_v1',
                                provider: firstPayload.provider || 'valhalla',
                                mode: firstPayload.mode || 'car',
                                calculated_at: new Date().toISOString(),
                                request_key: requestKey,
                                origins: originRows,
                                last_failure: null,
                            });
                        }
                        successfulRouteRows.forEach(({ comp }) => {
                            comp.routing = nextRouting.get(this.competitorIdentity(comp));
                        });
                        if (isReviewMode) {
                            this._competitorThreatScoreRequest += 1;
                            this._applyingCompetitorRouting = true;
                            try {
                                this.dispatchCompetitorWorkspace({
                                    type: 'transaction',
                                    actions: [
                                        {
                                            type: 'competitors/replace',
                                            rows: mergeRoutingIntoWorkspace(),
                                            preserveScore: true,
                                        },
                                        { type: 'score/clear' },
                                    ],
                                });
                            } finally {
                                this._applyingCompetitorRouting = false;
                            }
                        }
                        const calculatedAt = new Date().toISOString();
                        this.setCompetitorRoutingSnapshot({
                            fingerprint: requestKey,
                            status: batchRun.failed_batches.length
                                ? (successfulRouteRows.length ? 'partial' : 'error')
                                : (successfulRouteRows.length ? 'available' : 'empty'),
                            selected_ids: routeRows.map(({ comp }) => this.competitorIdentity(comp)),
                            total: batchRun.total,
                            processed: batchRun.processed,
                            succeeded: batchRun.succeeded,
                            failed: batchRun.failed,
                            batch_index: batchRun.batch_count,
                            batch_count: batchRun.batch_count,
                            rows: successfulRouteRows.map(({ comp }) => ({
                                id: this.competitorIdentity(comp),
                                routing: comp.routing,
                            })),
                            summary: {
                                competitors: successfulRouteRows.length,
                                origins: routeOrigins.length,
                                reachable,
                                unreachable,
                                provider: firstPayload.provider || 'valhalla',
                                mode: firstPayload.mode || 'car',
                            },
                            calculated_at: calculatedAt,
                            last_failure: batchFailure,
                            failed_batches: batchRun.failed_batches.map((batch) => ({
                                index: batch.batchIndex,
                                count: batch.rows.length,
                                code: String(batch.error?.routeFailure?.code || 'COMPETITOR_ROUTE_BATCH_FAILED'),
                                message: String(batch.error?.message || 'Lot routier en échec.'),
                            })),
                            generation: requestGeneration,
                        });
                        renderModalList();
                        persistModalSnapshot({
                            immediate: !isReviewMode,
                            remote: !isReviewMode,
                        });
                        if (isReviewMode) {
                            await this.saveCompetitors({ quiet: true });
                            this.refreshCompetitorViewSurfaces();
                        }
                        if (batchFailure) {
                            routeStatus.dataset.routeCode = batchFailure.code;
                            routeStatus.dataset.routeReason = batchFailure.reason;
                            routeStatus.textContent = `${batchFailure.message} · ${batchFailure.action_label}. ${failedRowsHavePrevious ? 'Le dernier résultat valide est conservé.' : 'Aucune distance routière n’a été inventée pour le lot en échec.'}`;
                        } else {
                            delete routeStatus.dataset.routeCode;
                            delete routeStatus.dataset.routeReason;
                            routeStatus.textContent = this.competitorRoutingSnapshotText();
                        }
                    } catch (error) {
                        if (
                            error?.name === 'AbortError'
                            || requestGeneration !== this._competitorRoutingGeneration
                        ) {
                            if (modal.isConnected) {
                                routeStatus.textContent = 'La vue a changé pendant le calcul. La réponse obsolète a été ignorée ; toute erreur obsolète a été ignorée également. Relancez sur la vue actuelle.';
                            }
                            return;
                        }
                        const liveDataset = currentRoutingDataset();
                        const liveRequestKey = this.competitorRoutingRequestKey(
                            routeOrigins,
                            liveDataset.included,
                            liveDataset.dataset.fingerprint,
                        );
                        if (!modal.isConnected || liveRequestKey !== requestKey) {
                            routeStatus.textContent = 'La vue a changé pendant le calcul. L’erreur obsolète a été ignorée ; relancez sur la vue actuelle.';
                            return;
                        }
                        const failure = error.routeFailure || this.normalizeCompetitorRoutingFailure({
                            code: 'COMPETITOR_ROUTE_INVALID_RESPONSE',
                            reason: 'invalid_provider_response',
                            action: 'retry',
                            action_label: 'Réessayer',
                            error: error.message || 'Calcul indisponible',
                        });
                        const hasPrevious = routeRows.some(({ comp }) => (
                            Array.isArray(comp.routing?.origins) && comp.routing.origins.length > 0
                        ));
                        routeRows.forEach(({ comp }) => {
                            const previous = comp.routing && typeof comp.routing === 'object'
                                ? comp.routing
                                : {};
                            comp.routing = {
                                schema_version: previous.schema_version || 'competitor_route_matrix_v1',
                                provider: previous.provider || 'valhalla',
                                mode: previous.mode || 'car',
                                calculated_at: previous.calculated_at || null,
                                request_key: previous.request_key || null,
                                origins: Array.isArray(previous.origins) ? previous.origins : [],
                                last_failure: failure,
                            };
                        });
                        if (isReviewMode) {
                            this._applyingCompetitorRouting = true;
                            try {
                                this.dispatchCompetitorWorkspace({
                                    type: 'competitors/replace',
                                    rows: mergeRoutingIntoWorkspace(),
                                    preserveScore: true,
                                });
                            } finally {
                                this._applyingCompetitorRouting = false;
                            }
                        }
                        const previousRows = Array.isArray(this.competitorRoutingSnapshot?.rows)
                            ? this.competitorRoutingSnapshot.rows
                            : [];
                        this.setCompetitorRoutingSnapshot({
                            fingerprint: requestKey,
                            status: 'error',
                            rows: previousRows,
                            summary: this.competitorRoutingSnapshot?.summary || null,
                            last_failure: failure,
                            generation: requestGeneration,
                        });
                        routeStatus.dataset.routeCode = failure.code;
                        routeStatus.dataset.routeReason = failure.reason;
                        routeStatus.textContent = `${failure.message} · ${failure.action_label}. ${hasPrevious ? 'Le dernier résultat valide est conservé.' : 'Aucune distance routière n’a été inventée.'}`;
                        renderModalList();
                        persistModalSnapshot({
                            immediate: !isReviewMode,
                            remote: !isReviewMode,
                        });
                        if (isReviewMode) {
                            await this.saveCompetitors({ quiet: true });
                            this.refreshCompetitorViewSurfaces();
                        }
                    } finally {
                        if (this._competitorRoutingRequest === activeRequest) {
                            this._competitorRoutingRequest = null;
                        }
                        if (this._competitorRoutingAbortController === abortController) {
                            this._competitorRoutingAbortController = null;
                        }
                        routeButton.disabled = false;
                    }
                };

                const closeModal = ({ persist = true } = {}) => {
                    if (persist) {
                        persistModalSnapshot({
                            immediate: true,
                            remote: !isReviewMode,
                        });
                    }
                    document.removeEventListener('keydown', onKeyDown);
                    document.body.style.overflow = previousOverflow;
                    if (modal.parentNode) {
                        document.body.removeChild(modal);
                    }
                    if (previousFocus && typeof previousFocus.focus === 'function') {
                        previousFocus.focus();
                    }
                };

                const rerunStructuredSearch = async (mutateState, scopeValue = '') => {
                    const builder = this.competitorFilterBuilder;
                    if (!structuredSnapshot || !builder?.state) return;
                    if (sourceState.available === false && !scopeValue) {
                        builder.setStatus(
                            'La source enregistrée n’existe plus. Choisissez un nouveau périmètre avant de relancer.',
                            'error',
                        );
                        return;
                    }
                    mutateState?.(builder.state);
                    let scope = structuredSnapshot.scope;
                    if (scopeValue) {
                        builder.setScope(scopeValue);
                        scope = builder.resolveScope();
                    }
                    const nextSnapshot = { ...builder.state.snapshot(), scope };
                    closeModal({ persist: false });
                    const trigger = builder.root?.querySelector('[data-competitor-filter-search]');
                    trigger?.focus();
                    if (!nextSnapshot.criteria.length) {
                        builder.setStatus('Ajoutez au moins un critère avant de relancer.', 'info');
                        builder.root?.querySelector('[data-competitor-filter-value]')?.focus();
                        return;
                    }
                    await this.searchCompetitors('structured', nextSnapshot);
                };

                modal.querySelectorAll('[data-competitor-modal-remove]').forEach((button) => {
                    button.addEventListener('click', () => {
                        const criterionId = button.dataset.competitorModalRemove;
                        if (!criterionId) return;
                        rerunStructuredSearch((state) => state.remove(criterionId));
                    });
                });
                modal.querySelector('[data-competitor-modal-operator]')?.addEventListener('change', (event) => {
                    rerunStructuredSearch((state) => state.setOperator(event.target.value));
                });
                modal.querySelector('[data-competitor-modal-scope]')?.addEventListener('change', (event) => {
                    rerunStructuredSearch(null, event.target.value);
                });

                const onKeyDown = (event) => {
                    if (event.key === 'Tab') {
                        const focusable = Array.from(content.querySelectorAll(
                            'button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])',
                        )).filter((element) => element.offsetParent !== null);
                        if (!focusable.length) return;
                        const first = focusable[0];
                        const last = focusable[focusable.length - 1];
                        if (event.shiftKey && document.activeElement === first) {
                            event.preventDefault();
                            last.focus();
                        } else if (!event.shiftKey && document.activeElement === last) {
                            event.preventDefault();
                            first.focus();
                        }
                        return;
                    }
                    if (event.key === 'Escape') {
                        if (modal.querySelector('[data-wzo-multi-filter-panel].is-open')) {
                            closeMultiFilterMenus();
                            event.stopPropagation();
                            return;
                        }
                        closeModal();
                    }
                };

                modal.querySelector('#closeCompetitorModal').addEventListener('click', closeModal);
                modal.querySelector('#cancelAddCompetitors')?.addEventListener('click', closeModal);
                modal.addEventListener('click', (event) => {
                    if (event.target === modal) closeModal();
                });
                document.addEventListener('keydown', onKeyDown);

                const renderKeywords = () => {
                    const strip = modal.querySelector('[data-legacy-keyword-strip]');
                    if (!strip) return;
                    const keywords = keywordSuggestions();
                    const visibleKeywords = modalFilters.keywordsExpanded ? keywords : keywords.slice(0, 10);
                    strip.innerHTML = keywordButtonsHtml(
                        visibleKeywords,
                        '<p>Aucun mot-clé fréquent.</p>',
                    );
                };
                const selectedMultiFilterValues = (name) => Array.from(modal.querySelectorAll('[data-wzo-multi-filter]:checked'))
                    .filter((control) => control.dataset.wzoMultiFilter === name)
                    .map((control) => control.value)
                    .filter(Boolean);
                const syncMultiFilterSummary = (name) => {
                    const summary = modal.querySelector(`[data-wzo-multi-filter-summary="${name}"]`);
                    if (!summary) return;
                    const count = normalizeMultiValues(modalFilters[name]).length;
                    summary.textContent = count ? `${count} choisi(s)` : 'Tous';
                };
                const closeMultiFilterMenus = (exceptName = '') => {
                    modal.querySelectorAll('[data-wzo-multi-filter-panel].is-open').forEach((panel) => {
                        const name = panel.dataset.wzoMultiFilterPanel || '';
                        if (exceptName && name === exceptName) return;
                        panel.classList.remove('is-open');
                        const menu = panel.querySelector('[data-wzo-multi-filter-menu]');
                        const trigger = panel.querySelector('[data-wzo-multi-filter-toggle]');
                        if (menu) menu.hidden = true;
                        if (trigger) trigger.setAttribute('aria-expanded', 'false');
                    });
                };
                const toggleMultiFilterMenu = (trigger) => {
                    const name = trigger?.dataset?.wzoMultiFilterToggle || '';
                    const panel = trigger?.closest('[data-wzo-multi-filter-panel]');
                    const menu = panel?.querySelector('[data-wzo-multi-filter-menu]');
                    if (!name || !panel || !menu) return;
                    const shouldOpen = menu.hidden;
                    closeMultiFilterMenus(shouldOpen ? name : '');
                    panel.classList.toggle('is-open', shouldOpen);
                    menu.hidden = !shouldOpen;
                    trigger.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
                };
                const syncFilterControls = () => {
                    modal.querySelectorAll('[data-wzo-filter-input]').forEach((control) => {
                        const key = control.dataset.wzoFilterInput;
                        if (!key) return;
                        control.value = modalFilters[key] || '';
                    });
                    modal.querySelectorAll('[data-wzo-multi-filter]').forEach((control) => {
                        const key = control.dataset.wzoMultiFilter;
                        control.checked = normalizeMultiValues(modalFilters[key]).includes(control.value);
                    });
                    ['effectifFilter', 'nafFilter', 'cityFilter', 'statusFilter', 'originFilter'].forEach(syncMultiFilterSummary);
                    modal.querySelectorAll('[data-wzo-filter-check]').forEach((control) => {
                        const key = control.dataset.wzoFilterCheck;
                        if (!key) return;
                        control.checked = Boolean(modalFilters[key]);
                    });
                    syncAdvancedFilterSummary();
                };
                const resetFiltersToFullBase = () => {
                    modalFilters = {
                        excludedKeywords: '',
                        sortKey: isReviewMode ? 'source_order' : 'distance_km',
                        sortDir: 'asc',
                        effectifFilter: [],
                        nafFilter: [],
                        cityFilter: [],
                        statusFilter: [],
                        originFilter: [],
                        createdAfter: '',
                        createdBefore: '',
                        minDistance: '',
                        maxDistance: '',
                        showExcluded: false,
                        showCompetitors: true,
                        validCoordsOnly: false,
                        keywordsExpanded: false,
                    };
                    if (isReviewMode) modalFilters.searchText = '';
                    selectedIndexes.clear();
                    const removedIds = currentRemovedCompetitorIds();
                    results.forEach((competitor, index) => {
                        if (!removedIds.has(this.competitorIdentity(competitor))) {
                            selectedIndexes.add(index);
                        }
                    });
                    closeMultiFilterMenus();
                    syncFilterControls();
                    renderKeywords();
                    renderModalList();
                    persistModalSnapshot();
                };
                const openLegacyKeywordModal = () => {
                    const keywordOverlay = document.createElement('div');
                    keywordOverlay.className = 'competitor-search-modal competitor-search-modal--keyword';
                    keywordOverlay.dataset.competitorToolType = toolType;
                    keywordOverlay.setAttribute('role', 'presentation');
                    const keywordContent = document.createElement('div');
                    keywordContent.className = 'g2-wzo-keyword-modal geo-manager-white-zone-sirene-keyword-modal';
                    keywordContent.setAttribute('role', 'dialog');
                    keywordContent.setAttribute('aria-modal', 'true');
                    keywordContent.setAttribute('aria-label', 'Exclure mots-clés SIRENE');
                    keywordContent.tabIndex = -1;
                    const selectedKeywords = parseKeywords(modalFilters.excludedKeywords);
                    const visibleRowsCount = currentFilteredIndexes().visible.length;
                    const excludedRowsCount = currentFilteredIndexes().excluded.length;
                    keywordContent.innerHTML = `
                        <p>Ajoutez des mots à exclure des candidats SIRENE. Les concurrents restent conservés dans le résultat reçu.</p>
                        <label>
                            <span>Mots exclus</span>
                            <textarea data-wzo-keyword-value rows="3" placeholder="ex: holding, siège, centrale">${escape(selectedKeywords.join(', '))}</textarea>
                        </label>
                        <div class="g2-wzo-keyword-stats">
                            <strong>${escape(visibleRowsCount)} visibles</strong>
                            <span>${escape(excludedRowsCount)} exclus</span>
                        </div>
                        <div class="g2-wzo-keyword-cloud" aria-label="Mots fréquents SIRENE" data-ui-group="white-zone-sirene-keyword-suggestions">
                            ${keywordButtonsHtml(
                                keywordSuggestions({
                                    ...modalFilters,
                                    excludedKeywords: selectedKeywords.join(', '),
                                }),
                                '<p class="g2-analysis-empty">Aucun mot fréquent exploitable.</p>',
                            )}
                        </div>
                        <footer class="g2-wzo-modal-footer">
                            <button type="button" class="ghost-btn" data-keyword-modal-close>Annuler</button>
                            <button type="button" class="primary-btn" data-keyword-modal-apply>Appliquer</button>
                        </footer>
                    `;
                    keywordOverlay.appendChild(keywordContent);
                    document.body.appendChild(keywordOverlay);
                    const keywordTextarea = keywordOverlay.querySelector('[data-wzo-keyword-value]');
                    const keywordCloud = keywordOverlay.querySelector('.g2-wzo-keyword-cloud');
                    const keywordOverlayFilters = () => ({
                        ...modalFilters,
                        excludedKeywords: parseKeywords(keywordTextarea?.value || '').join(', '),
                    });
                    const renderKeywordOverlay = () => {
                        if (!keywordCloud) return;
                        keywordCloud.innerHTML = keywordButtonsHtml(
                            keywordSuggestions(keywordOverlayFilters()),
                            '<p class="g2-analysis-empty">Aucun mot fréquent exploitable.</p>',
                        );
                    };
                    keywordTextarea?.addEventListener('input', renderKeywordOverlay);
                    keywordContent.focus();
                    const closeKeywordModal = () => {
                        document.removeEventListener('keydown', onKeywordKeyDown);
                        if (keywordOverlay.parentNode) {
                            document.body.removeChild(keywordOverlay);
                        }
                        content.focus();
                    };
                    const applyKeywordModal = () => {
                        const textarea = keywordOverlay.querySelector('[data-wzo-keyword-value]');
                        modalFilters.excludedKeywords = parseKeywords(textarea?.value || '').join(', ');
                        const keywordInput = modal.querySelector('[data-wzo-filter-input="excludedKeywords"]');
                        if (keywordInput) keywordInput.value = modalFilters.excludedKeywords;
                        syncAdvancedFilterSummary();
                        renderKeywords();
                        renderModalList();
                        persistModalSnapshot();
                        closeKeywordModal();
                    };
                    const onKeywordKeyDown = (event) => {
                        if (event.key === 'Escape') closeKeywordModal();
                    };
                    keywordOverlay.addEventListener('click', (event) => {
                        if (event.target === keywordOverlay || event.target.closest('[data-keyword-modal-close]')) {
                            closeKeywordModal();
                            return;
                        }
                        if (event.target.closest('[data-keyword-modal-apply]')) {
                            applyKeywordModal();
                            return;
                        }
                        const keywordToken = event.target.closest('[data-wzo-keyword-token]');
                        if (!keywordToken) return;
                        event.preventDefault();
                        const token = normalize(keywordToken.dataset.wzoKeywordToken);
                        const impact = window.MaplyticsCompetitorSearch.keywordExclusionImpact(
                            keywordCandidateRows(),
                            keywordOverlayFilters(),
                            token,
                        );
                        if (keywordTextarea) {
                            keywordTextarea.value = impact.nextFilters.excludedKeywords;
                        }
                        renderKeywordOverlay();
                    });
                    document.addEventListener('keydown', onKeywordKeyDown);
                };
                const updateFilterFromControl = (control) => {
                    const input = control.closest?.('[data-wzo-filter-input]');
                    const multi = control.closest?.('[data-wzo-multi-filter]');
                    const checkbox = control.closest?.('[data-wzo-filter-check]');
                    if (input) {
                        modalFilters[input.dataset.wzoFilterInput] = input.value || '';
                    }
                    if (multi) {
                        const key = multi.dataset.wzoMultiFilter;
                        modalFilters[key] = selectedMultiFilterValues(key);
                        syncMultiFilterSummary(key);
                    }
                    if (checkbox) {
                        modalFilters[checkbox.dataset.wzoFilterCheck] = Boolean(checkbox.checked);
                    }
                    syncAdvancedFilterSummary();
                    renderKeywords();
                    renderModalList();
                    persistModalSnapshot();
                };
                modal.addEventListener('input', (event) => {
                    if (event.target.closest('[data-wzo-filter-input]')) updateFilterFromControl(event.target);
                });
                modal.addEventListener('change', (event) => {
                    if (event.target.closest('[data-wzo-filter-input], [data-wzo-multi-filter], [data-wzo-filter-check]')) updateFilterFromControl(event.target);
                });
                modal.addEventListener('click', (event) => {
                    const multiFilterToggle = event.target.closest('[data-wzo-multi-filter-toggle]');
                    if (multiFilterToggle) {
                        event.preventDefault();
                        toggleMultiFilterMenu(multiFilterToggle);
                        return;
                    }
                    if (!event.target.closest('[data-wzo-multi-filter-panel]')) {
                        closeMultiFilterMenus();
                    }
                    const keywordToken = event.target.closest('[data-wzo-keyword-token]');
                    if (keywordToken) {
                        event.preventDefault();
                        const token = normalize(keywordToken.dataset.wzoKeywordToken);
                        const impact = window.MaplyticsCompetitorSearch.keywordExclusionImpact(
                            keywordCandidateRows(),
                            modalFilters,
                            token,
                        );
                        modalFilters = impact.nextFilters;
                        const keywordInput = modal.querySelector('[data-wzo-filter-input="excludedKeywords"]');
                        if (keywordInput) keywordInput.value = modalFilters.excludedKeywords;
                        syncAdvancedFilterSummary();
                        renderKeywords();
                        renderModalList();
                        persistModalSnapshot();
                        return;
                    }
                    const keywordAction = event.target.closest('[data-wzo-modal-action="keywords"]');
                    if (keywordAction) {
                        event.preventDefault();
                        openLegacyKeywordModal();
                    }
                });

                modal.querySelector('#selectAllCompetitors')?.addEventListener('click', () => {
                    currentFilteredIndexes().included.forEach(({ index }) => selectedIndexes.add(index));
                    renderModalList();
                    updateSelectedCount();
                    persistModalSnapshot();
                });
                modal.querySelector('#deselectAllCompetitors')?.addEventListener('click', () => {
                    currentFilteredIndexes().included.forEach(({ index }) => selectedIndexes.delete(index));
                    renderModalList();
                    updateSelectedCount();
                    persistModalSnapshot();
                });
                modal.querySelector('#resetCompetitorFilters').addEventListener('click', () => {
                    resetFiltersToFullBase();
                });
                modal.querySelector('#calculateCompetitorRoutes')?.addEventListener('click', calculateRoadDistances);

                modal.querySelector('#confirmAddCompetitors').addEventListener('click', () => {
                    if (isReviewMode) {
                        closeModal();
                        return;
                    }
                    const includedIndexes = new Set(
                        currentFilteredIndexes().included.map(({ index }) => index),
                    );
                    const selectedCompetitors = Array.from(selectedIndexes)
                        .sort((a, b) => a - b)
                        .filter((index) => includedIndexes.has(index))
                        .map((idx) => results[idx])
                        .filter(Boolean);
                    if (!selectedCompetitors.length) {
                        alert('Sélectionnez au moins un concurrent à ajouter.');
                        return;
                    }

                    const existingKeys = new Set(this.competitors.map((comp) => this.competitorIdentity(comp)));
                    const additions = [];
                    selectedCompetitors.forEach(comp => {
                        const key = this.competitorIdentity(comp);
                        if (!existingKeys.has(key)) {
                            existingKeys.add(key);
                            additions.push({
                                ...comp,
                                id: comp.id || `comp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`
                            });
                        }
                    });
                    this.dispatchCompetitorWorkspace({
                        type: 'transaction',
                        actions: [
                            { type: 'competitors/add', rows: additions },
                            {
                                type: 'presentation/set',
                                patch: { visibleOnMap: Boolean(modalFilters.showCompetitors) },
                            },
                        ],
                    });
                    const added = additions.length;
                    this.renderCompetitorsList();
                    this.syncCompetitorMapButton();
                    this.updateMarkersOnMap();
                    persistModalSnapshot();
                    this.saveCompetitors();
                    const hasCoordinate = (value) => (
                        value !== null
                        && value !== undefined
                        && value !== ''
                        && Number.isFinite(Number(value))
                    );
                    const addedWithCoords = selectedCompetitors.filter((comp) => (
                        hasCoordinate(comp.lat ?? comp.latitude)
                        && hasCoordinate(comp.lon ?? comp.lng ?? comp.longitude)
                    ));
                    if (addedWithCoords.length) {
                        this.fitCompetitorsOnMap(addedWithCoords);
                    } else {
                        alert('Concurrents ajoutés, mais aucun ne contient de coordonnées GPS exploitables pour la carte.');
                    }
                    if (added === 0) {
                        showAppMessage('info', 'Concurrents déjà présents', 'Les concurrents sélectionnés étaient déjà dans votre liste.');
                    }
                    closeModal({ persist: false });
                });

                syncFilterControls();
                renderKeywords();
                renderModalList();
                if (!restoredSearchSnapshot) {
                    persistModalSnapshot({ immediate: false, remote: true });
                }
                setTimeout(() => {
                    const routeButton = modal.querySelector('#calculateCompetitorRoutes');
                    if (apiResult.auto_calculate_routes && routeButton && !routeButton.disabled) {
                        routeButton.focus();
                        routeButton.click();
                        return;
                    }
                    (modal.querySelector('[data-competitor-basic] input, [data-competitor-basic] select') || content).focus();
                }, 0);
            },

            openCompetitorsReviewModal({ calculateRoutes = false } = {}) {
                if (!this.competitors.length) {
                    alert('Aucun concurrent ajouté pour le moment.');
                    return;
                }
                const selectedIds = this.competitorWorkspaceController.snapshot().selection.ids;
                this.showSearchResults(this.competitors, 'review', 'concurrents ajoutés', {
                    modal_mode: 'review',
                    view_filters: {
                        ...window.MaplyticsCompetitorSearch.normalizeViewFilters(
                            this.competitorViewFilters,
                        ),
                        searchText: this.filterText,
                        showCompetitors: this.visibleOnMap,
                    },
                    route_origins: this.lastCompetitorRouteOrigins,
                    route_selected_ids: [...selectedIds],
                    search_info: {
                        radius_km: this.lastSearchInfo?.radius_km || '',
                        pages_fetched: this.lastSearchInfo?.pages_fetched || '',
                        result_limit: this.competitors.length,
                        area_mode: this.lastSearchInfo?.area_mode || 'liste',
                    },
                    auto_calculate_routes: Boolean(calculateRoutes),
                });
            },

            // Obtenir les concurrents filtres
            getFilteredCompetitors() {
                return this.getCompetitorView().competitors;
            },

            refreshCompetitorViewSurfaces() {
                this.renderCompetitorsList();
                this.syncCompetitorMapButton();
                this.updateMarkersOnMap();
                this.updatePointsLegend();
                const fullscreenContent = document.querySelector('#fullscreen-sidebar #fs-sidebar-content');
                if (fullscreenContent) this.renderFullscreenSidebar(fullscreenContent);
                if (toolType === 'isochrone') {
                    window.maplyticsCompetitorVisualExportDialog?.invalidate?.(
                        'competitor-workspace-changed',
                    );
                }
                window.dispatchEvent(new CustomEvent(
                    'maplytics:analysis-workspace-changed',
                    { detail: { toolType, source: 'competitors' } },
                ));
            },

            applyCompetitorViewFilters(rawFilters) {
                const previousState = window.MaplyticsCompetitorSearch.fingerprint({
                    filters: window.MaplyticsCompetitorSearch.normalizeViewFilters({
                        ...(this.competitorViewFilters || {}),
                        searchText: '',
                    }),
                    searchText: this.filterText,
                });
                const normalized = window.MaplyticsCompetitorSearch.normalizeViewFilters(
                    rawFilters && typeof rawFilters === 'object' ? rawFilters : {},
                );
                this.dispatchCompetitorWorkspace({
                    type: 'filters/set',
                    filters: normalized,
                });
                const next = window.MaplyticsCompetitorSearch.fingerprint({
                    filters: this.competitorViewFilters,
                    searchText: this.filterText,
                });
                const nextView = this.getCompetitorView();
                if (previousState !== next) this.refreshCompetitorViewSurfaces();
                return nextView;
            },

            getCompetitorView() {
                this.ensureCompetitorDisplayReferences();
                const snapshot = this.competitorWorkspaceController.snapshot();
                return {
                    schema_version: 'home_competitor_view_v2',
                    filter_text: snapshot.filters.searchText,
                    filters: { ...snapshot.filters },
                    source_ids: snapshot.rows.map((row) => this.competitorIdentity(row)),
                    included_ids: [...snapshot.view.ids],
                    excluded: snapshot.view.excluded.map((entry) => ({ ...entry })),
                    fingerprint: snapshot.view.fingerprint,
                    competitors: snapshot.view.rows.map((row) => ({ ...row })),
                };
            },

            getCompetitorExportView() {
                const view = this.getCompetitorView();
                const snapshot = this.competitorWorkspaceController.snapshot();
                return {
                    ...view,
                    included_ids: [...snapshot.export.ids],
                    fingerprint: snapshot.export.fingerprint,
                    competitors: snapshot.export.rows.map((row) => ({ ...row })),
                };
            },

            getCompetitorVisualView() {
                this.ensureCompetitorDisplayReferences();
                const snapshot = this.competitorWorkspaceController.snapshot();
                return {
                    schema_version: 'home_competitor_visual_view_v1',
                    filter_text: snapshot.filters.searchText,
                    filters: { ...snapshot.filters },
                    source_ids: snapshot.rows.map((row) => this.competitorIdentity(row)),
                    included_ids: [...snapshot.map.ids],
                    excluded: snapshot.view.excluded.map((entry) => ({ ...entry })),
                    fingerprint: snapshot.view.fingerprint,
                    presentation_fingerprint: snapshot.map.fingerprint,
                    allow_noncontiguous_ranks: true,
                    competitors: snapshot.map.rows.map((row) => ({ ...row })),
                };
            },

            competitorViewPayload({ snapshotDate = '' } = {}) {
                const view = this.getCompetitorView();
                const capturedAt = String(snapshotDate || new Date().toISOString());
                return {
                    schema_version: window.MaplyticsCompetitorThreatScore.VIEW_SCHEMA,
                    snapshot_date: capturedAt,
                    filter_text: view.filter_text,
                    filters: view.filters,
                    source_ids: view.source_ids,
                    included_ids: view.included_ids,
                    excluded: view.excluded,
                    fingerprint: view.fingerprint,
                    visible_rows: view.competitors.map((competitor) => ({
                        id: this.competitorIdentity(competitor),
                        display_reference: Number(competitor.display_reference),
                        visible_rank: Number(competitor.visible_rank),
                    })),
                    threat_score_snapshot: window.MaplyticsCompetitorThreatScore.normalizeResult(
                        this.competitorThreatScore,
                        view,
                    ),
                };
            },

            clearCompetitorThreatScore() {
                this._competitorThreatScoreRequest += 1;
                this.dispatchCompetitorWorkspace({ type: 'score/clear' });
            },

            async revalidateSavedCompetitorThreatScore(savedScore) {
                const requestId = ++this._competitorThreatScoreRequest;
                const view = this.getCompetitorView();
                try {
                    const result = await window.MaplyticsCompetitorThreatScore.recalculateSavedScore({
                        view,
                        identity: (competitor) => this.competitorIdentity(competitor),
                        savedScore,
                    });
                    if (requestId !== this._competitorThreatScoreRequest) return false;
                    const currentView = this.getCompetitorView();
                    const normalized = window.MaplyticsCompetitorThreatScore.normalizeResult(
                        result,
                        currentView,
                    );
                    if (!normalized) throw new Error('Le résultat recalculé ne correspond plus à la vue courante.');
                    this.dispatchCompetitorWorkspace({ type: 'score/set', score: normalized });
                    this.renderCompetitorsList();
                    this.updateMarkersOnMap();
                    return true;
                } catch (error) {
                    if (requestId !== this._competitorThreatScoreRequest) return false;
                    this.dispatchCompetitorWorkspace({ type: 'score/clear' });
                    this.competitorFilterBuilder?.setStatus?.(
                        `${error.message || 'Le score sauvegardé ne peut pas être revalidé.'} Les métriques brutes restent disponibles.`,
                        'error',
                    );
                    this.renderCompetitorsList();
                    this.updateMarkersOnMap();
                    return false;
                }
            },

            restoreCompetitorView(rawView) {
                const resetView = () => {
                    this.dispatchCompetitorWorkspace({
                        type: 'filters/set',
                        filters: { searchText: '' },
                    });
                    this._competitorViewSnapshotDate = '';
                };
                const rejectView = (message) => {
                    resetView();
                    this.competitorFilterBuilder?.setStatus?.(message, 'error');
                    return false;
                };
                resetView();
                if (!rawView) return true;
                const supportedSchemas = new Set([
                    'home_competitor_view_v2',
                    window.MaplyticsCompetitorThreatScore.VIEW_SCHEMA,
                ]);
                if (!supportedSchemas.has(rawView.schema_version)) {
                    this.competitorFilterBuilder?.setStatus?.(
                        'L’ancienne vue avec score implicite a été réinitialisée. Les concurrents sont conservés.',
                        'info',
                    );
                    return false;
                }
                const filtersDeclared = Object.prototype.hasOwnProperty.call(rawView, 'filters');
                if (
                    filtersDeclared
                    && (
                        !rawView.filters
                        || typeof rawView.filters !== 'object'
                        || Array.isArray(rawView.filters)
                    )
                ) {
                    return rejectView(
                        'La vue concurrence sauvegardée contient des filtres invalides. Elle a été réinitialisée.',
                    );
                }
                const hasFilters = filtersDeclared;
                const normalizedFilters = window.MaplyticsCompetitorSearch.normalizeViewFilters(
                    hasFilters
                        ? rawView.filters
                        : { searchText: rawView.filter_text },
                );
                const legacyFilterText = String(rawView.filter_text || '').slice(0, 120);
                if (
                    hasFilters
                    && legacyFilterText
                    && normalizedFilters.searchText !== legacyFilterText
                ) {
                    return rejectView(
                        'La vue concurrence sauvegardée contient des filtres contradictoires. Elle a été réinitialisée.',
                    );
                }
                this.dispatchCompetitorWorkspace({
                    type: 'filters/set',
                    filters: {
                        ...normalizedFilters,
                        searchText: normalizedFilters.searchText || legacyFilterText,
                    },
                });
                const current = this.getCompetitorView();
                const exactOptionalArray = (key, expected) => (
                    !Object.prototype.hasOwnProperty.call(rawView, key)
                    || (
                        Array.isArray(rawView[key])
                        && rawView[key].length === expected.length
                        && rawView[key].every(
                            (value, index) => String(value) === String(expected[index]),
                        )
                    )
                );
                const currentVisibleRows = current.competitors.map((competitor) => ({
                    id: this.competitorIdentity(competitor),
                    display_reference: Number(competitor.display_reference),
                    visible_rank: Number(competitor.visible_rank),
                }));
                const visibleRowsMatch = (
                    !Object.prototype.hasOwnProperty.call(rawView, 'visible_rows')
                    || (
                        Array.isArray(rawView.visible_rows)
                        && JSON.stringify(rawView.visible_rows) === JSON.stringify(currentVisibleRows)
                    )
                );
                if (
                    !rawView.fingerprint
                    || rawView.fingerprint !== current.fingerprint
                    || !exactOptionalArray('source_ids', current.source_ids)
                    || !exactOptionalArray('included_ids', current.included_ids)
                    || !visibleRowsMatch
                ) {
                    return rejectView(
                        'La vue concurrence sauvegardée est obsolète. Les filtres de liste ont été refusés et réinitialisés.',
                    );
                }
                const snapshotDate = String(rawView.snapshot_date || '').trim();
                this._competitorViewSnapshotDate = snapshotDate && !Number.isNaN(Date.parse(snapshotDate))
                    ? snapshotDate
                    : '';
                if (rawView.schema_version === window.MaplyticsCompetitorThreatScore.VIEW_SCHEMA) {
                    const savedScore = window.MaplyticsCompetitorThreatScore.normalizeResult(
                        rawView.threat_score_snapshot,
                        current,
                    );
                    if (savedScore) {
                        this.revalidateSavedCompetitorThreatScore(savedScore);
                    } else if (rawView.threat_score_snapshot) {
                        this.competitorFilterBuilder?.setStatus?.(
                            'Le score sauvegardé ne correspond plus au snapshot courant. Les métriques brutes restent disponibles.',
                            'error',
                        );
                    }
                }
                return true;
            },

            competitorStatePayload({ snapshotDate = '' } = {}) {
                this.ensureCompetitorDisplayReferences();
                const capturedAt = String(snapshotDate || new Date().toISOString());
                return JSON.parse(JSON.stringify({
                    schema_version: 'home_competitor_state_v2',
                    territoryContext: this._competitorTerritoryContext,
                    competitors: this.competitors,
                    competitorView: this.competitorViewPayload({ snapshotDate: capturedAt }),
                    competitorSearchSnapshot: this.competitorSearchSnapshot,
                    customPoints: this.customPoints,
                    pointFolders: this.pointFolders,
                    competitorsNumbered: Boolean(this.competitorsNumbered),
                    nextDisplayReference: this.nextCompetitorDisplayReference,
                    competitorMarkerColor: window.MaplyticsCompetitorSearch
                        .normalizeMarkerColor(this.competitorMarkerColor),
                    competitorMarkerScale: window.MaplyticsCompetitorVisualEncoding
                        .normalizePresentationScale(this.competitorMarkerScale),
                    hiddenCompetitorIds: [...this.hiddenCompetitorIds],
                    visibleOnMap: Boolean(this.visibleOnMap),
                    pointsLegendVisible: Boolean(this.pointsLegendVisible),
                    removedItems: this.removedItems,
                    attractiveness: this.attractivenessStatePayload(),
                    network_points: this.networkPointsStatePayload(),
                }));
            },

            networkPointsStatePayload() {
                const state = window.MaplyticsNetworkPointsState.fromLegacy({
                    customPoints: this.customPoints,
                    pointFolders: this.pointFolders,
                    batches: this.networkPointBatches,
                    selectedOrigin: this.networkSelectedOrigin,
                    visible: this.customPointsVisible,
                    revision: this.networkRevision,
                    nextDisplayReference: this.networkNextDisplayReference,
                });
                this.networkFingerprint = state.fingerprint;
                this.networkNextDisplayReference = state.next_display_reference;
                this.customPoints = window.MaplyticsNetworkPointsState.toLegacy(state).customPoints;
                return state;
            },

            restoreNetworkPointsStatePayload(rawState, reason = 'listing-restored') {
                const restored = window.MaplyticsNetworkPointsState.toLegacy(rawState || {});
                this.customPoints = restored.customPoints;
                this.pointFolders = restored.pointFolders;
                this.networkPointBatches = restored.batches;
                this.networkSelectedOrigin = restored.selectedOrigin;
                this.networkRevision = restored.revision;
                this.networkFingerprint = restored.fingerprint;
                this.networkNextDisplayReference = restored.nextDisplayReference;
                this.customPointsVisible = restored.visible;
                this.selectedPointIds.clear();
                this.networkRoutingSnapshot = null;
                this.renderCustomPointsList();
                this.updateCustomPointsOnMap();
                if (this.pointsLegendVisible) this.updatePointsLegend();
                const state = this.networkPointsStatePayload();
                window.dispatchEvent(new CustomEvent(
                    'maplytics:network-points-changed',
                    {detail: {reason, revision: state.revision, fingerprint: state.fingerprint}},
                ));
                void this.saveCompetitors({quiet: true});
                return state;
            },

            touchNetworkPoints(reason = 'updated') {
                // Network points are part of the same persisted workspace as
                // competitors. Mark every accepted network mutation so a late
                // automatic restore cannot replace freshly edited points.
                this._competitorStateGeneration += 1;
                this.networkRevision = Math.max(0, Number(this.networkRevision) || 0) + 1;
                const state = this.networkPointsStatePayload();
                window.dispatchEvent(new CustomEvent(
                    'maplytics:network-points-changed',
                    { detail: { reason, revision: state.revision, fingerprint: state.fingerprint } },
                ));
                window.dispatchEvent(new CustomEvent(
                    'maplytics:analysis-workspace-changed',
                    { detail: { toolType, source: 'network-points' } },
                ));
                return state;
            },

            importNetworkPointsBatch(rows, options = {}) {
                const selectedRows = (Array.isArray(rows) ? rows : []).filter((row) => (
                    row?.selected
                    && Number.isFinite(Number(row.lat))
                    && Number.isFinite(Number(row.lng))
                ));
                if (!selectedRows.length || selectedRows.length > 1000) return null;

                this.networkPointsStatePayload();
                const batchId = `network-batch-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
                const knownFolderIds = new Set(this.pointFolders.map((folder) => folder.id));
                const folderByName = new Map(
                    this.pointFolders.map((folder) => [String(folder.name || '').trim().toLowerCase(), folder.id]),
                );
                const defaultFolderName = String(options.folderName || '').trim();
                const ensureFolder = (rawName) => {
                    const name = String(rawName || defaultFolderName || '').trim().slice(0, 120);
                    if (!name) return 'default';
                    const existing = folderByName.get(name.toLowerCase());
                    if (existing) return existing;
                    const id = `folder_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
                    this.pointFolders.push({
                        id,
                        name,
                        parentId: null,
                        color: options.color || '#2563eb',
                    });
                    knownFolderIds.add(id);
                    folderByName.set(name.toLowerCase(), id);
                    return id;
                };
                const fixedFolder = knownFolderIds.has(String(options.folderId || ''))
                    ? String(options.folderId)
                    : '';
                const existingIdentities = new Set(this.customPoints.map((point) => (
                    `${String(point.name || '').trim().toLowerCase()}|${Number(point.lat).toFixed(6)}|${Number(point.lon).toFixed(6)}`
                )));
                const additions = [];
                selectedRows.forEach((row, index) => {
                    const lat = Number(row.lat);
                    const lon = Number(row.lng);
                    const name = String(row.name || `Point ${index + 1}`).trim().slice(0, 200);
                    const identity = `${name.toLowerCase()}|${lat.toFixed(6)}|${lon.toFixed(6)}`;
                    if (existingIdentities.has(identity)) return;
                    existingIdentities.add(identity);
                    const rowColor = /^#[0-9a-f]{6}$/i.test(String(row.network_color || ''))
                        ? String(row.network_color).toLowerCase()
                        : options.color || '#2563eb';
                    const rowIcon = Object.prototype.hasOwnProperty.call(this.POINT_ICONS, row.network_icon)
                        ? row.network_icon
                        : options.icon || 'pin';
                    const folder = row.network_folder
                        ? ensureFolder(row.network_folder)
                        : fixedFolder || ensureFolder('');
                    additions.push({
                        id: `network-point-${Date.now()}-${index}-${Math.random().toString(36).slice(2, 7)}`,
                        name,
                        lat,
                        lon,
                        source: String(row.source || 'import').slice(0, 40),
                        folder,
                        batch_id: batchId,
                        color: rowColor,
                        icon: rowIcon,
                        image_url: window.MaplyticsNetworkPointsState.isLocalImage(options.imageUrl)
                            ? options.imageUrl
                            : '',
                        visible: true,
                        notes: String(row.description || row.address || '').slice(0, 1000),
                        created_at: new Date().toISOString(),
                        display_reference: this.networkNextDisplayReference++,
                        source_row_number: Number.isSafeInteger(Number(row.row_number))
                            && Number(row.row_number) > 0
                            ? Number(row.row_number)
                            : null,
                    });
                });
                if (!additions.length) return null;
                this.customPoints.push(...additions);
                this.networkPointBatches.push({
                    id: batchId,
                    name: String(options.batchName || `Lot ${this.networkPointBatches.length + 1}`).trim().slice(0, 160),
                    source: String(options.source || 'import').slice(0, 20),
                    imported_at: new Date().toISOString(),
                    point_count: additions.length,
                });
                this.touchNetworkPoints('batch-imported');
                this.renderCustomPointsList();
                this.updateCustomPointsOnMap();
                if (this.pointsLegendVisible) this.updatePointsLegend();
                void this.saveCompetitors({ quiet: true });
                return { batchId, added: additions.length };
            },

            attractivenessStatePayload() {
                const source = this.attractivenessSource || this.getSearchParams?.() || null;
                return window.MaplyticsSavedAnalysisState.buildAttractivenessState({
                    categories: this.attractivenessSelectedCategories,
                    results: this.attractivenessResults,
                    searchInfo: this.attractivenessSearchInfo,
                    visualEncoding: {
                        ...this.attractivenessVisualEncoding,
                        presentationScale: this.competitorMarkerScale,
                    },
                    visible: this.attractivenessVisible,
                    source,
                    allowedCategories: Object.keys(this.ATTRACTIVENESS_CATEGORIES),
                });
            },

            restoreAttractivenessStatePayload(rawState) {
                const restored = window.MaplyticsSavedAnalysisState.restoreAttractivenessState(
                    rawState,
                    {
                        allowedCategories: Object.keys(this.ATTRACTIVENESS_CATEGORIES),
                        currentSource: this.getSearchParams?.() || null,
                    },
                );
                this.attractivenessVisualEncoding = window.MaplyticsCompetitorVisualEncoding
                    .normalize({
                        ...(restored.state?.visual_encoding || {}),
                        presentationScale: this.competitorMarkerScale,
                    });
                this.attractivenessSelectedCategories = restored.state?.categories || [];
                this.attractivenessSource = restored.state?.source || null;
                if (!restored.valid) {
                    this.attractivenessResults = {};
                    this.attractivenessSearchInfo = {};
                    this.attractivenessVisible = false;
                    if (rawState && restored.reason !== 'missing_or_legacy') {
                        this.competitorFilterBuilder?.setStatus?.(
                            'L’attractivité sauvegardée ne correspond plus au périmètre courant. Ses résultats ont été invalidés.',
                            'error',
                        );
                    }
                    this.syncAttractivenessVisibilityControl();
                    return false;
                }
                this.attractivenessResults = restored.state.results;
                this.attractivenessSearchInfo = restored.state.search_info;
                this.attractivenessVisible = Boolean(restored.state.visible);
                if (this.attractivenessVisible) this.showAttractivenessResults();
                this.syncAttractivenessVisibilityControl();
                return true;
            },

            unwrapCompetitorState(rawData) {
                if (!Array.isArray(rawData)) return rawData;
                const first = rawData.length === 1 ? rawData[0] : null;
                const isStateWrapper = first
                    && typeof first === 'object'
                    && !Array.isArray(first)
                    && (
                        first.schema_version === 'home_competitor_state_v1'
                        || first.schema_version === 'home_competitor_state_v2'
                        || Object.prototype.hasOwnProperty.call(first, 'competitorView')
                        || Object.prototype.hasOwnProperty.call(first, 'competitorSearchSnapshot')
                        || Array.isArray(first.competitors)
                    );
                return isStateWrapper ? first : rawData;
            },

            restoreCompetitorStatePayload(
                rawState,
                { restoreBuilder = false, emptyIsSaved = false, allowTerritoryRebind = true } = {},
            ) {
                const territoryApi = window.MaplyticsCompetitorTerritory;
                const currentTerritory = this.currentCompetitorTerritory?.() || null;
                const detachedTerritory = !allowTerritoryRebind && !territoryApi?.canRestoreAutomatically?.(
                    rawState?.territoryContext, currentTerritory,
                );
                if (detachedTerritory) rawState = territoryApi?.withoutTerritorialResults(rawState) || {};
                this._competitorTerritoryContext = detachedTerritory ? currentTerritory
                    : territoryApi?.normalize(rawState?.territoryContext) || currentTerritory;
                this._competitorStateGeneration += 1;
                this._competitorSaveSequence += 1;
                this._competitorRestoreSequence += 1;
                this._competitorRestorePending = 0;
                this._competitorRestoreTarget = '';
                this._competitorRestoreTargetSequence = 0;
                this._competitorActiveProjectId = '';
                const legacyRows = Array.isArray(rawState) ? rawState : null;
                const state = !legacyRows && rawState && typeof rawState === 'object'
                    ? rawState
                    : {};
                const hasPersistedState = emptyIsSaved || (legacyRows
                    ? legacyRows.length > 0
                    : Boolean(
                        state.schema_version === 'home_competitor_state_v1'
                        || state.schema_version === 'home_competitor_state_v2'
                        || Object.prototype.hasOwnProperty.call(state, 'competitors')
                        || Object.prototype.hasOwnProperty.call(state, 'competitorView')
                        || Object.prototype.hasOwnProperty.call(state, 'competitorSearchSnapshot')
                        || Object.prototype.hasOwnProperty.call(state, 'customPoints')
                        || Object.prototype.hasOwnProperty.call(state, 'network_points')
                        || Object.prototype.hasOwnProperty.call(state, 'removedItems')
                    ));
                this.clearCompetitorThreatScore();
                this.clearAttractiveness({ resetSelection: true });
                this.competitors = legacyRows || (
                    Array.isArray(state.competitors) ? state.competitors : []
                );
                const restoredNetwork = state.network_points
                    && typeof state.network_points === 'object'
                    ? window.MaplyticsNetworkPointsState.toLegacy(state.network_points)
                    : window.MaplyticsNetworkPointsState.toLegacy(
                        window.MaplyticsNetworkPointsState.fromLegacy({
                            customPoints: state.customPoints,
                            pointFolders: state.pointFolders,
                            visible: state.customPointsVisible !== false,
                        }),
                    );
                const explicitEmptyLegacyNetwork = (
                    Array.isArray(state.customPoints)
                    && state.customPoints.length === 0
                    && Array.isArray(state.pointFolders)
                    && state.pointFolders.length === 0
                );
                this.customPoints = restoredNetwork.customPoints;
                this.removedItems = Array.isArray(state.removedItems) ? state.removedItems : [];
                // An exact empty snapshot is meaningful during transactional rollback.
                // Do not introduce the normal UI default folder into a screen that had none.
                this.pointFolders = explicitEmptyLegacyNetwork ? [] : restoredNetwork.pointFolders;
                this.networkPointBatches = restoredNetwork.batches;
                this.networkSelectedOrigin = restoredNetwork.selectedOrigin;
                this.networkRevision = restoredNetwork.revision;
                this.networkFingerprint = restoredNetwork.fingerprint;
                this.networkNextDisplayReference = restoredNetwork.nextDisplayReference;
                this.customPointsVisible = restoredNetwork.visible;
                this.competitorsNumbered = Boolean(state.competitorsNumbered);
                const restoredNextReference = Number(state.nextDisplayReference);
                this.nextCompetitorDisplayReference = (
                    Number.isSafeInteger(restoredNextReference)
                    && restoredNextReference > 0
                ) ? restoredNextReference : 1;
                this.competitorMarkerColor = window.MaplyticsCompetitorSearch
                    .normalizeMarkerColor(state.competitorMarkerColor);
                this.competitorMarkerScale = window.MaplyticsCompetitorVisualEncoding
                    .normalizePresentationScale(state.competitorMarkerScale);
                this.filterText = '';
                this.competitorViewFilters = window.MaplyticsCompetitorSearch.normalizeViewFilters();
                this.visibleOnMap = false;
                this.pointsLegendVisible = false;
                this.hiddenCompetitorIds = Array.isArray(state.hiddenCompetitorIds)
                    ? state.hiddenCompetitorIds
                    : [];
                this.hydrateCompetitorWorkspace({ search: {} });
                const removedCustomPointIds = new Set(
                    this.competitorWorkspaceController.snapshot().removed.custom_point_ids,
                );
                this.customPoints = this.customPoints.filter(
                    (point) => !removedCustomPointIds.has(String(point?.id || '')),
                );
                const restoredSearchSnapshot = this.setCompetitorSearchSnapshot(
                    state.competitorSearchSnapshot,
                    { restoreBuilder },
                );
                const searchSnapshotRestored = (
                    state.competitorSearchSnapshot === null
                    || state.competitorSearchSnapshot === undefined
                    || Boolean(restoredSearchSnapshot)
                );
                const viewRestored = this.restoreCompetitorView(state.competitorView);
                const stateRestored = viewRestored && searchSnapshotRestored;
                this.dispatchCompetitorWorkspace({
                    type: 'presentation/set',
                    patch: {
                        visibleOnMap: stateRestored && Boolean(state.visibleOnMap),
                        legendVisible: stateRestored && Boolean(state.pointsLegendVisible),
                    },
                });
                this.renderCompetitorsList();
                this.updateMarkersOnMap();
                this.syncCompetitorMapButton();
                this.syncCompetitorsNumberingButton();
                this.syncCompetitorMarkerColorControl();
                this.syncPointsLegendButton();
                if (this.pointsLegendVisible) {
                    this.updatePointsLegend();
                } else {
                    this.removePointsLegend();
                }
                this.renderCustomPointsList();
                this.updateCustomPointsOnMap();
                const restoredNetworkState = this.networkPointsStatePayload();
                window.dispatchEvent(new CustomEvent(
                    'maplytics:network-points-changed',
                    {
                        detail: {
                            reason: 'restored',
                            revision: restoredNetworkState.revision,
                            fingerprint: restoredNetworkState.fingerprint,
                        },
                    },
                ));
                this.restoreAttractivenessStatePayload(state.attractiveness);
                if (detachedTerritory) {
                    const message = 'Le listing sauvegardé appartient à un autre territoire ou à un ancien format sans rattachement. Ouvrez son analyse ou chargez-le explicitement pour le réutiliser.';
                    this.competitorFilterBuilder?.setStatus?.(message, 'info');
                    this.setCompetitorSaveStatus('conflict', 'Listing non rattaché · chargement explicite requis');
                    return Boolean(restoredNetworkState.points?.length);
                }
                if (!hasPersistedState) {
                    this.setCompetitorSaveStatus('idle', 'Non sauvegardé');
                    return false;
                }
                if (!stateRestored) {
                    this.setCompetitorSaveStatus(
                        'error',
                        'Échec · état sauvegardé refusé',
                    );
                    return false;
                }
                const metadata = this.competitorSnapshotMetadata();
                this.setCompetitorSaveStatus(
                    'restored',
                    metadata.snapshotDate
                        ? `Restauré · ${metadata.dateLabel}`
                        : 'Restauré · date non disponible',
                    { savedAt: metadata.snapshotDate },
                );
                return true;
            },

            openThreatScoreConfiguration(trigger = null) {
                const workspaceRequestGeneration = this._workspaceRequestGeneration;
                const view = this.getCompetitorView();
                this._threatScoreConfiguration?.close?.({ force: true });
                let configuration = null;
                configuration = window.MaplyticsCompetitorThreatScore.openConfiguration({
                    trigger,
                    view,
                    toolType,
                    identity: (competitor) => this.competitorIdentity(competitor),
                    currentScore: this.competitorThreatScore,
                    escapeHtml: (value) => this.escapeCompetitorText(value),
                    onClosed: () => {
                        if (this._threatScoreConfiguration === configuration) {
                            this._threatScoreConfiguration = null;
                        }
                    },
                    onApplied: async (result) => {
                        if (workspaceRequestGeneration !== this._workspaceRequestGeneration) {
                            return false;
                        }
                        const currentView = this.getCompetitorView();
                        const normalized = window.MaplyticsCompetitorThreatScore.normalizeResult(
                            result,
                            currentView,
                        );
                        if (!normalized) {
                            throw new Error('La réponse du score ne correspond pas au snapshot courant.');
                        }
                        const previousScore = this.competitorThreatScore;
                        this._competitorThreatScoreRequest += 1;
                        this.dispatchCompetitorWorkspace({ type: 'score/set', score: normalized });
                        this.renderCompetitorsList();
                        if (workspaceRequestGeneration !== this._workspaceRequestGeneration) {
                            return false;
                        }
                        const saved = await this.saveCompetitors({ quiet: true });
                        if (workspaceRequestGeneration !== this._workspaceRequestGeneration) {
                            return false;
                        }
                        if (!saved) {
                            this.dispatchCompetitorWorkspace({ type: 'score/set', score: previousScore });
                            this.renderCompetitorsList();
                            throw new Error('Le score n’a pas pu être sauvegardé. La configuration précédente est conservée.');
                        }
                        return true;
                    },
                    onDisabled: async () => {
                        if (workspaceRequestGeneration !== this._workspaceRequestGeneration) {
                            return false;
                        }
                        const previousScore = this.competitorThreatScore;
                        this.clearCompetitorThreatScore();
                        this.renderCompetitorsList();
                        if (workspaceRequestGeneration !== this._workspaceRequestGeneration) {
                            return false;
                        }
                        const saved = await this.saveCompetitors({ quiet: true });
                        if (workspaceRequestGeneration !== this._workspaceRequestGeneration) {
                            return false;
                        }
                        if (!saved) {
                            this.dispatchCompetitorWorkspace({ type: 'score/set', score: previousScore });
                            this.renderCompetitorsList();
                            throw new Error('La désactivation n’a pas pu être sauvegardée. Le score reste actif.');
                        }
                        return true;
                    },
                });
                this._threatScoreConfiguration = configuration;
                return configuration;
            },

            // Afficher la liste des concurrents (enrichi + premium gate)
            renderCompetitorsList() {
                const listEl = document.querySelector(`${scopeSelector} #competitorsList, ${scopeSelector} #importCompetitorsList`);
                const countEl = document.querySelector(`${scopeSelector} #competitorsCount, ${scopeSelector} #importCompetitorsCount`);
                const panelSummary = document.querySelector(`${scopeSelector} [data-competitor-list-summary]`);

                if (!listEl) return;

                if (this.competitors.length === 0) {
                    if (countEl) countEl.textContent = '0';
                    if (panelSummary) panelSummary.textContent = 'Aucun concurrent ajouté · ouvrir pour consulter';
                    listEl.innerHTML = '<p style="margin: 0; padding: 1rem; text-align: center; color: #64748b; font-size: 0.9rem; font-style: italic;">Aucun concurrent ajouté. Utilisez le formulaire ci-dessus pour rechercher et ajouter des concurrents.</p>';
                    return;
                }

                const view = this.getCompetitorView();
                const filtered = view.competitors;
                const workspace = this.competitorWorkspaceController.snapshot();
                const selectedIds = new Set(workspace.selection.ids);
                const hiddenIds = new Set(workspace.visibility.hidden_ids);
                const mapGloballyVisible = workspace.presentation.visible_on_map;
                if (countEl) {
                    countEl.textContent = `${filtered.length}/${this.competitors.length}`;
                    countEl.dataset.competitorViewFingerprint = view.fingerprint;
                }
                if (panelSummary) {
                    const hiddenLabel = mapGloballyVisible
                        ? (workspace.counts.hidden
                            ? ` · ${workspace.counts.hidden} masqué${workspace.counts.hidden > 1 ? 's' : ''} sur la carte`
                            : '')
                        : ' · carte masquée globalement';
                    panelSummary.textContent = `${filtered.length}/${this.competitors.length} dans la liste${hiddenLabel} · ouvrir les actions`;
                    panelSummary.dataset.competitorViewFingerprint = view.fingerprint;
                }

                const gate = PremiumGate.check('competitor_search');

                if (this.competitorRoutingSnapshot?.status === 'idle') {
                    const routedRows = filtered.filter((row) => (
                        Array.isArray(row.routing?.origins) && row.routing.origins.length
                    ));
                    if (routedRows.length) {
                        const originRows = routedRows.flatMap((row) => row.routing.origins || []);
                        this.setCompetitorRoutingSnapshot({
                            fingerprint: String(routedRows[0]?.routing?.request_key || view.fingerprint),
                            status: 'available',
                            rows: routedRows.map((row) => ({
                                id: this.competitorIdentity(row),
                                routing: row.routing,
                            })),
                            summary: {
                                competitors: routedRows.length,
                                origins: new Set(originRows.map((origin) => origin.origin_id)).size,
                                reachable: originRows.filter((origin) => origin.routing_status === 'available').length,
                                unreachable: originRows.filter((origin) => origin.routing_status !== 'available').length,
                                provider: routedRows[0]?.routing?.provider || 'valhalla',
                                mode: routedRows[0]?.routing?.mode || 'car',
                            },
                            calculated_at: routedRows[0]?.routing?.calculated_at || null,
                            last_failure: routedRows[0]?.routing?.last_failure || null,
                        });
                    }
                }

                const activeScore = window.MaplyticsCompetitorThreatScore.normalizeResult(
                    this.competitorThreatScore,
                    view,
                );
                if (this.competitorThreatScore && !activeScore) {
                    this.clearCompetitorThreatScore();
                }
                const selectionCount = selectedIds.size;

                // Barre de filtres. Le score reste absent tant que l'utilisateur ne l'a pas validé.
                const filterBarHtml = `<div class="competitor-filter-bar">
                    <label class="competitor-filter-label">
                        <span class="sr-only">Filtrer les concurrents ajoutés</span>
                        <input type="text" class="competitor-filter-text" placeholder="Rechercher par nom, ville..." value="${this.escapeCompetitorText(this.filterText)}">
                    </label>
                    <button type="button" class="ghost-btn competitor-score-activation" aria-haspopup="dialog" aria-pressed="${activeScore ? 'true' : 'false'}">${activeScore ? 'Modifier le score' : 'Activer un score'}</button>
                    ${activeScore ? '<button type="button" class="ghost-btn competitor-score-disable">Désactiver</button>' : ''}
                    <button type="button" class="ghost-btn competitor-routing-action" aria-haspopup="dialog" aria-label="Calculer les trajets des ${selectionCount} concurrents sélectionnés" ${selectionCount ? '' : 'disabled'}>
                        <i class="fas fa-route" aria-hidden="true"></i>
                        <span>Calculer les trajets (${selectionCount})</span>
                    </button>
                    <output class="competitor-routing-status" data-competitor-routing-snapshot-status="${this.escapeCompetitorText(this.competitorRoutingSnapshot?.status || 'idle')}" role="status">${this.escapeCompetitorText(this.competitorRoutingSnapshotText())}</output>
                </div>`;
                const snapshotMetadata = this.competitorSnapshotMetadata();
                const metadataHtml = `<div class="competitor-snapshot-metadata" data-snapshot-date="${this.escapeCompetitorText(snapshotMetadata.snapshotDate)}" data-snapshot-source="${this.escapeCompetitorText(snapshotMetadata.source)}" data-snapshot-completeness="${this.escapeCompetitorText(snapshotMetadata.completeness)}" style="font-size: 0.75rem; color: #64748b; margin: -0.15rem 0 0.6rem;">
                    Vue : ${this.escapeCompetitorText(snapshotMetadata.dateLabel)} · Source : ${this.escapeCompetitorText(snapshotMetadata.source)} · Complétude : ${this.escapeCompetitorText(snapshotMetadata.completeness)}
                </div>`;
                const selectionLabel = `${selectionCount} concurrent${selectionCount > 1 ? 's' : ''} sélectionné${selectionCount > 1 ? 's' : ''}`;
                const bulkToolbarHtml = `<div class="competitor-bulk-toolbar" role="group" aria-label="Actions sur les concurrents de la liste">
                    <output class="competitor-selection-status" role="status" aria-live="polite" aria-label="${selectionLabel}" title="${selectionLabel}"><span aria-hidden="true">${selectionCount}</span><span class="sr-only">${selectionLabel}</span></output>
                    <button type="button" class="ghost-btn competitor-select-all" aria-label="Sélectionner tous les concurrents filtrés" title="Tout sélectionner" ${filtered.length ? '' : 'disabled'}><i class="fas fa-check-double" aria-hidden="true"></i></button>
                    <button type="button" class="ghost-btn competitor-clear-selection" aria-label="Effacer la sélection" title="Effacer la sélection" ${selectionCount ? '' : 'disabled'}><i class="far fa-square" aria-hidden="true"></i></button>
                    <button type="button" class="ghost-btn competitor-remove-selection" aria-label="Supprimer les concurrents sélectionnés" title="Supprimer la sélection" ${selectionCount ? '' : 'disabled'}><i class="fas fa-trash" aria-hidden="true"></i></button>
                    <button type="button" class="ghost-btn competitor-remove-all" aria-label="Supprimer tous les concurrents" title="Supprimer tous les concurrents" ${this.competitors.length ? '' : 'disabled'}><i class="fas fa-trash-alt" aria-hidden="true"></i></button>
                </div>`;

                const renderCompetitor = (comp) => {
                    const effectif = getEffectifLabel(comp.tranche_effectif);
                    const age = getCompanyAge(comp.date_creation);
                    const nafDisplay = comp.naf_libelle || (comp.naf_code ? `NAF: ${comp.naf_code}` : '');
                    const ageDisplay = age !== null ? `${age} an${age > 1 ? 's' : ''}` : '';
                    const metaItems = [nafDisplay, effectif, ageDisplay]
                        .filter(Boolean)
                        .map((item) => this.escapeCompetitorText(item));
                    const safeName = this.escapeCompetitorText(comp.name || 'Nom inconnu');
                    const safeLocation = [comp.address, comp.city, comp.postal_code]
                        .filter(Boolean)
                        .map((item) => this.escapeCompetitorText(item))
                        .join(' ');
                    const safeDistance = this.escapeCompetitorText(comp.distance_km);
                    const safeId = this.escapeCompetitorText(comp.id || '');
                    const competitorViewId = this.competitorIdentity(comp);
                    const safeViewId = this.escapeCompetitorText(competitorViewId);
                    const safeGoogleMapsUrl = this.escapeCompetitorText(
                        window.MaplyticsCompetitorMapLinks.buildGoogleMapsUrl(comp),
                    );
                    const isSelected = selectedIds.has(competitorViewId);
                    const isHidden = hiddenIds.has(competitorViewId);
                    const isEffectivelyVisible = mapGloballyVisible && !isHidden;
                    const mapVisibilityStatus = !mapGloballyVisible
                        ? 'Carte des concurrents masquée globalement'
                        : isHidden
                            ? 'Masqué sur la carte'
                            : 'Visible sur la carte';
                    const mapVisibilityAction = !mapGloballyVisible
                        ? (isHidden ? 'Afficher au retour' : 'Masquer au retour')
                        : (isHidden ? 'Afficher carte' : 'Masquer carte');
                    const mapVisibilityLabel = !mapGloballyVisible
                        ? `${isHidden ? 'Afficher' : 'Masquer'} ${safeName} lorsque la carte des concurrents sera réactivée`
                        : `${isHidden ? 'Afficher' : 'Masquer'} ${safeName} sur la carte`;
                    const displayReference = Number(comp.display_reference);
                    const visibleRank = Number(comp.visible_rank);
                    const scoreHtml = window.MaplyticsCompetitorThreatScore.renderScore(
                        activeScore,
                        competitorViewId,
                        (value) => this.escapeCompetitorText(value),
                    );
                    const routingItems = (Array.isArray(comp.routing?.origins) ? comp.routing.origins : []).map((origin) => {
                        const label = this.escapeCompetitorText(origin.origin_label || origin.origin_id || 'Origine');
                        const roadDistance = this.competitorRoadMeasure(origin.road_distance_km);
                        const duration = this.competitorRoadMeasure(origin.road_duration_minutes);
                        if (
                            origin.routing_status !== 'available'
                            || roadDistance === null
                            || duration === null
                        ) {
                            return this.escapeCompetitorText(this.competitorRouteOriginState(origin));
                        }
                        const searchOrigin = (Array.isArray(comp.origins) ? comp.origins : []).find(
                            (item) => String(item.origin_id || '') === String(origin.origin_id || ''),
                        );
                        const searchDistance = Number(searchOrigin?.distance_km ?? comp.distance_km);
                        const delta = Number.isFinite(searchDistance)
                            ? ` · écart ${(roadDistance - searchDistance) >= 0 ? '+' : ''}${(roadDistance - searchDistance).toFixed(2).replace(/\.00$/, '')} km`
                            : '';
                        return `${label}: ${roadDistance.toFixed(2).replace(/\.00$/, '')} km · ${duration.toFixed(1).replace(/\.0$/, '')} min${delta}`;
                    });
                    const routingFreshness = this.escapeCompetitorText(
                        this.competitorRoutingFreshnessText(comp.routing),
                    );
                    const routingFailure = this.escapeCompetitorText(
                        this.competitorRoutingFailureText(comp.routing),
                    );

                    const mapVisibilityIcon = isHidden ? 'fa-eye' : 'fa-eye-slash';
                    return `<article class="competitor-list-row${isSelected ? ' is-selected' : ''}${isEffectivelyVisible ? '' : ' is-map-hidden'}${!mapGloballyVisible ? ' is-map-hidden-global' : ''}" data-competitor-view-id="${safeViewId}" data-visible-rank="${visibleRank}" data-display-reference="${displayReference}" data-map-visibility="${!mapGloballyVisible ? 'global-hidden' : isHidden ? 'hidden' : 'visible'}">
                        <label class="competitor-selection-control">
                            <input type="checkbox" class="competitor-selection-checkbox" data-competitor-id="${safeViewId}" ${isSelected ? 'checked' : ''} aria-label="Sélectionner ${safeName}">
                            <span class="sr-only">Sélectionner ${safeName}</span>
                        </label>
                        <div class="competitor-list-row__content">
                            <div class="competitor-list-row__identity">
                                <span class="competitor-display-reference"><span class="competitor-visible-rank">N° ${visibleRank}</span> · Réf. ${displayReference}</span>
                                <strong class="competitor-list-row__name" title="${safeName}">${safeName}</strong>
                            </div>
                            <div style="font-size: 0.85rem; color: #64748b; line-height: 1.5;">
                                ${safeLocation}${comp.distance_km !== null && comp.distance_km !== undefined ? ` &middot; distance de recherche ${safeDistance} km` : ''}
                            </div>
                            ${metaItems.length ? `<div style="font-size: 0.8rem; color: #94a3b8; margin-top: 0.25rem;">${metaItems.join(' &middot; ')}</div>` : ''}
                            <div data-competitor-routing-summary style="font-size: 0.8rem; color: #475569; margin-top: 0.25rem;">Trajets voiture : ${routingItems.length ? routingItems.join('<br>') : 'non calculés'}</div>
                            ${routingFreshness ? `<div data-competitor-routing-freshness style="font-size: 0.75rem; color: #64748b;">${routingFreshness}</div>` : ''}
                            ${routingFailure ? `<div data-competitor-routing-failure data-route-failure-code="${this.escapeCompetitorText(comp.routing?.last_failure?.code || '')}" style="font-size: 0.75rem; color: #b45309;">${routingFailure}</div>` : ''}
                            <div class="competitor-map-visibility-status" role="status">${mapVisibilityStatus}</div>
                            ${scoreHtml}
                        </div>
                        <div class="competitor-list-row__actions">
                            <a class="ghost-btn competitor-google-maps-link" href="${safeGoogleMapsUrl}" target="_blank" rel="noopener noreferrer" aria-label="Voir ${safeName} sur Google Maps" title="Voir la fiche ou rechercher ce magasin sur Google Maps"><i class="fab fa-google" aria-hidden="true"></i></a>
                            <button type="button" class="ghost-btn competitor-map-visibility-btn" data-competitor-id="${safeViewId}" aria-pressed="${isHidden ? 'false' : 'true'}" aria-label="${mapVisibilityLabel}" title="${mapVisibilityAction}"><i class="fas ${mapVisibilityIcon}" aria-hidden="true"></i></button>
                            <button type="button" class="competitor-to-point-btn" data-id="${safeId}" data-competitor-id="${safeViewId}" aria-label="Ajouter ${safeName} comme point personnalisé" title="Ajouter comme point personnalisé"><i class="fas fa-map-marker-alt" aria-hidden="true"></i></button>
                            <button type="button" class="competitor-remove-btn" data-competitor-id="${safeViewId}" aria-label="Supprimer ${safeName}" title="Supprimer"><i class="fas fa-trash-alt" aria-hidden="true"></i></button>
                        </div>
                    </article>`;
                };

                let html = filterBarHtml + metadataHtml + bulkToolbarHtml;
                html += renderSaturationBadge(filtered.length, gate);
                html += PremiumGate.renderGatedList(filtered, renderCompetitor, gate);
                listEl.innerHTML = html;

                // Event listeners pour les boutons supprimer
                listEl.querySelectorAll('.competitor-remove-btn').forEach(btn => {
                    btn.addEventListener('click', (event) => {
                        this.removeCompetitor(event.currentTarget.dataset.competitorId);
                    });
                });

                listEl.querySelectorAll('.competitor-selection-checkbox').forEach((checkbox) => {
                    checkbox.addEventListener('change', (event) => {
                        const identity = event.currentTarget.dataset.competitorId;
                        this.dispatchCompetitorWorkspace({
                            type: 'selection/toggle',
                            id: identity,
                        });
                        this.renderCompetitorsList();
                        const row = Array.from(listEl.querySelectorAll('[data-competitor-view-id]'))
                            .find((item) => item.dataset.competitorViewId === identity);
                        row?.querySelector('.competitor-selection-checkbox')?.focus({ preventScroll: true });
                    });
                });

                listEl.querySelectorAll('.competitor-map-visibility-btn').forEach((button) => {
                    button.addEventListener('click', (event) => {
                        const identity = event.currentTarget.dataset.competitorId;
                        const hidden = this.competitorWorkspaceController.snapshot()
                            .visibility.hidden_ids.includes(identity);
                        this.dispatchCompetitorWorkspace({
                            type: hidden ? 'visibility/show' : 'visibility/hide',
                            ids: [identity],
                        });
                        this.refreshCompetitorViewSurfaces();
                        const row = Array.from(listEl.querySelectorAll('[data-competitor-view-id]'))
                            .find((item) => item.dataset.competitorViewId === identity);
                        row?.querySelector('.competitor-map-visibility-btn')?.focus({ preventScroll: true });
                    });
                });

                listEl.querySelector('.competitor-select-all')?.addEventListener('click', () => {
                    this.dispatchCompetitorWorkspace({ type: 'selection/visible', selected: true });
                    this.renderCompetitorsList();
                    listEl.querySelector('.competitor-clear-selection')?.focus({ preventScroll: true });
                });
                listEl.querySelector('.competitor-clear-selection')?.addEventListener('click', () => {
                    this.dispatchCompetitorWorkspace({ type: 'selection/set', ids: [] });
                    this.renderCompetitorsList();
                    listEl.querySelector('.competitor-select-all')?.focus({ preventScroll: true });
                });
                listEl.querySelector('.competitor-remove-selection')?.addEventListener('click', () => {
                    const ids = this.competitorWorkspaceController.snapshot().selection.ids;
                    if (!ids.length || !confirm(`Supprimer ${ids.length} concurrent${ids.length > 1 ? 's' : ''} sélectionné${ids.length > 1 ? 's' : ''} ?`)) return;
                    this.removeCompetitors(ids);
                    listEl.querySelector('.competitor-select-all')?.focus({ preventScroll: true });
                });
                listEl.querySelector('.competitor-remove-all')?.addEventListener('click', () => {
                    const ids = this.competitors.map((competitor) => this.competitorIdentity(competitor));
                    if (!ids.length || !confirm(`Supprimer les ${ids.length} concurrents ajoutés ?`)) return;
                    this.removeCompetitors(ids);
                    listEl.querySelector('.competitor-select-all')?.focus({ preventScroll: true });
                });

                // Event listeners pour convertir en point personnalisé
                listEl.querySelectorAll('.competitor-to-point-btn').forEach(btn => {
                    btn.addEventListener('click', (event) => {
                        const identity = event.currentTarget.dataset.competitorId;
                        const comp = this.competitors.find(
                            (competitor) => this.competitorIdentity(competitor) === identity,
                        );
                        if (comp) this.convertCompetitorToPoint(comp);
                    });
                });

                // Event listeners pour les filtres
                const textInput = listEl.querySelector('.competitor-filter-text');
                if (textInput) {
                    let debounceTimer;
                    textInput.addEventListener('input', (e) => {
                        clearTimeout(debounceTimer);
                        debounceTimer = setTimeout(() => {
                            this.dispatchCompetitorWorkspace({
                                type: 'filters/set',
                                filters: {
                                    ...(this.competitorViewFilters || {}),
                                    searchText: e.target.value,
                                },
                            });
                            this.refreshCompetitorViewSurfaces();
                            const newInput = listEl.querySelector('.competitor-filter-text');
                            if (newInput) { newInput.focus(); newInput.selectionStart = newInput.selectionEnd = newInput.value.length; }
                        }, 300);
                    });
                }
                listEl.querySelector('.competitor-score-activation')?.addEventListener('click', (event) => {
                    this.openThreatScoreConfiguration(event.currentTarget);
                });
                listEl.querySelector('.competitor-routing-action')?.addEventListener('click', () => {
                    this.openCompetitorsReviewModal({ calculateRoutes: true });
                });
                listEl.querySelector('.competitor-score-disable')?.addEventListener('click', async () => {
                    const previousScore = this.competitorThreatScore;
                    this.clearCompetitorThreatScore();
                    this.renderCompetitorsList();
                    if (!await this.saveCompetitors({ quiet: true })) {
                        this.dispatchCompetitorWorkspace({ type: 'score/set', score: previousScore });
                        this.renderCompetitorsList();
                        this.competitorFilterBuilder?.setStatus?.(
                            'La désactivation n’a pas pu être sauvegardée. Le score reste actif.',
                            'error',
                        );
                    }
                });
            },

            // Ajouter un concurrent
            addCompetitor(competitor) {
                if (!this.competitors.some(c => c.siret === competitor.siret)) {
                    this.dispatchCompetitorWorkspace({
                        type: 'competitors/add',
                        rows: [{
                            id: `comp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
                            ...competitor,
                        }],
                    });
                    this.renderCompetitorsList();
                    this.updateMarkersOnMap();
                }
            },

            // Supprimer un concurrent
            removeCompetitor(id) {
                return this.removeCompetitors([id]);
            },

            // Supprimer une ou plusieurs lignes dans une seule transaction de workspace.
            removeCompetitors(ids) {
                const normalizedIds = [...new Set(
                    (Array.isArray(ids) ? ids : [ids])
                        .map((value) => String(value || '').trim())
                        .filter(Boolean),
                )];
                if (!normalizedIds.length) return false;
                const removedIds = new Set(normalizedIds);
                const beforeSnapshot = this.competitorWorkspaceController.snapshot();
                const activeIdentity = document.activeElement
                    ?.closest?.('[data-competitor-view-id]')
                    ?.dataset?.competitorViewId || '';
                const activeIndex = beforeSnapshot.view.ids.indexOf(activeIdentity);
                const remainingViewIds = beforeSnapshot.view.ids.filter(
                    (identity) => !removedIds.has(identity),
                );
                const fallbackIdentity = activeIndex >= 0
                    ? beforeSnapshot.view.ids
                        .slice(activeIndex + 1)
                        .find((identity) => !removedIds.has(identity))
                        || beforeSnapshot.view.ids
                            .slice(0, activeIndex)
                            .reverse()
                            .find((identity) => !removedIds.has(identity))
                        || ''
                    : remainingViewIds[0] || '';
                this.dispatchCompetitorWorkspace({
                    type: 'competitors/remove',
                    ids: normalizedIds,
                    removedAt: new Date().toISOString(),
                });
                this.clearAttractiveness();
                this.refreshCompetitorViewSurfaces();
                const listEl = document.querySelector(
                    `${scopeSelector} #competitorsList, ${scopeSelector} #importCompetitorsList`,
                );
                const fallbackRow = Array.from(
                    listEl?.querySelectorAll?.('[data-competitor-view-id]') || [],
                ).find((row) => row.dataset.competitorViewId === fallbackIdentity);
                const focusTarget = fallbackRow?.querySelector('.competitor-selection-checkbox')
                    || listEl?.querySelector('.competitor-select-all')
                    || document.querySelector(
                        `${scopeSelector} [data-competitor-workspace-panel="list"] > [data-competitor-workspace-summary]`,
                    );
                focusTarget?.focus?.({ preventScroll: true });
                window.requestAnimationFrame?.(() => {
                    focusTarget?.focus?.({ preventScroll: true });
                });
                window.setTimeout?.(() => {
                    focusTarget?.focus?.({ preventScroll: true });
                }, 0);
                void this.saveCompetitors();
                return true;
            },

            restoreRemovedCompetitor(key) {
                const snapshot = this.competitorWorkspaceController.snapshot();
                const item = snapshot.removed.items.find((entry) => entry.key === key);
                if (!item || item.kind !== 'competitor') return false;
                const exactSearchRow = this.lastSearchResults.find(
                    (row) => this.competitorIdentity(row) === item.identity,
                );
                const restoreRow = item.restore_row || exactSearchRow;
                if (!restoreRow) {
                    this.competitorFilterBuilder?.setStatus?.(
                        'Une nouvelle recherche contenant ce concurrent est nécessaire pour le restaurer.',
                        'error',
                    );
                    return false;
                }
                const result = this.dispatchCompetitorWorkspace({
                    type: 'removed/restore',
                    key,
                    row: restoreRow,
                });
                if (!result.applied) return false;
                this.clearAttractiveness();
                this.refreshCompetitorViewSurfaces();
                const restoredVisible = result.snapshot.view.ids.includes(item.identity);
                this.competitorFilterBuilder?.setStatus?.(
                    restoredVisible
                        ? `${item.label} a été restauré.`
                        : `${item.label} a été restauré mais reste masqué par le filtre courant.`,
                    'success',
                );
                void this.saveCompetitors();
                return true;
            },

            // Mettre à jour les markers sur la carte
            updateMarkersOnMap() {
                const invalidateImportVisual = () => {
                    if (toolType === 'import-table') {
                        importDetailedExportAdapter?.invalidate?.(
                            'import-competitors-changed',
                            {hard: false},
                        );
                    }
                };
                const mapController = toolType === 'isochrone' ? exportMapController : importMapController;
                if (!mapController || !mapController.map || typeof L === 'undefined') {
                    invalidateImportVisual();
                    return;
                }

                this.initMarkersLayer();
                if (!this.markersLayer) {
                    invalidateImportVisual();
                    return;
                }

                const view = this.getCompetitorView();
                const workspace = this.competitorWorkspaceController.snapshot();
                if (!(this.competitorMarkerRegistry instanceof Map)) {
                    this.competitorMarkerRegistry = new Map();
                }
                const desiredMarkers = new Map();
                workspace.map.rows.forEach((comp) => {
                    const identity = this.competitorIdentity(comp);
                    const rawLat = comp.lat ?? comp.latitude;
                    const rawLon = comp.lon ?? comp.lng ?? comp.longitude;
                    const markerLat = rawLat === null || rawLat === undefined || rawLat === ''
                        ? Number.NaN
                        : Number(rawLat);
                    const markerLon = rawLon === null || rawLon === undefined || rawLon === ''
                        ? Number.NaN
                        : Number(rawLon);
                    if (!identity || !Number.isFinite(markerLat) || !Number.isFinite(markerLon)) return;
                    const signature = JSON.stringify({
                        markerLat,
                        markerLon,
                        color: this.competitorMarkerColor,
                        markerScale: this.competitorMarkerScale,
                        numbered: this.competitorsNumbered,
                        visibleRank: Number(comp.visible_rank),
                        displayReference: Number(comp.display_reference),
                        name: comp.name || '',
                        address: comp.address || '',
                        city: comp.city || '',
                        postalCode: comp.postal_code || '',
                        nafLabel: comp.naf_libelle || '',
                        distanceKm: comp.distance_km ?? null,
                        employeeBand: comp.tranche_effectif || '',
                        creationDate: comp.date_creation || '',
                        routing: comp.routing || null,
                    });
                    desiredMarkers.set(identity, { comp, markerLat, markerLon, signature });
                });

                this.competitorMarkerRegistry.forEach((entry, identity) => {
                    const desired = desiredMarkers.get(identity);
                    if (desired && desired.signature === entry.signature) {
                        entry.marker.competitorViewFingerprint = view.fingerprint;
                        if (!this.markersLayer.hasLayer?.(entry.marker)) this.markersLayer.addLayer(entry.marker);
                        return;
                    }
                    this.markersLayer.removeLayer(entry.marker);
                    this.competitorMarkerRegistry.delete(identity);
                });

                desiredMarkers.forEach(({ comp, markerLat, markerLon, signature }, identity) => {
                    if (this.competitorMarkerRegistry.has(identity)) return;
                    const displayReference = Number(comp.display_reference);
                    const visibleRank = Number(comp.visible_rank);
                    const markerColor = this.competitorMarkerColor;
                    const markerLabelColor = window.MaplyticsCompetitorSearch.markerTextColor(markerColor);
                    const isNumbered = this.competitorsNumbered;
                    const markerSize = window.MaplyticsCompetitorVisualEncoding.presentationSize(
                        isNumbered ? 24 : 12,
                        this.competitorMarkerScale,
                    );
                    const markerInner = isNumbered
                        ? `<span style="font-size: ${Math.max(11, Math.round(markerSize * 0.46))}px; font-weight: 800; color: ${markerLabelColor}; line-height: 1;">${visibleRank}</span>`
                        : '';
                    const marker = L.marker([markerLat, markerLon], {
                        icon: L.divIcon({
                            className: isNumbered ? 'competitor-marker competitor-marker--numbered' : 'competitor-marker',
                            html: `<div style="background: ${markerColor}; width: ${markerSize}px; height: ${markerSize}px; border-radius: 50%; border: 2px solid white; box-shadow: 0 2px 4px rgba(0,0,0,0.3); display: flex; align-items: center; justify-content: center;">${markerInner}</div>`,
                            iconSize: [markerSize, markerSize],
                            iconAnchor: [markerSize / 2, markerSize / 2],
                        }),
                    });
                    marker.competitorViewId = identity;
                    marker.competitorViewFingerprint = view.fingerprint;
                    marker.competitorVisibleRank = visibleRank;
                    marker.competitorDisplayReference = displayReference;
                    marker.competitorWorkspaceSignature = signature;
                    marker.bindTooltip(`<b>${isNumbered ? `N° ${visibleRank} · Réf. ${displayReference} · ` : ''}${this.escapeCompetitorText(comp.name || 'Nom inconnu')}</b>`, {
                        permanent: false,
                        direction: 'top',
                        className: 'competitor-tooltip',
                    });

                    const effectif = getEffectifLabel(comp.tranche_effectif);
                    const age = getCompanyAge(comp.date_creation);
                    const routingSummary = (Array.isArray(comp.routing?.origins) ? comp.routing.origins : []).map((origin) => {
                        const label = this.escapeCompetitorText(origin.origin_label || origin.origin_id || 'Origine');
                        const distance = this.competitorRoadMeasure(origin.road_distance_km);
                        const duration = this.competitorRoadMeasure(origin.road_duration_minutes);
                        if (origin.routing_status !== 'available' || distance === null || duration === null) {
                            return this.escapeCompetitorText(this.competitorRouteOriginState(origin));
                        }
                        return `${label}: ${this.escapeCompetitorText(distance)} km · ${this.escapeCompetitorText(duration)} min`;
                    }).join('<br>');
                    const routingFreshness = this.escapeCompetitorText(
                        this.competitorRoutingFreshnessText(comp.routing),
                    );
                    const routingFailure = this.escapeCompetitorText(
                        this.competitorRoutingFailureText(comp.routing),
                    );
                    const safeGoogleMapsUrl = this.escapeCompetitorText(
                        window.MaplyticsCompetitorMapLinks.buildGoogleMapsUrl(comp),
                    );
                    marker.bindPopup(`<div style="min-width: 200px; font-size: 0.85rem; line-height: 1.6;">
                        <div style="font-weight: 700; font-size: 0.95rem; margin-bottom: 0.25rem;">${this.escapeCompetitorText(comp.name || 'Nom inconnu')}</div>
                        <div>N° <b>${visibleRank}</b> · Réf. <b>${displayReference}</b></div>
                        ${comp.naf_libelle ? `<div style="color: #475569;">${this.escapeCompetitorText(comp.naf_libelle)}</div>` : ''}
                        ${comp.address || comp.city ? `<div style="color: #64748b;">${[comp.address, comp.city, comp.postal_code].filter(Boolean).map((item) => this.escapeCompetitorText(item)).join(' ')}</div>` : ''}
                        ${comp.distance_km !== null && comp.distance_km !== undefined ? `<div>Distance de recherche: <b>${this.escapeCompetitorText(comp.distance_km)} km</b></div>` : ''}
                        ${routingSummary ? `<div>Trajets voiture:<br><b>${routingSummary}</b></div>` : '<div>Trajets voiture: non calculés</div>'}
                        ${routingFreshness ? `<div>${routingFreshness}</div>` : ''}
                        ${routingFailure ? `<div data-competitor-routing-failure style="color: #b45309;">${routingFailure}</div>` : ''}
                        ${effectif ? `<div>Effectif: ${this.escapeCompetitorText(effectif)}</div>` : ''}
                        ${age !== null ? `<div>Anciennete: ${this.escapeCompetitorText(age)} an${age > 1 ? 's' : ''}</div>` : ''}
                        <div style="margin-top: 0.5rem; display: flex; gap: 0.5rem; align-items: center; justify-content: flex-end;">
                            <a data-competitor-google-maps href="${safeGoogleMapsUrl}" target="_blank" rel="noopener noreferrer" style="min-height: 44px; display: inline-flex; align-items: center; background: #eff6ff; border: 1px solid #bfdbfe; color: #1d4ed8; padding: 0.35rem 0.65rem; border-radius: 0.25rem; font-size: 0.8rem;">Voir sur Google Maps</a>
                            <button type="button" data-remove-competitor="${this.escapeCompetitorText(identity)}" style="min-height: 44px; background: #fee2e2; border: 1px solid #fecaca; color: #dc2626; padding: 0.35rem 0.65rem; border-radius: 0.25rem; cursor: pointer; font-size: 0.8rem;">Supprimer</button>
                        </div>
                    </div>`, { maxWidth: 300 });
                    marker.on('popupopen', () => {
                        const popupElement = marker.getPopup()?.getElement();
                        const removeButton = popupElement?.querySelector('[data-remove-competitor]');
                        if (removeButton) {
                            removeButton.onclick = () => {
                                this.removeCompetitor(removeButton.dataset.removeCompetitor);
                            };
                        }
                    });
                    this.markersLayer.addLayer(marker);
                    this.competitorMarkerRegistry.set(identity, {
                        marker,
                        signature,
                    });
                });
                if (this.pointsLegendVisible) this.updatePointsLegend();
                invalidateImportVisual();
            },

            toggleCompetitorsNumbering() {
                this.dispatchCompetitorWorkspace({
                    type: 'presentation/set',
                    patch: { numbered: !this.competitorsNumbered },
                });
                this.refreshCompetitorViewSurfaces();
                this.syncCompetitorsNumberingButton();
            },

            syncCompetitorsNumberingButton() {
                const btn = document.querySelector(`${scopeSelector} .competitors-number-all-action`);
                if (btn) {
                    btn.classList.toggle('is-active', this.competitorsNumbered);
                    btn.setAttribute('aria-pressed', this.competitorsNumbered ? 'true' : 'false');
                    btn.title = this.competitorsNumbered ? 'Masquer la numérotation des concurrents' : 'Numéroter les concurrents sur la carte';
                }
            },

            // Toggle visibilité sur la carte
            setMapVisibility(value, { persist = false } = {}) {
                this.dispatchCompetitorWorkspace({
                    type: 'presentation/set',
                    patch: { visibleOnMap: Boolean(value) },
                });
                this.refreshCompetitorViewSurfaces();
                if (persist) void this.saveCompetitors({ quiet: true });
                return this.visibleOnMap;
            },

            toggleMapVisibility() {
                return this.setMapVisibility(!this.visibleOnMap, { persist: false });
            },

            openAttractivenessConfiguration(trigger = null) {
                const params = this.getSearchParams();
                if (!params) {
                    alert('Veuillez d\'abord définir une adresse de recherche.');
                    return false;
                }
                this._attractivenessModal?.close?.({ restoreFocus: false });
                const previousFocus = trigger || document.activeElement;
                const previousOverflow = document.body.style.overflow;
                const overlay = document.createElement('div');
                overlay.className = 'competitor-search-modal competitor-attractiveness-modal';
                overlay.dataset.competitorToolType = toolType;
                overlay.setAttribute('role', 'presentation');
                const dialog = document.createElement('div');
                dialog.className = 'g2-wzo-modal geo-manager-white-zone-opportunity-modal competitor-attractiveness-dialog';
                dialog.setAttribute('role', 'dialog');
                dialog.setAttribute('aria-modal', 'true');
                dialog.setAttribute('aria-labelledby', `${prefix || 'export'}AttractivenessTitle`);
                dialog.tabIndex = -1;
                const selected = new Set(
                    this.attractivenessSelectedCategories.length
                        ? this.attractivenessSelectedCategories
                        : Object.keys(this.ATTRACTIVENESS_CATEGORIES),
                );
                dialog.innerHTML = `
                    <header class="g2-wzo-modal-hero">
                        <div>
                            <span>Analyse de présence</span>
                            <h4 id="${prefix || 'export'}AttractivenessTitle">Choisir les catégories d’attractivité</h4>
                            <p>Rayon actuel : ${this.escapeCompetitorText(params.radiusKm || 15)} km. Aucun appel ne sera lancé avant confirmation.</p>
                        </div>
                        <button type="button" class="g2-wzo-modal-close" data-attractiveness-cancel aria-label="Fermer la sélection d’attractivité">×</button>
                    </header>
                    <section class="g2-wzo-modal-section">
                        <fieldset class="competitor-attractiveness-categories">
                            <legend>Catégories à analyser</legend>
                            ${Object.entries(this.ATTRACTIVENESS_CATEGORIES).map(([key, category]) => `
                                <label>
                                    <input type="checkbox" value="${this.escapeCompetitorText(key)}" data-attractiveness-category ${selected.has(key) ? 'checked' : ''}>
                                    <span aria-hidden="true">${category.emoji}</span>
                                    <strong>${this.escapeCompetitorText(category.label)}</strong>
                                </label>
                            `).join('')}
                        </fieldset>
                        <fieldset class="competitor-attractiveness-visuals">
                            <legend>Différencier les points sur la carte</legend>
                            <label>
                                <span>Couleur</span>
                                <select data-attractiveness-color-mode aria-label="Mode de couleur des points">
                                    <option value="category" ${this.attractivenessVisualEncoding.colorMode === 'category' ? 'selected' : ''}>Par catégorie</option>
                                    <option value="custom" ${this.attractivenessVisualEncoding.colorMode === 'custom' ? 'selected' : ''}>Couleur unique</option>
                                </select>
                            </label>
                            <label>
                                <span class="sr-only">Couleur unique des points</span>
                                <input type="color" data-attractiveness-custom-color value="${this.attractivenessVisualEncoding.customColor}" aria-label="Couleur unique des points">
                            </label>
                            <label>
                                <span>Taille</span>
                                <select data-attractiveness-size-mode aria-label="Taille des points">
                                    <option value="automatic" ${this.attractivenessVisualEncoding.sizeMode === 'automatic' ? 'selected' : ''}>Automatique · effectifs puis format GSA</option>
                                    <option value="uniform" ${this.attractivenessVisualEncoding.sizeMode === 'uniform' ? 'selected' : ''}>Uniforme</option>
                                    <option value="workforce" ${this.attractivenessVisualEncoding.sizeMode === 'workforce' ? 'selected' : ''}>Tranche d’effectifs SIRENE</option>
                                    <option value="gsa_format" ${this.attractivenessVisualEncoding.sizeMode === 'gsa_format' ? 'selected' : ''}>Format GSA · supérette à hypermarché</option>
                                </select>
                            </label>
                            <label>
                                <span>Agrandissement</span>
                                <select data-attractiveness-presentation-scale aria-label="Agrandissement de présentation des points">
                                    <option value="normal" ${this.competitorMarkerScale === 'normal' ? 'selected' : ''}>Normal</option>
                                    <option value="large" ${this.competitorMarkerScale === 'large' ? 'selected' : ''}>Grand · 135 %</option>
                                    <option value="xlarge" ${this.competitorMarkerScale === 'xlarge' ? 'selected' : ''}>Très grand · 170 %</option>
                                    <option value="xxlarge" ${this.competitorMarkerScale === 'xxlarge' ? 'selected' : ''}>Très grand · 200 %</option>
                                    <option value="maximum" ${this.competitorMarkerScale === 'maximum' ? 'selected' : ''}>Maximum · 250 %</option>
                                </select>
                            </label>
                            <div class="competitor-attractiveness-visual-preview" data-attractiveness-visual-preview aria-label="Aperçu des tailles de points"></div>
                            <small data-attractiveness-visual-coverage></small>
                            <small>Automatique utilise d’abord la tranche SIRENE, puis le format GSA vérifié. Le format GSA n’est jamais présenté comme un effectif ; une donnée absente garde une taille neutre.</small>
                        </fieldset>
                        <p class="competitor-attractiveness-validation" data-attractiveness-validation role="status" aria-live="polite"></p>
                    </section>
                    <footer class="g2-wzo-modal-footer">
                        <button type="button" class="ghost-btn" data-attractiveness-cancel>Annuler</button>
                        <button type="button" class="primary-btn" data-attractiveness-confirm>Analyser les catégories choisies</button>
                    </footer>
                `;
                overlay.appendChild(dialog);
                const modalRoot = document.fullscreenElement
                    || document.webkitFullscreenElement
                    || document.body;
                modalRoot.appendChild(overlay);
                document.body.style.overflow = 'hidden';

                const renderVisualEncodingHelp = () => {
                    const config = window.MaplyticsCompetitorVisualEncoding.normalize({
                        colorMode: dialog.querySelector('[data-attractiveness-color-mode]')?.value,
                        customColor: dialog.querySelector('[data-attractiveness-custom-color]')?.value,
                        sizeMode: dialog.querySelector('[data-attractiveness-size-mode]')?.value,
                        presentationScale: dialog.querySelector('[data-attractiveness-presentation-scale]')?.value,
                    });
                    const currentRows = Object.values(this.attractivenessResults || {}).flat();
                    const coverage = window.MaplyticsCompetitorVisualEncoding.coverage(
                        currentRows,
                        { color: '#ef4444' },
                        config,
                    );
                    const preview = dialog.querySelector('[data-attractiveness-visual-preview]');
                    preview.replaceChildren(...window.MaplyticsCompetitorVisualEncoding.previewStyles(config).map((style) => {
                        const item = document.createElement('span');
                        item.className = 'competitor-attractiveness-visual-preview__item';
                        const dot = document.createElement('i');
                        dot.style.width = `${style.size}px`;
                        dot.style.height = `${style.size}px`;
                        dot.style.background = style.color;
                        dot.setAttribute('aria-hidden', 'true');
                        const label = document.createElement('span');
                        label.textContent = style.label;
                        item.append(dot, label);
                        return item;
                    }));
                    const coverageNode = dialog.querySelector('[data-attractiveness-visual-coverage]');
                    coverageNode.textContent = coverage.total
                        ? `Couverture actuelle : effectifs ${coverage.workforce_band}/${coverage.total}, format GSA ${coverage.naf_gsa}/${coverage.total}, neutre ${coverage.neutral}/${coverage.total}.`
                        : 'Couverture actuelle : elle sera indiquée après l’analyse des établissements.';
                };
                dialog.querySelector('[data-attractiveness-size-mode]')?.addEventListener('change', renderVisualEncodingHelp);
                dialog.querySelector('[data-attractiveness-presentation-scale]')?.addEventListener('change', renderVisualEncodingHelp);
                dialog.querySelector('[data-attractiveness-color-mode]')?.addEventListener('change', renderVisualEncodingHelp);
                dialog.querySelector('[data-attractiveness-custom-color]')?.addEventListener('input', renderVisualEncodingHelp);
                renderVisualEncodingHelp();

                let closed = false;
                const close = ({ restoreFocus = true } = {}) => {
                    if (closed) return;
                    closed = true;
                    document.removeEventListener('keydown', onKeyDown);
                    document.body.style.overflow = previousOverflow;
                    overlay.remove();
                    if (this._attractivenessModal?.overlay === overlay) {
                        this._attractivenessModal = null;
                    }
                    if (restoreFocus && previousFocus?.focus) {
                        previousFocus.focus({ preventScroll: true });
                    }
                };
                const onKeyDown = (event) => {
                    if (event.key === 'Escape') {
                        event.preventDefault();
                        close();
                        return;
                    }
                    if (event.key !== 'Tab') return;
                    const focusable = Array.from(dialog.querySelectorAll(
                        'button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])',
                    )).filter((element) => element.offsetParent !== null);
                    if (!focusable.length) return;
                    const first = focusable[0];
                    const last = focusable.at(-1);
                    if (event.shiftKey && document.activeElement === first) {
                        event.preventDefault();
                        last.focus();
                    } else if (!event.shiftKey && document.activeElement === last) {
                        event.preventDefault();
                        first.focus();
                    }
                };
                overlay.addEventListener('click', (event) => {
                    if (event.target === overlay || event.target.closest('[data-attractiveness-cancel]')) {
                        close();
                        return;
                    }
                    if (!event.target.closest('[data-attractiveness-confirm]')) return;
                    const categoryKeys = Array.from(dialog.querySelectorAll(
                        '[data-attractiveness-category]:checked',
                    )).map((input) => input.value).filter((key) => this.ATTRACTIVENESS_CATEGORIES[key]);
                    const validation = dialog.querySelector('[data-attractiveness-validation]');
                    if (!categoryKeys.length) {
                        validation.textContent = 'Sélectionnez au moins une catégorie.';
                        dialog.querySelector('[data-attractiveness-category]')?.focus();
                        return;
                    }
                    this.attractivenessVisualEncoding = window.MaplyticsCompetitorVisualEncoding.normalize({
                        colorMode: dialog.querySelector('[data-attractiveness-color-mode]')?.value,
                        customColor: dialog.querySelector('[data-attractiveness-custom-color]')?.value,
                        sizeMode: dialog.querySelector('[data-attractiveness-size-mode]')?.value,
                        presentationScale: dialog.querySelector('[data-attractiveness-presentation-scale]')?.value,
                    });
                    this.setCompetitorMarkerScale(
                        this.attractivenessVisualEncoding.presentationScale,
                        { persist: false },
                    );
                    this.attractivenessSelectedCategories = [...categoryKeys];
                    close({ restoreFocus: false });
                    void this.searchAttractiveness(categoryKeys, { trigger: previousFocus });
                });
                document.addEventListener('keydown', onKeyDown);
                this._attractivenessModal = { overlay, dialog, close };
                dialog.focus();
                return this._attractivenessModal;
            },

            setAttractivenessVisible(value, {persist = false} = {}) {
                const nextVisible = Boolean(value);
                const hasResults = Object.values(this.attractivenessResults || {})
                    .some((rows) => Array.isArray(rows) && rows.length > 0);
                if (nextVisible && !hasResults) {
                    this.syncAttractivenessVisibilityControl();
                    return false;
                }
                const mapController = toolType === 'isochrone'
                    ? exportMapController
                    : importMapController;
                if (nextVisible) {
                    this.attractivenessVisible = true;
                    this.showAttractivenessResults();
                } else {
                    if (this.attractivenessLayer && mapController?.map) {
                        mapController.map.removeLayer(this.attractivenessLayer);
                        this.attractivenessLayer = null;
                    }
                    if (this._attractPanel && mapController?.map) {
                        mapController.map.removeControl(this._attractPanel);
                        this._attractPanel = null;
                    }
                    this.attractivenessVisible = false;
                }
                this.syncAttractivenessVisibilityControl();
                if (persist) void this.saveCompetitors({quiet: true});
                return this.attractivenessVisible;
            },

            syncAttractivenessVisibilityControl() {
                const controlId = prefix
                    ? `${prefix}CompetitorAttractVisibilityBtn`
                    : 'competitorAttractVisibilityBtn';
                const button = document.querySelector(`${scopeSelector} #${controlId}`);
                if (!button) return false;
                const hasResults = Object.values(this.attractivenessResults || {})
                    .some((rows) => Array.isArray(rows) && rows.length > 0);
                button.disabled = !hasResults;
                button.setAttribute('aria-pressed', this.attractivenessVisible ? 'true' : 'false');
                button.textContent = this.attractivenessVisible
                    ? 'Masquer attractivité'
                    : 'Afficher attractivité';
                button.title = hasResults
                    ? `${this.attractivenessVisible ? 'Masquer' : 'Afficher'} les résultats d’attractivité sans les recalculer`
                    : 'Lancez d’abord une analyse d’attractivité';
                return true;
            },

            cancelAttractivenessRequest() {
                const request = this._attractivenessRequest;
                this._attractivenessRequest = null;
                if (!request) return;
                request.controller.abort();
                request.restoreButton();
            },

            // Analyse attractivité zone (multi-catégories confirmées)
            async searchAttractiveness(
                categoryKeys = Object.keys(this.ATTRACTIVENESS_CATEGORIES),
                { trigger = null, refreshCache = false, preserveExisting = false } = {},
            ) {
                const workspaceRequestGeneration = this._workspaceRequestGeneration;
                const params = this.getSearchParams();
                if (!params) {
                    alert('Veuillez d\'abord définir une adresse de recherche.');
                    return;
                }

                const selectedKeys = Array.from(new Set(
                    (Array.isArray(categoryKeys) ? categoryKeys : [])
                        .map((key) => String(key || ''))
                        .filter((key) => this.ATTRACTIVENESS_CATEGORIES[key]),
                ));
                if (!selectedKeys.length) return false;

                this.cancelAttractivenessRequest();
                const btn = trigger || document.querySelector(`${scopeSelector} #competitorAttractBtn, ${scopeSelector} #importCompetitorAttractBtn`);
                const label = btn?.textContent;
                const disabled = btn?.disabled;
                const request = {
                    controller: new AbortController(),
                    restoreButton: () => {
                        if (!btn) return;
                        btn.disabled = disabled;
                        btn.textContent = label;
                        btn.style.background = this.attractivenessVisible ? 'linear-gradient(135deg, #6d28d9, #4338ca)' : 'linear-gradient(135deg, #8b5cf6, #6366f1)';
                    },
                };
                this._attractivenessRequest = request;
                const isCurrent = () => this._attractivenessRequest === request
                    && workspaceRequestGeneration === this._workspaceRequestGeneration;
                if (btn) { btn.disabled = true; btn.textContent = APP_CONFIG.appShellV2 ? 'Analyse...' : '⏳ Analyse multi-catégories...'; }

                try {
                    const categories = this.ATTRACTIVENESS_CATEGORIES;
                    const results = preserveExisting
                        ? { ...this.attractivenessResults }
                        : {};
                    const searchInfo = preserveExisting
                        ? { ...this.attractivenessSearchInfo }
                        : {};
                    // An empty array created by an earlier failure is not a
                    // collected empty result. Legacy nonempty rows still count.
                    const hasPreviousCollection = (key) => preserveExisting
                        && Array.isArray(results[key])
                        && (results[key].length > 0 || window.MaplyticsSavedAnalysisState
                            .normalizeAttractivenessInfo(searchInfo[key]).collected_at !== null);

                    const promises = selectedKeys.map(async (key) => {
                        const cat = categories[key];
                        try {
                            const response = await fetch('/api/competitors/search', {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                credentials: 'include',
                                signal: request.controller.signal,
                                body: JSON.stringify({
                                    method: 'naf',
                                    query: cat.codes.join(';'),
                                    lat: params.lat,
                                    lon: params.lon,
                                    radius_km: params.radiusKm || 15,
                                    refresh_cache: Boolean(refreshCache),
                                })
                            });
                            const data = await response.json().catch(() => ({}));
                            const rawInfo = data.search_info && typeof data.search_info === 'object'
                                ? data.search_info
                                : {};
                            const successful = Boolean(response.ok && data.success
                                && Array.isArray(data.competitors)
                                && !['unavailable', 'error', 'rate_limited'].includes(
                                    String(rawInfo.source_status || '').toLowerCase(),
                                ));
                            const retainedPrevious = !successful && hasPreviousCollection(key);
                            if (successful) {
                                results[key] = Array.isArray(data.competitors)
                                    ? data.competitors
                                    : [];
                            } else if (!preserveExisting || !Array.isArray(results[key])) {
                                results[key] = [];
                            }
                            searchInfo[key] = window.MaplyticsSavedAnalysisState.attractivenessCollectionInfo({
                                ...rawInfo,
                                message_user: String(
                                    rawInfo.message_user
                                    || data.error
                                    || (successful ? '' : `La catégorie « ${cat.label} » n’a pas pu être chargée.`),
                                ).slice(0, 300),
                            }, {successful, retainedPrevious, previous: searchInfo[key],
                                attemptedAt: new Date().toISOString()});
                        } catch (error) {
                            if (!isCurrent() || request.controller.signal.aborted) return;
                            const retainedPrevious = hasPreviousCollection(key);
                            if (!preserveExisting || !Array.isArray(results[key])) {
                                results[key] = [];
                            }
                            searchInfo[key] = window.MaplyticsSavedAnalysisState.attractivenessCollectionInfo({
                                source_status: 'error',
                                results_complete: false,
                                results_truncated: false,
                                source_label: '',
                                message_user: `La catégorie « ${cat.label} » est temporairement indisponible.`,
                            }, {successful: false, retainedPrevious, previous: searchInfo[key],
                                attemptedAt: new Date().toISOString()});
                            console.error(`Erreur attractivité ${key}:`, error);
                        }
                    });

                    await Promise.all(promises);
                    if (!isCurrent()) return false;

                    this.attractivenessResults = results;
                    this.attractivenessSearchInfo = searchInfo;
                    this.attractivenessSelectedCategories = preserveExisting
                        ? Array.from(new Set([
                            ...this.attractivenessSelectedCategories,
                            ...selectedKeys,
                        ]))
                        : [...selectedKeys];
                    this.attractivenessSource = {
                        lat: params.lat,
                        lon: params.lon,
                        radius_km: params.radiusKm || 15,
                    };
                    this.attractivenessVisible = true;
                    this.showAttractivenessResults();
                    this.syncAttractivenessVisibilityControl();
                    return results;
                } catch (e) {
                    if (!isCurrent()) return false;
                    console.error('Erreur attractivité:', e);
                    alert('Erreur lors de l\'analyse d\'attractivité.');
                } finally {
                    if (this._attractivenessRequest === request) {
                        request.restoreButton();
                        if (isCurrent() && btn?.isConnected) btn.focus({ preventScroll: true });
                        this._attractivenessRequest = null;
                    }
                }
            },

            showAttractivenessResults() {
                const mapController = toolType === 'isochrone' ? exportMapController : importMapController;
                if (!mapController || !mapController.map) return;

                if (!this.attractivenessLayer) {
                    this.attractivenessLayer = L.layerGroup().addTo(mapController.map);
                }
                this.attractivenessLayer.clearLayers();

                const categories = this.ATTRACTIVENESS_CATEGORIES;
                let totalWeightedScore = 0;
                let summaryHtml = '';
                const visualSourceCounts = { workforce_band: 0, naf_gsa: 0, neutral: 0, uniform: 0 };
                let renderedMarkerCount = 0;
                const incompleteKeys = [];

                const displayedKeys = Array.from(new Set(
                    (this.attractivenessSelectedCategories.length
                        ? this.attractivenessSelectedCategories
                        : Object.keys(this.attractivenessResults)).filter((key) => categories[key]),
                ));
                displayedKeys.forEach((key) => {
                    const cat = categories[key];
                    const received = Array.isArray(this.attractivenessResults[key]);
                    const competitors = received ? this.attractivenessResults[key] : [];
                    const count = competitors.length;
                    const searchInfo = this.attractivenessSearchInfo?.[key] || {};
                    const unavailable = ['unavailable', 'error', 'rate_limited']
                        .includes(searchInfo.source_status);
                    const incomplete = !received || unavailable || searchInfo.results_complete !== true;
                    if (incomplete) incompleteKeys.push(key);
                    const qualityLabel = unavailable ? 'Source indisponible'
                        : !received || searchInfo.results_complete == null ? 'Couverture non précisée'
                        : incomplete ? 'Résultat partiel' : count === 0 ? 'Recherche complète, aucun résultat' : '';
                    totalWeightedScore += count * cat.weight;

                    competitors.forEach(comp => {
                        if (!comp.lat || !comp.lon) return;
                        const visual = window.MaplyticsCompetitorVisualEncoding.markerStyle(
                            comp,
                            cat,
                            {
                                ...this.attractivenessVisualEncoding,
                                presentationScale: this.competitorMarkerScale,
                            },
                        );
                        visualSourceCounts[visual.sizeSource] += 1;
                        renderedMarkerCount += 1;
                        const marker = L.marker([comp.lat, comp.lon], {
                            icon: L.divIcon({
                                className: 'attract-marker',
                                html: `<div data-size-source="${visual.sizeSource}" data-visual-fingerprint="${visual.fingerprint}" style="width: ${visual.size}px; height: ${visual.size}px; border-radius: 50%; background: ${visual.color}; border: 2px solid white; box-shadow: 0 2px 4px rgba(0,0,0,0.3); display: flex; align-items: center; justify-content: center;"><span style="font-size: ${Math.max(10, Math.round(visual.size * 0.42))}px;">${cat.emoji}</span></div>`,
                                iconSize: [visual.size, visual.size], iconAnchor: [visual.size / 2, visual.size / 2]
                            })
                        });
                        const workforce = getEffectifLabel(visual.workforceCode);
                        const sizeDetail = visual.sizeSource === 'workforce_band' && workforce
                            ? `Tranche d’effectifs : ${workforce}`
                            : visual.sizeLabel;
                        marker.bindTooltip(`<b>${comp.name || cat.label}</b><br>${comp.address || ''} ${comp.city || ''}${comp.distance_km ? '<br>' + comp.distance_km + ' km' : ''}<br>${sizeDetail}`, { direction: 'top' });
                        this.attractivenessLayer.addLayer(marker);
                    });

                    summaryHtml += `<div style="display: flex; align-items: center; gap: 0.4rem; padding: 0.2rem 0;">
                        <span style="font-size: 0.9rem;">${cat.emoji}</span>
                        <span style="flex: 1; min-width: 0; font-size: 0.8rem; color: #334155;">${cat.label}${qualityLabel ? `<small class="attract-panel__category-warning">${qualityLabel}</small>` : ''}</span>
                        <span style="font-weight: 600; font-size: 0.85rem; color: ${cat.color};">${count}${searchInfo.results_truncated === true ? '+' : ''}</span>
                    </div>`;
                });

                let scoreLabel, scoreEmoji;
                if (incompleteKeys.length || !displayedKeys.length) { scoreLabel = 'Couverture à vérifier'; scoreEmoji = '⚠️'; }
                else if (totalWeightedScore <= 5) { scoreLabel = 'Faible'; scoreEmoji = '🔴'; }
                else if (totalWeightedScore <= 15) { scoreLabel = 'Moyen'; scoreEmoji = '🟡'; }
                else if (totalWeightedScore <= 30) { scoreLabel = 'Bon'; scoreEmoji = '🟢'; }
                else { scoreLabel = 'Excellent'; scoreEmoji = '🟢'; }

                const params = this.getSearchParams();
                const sizeModeLabels = {
                    automatic: 'automatique',
                    workforce: 'tranche d’effectifs SIRENE',
                    gsa_format: 'format GSA',
                    uniform: 'uniforme',
                };
                const presentationScaleLabels = {
                    normal: 'normal',
                    large: 'grand',
                    xlarge: 'très grand',
                    xxlarge: 'très grand 200 %',
                    maximum: 'maximum 250 %',
                };
                const coverageSummary = renderedMarkerCount
                    ? `effectifs ${visualSourceCounts.workforce_band}/${renderedMarkerCount} · format GSA ${visualSourceCounts.naf_gsa}/${renderedMarkerCount} · neutre ${visualSourceCounts.neutral}/${renderedMarkerCount}`
                    : 'aucun point rendu';
                const incompleteMessages = incompleteKeys.map((key) => (
                    this.escapeCompetitorText(
                        (this.attractivenessSearchInfo?.[key]?.message_user
                        || `La couverture de la catégorie « ${categories[key]?.label || key} » n’est pas confirmée.`)
                        + (this.attractivenessSearchInfo?.[key]?.retained_previous
                            ? ' Derniers résultats conservés ; leur date de collecte reste inchangée.' : ''),
                    )
                ));
                const retryableKeys = incompleteKeys.filter((key) => (
                    this.attractivenessSearchInfo?.[key]?.retry_policy !== 'change_scope'
                ));
                const completenessHtml = incompleteKeys.length
                    ? `<div class="attract-panel__warning" role="status">${incompleteMessages.join('<br>')}${retryableKeys.length ? '<button type="button" data-attractiveness-retry>Réessayer les catégories incomplètes</button>' : '<p>Modifiez le périmètre ou les catégories pour affiner la collecte.</p>'}</div>`
                    : displayedKeys.length
                        ? '<div class="attract-panel__complete">Recherche complète pour les catégories demandées.</div>'
                        : '<div role="status">Sélectionnez les catégories à rechercher.</div>';
                if (this._attractPanel) mapController.map.removeControl(this._attractPanel);
                this._attractPanel = L.control({ position: 'bottomleft' });
                this._attractPanel.onAdd = () => {
                    const div = L.DomUtil.create('div', 'attract-panel');
                    div.style.cssText = 'background: white; padding: 0.75rem; border-radius: 0.5rem; box-shadow: 0 2px 8px rgba(0,0,0,0.15); min-width: 200px; max-width: 240px;';
                    div.innerHTML = `
                        <div style="font-weight: 700; font-size: 1rem; margin-bottom: 0.5rem;">${scoreEmoji} Attractivité : ${scoreLabel}</div>
                        ${summaryHtml}
                        ${completenessHtml}
                        <div style="border-top: 1px solid #e2e8f0; margin-top: 0.4rem; padding-top: 0.4rem; font-size: 0.75rem; color: #475569;">
                            Couleur : ${this.attractivenessVisualEncoding.colorMode === 'custom' ? 'unique' : 'catégorie'} · Taille : ${sizeModeLabels[this.attractivenessVisualEncoding.sizeMode] || 'automatique'} · Agrandissement : ${presentationScaleLabels[this.competitorMarkerScale] || 'normal'}<br>
                            Couverture : ${coverageSummary}
                        </div>
                        <div style="border-top: 1px solid #e2e8f0; margin-top: 0.4rem; padding-top: 0.4rem; font-size: 0.75rem; color: #94a3b8;">
                            ${incompleteKeys.length ? 'Score disponible' : 'Score pondéré'} : ${totalWeightedScore} pts · Rayon : ${params?.radiusKm || this.attractivenessSource?.radius_km || 15} km
                        </div>`;
                    div.querySelector('[data-attractiveness-retry]')?.addEventListener('click', (event) => {
                        void this.searchAttractiveness(retryableKeys, {
                            trigger: event.currentTarget,
                            refreshCache: true,
                            preserveExisting: true,
                        });
                    });
                    window.MaplyticsLeafletControlDisclosure?.enhance?.(div, {
                        surface: toolType,
                        controlKey: 'attractiveness',
                        title: 'Attractivité',
                    });
                    L.DomEvent.disableClickPropagation(div);
                    return div;
                };
                this._attractPanel.addTo(mapController.map);
                window.dispatchEvent(new CustomEvent(
                    'maplytics:analysis-workspace-changed',
                    { detail: { toolType, source: 'attractiveness' } },
                ));
            },

            clearAttractiveness({ resetSelection = false } = {}) {
                this.cancelAttractivenessRequest();
                const mapController = toolType === 'isochrone' ? exportMapController : importMapController;
                if (this.attractivenessLayer && mapController?.map) {
                    mapController.map.removeLayer(this.attractivenessLayer);
                    this.attractivenessLayer = null;
                }
                if (this._attractPanel && mapController?.map) {
                    mapController.map.removeControl(this._attractPanel);
                    this._attractPanel = null;
                }
                this.attractivenessVisible = false;
                this.attractivenessResults = {};
                this.attractivenessSearchInfo = {};
                this.attractivenessSource = null;
                if (resetSelection) {
                    this.attractivenessSelectedCategories = [];
                    this.attractivenessVisualEncoding = window.MaplyticsCompetitorVisualEncoding
                        .normalize();
                }

                const btn = document.querySelector(`${scopeSelector} #competitorAttractBtn, ${scopeSelector} #importCompetitorAttractBtn`);
                if (btn) {
                    btn.textContent = APP_CONFIG.appShellV2 ? 'Attractivité' : '⭐ Attractivité';
                    btn.style.background = 'linear-gradient(135deg, #8b5cf6, #6366f1)';
                }
                this.syncAttractivenessVisibilityControl();
            },

            competitorExportSelectedFieldIds() {
                const surface = toolType === 'isochrone' ? 'export' : 'import';
                const fieldset = document.querySelector(
                    `${scopeSelector} [data-competitor-export-fields]`,
                ) || document.querySelector(
                    `[data-competitor-export-fields][data-competitor-export-surface="${surface}"]`,
                );
                if (!fieldset) return null;
                return Array.from(fieldset.querySelectorAll(
                    'input[data-competitor-export-field]:checked',
                )).map((input) => input.value);
            },

            competitorPointInRing(lon, lat, ring) {
                if (!Array.isArray(ring) || ring.length < 4) return false;
                let inside = false;
                for (let index = 0, previous = ring.length - 1; index < ring.length; previous = index, index += 1) {
                    const currentPoint = ring[index];
                    const previousPoint = ring[previous];
                    const currentLon = Number(currentPoint?.[0]);
                    const currentLat = Number(currentPoint?.[1]);
                    const previousLon = Number(previousPoint?.[0]);
                    const previousLat = Number(previousPoint?.[1]);
                    if (![currentLon, currentLat, previousLon, previousLat].every(Number.isFinite)) continue;
                    const intersects = ((currentLat > lat) !== (previousLat > lat))
                        && (lon < ((previousLon - currentLon) * (lat - currentLat))
                            / ((previousLat - currentLat) || Number.EPSILON) + currentLon);
                    if (intersects) inside = !inside;
                }
                return inside;
            },

            competitorPointInGeometry(lon, lat, geometry) {
                if (!geometry || !Number.isFinite(lon) || !Number.isFinite(lat)) return false;
                const polygonContains = (rings) => (
                    Array.isArray(rings)
                    && this.competitorPointInRing(lon, lat, rings[0])
                    && !rings.slice(1).some((ring) => this.competitorPointInRing(lon, lat, ring))
                );
                if (geometry.type === 'Polygon') return polygonContains(geometry.coordinates);
                if (geometry.type === 'MultiPolygon') {
                    return (geometry.coordinates || []).some(polygonContains);
                }
                return false;
            },

            competitorZoneMembership(competitor) {
                const definitions = this.competitorScopeDefinitions()
                    .filter((definition) => definition.type === 'zdc');
                const lat = Number(competitor?.lat ?? competitor?.latitude);
                const lon = Number(
                    competitor?.lon ?? competitor?.lng ?? competitor?.longitude,
                );
                const memberships = [];
                if (Number.isFinite(lat) && Number.isFinite(lon)) {
                    definitions.forEach((definition) => {
                        const inside = (definition.geometry?.features || []).some((feature) => (
                            this.competitorPointInGeometry(lon, lat, feature?.geometry)
                        ));
                        if (inside) memberships.push(
                            String(definition.label || '').replace(/^ZDC\s*·\s*/i, '').trim(),
                        );
                    });
                }
                const existing = competitor?.zone_memberships || competitor?.zdc_memberships;
                (Array.isArray(existing) ? existing : []).forEach((item) => {
                    const label = String(
                        item?.label || item?.name || item?.zone_name || item || '',
                    ).trim();
                    if (label && !memberships.includes(label)) memberships.push(label);
                });
                const activeScope = this._activeCompetitorSearchScope?.searchScope
                    || this.competitorSearchSnapshot?.query?.scope?.searchScope
                    || {};
                const nearbyDistanceKm = Number(
                    competitor?.buffer_km ?? activeScope.buffer_km,
                );
                let relation = '';
                if (memberships.length) relation = 'Dans ZDC';
                else if (competitor?.spatial_relation === 'nearby') {
                    relation = Number.isFinite(nearbyDistanceKm) && nearbyDistanceKm > 0
                        ? `À proximité (${nearbyDistanceKm} km)`
                        : 'À proximité';
                } else if (definitions.length) relation = 'Hors ZDC';
                return {
                    memberships,
                    relation,
                    nearbyDistanceKm: relation.startsWith('À proximité')
                        ? nearbyDistanceKm
                        : null,
                };
            },

            competitorDataExportSnapshot() {
                const dataExporter = window.MaplyticsCompetitorDataExport;
                if (!dataExporter?.buildSnapshot) {
                    throw new Error('Le module d’export des données concurrence est indisponible.');
                }
                const scoreView = this.getCompetitorView();
                const view = this.getCompetitorExportView();
                const activeScore = window.MaplyticsCompetitorThreatScore.normalizeResult(
                    this.competitorThreatScore,
                    scoreView,
                );
                const scoreHeaders = activeScore && view.competitors.length
                    ? window.MaplyticsCompetitorThreatScore.csvContract(
                        activeScore,
                        this.competitorIdentity(view.competitors[0]),
                    ).headers
                    : [];
                const snapshotMetadata = this.competitorSnapshotMetadata();
                return dataExporter.buildSnapshot({
                    view,
                    markerColor: this.competitorMarkerColor,
                    sourceFallback: snapshotMetadata.source,
                    effectifLabel: getEffectifLabel,
                    companyAge: getCompanyAge,
                    roadMeasure: (value) => this.competitorRoadMeasure(value),
                    routeOriginState: (origin) => this.competitorRouteOriginState(origin),
                    routingFreshnessText: (routing) => this.competitorRoutingFreshnessText(routing),
                    routingFailureText: (routing) => this.competitorRoutingFailureText(routing),
                    selectedFieldIds: this.competitorExportSelectedFieldIds(),
                    zoneMembership: (competitor) => this.competitorZoneMembership(competitor),
                    scoreHeaders,
                    scoreCells: (competitor) => (
                        activeScore
                        ? window.MaplyticsCompetitorThreatScore.csvContract(
                            activeScore,
                            this.competitorIdentity(competitor),
                        ).cells
                        : []
                    ),
                });
            },

            // Exporter en CSV depuis le snapshot filtré canonique.
            exportToCSV() {
                if (!window.maplyticsHasFeature?.('competitor_export')) {
                    showPremiumNotice(
                        'l’export de concurrents',
                        'L’export de concurrents est inclus à partir du plan Starter.',
                    );
                    return false;
                }
                const snapshot = this.competitorDataExportSnapshot();
                if (!snapshot.rows.length) {
                    alert('Aucun concurrent à exporter (vérifiez vos filtres).');
                    return false;
                }
                const csvContent = window.MaplyticsCompetitorDataExport.csvText(snapshot);
                const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = `concurrents_${new Date().toISOString().split('T')[0]}.csv`;
                link.click();
                URL.revokeObjectURL(url);
                return snapshot;
            },

            // Réutiliser l'export XLSX serveur canonique et formule-safe.
            async exportToXLSX() {
                if (!window.maplyticsHasFeature?.('competitor_export')) {
                    showPremiumNotice(
                        'l’export de concurrents',
                        'L’export de concurrents est inclus à partir du plan Starter.',
                    );
                    return false;
                }
                const snapshot = this.competitorDataExportSnapshot();
                if (!snapshot.rows.length) {
                    alert('Aucun concurrent à exporter (vérifiez vos filtres).');
                    return false;
                }
                if (!window.MaplyticsExportClient?.run) {
                    throw new Error('Le téléchargement XLSX est indisponible.');
                }
                return await window.MaplyticsExportClient.run('xlsx', snapshot.rows) || false;
            },

            // Sauvegarder les concurrents + points personnalisés
            async saveCompetitors({ quiet = false } = {}) {
                if (!connectedUserToken) {
                    this.setCompetitorSaveStatus('error', 'Échec · connexion requise');
                    return false;
                }
                const saveOwnerToken = connectedUserToken;
                if (this._competitorPersistenceBlocked) {
                    this.setCompetitorSaveStatus('conflict', 'Sauvegarde suspendue · réessayez');
                    return false;
                }
                if (this._competitorRestorePending) {
                    this.setCompetitorSaveStatus('conflict', 'Chargement en cours · réessayez');
                    return false;
                }
                const activeProjectId = String(this._competitorActiveProjectId || '');
                const persistenceTarget = this.competitorPersistenceTarget(activeProjectId);
                if (this.isCompetitorTargetStale(persistenceTarget)) {
                    this.competitorFilterBuilder?.setStatus?.(
                        'Sauvegarde refusée : une version plus récente existe dans un autre onglet. Actualisez la page.',
                        'error',
                    );
                    this.setCompetitorSaveStatus('conflict', 'Conflit · actualiser');
                    return false;
                }
                clearTimeout(this._competitorSnapshotSaveTimer);
                this._competitorSnapshotSaveTimer = null;
                const revision = ++this._competitorSaveSequence;
                const stateGeneration = this._competitorStateGeneration;
                const snapshotDate = new Date().toISOString();
                const competitorPayload = this.competitorStatePayload({ snapshotDate });
                this.setCompetitorSaveStatus(
                    'saving',
                    'Sauvegarde…',
                    { revision },
                );

                const execute = async () => {
                    if (
                        stateGeneration !== this._competitorStateGeneration
                        || saveOwnerToken !== connectedUserToken
                        || this.isCompetitorTargetStale(persistenceTarget)
                    ) return false;
                    try {
                    let response;
                    if (activeProjectId) {
                        response = await fetch(`/api/projects/save/${activeProjectId}`, {
                            method: 'PUT',
                            headers: { 'Content-Type': 'application/json' },
                            credentials: 'include',
                            body: JSON.stringify({ competitor_data: [competitorPayload] })
                        });
                    } else {
                        // Fallback: ancien endpoint pour compatibilité
                        response = await fetch('/api/competitors/save', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            credentials: 'include',
                            body: JSON.stringify({
                                tool_type: toolType,
                                competitors_data: [competitorPayload]
                            })
                        });
                    }
                    const result = await response.json();
                    if (stateGeneration !== this._competitorStateGeneration
                        || saveOwnerToken !== connectedUserToken) return false;
                    if (result.success) {
                        if (
                            stateGeneration !== this._competitorStateGeneration
                            || this.isCompetitorTargetStale(persistenceTarget)
                        ) return false;
                        if (
                            revision === this._competitorSaveSequence
                        ) {
                            this._competitorViewSnapshotDate = snapshotDate;
                            this.broadcastCompetitorSnapshot(snapshotDate, persistenceTarget);
                            this.setCompetitorSaveStatus(
                                'saved',
                                `Sauvegardé · ${new Date(snapshotDate).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}`,
                                { revision, savedAt: snapshotDate },
                            );
                            this.updateCompetitorSnapshotMetadata();
                        }
                        return true;
                    }
                    if (result.limit_reached && !quiet) {
                        alert(result.message || result.error);
                    }
                    console.warn('Erreur sauvegarde:', result.error);
                    this.setCompetitorSaveStatus(
                        'error',
                        `Échec · ${String(result.error || 'sauvegarde refusée')}`,
                        { revision },
                    );
                    return false;
                    } catch (error) {
                        if (stateGeneration !== this._competitorStateGeneration
                            || saveOwnerToken !== connectedUserToken) return false;
                        console.error('Erreur sauvegarde concurrents:', error);
                        this.setCompetitorSaveStatus(
                            'error',
                            `Échec · ${String(error?.message || 'réseau indisponible')}`,
                            { revision },
                        );
                        return false;
                    }
                };
                const operation = this._competitorSaveTail
                    .catch(() => false)
                    .then(execute);
                this._competitorSaveTail = operation.catch(() => false);
                return operation;
            },

            // Charger les concurrents + points personnalisés (backward-compatible)
            async loadCompetitors({ automatic = false } = {}) {
                if (!connectedUserToken) return false;
                const restoreOwnerToken = connectedUserToken;
                if (this._competitorPersistenceBlocked) {
                    this.setCompetitorSaveStatus('conflict', 'Opération en cours · réessayez');
                    return false;
                }
                if (
                    automatic
                    && toolType === 'isochrone'
                    && isHomeWorkspaceReset()
                ) return false;
                if (
                    automatic
                    && toolType === 'isochrone'
                    && isHomeWorkspaceScopePayloadReset('competitors')
                ) return false;
                // Automatic bootstrap restore is a fallback only.  If another
                // authority already populated or edited the workspace, preserve
                // that newer state instead of issuing a request able to overwrite
                // it later.
                if (automatic && this._competitorStateGeneration > 0) return false;
                const restoreOpenSequence = historyManager?.openIntentSequence || 0;
                const resetGeneration = toolType === 'isochrone'
                    ? homeWorkspaceScopeResetGeneration('competitors')
                    : 0;
                if (automatic && restoreOpenSequence > 0) return false;
                this._competitorRestoreAbortController?.abort?.();
                const restoreAbortController = typeof AbortController === 'function'
                    ? new AbortController()
                    : null;
                this._competitorRestoreAbortController = restoreAbortController;
                const restoreRequest = ++this._competitorRestoreSequence;
                const persistenceTarget = this.competitorPersistenceTarget('');
                const staleRevisionAtStart = this.competitorTargetStaleRevision(persistenceTarget);
                this._competitorRestorePending = restoreRequest;
                this._competitorRestoreTarget = persistenceTarget;
                this._competitorRestoreTargetSequence = restoreRequest;
                this._competitorStateGeneration += 1;
                const restoreStateGeneration = this._competitorStateGeneration;
                this._competitorSaveSequence += 1;
                this.setCompetitorSaveStatus('saving', 'Chargement…');
                const restoreRead = homeNavigationReads.begin();
                try {
                    await this._competitorSaveTail.catch(() => false);
                    if (!await restoreRead.canApply()) return false;
                    if (restoreRequest !== this._competitorRestoreSequence
                        || restoreOwnerToken !== connectedUserToken) return false;
                    const requestOptions = {
                        method: 'GET',
                        credentials: 'include',
                    };
                    if (restoreAbortController) {
                        requestOptions.signal = restoreAbortController.signal;
                    }
                    const response = await fetch(
                        `/api/competitors/load?tool_type=${toolType}`,
                        requestOptions,
                    );
                    const result = await response.json();
                    if (!await restoreRead.canApply()) return false;
                    if (
                        restoreRequest !== this._competitorRestoreSequence
                        || restoreOwnerToken !== connectedUserToken
                        || restoreStateGeneration !== this._competitorStateGeneration
                        || (
                        automatic
                        && (
                            (historyManager?.openIntentSequence || 0) !== restoreOpenSequence
                            || (
                                toolType === 'isochrone'
                                && resetGeneration !== homeWorkspaceScopeResetGeneration('competitors')
                            )
                        )
                        )
                    ) {
                        return false;
                    }
                    if (
                        this.competitorTargetStaleRevision(persistenceTarget)
                        !== staleRevisionAtStart
                    ) {
                        this.setCompetitorSaveStatus('conflict', 'Conflit · actualiser');
                        return false;
                    }

                    if (result.success && result.competitors_data) {
                        let data = this.unwrapCompetitorState(result.competitors_data);
                        if (
                            automatic
                            && toolType === 'isochrone'
                            && isHomeWorkspaceScopeReset('competitors')
                        ) {
                            data = Array.isArray(data)
                                ? []
                                : {
                                    ...(data && typeof data === 'object' ? data : {}),
                                    competitors: [],
                                    competitorView: null,
                                    competitorSearchSnapshot: null,
                                    hiddenCompetitorIds: [],
                                    removedItems: [],
                                    competitorsNumbered: false,
                                    visibleOnMap: false,
                                    pointsLegendVisible: Boolean(data?.pointsLegendVisible),
                                };
                        }
                        const restored = this.restoreCompetitorStatePayload(data, {
                            restoreBuilder: true,
                            allowTerritoryRebind: !automatic,
                        });
                        if (restored) {
                            this.clearCompetitorTargetStale(
                                persistenceTarget,
                                staleRevisionAtStart,
                            );
                        }
                        return restored;
                    }
                    if (restoreRequest === this._competitorRestoreSequence) {
                        this.setCompetitorSaveStatus(
                            'error',
                            `Échec · ${String(result.error || 'chargement refusé')}`,
                        );
                    }
                    return false;
                } catch (error) {
                    if (restoreAbortController?.signal?.aborted) return false;
                    if (!await restoreRead.canApply()) return false;
                    if (restoreRequest !== this._competitorRestoreSequence
                        || restoreOwnerToken !== connectedUserToken) return false;
                    console.error('Erreur chargement concurrents:', error);
                    if (restoreRequest === this._competitorRestoreSequence) {
                        this.setCompetitorSaveStatus(
                            'error',
                            `Échec · ${String(error?.message || 'chargement indisponible')}`,
                        );
                    }
                    return false;
                } finally {
                    restoreRead.end();
                    if (this._competitorRestoreAbortController === restoreAbortController) {
                        this._competitorRestoreAbortController = null;
                    }
                    if (this._competitorRestorePending === restoreRequest) {
                        this._competitorRestorePending = 0;
                    }
                    if (this._competitorRestoreTargetSequence === restoreRequest) {
                        this._competitorRestoreTarget = '';
                        this._competitorRestoreTargetSequence = 0;
                    }
                }
            },

            // ===== GESTION PROJETS =====

            async loadProjectList() {
                if (!connectedUserToken) return;
                try {
                    const response = await fetch(`/api/projects/list?tool_type=${toolType}`, {
                        credentials: 'include'
                    });
                    const result = await response.json();
                    const select = document.querySelector(`${scopeSelector} .competitor-project-select`);
                    if (!select) return;
                    const currentVal = String(this._competitorActiveProjectId || '');
                    select.innerHTML = '<option value="">-- Nouveau projet --</option>';
                    if (result.success && result.projects) {
                        result.projects.forEach(p => {
                            const opt = document.createElement('option');
                            opt.value = p.id;
                            opt.textContent = p.project_name + (p.is_active ? ' ✓' : '');
                            select.appendChild(opt);
                        });
                        // Conserver uniquement un choix explicite. Le bootstrap charge
                        // l'etat generique ; selectionner ici un projet "actif" ferait
                        // pointer la prochaine sauvegarde vers un etat qui n'a pas ete
                        // restaure.
                        if (currentVal) {
                            select.value = currentVal;
                        }
                        select._previousValue = select.value;
                    }
                } catch (e) {
                    console.error('Erreur chargement projets:', e);
                }
            },

            async createProject(name) {
                if (!connectedUserToken || !name) return false;
                if (this._competitorRestorePending || this._competitorPersistenceBlocked) {
                    this.setCompetitorSaveStatus('conflict', 'Chargement en cours · réessayez');
                    return false;
                }
                this._competitorPersistenceBlocked = true;
                const creationRevision = ++this._competitorSaveSequence;
                const stateGeneration = this._competitorStateGeneration;
                this.setCompetitorSaveStatus('saving', 'Création du projet…');
                try {
                    await this._competitorSaveTail.catch(() => false);
                    if (
                        stateGeneration !== this._competitorStateGeneration
                        || this._competitorRestorePending
                    ) {
                        this.setCompetitorSaveStatus('conflict', 'État modifié · réessayez');
                        return false;
                    }
                    const snapshotDate = new Date().toISOString();
                    const competitorPayload = this.competitorStatePayload({ snapshotDate });
                    const response = await fetch('/api/projects/create', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        credentials: 'include',
                        body: JSON.stringify({
                            project_name: name,
                            tool_type: toolType,
                            competitor_data: [competitorPayload]
                        })
                    });
                    const result = await response.json();
                    if (
                        stateGeneration !== this._competitorStateGeneration
                        || creationRevision !== this._competitorSaveSequence
                    ) return false;
                    if (result.success) {
                        this._competitorActiveProjectId = String(result.project_id || '');
                        this._competitorViewSnapshotDate = snapshotDate;
                        await this.loadProjectList();
                        this.broadcastCompetitorSnapshot(
                            snapshotDate,
                            this.competitorPersistenceTarget(this._competitorActiveProjectId),
                        );
                        this.setCompetitorSaveStatus(
                            'saved',
                            '✓ Projet créé',
                            { savedAt: snapshotDate },
                        );
                        this.updateCompetitorSnapshotMetadata();
                        return true;
                    } else if (result.limit_reached) {
                        this.setCompetitorSaveStatus(
                            'error',
                            `Échec · ${String(result.message || result.error || 'limite atteinte')}`,
                        );
                        alert(result.message || result.error);
                        return false;
                    } else {
                        this.setCompetitorSaveStatus(
                            'error',
                            `Échec · ${String(result.error || 'création du projet impossible')}`,
                        );
                        alert(result.error || 'Erreur lors de la création');
                        return false;
                    }
                } catch (e) {
                    console.error('Erreur création projet:', e);
                    this.setCompetitorSaveStatus(
                        'error',
                        `Échec · ${String(e?.message || 'création du projet impossible')}`,
                    );
                    return false;
                } finally {
                    this._competitorPersistenceBlocked = false;
                }
            },

            async loadProject(projectId) {
                if (!connectedUserToken || !projectId) return false;
                if (this._competitorPersistenceBlocked) {
                    this.setCompetitorSaveStatus('conflict', 'Opération en cours · réessayez');
                    return false;
                }
                const restoreRequest = ++this._competitorRestoreSequence;
                const persistenceTarget = this.competitorPersistenceTarget(projectId);
                const staleRevisionAtStart = this.competitorTargetStaleRevision(persistenceTarget);
                this._competitorRestorePending = restoreRequest;
                this._competitorRestoreTarget = persistenceTarget;
                this._competitorRestoreTargetSequence = restoreRequest;
                this._competitorStateGeneration += 1;
                this._competitorSaveSequence += 1;
                this.setCompetitorSaveStatus('saving', 'Chargement…');
                try {
                    await this._competitorSaveTail.catch(() => false);
                    if (restoreRequest !== this._competitorRestoreSequence) return false;
                    const response = await fetch(`/api/projects/load/${projectId}`, {
                        credentials: 'include'
                    });
                    const result = await response.json();
                    if (restoreRequest !== this._competitorRestoreSequence) return false;
                    if (
                        this.competitorTargetStaleRevision(persistenceTarget)
                        !== staleRevisionAtStart
                    ) {
                        this.setCompetitorSaveStatus('conflict', 'Conflit · actualiser');
                        return false;
                    }
                    if (result.success && result.project) {
                        const restored = this.restoreCompetitorStatePayload(
                            this.unwrapCompetitorState(result.project.competitor_data),
                            { restoreBuilder: true, emptyIsSaved: true },
                        );
                        const appliedGeneration = this._competitorStateGeneration;
                        if (restored) {
                            this.clearCompetitorTargetStale(
                                persistenceTarget,
                                staleRevisionAtStart,
                            );
                        }
                        if (!restored) return false;
                        this._competitorActiveProjectId = String(projectId);
                        await this.loadProjectList();
                        const applied = this._competitorStateGeneration === appliedGeneration;
                        if (applied && toolType === 'isochrone') {
                            clearHomeWorkspaceReset('isochrone');
                        }
                        return applied;
                    }
                    if (restoreRequest === this._competitorRestoreSequence) {
                        this.setCompetitorSaveStatus(
                            'error',
                            `Échec · ${String(result.error || 'projet indisponible')}`,
                        );
                    }
                    return false;
                } catch (e) {
                    console.error('Erreur chargement projet:', e);
                    if (restoreRequest === this._competitorRestoreSequence) {
                        this.setCompetitorSaveStatus(
                            'error',
                            `Échec · ${String(e?.message || 'projet indisponible')}`,
                        );
                    }
                    return false;
                } finally {
                    if (this._competitorRestorePending === restoreRequest) {
                        this._competitorRestorePending = 0;
                    }
                    if (this._competitorRestoreTargetSequence === restoreRequest) {
                        this._competitorRestoreTarget = '';
                        this._competitorRestoreTargetSequence = 0;
                    }
                }
            },

            async deleteProject(projectId) {
                if (!connectedUserToken || !projectId) return;
                const persistenceTarget = this.competitorPersistenceTarget(projectId);
                this._competitorPersistenceBlocked = true;
                this._competitorStateGeneration += 1;
                this._competitorSaveSequence += 1;
                try {
                    await this._competitorSaveTail.catch(() => false);
                    const response = await fetch(`/api/projects/delete/${projectId}`, {
                        method: 'DELETE',
                        credentials: 'include'
                    });
                    const result = await response.json();
                    if (result.success) {
                        this.restoreCompetitorStatePayload([]);
                        this.broadcastCompetitorSnapshot('', persistenceTarget);
                        this.setCompetitorSaveStatus('idle', 'Non sauvegardé');
                        await this.loadProjectList();
                    }
                } catch (e) {
                    console.error('Erreur suppression projet:', e);
                } finally {
                    this._competitorPersistenceBlocked = false;
                }
            },

            showNewProjectPrompt() {
                const name = prompt('Nom du nouveau projet :');
                if (name && name.trim()) {
                    this.createProject(name.trim());
                }
            },

            // ===== POINTS PERSONNALISÉS =====

            // Ajouter un point personnalisé depuis une adresse (géocodage serveur)
            async addCustomPointFromAddress(address) {
                const workspaceRequestGeneration = this._workspaceRequestGeneration;
                try {
                    const response = await fetch('/api/competitors/geocode', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        credentials: 'include',
                        body: JSON.stringify({ address })
                    });
                    const result = await response.json();
                    if (workspaceRequestGeneration !== this._workspaceRequestGeneration) return false;
                    if (!result.success) {
                        alert(result.error || 'Adresse introuvable.');
                        return;
                    }
                    this.addCustomPoint({
                        name: address,
                        lat: result.lat,
                        lon: result.lon,
                        color: '#2563eb',
                        icon: 'pin',
                        folder: 'default',
                        visible: true,
                        source: 'address'
                    });
                } catch (e) {
                    if (workspaceRequestGeneration !== this._workspaceRequestGeneration) return false;
                    console.error('Erreur géocodage:', e);
                    alert('Erreur lors du géocodage.');
                }
            },

            // Ajouter un point GPS direct
            addCustomPointFromGps(lat, lon, name) {
                this.addCustomPoint({
                    name: name || `Point ${lat.toFixed(4)}, ${lon.toFixed(4)}`,
                    lat, lon,
                    color: '#10b981',
                    icon: 'pin',
                    folder: 'default',
                    visible: true,
                    source: 'gps'
                });
            },

            addCustomPoint(point) {
                this.networkPointsStatePayload();
                const candidate = {
                    id: `cpt_${Date.now()}_${Math.random().toString(36).substr(2, 6)}`,
                    created_at: new Date().toISOString(),
                    ...point,
                    display_reference: this.networkNextDisplayReference++,
                    source_row_number: Number.isSafeInteger(Number(point?.source_row_number))
                        && Number(point.source_row_number) > 0
                        ? Number(point.source_row_number)
                        : null,
                };
                const removedPointIds = new Set(
                    this.competitorWorkspaceController.snapshot().removed.custom_point_ids,
                );
                if (removedPointIds.has(String(candidate.id || ''))) return false;
                this.customPoints.push(candidate);
                this.touchNetworkPoints('point-added');
                this.renderCustomPointsList();
                this.updateCustomPointsOnMap();
                if (this.pointsLegendVisible) this.updatePointsLegend();
                this.saveCompetitors();
                return true;
            },

            convertCompetitorToPoint(comp) {
                const notes = [comp.siret ? 'SIRET: ' + comp.siret : '', comp.naf_code ? 'NAF: ' + comp.naf_code : '', comp.naf_libelle || ''].filter(Boolean).join(' | ');
                this.addCustomPoint({
                    name: comp.name || 'Concurrent',
                    lat: comp.lat,
                    lon: comp.lon,
                    color: '#ef4444',
                    icon: 'office',
                    folder: 'default',
                    visible: true,
                    notes: notes
                });
            },

            removeCustomPoint(id) {
                const point = this.customPoints.find((item) => item.id === id);
                if (!point) return false;
                const folderName = this.pointFolders.find(
                    (folder) => folder.id === point.folder,
                )?.name;
                this.dispatchCompetitorWorkspace({
                    type: 'removed/add',
                    items: [{
                        kind: 'custom_point',
                        identity: String(point.id || ''),
                        label: point.name || 'Point retiré',
                        secondaryLabel: folderName
                            ? `Dossier ${folderName}`
                            : 'Point personnalisé',
                        removedAt: new Date().toISOString(),
                    }],
                });
                this.customPoints = this.customPoints.filter(p => p.id !== id);
                this.selectedPointIds.delete(id);
                this.touchNetworkPoints('point-removed');
                this.renderCustomPointsList();
                this.updateCustomPointsOnMap();
                if (this.pointsLegendVisible) this.updatePointsLegend();
                this.saveCompetitors();
                return true;
            },

            updateCustomPoint(id, updates) {
                const idx = this.customPoints.findIndex(p => p.id === id);
                if (idx >= 0) {
                    Object.assign(this.customPoints[idx], updates);
                    this.touchNetworkPoints('point-updated');
                    this.renderCustomPointsList();
                    this.updateCustomPointsOnMap();
                    this.saveCompetitors();
                }
            },

            renderCustomPointsList(targetContainer) {
                const listEl = targetContainer || document.querySelector(`${scopeSelector} .custom-points-list`);
                const countEl = document.querySelector(`${scopeSelector} .custom-points-count`);
                if (!listEl) return;
                if (countEl) countEl.textContent = this.customPoints.length;

                if (this.customPoints.length === 0 && this.pointFolders.length <= 1) {
                    listEl.innerHTML = '<p style="margin: 0; text-align: center; color: #64748b; font-size: 0.85rem; padding: 0.5rem; font-style: italic;">Aucun point. Utilisez 📍 dans Adresse ou GPS pour ajouter des points.</p>';
                    return;
                }

                // Grouper par dossier
                const grouped = {};
                this.customPoints.forEach(p => {
                    const fid = p.folder || 'default';
                    if (!grouped[fid]) grouped[fid] = [];
                    grouped[fid].push(p);
                });

                let html = '';
                // Toolbar bulk si mode sélection actif
                if (this.selectMode) {
                    const hasSel = this.selectedPointIds.size > 0;
                    const disabledStyle = hasSel ? '' : ' opacity: 0.4; pointer-events: none;';
                    html += `<div class="bulk-toolbar" style="position: sticky; top: 0; z-index: 10; background: #f0f4ff; border: 1px solid #bfdbfe; border-radius: 0.375rem; padding: 0.4rem 0.5rem; margin-bottom: 0.5rem; display: flex; gap: 0.35rem; align-items: center; flex-wrap: wrap;">
                        <button class="bulk-select-all ghost-btn" style="font-size: 0.7rem; padding: 0.2rem 0.4rem; font-weight: 600;">☑ Tout</button>
                        <span style="font-size: 0.75rem; font-weight: 600; color: #1e40af;">${this.selectedPointIds.size} sélectionné(s)</span>
                        <button class="bulk-color ghost-btn" style="font-size: 0.7rem; padding: 0.2rem 0.4rem;${disabledStyle}">🎨 Couleur</button>
                        <button class="bulk-icon ghost-btn" style="font-size: 0.7rem; padding: 0.2rem 0.4rem;${disabledStyle}">😀 Icône</button>
                        <button class="bulk-folder ghost-btn" style="font-size: 0.7rem; padding: 0.2rem 0.4rem;${disabledStyle}">📁 Dossier</button>
                        <button class="bulk-visibility ghost-btn" style="font-size: 0.7rem; padding: 0.2rem 0.4rem;${disabledStyle}">👁️ Visibilité</button>
                        <button class="bulk-delete ghost-btn" style="font-size: 0.7rem; padding: 0.2rem 0.4rem; color: #dc2626;${disabledStyle}">🗑️ Supprimer</button>
                    </div>`;
                }
                let renderedPointCount = 0;
                let deferredPointCount = 0;
                // Rendu récursif des dossiers
                const renderFolder = (folderId, depth) => {
                    const folder = this.pointFolders.find(f => f.id === folderId) || { id: folderId, name: folderId, color: '#6b7280' };
                    const points = grouped[folderId] || [];
                    const childFolders = this.pointFolders.filter(f => f.parentId === folderId);

                    const indent = depth * 12;
                    html += `<div class="folder-drop-target" data-folder-id="${folderId}" style="margin-left: ${indent}px; margin-bottom: 0.25rem;">`;
                    if (folderId !== 'default' || this.pointFolders.length > 1) {
                        const allVisible = points.every(p => p.visible !== false);
                        const folderSelectAll = this.selectMode ? `<input type="checkbox" class="folder-select-all" data-folder="${folderId}" style="margin: 0; cursor: pointer;" title="Tout sélectionner dans ce dossier" ${points.every(p => this.selectedPointIds.has(p.id)) && points.length > 0 ? 'checked' : ''}>` : '';
                        html += `<div style="display: flex; align-items: center; gap: 0.25rem; padding: 0.25rem 0;">
                            ${folderSelectAll}
                            <span style="font-size: 0.8rem;">📁</span>
                            <span style="font-weight: 600; font-size: 0.8rem; color: ${folder.color};">${folder.name}</span>
                            <span style="font-size: 0.75rem; color: #94a3b8;">(${points.length})</span>
                            <span style="margin-left: auto; display: flex; gap: 0.25rem;">
                                <button class="custom-folder-toggle" data-folder="${folderId}" style="background: none; border: none; cursor: pointer; font-size: 0.7rem; color: #94a3b8;" title="Visibilité du dossier">${allVisible ? '👁️' : '🙈'}</button>
                                ${folderId !== 'default' ? `<button class="custom-folder-remove" data-folder="${folderId}" style="background: none; border: none; cursor: pointer; font-size: 0.7rem; color: #94a3b8;" title="Supprimer dossier">🗑️</button>` : ''}
                            </span>
                        </div>`;
                    }

                    points.forEach(p => {
                        if (renderedPointCount >= this.networkVisiblePointLimit) {
                            deferredPointCount += 1;
                            return;
                        }
                        renderedPointCount += 1;
                        const displayReference = Number(p.display_reference) || 0;
                        const iconInfo = this.POINT_ICONS[p.icon] || this.POINT_ICONS['pin'];
                        const isNumbered = p.icon === 'number';
                        const pointImage = p.image_url || p.imageUrl || '';
                        const displayEmoji = window.MaplyticsNetworkPointsState.isLocalImage(pointImage)
                            ? `<img src="${pointImage}" alt="" width="18" height="18" style="object-fit: contain; border-radius: 3px;">`
                            : isNumbered
                            ? `<span style="display: inline-flex; align-items: center; justify-content: center; width: 16px; height: 16px; border-radius: 50%; background: ${p.color || '#2563eb'}; color: white; font-size: 0.6rem; font-weight: 700;">${displayReference}</span>`
                            : `<span style="font-size: 0.75rem;">${iconInfo.emoji}</span>`;
                        const isSelected = this.selectedPointIds.has(p.id);
                        const selectCheckbox = this.selectMode ? `<input type="checkbox" class="point-select-cb" data-id="${p.id}" ${isSelected ? 'checked' : ''} style="margin: 0; cursor: pointer;">` : '';
                        const actionBtns = this.selectMode ? '' : `
                            <button class="custom-point-toggle" data-id="${p.id}" style="background: none; border: none; cursor: pointer; font-size: 0.8rem; padding: 0;" title="Visibilité">${p.visible !== false ? '👁️' : '🙈'}</button>
                            <button class="custom-point-edit" data-id="${p.id}" style="background: none; border: none; cursor: pointer; font-size: 0.8rem; padding: 0;" title="Modifier">✏️</button>
                            <button class="custom-point-remove" data-id="${p.id}" style="background: none; border: none; cursor: pointer; font-size: 0.8rem; padding: 0; color: #dc2626;" title="Supprimer">×</button>`;
                        html += `<div class="custom-point-item point-item" data-id="${p.id}" draggable="true" style="padding: 0.4rem; border-bottom: 1px solid #f1f5f9; display: flex; align-items: center; gap: 0.4rem;${isSelected ? ' background: #eff6ff;' : ''}">
                            ${selectCheckbox}
                            ${isNumbered ? '' : `<div style="width: 10px; height: 10px; border-radius: 50%; background: ${p.color || '#2563eb'}; flex-shrink: 0;"></div>`}
                            ${displayEmoji}
                            <div style="flex: 1; min-width: 0;">
                                <div style="font-size: 0.8rem; font-weight: 500; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;" title="${p.name || ''}">${p.name || 'Sans nom'}</div>
                                <div style="font-size: 0.7rem; color: #94a3b8;">${p.lat?.toFixed(4)}, ${p.lon?.toFixed(4)}${(() => { const sp = this.getSearchParams(); if (sp && p.lat && p.lon) { const d = this.haversineDistance(sp.lat, sp.lon, p.lat, p.lon); return ' · ' + (d < 1 ? (d*1000).toFixed(0) + ' m' : d.toFixed(1) + ' km'); } return ''; })()}</div>
                            </div>
                            ${actionBtns}
                        </div>`;
                    });

                    childFolders.forEach(cf => renderFolder(cf.id, depth + 1));
                    html += '</div>';
                };

                // Rendre les dossiers racine
                const rootFolders = this.pointFolders.filter(f => !f.parentId);
                rootFolders.forEach(f => renderFolder(f.id, 0));
                // Points sans dossier valide
                const validIds = new Set(this.pointFolders.map(f => f.id));
                const orphans = this.customPoints.filter(p => !validIds.has(p.folder || 'default'));
                if (orphans.length > 0) {
                    grouped['_orphans'] = orphans;
                    renderFolder('_orphans', 0);
                }

                if (deferredPointCount > 0) {
                    html += `<button type="button" class="ui-btn ui-btn-secondary network-points-show-more" data-network-points-show-more>Afficher ${Math.min(200, deferredPointCount)} point(s) de plus</button>`;
                }

                listEl.innerHTML = html;

                listEl.querySelector('[data-network-points-show-more]')?.addEventListener('click', () => {
                    this.networkVisiblePointLimit = Math.min(
                        this.customPoints.length,
                        this.networkVisiblePointLimit + 200,
                    );
                    this.renderCustomPointsList();
                });

                // Event listeners
                listEl.querySelectorAll('.custom-point-remove').forEach(btn => {
                    btn.addEventListener('click', () => this.removeCustomPoint(btn.dataset.id));
                });
                listEl.querySelectorAll('.custom-point-toggle').forEach(btn => {
                    btn.addEventListener('click', () => {
                        const pt = this.customPoints.find(p => p.id === btn.dataset.id);
                        if (pt) this.updateCustomPoint(btn.dataset.id, { visible: pt.visible === false });
                    });
                });
                listEl.querySelectorAll('.custom-point-edit').forEach(btn => {
                    btn.addEventListener('click', () => this.showEditPointModal(btn.dataset.id));
                });
                listEl.querySelectorAll('.custom-folder-remove').forEach(btn => {
                    btn.addEventListener('click', () => this.removeFolder(btn.dataset.folder));
                });

                // Folder visibility toggle
                listEl.querySelectorAll('.custom-folder-toggle').forEach(btn => {
                    btn.addEventListener('click', () => this.toggleFolderVisibility(btn.dataset.folder));
                });

                // Drag-and-drop
                listEl.querySelectorAll('.point-item[draggable="true"]').forEach(el => {
                    el.addEventListener('dragstart', (e) => {
                        const ids = this.selectMode && this.selectedPointIds.has(el.dataset.id)
                            ? [...this.selectedPointIds] : [el.dataset.id];
                        e.dataTransfer.setData('text/plain', JSON.stringify(ids));
                        e.dataTransfer.effectAllowed = 'move';
                        el.classList.add('dragging');
                    });
                    el.addEventListener('dragend', () => el.classList.remove('dragging'));
                });
                listEl.querySelectorAll('.folder-drop-target').forEach(el => {
                    el.addEventListener('dragover', (e) => { e.preventDefault(); e.dataTransfer.dropEffect = 'move'; el.classList.add('drag-over'); });
                    el.addEventListener('dragleave', (e) => { if (!el.contains(e.relatedTarget)) el.classList.remove('drag-over'); });
                    el.addEventListener('drop', (e) => {
                        e.preventDefault(); el.classList.remove('drag-over');
                        try {
                            const ids = JSON.parse(e.dataTransfer.getData('text/plain'));
                            const targetFolder = el.dataset.folderId;
                            if (targetFolder) ids.forEach(id => {
                                const idx = this.customPoints.findIndex(p => p.id === id);
                                if (idx >= 0) this.customPoints[idx].folder = targetFolder;
                            });
                            this.touchNetworkPoints('points-moved');
                            this.renderCustomPointsList();
                            this.updateCustomPointsOnMap();
                            this.saveCompetitors();
                        } catch(err) { console.error('Drop error:', err); }
                    });
                });

                // Select mode checkboxes
                listEl.querySelectorAll('.point-select-cb').forEach(cb => {
                    cb.addEventListener('change', () => {
                        if (cb.checked) this.selectedPointIds.add(cb.dataset.id);
                        else this.selectedPointIds.delete(cb.dataset.id);
                        this.renderCustomPointsList();
                    });
                });
                listEl.querySelectorAll('.folder-select-all').forEach(cb => {
                    cb.addEventListener('change', () => {
                        const fid = cb.dataset.folder;
                        const folderPoints = this.customPoints.filter(p => (p.folder || 'default') === fid);
                        if (cb.checked) folderPoints.forEach(p => this.selectedPointIds.add(p.id));
                        else folderPoints.forEach(p => this.selectedPointIds.delete(p.id));
                        this.renderCustomPointsList();
                    });
                });

                // Bulk actions
                const bulkSelectAllBtn = listEl.querySelector('.bulk-select-all');
                if (bulkSelectAllBtn) bulkSelectAllBtn.addEventListener('click', () => this.selectAll());
                const bulkColorBtn = listEl.querySelector('.bulk-color');
                if (bulkColorBtn) bulkColorBtn.addEventListener('click', () => this.showBulkPopover('color', bulkColorBtn));
                const bulkIconBtn = listEl.querySelector('.bulk-icon');
                if (bulkIconBtn) bulkIconBtn.addEventListener('click', () => this.showBulkPopover('icon', bulkIconBtn));
                const bulkFolderBtn = listEl.querySelector('.bulk-folder');
                if (bulkFolderBtn) bulkFolderBtn.addEventListener('click', () => this.showBulkPopover('folder', bulkFolderBtn));
                const bulkVisBtn = listEl.querySelector('.bulk-visibility');
                if (bulkVisBtn) bulkVisBtn.addEventListener('click', () => {
                    this.selectedPointIds.forEach(id => {
                        const pt = this.customPoints.find(p => p.id === id);
                        if (pt) pt.visible = pt.visible === false;
                    });
                    this.selectedPointIds.clear(); this.selectMode = false;
                    this.touchNetworkPoints('points-visibility-updated');
                    this.renderCustomPointsList(); this.updateCustomPointsOnMap(); this.saveCompetitors();
                });
                const bulkDelBtn = listEl.querySelector('.bulk-delete');
                if (bulkDelBtn) bulkDelBtn.addEventListener('click', () => this.bulkDelete());

                // Sync fullscreen sidebar if open (avoid recursion)
                if (!targetContainer) {
                    const fsSidebar = document.querySelector('#fullscreen-sidebar .fs-points-container');
                    if (fsSidebar) this.renderCustomPointsList(fsSidebar);
                }
            },

            showEditPointModal(pointId) {
                const point = this.customPoints.find(p => p.id === pointId);
                if (!point) return;

                const modal = document.createElement('div');
                modal.style.cssText = 'position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.5); z-index: 10001; display: flex; align-items: center; justify-content: center;';
                const content = document.createElement('div');
                content.style.cssText = 'background: var(--bg-surface, #18181b); color: var(--text, #fafafa); border-radius: 0.5rem; padding: 1.5rem; max-width: 450px; width: 90%; border: 1px solid var(--border, #27272a);';

                const folderOptions = this.pointFolders.map(f =>
                    `<option value="${f.id}" ${(point.folder || 'default') === f.id ? 'selected' : ''}>${f.name}</option>`
                ).join('');

                const colorBtns = this.PRESET_COLORS.map(c =>
                    `<button type="button" class="edit-color-btn" data-color="${c}" style="width: 28px; height: 28px; border-radius: 50%; background: ${c}; border: 2px solid ${c === (point.color || '#2563eb') ? '#fff' : 'transparent'}; cursor: pointer;"></button>`
                ).join('');

                const iconBtns = Object.entries(this.POINT_ICONS).map(([key, val]) => {
                    const title = key === 'number' ? 'Numéroté — les points seront numérotés automatiquement (1, 2, 3...)' : val.label;
                    return `<button type="button" class="edit-icon-btn" data-icon="${key}" style="font-size: 1.2rem; padding: 0.3rem; border: 2px solid ${key === (point.icon || 'pin') ? '#2563eb' : 'transparent'}; border-radius: 0.25rem; background: none; cursor: pointer;" title="${title}">${val.emoji}</button>`;
                }).join('');

                content.innerHTML = `
                    <h3 style="margin: 0 0 1rem 0; font-size: 1.1rem; color: var(--text, #fafafa);">Modifier le point</h3>
                    <div style="margin-bottom: 0.75rem;">
                        <label style="display: block; font-size: 0.8rem; color: var(--text-secondary, #a1a1aa); margin-bottom: 0.25rem;">Nom</label>
                        <input type="text" id="editPointName" value="${(point.name || '').replace(/"/g, '&quot;')}" style="width: 100%; padding: 0.5rem; border: 1px solid var(--border, #27272a); border-radius: 0.375rem; font-size: 0.9rem; background: var(--bg-elevated, #27272a); color: var(--text, #fafafa);">
                    </div>
                    <div style="margin-bottom: 0.75rem;">
                        <label style="display: block; font-size: 0.8rem; color: var(--text-secondary, #a1a1aa); margin-bottom: 0.25rem;">Couleur</label>
                        <div style="display: flex; gap: 0.5rem; flex-wrap: wrap;">${colorBtns}</div>
                    </div>
                    <div style="margin-bottom: 0.75rem;">
                        <label style="display: block; font-size: 0.8rem; color: var(--text-secondary, #a1a1aa); margin-bottom: 0.25rem;">Icône</label>
                        <div style="display: flex; gap: 0.25rem; flex-wrap: wrap;">${iconBtns}</div>
                    </div>
                    <div style="margin-bottom: 1rem;">
                        <label style="display: block; font-size: 0.8rem; color: var(--text-secondary, #a1a1aa); margin-bottom: 0.25rem;">Dossier</label>
                        <select id="editPointFolder" style="width: 100%; padding: 0.5rem; border: 1px solid var(--border, #27272a); border-radius: 0.375rem; font-size: 0.9rem; background: var(--bg-elevated, #27272a); color: var(--text, #fafafa);">
                            ${folderOptions}
                        </select>
                    </div>
                    <div style="display: flex; gap: 0.5rem; justify-content: flex-end;">
                        <button type="button" id="cancelEditPoint" class="ghost-btn" style="padding: 0.5rem 1rem;">Annuler</button>
                        <button type="button" id="saveEditPoint" class="primary-btn" style="padding: 0.5rem 1rem;">Sauvegarder</button>
                    </div>
                `;
                modal.appendChild(content);
                document.body.appendChild(modal);

                let selectedColor = point.color || '#2563eb';
                let selectedIcon = point.icon || 'pin';

                content.querySelectorAll('.edit-color-btn').forEach(btn => {
                    btn.addEventListener('click', () => {
                        selectedColor = btn.dataset.color;
                        content.querySelectorAll('.edit-color-btn').forEach(b => b.style.borderColor = 'transparent');
                        btn.style.borderColor = '#fff';
                    });
                });
                content.querySelectorAll('.edit-icon-btn').forEach(btn => {
                    btn.addEventListener('click', () => {
                        selectedIcon = btn.dataset.icon;
                        content.querySelectorAll('.edit-icon-btn').forEach(b => b.style.borderColor = 'transparent');
                        btn.style.borderColor = '#2563eb';
                    });
                });

                const closeModal = () => document.body.removeChild(modal);
                modal.querySelector('#cancelEditPoint').addEventListener('click', closeModal);
                modal.addEventListener('click', (e) => { if (e.target === modal) closeModal(); });

                modal.querySelector('#saveEditPoint').addEventListener('click', () => {
                    const newName = modal.querySelector('#editPointName').value.trim();
                    const newFolder = modal.querySelector('#editPointFolder').value;
                    this.updateCustomPoint(pointId, {
                        name: newName || point.name,
                        color: selectedColor,
                        icon: selectedIcon,
                        folder: newFolder
                    });
                    closeModal();
                });
            },

            addFolder(name, parentId, color) {
                const id = `folder_${Date.now()}_${Math.random().toString(36).substr(2, 4)}`;
                this.pointFolders.push({
                    id, name: name || 'Nouveau dossier',
                    parentId: parentId || null,
                    color: color || '#6b7280'
                });
                this.touchNetworkPoints('folder-added');
                this.renderCustomPointsList();
                this.saveCompetitors();
                return id;
            },

            removeFolder(folderId, strategy = null) {
                if (folderId === 'default') return;
                const folderPoints = this.customPoints.filter((point) => point.folder === folderId);
                const childFolders = this.pointFolders.filter((folder) => folder.parentId === folderId);
                if (!strategy && (folderPoints.length || childFolders.length)) {
                    window.MaplyticsNetworkPointsUI?.requestFolderRemoval?.(this, folderId);
                    return false;
                }
                if (!['move', 'delete', null].includes(strategy)) return false;
                if (strategy === 'delete') {
                    const removedAt = new Date().toISOString();
                    this.dispatchCompetitorWorkspace({
                        type: 'removed/add',
                        items: folderPoints.map((point) => ({
                            kind: 'custom_point',
                            identity: String(point.id || ''),
                            label: point.name || 'Point retiré',
                            secondaryLabel: 'Dossier supprimé',
                            removedAt,
                        })),
                    });
                    const removedIds = new Set(folderPoints.map((point) => point.id));
                    this.customPoints = this.customPoints.filter((point) => !removedIds.has(point.id));
                    removedIds.forEach((id) => this.selectedPointIds.delete(id));
                } else {
                    this.customPoints.forEach(p => {
                        if (p.folder === folderId) p.folder = 'default';
                    });
                }
                // Déplacer les sous-dossiers vers le parent du dossier supprimé
                const folder = this.pointFolders.find(f => f.id === folderId);
                const parentId = folder ? folder.parentId : null;
                this.pointFolders.forEach(f => {
                    if (f.parentId === folderId) f.parentId = parentId;
                });
                this.pointFolders = this.pointFolders.filter(f => f.id !== folderId);
                this.touchNetworkPoints('folder-removed');
                this.renderCustomPointsList();
                this.updateCustomPointsOnMap();
                this.saveCompetitors();
                return true;
            },

            showAddFolderPrompt() {
                const name = prompt('Nom du dossier :');
                if (name && name.trim()) {
                    const colorIdx = this.pointFolders.length % this.PRESET_COLORS.length;
                    this.addFolder(name.trim(), null, this.PRESET_COLORS[colorIdx]);
                }
            },

            syncNetworkSelectionButton() {
                const btn = document.querySelector(`${scopeSelector} .custom-points-select-mode`);
                if (!btn) return;
                if (window.MaplyticsNetworkPointsUI?.syncSelectionButton) {
                    window.MaplyticsNetworkPointsUI.syncSelectionButton(btn, this.selectMode);
                    return;
                }
                btn.textContent = this.selectMode ? '✕ Annuler' : '☑ Sélection';
                btn.style.background = this.selectMode ? '#dbeafe' : '';
            },

            toggleSelectMode() {
                this.selectMode = !this.selectMode;
                this.selectedPointIds.clear();
                this.renderCustomPointsList();
                this.syncNetworkSelectionButton();
            },

            selectAll() {
                if (this.selectedPointIds.size === this.customPoints.length) {
                    this.selectedPointIds.clear();
                } else {
                    this.customPoints.forEach(p => this.selectedPointIds.add(p.id));
                }
                this.renderCustomPointsList();
            },

            toggleNumberAll() {
                const allNumbered = this.customPoints.length > 0 && this.customPoints.every(p => p.icon === 'number');
                this.customPoints.forEach(p => p.icon = allNumbered ? 'pin' : 'number');
                this.touchNetworkPoints('point-icons-updated');
                this.renderCustomPointsList();
                this.updateCustomPointsOnMap();
                this.saveCompetitors();
                const btn = document.querySelector(`${scopeSelector} .custom-points-number-all`);
                if (btn) btn.style.background = allNumbered ? '' : '#dbeafe';
            },

            toggleFolderVisibility(folderId) {
                const folderPoints = this.customPoints.filter(p => (p.folder || 'default') === folderId);
                const allVisible = folderPoints.every(p => p.visible !== false);
                folderPoints.forEach(p => p.visible = !allVisible);
                this.touchNetworkPoints('folder-visibility-updated');
                this.renderCustomPointsList();
                this.updateCustomPointsOnMap();
                this.saveCompetitors();
            },

            bulkUpdate(updates) {
                this.selectedPointIds.forEach(id => {
                    const idx = this.customPoints.findIndex(p => p.id === id);
                    if (idx >= 0) Object.assign(this.customPoints[idx], updates);
                });
                this.selectedPointIds.clear();
                this.selectMode = false;
                this.touchNetworkPoints('points-bulk-updated');
                this.renderCustomPointsList();
                this.updateCustomPointsOnMap();
                if (this.pointsLegendVisible) this.updatePointsLegend();
                this.saveCompetitors();
                this.syncNetworkSelectionButton();
            },

            bulkDelete() {
                if (!confirm(`Supprimer ${this.selectedPointIds.size} point(s) ?`)) return;
                const removedAt = new Date().toISOString();
                const removedItems = this.customPoints
                    .filter((point) => this.selectedPointIds.has(point.id))
                    .map((point) => {
                        const folderName = this.pointFolders.find(
                            (folder) => folder.id === point.folder,
                        )?.name;
                        return {
                            kind: 'custom_point',
                            identity: String(point.id || ''),
                            label: point.name || 'Point retiré',
                            secondaryLabel: folderName
                                ? `Dossier ${folderName}`
                                : 'Point personnalisé',
                            removedAt,
                        };
                    });
                if (removedItems.length) {
                    this.dispatchCompetitorWorkspace({
                        type: 'removed/add',
                        items: removedItems,
                    });
                }
                this.customPoints = this.customPoints.filter(p => !this.selectedPointIds.has(p.id));
                this.selectedPointIds.clear();
                this.selectMode = false;
                this.touchNetworkPoints('points-bulk-removed');
                this.renderCustomPointsList();
                this.updateCustomPointsOnMap();
                if (this.pointsLegendVisible) this.updatePointsLegend();
                this.saveCompetitors();
                this.syncNetworkSelectionButton();
            },

            showBulkPopover(type, anchorBtn) {
                // Remove any existing popover
                document.querySelectorAll('.bulk-popover').forEach((existing) => {
                    if (typeof existing.__maplyticsClose === 'function') {
                        existing.__maplyticsClose({ restoreFocus: false });
                    } else {
                        existing.remove();
                    }
                });
                const popover = document.createElement('div');
                popover.className = 'bulk-popover';
                popover.id = `bulk-popover-${Date.now()}`;
                popover.setAttribute('role', 'dialog');
                popover.setAttribute('aria-modal', 'false');
                popover.setAttribute(
                    'aria-label',
                    `Choisir ${type === 'color' ? 'une couleur' : type === 'icon' ? 'une icône' : 'un dossier'}`,
                );
                popover.style.cssText = 'position: fixed; z-index: 12050; background: white; border: 1px solid #e2e8f0; border-radius: 0.375rem; padding: 0.5rem; box-shadow: 0 4px 12px rgba(0,0,0,0.15); display: flex; gap: 0.25rem; flex-wrap: wrap; max-width: min(250px, calc(100vw - 16px)); max-height: calc(100vh - 16px); overflow: auto;';
                anchorBtn.setAttribute('aria-haspopup', 'dialog');
                anchorBtn.setAttribute('aria-expanded', 'true');
                anchorBtn.setAttribute('aria-controls', popover.id);

                let closed = false;
                const positionPopover = () => {
                    if (closed || !popover.isConnected || !anchorBtn.isConnected) return;
                    const viewport = window.visualViewport;
                    const viewportLeft = Number(viewport?.offsetLeft) || 0;
                    const viewportTop = Number(viewport?.offsetTop) || 0;
                    const viewportWidth = Number(viewport?.width) || document.documentElement.clientWidth;
                    const viewportHeight = Number(viewport?.height) || document.documentElement.clientHeight;
                    const viewportRight = viewportLeft + viewportWidth;
                    const viewportBottom = viewportTop + viewportHeight;
                    const margin = 8;
                    const gap = 8;
                    popover.style.maxWidth = `${Math.max(1, viewportWidth - (margin * 2))}px`;
                    popover.style.maxHeight = `${Math.max(1, viewportHeight - (margin * 2))}px`;
                    const anchorRect = anchorBtn.getBoundingClientRect();
                    const popoverRect = popover.getBoundingClientRect();
                    const preferredTop = anchorRect.bottom + gap + popoverRect.height <= viewportBottom - margin
                        ? anchorRect.bottom + gap
                        : anchorRect.top - gap - popoverRect.height;
                    const left = Math.min(
                        Math.max(anchorRect.left, viewportLeft + margin),
                        Math.max(viewportLeft + margin, viewportRight - margin - popoverRect.width),
                    );
                    const top = Math.min(
                        Math.max(preferredTop, viewportTop + margin),
                        Math.max(viewportTop + margin, viewportBottom - margin - popoverRect.height),
                    );
                    popover.style.left = `${Math.round(left)}px`;
                    popover.style.top = `${Math.round(top)}px`;
                };
                const closePopover = ({ restoreFocus = true } = {}) => {
                    if (closed) return;
                    closed = true;
                    document.removeEventListener('click', closeOnOutsideClick, true);
                    document.removeEventListener('keydown', closeOnEscape, true);
                    window.removeEventListener('resize', positionPopover);
                    window.removeEventListener('scroll', positionPopover, true);
                    window.visualViewport?.removeEventListener('resize', positionPopover);
                    window.visualViewport?.removeEventListener('scroll', positionPopover);
                    popover.remove();
                    anchorBtn.setAttribute('aria-expanded', 'false');
                    anchorBtn.removeAttribute('aria-controls');
                    if (restoreFocus && anchorBtn.isConnected) anchorBtn.focus({ preventScroll: true });
                };
                const closeOnOutsideClick = (event) => {
                    if (!popover.contains(event.target) && event.target !== anchorBtn) closePopover();
                };
                const closeOnEscape = (event) => {
                    if (event.key !== 'Escape') return;
                    event.preventDefault();
                    closePopover();
                };
                popover.__maplyticsClose = closePopover;

                if (type === 'color') {
                    this.PRESET_COLORS.forEach(c => {
                        const btn = document.createElement('button');
                        btn.type = 'button';
                        btn.style.cssText = `width: 28px; height: 28px; border-radius: 50%; background: ${c}; border: 2px solid transparent; cursor: pointer;`;
                        btn.setAttribute('aria-label', `Choisir la couleur ${c}`);
                        btn.addEventListener('click', () => { closePopover({ restoreFocus: false }); this.bulkUpdate({ color: c }); });
                        popover.appendChild(btn);
                    });
                } else if (type === 'icon') {
                    Object.entries(this.POINT_ICONS).forEach(([key, val]) => {
                        const btn = document.createElement('button');
                        btn.type = 'button';
                        btn.style.cssText = 'font-size: 1.2rem; padding: 0.25rem; border: none; background: none; cursor: pointer; border-radius: 0.25rem;';
                        btn.textContent = val.emoji;
                        btn.title = val.label;
                        btn.setAttribute('aria-label', `Choisir l’icône ${val.label}`);
                        btn.addEventListener('click', () => { closePopover({ restoreFocus: false }); this.bulkUpdate({ icon: key }); });
                        popover.appendChild(btn);
                    });
                } else if (type === 'folder') {
                    this.pointFolders.forEach(f => {
                        const btn = document.createElement('button');
                        btn.type = 'button';
                        btn.style.cssText = 'display: block; width: 100%; text-align: left; padding: 0.35rem 0.5rem; border: none; background: none; cursor: pointer; font-size: 0.8rem; border-radius: 0.25rem;';
                        btn.textContent = `📁 ${f.name}`;
                        btn.addEventListener('mouseover', () => btn.style.background = '#f1f5f9');
                        btn.addEventListener('mouseout', () => btn.style.background = 'none');
                        btn.addEventListener('click', () => { closePopover({ restoreFocus: false }); this.bulkUpdate({ folder: f.id }); });
                        popover.appendChild(btn);
                    });
                    popover.style.flexDirection = 'column';
                }

                document.body.appendChild(popover);
                positionPopover();
                window.addEventListener('resize', positionPopover, { passive: true });
                window.addEventListener('scroll', positionPopover, { passive: true, capture: true });
                window.visualViewport?.addEventListener('resize', positionPopover, { passive: true });
                window.visualViewport?.addEventListener('scroll', positionPopover, { passive: true });
                setTimeout(() => {
                    document.addEventListener('click', closeOnOutsideClick, true);
                    document.addEventListener('keydown', closeOnEscape, true);
                    popover.querySelector('button')?.focus({ preventScroll: true });
                }, 0);
            },

            renderFullscreenSidebar(container, options = {}) {
                const mapController = toolType === 'isochrone'
                    ? exportMapController
                    : importMapController;
                const choropleth = mapController?.getChoroplethSnapshot?.() || null;
                const zoneCount = Number(mapController?.zonesLayers?.size || 0);
                const competitorView = this.getCompetitorView();
                const legendItemCount = this.pointsLegendItemCount();
                const legendUnavailable = legendItemCount === 0;
                const attractivenessCount = Object.values(this.attractivenessResults || {})
                    .reduce((total, rows) => total + (Array.isArray(rows) ? rows.length : 0), 0);
                const fsMapId = toolType === 'isochrone' ? 'exportMap' : 'importMap';
                const networkVisible = this.customPointsVisible !== false;
                const networkStatus = String(options.networkAnnouncement || (
                    this.customPoints.length
                        ? `${this.customPoints.length} point(s) Réseau ${networkVisible ? 'affiché(s)' : 'masqué(s)'} sur la carte.`
                        : 'Ajoutez un point Réseau pour utiliser la visibilité globale.'
                ));
                let html = `
                    <section class="home-fullscreen-workspace__section" data-fs-section="maps">
                        <h3>Cartes démographiques</h3>
                        <p class="home-fullscreen-workspace__status">${choropleth?.active ? 'Carte active' : 'Carte disponible dans les réglages'}</p>
                        <p class="home-fullscreen-workspace__status" data-fs-map-settings-status role="status" aria-live="polite"></p>
                        <div class="home-fullscreen-workspace__quick-actions">
                            <button type="button" data-fs-open-map-settings data-fs-map-settings-section="demographic" aria-expanded="false" aria-controls="choroplethSettingsTitle_${fsMapId}">Réglages</button>
                        </div>
                    </section>
                    <section class="home-fullscreen-workspace__section" data-fs-section="zones">
                        <h3>Zones de chalandise (${zoneCount})</h3>
                        <div class="home-fullscreen-workspace__quick-actions">
                            <button type="button" data-fs-fit-zones>Cadrer</button>
                            <button type="button" data-fs-open-map-settings data-fs-map-settings-section="zones" aria-expanded="false">Ordre et opacité</button>
                        </div>
                    </section>
                    <section class="home-fullscreen-workspace__section" data-fs-section="competitors">`;
                html += `<h3 data-competitor-fullscreen-count="${competitorView.competitors.length}" data-competitor-view-fingerprint="${this.escapeCompetitorText(competitorView.fingerprint)}">Concurrents (${competitorView.competitors.length})</h3>`;
                html += `<div class="home-fullscreen-workspace__quick-actions">
                    <button type="button" data-fs-toggle-competitors aria-pressed="${this.visibleOnMap ? 'true' : 'false'}">${this.visibleOnMap ? 'Masquer' : 'Afficher'}</button>
                    <button type="button" data-fs-toggle-points-legend aria-pressed="${this.pointsLegendVisible ? 'true' : 'false'}" ${legendUnavailable ? 'disabled aria-disabled="true"' : ''}>Légende</button>
                    <button type="button" data-fs-configure-attractiveness>Configurer l’attractivité</button>
                    <button type="button" data-fs-toggle-attractiveness aria-pressed="${this.attractivenessVisible ? 'true' : 'false'}" ${attractivenessCount ? '' : 'disabled aria-disabled="true"'}>${this.attractivenessVisible ? 'Masquer l’attractivité' : 'Afficher l’attractivité'}</button>
                </div>`;
                html += `<p class="home-fullscreen-workspace__status" data-fs-competitor-status role="status" aria-live="polite">${legendUnavailable
                    ? 'Ajoutez ou affichez au moins un point pour utiliser la légende.'
                    : `${legendItemCount} élément(s) disponible(s) pour la légende.`} ${attractivenessCount
                    ? `${attractivenessCount} résultat(s) d’attractivité conservé(s).`
                    : 'Configurez l’attractivité pour créer ses résultats.'}</p>`;
                if (competitorView.competitors.length === 0) {
                    html += '<p class="home-fullscreen-workspace__empty">Aucun concurrent</p>';
                } else {
                    html += '<div class="home-fullscreen-workspace__competitor-list">';
                    competitorView.competitors.forEach(c => {
                        html += `<div class="home-fullscreen-workspace__competitor" data-competitor-fullscreen-id="${this.escapeCompetitorText(this.competitorIdentity(c))}" data-competitor-view-id="${this.escapeCompetitorText(this.competitorIdentity(c))}" data-visible-rank="${Number(c.visible_rank)}" data-display-reference="${Number(c.display_reference)}">
                            <span class="competitor-fullscreen-reference">N° ${Number(c.visible_rank)} · Réf. ${Number(c.display_reference)}</span>
                            <span class="home-fullscreen-workspace__competitor-name">${this.escapeCompetitorText(c.name || 'Inconnu')}</span>
                            <span class="home-fullscreen-workspace__competitor-distance">${c.distance_km ? `${this.escapeCompetitorText(c.distance_km)} km` : ''}</span>
                        </div>`;
                    });
                    html += '</div>';
                }
                html += '</section>';

                html += `<section class="home-fullscreen-workspace__section" data-fs-section="network">
                    <h3>Réseau de points (${this.customPoints.length})</h3>
                    <div class="home-fullscreen-workspace__quick-actions">
                        <button type="button" class="fs-add-point ghost-btn">Ajouter un point</button>
                        <button type="button" class="fs-add-folder ghost-btn">Ajouter un dossier</button>
                        <button type="button" class="fs-select-mode ghost-btn">Sélection</button>
                        <button type="button" class="fs-toggle-all ghost-btn" aria-pressed="${networkVisible ? 'true' : 'false'}" ${this.customPoints.length ? '' : 'disabled aria-disabled="true"'}>${networkVisible ? 'Masquer' : 'Afficher'}</button>
                    </div>
                    <p class="home-fullscreen-workspace__status" data-fs-network-status role="status" aria-live="polite">${this.escapeCompetitorText(networkStatus)}</p>
                    <div class="fs-points-container home-fullscreen-workspace__points"></div>
                </section>
                <section class="home-fullscreen-workspace__section" data-fs-section="basemap">
                    <h3>Fond de carte et représentation</h3>
                    <div class="home-fullscreen-workspace__quick-actions">
                        <button type="button" data-fs-open-map-settings data-fs-map-settings-section="basemap" aria-expanded="false">Personnaliser la carte</button>
                    </div>
                </section>`;

                container.innerHTML = html;

                // Render full points list into the container
                const pointsDiv = container.querySelector('.fs-points-container');
                if (pointsDiv) this.renderCustomPointsList(pointsDiv);

                container.querySelectorAll('[data-fs-open-map-settings]').forEach((button) => {
                    button.addEventListener('click', () => {
                        const opened = mapController?.openFullscreenSettings?.(
                            button.dataset.fsMapSettingsSection,
                            button,
                        );
                        if (opened) return;
                        const status = container.querySelector('[data-fs-map-settings-status]');
                        if (status) status.textContent = 'Ces réglages ne sont pas disponibles dans le contexte courant.';
                    });
                });
                container.querySelector('[data-fs-fit-zones]')?.addEventListener('click', () => {
                    mapController?.updateMapBounds?.(true);
                });
                container.querySelector('[data-fs-toggle-competitors]')?.addEventListener('click', () => {
                    this.toggleMapVisibility();
                    this.renderFullscreenSidebar(container);
                });
                container.querySelector('[data-fs-toggle-points-legend]')?.addEventListener('click', () => {
                    this.togglePointsLegend();
                    this.renderFullscreenSidebar(container);
                });
                container.querySelector('[data-fs-configure-attractiveness]')?.addEventListener('click', (event) => {
                    this.openAttractivenessConfiguration(event.currentTarget);
                });
                container.querySelector('[data-fs-toggle-attractiveness]')?.addEventListener('click', () => {
                    this.setAttractivenessVisible(!this.attractivenessVisible);
                    this.renderFullscreenSidebar(container);
                });
                container.querySelector('.fs-add-point')?.addEventListener('click', () => {
                    const sp = this.getSearchParams();
                    if (sp) {
                        this.addCustomPoint({ name: 'Nouveau point', lat: sp.lat, lon: sp.lon, color: '#2563eb', icon: 'pin', folder: 'default', visible: true });
                    } else {
                        alert('Lancez une recherche d\'abord pour définir la position.');
                    }
                });
                container.querySelector('.fs-add-folder')?.addEventListener('click', () => this.showAddFolderPrompt());
                container.querySelector('.fs-select-mode')?.addEventListener('click', () => this.toggleSelectMode());
                container.querySelector('.fs-toggle-all')?.addEventListener('click', () => {
                    const visible = this.toggleAllCustomPointsVisibility();
                    this.renderFullscreenSidebar(container, {
                        networkAnnouncement: visible
                            ? `${this.customPoints.length} point(s) Réseau affiché(s) sur la carte.`
                            : `${this.customPoints.length} point(s) Réseau masqué(s) sur la carte.`,
                    });
                });
            },

            updateCustomPointsOnMap() {
                const invalidateImportVisual = () => {
                    if (toolType === 'import-table') {
                        importDetailedExportAdapter?.invalidate?.(
                            'import-custom-points-changed',
                            {hard: false},
                        );
                    }
                };
                const mapController = toolType === 'isochrone' ? exportMapController : importMapController;
                if (!mapController || !mapController.map || typeof L === 'undefined') {
                    invalidateImportVisual();
                    return;
                }

                if (!this.customPointsLayer) {
                    this.customPointsLayer = L.layerGroup().addTo(mapController.map);
                }
                this.customPointsLayer.clearLayers();

                if (!this.customPointsVisible) {
                    invalidateImportVisual();
                    return;
                }

                this.customPoints.filter(p => p.visible !== false && p.lat && p.lon).forEach(p => {
                    const displayReference = Number(p.display_reference) || 0;
                    const routingSnapshot = this.networkRoutingSnapshot;
                    const routingRow = routingSnapshot?.highlight_visibility === false
                        ? null
                        : routingSnapshot?.nearest?.find((row) => row.point_id === p.id);
                    const routingRank = Number(routingRow?.route_rank) || 0;
                    const iconInfo = this.POINT_ICONS[p.icon] || this.POINT_ICONS['pin'];
                    const isNumbered = p.icon === 'number';
                    const rawPointImage = p.image_url || p.imageUrl || '';
                    const pointImage = window.MaplyticsNetworkPointsState.isLocalImage(rawPointImage)
                        ? rawPointImage
                        : '';
                    const displayContent = pointImage
                        ? `<img class="custom-point-marker__image" src="${escapeHtml(pointImage)}" alt="" width="28" height="28">`
                        : isNumbered
                        ? `<span style="font-size: 11px; font-weight: 700; color: white;">${displayReference}</span>`
                        : `<span style="font-size: 12px;">${iconInfo.emoji}</span>`;
                    const surfaceClass = pointImage ? 'custom-point-marker__surface--image' : 'custom-point-marker__surface--symbol';
                    const marker = L.marker([p.lat, p.lon], {
                        icon: L.divIcon({
                            className: 'custom-point-marker',
                            html: `<div class="custom-point-marker__wrapper">
                                <div class="custom-point-marker__surface ${surfaceClass}" style="--network-marker-color: ${p.color || '#2563eb'};">
                                    ${displayContent}
                                </div>
                                ${routingRank ? `<span class="network-routing-rank-badge" aria-label="Rang routier ${routingRank}">${routingRank}</span>` : ''}
                            </div>`,
                            iconSize: pointImage ? [28, 28] : [24, 24],
                            iconAnchor: pointImage ? [14, 14] : [12, 12]
                        })
                    });
                    marker.bindTooltip(`<b>${isNumbered ? `Réf. ${displayReference} · ` : ''}${p.name || 'Point'}</b>`, { direction: 'top', offset: [0, -12] });
                    marker.on('click', () => {
                        marker.unbindPopup();
                        marker.bindPopup(`<div style="text-align: center; min-width: 140px;">
                            <b>${p.name || 'Point'}</b>
                            <div style="font-size: 0.8rem; color: #64748b;">${p.lat.toFixed(4)}, ${p.lon.toFixed(4)}</div>
                            <button class="marker-remove-btn" data-point-id="${p.id}" style="margin-top: 0.5rem; padding: 0.3rem 0.75rem; background: #dc2626; color: white; border: none; border-radius: 4px; cursor: pointer; font-size: 0.8rem;">Supprimer</button>
                        </div>`).openPopup();
                    });
                    marker.on('popupopen', () => {
                        const removeButton = marker.getPopup()
                            ?.getElement()
                            ?.querySelector('.marker-remove-btn');
                        if (removeButton) {
                            removeButton.onclick = () => {
                                this.removeCustomPoint(removeButton.dataset.pointId);
                            };
                        }
                    });
                    this.customPointsLayer.addLayer(marker);
                });
                invalidateImportVisual();
            },

            // Legende des points sur la carte
            pointsLegendControl: null,
            pointsLegendVisible: false,

            removePointsLegend() {
                const mapController = toolType === 'isochrone' ? exportMapController : importMapController;
                if (mapController?.map && this.pointsLegendControl) {
                    mapController.map.removeControl(this.pointsLegendControl);
                }
                this.pointsLegendControl = null;
            },

            pointsLegendItemCount() {
                const customPointCount = this.customPoints.filter(
                    (point) => point.visible !== false,
                ).length;
                const competitorCount = this.competitorWorkspaceController
                    ?.snapshot?.().map?.rows?.length || 0;
                return customPointCount + competitorCount;
            },

            syncPointsLegendButton() {
                const btn = document.querySelector(
                    `${scopeSelector} #competitorLegendBtn, ${scopeSelector} #importCompetitorLegendBtn`,
                );
                if (!btn) return;
                btn.style.background = this.pointsLegendVisible ? '#eff6ff' : '';
                btn.style.color = this.pointsLegendVisible ? '#2563eb' : '';
                btn.setAttribute('aria-pressed', this.pointsLegendVisible ? 'true' : 'false');
            },

            setPointsLegendVisible(value, { persist = false } = {}) {
                this.dispatchCompetitorWorkspace({
                    type: 'presentation/set',
                    patch: { legendVisible: Boolean(value) },
                });
                if (this.pointsLegendVisible) {
                    this.updatePointsLegend();
                } else this.removePointsLegend();
                this.syncPointsLegendButton();
                if (toolType === 'isochrone') {
                    window.maplyticsCompetitorVisualExportDialog?.invalidate?.(
                        'competitor-legend-visibility',
                    );
                }
                if (persist) void this.saveCompetitors({ quiet: true });
                return this.pointsLegendVisible;
            },

            togglePointsLegend() {
                if (!this.pointsLegendVisible && this.pointsLegendItemCount() === 0) {
                    return false;
                }
                return this.setPointsLegendVisible(!this.pointsLegendVisible, { persist: false });
            },

            updatePointsLegend() {
                const mapController = toolType === 'isochrone' ? exportMapController : importMapController;
                if (!mapController || !mapController.map || !this.pointsLegendVisible) return;

                // Supprimer l'ancienne
                if (this.pointsLegendControl) {
                    mapController.map.removeControl(this.pointsLegendControl);
                    this.pointsLegendControl = null;
                }

                const allItems = [];
                // Custom points
                let idx = 0;
                this.customPoints.filter(p => p.visible !== false).forEach(p => {
                    idx++;
                    const iconInfo = this.POINT_ICONS[p.icon] || this.POINT_ICONS['pin'];
                    const pointImage = p.image_url || p.imageUrl || '';
                    const label = window.MaplyticsNetworkPointsState.isLocalImage(pointImage)
                        ? '🖼️'
                        : p.icon === 'number' ? `${idx}` : iconInfo.emoji;
                    allItems.push({ color: p.color || '#2563eb', label, name: p.name || 'Point', type: 'custom' });
                });
                const competitorView = this.getCompetitorView();
                const workspace = this.competitorWorkspaceController.snapshot();
                const mappedCompetitors = workspace.map.rows;
                if (mappedCompetitors.length > 0) {
                    if (this.competitorsNumbered) {
                        mappedCompetitors.forEach((competitor) => {
                            allItems.push({
                                color: this.competitorMarkerColor,
                                label: String(competitor.visible_rank),
                                name: `Réf. ${competitor.display_reference} · ${competitor.name || 'Nom inconnu'}`,
                                type: 'competitor',
                                viewId: this.competitorIdentity(competitor),
                                viewFingerprint: competitorView.fingerprint,
                                visibleRank: competitor.visible_rank,
                                displayReference: competitor.display_reference,
                            });
                        });
                    } else {
                        allItems.push({ color: this.competitorMarkerColor, label: '●', name: `Concurrents (${mappedCompetitors.length})`, type: 'competitor' });
                    }
                }

                if (allItems.length === 0) return;

                this.pointsLegendControl = L.control({ position: 'bottomleft' });
                this.pointsLegendControl.onAdd = () => {
                    const div = L.DomUtil.create('div', 'points-legend');
                    div.style.cssText = 'background: white; padding: 0.5rem 0.75rem; border-radius: 0.375rem; box-shadow: 0 2px 6px rgba(0,0,0,0.15); font-size: 0.75rem; max-height: 250px; overflow-y: auto; max-width: 220px;';
                    let html = '<div style="font-weight: 600; margin-bottom: 0.35rem; border-bottom: 1px solid #e2e8f0; padding-bottom: 0.25rem;">Légende</div>';
                    allItems.forEach(item => {
                        const viewAttributes = item.viewId
                            ? ` data-competitor-view-id="${this.escapeCompetitorText(item.viewId)}" data-competitor-view-fingerprint="${this.escapeCompetitorText(item.viewFingerprint)}" data-visible-rank="${Number(item.visibleRank)}" data-display-reference="${Number(item.displayReference)}"`
                            : '';
                        html += `<div${viewAttributes} style="display: flex; align-items: center; gap: 0.4rem; padding: 0.15rem 0;">
                            <span style="color: ${item.color}; font-size: ${item.type === 'competitor' ? '0.9rem' : '0.75rem'}; width: 16px; text-align: center;">${item.label}</span>
                            <span style="color: #334155; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">${item.name}</span>
                        </div>`;
                    });
                    div.innerHTML = html;
                    window.MaplyticsLeafletControlDisclosure?.enhance?.(div, {
                        surface: toolType,
                        controlKey: 'points-legend',
                        title: 'Légende des points',
                        preserveDirectChildren: true,
                    });
                    L.DomEvent.disableClickPropagation(div);
                    return div;
                };
                this.pointsLegendControl.addTo(mapController.map);
            },

            toggleAllCustomPointsVisibility() {
                this.customPointsVisible = !this.customPointsVisible;
                this.touchNetworkPoints('network-visibility-updated');
                this.updateCustomPointsOnMap();
                const toggleBtn = document.querySelector(
                    `${scopeSelector} .custom-points-toggle-all`,
                );
                if (toggleBtn) {
                    toggleBtn.textContent = this.customPointsVisible ? '👁️' : '🙈';
                    toggleBtn.setAttribute(
                        'aria-pressed',
                        this.customPointsVisible ? 'true' : 'false',
                    );
                    toggleBtn.setAttribute(
                        'aria-label',
                        this.customPointsVisible
                            ? 'Masquer les points Réseau'
                            : 'Afficher les points Réseau',
                    );
                }
                if (this.pointsLegendVisible) this.updatePointsLegend();
                this.saveCompetitors();
                return this.customPointsVisible;
            },

            resetLocalWorkspace({ preserveCustomPoints = false } = {}) {
                const retainedCustomPointState = preserveCustomPoints
                    ? {
                        customPoints: JSON.parse(JSON.stringify(this.customPoints || [])),
                        pointFolders: JSON.parse(JSON.stringify(this.pointFolders || [])),
                        selectedPointIds: [...this.selectedPointIds],
                        selectMode: Boolean(this.selectMode),
                        customPointsVisible: this.customPointsVisible !== false,
                        pointsLegendVisible: Boolean(this.pointsLegendVisible),
                        networkPointBatches: JSON.parse(JSON.stringify(this.networkPointBatches || [])),
                        networkSelectedOrigin: this.networkSelectedOrigin,
                        networkRevision: this.networkRevision,
                        networkNextDisplayReference: this.networkNextDisplayReference,
                    }
                    : null;
                this._competitorPersistenceBlocked = true;
                this._competitorSearchAbortController?.abort?.();
                this._competitorSearchAbortController = null;
                this._activeCompetitorSearchScope = null;
                this._workspaceRequestGeneration += 1;
                this._competitorStateGeneration += 1;
                this._competitorSaveSequence += 1;
                this._competitorRestoreSequence += 1;
                this._competitorRestoreAbortController?.abort?.();
                this._competitorRestoreAbortController = null;
                this._competitorThreatScoreRequest += 1;
                clearTimeout(this._competitorSnapshotSaveTimer);
                this._competitorSnapshotSaveTimer = null;
                this._competitorRestorePending = 0;
                this._competitorRestoreTarget = '';
                this._competitorRestoreTargetSequence = 0;
                this._competitorRoutingAbortController?.abort?.();
                this._competitorRoutingAbortController = null;
                this._competitorRoutingRequest = null;
                this._competitorRoutingGeneration += 1;
                this._competitorRoutingCoordinator?.coordinator?.clear?.();
                this._competitorRoutingCoordinator = null;
                this.competitorRoutingSnapshot = {
                    schema_version: 'home_competitor_routing_snapshot_v3',
                    fingerprint: '',
                    status: 'idle',
                    selected_ids: [],
                    total: 0,
                    processed: 0,
                    succeeded: 0,
                    failed: 0,
                    batch_index: 0,
                    batch_count: 0,
                    rows: [],
                    summary: null,
                    calculated_at: null,
                    last_failure: null,
                    failed_batches: [],
                    generation: this._competitorRoutingGeneration,
                };
                this._threatScoreConfiguration?.close?.({ force: true });
                this._threatScoreConfiguration = null;
                this._attractivenessModal?.close?.({ restoreFocus: false });
                this._attractivenessModal = null;
                this.attractivenessSelectedCategories = [];

                document.querySelectorAll(
                    `.competitor-search-modal[data-competitor-tool-type="${toolType}"]`,
                ).forEach((modal) => {
                    const close = modal.querySelector(
                        '#closeCompetitorModal, [data-keyword-modal-close]',
                    );
                    if (close) close.click();
                    if (modal.isConnected) modal.remove();
                });
                document.body.style.overflow = '';

                this.clearAttractiveness();
                const mapController = toolType === 'isochrone'
                    ? exportMapController
                    : importMapController;
                if (this._searchMarker && mapController?.map) {
                    mapController.map.removeLayer(this._searchMarker);
                }
                this._searchMarker = null;
                this.lastSearchResults = [];
                this.lastSearchInfo = {};
                this.lastCompetitorRouteOrigins = [];
                this.lastStructuredSearch = null;
                this.competitorSearchSnapshot = null;
                this.selectedPointIds.clear();
                this.selectMode = false;
                this.customPointsVisible = true;
                this.competitorFilterBuilder?.state?.reset?.();
                this.competitorFilterBuilder?.setOrigins?.([]);
                this.restoreCompetitorStatePayload([], { restoreBuilder: false });
                this.setPointsLegendVisible(false, { persist: false });
                if (retainedCustomPointState) {
                    this.customPoints = retainedCustomPointState.customPoints;
                    this.pointFolders = retainedCustomPointState.pointFolders;
                    this.selectedPointIds = new Set(
                        retainedCustomPointState.selectedPointIds.filter((id) => (
                            this.customPoints.some((point) => point.id === id)
                        )),
                    );
                    this.selectMode = retainedCustomPointState.selectMode;
                    this.customPointsVisible = retainedCustomPointState.customPointsVisible;
                    this.networkPointBatches = retainedCustomPointState.networkPointBatches;
                    this.networkSelectedOrigin = retainedCustomPointState.networkSelectedOrigin;
                    this.networkRevision = retainedCustomPointState.networkRevision;
                    this.networkNextDisplayReference = retainedCustomPointState.networkNextDisplayReference;
                    this.networkPointsStatePayload();
                    this.renderCustomPointsList();
                    this.updateCustomPointsOnMap();
                    this.setPointsLegendVisible(
                        retainedCustomPointState.pointsLegendVisible,
                        { persist: false },
                    );
                }
                const projectSelect = document.querySelector(
                    `${scopeSelector} .competitor-project-select`,
                );
                if (projectSelect) {
                    projectSelect.value = '';
                    projectSelect._previousValue = '';
                }
                this.setCompetitorSaveStatus('idle', 'Non sauvegardé');
                this._competitorPersistenceBlocked = false;
                return true;
            },

            // Réinitialiser les concurrents
            async resetCompetitors() {
                if (!confirm('Voulez-vous vraiment supprimer tous les concurrents ? Cette action est irréversible.')) {
                    return false;
                }
                this._competitorPersistenceBlocked = true;
                this._competitorStateGeneration += 1;
                this._competitorSaveSequence += 1;
                try {
                    await this._competitorSaveTail.catch(() => false);
                    if (!connectedUserToken) {
                        this.restoreCompetitorStatePayload([]);
                        this.setCompetitorSaveStatus('idle', 'Non sauvegardé');
                        return true;
                    }
                    const response = await fetch(`/api/competitors/reset?tool_type=${toolType}`, {
                        method: 'DELETE',
                        credentials: 'include'
                    });

                    const result = await response.json();

                    if (result.success) {
                        this.restoreCompetitorStatePayload([]);
                        this.broadcastCompetitorSnapshot(
                            '',
                            this.competitorPersistenceTarget(''),
                        );
                        this.setCompetitorSaveStatus('idle', 'Non sauvegardé');
                        return true;
                    } else {
                        alert('Erreur lors de la suppression: ' + (result.error || 'Erreur inconnue'));
                        return false;
                    }
                } catch (error) {
                    console.error('Erreur reset concurrents:', error);
                    alert('Erreur lors de la suppression. Vérifiez votre connexion.');
                    return false;
                } finally {
                    this._competitorPersistenceBlocked = false;
                }
            }
            };
        };

        // ============================================
        // STATS MANAGER (Onglet 3 Statistiques)
        // ============================================
        // Factory function pour créer un statsManager
        const createStatsManager = (toolType, scopeSelector, prefix = '') => {
            const statsElementId = (suffix) => (
                prefix
                    ? `${prefix}${suffix.charAt(0).toUpperCase()}${suffix.slice(1)}`
                    : suffix
            );
            // Helper pour récupérer le zonesManager (lazy evaluation)
            const getZonesManager = () => {
                if (toolType === 'isochrone') {
                    return typeof zonesManager !== 'undefined' ? zonesManager : null;
                } else if (toolType === 'import-table') {
                    return typeof importZonesManager !== 'undefined' ? importZonesManager : null;
                }
                return null;
            };

            return {
            chartInstance: null, // Instance Chart.js actuelle
            currentData: null, // Données actuelles chargées
            exportPromise: null,
            exportBusy: false,
            exportChoiceRevision: 0,
            renderRevision: 0,
            statsTableResizeObserver: null,

            // Helper: formatNumber (identique à celui utilisé ailleurs)
            formatNumber(num) {
                return Math.round(num).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
            },

            metricValue(row, fields) {
                for (const field of fields) {
                    const rawValue = row?.[field];
                    if (rawValue === null || rawValue === undefined || rawValue === '') {
                        continue;
                    }
                    const value = Number(rawValue);
                    if (Number.isFinite(value) && value >= 0) return value;
                }
                return null;
            },

            metricCoverage(rows, fields) {
                const values = (Array.isArray(rows) ? rows : []).map(
                    (row) => this.metricValue(row, fields),
                );
                const available = values.filter((value) => value !== null);
                return {
                    complete: values.length > 0 && available.length === values.length,
                    availableCount: available.length,
                    rowCount: values.length,
                    total: values.length > 0 && available.length === values.length
                        ? available.reduce((sum, value) => sum + value, 0)
                        : null,
                };
            },

            metricCoverageLabel(coverage) {
                return coverage.complete
                    ? `${coverage.rowCount} commune(s)`
                    : `Couverture incomplète : ${coverage.availableCount}/${coverage.rowCount} commune(s)`;
            },

            presentationSnapshot() {
                if (toolType !== 'isochrone') {
                    return {
                        mode: 'cumulative',
                        sourceMode: 'cumulative',
                        viewMode: 'cumulative',
                        label: 'Cumul',
                        projectionFingerprint: '',
                    };
                }
                const snapshot = exportZonePresentationController?.getSnapshot?.() || {};
                const sourceMode = snapshot.sourceMode === 'exclusive'
                    || snapshot.mode === 'exclusive'
                    ? 'exclusive'
                    : 'cumulative';
                const viewMode = ['cumulative', 'exclusive', 'comparison'].includes(
                    snapshot.viewMode,
                )
                    ? snapshot.viewMode
                    : sourceMode;
                return {
                    mode: viewMode,
                    sourceMode,
                    viewMode,
                    label: viewMode === 'exclusive'
                        ? 'Zone par zone'
                        : viewMode === 'comparison'
                            ? 'Comparaison'
                            : 'Cumul',
                    projectionFingerprint: viewMode === 'comparison'
                        ? snapshot.statsProjectionFingerprint || ''
                        : snapshot.projectionFingerprint || '',
                };
            },

            decoratePresentation(displayArea) {
                if (!displayArea) return;
                const renderRevision = this.renderRevision;
                const presentation = this.presentationSnapshot();
                displayArea.querySelector('.home-stats-presentation-badge')?.remove();
                const badge = document.createElement('p');
                badge.className = 'home-stats-presentation-badge';
                badge.dataset.mode = presentation.mode;
                badge.textContent = `Présentation des données : ${presentation.label}`;
                displayArea.prepend(badge);
                let attempts = 0;
                const syncChartTitle = () => {
                    if (renderRevision !== this.renderRevision) return;
                    if (this.chartInstance) {
                        const titleOptions = this.chartInstance.options?.plugins?.title;
                        if (titleOptions) {
                            titleOptions.display = true;
                            titleOptions.text = `Présentation : ${presentation.label}`;
                        }
                        this.chartInstance.update('none');
                        return;
                    }
                    attempts += 1;
                    if (attempts < 30 && this.currentData?.format === 'visual') {
                        window.setTimeout(syncChartTitle, 50);
                    }
                };
                syncChartTitle();
            },

            setChartAccessibility(canvas, title, summary) {
                if (!canvas) return;
                const descriptionId = `${canvas.id}Description`;
                let description = document.getElementById(descriptionId);
                if (!description) {
                    description = document.createElement('p');
                    description.id = descriptionId;
                    description.className = 'sr-only home-stats-chart-description';
                    canvas.insertAdjacentElement('afterend', description);
                }
                description.textContent = summary;
                canvas.setAttribute('role', 'img');
                canvas.setAttribute('aria-label', title);
                canvas.setAttribute('aria-describedby', descriptionId);
            },

            async loadChartConstructor() {
                if (typeof window.Chart !== 'undefined') {
                    return window.Chart;
                }
                try {
                    return await window.MaplyticsLazyAssets?.ensureChartJs?.();
                } catch (error) {
                    console.warn('Graphique indisponible:', error?.message || error);
                    return null;
                }
            },

            exportChoiceState() {
                const currentRows = Array.isArray(this.currentData?.data?.rows)
                    ? this.currentData.data.rows
                    : [];
                const controller = toolType === 'isochrone'
                    ? tableControllers.export
                    : tableControllers.import;
                const visibleDetailedRows = Array.isArray(controller?.filteredRows)
                    ? controller.filteredRows
                    : [];
                const detailedRows = Array.isArray(controller?.allRows)
                    ? controller.allRows
                    : [];
                const detailedColumns = Array.isArray(controller?.columns)
                    ? controller.columns
                    : [];
                const excelAllowed = typeof window.maplyticsHasFeature === 'function'
                    && window.maplyticsHasFeature('export_excel');
                const excel = (() => {
                    if (!excelAllowed) {
                        return {
                            available: false,
                            reason: 'Votre formule ne comprend pas l’export Excel détaillé.',
                        };
                    }
                    if (!detailedRows.length || !detailedColumns.length) {
                        return {
                            available: false,
                            reason: 'Pré-requis : affichez un résultat détaillé.',
                        };
                    }
                    return {
                        available: true,
                        reason: `${visibleDetailedRows.length} ligne(s) visible(s) sur ${detailedRows.length}, dans le classeur canonique à quatre feuilles.`,
                    };
                })();
                const visual = window.maplyticsGetVisualExportAvailability?.('export') || {
                    available: false,
                    reason: 'Pré-requis : créez et affichez une zone sur la carte.',
                };
                return {
                    excel,
                    visual,
                    statistics: {
                        available: currentRows.length > 0,
                        visualAvailable: Boolean(
                            currentRows.length
                            && this.currentData?.format === 'visual'
                            && this.chartInstance
                        ),
                        reason: currentRows.length
                            ? `${currentRows.length} ligne(s) statistique(s) prête(s).`
                            : 'Affichez d’abord une statistique.',
                    },
                };
            },

            syncExportChoices() {
                const state = this.exportChoiceState();
                if (!prefix) {
                    window.MaplyticsDetailedExportSurface?.syncChoiceBand?.(
                        'resultExportChoices',
                        [
                            {name: 'detail-xlsx', ...state.excel},
                            {name: 'visual-map', ...state.visual},
                        ],
                        {
                            busy: this.exportBusy,
                            busyMessage: 'Un export de statistique est déjà en cours.',
                        },
                    );
                    ['statsExportCSVBtn', 'statsExportSimplePDFBtn', 'statsExportPDFBtn'].forEach((buttonId) => {
                        const button = document.querySelector(
                            `${scopeSelector} #${statsElementId(buttonId)}`,
                        );
                        if (button) {
                            const isPngExport = buttonId === 'statsExportPDFBtn';
                            const available = isPngExport
                                ? state.statistics.visualAvailable
                                : state.statistics.available;
                            const entitled = !isPngExport || hasFeature('export_png_stats');
                            button.disabled = this.exportBusy || !available || !entitled;
                            button.setAttribute('aria-disabled', button.disabled ? 'true' : 'false');
                            if (isPngExport) {
                                button.dataset.premiumFeature = 'export_png_stats';
                                button.title = entitled
                                    ? 'Télécharger le graphique au format PNG'
                                    : 'Export graphique PNG inclus à partir du plan Starter.';
                            }
                        }
                    });
                }
                return state;
            },

            scheduleExportChoiceSync() {
                const revision = ++this.exportChoiceRevision;
                const startedAt = Date.now();
                const refresh = () => {
                    if (revision !== this.exportChoiceRevision) return;
                    this.syncExportChoices();
                    if (
                        this.currentData?.format === 'visual'
                        && !this.chartInstance
                        && Date.now() - startedAt < 3000
                    ) {
                        window.setTimeout(refresh, 50);
                    }
                };
                refresh();
            },

            setExportState(state, message) {
                const status = document.querySelector(
                    `${scopeSelector} #${statsElementId('statsExportStatus')}`,
                );
                const workspace = document.querySelector(
                    `${scopeSelector} #${statsElementId('statsContent')}`,
                );
                if (status) {
                    status.dataset.state = state;
                    status.textContent = message;
                }
                if (workspace) {
                    workspace.setAttribute('aria-busy', state === 'running' ? 'true' : 'false');
                }
                this.exportBusy = state === 'running';
                if (prefix) {
                    [
                        'statsExportCSVBtn',
                        'statsExportExcelBtn',
                        'statsExportSimplePDFBtn',
                        'statsExportPDFBtn',
                    ].forEach((buttonId) => {
                        const button = document.querySelector(
                            `${scopeSelector} #${statsElementId(buttonId)}`,
                        );
                        if (button) button.disabled = this.exportBusy;
                    });
                } else {
                    this.syncExportChoices();
                }
            },

            syncComparisonSelector() {
                if (toolType !== 'isochrone' || prefix) return null;
                const root = document.getElementById('statsComparisonSelector');
                const choices = root?.querySelector('[data-stats-comparison-choices]');
                const status = root?.querySelector('[data-stats-comparison-status]');
                const zoneSelect = document.getElementById('statsZoneSelect');
                if (!root || !choices || !status || !zoneSelect) return null;
                const comparison = this.presentationSnapshot().viewMode === 'comparison';
                root.hidden = !comparison;
                root.setAttribute('aria-hidden', String(!comparison));
                if (!comparison) return {visible: false, selected: []};

                const zm = getZonesManager();
                const currentZones = new Map(
                    Array.from(zm?.zones?.values?.() || []).map((zone) => [String(zone.id), zone]),
                );
                const metricSeries = window.maplyticsGetZoneMetricSeries?.();
                const seriesById = new Map(
                    (metricSeries?.series || []).map((zone) => [String(zone.zoneId), zone]),
                );
                const selectedOptions = new Set(
                    Array.from(zoneSelect.selectedOptions).map((option) => option.value),
                );
                const globalSelected = selectedOptions.has('global');
                const entries = Array.from(zoneSelect.options)
                    .filter((option) => option.value !== 'global')
                    .map((option, index) => {
                        const id = String(option.value);
                        const zone = currentZones.get(id) || {};
                        const series = seriesById.get(id) || null;
                        const visible = series ? series.visible !== false : zone.visible !== false;
                        const available = Boolean(
                            series
                            && series.geometryStatus === 'available'
                            && series.geometry,
                        );
                        const pointName = String(
                            series?.pointName
                            || zone.pointName
                            || zone.origin?.display_name
                            || zone.origin?.label
                            || `Point ${index + 1}`,
                        );
                        const zoneName = String(series?.name || zone.name || option.textContent || id);
                        const rangeLabel = String(
                            series?.rangeLabel
                            || (Number.isFinite(Number(zone.minutes)) ? `${Number(zone.minutes)} min` : '')
                            || (Number.isFinite(Number(zone.distance)) ? `${Number(zone.distance)} km` : ''),
                        );
                        const reason = !visible
                            ? 'Cette ZDC est masquée sur la carte.'
                            : !available
                                ? 'La projection vérifiée de cette ZDC est indisponible.'
                                : '';
                        return {
                            id,
                            pointName,
                            zoneName,
                            rangeLabel,
                            color: /^#[0-9a-f]{6}$/i.test(String(series?.color || zone.color || ''))
                                ? String(series?.color || zone.color)
                                : '#64748b',
                            visible,
                            available,
                            disabled: Boolean(reason),
                            reason,
                            checked: !reason && (globalSelected || selectedOptions.has(id)),
                        };
                    });
                if (globalSelected) {
                    const eligibleIds = new Set(
                        entries.filter((entry) => !entry.disabled).map((entry) => entry.id),
                    );
                    Array.from(zoneSelect.options).forEach((option) => {
                        option.selected = option.value !== 'global' && eligibleIds.has(option.value);
                    });
                }
                choices.innerHTML = entries.map((entry) => `
                    <label class="home-stats-comparison-choice${entry.disabled ? ' is-unavailable' : ''}" style="--zone-color: ${entry.color};" title="${this.escapeHtml(entry.reason || entry.zoneName)}">
                        <input type="checkbox" value="${this.escapeHtml(entry.id)}" ${entry.checked ? 'checked' : ''} ${entry.disabled ? 'disabled' : ''}>
                        <span class="home-stats-comparison-choice__swatch" aria-hidden="true"></span>
                        <span class="home-stats-comparison-choice__copy">
                            <strong>${this.escapeHtml(entry.pointName)}</strong>
                            <span>${this.escapeHtml(entry.zoneName)}</span>
                            <small>${this.escapeHtml(entry.rangeLabel || (entry.visible ? 'Visible' : 'Masquée'))}${entry.reason ? ` · ${this.escapeHtml(entry.reason)}` : ''}</small>
                        </span>
                    </label>
                `).join('');
                const selected = entries.filter((entry) => entry.checked).map((entry) => entry.id);
                status.textContent = selected.length >= 2
                    ? `${selected.length} ZDC sélectionnées pour la comparaison.`
                    : 'Sélectionnez au moins deux ZDC visibles et vérifiées.';
                status.dataset.state = selected.length >= 2 ? 'ready' : 'incomplete';
                if (root.dataset.comparisonBound !== '1') {
                    root.dataset.comparisonBound = '1';
                    choices.addEventListener('change', () => {
                        const enabled = Array.from(choices.querySelectorAll('input:not(:disabled)'));
                        const checked = enabled.filter((input) => input.checked).map((input) => input.value);
                        const allChecked = enabled.length > 0 && checked.length === enabled.length;
                        Array.from(zoneSelect.options).forEach((option) => {
                            option.selected = option.value === 'global'
                                ? allChecked
                                : !allChecked && checked.includes(option.value);
                        });
                        zoneSelect.dispatchEvent(new Event('change', {bubbles: true}));
                    });
                }
                return {visible: true, selected, entries};
            },

            // Mettre à jour le sélecteur de zones disponibles
            updateZonesSelect() {
                const zoneSelectEl = document.querySelector(`${scopeSelector} #${statsElementId('statsZoneSelect')}`);
                if (!zoneSelectEl) return;

                // Garder l'option "Global"
                zoneSelectEl.innerHTML = '<option value="global" selected>Global (toutes les zones)</option>';

                if (toolType === 'isochrone') {
                    // Pour Isochrone: récupérer les zones depuis zonesManager
                    const zm = getZonesManager();
                    if (zm && zm.zones && zm.zones.size > 0) {
                        const zonesArray = Array.from(zm.zones.values());
                        // Trier par minutes (croissant)
                        zonesArray.sort((a, b) => (
                            ((a.minutes || 0) - (b.minutes || 0))
                            || String(a.id).localeCompare(String(b.id))
                        ));

                        zonesArray.forEach(zone => {
                            const option = document.createElement('option');
                            option.value = zone.id;
                            option.textContent = zone.name;
                            zoneSelectEl.appendChild(option);
                        });
                    }
                } else if (toolType === 'import-table') {
                    // Pour Import-table: toujours "Global" uniquement (pas de zones multiples)
                    // Le sélecteur reste avec uniquement "Global"
                }
                this.syncComparisonSelector();
                this.syncExportChoices();
            },

            // Récupérer les données pour les zones sélectionnées
            getDataForZones(selectedZones) {
                if (!selectedZones || selectedZones.length === 0) {
                    return { rows: [], zones: [] };
                }

                const isGlobal = selectedZones.includes('global') || (selectedZones.length === 1 && selectedZones[0] === 'global');

                if (toolType === 'isochrone') {
                    // Pour Isochrone: récupérer depuis zonesManager.zones
                    const zm = getZonesManager();
                    if (!zm) return { rows: [], zones: [] };

                    const availableZones = Array.from(zm.zones.values());
                    const selectedZonesList = isGlobal
                        ? availableZones
                        : selectedZones.map((zoneId) => (
                            availableZones.find((zone) => zone.id === zoneId)
                        )).filter(Boolean);
                    const zoneSeries = window.maplyticsGetZoneMetricSeries?.() || null;
                    if (['exclusive', 'comparison'].includes(
                        this.presentationSnapshot().viewMode,
                    )) {
                        return {
                            rows: [],
                            zones: selectedZonesList,
                            zoneSeries,
                        };
                    }
                    const selectedDatasetRefs = new Set(
                        selectedZonesList.map((zone) => String(zone.id)),
                    );
                    const projectedRows = zm.getAggregatedRowsForZones(availableZones);
                    const globalRows = (() => {
                        const unique = new Map();
                        const withoutIdentity = [];
                        const zonesByDatasetRef = new Map(availableZones.map((zone) => (
                            [String(zone.id), zone]
                        )));
                        projectedRows.forEach((row) => {
                            const identity = String(
                                row?.code_insee ?? row?.code_commune ?? '',
                            ).trim().toUpperCase();
                            if (!identity) {
                                withoutIdentity.push(row);
                                return;
                            }
                            const datasetRef = String(row?.zone_dataset_ref || '');
                            const sourceZone = zonesByDatasetRef.get(datasetRef);
                            const groupKey = sourceZone
                                ? zm.getZoneAggregationGroupKey(sourceZone)
                                : `dataset:${datasetRef || 'unknown'}`;
                            const aggregationIdentity = `${groupKey}|${identity}`;
                            const rangeUpper = Number(
                                row?.zone_duration_min
                                ?? row?.zone_distance_km
                                ?? sourceZone?.minutes
                                ?? sourceZone?.distance,
                            );
                            const previous = unique.get(aggregationIdentity);
                            if (
                                !previous
                                || (
                                    Number.isFinite(rangeUpper)
                                    && rangeUpper < previous.rangeUpper
                                )
                            ) {
                                unique.set(aggregationIdentity, {
                                    rangeUpper: Number.isFinite(rangeUpper)
                                        ? rangeUpper
                                        : Number.POSITIVE_INFINITY,
                                    row,
                                });
                            }
                        });
                        return [
                            ...Array.from(unique.values(), (entry) => entry.row),
                            ...withoutIdentity,
                        ];
                    })();
                    const rows = (isGlobal
                        ? globalRows
                        : projectedRows.filter((row) => (
                            selectedDatasetRefs.has(String(row.zone_dataset_ref))
                        ))
                    ).map(
                        (row) => ({ ...row, zone_name: row.zone_chalandise }),
                    );
                    return { rows, zones: selectedZonesList, zoneSeries };
                } else if (toolType === 'import-table') {
                    // Bug #7 Fix: Pour Import-table, récupérer depuis tableControllers.import.allRows
                    // Ces données sont les rows enrichies par le backend avec les données démographiques
                    const controller = tableControllers.import;
                    (window.debugLog || (()=>{}))('[import-table] getDataForZones controller.allRows:', controller?.allRows?.length || 0);
                    if (controller && controller.allRows && controller.allRows.length > 0) {
                        // Créer une structure compatible avec le format isochrone
                        const rows = controller.allRows.map(r => ({
                            ...r,
                            zone_name: 'Global',
                            // S'assurer que les champs démographiques sont accessibles
                            population: r.population ?? r.Population ?? null,
                            menages: r.menages ?? r.Menages ?? r.ménages ?? null,
                            revenus: r.revenus ?? r.Revenus ?? r.revenu ?? null,
                            age_moyen: r.age_moyen ?? r['Age moyen'] ?? r.age ?? null,
                        }));
                        debugLog('[import-table] rows formatées:', rows.length, 'Exemple:', rows[0]);
                        return { rows: rows, zones: [{ name: 'Global', minutes: 0 }] };
                    }
                    console.warn('[Bug #7] import-table: Aucune donnée dans tableControllers.import.allRows');
                    return { rows: [], zones: [] };
                }

                return { rows: [], zones: [] };
            },

            // Agrégation des données (pour mode "Global" avec différences)
            aggregateData(rows, selectedZones) {
                if (!rows || rows.length === 0) {
                    return { total: 0, aggregated: {} };
                }
                const population = this.metricCoverage(rows, ['population', 'Population']);
                const households = this.metricCoverage(
                    rows,
                    ['menages', 'Menages', 'ménages'],
                );
                return {
                    total: rows.length,
                    aggregated: {
                        population: population.total,
                        menages: households.total,
                    },
                };
            },

            escapeHtml(value) {
                return String(value ?? '')
                    .replaceAll('&', '&amp;')
                    .replaceAll('<', '&lt;')
                    .replaceAll('>', '&gt;')
                    .replaceAll('"', '&quot;')
                    .replaceAll("'", '&#039;');
            },

            formatZoneMetricValue(value, statType) {
                if (!Number.isFinite(value)) return '—';
                if (statType === 'age_moyen') return `${value.toFixed(1)} ans`;
                if (statType === 'revenus') return `${this.formatNumber(value)} €`;
                return this.formatNumber(value);
            },

            renderZoneSeriesStats(model, matrix, format, displayArea, renderRevision) {
                const comparison = model.viewMode === 'comparison';
                const unavailableCount = matrix.rows.reduce(
                    (total, row) => total + row.values.filter((value) => value === null).length,
                    0,
                );
                const tableHead = matrix.zones.map((zone) => `
                    <th scope="col">
                        <span class="home-stats-zone-series__swatch" style="--zone-color: ${zone.color};" aria-hidden="true"></span>
                        ${this.escapeHtml(zone.label)}
                    </th>
                `).join('');
                const tableFamilyDefinitions = [
                    ['summary', 'Synthèse', ['population', 'menages', 'logements_secondaires', 'age_moyen']],
                    ['income', 'Revenus', ['revenus']],
                    ['age', 'Âges', ['age']],
                    ['csp', 'Catégories socioprofessionnelles', ['csp']],
                    ['households', 'Ménages', ['menages_repartition']],
                    ['housing', 'Logements', ['logements_type']],
                ];
                const renderMetricRow = (row) => `
                    <tr class="home-stats-zone-series__metric-row" data-stat-type="${this.escapeHtml(row.statType)}" data-metric-id="${this.escapeHtml(row.id)}">
                        <th scope="row">
                            <span>${this.escapeHtml(row.kind === 'grouped' ? row.category : row.label)}</span>
                        </th>
                        <td class="home-stats-zone-series__unit">${this.escapeHtml(row.unit)}</td>
                        ${matrix.zones.map((zone, zoneIndex) => {
                            const value = row.values[zoneIndex];
                            const reason = value === null ? row.reasons[zoneIndex] : '';
                            const detail = row.details?.[zoneIndex] || {};
                            const rowCount = Number(detail.rowCount) || 0;
                            const availableCount = Number(detail.availableCount) || 0;
                            const coverage = rowCount > 0
                                ? availableCount === rowCount
                                    ? `Couverture ${availableCount}/${rowCount} commune(s)`
                                    : `Couverture incomplète : ${availableCount}/${rowCount} commune(s)`
                                : '';
                            const provenance = row.statType === 'revenus'
                                ? `${coverage}${coverage ? ' · ' : ''}Millésime ${
                                    detail.vintages?.length ? detail.vintages.join(', ') : 'non renseigné'
                                }`
                                : coverage;
                            return `<td${reason ? ` title="${this.escapeHtml(reason)}"` : ''}>
                                <strong>${value === null
                                    ? 'Indisponible'
                                    : this.formatZoneMetricValue(value, row.statType)}</strong>
                                ${provenance ? `<small>${this.escapeHtml(provenance)}</small>` : ''}
                                ${reason ? `<small>${this.escapeHtml(reason)}</small>` : ''}
                            </td>`;
                        }).join('')}
                    </tr>
                `;
                const tableColumnCount = matrix.zones.length + 2;
                const tableBodies = tableFamilyDefinitions.map(([
                    familyId,
                    familyLabel,
                    statTypes,
                ]) => {
                    const familyRows = matrix.rows.filter(
                        (row) => statTypes.includes(row.statType),
                    );
                    if (!familyRows.length) return '';
                    const headingId = `${prefix}zoneStatsFamily-${familyId}`;
                    return `
                        <tbody
                            data-stat-family="${this.escapeHtml(familyId)}"
                            aria-labelledby="${this.escapeHtml(headingId)}"
                        >
                            <tr class="home-stats-zone-series__family-row">
                                <th
                                    id="${this.escapeHtml(headingId)}"
                                    scope="rowgroup"
                                    colspan="${tableColumnCount}"
                                >
                                    <span>${this.escapeHtml(familyLabel)}</span>
                                    <small>${familyRows.length} indicateur(s)</small>
                                </th>
                            </tr>
                            ${familyRows.map(renderMetricRow).join('')}
                        </tbody>
                    `;
                }).join('');
                const totalBlock = model.total.status === 'verified'
                    ? `
                        <div class="home-stats-zone-series__verified-total">
                            <span>Somme inter-zones vérifiée</span>
                            <strong>${this.formatZoneMetricValue(model.total.value, model.statType)}</strong>
                        </div>
                    `
                    : model.total.status === 'unavailable'
                        ? '<p class="home-stats-zone-series__notice">Total inter-zones non affiché : invariant additif ou couverture incomplet.</p>'
                        : '';
                const canvasId = `${prefix}zoneSeriesStatsChart`;
                displayArea.innerHTML = `
                    <section
                        class="home-stats-zone-series"
                        data-zone-stats-model="${model.version}"
                        data-source-mode="${this.escapeHtml(model.sourceMode)}"
                        data-view-mode="${this.escapeHtml(model.viewMode)}"
                        data-projection-fingerprint="${this.escapeHtml(model.projectionFingerprint)}"
                        data-zone-stats-matrix="${this.escapeHtml(matrix.version)}"
                        data-zone-stats-matrix-fingerprint="${this.escapeHtml(matrix.fingerprint)}"
                        aria-labelledby="${prefix}zoneSeriesStatsTitle"
                    >
                        <header class="home-stats-zone-series__header">
                            <div>
                                <h4 id="${prefix}zoneSeriesStatsTitle">${comparison ? 'Comparaison · ' : ''}${this.escapeHtml(model.label)} par zone</h4>
                                <p>${matrix.zones.length} ${comparison ? 'ZDC comparée(s)' : 'tranche(s)'} · ${matrix.rows.length} indicateur(s) détaillé(s) · ${unavailableCount
                                    ? `${unavailableCount} valeur(s) indisponible(s)`
                                    : 'couverture complète'}</p>
                            </div>
                            <span>Empreinte ${this.escapeHtml(model.projectionFingerprint.slice(0, 8))}</span>
                        </header>
                        ${totalBlock}
                        ${format === 'visual' && model.available
                            ? `<div class="home-stats-zone-series__chart"><canvas id="${canvasId}"></canvas></div>`
                            : ''}
                        ${!model.available
                            ? `<p class="home-stats-zone-series__notice" role="status">${this.escapeHtml(model.reason)}</p>`
                            : ''}
                        <div class="home-stats-zone-series__table-wrap">
                            <table class="home-stats-zone-series__table">
                                <caption>Ensemble des indicateurs par zone. Le graphique présente ${this.escapeHtml(model.label)}.</caption>
                                <thead><tr><th scope="col">Indicateur</th><th scope="col">Unité</th>${tableHead}</tr></thead>
                                ${tableBodies}
                            </table>
                        </div>
                        <p class="home-stats-zone-series__scroll-hint" hidden>
                            Faites défiler le tableau horizontalement pour consulter toutes les zones.
                        </p>
                    </section>
                `;
                this.statsTableResizeObserver?.disconnect?.();
                this.statsTableResizeObserver = null;
                const tableWrap = displayArea.querySelector(
                    '.home-stats-zone-series__table-wrap',
                );
                const scrollHint = displayArea.querySelector(
                    '.home-stats-zone-series__scroll-hint',
                );
                const syncTableOverflow = () => {
                    if (renderRevision !== this.renderRevision || !tableWrap?.isConnected) {
                        return;
                    }
                    const overflow = tableWrap.scrollWidth > tableWrap.clientWidth + 1;
                    tableWrap.dataset.horizontalOverflow = overflow ? 'true' : 'false';
                    if (scrollHint) scrollHint.hidden = !overflow;
                };
                window.requestAnimationFrame(syncTableOverflow);
                if (typeof ResizeObserver === 'function' && tableWrap) {
                    this.statsTableResizeObserver = new ResizeObserver(syncTableOverflow);
                    this.statsTableResizeObserver.observe(tableWrap);
                }
                if (format !== 'visual' || !model.available) return;
                const summary = model.zones.map((zone) => (
                    `${zone.label}: ${zone.values.map((value, index) => (
                        `${model.categories[index]} ${this.formatZoneMetricValue(value, model.statType)}`
                    )).join(', ')}`
                )).join('; ');
                window.setTimeout(async () => {
                    const canvas = document.getElementById(canvasId);
                    if (renderRevision !== this.renderRevision || !canvas?.isConnected) return;
                    this.setChartAccessibility(
                        canvas,
                        `${model.label} par zone`,
                        summary,
                    );
                    const ChartConstructor = await this.loadChartConstructor();
                    if (
                        renderRevision !== this.renderRevision
                        || !canvas.isConnected
                        || !ChartConstructor
                    ) return;
                    const horizontal = ['horizontal_scalar', 'composition_100'].includes(
                        model.chartMode,
                    );
                    const composition = model.chartMode === 'composition_100';
                    const categoryColors = [
                        '#2563eb', '#0f766e', '#9333ea', '#ea580c', '#be123c',
                        '#0369a1', '#4d7c0f', '#a16207',
                    ];
                    const chartLabels = horizontal
                        ? model.zones.map((zone) => zone.chartLabel)
                        : [...model.categories];
                    const datasets = model.chartMode === 'horizontal_scalar'
                        ? [{
                            label: model.label,
                            data: model.zones.map((zone, index) => (
                                model.chartValues[index]?.[0] ?? null
                            )),
                            backgroundColor: model.zones.map((zone) => zone.color),
                            borderColor: model.zones.map((zone) => zone.color),
                            borderWidth: 1,
                        }]
                        : composition
                            ? model.categories.map((category, categoryIndex) => ({
                                label: category,
                                data: model.zones.map((zone, zoneIndex) => (
                                    model.chartValues[zoneIndex]?.[categoryIndex] ?? null
                                )),
                                backgroundColor: categoryColors[
                                    categoryIndex % categoryColors.length
                                ],
                                borderWidth: 0,
                            }))
                            : model.zones.map((zone, zoneIndex) => ({
                                label: zone.chartLabel,
                                data: [...(model.chartValues[zoneIndex] || [])],
                                backgroundColor: zone.color,
                                borderColor: zone.color,
                                borderWidth: 1,
                            }));
                    const scalarValueLabels = {
                        id: 'maplyticsScalarValueLabels',
                        afterDatasetsDraw: (chart) => {
                            if (model.chartMode !== 'horizontal_scalar') return;
                            const context = chart.ctx;
                            context.save();
                            context.fillStyle = '#172033';
                            context.font = '600 11px system-ui, sans-serif';
                            chart.getDatasetMeta(0).data.forEach((bar, index) => {
                                const value = datasets[0].data[index];
                                if (!Number.isFinite(value)) return;
                                const position = bar.tooltipPosition();
                                context.fillText(
                                    this.formatZoneMetricValue(value, model.statType),
                                    Math.min(position.x + 6, chart.chartArea.right - 92),
                                    position.y + 4,
                                );
                            });
                            context.restore();
                        },
                    };
                    this.chartInstance = new ChartConstructor(canvas.getContext('2d'), {
                        type: 'bar',
                        data: {
                            labels: chartLabels,
                            datasets,
                        },
                        plugins: [scalarValueLabels],
                        options: {
                            indexAxis: horizontal ? 'y' : 'x',
                            responsive: true,
                            maintainAspectRatio: false,
                            plugins: {
                                legend: {display: true, position: 'top'},
                                tooltip: {
                                    callbacks: {
                                        label: (context) => {
                                            const value = horizontal
                                                ? context.parsed.x
                                                : context.parsed.y;
                                            return composition
                                                ? `${context.dataset.label}: ${Number(value).toFixed(1)} %`
                                                : `${context.dataset.label}: ${this.formatZoneMetricValue(
                                                    value,
                                                    model.statType,
                                                )}`;
                                        },
                                    },
                                },
                            },
                            scales: composition
                                ? {
                                    x: {
                                        beginAtZero: true,
                                        max: 100,
                                        stacked: true,
                                        ticks: {callback: (value) => `${value} %`},
                                    },
                                    y: {stacked: true},
                                }
                                : horizontal
                                    ? {x: {beginAtZero: true}, y: {stacked: false}}
                                    : {x: {stacked: false}, y: {beginAtZero: true}},
                        },
                    });
                }, 50);
            },

            // Rendu des statistiques (routeur vers méthodes spécifiques)
            renderStats(statType, format = 'visual') {
                const displayArea = document.querySelector(`${scopeSelector} #${statsElementId('statsDisplayArea')}`);
                if (!displayArea) return;
                const renderRevision = ++this.renderRevision;
                this.currentData = null;
                this.destroyChart();
                this.syncComparisonSelector();
                this.scheduleExportChoiceSync();

                // Gate interactive_charts
                if (typeof PremiumGate !== 'undefined') {
                    const chartGate = PremiumGate.check('interactive_charts');
                    if (chartGate.level !== 'premium') {
                        displayArea.innerHTML = PremiumGate.renderLock({
                            featureCode: 'interactive_charts',
                            title: 'Graphiques interactifs',
                            description: 'Pyramide des âges, CSP, revenus, répartition des ménages et plus encore.',
                            previewHTML: PremiumGate.renderSkeletonStats(4),
                        }, chartGate);
                        return;
                    }
                }

                const zoneSelect = document.querySelector(`${scopeSelector} #${statsElementId('statsZoneSelect')}`);
                const selectedZones = zoneSelect ? Array.from(zoneSelect.selectedOptions).map(opt => opt.value) : [];

                if (selectedZones.length === 0) {
                    displayArea.innerHTML = '<div style="text-align: center; color: #64748b; padding: 2rem;"><p style="margin: 0; font-size: 0.9rem; font-style: italic;">Sélectionnez une zone pour afficher les statistiques</p></div>';
                    return;
                }

                const data = this.getDataForZones(selectedZones);
                const presentation = this.presentationSnapshot();
                const zoneStatsModel = data.zoneSeries
                    && window.MaplyticsZoneMetricSeries?.buildStatsModel
                    ? window.MaplyticsZoneMetricSeries.buildStatsModel(
                        data.zoneSeries,
                        statType,
                        selectedZones,
                        {viewMode: presentation.viewMode},
                    )
                    : null;
                const zoneStatsMatrix = data.zoneSeries
                    && window.MaplyticsZoneMetricSeries?.buildStatsMatrix
                    ? window.MaplyticsZoneMetricSeries.buildStatsMatrix(
                        data.zoneSeries,
                        selectedZones,
                        {viewMode: presentation.viewMode},
                    )
                    : null;
                if (zoneStatsModel && zoneStatsMatrix) {
                    const matrixRows = zoneStatsMatrix.rows.map((row) => ({
                        indicator: row.label,
                        unit: row.unit,
                        ...Object.fromEntries(zoneStatsMatrix.zones.map((zone, index) => [
                            zone.label,
                            row.values[index] ?? 'Indisponible',
                        ])),
                    }));
                    const zoneData = {
                        ...data,
                        rows: matrixRows,
                        zoneStatsModel,
                        zoneStatsMatrix,
                    };
                    this.currentData = {
                        statType,
                        format,
                        data: zoneData,
                        selectedZones,
                        presentation,
                    };
                    this.renderZoneSeriesStats(
                        zoneStatsModel,
                        zoneStatsMatrix,
                        format,
                        displayArea,
                        renderRevision,
                    );
                    this.decoratePresentation(displayArea);
                    this.scheduleExportChoiceSync();
                    return;
                }
                if (!data.rows || data.rows.length === 0) {
                    displayArea.innerHTML = '<div style="text-align: center; color: #64748b; padding: 2rem;"><p style="margin: 0; font-size: 0.9rem; font-style: italic;">Aucune donnée disponible pour les zones sélectionnées</p></div>';
                    return;
                }

                // Stocker les données actuelles
                this.currentData = {
                    statType,
                    format,
                    data,
                    selectedZones,
                    presentation,
                };

                // Router vers la méthode spécifique selon le type de statistique
                switch(statType) {
                    case 'population':
                        this.renderPopulation(data, format, displayArea);
                        break;
                    case 'menages':
                        this.renderMenages(data, format, displayArea);
                        break;
                    case 'logements_type':
                        this.renderLogementsType(data, format, displayArea);
                        break;
                    case 'csp':
                        this.renderCSP(data, format, displayArea);
                        break;
                    case 'age':
                        this.renderAgePyramid(data, format, displayArea);
                        break;
                    case 'menages_repartition':
                        this.renderMenagesRepartition(data, format, displayArea);
                        break;
                    case 'logements_secondaires':
                        this.renderLogementsSecondaires(data, format, displayArea);
                        break;
                    case 'revenus':
                        this.renderRevenus(data, format, displayArea);
                        break;
                    case 'age_moyen':
                        this.renderAgeMoyen(data, format, displayArea);
                        break;
                    default:
                        displayArea.innerHTML = `<div style="text-align: center; color: #64748b; padding: 2rem;"><p style="margin: 0; font-size: 0.9rem; font-style: italic;">Statistique "${statType}" - Fonctionnalité en cours de développement...</p></div>`;
                }
                this.decoratePresentation(displayArea);
                this.scheduleExportChoiceSync();
            },

            // Rendu statistique Population
            renderPopulation(data, format, displayArea) {
                const renderRevision = this.renderRevision;
                const rows = data.rows || [];
                const populationCoverage = this.metricCoverage(
                    rows,
                    ['population', 'Population'],
                );
                const totalPopulationLabel = populationCoverage.total === null
                    ? 'Non disponible'
                    : this.formatNumber(populationCoverage.total);
                const populationRanking = rows
                    .map((row) => ({
                        label: row.nom_commune || row.commune || 'Commune non renseignée',
                        value: this.metricValue(row, ['population', 'Population']),
                    }))
                    .filter((item) => item.value !== null)
                    .sort((left, right) => right.value - left.value)
                    .slice(0, 10);

                if (format === 'visual') {
                    // Format visuel : Graphique en barres Chart.js
                    // Pour simplifier, on affiche un graphique avec le total
                    // (on pourrait aussi grouper par zone si multi-zones)
                    displayArea.innerHTML = `
                        <div style="padding: 1rem;">
                            <div style="margin-bottom: 1rem; padding: 0.75rem; background: #f8fafc; border-radius: 0.5rem; border-left: 4px solid #2563eb;">
                                <div style="font-size: 0.85rem; color: #64748b; margin-bottom: 0.25rem;">Population totale</div>
                                <div style="font-size: 1.5rem; font-weight: 600; color: #0f172a;">${totalPopulationLabel}</div>
                                <div style="font-size: 0.75rem; color: #64748b; margin-top: 0.25rem;">${this.metricCoverageLabel(populationCoverage)}</div>
                            </div>
                            <div style="position: relative; height: 300px;">
                                <canvas id="${prefix}populationChart"></canvas>
                            </div>
                            <p class="home-stats-chart-description">Communes classées par population, dans la limite des 10 premières.</p>
                        </div>
                    `;

                    // Créer le graphique Chart.js après un court délai pour s'assurer que le canvas est dans le DOM
                    setTimeout(async () => {
                        const canvas = document.getElementById(`${prefix}populationChart`);
                        if (!canvas) return;
                        if (renderRevision !== this.renderRevision) return;
                        this.setChartAccessibility(
                            canvas,
                            'Classement des communes par population',
                            populationRanking.map((item) => `${item.label}: ${this.formatNumber(item.value)}`).join(', '),
                        );

                        const ctx = canvas.getContext('2d');

                        const ChartConstructor = await this.loadChartConstructor();
                        if (renderRevision !== this.renderRevision) return;
                        if (ChartConstructor && canvas.isConnected && populationRanking.length > 0) {
                            this.chartInstance = new ChartConstructor(ctx, {
                                type: 'bar',
                                data: {
                                    labels: populationRanking.map((item) => item.label),
                                    datasets: [{
                                        label: 'Population',
                                        data: populationRanking.map((item) => item.value),
                                        backgroundColor: '#2563eb',
                                        borderColor: '#1e40af',
                                        borderWidth: 1
                                    }]
                                },
                                options: {
                                    indexAxis: 'y',
                                    responsive: true,
                                    maintainAspectRatio: false,
                                    plugins: {
                                        legend: {
                                            display: false
                                        },
                                        tooltip: {
                                            callbacks: {
                                                label: (context) => {
                                                    return `Population: ${this.formatNumber(context.parsed.x)} habitants`;
                                                }
                                            }
                                        }
                                    },
                                    scales: {
                                        x: {
                                            beginAtZero: true,
                                            ticks: {
                                                callback: (value) => {
                                                    return this.formatNumber(value);
                                                }
                                            }
                                        }
                                    }
                                }
                            });
                        }
                    }, 50);

                } else {
                    // Format brut : Tableau HTML
                    let tableHTML = `
                        <div style="padding: 1rem;">
                            <div style="margin-bottom: 1rem; padding: 0.75rem; background: #f8fafc; border-radius: 0.5rem; border-left: 4px solid #2563eb;">
                                <div style="font-size: 0.85rem; color: #64748b; margin-bottom: 0.25rem;">Population totale</div>
                                <div style="font-size: 1.5rem; font-weight: 600; color: #0f172a;">${totalPopulationLabel}</div>
                                <div style="font-size: 0.75rem; color: #64748b; margin-top: 0.25rem;">${this.metricCoverageLabel(populationCoverage)}</div>
                            </div>
                            <div style="overflow-x: auto;">
                                <table style="width: 100%; border-collapse: collapse; font-size: 0.9rem;">
                                    <thead>
                                        <tr style="background: #f8fafc; border-bottom: 2px solid #e2e8f0;">
                                            <th style="padding: 0.75rem; text-align: left; font-weight: 600; color: #0f172a;">Commune</th>
                                            <th style="padding: 0.75rem; text-align: right; font-weight: 600; color: #0f172a;">Population</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                    `;

                    // Trier par population décroissante
                    const sortedRows = [...rows].sort((a, b) => {
                        const popA = this.metricValue(a, ['population', 'Population']);
                        const popB = this.metricValue(b, ['population', 'Population']);
                        return (popB ?? -1) - (popA ?? -1);
                    });

                    sortedRows.forEach(row => {
                        const pop = this.metricValue(row, ['population', 'Population']);
                        const communeName = row.nom_commune || row.commune || 'N/A';

                        tableHTML += `
                            <tr style="border-bottom: 1px solid #e2e8f0;">
                                <td style="padding: 0.75rem; color: #334155;">${communeName}</td>
                                <td style="padding: 0.75rem; text-align: right; color: #0f172a; font-weight: 500;">${pop !== null ? this.formatNumber(pop) : '-'}</td>
                            </tr>
                        `;
                    });

                    tableHTML += `
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    `;

                    displayArea.innerHTML = tableHTML;
                }
            },

            // Rendu statistique Ménages
            renderMenages(data, format, displayArea) {
                const renderRevision = this.renderRevision;
                const rows = data.rows || [];
                const householdCoverage = this.metricCoverage(
                    rows,
                    ['menages', 'Menages', 'ménages'],
                );
                const totalMenagesLabel = householdCoverage.total === null
                    ? 'Non disponible'
                    : this.formatNumber(householdCoverage.total);
                const householdRanking = rows
                    .map((row) => ({
                        label: row.nom_commune || row.commune || 'Commune non renseignée',
                        value: this.metricValue(row, ['menages', 'Menages', 'ménages']),
                    }))
                    .filter((item) => item.value !== null)
                    .sort((left, right) => right.value - left.value)
                    .slice(0, 10);

                if (format === 'visual') {
                    // Format visuel : Graphique en barres Chart.js
                    displayArea.innerHTML = `
                        <div style="padding: 1rem;">
                            <div style="margin-bottom: 1rem; padding: 0.75rem; background: #f8fafc; border-radius: 0.5rem; border-left: 4px solid #7c3aed;">
                                <div style="font-size: 0.85rem; color: #64748b; margin-bottom: 0.25rem;">Ménages totaux</div>
                                <div style="font-size: 1.5rem; font-weight: 600; color: #0f172a;">${totalMenagesLabel}</div>
                                <div style="font-size: 0.75rem; color: #64748b; margin-top: 0.25rem;">${this.metricCoverageLabel(householdCoverage)}</div>
                            </div>
                            <div style="position: relative; height: 300px;">
                                <canvas id="${prefix}menagesChart"></canvas>
                            </div>
                            <p class="home-stats-chart-description">Communes classées par nombre de ménages, dans la limite des 10 premières.</p>
                        </div>
                    `;

                    // Créer le graphique Chart.js après un court délai pour s'assurer que le canvas est dans le DOM
                    setTimeout(async () => {
                        const canvas = document.getElementById(`${prefix}menagesChart`);
                        if (!canvas) return;
                        if (renderRevision !== this.renderRevision) return;
                        this.setChartAccessibility(
                            canvas,
                            'Classement des communes par nombre de ménages',
                            householdRanking.map((item) => `${item.label}: ${this.formatNumber(item.value)}`).join(', '),
                        );

                        const ctx = canvas.getContext('2d');

                        const ChartConstructor = await this.loadChartConstructor();
                        if (renderRevision !== this.renderRevision) return;
                        if (ChartConstructor && canvas.isConnected && householdRanking.length > 0) {
                            this.chartInstance = new ChartConstructor(ctx, {
                                type: 'bar',
                                data: {
                                    labels: householdRanking.map((item) => item.label),
                                    datasets: [{
                                        label: 'Ménages',
                                        data: householdRanking.map((item) => item.value),
                                        backgroundColor: '#7c3aed',
                                        borderColor: '#6d28d9',
                                        borderWidth: 1
                                    }]
                                },
                                options: {
                                    indexAxis: 'y',
                                    responsive: true,
                                    maintainAspectRatio: false,
                                    plugins: {
                                        legend: {
                                            display: false
                                        },
                                        tooltip: {
                                            callbacks: {
                                                label: (context) => {
                                                    return `Ménages: ${this.formatNumber(context.parsed.x)}`;
                                                }
                                            }
                                        }
                                    },
                                    scales: {
                                        x: {
                                            beginAtZero: true,
                                            ticks: {
                                                callback: (value) => {
                                                    return this.formatNumber(value);
                                                }
                                            }
                                        }
                                    }
                                }
                            });
                        }
                    }, 50);

                } else {
                    // Format brut : Tableau HTML
                    let tableHTML = `
                        <div style="padding: 1rem;">
                            <div style="margin-bottom: 1rem; padding: 0.75rem; background: #f8fafc; border-radius: 0.5rem; border-left: 4px solid #7c3aed;">
                                <div style="font-size: 0.85rem; color: #64748b; margin-bottom: 0.25rem;">Ménages totaux</div>
                                <div style="font-size: 1.5rem; font-weight: 600; color: #0f172a;">${totalMenagesLabel}</div>
                                <div style="font-size: 0.75rem; color: #64748b; margin-top: 0.25rem;">${this.metricCoverageLabel(householdCoverage)}</div>
                            </div>
                            <div style="overflow-x: auto;">
                                <table style="width: 100%; border-collapse: collapse; font-size: 0.9rem;">
                                    <thead>
                                        <tr style="background: #f8fafc; border-bottom: 2px solid #e2e8f0;">
                                            <th style="padding: 0.75rem; text-align: left; font-weight: 600; color: #0f172a;">Commune</th>
                                            <th style="padding: 0.75rem; text-align: right; font-weight: 600; color: #0f172a;">Ménages</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                    `;

                    // Trier par ménages décroissants
                    const sortedRows = [...rows].sort((a, b) => {
                        const menagesA = this.metricValue(a, ['menages', 'Menages', 'ménages']);
                        const menagesB = this.metricValue(b, ['menages', 'Menages', 'ménages']);
                        return (menagesB ?? -1) - (menagesA ?? -1);
                    });

                    sortedRows.forEach(row => {
                        const menages = this.metricValue(
                            row,
                            ['menages', 'Menages', 'ménages'],
                        );
                        const communeName = row.nom_commune || row.commune || 'N/A';

                        tableHTML += `
                            <tr style="border-bottom: 1px solid #e2e8f0;">
                                <td style="padding: 0.75rem; color: #334155;">${communeName}</td>
                                <td style="padding: 0.75rem; text-align: right; color: #0f172a; font-weight: 500;">${menages !== null ? this.formatNumber(menages) : '-'}</td>
                            </tr>
                        `;
                    });

                    tableHTML += `
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    `;

                    displayArea.innerHTML = tableHTML;
                }
            },

            // Rendu du revenu médian communal pondéré par la population.
            renderRevenus(data, format, displayArea) {
                const renderRevision = this.renderRevision;
                const rows = data.rows || [];
                const incomeAliases = window.MaplyticsZoneMetricSeries
                    ?.METRIC_ALIASES?.revenus || [
                        'revenu_median', 'revenus', 'revenu', 'revenu_moyen',
                        'median_income', 'income',
                    ];
                const incomeMetric = window.MaplyticsZoneMetricSeries
                    ?.weightedCommunalIncome?.(rows) || {
                        status: 'unavailable',
                        value: null,
                        rowCount: rows.length,
                        availableCount: 0,
                        reason: 'Le calcul vérifiable du revenu est indisponible.',
                    };
                if (incomeMetric.status !== 'available') {
                    displayArea.innerHTML = `
                        <section class="home-stats-zone-series" role="status">
                            <header class="home-stats-zone-series__header">
                                <div>
                                    <h4>Revenu médian communal pondéré</h4>
                                    <p>Couverture ${incomeMetric.availableCount}/${incomeMetric.rowCount} commune(s)</p>
                                </div>
                                <strong>Indisponible</strong>
                            </header>
                            <p class="home-stats-zone-series__notice">${this.escapeHtml(incomeMetric.reason)}</p>
                        </section>
                    `;
                    return;
                }
                const moyenneRevenus = incomeMetric.value;
                const incomeVintage = incomeMetric.vintages?.length
                    ? incomeMetric.vintages.join(', ')
                    : 'non renseigné';

                if (format === 'visual') {
                    // Format visuel : valeur pondérée issue du même snapshot que les exports.
                    displayArea.innerHTML = `
                        <div style="padding: 1rem;">
                            <div style="margin-bottom: 1rem; padding: 0.75rem; background: #f8fafc; border-radius: 0.5rem; border-left: 4px solid #f59e0b;">
                                <div style="font-size: 0.85rem; color: #64748b; margin-bottom: 0.25rem;">Revenu médian communal pondéré</div>
                                <div style="font-size: 1.5rem; font-weight: 600; color: #0f172a;">${this.formatNumber(moyenneRevenus)} €</div>
                                <div style="font-size: 0.75rem; color: #64748b; margin-top: 0.25rem;">Couverture ${incomeMetric.availableCount}/${incomeMetric.rowCount} commune(s) · Millésime ${this.escapeHtml(incomeVintage)}</div>
                            </div>
                            <div style="position: relative; height: 300px;">
                                <canvas id="${prefix}revenusChart"></canvas>
                            </div>
                        </div>
                    `;

                    setTimeout(async () => {
                        const canvas = document.getElementById(`${prefix}revenusChart`);
                        if (!canvas) return;
                        if (renderRevision !== this.renderRevision) return;
                        this.setChartAccessibility(
                            canvas,
                            'Graphique du revenu médian communal pondéré',
                            `${this.formatNumber(moyenneRevenus)} euros, couverture ${incomeMetric.availableCount} sur ${incomeMetric.rowCount} communes, millésime ${incomeVintage}.`,
                        );

                        const ctx = canvas.getContext('2d');

                        const ChartConstructor = await this.loadChartConstructor();
                        if (renderRevision !== this.renderRevision) return;
                        if (ChartConstructor && canvas.isConnected) {
                            this.chartInstance = new ChartConstructor(ctx, {
                                type: 'bar',
                                data: {
                                    labels: ['Revenu médian pondéré'],
                                    datasets: [{
                                        label: 'Revenu médian pondéré',
                                        data: [moyenneRevenus],
                                        backgroundColor: '#f59e0b',
                                        borderColor: '#d97706',
                                        borderWidth: 1
                                    }]
                                },
                                options: {
                                    responsive: true,
                                    maintainAspectRatio: false,
                                    plugins: {
                                        legend: {
                                            display: true,
                                            position: 'top'
                                        },
                                        tooltip: {
                                            callbacks: {
                                                label: (context) => {
                                                    return `Revenu médian pondéré : ${this.formatNumber(context.parsed.y)} €/an`;
                                                }
                                            }
                                        }
                                    },
                                    scales: {
                                        y: {
                                            beginAtZero: false,
                                            ticks: {
                                                callback: (value) => {
                                                    return `${this.formatNumber(value)} €`;
                                                }
                                            }
                                        }
                                    }
                                }
                            });
                        }
                    }, 50);

                } else {
                    // Format brut : Tableau HTML
                    let tableHTML = `
                        <div style="padding: 1rem;">
                            <div style="margin-bottom: 1rem; padding: 0.75rem; background: #f8fafc; border-radius: 0.5rem; border-left: 4px solid #f59e0b;">
                                <div style="font-size: 0.85rem; color: #64748b; margin-bottom: 0.25rem;">Revenu médian communal pondéré</div>
                                <div style="font-size: 1.5rem; font-weight: 600; color: #0f172a;">${this.formatNumber(moyenneRevenus)} €/an</div>
                                <div style="font-size: 0.75rem; color: #64748b; margin-top: 0.25rem;">Couverture ${incomeMetric.availableCount}/${incomeMetric.rowCount} commune(s) · Millésime ${this.escapeHtml(incomeVintage)}</div>
                            </div>
                            <div style="overflow-x: auto;">
                                <table style="width: 100%; border-collapse: collapse; font-size: 0.9rem;">
                                    <thead>
                                        <tr style="background: #f8fafc; border-bottom: 2px solid #e2e8f0;">
                                            <th style="padding: 0.75rem; text-align: left; font-weight: 600; color: #0f172a;">Commune</th>
                                            <th style="padding: 0.75rem; text-align: right; font-weight: 600; color: #0f172a;">Revenu médian (€/an)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                    `;

                    // Trier par revenus décroissants
                    const sortedRows = [...rows].sort((a, b) => {
                        const revenusA = this.metricValue(a, incomeAliases);
                        const revenusB = this.metricValue(b, incomeAliases);
                        return (revenusB ?? Number.NEGATIVE_INFINITY)
                            - (revenusA ?? Number.NEGATIVE_INFINITY);
                    });

                    sortedRows.forEach(row => {
                        const revenus = this.metricValue(row, incomeAliases);
                        const communeName = row.nom_commune || row.commune || 'N/A';
                        tableHTML += `
                            <tr style="border-bottom: 1px solid #e2e8f0;">
                                <td style="padding: 0.75rem; color: #334155;">${communeName}</td>
                                <td style="padding: 0.75rem; text-align: right; color: #0f172a; font-weight: 500;">${revenus !== null ? this.formatNumber(revenus) : '-'}</td>
                            </tr>
                        `;
                    });

                    tableHTML += `
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    `;

                    displayArea.innerHTML = tableHTML;
                }
            },

            // Rendu statistique Âge moyen
            renderAgeMoyen(data, format, displayArea) {
                const renderRevision = this.renderRevision;
                const rows = data.rows || [];
                const NATIONAL_AVERAGE_AGE = 42.3; // Source: INSEE 2023 - Âge moyen de la population

                // Calculer la moyenne pondérée par population (ou simple moyenne si pas de population)
                let totalAge = 0;
                let totalPopulation = 0;
                let count = 0;

                rows.forEach(row => {
                    const age = parseFloat(row.age_moyen || 0);
                    const pop = parseFloat(row.population || 0);
                    if (!isNaN(age) && age > 0) {
                        if (pop > 0) {
                            totalAge += age * pop;
                            totalPopulation += pop;
                        } else {
                            totalAge += age;
                            count++;
                        }
                    }
                });

                const moyenneAge = totalPopulation > 0 ? totalAge / totalPopulation : (count > 0 ? totalAge / count : 0);
                const ecartPourcentage = moyenneAge > 0 ? (((moyenneAge - NATIONAL_AVERAGE_AGE) / NATIONAL_AVERAGE_AGE) * 100).toFixed(1) : 0;

                if (format === 'visual') {
                    // Format visuel : Graphique en barres Chart.js avec ligne de référence
                    displayArea.innerHTML = `
                        <div style="padding: 1rem;">
                            <div style="margin-bottom: 1rem; padding: 0.75rem; background: #f8fafc; border-radius: 0.5rem; border-left: 4px solid #ec4899;">
                                <div style="font-size: 0.85rem; color: #64748b; margin-bottom: 0.25rem;">Âge moyen</div>
                                <div style="font-size: 1.5rem; font-weight: 600; color: #0f172a;">${moyenneAge > 0 ? moyenneAge.toFixed(1) : '-'} ans</div>
                                <div style="font-size: 0.75rem; color: #94a3b8; margin-top: 0.25rem;">${rows.length} commune(s) - Moyenne nationale: ${NATIONAL_AVERAGE_AGE.toFixed(1)} ans</div>
                            </div>
                            <div style="position: relative; height: 300px;">
                                <canvas id="${prefix}ageMoyenChart"></canvas>
                            </div>
                        </div>
                    `;

                    setTimeout(async () => {
                        const canvas = document.getElementById(`${prefix}ageMoyenChart`);
                        if (!canvas) return;
                        if (renderRevision !== this.renderRevision) return;
                        this.setChartAccessibility(
                            canvas,
                            'Graphique de l’âge moyen',
                            `${moyenneAge.toFixed(1)} ans, référence nationale ${NATIONAL_AVERAGE_AGE.toFixed(1)} ans.`,
                        );

                        const ctx = canvas.getContext('2d');

                        const ChartConstructor = await this.loadChartConstructor();
                        if (renderRevision !== this.renderRevision) return;
                        if (ChartConstructor && canvas.isConnected && moyenneAge > 0) {
                            this.chartInstance = new ChartConstructor(ctx, {
                                type: 'bar',
                                data: {
                                    labels: ['Âge moyen'],
                                    datasets: [{
                                        label: 'Âge moyen',
                                        data: [moyenneAge],
                                        backgroundColor: '#ec4899',
                                        borderColor: '#db2777',
                                        borderWidth: 1
                                    }, {
                                        label: 'Moyenne nationale',
                                        data: [NATIONAL_AVERAGE_AGE],
                                        type: 'line',
                                        borderColor: '#64748b',
                                        borderWidth: 2,
                                        borderDash: [5, 5],
                                        fill: false,
                                        pointRadius: 0
                                    }]
                                },
                                options: {
                                    responsive: true,
                                    maintainAspectRatio: false,
                                    plugins: {
                                        legend: {
                                            display: true,
                                            position: 'top'
                                        },
                                        tooltip: {
                                            callbacks: {
                                                label: (context) => {
                                                    if (context.datasetIndex === 0) {
                                                        return `Âge moyen: ${context.parsed.y.toFixed(1)} ans (${ecartPourcentage > 0 ? '+' : ''}${ecartPourcentage}% vs moyenne nationale)`;
                                                    } else {
                                                        return `Moyenne nationale: ${context.parsed.y.toFixed(1)} ans`;
                                                    }
                                                }
                                            }
                                        }
                                    },
                                    scales: {
                                        y: {
                                            beginAtZero: false,
                                            ticks: {
                                                callback: (value) => {
                                                    return value.toFixed(1) + ' ans';
                                                }
                                            }
                                        }
                                    }
                                }
                            });
                        }
                    }, 50);

                } else {
                    // Format brut : Tableau HTML
                    let tableHTML = `
                        <div style="padding: 1rem;">
                            <div style="margin-bottom: 1rem; padding: 0.75rem; background: #f8fafc; border-radius: 0.5rem; border-left: 4px solid #ec4899;">
                                <div style="font-size: 0.85rem; color: #64748b; margin-bottom: 0.25rem;">Âge moyen</div>
                                <div style="font-size: 1.5rem; font-weight: 600; color: #0f172a;">${moyenneAge > 0 ? moyenneAge.toFixed(1) : '-'} ans</div>
                                <div style="font-size: 0.75rem; color: #94a3b8; margin-top: 0.25rem;">${rows.length} commune(s) - Moyenne nationale: ${NATIONAL_AVERAGE_AGE.toFixed(1)} ans (${ecartPourcentage > 0 ? '+' : ''}${ecartPourcentage}%)</div>
                            </div>
                            <div style="overflow-x: auto;">
                                <table style="width: 100%; border-collapse: collapse; font-size: 0.9rem;">
                                    <thead>
                                        <tr style="background: #f8fafc; border-bottom: 2px solid #e2e8f0;">
                                            <th style="padding: 0.75rem; text-align: left; font-weight: 600; color: #0f172a;">Commune</th>
                                            <th style="padding: 0.75rem; text-align: right; font-weight: 600; color: #0f172a;">Âge moyen (ans)</th>
                                            <th style="padding: 0.75rem; text-align: right; font-weight: 600; color: #0f172a;">Moyenne nationale (ans)</th>
                                            <th style="padding: 0.75rem; text-align: right; font-weight: 600; color: #0f172a;">Écart (%)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                    `;

                    // Trier par âge moyen décroissant
                    const sortedRows = [...rows].sort((a, b) => {
                        const ageA = parseFloat(a.age_moyen || 0);
                        const ageB = parseFloat(b.age_moyen || 0);
                        return ageB - ageA;
                    });

                    sortedRows.forEach(row => {
                        const age = parseFloat(row.age_moyen || 0);
                        const communeName = row.nom_commune || row.commune || 'N/A';
                        const ecartRow = age > 0 ? (((age - NATIONAL_AVERAGE_AGE) / NATIONAL_AVERAGE_AGE) * 100).toFixed(1) : '-';

                        tableHTML += `
                            <tr style="border-bottom: 1px solid #e2e8f0;">
                                <td style="padding: 0.75rem; color: #334155;">${communeName}</td>
                                <td style="padding: 0.75rem; text-align: right; color: #0f172a; font-weight: 500;">${!isNaN(age) && age > 0 ? age.toFixed(1) : '-'}</td>
                                <td style="padding: 0.75rem; text-align: right; color: #64748b;">${NATIONAL_AVERAGE_AGE.toFixed(1)}</td>
                                <td style="padding: 0.75rem; text-align: right; color: ${ecartRow > 0 ? '#10b981' : ecartRow < 0 ? '#ef4444' : '#64748b'}; font-weight: 500;">${ecartRow !== '-' ? (ecartRow > 0 ? '+' : '') + ecartRow + '%' : '-'}</td>
                            </tr>
                        `;
                    });

                    tableHTML += `
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    `;

                    displayArea.innerHTML = tableHTML;
                }
            },

            // Rendu statistique Proportion appartement/maison
            renderLogementsType(data, format, displayArea) {
                const renderRevision = this.renderRevision;
                const rows = data.rows || [];

                // Calculer l'agrégation (somme totale)
                let totalMaisons = 0;
                let totalAppartements = 0;
                rows.forEach(row => {
                    const maisons = parseFloat(row.logement_maison || 0);
                    const appartements = parseFloat(row.logement_appartement || 0);
                    if (!isNaN(maisons) && maisons > 0) {
                        totalMaisons += maisons;
                    }
                    if (!isNaN(appartements) && appartements > 0) {
                        totalAppartements += appartements;
                    }
                });

                const totalLogements = totalMaisons + totalAppartements;
                const pctMaisons = totalLogements > 0 ? ((totalMaisons / totalLogements) * 100).toFixed(1) : 0;
                const pctAppartements = totalLogements > 0 ? ((totalAppartements / totalLogements) * 100).toFixed(1) : 0;

                if (format === 'visual') {
                    // Format visuel : Graphique en camembert Chart.js
                    displayArea.innerHTML = `
                        <div style="padding: 1rem;">
                            <div style="margin-bottom: 1rem; padding: 0.75rem; background: #f8fafc; border-radius: 0.5rem; border-left: 4px solid #10b981;">
                                <div style="font-size: 0.85rem; color: #64748b; margin-bottom: 0.25rem;">Répartition des logements</div>
                                <div style="display: flex; gap: 1.5rem; margin-top: 0.5rem;">
                                    <div style="flex: 1;">
                                        <div style="font-size: 0.75rem; color: #94a3b8;">Maisons</div>
                                        <div style="font-size: 1.25rem; font-weight: 600; color: #0f172a;">${this.formatNumber(totalMaisons)}</div>
                                        <div style="font-size: 0.7rem; color: #64748b;">${pctMaisons}%</div>
                                    </div>
                                    <div style="flex: 1;">
                                        <div style="font-size: 0.75rem; color: #94a3b8;">Appartements</div>
                                        <div style="font-size: 1.25rem; font-weight: 600; color: #0f172a;">${this.formatNumber(totalAppartements)}</div>
                                        <div style="font-size: 0.7rem; color: #64748b;">${pctAppartements}%</div>
                                    </div>
                                    <div style="flex: 1;">
                                        <div style="font-size: 0.75rem; color: #94a3b8;">Total</div>
                                        <div style="font-size: 1.25rem; font-weight: 600; color: #0f172a;">${this.formatNumber(totalLogements)}</div>
                                        <div style="font-size: 0.7rem; color: #64748b;">${rows.length} commune(s)</div>
                                    </div>
                                </div>
                            </div>
                            <div style="position: relative; height: 350px;">
                                <canvas id="${prefix}logementsTypeChart"></canvas>
                            </div>
                        </div>
                    `;

                    // Créer le graphique Chart.js (camembert) après un court délai
                    setTimeout(async () => {
                        const canvas = document.getElementById(`${prefix}logementsTypeChart`);
                        if (!canvas) return;
                        if (renderRevision !== this.renderRevision) return;
                        this.setChartAccessibility(
                            canvas,
                            'Graphique de répartition entre maisons et appartements',
                            `${this.formatNumber(totalMaisons)} maisons et ${this.formatNumber(totalAppartements)} appartements.`,
                        );

                        const ctx = canvas.getContext('2d');

                        const ChartConstructor = await this.loadChartConstructor();
                        if (renderRevision !== this.renderRevision) return;
                        if (ChartConstructor && canvas.isConnected && totalLogements > 0) {
                            this.chartInstance = new ChartConstructor(ctx, {
                                type: 'pie',
                                data: {
                                    labels: ['Maisons', 'Appartements'],
                                    datasets: [{
                                        data: [totalMaisons, totalAppartements],
                                        backgroundColor: ['#10b981', '#3b82f6'],
                                        borderColor: ['#059669', '#2563eb'],
                                        borderWidth: 2
                                    }]
                                },
                                options: {
                                    responsive: true,
                                    maintainAspectRatio: false,
                                    plugins: {
                                        legend: {
                                            position: 'bottom',
                                            labels: {
                                                padding: 15,
                                                font: {
                                                    size: 13
                                                }
                                            }
                                        },
                                        tooltip: {
                                            callbacks: {
                                                label: (context) => {
                                                    const label = context.label || '';
                                                    const value = context.parsed || 0;
                                                    const total = context.dataset.data.reduce((a, b) => a + b, 0);
                                                    const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : 0;
                                                    return `${label}: ${this.formatNumber(value)} (${percentage}%)`;
                                                }
                                            }
                                        }
                                    }
                                }
                            });
                        }
                    }, 50);

                } else {
                    // Format brut : Tableau HTML avec valeurs absolues et pourcentages
                    let tableHTML = `
                        <div style="padding: 1rem;">
                            <div style="margin-bottom: 1rem; padding: 0.75rem; background: #f8fafc; border-radius: 0.5rem; border-left: 4px solid #10b981;">
                                <div style="font-size: 0.85rem; color: #64748b; margin-bottom: 0.25rem;">Répartition des logements</div>
                                <div style="display: flex; gap: 1.5rem; margin-top: 0.5rem;">
                                    <div style="flex: 1;">
                                        <div style="font-size: 0.75rem; color: #94a3b8;">Maisons</div>
                                        <div style="font-size: 1.25rem; font-weight: 600; color: #0f172a;">${this.formatNumber(totalMaisons)}</div>
                                        <div style="font-size: 0.7rem; color: #64748b;">${pctMaisons}%</div>
                                    </div>
                                    <div style="flex: 1;">
                                        <div style="font-size: 0.75rem; color: #94a3b8;">Appartements</div>
                                        <div style="font-size: 1.25rem; font-weight: 600; color: #0f172a;">${this.formatNumber(totalAppartements)}</div>
                                        <div style="font-size: 0.7rem; color: #64748b;">${pctAppartements}%</div>
                                    </div>
                                    <div style="flex: 1;">
                                        <div style="font-size: 0.75rem; color: #94a3b8;">Total</div>
                                        <div style="font-size: 1.25rem; font-weight: 600; color: #0f172a;">${this.formatNumber(totalLogements)}</div>
                                        <div style="font-size: 0.7rem; color: #64748b;">${rows.length} commune(s)</div>
                                    </div>
                                </div>
                            </div>
                            <div style="overflow-x: auto;">
                                <table style="width: 100%; border-collapse: collapse; font-size: 0.9rem;">
                                    <thead>
                                        <tr style="background: #f8fafc; border-bottom: 2px solid #e2e8f0;">
                                            <th style="padding: 0.75rem; text-align: left; font-weight: 600; color: #0f172a;">Commune</th>
                                            <th style="padding: 0.75rem; text-align: right; font-weight: 600; color: #0f172a;">Maisons</th>
                                            <th style="padding: 0.75rem; text-align: right; font-weight: 600; color: #0f172a;">Appartements</th>
                                            <th style="padding: 0.75rem; text-align: right; font-weight: 600; color: #0f172a;">Total</th>
                                            <th style="padding: 0.75rem; text-align: right; font-weight: 600; color: #0f172a;">% Maisons</th>
                                            <th style="padding: 0.75rem; text-align: right; font-weight: 600; color: #0f172a;">% Apparts</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                    `;

                    // Trier par total de logements décroissant
                    const sortedRows = [...rows].sort((a, b) => {
                        const totalA = parseFloat(a.logement_maison || 0) + parseFloat(a.logement_appartement || 0);
                        const totalB = parseFloat(b.logement_maison || 0) + parseFloat(b.logement_appartement || 0);
                        return totalB - totalA;
                    });

                    sortedRows.forEach(row => {
                        const maisons = parseFloat(row.logement_maison || 0);
                        const appartements = parseFloat(row.logement_appartement || 0);
                        const total = maisons + appartements;
                        const pctMaisonsRow = total > 0 ? ((maisons / total) * 100).toFixed(1) : '0.0';
                        const pctAppartementsRow = total > 0 ? ((appartements / total) * 100).toFixed(1) : '0.0';
                        const communeName = row.nom_commune || row.commune || 'N/A';

                        tableHTML += `
                            <tr style="border-bottom: 1px solid #e2e8f0;">
                                <td style="padding: 0.75rem; color: #334155;">${communeName}</td>
                                <td style="padding: 0.75rem; text-align: right; color: #0f172a; font-weight: 500;">${!isNaN(maisons) && maisons > 0 ? this.formatNumber(maisons) : '-'}</td>
                                <td style="padding: 0.75rem; text-align: right; color: #0f172a; font-weight: 500;">${!isNaN(appartements) && appartements > 0 ? this.formatNumber(appartements) : '-'}</td>
                                <td style="padding: 0.75rem; text-align: right; color: #0f172a; font-weight: 600;">${total > 0 ? this.formatNumber(total) : '-'}</td>
                                <td style="padding: 0.75rem; text-align: right; color: #64748b;">${total > 0 ? pctMaisonsRow + '%' : '-'}</td>
                                <td style="padding: 0.75rem; text-align: right; color: #64748b;">${total > 0 ? pctAppartementsRow + '%' : '-'}</td>
                            </tr>
                        `;
                    });

                    tableHTML += `
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    `;

                    displayArea.innerHTML = tableHTML;
                }
            },

            // Rendu statistique CSP (Catégories Socio-Professionnelles)
            renderCSP(data, format, displayArea) {
                const renderRevision = this.renderRevision;
                const rows = data.rows || [];

                // Calculer l'agrégation (somme totale pour chaque CSP)
                const cspLabels = ['Cadres', 'Prof. intermédiaires', 'Employés', 'Ouvriers', 'Retraités', 'Artisans', 'Agriculteurs'];
                const cspKeys = ['csp_cadres', 'csp_prof_inter', 'csp_employes', 'csp_ouvriers', 'csp_retraites', 'csp_artisans', 'csp_agriculteurs'];
                const cspValues = [0, 0, 0, 0, 0, 0, 0];

                rows.forEach(row => {
                    cspKeys.forEach((key, index) => {
                        const value = parseFloat(row[key] || 0);
                        if (!isNaN(value) && value > 0) {
                            cspValues[index] += value;
                        }
                    });
                });

                const totalCSP = cspValues.reduce((a, b) => a + b, 0);

                // Filtrer les CSP avec des valeurs > 0 pour l'affichage
                const filteredData = cspLabels.map((label, index) => ({
                    label,
                    value: cspValues[index],
                    key: cspKeys[index]
                })).filter(item => item.value > 0);

                if (format === 'visual') {
                    // Format visuel : Graphique en camembert Chart.js
                    const colors = ['#2563eb', '#7c3aed', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6', '#06b6d4'];

                    displayArea.innerHTML = `
                        <div style="padding: 1rem;">
                            <div style="margin-bottom: 1rem; padding: 0.75rem; background: #f8fafc; border-radius: 0.5rem; border-left: 4px solid #8b5cf6;">
                                <div style="font-size: 0.85rem; color: #64748b; margin-bottom: 0.25rem;">Répartition CSP (totale)</div>
                                <div style="font-size: 1.5rem; font-weight: 600; color: #0f172a;">${this.formatNumber(totalCSP)}</div>
                                <div style="font-size: 0.75rem; color: #94a3b8; margin-top: 0.25rem;">${rows.length} commune(s)</div>
                            </div>
                            <div style="position: relative; height: 400px;">
                                <canvas id="${prefix}cspChart"></canvas>
                            </div>
                        </div>
                    `;

                    setTimeout(async () => {
                        const canvas = document.getElementById(`${prefix}cspChart`);
                        if (!canvas) return;
                        if (renderRevision !== this.renderRevision) return;
                        this.setChartAccessibility(
                            canvas,
                            'Graphique de répartition des catégories socioprofessionnelles',
                            filteredData.map((item) => `${item.label}: ${this.formatNumber(item.value)}`).join(', '),
                        );

                        const ctx = canvas.getContext('2d');

                        const ChartConstructor = await this.loadChartConstructor();
                        if (renderRevision !== this.renderRevision) return;
                        if (ChartConstructor && canvas.isConnected && totalCSP > 0) {
                            this.chartInstance = new ChartConstructor(ctx, {
                                type: 'pie',
                                data: {
                                    labels: filteredData.map(d => d.label),
                                    datasets: [{
                                        data: filteredData.map(d => d.value),
                                        backgroundColor: colors.slice(0, filteredData.length),
                                        borderColor: colors.slice(0, filteredData.length).map(c => c.replace('0.8', '1')),
                                        borderWidth: 2
                                    }]
                                },
                                options: {
                                    responsive: true,
                                    maintainAspectRatio: false,
                                    plugins: {
                                        legend: {
                                            position: 'right',
                                            labels: {
                                                padding: 15,
                                                font: { size: 12 }
                                            }
                                        },
                                        tooltip: {
                                            callbacks: {
                                                label: (context) => {
                                                    const label = context.label || '';
                                                    const value = context.parsed || 0;
                                                    const percentage = totalCSP > 0 ? ((value / totalCSP) * 100).toFixed(1) : 0;
                                                    return `${label}: ${this.formatNumber(value)} (${percentage}%)`;
                                                }
                                            }
                                        }
                                    }
                                }
                            });
                        }
                    }, 50);

                } else {
                    // Format brut : Tableau HTML
                    let tableHTML = `
                        <div style="padding: 1rem;">
                            <div style="margin-bottom: 1rem; padding: 0.75rem; background: #f8fafc; border-radius: 0.5rem; border-left: 4px solid #8b5cf6;">
                                <div style="font-size: 0.85rem; color: #64748b; margin-bottom: 0.25rem;">Répartition CSP (totale)</div>
                                <div style="font-size: 1.5rem; font-weight: 600; color: #0f172a;">${this.formatNumber(totalCSP)}</div>
                                <div style="font-size: 0.75rem; color: #94a3b8; margin-top: 0.25rem;">${rows.length} commune(s)</div>
                            </div>
                            <div style="overflow-x: auto;">
                                <table style="width: 100%; border-collapse: collapse; font-size: 0.9rem;">
                                    <thead>
                                        <tr style="background: #f8fafc; border-bottom: 2px solid #e2e8f0;">
                                            <th style="padding: 0.75rem; text-align: left; font-weight: 600; color: #0f172a;">CSP</th>
                                            <th style="padding: 0.75rem; text-align: right; font-weight: 600; color: #0f172a;">Effectif</th>
                                            <th style="padding: 0.75rem; text-align: right; font-weight: 600; color: #0f172a;">Pourcentage</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                    `;

                    // Trier par valeur décroissante
                    const sortedData = [...filteredData].sort((a, b) => b.value - a.value);

                    sortedData.forEach(item => {
                        const percentage = totalCSP > 0 ? ((item.value / totalCSP) * 100).toFixed(1) : '0.0';
                        tableHTML += `
                            <tr style="border-bottom: 1px solid #e2e8f0;">
                                <td style="padding: 0.75rem; color: #334155;">${item.label}</td>
                                <td style="padding: 0.75rem; text-align: right; color: #0f172a; font-weight: 500;">${this.formatNumber(item.value)}</td>
                                <td style="padding: 0.75rem; text-align: right; color: #64748b;">${percentage}%</td>
                            </tr>
                        `;
                    });

                    tableHTML += `
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    `;

                    displayArea.innerHTML = tableHTML;
                }
            },

            // Rendu statistique Pyramide des âges
            renderAgePyramid(data, format, displayArea) {
                const renderRevision = this.renderRevision;
                const rows = data.rows || [];

                // Calculer l'agrégation (somme totale pour chaque tranche d'âge)
                const ageLabels = ['0-14 ans', '15-19 ans', '20-24 ans', '25-39 ans', '40-54 ans', '55-64 ans', '65-79 ans', '80 ans et +'];
                const ageKeys = ['pop_0_14', 'pop_15_19', 'pop_20_24', 'pop_25_39', 'pop_40_54', 'pop_55_64', 'pop_65_79', 'pop_80_plus'];
                const ageValues = [0, 0, 0, 0, 0, 0, 0, 0];

                rows.forEach(row => {
                    ageKeys.forEach((key, index) => {
                        const value = parseFloat(row[key] || 0);
                        if (!isNaN(value) && value > 0) {
                            ageValues[index] += value;
                        }
                    });
                });

                const totalPop = ageValues.reduce((a, b) => a + b, 0);

                if (format === 'visual') {
                    // Format visuel : Graphique en barres horizontales (pyramide)
                    displayArea.innerHTML = `
                        <div style="padding: 1rem;">
                            <div style="margin-bottom: 1rem; padding: 0.75rem; background: #f8fafc; border-radius: 0.5rem; border-left: 4px solid #f59e0b;">
                                <div style="font-size: 0.85rem; color: #64748b; margin-bottom: 0.25rem;">Population totale (par tranche d'âge)</div>
                                <div style="font-size: 1.5rem; font-weight: 600; color: #0f172a;">${this.formatNumber(totalPop)}</div>
                                <div style="font-size: 0.75rem; color: #94a3b8; margin-top: 0.25rem;">${rows.length} commune(s)</div>
                            </div>
                            <div style="position: relative; height: 400px;">
                                <canvas id="${prefix}agePyramidChart"></canvas>
                            </div>
                        </div>
                    `;

                    setTimeout(async () => {
                        const canvas = document.getElementById(`${prefix}agePyramidChart`);
                        if (!canvas) return;
                        if (renderRevision !== this.renderRevision) return;
                        this.setChartAccessibility(
                            canvas,
                            'Graphique de répartition de la population par âge',
                            ageLabels.map((label, index) => `${label}: ${this.formatNumber(ageValues[index])}`).join(', '),
                        );

                        const ctx = canvas.getContext('2d');

                        const ChartConstructor = await this.loadChartConstructor();
                        if (renderRevision !== this.renderRevision) return;
                        if (ChartConstructor && canvas.isConnected && totalPop > 0) {
                            this.chartInstance = new ChartConstructor(ctx, {
                                type: 'bar',
                                data: {
                                    labels: ageLabels,
                                    datasets: [{
                                        label: 'Population',
                                        data: ageValues,
                                        backgroundColor: '#f59e0b',
                                        borderColor: '#d97706',
                                        borderWidth: 1
                                    }]
                                },
                                options: {
                                    indexAxis: 'y',
                                    responsive: true,
                                    maintainAspectRatio: false,
                                    plugins: {
                                        legend: {
                                            display: false
                                        },
                                        tooltip: {
                                            callbacks: {
                                                label: (context) => {
                                                    const value = context.parsed.x || 0;
                                                    const percentage = totalPop > 0 ? ((value / totalPop) * 100).toFixed(1) : 0;
                                                    return `Population: ${this.formatNumber(value)} (${percentage}%)`;
                                                }
                                            }
                                        }
                                    },
                                    scales: {
                                        x: {
                                            beginAtZero: true,
                                            ticks: {
                                                callback: (value) => {
                                                    return this.formatNumber(value);
                                                }
                                            }
                                        }
                                    }
                                }
                            });
                        }
                    }, 50);

                } else {
                    // Format brut : Tableau HTML
                    let tableHTML = `
                        <div style="padding: 1rem;">
                            <div style="margin-bottom: 1rem; padding: 0.75rem; background: #f8fafc; border-radius: 0.5rem; border-left: 4px solid #f59e0b;">
                                <div style="font-size: 0.85rem; color: #64748b; margin-bottom: 0.25rem;">Population totale (par tranche d'âge)</div>
                                <div style="font-size: 1.5rem; font-weight: 600; color: #0f172a;">${this.formatNumber(totalPop)}</div>
                                <div style="font-size: 0.75rem; color: #94a3b8; margin-top: 0.25rem;">${rows.length} commune(s)</div>
                            </div>
                            <div style="overflow-x: auto;">
                                <table style="width: 100%; border-collapse: collapse; font-size: 0.9rem;">
                                    <thead>
                                        <tr style="background: #f8fafc; border-bottom: 2px solid #e2e8f0;">
                                            <th style="padding: 0.75rem; text-align: left; font-weight: 600; color: #0f172a;">Tranche d'âge</th>
                                            <th style="padding: 0.75rem; text-align: right; font-weight: 600; color: #0f172a;">Population</th>
                                            <th style="padding: 0.75rem; text-align: right; font-weight: 600; color: #0f172a;">Pourcentage</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                    `;

                    ageLabels.forEach((label, index) => {
                        const value = ageValues[index];
                        const percentage = totalPop > 0 ? ((value / totalPop) * 100).toFixed(1) : '0.0';
                        tableHTML += `
                            <tr style="border-bottom: 1px solid #e2e8f0;">
                                <td style="padding: 0.75rem; color: #334155;">${label}</td>
                                <td style="padding: 0.75rem; text-align: right; color: #0f172a; font-weight: 500;">${this.formatNumber(value)}</td>
                                <td style="padding: 0.75rem; text-align: right; color: #64748b;">${percentage}%</td>
                            </tr>
                        `;
                    });

                    tableHTML += `
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    `;

                    displayArea.innerHTML = tableHTML;
                }
            },

            // Rendu statistique Répartition des ménages
            renderMenagesRepartition(data, format, displayArea) {
                const renderRevision = this.renderRevision;
                const rows = data.rows || [];

                // Calculer l'agrégation (somme totale)
                let total1Pers = 0;
                let totalCoupleSansEnfant = 0;
                let totalCoupleAvecEnfants = 0;
                let totalMonoparentale = 0;

                rows.forEach(row => {
                    const val1 = parseFloat(row.menages_1_pers || 0);
                    const val2 = parseFloat(row.fam_couple_sans_enfant || 0);
                    const val3 = parseFloat(row.fam_couple_avec_enfants || 0);
                    const val4 = parseFloat(row.fam_monoparentale || 0);

                    if (!isNaN(val1) && val1 > 0) total1Pers += val1;
                    if (!isNaN(val2) && val2 > 0) totalCoupleSansEnfant += val2;
                    if (!isNaN(val3) && val3 > 0) totalCoupleAvecEnfants += val3;
                    if (!isNaN(val4) && val4 > 0) totalMonoparentale += val4;
                });

                const totalMenages = total1Pers + totalCoupleSansEnfant + totalCoupleAvecEnfants + totalMonoparentale;

                const dataItems = [
                    { label: '1 personne', value: total1Pers },
                    { label: 'Couple sans enfant', value: totalCoupleSansEnfant },
                    { label: 'Couple avec enfants', value: totalCoupleAvecEnfants },
                    { label: 'Famille monoparentale', value: totalMonoparentale }
                ].filter(item => item.value > 0);

                if (format === 'visual') {
                    // Format visuel : Graphique en camembert Chart.js
                    const colors = ['#3b82f6', '#10b981', '#f59e0b', '#ef4444'];

                    displayArea.innerHTML = `
                        <div style="padding: 1rem;">
                            <div style="margin-bottom: 1rem; padding: 0.75rem; background: #f8fafc; border-radius: 0.5rem; border-left: 4px solid #06b6d4;">
                                <div style="font-size: 0.85rem; color: #64748b; margin-bottom: 0.25rem;">Répartition des ménages (totale)</div>
                                <div style="font-size: 1.5rem; font-weight: 600; color: #0f172a;">${this.formatNumber(totalMenages)}</div>
                                <div style="font-size: 0.75rem; color: #94a3b8; margin-top: 0.25rem;">${rows.length} commune(s)</div>
                            </div>
                            <div style="position: relative; height: 400px;">
                                <canvas id="${prefix}menagesRepartitionChart"></canvas>
                            </div>
                        </div>
                    `;

                    setTimeout(async () => {
                        const canvas = document.getElementById(`${prefix}menagesRepartitionChart`);
                        if (!canvas) return;
                        if (renderRevision !== this.renderRevision) return;
                        this.setChartAccessibility(
                            canvas,
                            'Graphique de répartition des ménages',
                            dataItems.map((item) => `${item.label}: ${this.formatNumber(item.value)}`).join(', '),
                        );

                        const ctx = canvas.getContext('2d');

                        const ChartConstructor = await this.loadChartConstructor();
                        if (renderRevision !== this.renderRevision) return;
                        if (ChartConstructor && canvas.isConnected && totalMenages > 0) {
                            this.chartInstance = new ChartConstructor(ctx, {
                                type: 'pie',
                                data: {
                                    labels: dataItems.map(d => d.label),
                                    datasets: [{
                                        data: dataItems.map(d => d.value),
                                        backgroundColor: colors.slice(0, dataItems.length),
                                        borderColor: colors.slice(0, dataItems.length).map(c => c.replace('0.8', '1')),
                                        borderWidth: 2
                                    }]
                                },
                                options: {
                                    responsive: true,
                                    maintainAspectRatio: false,
                                    plugins: {
                                        legend: {
                                            position: 'right',
                                            labels: {
                                                padding: 15,
                                                font: { size: 12 }
                                            }
                                        },
                                        tooltip: {
                                            callbacks: {
                                                label: (context) => {
                                                    const label = context.label || '';
                                                    const value = context.parsed || 0;
                                                    const percentage = totalMenages > 0 ? ((value / totalMenages) * 100).toFixed(1) : 0;
                                                    return `${label}: ${this.formatNumber(value)} (${percentage}%)`;
                                                }
                                            }
                                        }
                                    }
                                }
                            });
                        }
                    }, 50);

                } else {
                    // Format brut : Tableau HTML
                    let tableHTML = `
                        <div style="padding: 1rem;">
                            <div style="margin-bottom: 1rem; padding: 0.75rem; background: #f8fafc; border-radius: 0.5rem; border-left: 4px solid #06b6d4;">
                                <div style="font-size: 0.85rem; color: #64748b; margin-bottom: 0.25rem;">Répartition des ménages (totale)</div>
                                <div style="font-size: 1.5rem; font-weight: 600; color: #0f172a;">${this.formatNumber(totalMenages)}</div>
                                <div style="font-size: 0.75rem; color: #94a3b8; margin-top: 0.25rem;">${rows.length} commune(s)</div>
                            </div>
                            <div style="overflow-x: auto;">
                                <table style="width: 100%; border-collapse: collapse; font-size: 0.9rem;">
                                    <thead>
                                        <tr style="background: #f8fafc; border-bottom: 2px solid #e2e8f0;">
                                            <th style="padding: 0.75rem; text-align: left; font-weight: 600; color: #0f172a;">Type de ménage</th>
                                            <th style="padding: 0.75rem; text-align: right; font-weight: 600; color: #0f172a;">Effectif</th>
                                            <th style="padding: 0.75rem; text-align: right; font-weight: 600; color: #0f172a;">Pourcentage</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                    `;

                    dataItems.forEach(item => {
                        const percentage = totalMenages > 0 ? ((item.value / totalMenages) * 100).toFixed(1) : '0.0';
                        tableHTML += `
                            <tr style="border-bottom: 1px solid #e2e8f0;">
                                <td style="padding: 0.75rem; color: #334155;">${item.label}</td>
                                <td style="padding: 0.75rem; text-align: right; color: #0f172a; font-weight: 500;">${this.formatNumber(item.value)}</td>
                                <td style="padding: 0.75rem; text-align: right; color: #64748b;">${percentage}%</td>
                            </tr>
                        `;
                    });

                    tableHTML += `
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    `;

                    displayArea.innerHTML = tableHTML;
                }
            },

            // Rendu statistique Logements secondaires
            renderLogementsSecondaires(data, format, displayArea) {
                const renderRevision = this.renderRevision;
                const rows = data.rows || [];

                // Calculer l'agrégation (somme totale)
                let totalPrincipales = 0;
                let totalSecondaires = 0;
                let totalVacants = 0;

                rows.forEach(row => {
                    const val1 = parseFloat(row.res_principales || 0);
                    const val2 = parseFloat(row.res_secondaires || 0);
                    const val3 = parseFloat(row.logements_vacants || 0);

                    if (!isNaN(val1) && val1 > 0) totalPrincipales += val1;
                    if (!isNaN(val2) && val2 > 0) totalSecondaires += val2;
                    if (!isNaN(val3) && val3 > 0) totalVacants += val3;
                });

                const totalLogements = totalPrincipales + totalSecondaires + totalVacants;

                if (format === 'visual') {
                    // Format visuel : Graphique en barres Chart.js
                    displayArea.innerHTML = `
                        <div style="padding: 1rem;">
                            <div style="margin-bottom: 1rem; padding: 0.75rem; background: #f8fafc; border-radius: 0.5rem; border-left: 4px solid #ec4899;">
                                <div style="font-size: 0.85rem; color: #64748b; margin-bottom: 0.25rem;">Répartition des logements (totale)</div>
                                <div style="font-size: 1.5rem; font-weight: 600; color: #0f172a;">${this.formatNumber(totalLogements)}</div>
                                <div style="font-size: 0.75rem; color: #94a3b8; margin-top: 0.25rem;">${rows.length} commune(s)</div>
                            </div>
                            <div style="position: relative; height: 350px;">
                                <canvas id="${prefix}logementsSecondairesChart"></canvas>
                            </div>
                        </div>
                    `;

                    setTimeout(async () => {
                        const canvas = document.getElementById(`${prefix}logementsSecondairesChart`);
                        if (!canvas) return;
                        if (renderRevision !== this.renderRevision) return;
                        this.setChartAccessibility(
                            canvas,
                            'Graphique de répartition des logements',
                            `Résidences principales: ${this.formatNumber(totalPrincipales)}, résidences secondaires: ${this.formatNumber(totalSecondaires)}, logements vacants: ${this.formatNumber(totalVacants)}.`,
                        );

                        const ctx = canvas.getContext('2d');

                        const ChartConstructor = await this.loadChartConstructor();
                        if (renderRevision !== this.renderRevision) return;
                        if (ChartConstructor && canvas.isConnected && totalLogements > 0) {
                            this.chartInstance = new ChartConstructor(ctx, {
                                type: 'bar',
                                data: {
                                    labels: ['Résidences principales', 'Résidences secondaires', 'Logements vacants'],
                                    datasets: [{
                                        label: 'Nombre de logements',
                                        data: [totalPrincipales, totalSecondaires, totalVacants],
                                        backgroundColor: ['#10b981', '#3b82f6', '#94a3b8'],
                                        borderColor: ['#059669', '#2563eb', '#64748b'],
                                        borderWidth: 1
                                    }]
                                },
                                options: {
                                    responsive: true,
                                    maintainAspectRatio: false,
                                    plugins: {
                                        legend: {
                                            display: false
                                        },
                                        tooltip: {
                                            callbacks: {
                                                label: (context) => {
                                                    const value = context.parsed.y || 0;
                                                    const percentage = totalLogements > 0 ? ((value / totalLogements) * 100).toFixed(1) : 0;
                                                    return `${context.label}: ${this.formatNumber(value)} (${percentage}%)`;
                                                }
                                            }
                                        }
                                    },
                                    scales: {
                                        y: {
                                            beginAtZero: true,
                                            ticks: {
                                                callback: (value) => {
                                                    return this.formatNumber(value);
                                                }
                                            }
                                        }
                                    }
                                }
                            });
                        }
                    }, 50);

                } else {
                    // Format brut : Tableau HTML
                    let tableHTML = `
                        <div style="padding: 1rem;">
                            <div style="margin-bottom: 1rem; padding: 0.75rem; background: #f8fafc; border-radius: 0.5rem; border-left: 4px solid #ec4899;">
                                <div style="font-size: 0.85rem; color: #64748b; margin-bottom: 0.25rem;">Répartition des logements (totale)</div>
                                <div style="font-size: 1.5rem; font-weight: 600; color: #0f172a;">${this.formatNumber(totalLogements)}</div>
                                <div style="font-size: 0.75rem; color: #94a3b8; margin-top: 0.25rem;">${rows.length} commune(s)</div>
                            </div>
                            <div style="overflow-x: auto;">
                                <table style="width: 100%; border-collapse: collapse; font-size: 0.9rem;">
                                    <thead>
                                        <tr style="background: #f8fafc; border-bottom: 2px solid #e2e8f0;">
                                            <th style="padding: 0.75rem; text-align: left; font-weight: 600; color: #0f172a;">Type de logement</th>
                                            <th style="padding: 0.75rem; text-align: right; font-weight: 600; color: #0f172a;">Nombre</th>
                                            <th style="padding: 0.75rem; text-align: right; font-weight: 600; color: #0f172a;">Pourcentage</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                    `;

                    const tableData = [
                        { label: 'Résidences principales', value: totalPrincipales },
                        { label: 'Résidences secondaires', value: totalSecondaires },
                        { label: 'Logements vacants', value: totalVacants }
                    ];

                    tableData.forEach(item => {
                        const percentage = totalLogements > 0 ? ((item.value / totalLogements) * 100).toFixed(1) : '0.0';
                        tableHTML += `
                            <tr style="border-bottom: 1px solid #e2e8f0;">
                                <td style="padding: 0.75rem; color: #334155;">${item.label}</td>
                                <td style="padding: 0.75rem; text-align: right; color: #0f172a; font-weight: 500;">${this.formatNumber(item.value)}</td>
                                <td style="padding: 0.75rem; text-align: right; color: #64748b;">${percentage}%</td>
                            </tr>
                        `;
                    });

                    tableHTML += `
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    `;

                    displayArea.innerHTML = tableHTML;
                }
            },

            // Export (base - à étendre)
            async exportStats(format) {
                if (this.exportPromise) {
                    return this.exportPromise;
                }
                if (format === 'png' && !hasFeature('export_png_stats')) {
                    showPremiumNotice(
                        'l’export graphique PNG',
                        'L’export graphique PNG est inclus à partir du plan Starter.',
                    );
                    this.setExportState('locked', 'Export graphique PNG réservé au plan Starter ou supérieur.');
                    return false;
                }
                if (!this.currentData) {
                    showAppMessage(
                        'warning',
                        'Aucune statistique à exporter',
                        'Affichez d’abord une statistique.',
                    );
                    return;
                }

                const { statType, format: currentFormat, data, selectedZones } = this.currentData;

                // Mapping des noms de statistiques pour les noms de fichiers
                const statTypeLabels = {
                    'population': 'population',
                    'menages': 'menages',
                    'csp': 'csp',
                    'age': 'pyramide_ages',
                    'menages_repartition': 'repartition_menages',
                    'logements_secondaires': 'logements_secondaires',
                    'logements_type': 'proportion_logements',
                    'revenus': 'revenu_median_pondere',
                };

                const fileName = statTypeLabels[statType] || statType;
                const dateStr = new Date().toISOString().split('T')[0];

                if (format === 'png') {
                    // Export PNG : exporter le graphique Chart.js si disponible (format visual)
                    if (currentFormat === 'visual' && this.chartInstance) {
                        // Exporter le graphique Chart.js en PNG
                        const imageUrl = this.chartInstance.toBase64Image();
                        const link = document.createElement('a');
                        link.href = imageUrl;
                        link.download = `stats_${fileName}_${dateStr}.png`;
                        link.click();
                        this.setExportState('done', 'Graphique PNG téléchargé.');
                    } else {
                        // Pour les tableaux HTML (format raw), PNG n'est pas disponible sans html2canvas
                        showAppMessage(
                            'info',
                            'Export PNG indisponible',
                            'Pour un tableau, utilisez CSV ou Excel.',
                        );
                    }
                    return;
                }

                // Pour CSV et Excel : extraire les données depuis le tableau HTML si disponible
                const displayArea = document.querySelector(`${scopeSelector} #${statsElementId('statsDisplayArea')}`);
                let headers = [];
                let rows = [];
                const zoneStatsModel = data.zoneStatsModel;
                const zoneStatsMatrix = data.zoneStatsMatrix;

                if (zoneStatsMatrix?.rows?.length) {
                    headers = [
                        'Indicateur',
                        'Unité',
                        ...zoneStatsMatrix.zones.map((zone) => zone.label),
                    ];
                    rows = zoneStatsMatrix.rows.map((row) => [
                        row.label,
                        row.unit,
                        ...row.values.map((value) => value ?? 'Indisponible'),
                    ]);
                } else if (zoneStatsModel?.table?.headers?.length) {
                    headers = [...zoneStatsModel.table.headers];
                    rows = zoneStatsModel.table.rows.map((row) => (
                        row.map((value) => value ?? 'Indisponible')
                    ));
                } else if (displayArea && currentFormat === 'raw') {
                    // Extraire depuis le tableau HTML
                    const table = displayArea.querySelector('table');
                    if (table) {
                        const thead = table.querySelector('thead');
                        const tbody = table.querySelector('tbody');

                        if (thead) {
                            const headerRow = thead.querySelector('tr');
                            if (headerRow) {
                                headers = Array.from(headerRow.querySelectorAll('th')).map(th => th.textContent.trim());
                            }
                        }

                        if (tbody) {
                            rows = Array.from(tbody.querySelectorAll('tr')).map(tr => {
                                return Array.from(tr.querySelectorAll('th, td')).map(cell => {
                                    // Retirer les espaces de formatage des nombres
                                    let text = cell.textContent.trim();
                                    // Retirer les espaces dans les nombres formatés (ex: "1 234" -> "1234")
                                    text = text.replace(/(\d)\s+(\d)/g, '$1$2');
                                    return text;
                                });
                            });
                        }
                    }
                }

                // Si pas de tableau HTML, reconstruire depuis les données
                if (headers.length === 0 || rows.length === 0) {
                    const rawRows = data.rows || [];

                    // Reconstruire les données selon le type de statistique
                    switch (statType) {
                        case 'population':
                            headers = ['Commune', 'Population'];
                            rows = rawRows.map(row => {
                                const pop = parseFloat(row.population || 0);
                                const communeName = row.nom_commune || row.commune || 'N/A';
                                return [communeName, !isNaN(pop) && pop > 0 ? pop.toString() : '0'];
                            });
                            break;
                        case 'menages':
                            headers = ['Commune', 'Ménages'];
                            rows = rawRows.map(row => {
                                const menages = parseFloat(row.menages || 0);
                                const communeName = row.nom_commune || row.commune || 'N/A';
                                return [communeName, !isNaN(menages) && menages > 0 ? menages.toString() : '0'];
                            });
                            break;
                        case 'logements_type':
                            headers = ['Commune', 'Maisons', 'Appartements', 'Total', '% Maisons', '% Apparts'];
                            rows = rawRows.map(row => {
                                const maisons = parseFloat(row.logement_maison || 0);
                                const appartements = parseFloat(row.logement_appartement || 0);
                                const total = maisons + appartements;
                                const pctMaisons = total > 0 ? ((maisons / total) * 100).toFixed(1) : '0.0';
                                const pctApparts = total > 0 ? ((appartements / total) * 100).toFixed(1) : '0.0';
                                const communeName = row.nom_commune || row.commune || 'N/A';
                                return [communeName, maisons.toString(), appartements.toString(), total.toString(), pctMaisons + '%', pctApparts + '%'];
                            });
                            break;
                        case 'csp':
                            headers = ['CSP', 'Valeur', 'Pourcentage'];
                            const cspLabels = ['Cadres', 'Prof. intermédiaires', 'Employés', 'Ouvriers', 'Retraités', 'Artisans', 'Agriculteurs'];
                            const cspKeys = ['csp_cadres', 'csp_prof_inter', 'csp_employes', 'csp_ouvriers', 'csp_retraites', 'csp_artisans', 'csp_agriculteurs'];
                            const cspValues = [0, 0, 0, 0, 0, 0, 0];

                            rawRows.forEach(row => {
                                cspKeys.forEach((key, index) => {
                                    const value = parseFloat(row[key] || 0);
                                    if (!isNaN(value) && value > 0) {
                                        cspValues[index] += value;
                                    }
                                });
                            });

                            const totalCSP = cspValues.reduce((a, b) => a + b, 0);
                            rows = cspLabels.map((label, index) => {
                                const value = cspValues[index];
                                const percentage = totalCSP > 0 ? ((value / totalCSP) * 100).toFixed(1) : '0.0';
                                return [label, value.toString(), percentage + '%'];
                            }).filter(row => parseFloat(row[1]) > 0);
                            break;
                        case 'age':
                            headers = ['Tranche d\'âge', 'Population', 'Pourcentage'];
                            const ageLabels = ['0-14 ans', '15-19 ans', '20-24 ans', '25-39 ans', '40-54 ans', '55-64 ans', '65-79 ans', '80 ans et +'];
                            const ageKeys = ['pop_0_14', 'pop_15_19', 'pop_20_24', 'pop_25_39', 'pop_40_54', 'pop_55_64', 'pop_65_79', 'pop_80_plus'];
                            const ageValues = [0, 0, 0, 0, 0, 0, 0, 0];

                            rawRows.forEach(row => {
                                ageKeys.forEach((key, index) => {
                                    const value = parseFloat(row[key] || 0);
                                    if (!isNaN(value) && value > 0) {
                                        ageValues[index] += value;
                                    }
                                });
                            });

                            const totalPop = ageValues.reduce((a, b) => a + b, 0);
                            rows = ageLabels.map((label, index) => {
                                const value = ageValues[index];
                                const percentage = totalPop > 0 ? ((value / totalPop) * 100).toFixed(1) : '0.0';
                                return [label, value.toString(), percentage + '%'];
                            });
                            break;
                        case 'menages_repartition':
                            headers = ['Type de ménage', 'Valeur', 'Pourcentage'];
                            let total1Pers = 0, totalCoupleSansEnfant = 0, totalCoupleAvecEnfants = 0, totalMonoparentale = 0;

                            rawRows.forEach(row => {
                                total1Pers += parseFloat(row.menages_1_pers || 0);
                                totalCoupleSansEnfant += parseFloat(row.fam_couple_sans_enfant || 0);
                                totalCoupleAvecEnfants += parseFloat(row.fam_couple_avec_enfants || 0);
                                totalMonoparentale += parseFloat(row.fam_monoparentale || 0);
                            });

                            const totalMenages = total1Pers + totalCoupleSansEnfant + totalCoupleAvecEnfants + totalMonoparentale;
                            const dataItems = [
                                { label: '1 personne', value: total1Pers },
                                { label: 'Couple sans enfant', value: totalCoupleSansEnfant },
                                { label: 'Couple avec enfants', value: totalCoupleAvecEnfants },
                                { label: 'Famille monoparentale', value: totalMonoparentale }
                            ].filter(item => item.value > 0);

                            rows = dataItems.map(item => {
                                const percentage = totalMenages > 0 ? ((item.value / totalMenages) * 100).toFixed(1) : '0.0';
                                return [item.label, item.value.toString(), percentage + '%'];
                            });
                            break;
                        case 'logements_secondaires':
                            headers = ['Type de logement', 'Valeur', 'Pourcentage'];
                            let totalPrincipales = 0, totalSecondaires = 0, totalVacants = 0;

                            rawRows.forEach(row => {
                                totalPrincipales += parseFloat(row.res_principales || 0);
                                totalSecondaires += parseFloat(row.res_secondaires || 0);
                                totalVacants += parseFloat(row.logements_vacants || 0);
                            });

                            const totalLogements = totalPrincipales + totalSecondaires + totalVacants;
                            const logementItems = [
                                { label: 'Résidences principales', value: totalPrincipales },
                                { label: 'Résidences secondaires', value: totalSecondaires },
                                { label: 'Logements vacants', value: totalVacants }
                            ].filter(item => item.value > 0);

                            rows = logementItems.map(item => {
                                const percentage = totalLogements > 0 ? ((item.value / totalLogements) * 100).toFixed(1) : '0.0';
                                return [item.label, item.value.toString(), percentage + '%'];
                            });
                            break;
                        case 'revenus': {
                            const income = window.MaplyticsZoneMetricSeries
                                ?.weightedCommunalIncome?.(rawRows) || {
                                    status: 'unavailable',
                                    value: null,
                                    rowCount: rawRows.length,
                                    availableCount: 0,
                                    reason: 'Le calcul vérifiable du revenu est indisponible.',
                                };
                            headers = ['Indicateur', 'Valeur', 'Couverture', 'Raison'];
                            rows = [[
                                'Revenu médian communal pondéré',
                                income.status === 'available'
                                    ? income.value
                                    : 'Indisponible',
                                `${income.availableCount}/${income.rowCount} commune(s)`,
                                income.reason,
                            ]];
                            break;
                        }
                        default:
                            showAppMessage(
                                'warning',
                                'Export indisponible',
                                `La statistique « ${statType} » ne peut pas être exportée.`,
                            );
                            return;
                    }
                }

                const presentation = this.presentationSnapshot();
                const exportRows = rows.map((row) => ({
                    ...Object.fromEntries(headers.map((header, index) => [header, row[index]])),
                    'Présentation des données': presentation.label,
                    ...(presentation.projectionFingerprint
                        ? {'Empreinte de projection': presentation.projectionFingerprint}
                        : {}),
                }));
                if (!exportRows.length) {
                    showAppMessage(
                        'warning',
                        'Aucune donnée à exporter',
                        'La statistique sélectionnée ne contient aucune ligne.',
                    );
                    return;
                }
                const operation = format === 'excel'
                    ? window.exportToExcel?.(exportRows)
                    : format === 'simple-pdf'
                        ? window.exportToPdf?.(exportRows)
                        : window.exportVisibleDataset?.('csv', exportRows);
                if (!operation || typeof operation.then !== 'function') {
                    showAppMessage(
                        'error',
                        'Export indisponible',
                        'Le service d’export n’est pas chargé. Rechargez la page.',
                    );
                    this.setExportState('error', 'Service d’export indisponible.');
                    return null;
                }

                const startedAt = performance.now();
                const formatLabel = format === 'simple-pdf'
                    ? 'PDF'
                    : format === 'excel'
                        ? 'Excel'
                        : 'CSV';
                this.setExportState(
                    'running',
                    `Préparation du fichier ${formatLabel}…`,
                );
                this.exportPromise = Promise.resolve(operation)
                    .then((result) => {
                        if (!result) {
                            this.setExportState(
                                'error',
                                `Le fichier ${formatLabel} n’a pas été généré.`,
                            );
                            return null;
                        }
                        const elapsedSeconds = Math.max(
                            0.1,
                            (performance.now() - startedAt) / 1000,
                        ).toFixed(1);
                        this.setExportState(
                            'done',
                            `${formatLabel} téléchargé en ${elapsedSeconds} s.`,
                        );
                        return result;
                    })
                    .catch((error) => {
                        this.setExportState(
                            'error',
                            error?.message || `Échec de l’export ${formatLabel}.`,
                        );
                        return null;
                    })
                    .finally(() => {
                        this.exportPromise = null;
                    });
                return this.exportPromise;
            },

            // Détruire le graphique Chart.js
            destroyChart() {
                if (this.chartInstance) {
                    this.chartInstance.destroy();
                    this.chartInstance = null;
                }
            },

            // Cleanup
            destroy() {
                this.renderRevision += 1;
                this.destroyChart();
                this.currentData = null;
                this.exportPromise = null;
                this.exportBusy = false;
                this.exportChoiceRevision += 1;
                this.syncExportChoices();
            }
            };
        };

        const competitorNetworkComposition = (
            window.MaplyticsCompetitorNetworkComposition.createManagers({
                createManager: createCompetitorsManager,
            })
        );
        const competitorsManager = competitorNetworkComposition.exportManager;
        const importCompetitorsManager = competitorNetworkComposition.importManager;
        let homePageLifecycleGeneration = 0;
        window.addEventListener('pagehide', () => {
            // Cancelling a fetch resolves its restore promise. Invalidate the
            // whole bootstrap before aborting so its next await continuation
            // cannot start another restore in the outgoing document.
            homePageLifecycleGeneration += 1;
            [competitorsManager, importCompetitorsManager].forEach((manager) => {
                manager._competitorRestoreAbortController?.abort?.();
                manager._competitorRestoreAbortController = null;
            });
        });
        competitorsManager.initCompetitorTerritorySync();
        importCompetitorsManager.initCompetitorTerritorySync();
        window.MaplyticsCompetitorNetworkComposition.bindFullscreenSidebars({
            documentRef: document,
            exportManager: competitorsManager,
            importManager: importCompetitorsManager,
        });

        const enhanceCompetitorsPanelV2 = (scopeSelector, prefix = '', manager = null) => {
            if (!APP_CONFIG.appShellV2) return;
            const contentId = prefix ? 'importCompetitorsContent' : 'competitorsContent';
            const listId = prefix ? 'importCompetitorsList' : 'competitorsList';
            const content = document.querySelector(`${scopeSelector} #${contentId}`);
            if (!content || content.dataset.v2Progressive === '1') return;
            content.dataset.v2Progressive = '1';
            content.classList.add('competitors-panel');

            const searchBlock = content.querySelector('.competitors-search');
            const methodTabs = content.querySelector('.competitors-method-tabs');
            if (searchBlock && methodTabs) {
                ['naf', 'address', 'gps', 'sector', 'siren'].forEach(method => {
                    const methodCapitalized = method.charAt(0).toUpperCase() + method.slice(1);
                    const formId = method === 'naf'
                        ? (prefix ? 'importCompetitorSearchNaf' : 'competitorSearchNaf')
                        : (prefix ? `${prefix}CompetitorSearch${methodCapitalized}` : `competitorSearch${methodCapitalized}`);
                    const form = content.querySelector(`#${formId}`);
                    if (form && form.parentNode !== searchBlock) {
                        searchBlock.appendChild(form);
                    }
                });
                if (!searchBlock.querySelector('.competitors-legacy-search')) {
                    const legacyDetails = document.createElement('details');
                    legacyDetails.className = 'competitors-legacy-search';
                    legacyDetails.dataset.competitorAdvanced = '';
                    legacyDetails.innerHTML = `
                        <summary>
                            <span>Points et recherche par lot</span>
                            <small>Adresse, GPS et plusieurs SIREN/SIRET</small>
                        </summary>
                        <div class="competitors-legacy-search__body"></div>
                    `;
                    searchBlock.insertBefore(legacyDetails, methodTabs);
                    const legacyBody = legacyDetails.querySelector('.competitors-legacy-search__body');
                    legacyBody.appendChild(methodTabs);
                    ['naf', 'address', 'gps', 'sector', 'siren'].forEach(method => {
                        const methodCapitalized = method.charAt(0).toUpperCase() + method.slice(1);
                        const formId = method === 'naf'
                            ? (prefix ? 'importCompetitorSearchNaf' : 'competitorSearchNaf')
                            : (prefix ? `${prefix}CompetitorSearch${methodCapitalized}` : `competitorSearch${methodCapitalized}`);
                        const form = content.querySelector(`#${formId}`);
                        if (form) legacyBody.appendChild(form);
                    });
                    const legacyUniqueMethods = new Set(['address', 'gps', 'siren']);
                    methodTabs.querySelectorAll('.competitor-search-method-btn').forEach((button) => {
                        const method = String(button.dataset.method || '');
                        if (!legacyUniqueMethods.has(method)) button.hidden = true;
                        button.classList.toggle('active', method === 'address');
                    });
                    ['naf', 'sector'].forEach((method) => {
                        const methodCapitalized = method.charAt(0).toUpperCase() + method.slice(1);
                        const formId = method === 'naf'
                            ? (prefix ? 'importCompetitorSearchNaf' : 'competitorSearchNaf')
                            : (prefix ? `${prefix}CompetitorSearch${methodCapitalized}` : `competitorSearch${methodCapitalized}`);
                        const duplicateForm = content.querySelector(`#${formId}`);
                        if (duplicateForm) {
                            duplicateForm.hidden = true;
                            duplicateForm.setAttribute('aria-hidden', 'true');
                        }
                    });
                    ['address', 'gps', 'siren'].forEach((method) => {
                        const methodCapitalized = method.charAt(0).toUpperCase() + method.slice(1);
                        const form = content.querySelector(
                            `#${prefix ? `${prefix}CompetitorSearch${methodCapitalized}` : `competitorSearch${methodCapitalized}`}`,
                        );
                        if (form) form.style.display = method === 'address' ? 'block' : 'none';
                    });
                    const sirenForm = content.querySelector(
                        `#${prefix ? 'importCompetitorSearchSiren' : 'competitorSearchSiren'}`,
                    );
                    const sirenSingleRow = sirenForm?.querySelector(':scope > .home-competitor-row');
                    if (sirenSingleRow) sirenSingleRow.hidden = true;
                    const sirenSingleLabel = sirenForm?.querySelector(':scope > label');
                    if (sirenSingleLabel) sirenSingleLabel.hidden = true;
                    const sirenBatchDetails = sirenForm?.querySelector(':scope > details');
                    if (sirenBatchDetails) sirenBatchDetails.open = true;
                }
            }

            const listPanel = content.querySelector('.competitors-list-panel');
            [
                searchBlock?.querySelector(':scope > .home-competitors-title'),
                listPanel?.querySelector('.home-competitors-title'),
            ].filter(Boolean).forEach((title) => {
                title.hidden = true;
                title.setAttribute('aria-hidden', 'true');
                title.dataset.competitorLegacyTitle = '';
            });
            let listDisclosure = content.querySelector('[data-competitor-workspace-panel="list"]');
            if (listPanel && !listDisclosure) {
                listDisclosure = document.createElement('details');
                listDisclosure.className = 'competitors-list-disclosure';
                listDisclosure.dataset.competitorWorkspacePanel = 'list';
                listDisclosure.open = manager?.competitorPanelPreferenceStore?.snapshot?.().listOpen !== false;
                listDisclosure.innerHTML = `
                    <summary class="sr-only" data-competitor-workspace-summary tabindex="-1">
                        <span>Actifs</span>
                        <small data-competitor-list-summary>Aucun concurrent ajouté · ouvrir pour consulter</small>
                    </summary>
                    <div class="competitors-list-disclosure__body"></div>
                `;
                listPanel.parentNode.insertBefore(listDisclosure, listPanel);
                listDisclosure.querySelector('.competitors-list-disclosure__body').appendChild(listPanel);
                listDisclosure.addEventListener('toggle', () => {
                    manager?.competitorPanelPreferenceStore?.update?.({ listOpen: listDisclosure.open });
                });
            }
            const toolsDetails = document.createElement('details');
            toolsDetails.className = 'competitors-tools';
            toolsDetails.open = true;
            toolsDetails.dataset.competitorWorkspacePanel = 'exploit';
            toolsDetails.innerHTML = `
                <summary>
                    <span>Options</span>
                    <small class="sr-only">Carte, couleur, légende, score, export et points</small>
                </summary>
                <div class="competitors-tools-body"></div>
            `;
            const toolsBody = toolsDetails.querySelector('.competitors-tools-body');
            const projectBar = content.querySelector('.competitors-project-bar');
            const actions = content.querySelector('.competitors-actions');
            const customPoints = content.querySelector('.competitors-custom-points');
            if (actions && !actions.querySelector('.competitors-number-all-action')) {
                const quickNumberButton = document.createElement('button');
                quickNumberButton.type = 'button';
                quickNumberButton.className = 'competitors-number-all-action';
                quickNumberButton.title = 'Numéroter les concurrents sur la carte';
                quickNumberButton.setAttribute('aria-label', 'Numéroter les concurrents sur la carte');
                quickNumberButton.setAttribute('aria-pressed', 'false');
                quickNumberButton.textContent = '#';
                actions.appendChild(quickNumberButton);
            }
            if (actions && !actions.querySelector('.competitor-marker-color-control')) {
                const colorControl = document.createElement('label');
                colorControl.className = 'competitor-marker-color-control';
                colorControl.title = 'Choisir la couleur des concurrents sur la carte';
                colorControl.innerHTML = `
                    <span>Couleur</span>
                    <input
                        type="color"
                        class="competitor-marker-color-input"
                        value="${window.MaplyticsCompetitorSearch.DEFAULT_COMPETITOR_MARKER_COLOR}"
                        aria-label="Couleur des concurrents numérotés"
                    >
                `;
                actions.appendChild(colorControl);
            }
            if (actions && !actions.querySelector('.competitor-marker-scale-control')) {
                const scaleControl = document.createElement('label');
                scaleControl.className = 'competitor-marker-scale-control';
                scaleControl.title = 'Agrandir les concurrents sur la carte et dans la fiche PNG';
                scaleControl.innerHTML = `
                    <span>Taille des concurrents</span>
                    <select
                        data-competitor-marker-scale
                        aria-label="Taille des concurrents — carte et image"
                    >
                        <option value="normal">Normal · 100 %</option>
                        <option value="large">Grand · 135 %</option>
                        <option value="xlarge">Très grand · 170 %</option>
                        <option value="xxlarge">Très grand · 200 %</option>
                        <option value="maximum">Maximum · 250 %</option>
                    </select>
                `;
                actions.appendChild(scaleControl);
            }
            if (actions) {
                [
                    ['CompetitorHeatmapBtn', 'Pression', 'Afficher la pression concurrentielle sur la carte'],
                    ['CompetitorAttractBtn', 'Attractivité', 'Évaluer l’attractivité autour de la zone'],
                    ['CompetitorOpenModalBtn', 'Voir', 'Voir les concurrents'],
                    ['CompetitorToggleMapBtn', 'Carte', 'Afficher ou masquer les concurrents sur la carte'],
                    ['CompetitorExportBtn', 'Export', prefix
                        ? 'Exporter les concurrents en CSV'
                        : 'Exporter les concurrents en CSV ou fiche PNG'],
                    ['CompetitorLegendBtn', 'Légende', 'Afficher ou masquer la légende des points']
                ].forEach(([idSuffix, label, title]) => {
                    const id = prefix ? `${prefix}${idSuffix}` : `${idSuffix.charAt(0).toLowerCase()}${idSuffix.slice(1)}`;
                    const btn = actions.querySelector(`#${id}`);
                    if (!btn) return;
                    if (idSuffix === 'CompetitorOpenModalBtn') {
                        btn.innerHTML = '<i class="fas fa-table-list" aria-hidden="true"></i><span>Voir</span>';
                    } else {
                        btn.textContent = label;
                    }
                    btn.title = title;
                    btn.setAttribute('aria-label', title);
                });
            }
            if (projectBar) toolsBody.appendChild(projectBar);
            if (actions) toolsBody.appendChild(actions);
            if (customPoints) toolsBody.appendChild(customPoints);
            const exportCatalog = window.MaplyticsCompetitorDataExport?.FIELD_CATALOG || [];
            if (exportCatalog.length && !content.querySelector('[data-competitor-export-fields]')) {
                const exportTriggerId = prefix ? `${prefix}CompetitorExportBtn` : 'competitorExportBtn';
                const exportTrigger = actions?.querySelector(`#${exportTriggerId}`)
                    || document.getElementById(exportTriggerId);
                const exportSplit = document.createElement('span');
                exportSplit.className = 'home-competitor-export-split';
                const fieldset = document.createElement('fieldset');
                fieldset.className = 'home-legend-fieldset home-competitor-export-fields';
                fieldset.id = `${prefix || 'export'}CompetitorExportFields`;
                fieldset.dataset.competitorExportFields = '';
                fieldset.dataset.competitorExportSurface = prefix ? 'import' : 'export';
                const legend = document.createElement('legend');
                legend.innerHTML = `
                    <span>Données à inclure dans CSV et XLSX</span>
                    <output data-competitor-export-field-count aria-live="polite"></output>
                `;
                legend.tabIndex = -1;
                fieldset.appendChild(legend);
                const toolbar = document.createElement('div');
                toolbar.className = 'competitor-export-field-picker__toolbar';
                toolbar.innerHTML = `
                    <button type="button" data-competitor-export-select-all>Tout sélectionner</button>
                    <button type="button" data-competitor-export-reset>Réinitialiser</button>
                `;
                fieldset.appendChild(toolbar);
                const groupDefinitions = [
                    ['identity', 'Identité et adresse', ['rank', 'reference', 'name', 'address', 'city', 'postal_code', 'siret', 'siren']],
                    ['activity', 'Activité et effectifs', ['naf_code', 'naf_label', 'workforce_band_code', 'workforce_band_label', 'workforce_year', 'creation_date', 'company_age', 'source']],
                    ['routing', 'Recherche et routage', ['search_distance', 'search_origins', 'search_distances', 'route_distances', 'route_durations', 'route_status']],
                    ['zones', 'Zones et présentation', ['zone_memberships', 'zone_relation', 'nearby_distance_km', 'map_color', 'map_visibility']],
                ];
                const fieldsById = new Map(exportCatalog.map((field) => [field.id, field]));
                groupDefinitions.forEach(([groupId, groupLabel, fieldIds]) => {
                    const group = document.createElement('details');
                    group.className = 'competitor-export-field-picker__group';
                    group.dataset.competitorExportGroup = groupId;
                    const heading = document.createElement('summary');
                    heading.innerHTML = `
                        <span>${groupLabel}</span>
                        <small>${fieldIds.length} champ${fieldIds.length > 1 ? 's' : ''}</small>
                    `;
                    const options = document.createElement('div');
                    options.className = 'home-legend-options competitor-export-field-picker__options';
                    fieldIds.forEach((fieldId) => {
                        const field = fieldsById.get(fieldId);
                        if (!field) return;
                        const label = document.createElement('label');
                        label.className = 'home-legend-option';
                        const input = document.createElement('input');
                        input.type = 'checkbox';
                        input.value = field.id;
                        input.checked = field.mandatory || field.selected;
                        input.disabled = field.mandatory;
                        input.dataset.competitorExportField = field.id;
                        input.id = `${prefix || 'export'}CompetitorExportField_${field.id}`;
                        const copy = document.createElement('span');
                        copy.textContent = field.mandatory
                            ? `${field.label} · obligatoire`
                            : field.label;
                        label.append(input, copy);
                        options.appendChild(label);
                    });
                    group.append(heading, options);
                    fieldset.appendChild(group);
                });
                const explanation = document.createElement('p');
                explanation.className = 'competitor-export-field-picker__help';
                explanation.textContent = (
                    'Une colonne optionnelle entièrement vide est omise. '
                    + 'Les absences partielles sont expliquées une seule fois.'
                );
                fieldset.appendChild(explanation);
                if (exportTrigger?.parentNode) {
                    exportTrigger.parentNode.insertBefore(exportSplit, exportTrigger);
                    exportSplit.appendChild(exportTrigger);
                    const fieldsToggle = document.createElement('button');
                    fieldsToggle.type = 'button';
                    fieldsToggle.className = 'ui-btn ui-btn-secondary secondary-btn home-competitor-export-toggle';
                    fieldsToggle.innerHTML = '<span aria-hidden="true">⌄</span><span class="sr-only">Choisir les champs exportés</span>';
                    fieldsToggle.setAttribute('aria-label', 'Choisir les champs exportés');
                    fieldsToggle.setAttribute('aria-controls', fieldset.id);
                    fieldsToggle.setAttribute('aria-expanded', 'false');
                    exportSplit.appendChild(fieldsToggle);
                    const mountTarget = prefix
                        ? toolsBody
                        : document.querySelector(
                            '#competitorVisualExportDialog .home-legend-controls',
                        );
                    (mountTarget || toolsBody).appendChild(fieldset);
                    const inputs = Array.from(fieldset.querySelectorAll(
                        'input[data-competitor-export-field]',
                    ));
                    const count = legend.querySelector('[data-competitor-export-field-count]');
                    const updateCount = () => {
                        const selected = inputs.filter((input) => input.checked).length;
                        count.textContent = `${selected}/${inputs.length}`;
                    };
                    const dispatchFieldChange = () => {
                        updateCount();
                        window.maplyticsCompetitorVisualExportDialog?.invalidate?.(
                            'competitor-export-fields-changed',
                        );
                        document.dispatchEvent(new CustomEvent('competitor-export-fields-change', {
                            detail: {surface: prefix ? 'import' : 'export'},
                        }));
                    };
                    fieldset.addEventListener('change', dispatchFieldChange);
                    fieldset.querySelector('[data-competitor-export-select-all]')
                        ?.addEventListener('click', () => {
                            inputs.forEach((input) => { input.checked = true; });
                            dispatchFieldChange();
                        });
                    fieldset.querySelector('[data-competitor-export-reset]')
                        ?.addEventListener('click', () => {
                            inputs.forEach((input) => {
                                const field = fieldsById.get(input.value);
                                input.checked = Boolean(field?.mandatory || field?.selected);
                            });
                            dispatchFieldChange();
                        });
                    fieldsToggle.addEventListener('click', () => {
                        if (!prefix && !document.getElementById('competitorVisualExportDialog')?.open) {
                            window.maplyticsCompetitorVisualExportDialog?.open?.();
                        }
                        toolsDetails.open = true;
                        fieldsToggle.setAttribute('aria-expanded', 'true');
                        fieldset.scrollIntoView({block: 'nearest'});
                        window.requestAnimationFrame(() => {
                            legend.focus({preventScroll: true});
                        });
                    });
                    document.addEventListener('keydown', (event) => {
                        if (
                            event.key === 'Escape'
                            && fieldset.contains(document.activeElement)
                        ) {
                            event.preventDefault();
                            if (!prefix) {
                                const visualDialog = document.getElementById(
                                    'competitorVisualExportDialog',
                                );
                                if (visualDialog?.open) visualDialog.close();
                            }
                            fieldsToggle.setAttribute('aria-expanded', 'false');
                            window.setTimeout(
                                () => fieldsToggle.focus({preventScroll: true}),
                                0,
                            );
                        }
                    });
                    if (!prefix) {
                        document.getElementById('competitorVisualExportDialog')
                            ?.addEventListener('close', () => {
                                fieldsToggle.setAttribute('aria-expanded', 'false');
                            });
                    }
                    updateCount();
                } else {
                    toolsBody.appendChild(fieldset);
                }
            }
            if (toolsBody.children.length > 0 && !content.querySelector('.competitors-tools')) {
                if (listDisclosure) {
                    listDisclosure.insertAdjacentElement('afterend', toolsDetails);
                } else if (listPanel) {
                    listPanel.insertAdjacentElement('afterend', toolsDetails);
                } else {
                    content.appendChild(toolsDetails);
                }
            }

            const createRegion = (key, title, description) => {
                const region = document.createElement('section');
                const regionId = `${prefix || 'export'}CompetitorWorkspace${key.charAt(0).toUpperCase()}${key.slice(1)}`;
                region.className = `competitor-workspace-region competitor-workspace-region--${key}`;
                region.dataset.competitorWorkspaceRegion = key;
                region.setAttribute('aria-labelledby', `${regionId}Title`);
                region.innerHTML = `
                    <header class="competitor-workspace-region__header">
                        <div class="competitor-workspace-region__heading">
                            <span class="competitor-workspace-region__step" aria-hidden="true"></span>
                            <h4 id="${regionId}Title">${title}</h4>
                            <p class="sr-only">${description}</p>
                        </div>
                        ${key === 'results' ? '<output data-competitor-workspace-region-status role="status" aria-live="polite">Aucun concurrent ajouté.</output>' : ''}
                    </header>
                    <div class="competitor-workspace-region__body"></div>
                `;
                return region;
            };
            const regionDefinitions = [
                ['search', 'Rechercher', 'Définissez les critères et le périmètre de recherche.'],
                ['results', 'Résultats', 'Consultez et sélectionnez les concurrents ajoutés.'],
                ['exploit', 'Exploiter', 'Choisissez leur affichage, leur score et leur export.'],
            ];
            const regions = new Map(regionDefinitions.map((definition, index) => {
                const region = createRegion(...definition);
                region.querySelector('.competitor-workspace-region__step').textContent = String(index + 1);
                return [definition[0], region];
            }));
            const searchRegion = regions.get('search');
            const resultsRegion = regions.get('results');
            const exploitRegion = regions.get('exploit');
            if (searchBlock) searchRegion.querySelector('.competitor-workspace-region__body').appendChild(searchBlock);
            const resultsBody = resultsRegion.querySelector('.competitor-workspace-region__body');
            if (listDisclosure) resultsBody.appendChild(listDisclosure);
            const removedDisclosure = document.createElement('details');
            removedDisclosure.className = 'competitor-removed-items';
            removedDisclosure.setAttribute('data-competitor-removed-items', '');
            removedDisclosure.hidden = true;
            removedDisclosure.innerHTML = `
                <summary>
                    <span>Retirés</span>
                    <strong data-competitor-removed-count>0</strong>
                </summary>
                <ul data-competitor-removed-list aria-label="Éléments retirés manuellement"></ul>
            `;
            resultsBody.appendChild(removedDisclosure);
            const mountedTools = content.querySelector('.competitors-tools');
            if (mountedTools) exploitRegion.querySelector('.competitor-workspace-region__body').appendChild(mountedTools);
            const regionFragment = document.createDocumentFragment();
            regionDefinitions.forEach(([key]) => regionFragment.appendChild(regions.get(key)));
            content.insertBefore(regionFragment, content.firstChild);
            content.dataset.competitorWorkspace = 'v23';

            const resultsStatus = resultsRegion.querySelector('[data-competitor-workspace-region-status]');
            const renderRemovedItems = (snapshot) => {
                const items = snapshot.removed.items;
                const countNode = removedDisclosure.querySelector('[data-competitor-removed-count]');
                const listNode = removedDisclosure.querySelector('[data-competitor-removed-list]');
                countNode.textContent = String(items.length);
                removedDisclosure.hidden = items.length === 0;
                listNode.replaceChildren(...items.map((item) => {
                    const row = document.createElement('li');
                    row.dataset.removedItemKey = item.key;
                    const label = document.createElement('strong');
                    label.textContent = item.label;
                    const secondary = document.createElement('span');
                    const kindLabel = item.kind === 'custom_point' ? 'Point' : 'Concurrent';
                    const removedDate = item.removedAt
                        ? new Date(item.removedAt).toLocaleString('fr-FR')
                        : '';
                    secondary.textContent = [kindLabel, item.secondaryLabel, removedDate]
                        .filter(Boolean)
                        .join(' · ');
                    const exactSearchRow = manager.lastSearchResults.find(
                        (candidate) => manager.competitorIdentity(candidate) === item.identity,
                    );
                    const restoreAvailable = item.kind === 'competitor'
                        && Boolean(item.restore_row || exactSearchRow);
                    const restore = document.createElement('button');
                    restore.type = 'button';
                    restore.className = 'competitor-restore-btn';
                    restore.dataset.competitorRestoreKey = item.key;
                    restore.disabled = !restoreAvailable;
                    restore.title = restoreAvailable
                        ? `Restaurer ${item.label}`
                        : 'Nouvelle recherche nécessaire avant restauration';
                    restore.setAttribute('aria-label', restore.title);
                    restore.innerHTML = '<i class="fas fa-undo-alt" aria-hidden="true"></i>';
                    const copy = document.createElement('div');
                    copy.className = 'competitor-removed-item__copy';
                    copy.append(label, secondary);
                    if (!restoreAvailable && item.kind === 'competitor') {
                        const reason = document.createElement('small');
                        reason.textContent = 'Nouvelle recherche nécessaire';
                        copy.appendChild(reason);
                    }
                    row.append(copy, restore);
                    return row;
                }));
            };
            removedDisclosure.addEventListener('click', (event) => {
                const button = event.target.closest('[data-competitor-restore-key]');
                if (!button || button.disabled) return;
                manager.restoreRemovedCompetitor(button.dataset.competitorRestoreKey);
            });
            const updateRegionState = (snapshot) => {
                const search = snapshot.search;
                const count = snapshot.counts.total;
                const removedCount = snapshot.counts.removed;
                const labels = {
                    idle: count ? `${count} concurrent${count > 1 ? 's' : ''} ajouté${count > 1 ? 's' : ''}.` : 'Aucun concurrent ajouté.',
                    loading: 'Recherche en cours…',
                    ready: `${search.available_result_ids.length} résultat${search.available_result_ids.length > 1 ? 's' : ''} à examiner · ${count} ajouté${count > 1 ? 's' : ''}.`,
                    empty: 'Aucun résultat pour ces critères. Modifiez la recherche.',
                    error: `Recherche impossible · ${search.error}`,
                };
                resultsRegion.dataset.state = search.status;
                resultsRegion.setAttribute('aria-busy', search.status === 'loading' ? 'true' : 'false');
                resultsStatus.textContent = (labels[search.status] || labels.idle)
                    + (removedCount ? ` · ${removedCount} retiré${removedCount > 1 ? 's' : ''}.` : '');
                renderRemovedItems(snapshot);
                const requiresRows = [
                    prefix ? `#${prefix}CompetitorOpenModalBtn` : '#competitorOpenModalBtn',
                    prefix ? `#${prefix}CompetitorToggleMapBtn` : '#competitorToggleMapBtn',
                    prefix ? `#${prefix}CompetitorExportBtn` : '#competitorExportBtn',
                    prefix ? `#${prefix}CompetitorLegendBtn` : '#competitorLegendBtn',
                    '.competitors-number-all-action',
                ];
                requiresRows.forEach((selector) => {
                    const control = exploitRegion.querySelector(selector);
                    if (!control) return;
                    control.disabled = count === 0;
                    control.dataset.workspaceUnavailable = count === 0 ? 'no-results' : '';
                });
            };
            manager._competitorWorkspaceRegionUnsubscribe?.();
            manager._competitorWorkspaceRegionUnsubscribe = (
                manager.competitorWorkspaceController.subscribe(updateRegionState)
            );

            const list = document.querySelector(`${scopeSelector} #${listId}`);
            if (list) {
                list.classList.add('competitors-scroll-list');
            }
        };

        // Fonction générique pour initialiser l'onglet Concurrents
        const initCompetitorsTab = (manager, scopeSelector, prefix = '') => {
            const panelPreferenceKey = `home_competitor_workspace_panels_v1:${prefix || 'export'}`;
            manager.competitorPanelPreferenceStore = manager.competitorPanelPreferenceStore
                || window.MaplyticsCompetitorSearch.createPanelPreferenceStore(panelPreferenceKey);
            enhanceCompetitorsPanelV2(scopeSelector, prefix, manager);
            let competitorNafCatalog = null;
            let competitorNafCatalogPromise = null;
            const loadCompetitorNafCatalog = async () => {
                if (competitorNafCatalog) return competitorNafCatalog;
                if (!competitorNafCatalogPromise) {
                    competitorNafCatalogPromise = fetch('/api/competitors/naf-codes')
                        .then((response) => response.json())
                        .then((payload) => {
                            competitorNafCatalog = payload?.success && Array.isArray(payload.codes)
                                ? payload.codes
                                : [];
                            return competitorNafCatalog;
                        })
                        .catch((error) => {
                            console.error('Erreur chargement codes NAF:', error);
                            competitorNafCatalog = [];
                            return competitorNafCatalog;
                        });
                }
                return competitorNafCatalogPromise;
            };
            const searchRoot = document.querySelector(`${scopeSelector} .home-competitors-search`);
            if (
                searchRoot
                && !manager.competitorFilterBuilder
                && window.MaplyticsCompetitorSearch?.mountBuilder
            ) {
                manager.competitorFilterBuilder = window.MaplyticsCompetitorSearch.mountBuilder(
                    searchRoot,
                    {
                        idPrefix: prefix || 'export',
                        state: manager.competitorFilterState
                            || (manager.competitorFilterState = window.MaplyticsCompetitorSearch.createState()),
                        preferenceStore: manager.competitorPanelPreferenceStore,
                        getSuggestions: async (type, query) => (
                            window.MaplyticsCompetitorSearch.catalogSuggestions(
                                await loadCompetitorNafCatalog(),
                                type,
                                query,
                            )
                        ),
                        getScopeOptions: () => manager.competitorScopeOptions(),
                        resolveScope: (value) => manager.resolveCompetitorScope(value),
                        onSearch: async (snapshot) => {
                            const result = await manager.searchCompetitors('structured', snapshot);
                            if (result?.cancelled) return result;
                            if (!result?.success) {
                                throw new Error(result?.error || 'Recherche impossible.');
                            }
                            return result;
                        },
                        onReopen: () => manager.openCompetitorSearchSnapshot(),
                    },
                );
                manager.initCompetitorSnapshotSync();
                manager.initZoneScopeSync();
                const savedSnapshot = manager.setCompetitorSearchSnapshot(
                    manager.competitorSearchSnapshot,
                    { restoreBuilder: true },
                );
                if (savedSnapshot) {
                    manager.competitorFilterBuilder.setSnapshotAvailable(
                        true,
                        manager.competitorSnapshotSourceState(savedSnapshot).label,
                    );
                }
            }
            // Event listeners pour les méthodes de recherche
            const methodButtons = document.querySelectorAll(`${scopeSelector} .competitor-search-method-btn`);
            methodButtons.forEach(btn => {
                btn.addEventListener('click', () => {
                    const method = btn.dataset.method;

                    // Désactiver tous les boutons dans ce scope
                    methodButtons.forEach(b => {
                        b.classList.remove('active');
                        b.style.borderBottomColor = 'transparent';
                        b.style.color = '#64748b';
                        b.style.fontWeight = '500';
                    });

                    // Activer le bouton sélectionné
                    btn.classList.add('active');
                    btn.style.borderBottomColor = '#2563eb';
                    btn.style.color = '#2563eb';
                    btn.style.fontWeight = '600';

                    // Afficher le bon formulaire
                    document.querySelectorAll(`${scopeSelector} .competitor-search-form`).forEach(form => {
                        form.style.display = 'none';
                    });

                    // Construire l'ID avec la bonne casse (prefix peut être 'import' ou vide)
                    const methodCapitalized = method.charAt(0).toUpperCase() + method.slice(1);
                    const formId = prefix ? `${prefix}CompetitorSearch${methodCapitalized}` : `competitorSearch${methodCapitalized}`;
                    const activeForm = document.querySelector(`${scopeSelector} #${formId}`);
                    if (activeForm) {
                        activeForm.style.display = 'block';
                    } else {
                        console.warn(`Formulaire de recherche introuvable: #${formId}`);
                    }
                });
            });

            // ===== Autocomplete NAF =====
            const nafInputId = prefix ? `${prefix}CompetitorNafCode` : 'competitorNafCode';
            const nafAutoId = prefix ? `${prefix}CompetitorNafAutocomplete` : 'competitorNafAutocomplete';
            const nafSelectedId = prefix ? `${prefix}CompetitorNafSelected` : 'competitorNafSelected';
            const nafInput = document.querySelector(`${scopeSelector} #${nafInputId}`);
            const nafAutoDiv = document.querySelector(`${scopeSelector} #${nafAutoId}`);
            const nafSelectedDiv = document.querySelector(`${scopeSelector} #${nafSelectedId}`);
            let nafSelectedCodes = [];
            const looksLikeNafQuery = (value) => String(value || '')
                .split(';')
                .map(part => part.trim().replace(/\s+/g, ''))
                .filter(Boolean)
                .every(part => /^\d{2}\.?\d{2}[a-z]$/i.test(part));

            if (nafInput && nafAutoDiv) {
                let nafDebounce = null;

                const renderNafSelected = () => {
                    if (!nafSelectedDiv) return;
                    nafSelectedDiv.innerHTML = nafSelectedCodes.map(c =>
                        `<span style="display: inline-flex; align-items: center; gap: 0.25rem; padding: 0.15rem 0.5rem; background: #eff6ff; border: 1px solid #bfdbfe; border-radius: 1rem; font-size: 0.75rem; color: #1e40af;">
                            ${c} <button type="button" data-code="${c}" style="background: none; border: none; cursor: pointer; color: #93c5fd; font-size: 0.9rem; line-height: 1; padding: 0;">&times;</button>
                        </span>`
                    ).join('');
                    // Sync input value
                    nafInput.value = '';
                    nafInput.placeholder = nafSelectedCodes.length > 0 ? 'Ajouter un autre code...' : 'Rechercher : boulangerie, 10.71C...';
                    // Remove tag click
                    nafSelectedDiv.querySelectorAll('button[data-code]').forEach(btn => {
                        btn.addEventListener('click', () => {
                            nafSelectedCodes = nafSelectedCodes.filter(c => c !== btn.dataset.code);
                            renderNafSelected();
                        });
                    });
                };

                const filterNaf = (codes, query) => {
                    const q = query.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
                    return codes.filter(entry => {
                        if (nafSelectedCodes.includes(entry.code)) return false;
                        const code = entry.code.toLowerCase();
                        const label = (entry.label || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
                        const sectors = (entry.sectors || []).join(' ').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
                        return code.includes(q) || label.includes(q) || sectors.includes(q);
                    }).slice(0, 15);
                };

                nafInput.addEventListener('focus', () => loadCompetitorNafCatalog());
                nafInput.addEventListener('input', () => {
                    clearTimeout(nafDebounce);
                    nafDebounce = setTimeout(async () => {
                        const q = nafInput.value.trim();
                        if (q.length < 2) { nafAutoDiv.style.display = 'none'; return; }
                        const codes = await loadCompetitorNafCatalog();
                        const matches = filterNaf(codes, q);
                        if (matches.length === 0) { nafAutoDiv.style.display = 'none'; return; }
                        nafAutoDiv.innerHTML = matches.map(m => {
                            const sectorsStr = m.sectors.length > 0 ? ` <span style="color: #94a3b8;">(${m.sectors.join(', ')})</span>` : '';
                            return `<div class="naf-autocomplete-item" data-code="${m.code}" style="padding: 0.5rem 0.75rem; cursor: pointer; border-bottom: 1px solid #f1f5f9; font-size: 0.85rem; transition: background 0.1s;">
                                <strong>${m.code}</strong> — ${m.label || 'Sans libellé'}${sectorsStr}
                            </div>`;
                        }).join('');
                        nafAutoDiv.style.display = 'block';
                        // Hover style
                        nafAutoDiv.querySelectorAll('.naf-autocomplete-item').forEach(item => {
                            item.addEventListener('mouseenter', () => item.style.background = '#f1f5f9');
                            item.addEventListener('mouseleave', () => item.style.background = '');
                            item.addEventListener('click', () => {
                                if (!nafSelectedCodes.includes(item.dataset.code)) {
                                    nafSelectedCodes.push(item.dataset.code);
                                    renderNafSelected();
                                }
                                nafAutoDiv.style.display = 'none';
                            });
                        });
                    }, 200);
                });
                // Fermer dropdown au clic exterieur
                document.addEventListener('click', (e) => {
                    if (!nafInput.contains(e.target) && !nafAutoDiv.contains(e.target)) {
                        nafAutoDiv.style.display = 'none';
                    }
                });
            }

            // Event listeners pour les boutons de recherche
            // Construire les IDs avec la bonne casse
            const nafBtnId = prefix ? `${prefix}CompetitorSearchNafBtn` : 'competitorSearchNafBtn';
            const nafBtn = document.querySelector(`${scopeSelector} #${nafBtnId}`);
            if (nafBtn && nafBtn.dataset.competitorBound !== 'true') {
                nafBtn.dataset.competitorBound = 'true';
                nafBtn.addEventListener('click', (event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    // Utiliser les codes selectionnes via autocomplete, ou le texte brut
                    const codeId = prefix ? `${prefix}CompetitorNafCode` : 'competitorNafCode';
                    const rawInput = document.querySelector(`${scopeSelector} #${codeId}`)?.value.trim();
                    const code = nafSelectedCodes.length > 0 ? nafSelectedCodes.join(';') : rawInput;
                    if (!code) {
                        alert('Veuillez sélectionner ou entrer un code NAF.');
                        return;
                    }
                    const method = nafSelectedCodes.length > 0 || looksLikeNafQuery(code) ? 'naf' : 'sector';
                    manager.searchCompetitors(method, code);
                });
            } else {
                console.warn(`Bouton recherche NAF introuvable: #${nafBtnId}`);
            }

            // Bouton ajouter point GPS sur la carte
            const addGpsBtnId = prefix ? `${prefix}CompetitorAddGpsBtn` : 'competitorAddGpsBtn';
            const addGpsBtn = document.querySelector(`${scopeSelector} #${addGpsBtnId}`);
            if (addGpsBtn) {
                addGpsBtn.addEventListener('click', () => {
                    const singleId = prefix ? `${prefix}CompetitorGpsSingle` : 'competitorGpsSingle';
                    const raw = document.querySelector(`${scopeSelector} #${singleId}`)?.value.trim();
                    if (!raw) {
                        alert('Veuillez entrer les coordonnées GPS.');
                        return;
                    }
                    const parts = raw.split(/[,;\s]+/).filter(Boolean);
                    if (parts.length < 2) {
                        alert('Format attendu : lat, lon');
                        return;
                    }
                    const lat = parseFloat(parts[0]);
                    const lon = parseFloat(parts[1]);
                    if (isNaN(lat) || isNaN(lon)) {
                        alert('Coordonnées invalides.');
                        return;
                    }
                    manager.addCustomPointFromGps(lat, lon);
                });
            }

            // Bouton multi-paste GPS
            const addGpsMultiBtnId = prefix ? `${prefix}CompetitorAddGpsMultiBtn` : 'competitorAddGpsMultiBtn';
            const addGpsMultiBtn = document.querySelector(`${scopeSelector} #${addGpsMultiBtnId}`);
            if (addGpsMultiBtn) {
                addGpsMultiBtn.addEventListener('click', () => {
                    const multiId = prefix ? `${prefix}CompetitorGpsMulti` : 'competitorGpsMulti';
                    const textarea = document.querySelector(`${scopeSelector} #${multiId}`);
                    const raw = textarea?.value.trim();
                    if (!raw) {
                        alert('Collez des coordonnées (une par ligne, format: lat, lon).');
                        return;
                    }
                    const lines = raw.split('\n').map(l => l.trim()).filter(Boolean);
                    let added = 0;
                    let errors = 0;
                    for (const line of lines) {
                        const parts = line.split(/[,;\s]+/).filter(Boolean);
                        if (parts.length >= 2) {
                            const lat = parseFloat(parts[0]);
                            const lon = parseFloat(parts[1]);
                            if (!isNaN(lat) && !isNaN(lon)) {
                                manager.addCustomPointFromGps(lat, lon);
                                added++;
                            } else {
                                errors++;
                            }
                        } else {
                            errors++;
                        }
                    }
                    if (textarea) textarea.value = '';
                    let msg = `${added} point(s) ajouté(s) sur la carte.`;
                    if (errors > 0) msg += ` ${errors} ligne(s) ignorée(s) (format invalide).`;
                    alert(msg);
                });
            }

            const sectorBtnId = prefix ? `${prefix}CompetitorSearchSectorBtn` : 'competitorSearchSectorBtn';
            const sectorBtn = document.querySelector(`${scopeSelector} #${sectorBtnId}`);
            if (sectorBtn) {
                sectorBtn.addEventListener('click', () => {
                    const sectorId = prefix ? `${prefix}CompetitorSector` : 'competitorSector';
                    const sector = document.querySelector(`${scopeSelector} #${sectorId}`)?.value.trim();
                    if (!sector) {
                        alert('Veuillez entrer un nom de secteur.');
                        return;
                    }
                    manager.searchCompetitors('sector', sector);
                });
            } else {
                console.warn(`Bouton recherche secteur introuvable: #${sectorBtnId}`);
            }

            // ===== Boutons SIREN/SIRET =====
            const sirenBtnId = prefix ? `${prefix}CompetitorSearchSirenBtn` : 'competitorSearchSirenBtn';
            const sirenBtn = document.querySelector(`${scopeSelector} #${sirenBtnId}`);
            if (sirenBtn) {
                sirenBtn.addEventListener('click', () => {
                    const codeId = prefix ? `${prefix}CompetitorSirenCode` : 'competitorSirenCode';
                    const code = document.querySelector(`${scopeSelector} #${codeId}`)?.value.trim();
                    if (!code) { alert('Veuillez entrer un numéro SIREN ou SIRET.'); return; }
                    manager.searchCompetitors('siren', code);
                });
            }
            const sirenBatchBtnId = prefix ? `${prefix}CompetitorSearchSirenBatchBtn` : 'competitorSearchSirenBatchBtn';
            const sirenBatchBtn = document.querySelector(`${scopeSelector} #${sirenBatchBtnId}`);
            if (sirenBatchBtn) {
                sirenBatchBtn.addEventListener('click', () => {
                    const batchId = prefix ? `${prefix}CompetitorSirenBatch` : 'competitorSirenBatch';
                    const textarea = document.querySelector(`${scopeSelector} #${batchId}`);
                    const lines = (textarea?.value || '').split('\n').map(l => l.trim()).filter(Boolean);
                    if (lines.length === 0) { alert('Veuillez entrer au moins un numéro.'); return; }
                    manager.searchCompetitors('siren', lines.join(';'));
                });
            }

            // Bouton toggle visibilité carte
            const toggleMapBtnId = prefix ? `${prefix}CompetitorToggleMapBtn` : 'competitorToggleMapBtn';
            const toggleMapBtn = document.querySelector(`${scopeSelector} #${toggleMapBtnId}`);
            if (toggleMapBtn) {
                toggleMapBtn.addEventListener('click', () => {
                    manager.toggleMapVisibility();
                });
            } else {
                console.warn(`Bouton toggle carte introuvable: #${toggleMapBtnId}`);
            }

            // Bouton voir les concurrents ajoutes
            const openModalBtnId = prefix ? `${prefix}CompetitorOpenModalBtn` : 'competitorOpenModalBtn';
            const openModalBtn = document.querySelector(`${scopeSelector} #${openModalBtnId}`);
            if (openModalBtn && openModalBtn.dataset.competitorBound !== 'true') {
                openModalBtn.addEventListener('click', () => {
                    manager.openCompetitorsReviewModal();
                });
                openModalBtn.dataset.competitorBound = 'true';
            }

            // Bouton attractivité
            const attractBtnId = prefix ? `${prefix}CompetitorAttractBtn` : 'competitorAttractBtn';
            const attractBtn = document.querySelector(`${scopeSelector} #${attractBtnId}`);
            if (attractBtn && attractBtn.dataset.competitorAttractBound !== 'true') {
                attractBtn.addEventListener('click', (event) => {
                    manager.openAttractivenessConfiguration(event.currentTarget);
                });
                attractBtn.dataset.competitorAttractBound = 'true';
            }
            const attractVisibilityBtnId = prefix
                ? `${prefix}CompetitorAttractVisibilityBtn`
                : 'competitorAttractVisibilityBtn';
            const attractVisibilityBtn = document.querySelector(
                `${scopeSelector} #${attractVisibilityBtnId}`,
            );
            if (
                attractVisibilityBtn
                && attractVisibilityBtn.dataset.competitorAttractVisibilityBound !== 'true'
            ) {
                attractVisibilityBtn.addEventListener('click', () => {
                    manager.setAttractivenessVisible(
                        !manager.attractivenessVisible,
                        { persist: true },
                    );
                });
                attractVisibilityBtn.dataset.competitorAttractVisibilityBound = 'true';
            }
            manager.syncAttractivenessVisibilityControl();

            // Bouton export
            const exportBtnId = prefix ? `${prefix}CompetitorExportBtn` : 'competitorExportBtn';
            const exportBtn = document.querySelector(`${scopeSelector} #${exportBtnId}`);
            if (exportBtn) {
                if (!prefix) {
                    if (!window.maplyticsCompetitorVisualExportDialog) {
                        if (
                            !window.MaplyticsCompetitorVisualExport?.createController
                            || !window.MaplyticsVisualExportRenderer?.createExporter
                        ) {
                            exportBtn.disabled = true;
                            exportBtn.title = 'La préparation de la fiche visuelle est indisponible.';
                            console.error('Module de fiche concurrence indisponible.');
                        } else {
                            window.maplyticsCompetitorVisualExportDialog = window.MaplyticsCompetitorVisualExport.createController({
                                manager,
                                exporter: window.MaplyticsVisualExportRenderer.createExporter(),
                                canExport: () => window.maplyticsHasFeature?.('competitor_export') === true,
                                onDenied: () => showPremiumNotice(
                                    'l’export de concurrents',
                                    'L’export de concurrents est inclus à partir du plan Starter.',
                                ),
                                getMapSnapshot: (snapshot, points) => (
                                    exportMapController?.capturePointVisualExportSnapshot?.(snapshot, points)
                                ),
                            });
                        }
                    }
                } else {
                    exportBtn.addEventListener('click', () => {
                        manager.exportToCSV();
                    });
                }
            } else {
                console.warn(`Bouton export introuvable: #${exportBtnId}`);
            }

            // Bouton legende
            const legendBtnId = prefix ? `${prefix}CompetitorLegendBtn` : 'competitorLegendBtn';
            const legendBtn = document.querySelector(`${scopeSelector} #${legendBtnId}`);
            if (legendBtn) {
                manager.syncPointsLegendButton();
                legendBtn.addEventListener('click', () => {
                    manager.togglePointsLegend();
                });
            }

            // Bouton ajouter point depuis adresse
            const addAddressBtnId = prefix ? `${prefix}CompetitorAddAddressBtn` : 'competitorAddAddressBtn';
            const addAddressBtn = document.querySelector(`${scopeSelector} #${addAddressBtnId}`);
            if (addAddressBtn) {
                addAddressBtn.addEventListener('click', () => {
                    const addressId = prefix ? `${prefix}CompetitorAddress` : 'competitorAddress';
                    const address = document.querySelector(`${scopeSelector} #${addressId}`)?.value.trim();
                    if (!address) {
                        alert('Veuillez entrer une adresse.');
                        return;
                    }
                    manager.addCustomPointFromAddress(address);
                });
            }

            // Bouton numérotation globale
            const numberAllBtn = document.querySelector(`${scopeSelector} .custom-points-number-all`);
            if (numberAllBtn) {
                numberAllBtn.addEventListener('click', () => manager.toggleNumberAll());
            }

            // Bouton numérotation des concurrents de base
            const numberCompetitorsBtn = document.querySelector(`${scopeSelector} .competitors-number-all-action`);
            if (numberCompetitorsBtn) {
                manager.syncCompetitorsNumberingButton();
                numberCompetitorsBtn.addEventListener('click', () => manager.toggleCompetitorsNumbering());
            }
            const saveRetry = document.querySelector(
                `${scopeSelector} [data-competitor-save-retry]`,
            );
            if (saveRetry && saveRetry.dataset.competitorSaveRetryBound !== 'true') {
                saveRetry.dataset.competitorSaveRetryBound = 'true';
                saveRetry.addEventListener('click', async (event) => {
                    event.preventDefault();
                    saveRetry.disabled = true;
                    await manager.saveCompetitors({ quiet: false });
                    if (saveRetry.hidden === false) saveRetry.disabled = false;
                });
            }
            const competitorColorInput = document.querySelector(
                `${scopeSelector} .competitor-marker-color-input`,
            );
            if (competitorColorInput) {
                manager.syncCompetitorMarkerColorControl();
                competitorColorInput.addEventListener('input', (event) => {
                    manager.setCompetitorMarkerColor(event.target.value, { persist: false });
                });
                competitorColorInput.addEventListener('change', (event) => {
                    manager.setCompetitorMarkerColor(event.target.value, { persist: true });
                });
            }
            const competitorScaleInput = document.querySelector(
                `${scopeSelector} [data-competitor-marker-scale]`,
            );
            if (competitorScaleInput) {
                manager.syncCompetitorMarkerScaleControl();
                competitorScaleInput.addEventListener('change', (event) => {
                    manager.setCompetitorMarkerScale(event.target.value, { persist: true });
                });
            }

            // Bouton mode sélection
            const selectModeBtn = document.querySelector(`${scopeSelector} .custom-points-select-mode`);
            if (selectModeBtn) {
                selectModeBtn.addEventListener('click', () => {
                    manager.toggleSelectMode();
                });
            }

            // Bouton ajouter dossier (points personnalisés)
            const addFolderBtn = document.querySelector(`${scopeSelector} .custom-points-add-folder`);
            if (addFolderBtn) {
                addFolderBtn.addEventListener('click', () => {
                    manager.showAddFolderPrompt();
                });
            }

            // Bouton toggle visibilité tous les points personnalisés
            const toggleAllPtsBtn = document.querySelector(`${scopeSelector} .custom-points-toggle-all`);
            if (toggleAllPtsBtn) {
                toggleAllPtsBtn.addEventListener('click', () => {
                    manager.toggleAllCustomPointsVisibility();
                });
            }

            // ===== Gestion projets =====
            const projectSelect = document.querySelector(`${scopeSelector} .competitor-project-select`);
            if (projectSelect) {
                projectSelect.addEventListener('change', () => {
                    const projectId = projectSelect.value;
                    // Confirmation si des donnees existent
                    if (
                        manager.competitors.length > 0
                        || manager.customPoints.length > 0
                        || manager.removedItems.length > 0
                    ) {
                        if (!confirm('Les donnees non sauvegardees seront perdues. Continuer ?')) {
                            // Restaurer la selection precedente
                            projectSelect.value = manager._competitorActiveProjectId || '';
                            return;
                        }
                    }
                    if (projectId) {
                        manager.loadProject(projectId).then((loaded) => {
                            projectSelect.value = loaded
                                ? String(projectId)
                                : String(manager._competitorActiveProjectId || '');
                            projectSelect._previousValue = projectSelect.value;
                        });
                    } else {
                        // "Nouveau projet" selectionne : vider les donnees
                        manager.restoreCompetitorStatePayload([]);
                        manager.setCompetitorSaveStatus('idle', 'Non sauvegardé');
                        projectSelect._previousValue = '';
                    }
                });
            }
            const projectSaveBtn = document.querySelector(`${scopeSelector} .competitor-project-save-btn`);
            if (projectSaveBtn) {
                projectSaveBtn.addEventListener('click', () => {
                    const projectId = projectSelect ? projectSelect.value : null;
                    if (projectId) {
                        manager.saveCompetitors();
                    } else {
                        manager.showNewProjectPrompt();
                    }
                });
            }
            const projectNewBtn = document.querySelector(`${scopeSelector} .competitor-project-new-btn`);
            if (projectNewBtn) {
                projectNewBtn.addEventListener('click', () => manager.showNewProjectPrompt());
            }
            const projectDeleteBtn = document.querySelector(`${scopeSelector} .competitor-project-delete-btn`);
            if (projectDeleteBtn) {
                projectDeleteBtn.addEventListener('click', () => {
                    const projectId = projectSelect ? projectSelect.value : null;
                    if (projectId && confirm('Supprimer ce projet ?')) {
                        manager.deleteProject(projectId);
                    }
                });
            }

            // Les anciens projets restent chargeables par URL pour compatibilité.
            // La surface visible de sauvegarde est désormais "Mes analyses".
            if (projectSelect) manager.loadProjectList();
        };

        const mountNetworkPointsTab = (manager) => (
            window.MaplyticsCompetitorNetworkComposition.mountNetworkPointsTab({
                manager,
                documentRef: document,
                fetchImpl: (...args) => fetch(...args),
                appConfig: APP_CONFIG,
                notify: showAppMessage,
                networkPointsState: window.MaplyticsNetworkPointsState,
                networkPointsUi: window.MaplyticsNetworkPointsUI,
            })
        );

        // Fonction générique pour initialiser l'onglet Statistiques
        const initStatsTab = (manager, scopeSelector, prefix = '') => {
            if (!manager) {
                console.warn('StatsManager not available for', scopeSelector);
                return;
            }
            const statsElementId = (suffix) => (
                prefix
                    ? `${prefix}${suffix.charAt(0).toUpperCase()}${suffix.slice(1)}`
                    : suffix
            );
            const runExport = (format, button) => {
                const exportMenu = button?.closest('details');
                if (exportMenu) exportMenu.open = false;
                return manager.exportStats(format);
            };

            // Sélecteur de zone
            const zoneSelect = document.querySelector(`${scopeSelector} #${statsElementId('statsZoneSelect')}`);
            if (zoneSelect) {
                // Mettre à jour les zones disponibles
                manager.updateZonesSelect();

                // Event listener pour changement de sélection
                zoneSelect.addEventListener('change', () => {
                    manager.syncComparisonSelector?.();
                    const statTypeSelect = document.querySelector(`${scopeSelector} #${statsElementId('statsTypeSelect')}`);
                    const displayFormatName = prefix === 'import' ? 'importStatsDisplayFormat' : 'statsDisplayFormat';
                    const displayFormat = document.querySelector(`${scopeSelector} input[name="${displayFormatName}"]:checked`);
                    if (statTypeSelect && displayFormat) {
                        manager.renderStats(statTypeSelect.value, displayFormat.value);
                    }
                });
            }

            // Sélecteur de statistique
            const statTypeSelect = document.querySelector(`${scopeSelector} #${statsElementId('statsTypeSelect')}`);
            const displayFormatName = prefix === 'import' ? 'importStatsDisplayFormat' : 'statsDisplayFormat';
            if (statTypeSelect) {
                statTypeSelect.addEventListener('change', () => {
                    const displayFormat = document.querySelector(`${scopeSelector} input[name="${displayFormatName}"]:checked`);
                    if (displayFormat) {
                        manager.renderStats(statTypeSelect.value, displayFormat.value);
                    }
                });
            }

            // Radio buttons format d'affichage
            const formatRadios = document.querySelectorAll(`${scopeSelector} input[name="${displayFormatName}"]`);
            formatRadios.forEach(radio => {
                radio.addEventListener('change', () => {
                    const statTypeSelect = document.querySelector(`${scopeSelector} #${statsElementId('statsTypeSelect')}`);
                    if (radio.checked && statTypeSelect) {
                        manager.renderStats(statTypeSelect.value, radio.value);
                    }
                });
            });

            // Boutons d'export
            const exportCSVBtn = document.querySelector(`${scopeSelector} #${statsElementId('statsExportCSVBtn')}`);
            if (exportCSVBtn) {
                exportCSVBtn.addEventListener('click', () => runExport('csv', exportCSVBtn));
            }

            const exportExcelBtn = prefix
                ? document.querySelector(`${scopeSelector} #${statsElementId('statsExportExcelBtn')}`)
                : document.getElementById('statsExportExcelBtn');
            if (exportExcelBtn) {
                exportExcelBtn.addEventListener('click', () => {
                    if (prefix) return runExport('excel', exportExcelBtn);
                    return openMultiZoneExcelDialog(exportExcelBtn);
                });
            }

            const exportPDFBtn = document.querySelector(`${scopeSelector} #${statsElementId('statsExportPDFBtn')}`);
            if (exportPDFBtn) {
                exportPDFBtn.addEventListener('click', () => runExport('png', exportPDFBtn));
            }

            const exportSimplePDFBtn = document.querySelector(`${scopeSelector} #${statsElementId('statsExportSimplePDFBtn')}`);
            if (exportSimplePDFBtn) {
                exportSimplePDFBtn.addEventListener('click', () => runExport('simple-pdf', exportSimplePDFBtn));
            }
        };

        const openSavedAnalysesBtn = document.getElementById('openSavedAnalysesBtn');
        if (openSavedAnalysesBtn) {
            openSavedAnalysesBtn.addEventListener('click', () => {
                zonesManager.switchTab('tab5');
                const searchInput = document.querySelector(
                    '#historyContent [data-history-search]'
                );
                window.requestAnimationFrame(() => {
                    searchInput?.focus({ preventScroll: true });
                });
            });
        }

        const createAnalysisFolderBtn = document.getElementById('createAnalysisFolderBtn');
        if (createAnalysisFolderBtn) {
            createAnalysisFolderBtn.addEventListener('click', async () => {
                zonesManager.switchTab('tab5');
                try {
                    const surfaces = await window.maplyticsSavedAnalysesReady;
                    const opened = await surfaces?.export?.openFolderCreationFlow?.();
                    if (!opened) {
                        showAppMessage(
                            'info',
                            'Connexion requise',
                            'Connectez-vous pour créer un dossier dans Mes analyses.',
                        );
                    }
                } catch (error) {
                    showAppMessage(
                        'error',
                        'Mes analyses indisponibles',
                        error?.message || 'Le dossier ne peut pas être préparé pour le moment.',
                    );
                }
            });
        }

        // Bouton pour ajouter une zone
        const addZoneBtn = document.getElementById('addZoneBtn');
        function syncAddZoneButtonState() {
            if (!addZoneBtn) return;
            const zoneCount = Number(zonesManager?.zones?.size || 0);
            const calculationPending = Boolean(
                exportCalculationInProgress || zonesManager?.pendingCreationRequest
            );
            const limitReached = zoneCount >= 6;
            const requiresUpgrade = zoneCount >= 1
                && typeof hasFeature === 'function'
                && !hasFeature('multi_zones');
            const lock = addZoneBtn.querySelector('.home-zone-add-btn__lock');

            let state = 'ready';
            let label = 'Ajouter une zone';
            let title = 'Ajouter une nouvelle zone de chalandise';
            let disabled = false;

            if (calculationPending) {
                state = 'calculating';
                label = 'Ajouter une zone, indisponible pendant le calcul';
                title = 'Attendez la fin du calcul avant d’ajouter une zone.';
                disabled = true;
            } else if (limitReached) {
                state = 'limit';
                label = 'Ajouter une zone, limite de six zones atteinte';
                title = 'La limite de six zones affichées est atteinte.';
                disabled = true;
            } else if (requiresUpgrade) {
                state = 'upgrade';
                label = 'Ajouter une zone, nécessite le plan Starter ou supérieur';
                title = 'Découvrir Starter pour créer plusieurs zones de chalandise.';
            }

            addZoneBtn.dataset.addZoneState = state;
            addZoneBtn.disabled = disabled;
            addZoneBtn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
            addZoneBtn.setAttribute('aria-label', label);
            addZoneBtn.title = title;
            if (lock) lock.hidden = !requiresUpgrade || disabled;
        }
        if (addZoneBtn) {
            addZoneBtn.addEventListener('click', () => {
                zonesManager.openCreateDialog(addZoneBtn);
            });
            syncAddZoneButtonState();
        }

        const resetHomeWorkspace = () => {
            if (zonesManager?.metadataRenamePending) {
                showAppMessage(
                    'warning',
                    'Renommage en cours',
                    'Attendez la confirmation du renommage avant de réinitialiser la carte.',
                );
                return false;
            }
            if (!markHomeWorkspaceReset()) {
                showAppMessage(
                    'error',
                    'Réinitialisation indisponible',
                    'Le navigateur ne permet pas de verrouiller la restauration automatique. Aucun contenu n’a été effacé.',
                );
                return false;
            }

            window.maplyticsClearOpenedAnalysis?.('isochrone');
            window.maplyticsPendingLegacyProjectLoad = null;
            try {
                const resetUrl = new URL(window.location.href);
                resetUrl.searchParams.delete('load_project');
                resetUrl.searchParams.delete('load_analysis');
                resetUrl.searchParams.delete('tool_type');
                window.history.replaceState({}, '', `${resetUrl.pathname}${resetUrl.search}${resetUrl.hash}`);
            } catch (_error) {
                // L'URL courante ne doit jamais empêcher le nettoyage local.
            }
            exportJobGeneration += 1;
            activeExportJob?.cancel?.();
            activeExportJob = null;
            const resetError = new Error('La création a été annulée par la réinitialisation de la carte.');
            resetError.code = 'home_workspace_reset';
            activeExportCreationRequest?.reject?.(resetError);
            activeExportCreationRequest = null;
            zonesManager?.pendingCreationRequest?.reject?.(resetError);
            zonesManager.pendingCreationRequest = null;

            clearTimeout(exportAddressDebounce);
            exportAddressDebounce = null;
            if (exportAddressAbort) exportAddressAbort.abort();
            exportAddressAbort = null;
            exportAddressSuggestionsData = [];
            hideExportAddressSuggestions();
            exportMapController?.cancelPendingInteractions?.();

            competitorsManager?.resetLocalWorkspace?.();
            zonesManager?.resetLocalWorkspace?.();
            exportMapController?.clearGeoJson?.();
            exportMapController?.clearMarker?.();

            if (exportQueryInput) {
                exportQueryInput.value = '';
                delete exportQueryInput.dataset.selectedAddress;
                exportQueryInput.disabled = false;
            }
            if (exportLatitudeInput) exportLatitudeInput.value = '';
            if (exportLongitudeInput) exportLongitudeInput.value = '';
            setExportAddressStatus('pending', 'Adresse à valider');
            setExportCalculationBusy(false);
            setFormLoading(exportForm, false);
            exportLogs.textContent = '';
            exportSummary.textContent = "Aucun calcul lancé pour l'instant.";
            hideProgress(exportProgress);

            [exportDownload, exportIsoLink, exportExcelLink].forEach((link) => {
                if (!link) return;
                link.hidden = true;
                link.removeAttribute('href');
                link.removeAttribute('data-job-id');
            });
            hideToolBridge('export');
            latestToolBridgeContext.export = null;
            const storedToolSnapshot = readToolResultSnapshot();
            if (!storedToolSnapshot || storedToolSnapshot.panelType === 'export') {
                sessionStorage.removeItem(TOOL_RESULT_SNAPSHOT_KEY);
            }
            sessionStorage.removeItem(TOOL_BRIDGE_CONTEXT_KEY);
            window.maplyticsVisualExportDialog?.close?.();
            window.maplyticsCompetitorVisualExportDialog?.close?.();
            document.querySelectorAll('.export-modal').forEach((modal) => {
                if (typeof modal.closeExportModal === 'function') modal.closeExportModal();
                else modal.querySelector('.export-modal-close')?.click();
            });
            window.maplyticsVisualExportController?.sync?.('home-workspace-reset');
            setResultsRailStatus('export', 'empty');
            document.dispatchEvent(new CustomEvent('maplytics:home-workspace-reset'));
            showAppMessage(
                'success',
                'Carte réinitialisée',
                'La session visuelle est vide. Vos analyses et projets sauvegardés restent disponibles.',
            );
            return true;
        };
        window.maplyticsResetHomeWorkspace = resetHomeWorkspace;

        const cancelActiveExportCreationForScopedReset = (scope) => {
            exportJobGeneration += 1;
            activeExportJob?.cancel?.();
            activeExportJob = null;
            const resetError = new Error(
                `La création a été annulée par la réinitialisation ciblée (${scope}).`,
            );
            resetError.code = `home_scoped_reset_${scope}`;
            activeExportCreationRequest?.reject?.(resetError);
            activeExportCreationRequest = null;
            zonesManager?.pendingCreationRequest?.reject?.(resetError);
            zonesManager.pendingCreationRequest = null;
            setExportCalculationBusy(false);
            setFormLoading(exportForm, false);
            hideProgress(exportProgress);
        };

        const clearHomeZoneDerivedOutputs = (reason) => {
            [exportDownload, exportIsoLink, exportExcelLink].forEach((link) => {
                if (!link) return;
                link.hidden = true;
                link.removeAttribute('href');
                link.removeAttribute('data-job-id');
            });
            hideToolBridge('export');
            latestToolBridgeContext.export = null;
            const storedToolSnapshot = readToolResultSnapshot();
            if (!storedToolSnapshot || storedToolSnapshot.panelType === 'export') {
                sessionStorage.removeItem(TOOL_RESULT_SNAPSHOT_KEY);
            }
            window.maplyticsVisualExportDialog?.close?.();
            window.maplyticsCompetitorVisualExportDialog?.close?.();
            window.maplyticsCompetitorVisualExportDialog?.invalidate?.(reason);
            setResultsRailStatus('export', 'empty');
        };

        const resetHomeZonesAndCompetitorsScope = () => {
            if (zonesManager?.metadataRenamePending) {
                showAppMessage(
                    'warning',
                    'Renommage en cours',
                    'Attendez la confirmation du renommage avant de réinitialiser la carte.',
                );
                return false;
            }
            if (!markHomeWorkspaceScopeResets(
                ['zones', 'competitors'],
                { purgePayload: true },
            )) {
                showAppMessage(
                    'error',
                    'Réinitialisation indisponible',
                    'Le navigateur ne permet pas de verrouiller la restauration des zones et concurrents. Aucun contenu n’a été effacé.',
                );
                return false;
            }

            cancelActiveExportCreationForScopedReset('zones_competitors');
            window.maplyticsClearOpenedAnalysis?.('isochrone');
            homeWorkspaceResetTransactionActive = true;
            document.documentElement.dataset.homeResetTransaction = 'zones_competitors';
            try {
                competitorsManager.resetLocalWorkspace();
                zonesManager.resetLocalWorkspace();
                clearHomeZoneDerivedOutputs('home-zones-competitors-reset');
            } finally {
                homeWorkspaceResetTransactionActive = false;
                delete document.documentElement.dataset.homeResetTransaction;
            }
            window.maplyticsVisualExportController?.sync?.('home-zones-competitors-reset');
            scheduleZonePresentationSync('home-zones-competitors-reset');
            document.dispatchEvent(new CustomEvent('maplytics:home-scoped-reset', {
                detail: {
                    scope: 'zones_competitors',
                    scopes: ['zones', 'competitors'],
                },
            }));
            showAppMessage(
                'success',
                'Carte réinitialisée',
                'Les zones, résultats, concurrents et points affichés ont été retirés. Le point de départ et vos sauvegardes sont conservés.',
            );
            return true;
        };

        const resetHomeZonesScope = () => {
            if (zonesManager?.metadataRenamePending) {
                showAppMessage(
                    'warning',
                    'Renommage en cours',
                    'Attendez la confirmation du renommage avant de réinitialiser les zones.',
                );
                return false;
            }
            if (!markHomeWorkspaceScopeReset('zones')) {
                showAppMessage(
                    'error',
                    'Réinitialisation indisponible',
                    'Le navigateur ne permet pas de verrouiller la restauration des zones. Aucun contenu n’a été effacé.',
                );
                return false;
            }
            cancelActiveExportCreationForScopedReset('zones');
            window.maplyticsClearOpenedAnalysis?.('isochrone');
            zonesManager.resetLocalWorkspace();
            clearHomeZoneDerivedOutputs('home-zones-reset');
            window.maplyticsVisualExportController?.sync?.('home-zones-reset');
            document.dispatchEvent(new CustomEvent('maplytics:home-scoped-reset', {
                detail: { scope: 'zones' },
            }));
            showAppMessage(
                'success',
                'Zones réinitialisées',
                'Les zones et leurs sorties ont été retirées. Le point actif, les concurrents et les points personnalisés sont conservés.',
            );
            return true;
        };

        const resetHomeOriginScope = () => {
            if (!markHomeWorkspaceScopeReset('origin')) {
                showAppMessage(
                    'error',
                    'Réinitialisation indisponible',
                    'Le navigateur ne permet pas de verrouiller la restauration du point. Aucun contenu n’a été effacé.',
                );
                return false;
            }
            cancelActiveExportCreationForScopedReset('origin');
            clearTimeout(exportAddressDebounce);
            exportAddressDebounce = null;
            if (exportAddressAbort) exportAddressAbort.abort();
            exportAddressAbort = null;
            exportAddressSuggestionsData = [];
            hideExportAddressSuggestions();
            exportMapController?.cancelPendingInteractions?.();
            exportMapController?.clearMarker?.();
            if (exportQueryInput) {
                exportQueryInput.value = '';
                delete exportQueryInput.dataset.selectedAddress;
                exportQueryInput.disabled = false;
            }
            if (exportLatitudeInput) exportLatitudeInput.value = '';
            if (exportLongitudeInput) exportLongitudeInput.value = '';
            setExportAddressStatus('pending', 'Adresse à valider');
            updateExportRecenterPointButton();
            window.maplyticsVisualExportController?.sync?.('home-origin-reset');
            document.dispatchEvent(new CustomEvent('maplytics:home-scoped-reset', {
                detail: { scope: 'origin' },
            }));
            showAppMessage(
                'success',
                'Point de départ retiré',
                'Le point actif a été retiré. Les zones calculées conservent leur origine enregistrée.',
            );
            return true;
        };

        const resetHomeCompetitorsScope = () => {
            if (!markHomeWorkspaceScopeReset('competitors')) {
                showAppMessage(
                    'error',
                    'Réinitialisation indisponible',
                    'Le navigateur ne permet pas de verrouiller la restauration des concurrents. Aucun contenu n’a été effacé.',
                );
                return false;
            }
            competitorsManager.resetLocalWorkspace({ preserveCustomPoints: true });
            window.maplyticsCompetitorVisualExportDialog?.close?.();
            window.maplyticsCompetitorVisualExportDialog?.invalidate?.('home-competitors-reset');
            window.maplyticsVisualExportController?.sync?.('home-competitors-reset');
            document.dispatchEvent(new CustomEvent('maplytics:home-scoped-reset', {
                detail: { scope: 'competitors' },
            }));
            showAppMessage(
                'success',
                'Concurrents supprimés',
                'Les concurrents affichés ont été retirés. Les zones, le point actif et les points personnalisés sont conservés.',
            );
            return true;
        };

        const HOME_SCOPED_RESET_CONFIRMATIONS = Object.freeze({
            zones_competitors: 'Réinitialiser les zones et les concurrents ?\n\nLes zones, tableaux, statistiques, concurrents, points personnalisés, scores et aperçus associés seront retirés. Le point de départ et vos analyses sauvegardées seront conservés. Aucune donnée serveur ne sera supprimée.',
            zones: 'Réinitialiser les zones de chalandise ?\n\nLes zones, statistiques, tableaux et aperçus associés seront retirés. Le point actif, les concurrents et les points personnalisés seront conservés. Aucune analyse sauvegardée ne sera modifiée.',
            origin: 'Retirer le point de départ actif ?\n\nLa saisie, les coordonnées, le marqueur libre et les calculs en cours seront annulés. Les zones déjà calculées et leur origine enregistrée seront conservées.',
            competitors: 'Supprimer les concurrents affichés ?\n\nLa liste, le score, les marqueurs et les exports Concurrents seront réinitialisés. Les zones, le point actif et les points personnalisés seront conservés. Aucun projet sauvegardé ne sera modifié.',
            all: 'Réinitialiser toute la carte ?\n\nLes zones, l’adresse, les résultats, les concurrents, les points et les aperçus affichés seront vidés. Vos analyses et projets sauvegardés ne seront ni modifiés ni supprimés.',
        });
        const HOME_SCOPED_RESET_ACTIONS = Object.freeze({
            zones_competitors: resetHomeZonesAndCompetitorsScope,
            zones: resetHomeZonesScope,
            origin: resetHomeOriginScope,
            competitors: resetHomeCompetitorsScope,
            all: resetHomeWorkspace,
        });
        const runHomeScopedResetAction = (scope) => {
            const action = HOME_SCOPED_RESET_ACTIONS[scope];
            const message = HOME_SCOPED_RESET_CONFIRMATIONS[scope];
            if (!action || !message || !confirm(message)) return false;
            return action();
        };
        window.maplyticsResetHomeScope = runHomeScopedResetAction;

        // Remise à zéro locale et ciblée, sans mutation des sauvegardes serveur.
        const clearAllZonesBtn = document.getElementById('clearAllZonesBtn');
        const homeScopedResetMenuBtn = document.getElementById('homeScopedResetMenuBtn');
        const homeScopedResetMenu = document.getElementById('homeScopedResetMenu');
        if (clearAllZonesBtn && homeScopedResetMenuBtn && homeScopedResetMenu) {
            window.maplyticsScopedWorkspaceResetController = (
                window.MaplyticsScopedWorkspaceReset?.create?.({
                    primary: clearAllZonesBtn,
                    trigger: homeScopedResetMenuBtn,
                    menu: homeScopedResetMenu,
                    onPrimary: () => runHomeScopedResetAction('zones_competitors'),
                    onAction: runHomeScopedResetAction,
                }) || null
            );
        }

        window.maplyticsOriginMarkerStyleController = (
            window.MaplyticsOriginMarkerStyle?.createDialogController?.({
                dialog: document.getElementById('homeOriginMarkerStyleDialog'),
                trigger: document.getElementById('homeOriginMarkerStyleBtn'),
                getOrigins: () => zonesManager.listOriginMarkerStyles(),
                onApply: (pointKey, style) => {
                    if (!zonesManager.updateOriginMarkerStyle(pointKey, style)) return;
                    showAppMessage(
                        'success',
                        'Point d’origine mis à jour',
                        'La carte et les prochains exports visuels utilisent cette apparence.',
                    );
                },
                onReset: (pointKey) => {
                    zonesManager.updateOriginMarkerStyle(
                        pointKey,
                        window.MaplyticsOriginMarkerStyle.DEFAULT_STYLE,
                    );
                },
            }) || null
        );

        // Initialiser le système d'onglets du zones-manager (Isochrone)
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => {
                zonesManager.initTabs();
                initCompetitorsTab(competitorsManager, '#zonesManager', '');
                mountNetworkPointsTab(competitorsManager);
                if (typeof statsManager !== 'undefined' && statsManager) {
                    initStatsTab(statsManager, '#zonesManager', '');
                }
            });
        } else {
            zonesManager.initTabs();
            initCompetitorsTab(competitorsManager, '#zonesManager', '');
            mountNetworkPointsTab(competitorsManager);
            if (typeof statsManager !== 'undefined' && statsManager) {
                initStatsTab(statsManager, '#zonesManager', '');
            }
        }

        // Initialiser le système d'onglets du zones-manager (Import-table)
        const importZonesManager = {
            initTabs() {
                // Event listeners pour les boutons d'onglets
                const tabButtons = document.querySelectorAll('#importZonesManager [data-tab]');
                tabButtons.forEach(btn => {
                    btn.addEventListener('click', () => {
                        const tabId = btn.getAttribute('data-tab');
                        if (tabId && !btn.disabled) {
                            if (APP_CONFIG.appShellV2) {
                                revealResultsPanel('import');
                            }
                            this.switchTab(tabId);
                        }
                    });
                });
            },

            switchTab(tabId) {
                // Masquer tous les contenus d'onglets
                const allContents = document.querySelectorAll('#importZonesManager .zones-tab-content');
                allContents.forEach(content => {
                    content.style.display = 'none';
                    content.classList.remove('active');
                });

                // Désactiver tous les boutons d'onglets
                const allTabs = document.querySelectorAll('#importZonesManager [data-tab]');
                allTabs.forEach(tab => {
                    tab.classList.remove('active');
                    tab.style.borderBottomColor = 'transparent';
                    tab.style.color = '#64748b';
                    tab.style.fontWeight = '500';
                });

                if (tabId === 'importTab5') {
                    window.maplyticsSavedAnalysisSurfaces?.import?.updateAvailability();
                }

                // Activer l'onglet sélectionné
                const selectedTab = document.querySelector(`#importZonesManager [data-tab="${tabId}"]`);
                const selectedContent = document.getElementById(`${tabId}-content`);

                if (selectedTab && selectedContent) {
                    selectedTab.classList.add('active');
                    selectedTab.style.borderBottomColor = '#2563eb';
                    selectedTab.style.color = '#2563eb';
                    selectedTab.style.fontWeight = '600';

                    selectedContent.style.display = 'block';
                    selectedContent.classList.add('active');

                    if (tabId === 'importTabMaps') {
                        const mapId = 'importMap';
                        window.requestAnimationFrame(() => {
                            document.getElementById(`choroplethSettingsTitle_${mapId}`)
                                ?.focus({ preventScroll: true });
                        });
                    }

                    // Animation fadeIn
                    selectedContent.style.opacity = '0';
                    setTimeout(() => {
                        selectedContent.style.transition = 'opacity 0.3s ease';
                        selectedContent.style.opacity = '1';
                    }, 10);
                }
            },

            updateTabVisibility() {
                // Pour Import-table, vérifier si le tableau a des données
                // Utiliser tableControllers.import.allRows plutôt que le DOM (plus fiable car populateTable est asynchrone)
                const hasData = tableControllers && tableControllers.import && tableControllers.import.allRows && tableControllers.import.allRows.length > 0;
                const hasMappedPoints = Boolean(
                    importCompetitorsManager
                    && (
                        importCompetitorsManager.competitors?.length
                        || importCompetitorsManager.customPoints?.length
                    )
                );

                const tab2 = document.getElementById('importZonesTab2');
                const tab3 = document.getElementById('importZonesTab3');
                const tab5 = document.getElementById('importZonesTab5');

                // Fonction helper pour gérer la visibilité d'un onglet
                const setTabVisibility = (tab, enabled) => {
                    if (!tab) return;
                    if (enabled) {
                        tab.style.opacity = '1';
                        tab.style.pointerEvents = 'auto';
                        tab.style.cursor = 'pointer';
                    } else {
                        tab.style.opacity = '0.5';
                        tab.style.pointerEvents = 'none';
                        tab.style.cursor = 'not-allowed';
                    }
                };

                // Données et statistiques exigent un import. L'historique reste
                // accessible pour les analyses enregistrées.
                setTabVisibility(tab2, hasData || hasMappedPoints);
                setTabVisibility(tab3, hasData);
                setTabVisibility(tab5, true);
            }
        };

        document.getElementById('importOpenSavedAnalysesBtn')?.addEventListener(
            'click',
            () => {
                importZonesManager.switchTab('importTab5');
                const searchInput = document.querySelector(
                    '#importHistoryContent [data-history-search]'
                );
                window.requestAnimationFrame(() => {
                    searchInput?.focus({ preventScroll: true });
                });
            },
        );

        const importInputPanel = document.getElementById('importInputPanel');
        const importModeTabs = Array.from(
            document.querySelectorAll('#importInputPanel .import-input-mode'),
        );
        const getImportGridEditor = () => {
            const editor = importGrid?.querySelector('td[contenteditable="true"]') || null;
            if (editor && !editor.id) editor.id = 'importGridActiveEditor';
            return editor;
        };
        const setImportInputMode = (
            mode = 'file',
            { focusPanel = true, notify = true } = {},
        ) => {
            const validMode = ['file', 'csv', 'grid'].includes(mode) ? mode : 'file';
            if (importInputPanel) importInputPanel.dataset.activeMode = validMode;
            importModeTabs.forEach((button) => {
                const active = button.dataset.importMode === validMode;
                button.classList.toggle('active', active);
                button.setAttribute('aria-selected', active ? 'true' : 'false');
                button.setAttribute('tabindex', active ? '0' : '-1');
            });
            importGuidedModeButtons.forEach((button) => {
                const active = button.dataset.importGuidedMode === validMode;
                button.setAttribute('aria-pressed', active ? 'true' : 'false');
            });
            document.querySelectorAll('#importInputPanel .import-input-section').forEach((section) => {
                section.hidden = section.dataset.importSection !== validMode;
            });
            // Un contrôle masqué ne doit jamais écraser la source visible dans
            // FormData. Le mode Tableur sérialise volontairement vers importData.
            importFileInput.disabled = validMode !== 'file';
            importDataTextarea.disabled = validMode === 'file';
            const target = validMode === 'file'
                ? importFileInput
                : validMode === 'csv'
                    ? importDataTextarea
                    : getImportGridEditor() || document.getElementById('importGridWrapper');
            if (focusPanel) {
                const focusGeneration = homePageLifecycleGeneration;
                window.setTimeout(() => {
                    // A delayed import focus must not steal focus from another
                    // tool, a newer input mode or an outgoing document.
                    if (focusGeneration !== homePageLifecycleGeneration
                        || importInputPanel?.dataset.activeMode !== validMode
                        || !target?.isConnected || target.disabled
                        || !target.getClientRects().length
                        || window.getComputedStyle(target).visibility !== 'visible') return;
                    target.focus?.();
                }, 50);
            }
            if (notify) {
                importInputPanel?.dispatchEvent(new CustomEvent('maplytics:import-mode-changed', {
                    detail: { mode: validMode },
                }));
            }
        };

        importModeTabs.forEach((button) => {
            button.addEventListener('click', () => setImportInputMode(button.dataset.importMode || 'file'));
            button.addEventListener('keydown', (event) => {
                let nextIndex = -1;
                const currentIndex = importModeTabs.indexOf(button);
                if (event.key === 'ArrowRight') {
                    nextIndex = (currentIndex + 1) % importModeTabs.length;
                } else if (event.key === 'ArrowLeft') {
                    nextIndex = (currentIndex - 1 + importModeTabs.length) % importModeTabs.length;
                } else if (event.key === 'Home') {
                    nextIndex = 0;
                } else if (event.key === 'End') {
                    nextIndex = importModeTabs.length - 1;
                }
                if (nextIndex < 0) return;
                event.preventDefault();
                const nextTab = importModeTabs[nextIndex];
                setImportInputMode(nextTab.dataset.importMode || 'file', { focusPanel: false });
                nextTab.focus();
            });
        });

        window.setImportInputMode = setImportInputMode;

        // Déplacer le panneau d'import progressif dans l'onglet 1 du zones-manager import-table
        function moveImportGridToTab1() {
            const importInputPanel = document.getElementById('importInputPanel');
            const importInputMount = document.getElementById('importInputMount');
            if (importInputPanel && importInputMount && importInputPanel.parentElement !== importInputMount) {
                importInputMount.appendChild(importInputPanel);
            }
            const importDetailedExports = document.getElementById('importDetailedExportChoices');
            const importDetailedExportMount = document.getElementById('importDetailedExportMount');
            if (
                importDetailedExports
                && importDetailedExportMount
                && importDetailedExports.parentElement !== importDetailedExportMount
            ) {
                importDetailedExportMount.appendChild(importDetailedExports);
            }
            setImportInputMode('file', { focusPanel: false, notify: false });
        }

        // Créer les instances de statsManager pour chaque outil (après définition de importZonesManager)
        const statsManager = createStatsManager('isochrone', '#zonesManager', '');
        const importStatsManager = createStatsManager('import-table', '#importZonesManager', 'import');
        window.maplyticsStatsManagers = Object.freeze({
            export: statsManager,
            import: importStatsManager,
        });

        const currentZoneProjectionRefs = () => (
            window.MaplyticsStatsPresentationCoordinator.buildProjectionRefs({
                zones: zonesManager.zones.values(),
                zonePointName,
                zoneOriginAddress,
                resolveTransportMode: (zone) => zonesManager.resolveTransportMode(zone),
                createJobSource: (jobId, data) => (
                    window.MaplyticsZonePresentation?.createJobSource?.(jobId, data)
                ),
            })
        );

        const markExpiredZoneProjectionSources = (change = {}) => (
            window.MaplyticsStatsPresentationCoordinator.markExpiredSources({
                change,
                zones: zonesManager.zones.values(),
                save: () => zonesManager.saveZonesToLocalStorage(),
            })
        );

        const projectedGeoJsonForZone = (zone, projectedZone, mode, fingerprint) => (
            window.MaplyticsStatsPresentationCoordinator.projectGeoJsonForZone({
                zone,
                projectedZone,
                mode,
                fingerprint,
            })
        );

        const applyZonePresentationSnapshot = (snapshot) => {
            const tableState = zonesManager.captureZoneMetadataTableState();
            const statsSelect = document.getElementById('statsZoneSelect');
            const statsSelection = statsSelect
                ? Array.from(statsSelect.selectedOptions).map((option) => option.value)
                : [];
            const mode = snapshot?.mapMode === 'exclusive'
                || snapshot?.mode === 'exclusive'
                ? 'exclusive'
                : 'cumulative';
            const projectedById = new Map(
                (snapshot?.projection?.zones || []).map((zone) => [String(zone.zone_id), zone]),
            );
            zonesManager.zones.forEach((zone, zoneId) => {
                const previous = exportMapController?.zonesLayers?.get(zoneId);
                const hierarchyVisible = zonesManager.hierarchyController
                    ?.isZoneVisible?.(zoneId);
                const visible = typeof hierarchyVisible === 'boolean'
                    ? hierarchyVisible
                    : previous?.visible !== false;
                const opacity = Number.isFinite(Number(previous?.opacity))
                    ? Number(previous.opacity)
                    : 1;
                const projectedZone = projectedById.get(String(zoneId));
                const geojson = projectedZone
                    ? projectedGeoJsonForZone(
                        zone,
                        projectedZone,
                        mode,
                        snapshot.projectionFingerprint,
                    )
                    : zone.geojson;
                if (!geojson) return;
                exportMapController?.renderGeoJson?.(
                    geojson,
                    zoneId,
                    zone.color,
                    mode === 'exclusive' && projectedZone?.range_label
                        ? projectedZone.range_label
                        : zone.name,
                    {
                        restoring: true,
                        animate: false,
                        deferBounds: true,
                        visible,
                    },
                );
                exportMapController?.updateZoneOpacity?.(zoneId, opacity);
                exportMapController?.setZoneVisibility?.(zoneId, visible);
            });
            exportMapController?.updateMapBounds?.(false);
            exportMapController?.updateMapLegendMultiZones?.();
            zonesManager._doUpdateTableWithZones({synchronous: true});
            zonesManager.restoreZoneMetadataTableState(tableState);
            zonesManager.updateExportSummary();
            zonesManager.updateZoneFilter();
            statsManager.updateZonesSelect();
            if (statsSelect && statsSelection.length) {
                let restored = false;
                Array.from(statsSelect.options).forEach((option) => {
                    option.selected = statsSelection.includes(option.value);
                    restored = restored || option.selected;
                });
                if (!restored) {
                    const globalOption = statsSelect.querySelector('option[value="global"]');
                    if (globalOption) globalOption.selected = true;
                }
            }
            if (statsManager.currentData?.statType) {
                statsManager.renderStats(
                    statsManager.currentData.statType,
                    statsManager.currentData.format,
                );
            }
            window.MaplyticsMultiZoneExcel?.invalidate?.(
                'export',
                'La présentation Cumul / Zone par zone a changé. Actualisez l’aperçu.',
            );
            window.maplyticsVisualExportController?.sync?.('zone-presentation-changed');
            document.dispatchEvent(new CustomEvent('maplytics:zone-presentation-changed', {
                detail: {
                    surface: 'export',
                    mode,
                    sourceMode: mode,
                    viewMode: mode,
                    sourceFingerprint: snapshot?.sourceFingerprint || '',
                    projectionFingerprint: snapshot?.projectionFingerprint || '',
                },
            }));
        };

        const applyStatsPresentationView = (snapshot) => (
            window.MaplyticsStatsPresentationCoordinator.applyStatsView({
                snapshot,
                statsManager,
                documentRef: document,
            })
        );

        exportZonePresentationController = (
            window.MaplyticsStatsPresentationCoordinator.createController({
                presentationApi: window.MaplyticsZonePresentation,
                getZoneRefs: currentZoneProjectionRefs,
                onApply: applyZonePresentationSnapshot,
                onViewChange: applyStatsPresentationView,
                onSourceLifecycleChange: markExpiredZoneProjectionSources,
                controls: {
                    root: document.getElementById('statsPresentationControl'),
                    cumulative: document.getElementById('statsPresentationCumulative'),
                    exclusive: document.getElementById('statsPresentationExclusive'),
                    comparison: document.getElementById('statsPresentationComparison'),
                    status: document.getElementById('statsPresentationStatus'),
                    recovery: document.querySelector('[data-stats-presentation-recovery]'),
                    recalculate: document.querySelector('[data-stats-presentation-recalculate]'),
                    openHistory: document.querySelector('[data-stats-presentation-open-history]'),
                },
                onRecalculate: focusExportZoneRecalculation,
                onOpenHistory: openExportSavedAnalyses,
            })
        );
        window.maplyticsZonePresentationController = exportZonePresentationController;
        window.maplyticsVisualExportController?.subscribe?.(() => {
            statsManager.syncExportChoices();
        });

        // Mes analyses partage un seul HistoryManager entre Export et Import.
        let historyManager, exportManager;
        let importExportManager;
        const savedAnalysesReadySignal = window.MaplyticsSavedAnalysisCoordinator
            .createReadySignal();
        let resolveHomeWorkspaceDraftReady;
        const homeWorkspaceDraftReady = new Promise((resolve) => {
            resolveHomeWorkspaceDraftReady = resolve;
        });

        function initPremiumManagers() {
            if (typeof ExportManager !== 'undefined') {
                exportManager = new ExportManager();
            }

            if (typeof ExportManager !== 'undefined') {
                importExportManager = new ExportManager();
            }

            const serializeCompetitorState = (manager) => {
                if (!manager?.competitorStatePayload) {
                    return {
                        schema_version: 'home_competitor_state_v2',
                        competitors: [],
                        customPoints: [],
                        pointFolders: [],
                        competitorsNumbered: false,
                        nextDisplayReference: 1,
                        competitorMarkerColor: window.MaplyticsCompetitorSearch.DEFAULT_COMPETITOR_MARKER_COLOR,
                        competitorMarkerScale: 'normal',
                        visibleOnMap: false,
                        pointsLegendVisible: false,
                        removedItems: [],
                        attractiveness: window.MaplyticsSavedAnalysisState
                            .buildAttractivenessState(),
                        network_points: window.MaplyticsNetworkPointsState.fromLegacy(),
                    };
                }
                return manager.competitorStatePayload();
            };

            const restoreCompetitorState = (manager, state = {}) => {
                if (!manager) return;
                manager.restoreCompetitorStatePayload?.(state, {
                    restoreBuilder: true,
                });
            };

            const restoreSelectedStatistic = (selectId, analysis) => {
                const selected = analysis?.stats_config?.selected_stat_type;
                const select = document.getElementById(selectId);
                if (
                    !selected
                    || !select
                    || !Array.from(select.options).some((option) => option.value === selected)
                ) {
                    return;
                }
                select.value = selected;
            };

            const captureIsochroneAnalysis = () => {
                const zones = Array.from(zonesManager.zones.values()).map((zone) =>
                    zonesManager.serializeZone(zone)
                );
                const competitorState = serializeCompetitorState(competitorsManager);
                return window.MaplyticsZoneAnalysisCoordinator.capture({
                    zones,
                    competitorState,
                    origin: {
                        query: document.getElementById('exportQuery')?.value || '',
                        lat: document.getElementById('exportLatitude')?.value || null,
                        lon: document.getElementById('exportLongitude')?.value || null,
                    },
                    transportMode: document.getElementById('exportTransportMode')?.value
                        || 'driving-car',
                    selectedStatistic: document.getElementById('statsTypeSelect')?.value
                        || 'population',
                });
            };

            const captureImportAnalysis = () => {
                const controller = tableControllers?.import;
                const competitorState = serializeCompetitorState(importCompetitorsManager);
                const rows = Array.isArray(controller?.allRows) ? controller.allRows : [];
                const hasCompetitorState = competitorState.competitors.length > 0
                    || competitorState.customPoints.length > 0
                    || competitorState.removedItems.length > 0;
                if (!rows.length && !hasCompetitorState) return null;
                return {
                    tool_type: 'import-table',
                    zones_config: {
                        tool_type: 'import-table',
                        metadata: {business_origin: 'import'},
                        has_data: rows.length > 0,
                    },
                    stats_config: {
                        selected_stat_type: document.getElementById('importStatsTypeSelect')?.value || 'population',
                    },
                    result_data: {
                        total_rows: rows.length,
                        columns: Array.isArray(controller?.columns) ? controller.columns : [],
                        rows,
                        summary: controller?.summary || {},
                        competitor_state: competitorState,
                    },
                    tags: [],
                    notes: '',
                };
            };

            const createHomeWorkspaceDraftController = () => {
                const api = window.MaplyticsHomeWorkspaceDraft;
                if (!api?.createCoordinator || !api?.createStore || !api?.scopeKey) return null;
                const scope = api.scopeKey({
                    userId: APP_CONFIG.userId,
                    anonymousToken: APP_CONFIG.userId ? '' : getOrCreateToken(),
                });
                if (!scope) return null;
                const coordinator = api.createCoordinator({
                    store: api.createStore(),
                    scope,
                    getSnapshot: captureIsochroneAnalysis,
                    restoreState: (state) => (
                        competitorsManager?.restoreCompetitorStatePayload?.(
                            state,
                            {restoreBuilder: true, emptyIsSaved: true},
                        )
                    ),
                    restoreStatistic: (selected) => restoreSelectedStatistic(
                        'statsTypeSelect',
                        {
                            stats_config: {
                                selected_stat_type: selected,
                            },
                        },
                    ),
                });
                if (!coordinator) return null;

                window.addEventListener(
                    'maplytics:analysis-workspace-changed',
                    coordinator.schedule,
                );
                window.addEventListener('pagehide', coordinator.flush);
                document.getElementById('statsTypeSelect')?.addEventListener(
                    'change',
                    coordinator.schedule,
                );
                return coordinator;
            };

            const restoreIsochroneAnalysis = async (analysis, openContext = null) => {
                await window.MaplyticsZoneAnalysisCoordinator.restore({
                    analysis,
                    openContext,
                    prepareSnapshot: (zonesConfig) => (
                        zonesManager.prepareSavedZonesSnapshot(zonesConfig)
                    ),
                    ensureMap: () => ensurePanelMap('export'),
                    isMapAvailable: () => Boolean(exportMapController?.map),
                    storage: homeZonesStorage,
                    storageKey: HOME_ZONE_STORAGE_KEY,
                    captureViewState: () => zonesManager.captureSavedZonesViewState(),
                    capturePostMutationState: () => ({
                        competitors: serializeCompetitorState(competitorsManager),
                        competitorProjectId: competitorsManager._competitorActiveProjectId,
                        statistic: document.getElementById('statsTypeSelect')?.value || '',
                        panelId: document.querySelector('.tab-button.active')?.dataset.target
                            || 'exportPanel',
                        url: `${window.location.pathname}${window.location.search}${window.location.hash}`,
                        zoneTab: document.querySelector(
                            '#zonesManager .zones-tab-btn.active',
                        )?.dataset.tab || 'tab1',
                        mobileSheet: document.querySelector(
                            '.app-mobile-dock [data-mobile-jump].active',
                        )?.dataset.mobileJump || 'map',
                        resultsStates: {
                            export: getResultsState(
                                document.querySelector('#exportPanel .layout-grid'),
                            ),
                            import: getResultsState(
                                document.querySelector('#importPanel .layout-grid'),
                            ),
                        },
                    }),
                    replaceSnapshot: (prepared) => {
                        zonesManager.replaceZonesFromSavedSnapshot(prepared, {
                            resetPresentation: true,
                            syncPresentation: false,
                        });
                    },
                    applyAfterReplace: () => {
                        restoreSelectedStatistic('statsTypeSelect', analysis);
                        restoreCompetitorState(
                            competitorsManager,
                            analysis.result_data?.competitor_state || {},
                        );
                        activateToolPanel('exportPanel', {load: false});
                        zonesManager.switchTab('tab1');
                        revealResultsPanel('export');
                        syncResultsRailAvailability('export');
                        scheduleZonePresentationSync('saved-analysis-opened');
                    },
                    restoreViewState: (previousView) => {
                        zonesManager.restoreSavedZonesViewState(previousView, {
                            syncPresentation: false,
                        });
                    },
                    restorePostMutationState: (previous) => {
                        restoreCompetitorState(competitorsManager, previous.competitors);
                        competitorsManager._competitorActiveProjectId = String(
                            previous.competitorProjectId || '',
                        );
                        const previousProjectSelect = document.querySelector(
                            '#zonesManager .competitor-project-select',
                        );
                        if (previousProjectSelect) {
                            previousProjectSelect.value = (
                                competitorsManager._competitorActiveProjectId
                            );
                        }
                        const statisticSelect = document.getElementById('statsTypeSelect');
                        if (statisticSelect && previous.statistic) {
                            statisticSelect.value = previous.statistic;
                        }
                        activateToolPanel(previous.panelId, {
                            load: false,
                            syncUrl: false,
                        });
                        zonesManager.switchTab(previous.zoneTab);
                        setResultsPanelState('export', previous.resultsStates.export);
                        setResultsPanelState('import', previous.resultsStates.import);
                        window.setAppShellV2ResultsSheet?.(previous.mobileSheet);
                        window.history.replaceState(
                            window.history.state,
                            document.title,
                            previous.url,
                        );
                    },
                    onRollbackError: (stage, rollbackError) => {
                        const labels = {
                            view: 'écran zones',
                            storage: 'stockage zones',
                            interface: 'interface zones',
                        };
                        console.error(
                            `Rollback ${labels[stage] || stage} incomplet:`,
                            rollbackError,
                        );
                    },
                });
            };

            const restoreImportAnalysis = async (analysis, openContext = null) => {
                const resultData = analysis.result_data || {};
                const rows = Array.isArray(resultData.rows) ? resultData.rows : [];
                const columns = Array.isArray(resultData.columns) && resultData.columns.length
                    ? resultData.columns
                    : (rows[0] ? Object.keys(rows[0]) : []);
                const stats = rows.length ? calculateStatistics(rows) : null;
                const competitorState = resultData.competitor_state || {};
                const legacyCompetitors = Array.isArray(competitorState)
                    ? competitorState
                    : [];
                const currentCompetitors = Array.isArray(competitorState.competitors)
                    ? competitorState.competitors
                    : [];
                const currentCustomPoints = Array.isArray(competitorState.customPoints)
                    ? competitorState.customPoints
                    : [];
                const currentRemovedItems = Array.isArray(competitorState.removedItems)
                    ? competitorState.removedItems
                    : [];
                const hasCompetitorState = legacyCompetitors.length > 0
                    || currentCompetitors.length > 0
                    || currentCustomPoints.length > 0
                    || currentRemovedItems.length > 0;
                await ensurePanelMap('import');
                await new Promise((resolve) => requestAnimationFrame(resolve));
                openContext?.assertCurrent?.();
                if (rows.length) {
                    importDetailedExportAdapter?.activate?.({
                        rows,
                        columns,
                        title: `Import restauré — analyse ${analysis.id || 'locale'}`,
                    });
                } else {
                    importDetailedExportAdapter?.invalidate?.(
                        'saved-import-without-rows',
                        {hard: true},
                    );
                }
                restoreSelectedStatistic('importStatsTypeSelect', analysis);
                activateToolPanel('importPanel', { load: false });
                if (rows.length) {
                    _doPopulateTable(importTable, columns, rows);
                    tableControllers.import.container.hidden = false;
                    tableControllers.import.search.hidden = false;
                    tableControllers.import.actions.hidden = false;
                    renderStatistics(
                        document.getElementById('importStats'),
                        document.getElementById('importStatsGrid'),
                        document.getElementById('importSourceDistribution'),
                        stats,
                        tableControllers.import.isPremium,
                    );
                    document.getElementById('importSummary').textContent =
                        `${rows.length} ligne${rows.length > 1 ? 's' : ''} restaurée${rows.length > 1 ? 's' : ''}.`;
                } else {
                    resetTable(importTable);
                    tableControllers.import.container.hidden = true;
                    tableControllers.import.search.hidden = true;
                    tableControllers.import.actions.hidden = true;
                    document.getElementById('importStats').hidden = true;
                    document.getElementById('importSummary').textContent = hasCompetitorState
                        ? 'Aucune ligne restaurée. Les points cartographiques enregistrés ont été rétablis.'
                        : 'Aucune ligne restaurée dans cette ancienne sauvegarde.';
                }
                restoreCompetitorState(
                    importCompetitorsManager,
                    competitorState,
                );
                importZonesManager.updateTabVisibility();
                importZonesManager.switchTab(hasCompetitorState ? 'importTab2' : 'importTab1');
                revealResultsPanel('import');
                setResultsRailStatus(
                    'import',
                    rows.length || hasCompetitorState ? 'available' : 'empty',
                );
            };

            const createSelectiveRestoreAnalysis = (analysis, restoreOptions) => {
                const selectedDomainKeys = new Set(
                    Array.isArray(restoreOptions?.selectedDomainKeys)
                        ? restoreOptions.selectedDomainKeys.map(String)
                        : [],
                );
                if (analysis?.tool_type === 'isochrone') {
                    const current = captureIsochroneAnalysis() || {
                        tool_type: 'isochrone',
                        zones_config: {zones: [], metadata: {}},
                        stats_config: {
                            selected_stat_type: document.getElementById('statsTypeSelect')?.value
                                || 'population',
                        },
                        result_data: {
                            competitor_state: serializeCompetitorState(competitorsManager),
                        },
                    };
                    return window.MaplyticsZoneAnalysisCoordinator.createSelectiveRestore({
                        savedAnalysis: analysis,
                        currentAnalysis: current,
                        selectedDomainKeys: [...selectedDomainKeys],
                    });
                }
                const clone = (value) => {
                    if (typeof structuredClone === 'function') return structuredClone(value);
                    return JSON.parse(JSON.stringify(value));
                };
                const saved = clone(analysis || {});
                if (saved.tool_type === 'import-table') {
                    const current = captureImportAnalysis() || {
                        tool_type: 'import-table',
                        zones_config: { tool_type: 'import-table', has_data: false },
                        stats_config: {
                            selected_stat_type: document.getElementById('importStatsTypeSelect')?.value
                                || 'population',
                        },
                        result_data: {
                            rows: [],
                            columns: [],
                            summary: {},
                            competitor_state: serializeCompetitorState(importCompetitorsManager),
                        },
                    };
                    const useSavedData = selectedDomainKeys.has('import-data');
                    const sourceData = useSavedData ? saved.result_data || {} : current.result_data || {};
                    const competitorState = selectedDomainKeys.has('competitors')
                        ? clone(saved.result_data?.competitor_state || {})
                        : clone(current.result_data?.competitor_state || {});
                    return {
                        ...saved,
                        zones_config: useSavedData
                            ? clone(saved.zones_config || {})
                            : clone(current.zones_config || {}),
                        stats_config: selectedDomainKeys.has('statistic')
                            ? clone(saved.stats_config || {})
                            : clone(current.stats_config || {}),
                        result_data: {
                            ...(current.result_data || {}),
                            rows: clone(sourceData.rows || []),
                            columns: clone(sourceData.columns || []),
                            summary: clone(sourceData.summary || {}),
                            total_rows: Array.isArray(sourceData.rows)
                                ? sourceData.rows.length
                                : 0,
                            competitor_state: competitorState,
                        },
                    };
                }
                throw new Error('Ce type d’analyse ne permet pas un chargement sélectif.');
            };

            const restoreSavedAnalysis = async (
                analysis,
                openContext = null,
                restoreOptions = null,
            ) => {
                const effectiveAnalysis = restoreOptions?.mode === 'selective'
                    ? createSelectiveRestoreAnalysis(analysis, restoreOptions)
                    : analysis;
                if (effectiveAnalysis.tool_type === 'isochrone') {
                    await restoreIsochroneAnalysis(effectiveAnalysis, openContext);
                    return;
                }
                if (effectiveAnalysis.tool_type === 'import-table') {
                    const rollbackAnalysis = restoreOptions?.mode === 'selective'
                        ? captureImportAnalysis() || {
                            tool_type: 'import-table',
                            zones_config: { tool_type: 'import-table', has_data: false },
                            stats_config: {
                                selected_stat_type: document.getElementById('importStatsTypeSelect')?.value
                                    || 'population',
                            },
                            result_data: {
                                rows: [],
                                columns: [],
                                summary: {},
                                competitor_state: serializeCompetitorState(
                                    importCompetitorsManager,
                                ),
                            },
                        }
                        : null;
                    try {
                        await restoreImportAnalysis(effectiveAnalysis, openContext);
                    } catch (error) {
                        if (rollbackAnalysis) {
                            try {
                                await restoreImportAnalysis(rollbackAnalysis, null);
                            } catch (rollbackError) {
                                console.error(
                                    'Rollback du chargement sélectif Import incomplet:',
                                    rollbackError,
                                );
                            }
                        }
                        throw error;
                    }
                    return;
                }
                if (effectiveAnalysis.tool_type === 'best-location') {
                    openContext?.assertCurrent?.();
                    window.location.assign(`/user/best-location?analysis_id=${effectiveAnalysis.id}`);
                    return;
                }
                if (effectiveAnalysis.tool_type === 'geo-manager-competitors') {
                    openContext?.assertCurrent?.();
                    if (!window.GeoManagerV2?.openSavedCompetitorAnalysis) {
                        throw new Error('Géo Manager indisponible.');
                    }
                    await window.GeoManagerV2.openSavedCompetitorAnalysis(effectiveAnalysis, {
                        isCurrent: openContext?.isCurrent,
                        activate: () => {
                            openContext?.assertCurrent?.();
                            document.querySelector('[data-target="geoManagerPanel"]')?.click();
                        },
                    });
                    openContext?.assertCurrent?.();
                    return;
                }
                throw new Error('Type d’analyse non reconnu.');
            };

            const connected = typeof connectedUserToken !== 'undefined' && Boolean(connectedUserToken);
            const savedAnalysisFeatures = Array.isArray(connectedUserFeatures)
                ? connectedUserFeatures
                : [];
            const assignIsochroneFolderToDisplayedZones = (folder, context = {}) => {
                const normalizedFolder = String(folder || '').trim();
                zonesManager.zones.forEach((zone) => {
                    if (context.source !== 'open' || !String(zone.folder || '').trim()) {
                        zone.folder = normalizedFolder;
                    }
                    if (context.analysisId) {
                        zone.metadataAnalysisId = context.analysis?.read_only
                            ? null
                            : Number(context.analysisId);
                        zone.pdfSource = context.analysis?.read_only
                            ? null
                            : {
                                kind: 'saved_analysis',
                                analysis_id: Number(context.analysisId),
                            };
                    }
                });
                zonesManager.renderZonesList();
                zonesManager.saveZonesToLocalStorage();
                scheduleZonePresentationSync('saved-analysis-source-attached');
            };
            const prepareIsochroneFolderSave = (payload, context = {}) => {
                const zonesConfig = payload?.zones_config;
                if (!Array.isArray(zonesConfig?.zones)) return payload;
                const folder = String(context.folder || '').trim();
                return {
                    ...payload,
                    zones_config: {
                        ...zonesConfig,
                        zones: zonesConfig.zones.map((zone) => (
                            zone && typeof zone === 'object'
                                ? { ...zone, folder }
                                : zone
                        )),
                    },
                };
            };
            const savedAnalysisCoordinator = window.MaplyticsSavedAnalysisCoordinator.mount({
                HistoryManagerClass: HistoryManager,
                SavedAnalysesSurfaceClass: SavedAnalysesSurface,
                readySignal: savedAnalysesReadySignal,
                connected,
                features: savedAnalysisFeatures,
                exportRoot: document.getElementById('historyContent'),
                importRoot: document.getElementById('importHistoryContent'),
                exportOptions: {
                    getCurrentAnalysis: captureIsochroneAnalysis,
                    restoreAnalysis: restoreSavedAnalysis,
                    prepareSavePayload: prepareIsochroneFolderSave,
                    onFolderAssigned: assignIsochroneFolderToDisplayedZones,
                },
                importOptions: {
                    getCurrentAnalysis: captureImportAnalysis,
                    restoreAnalysis: restoreSavedAnalysis,
                },
            });
            historyManager = savedAnalysisCoordinator.historyManager;

            const currentOwnedAnalysisId = (surface, toolType) => {
                surface?.refreshEditSessionState?.();
                const session = surface?.editSession;
                return session?.tool_type === toolType
                    && session.owner_mode === 'owned'
                    && !session.dirty
                    ? session.analysis_id
                    : null;
            };

            window.MaplyticsAtelierEntry?.mount({
                button: document.getElementById('openAtelierBtn'),
                dialog: document.getElementById('homeAtelierDialog'),
                getRefs: currentZoneProjectionRefs,
                getSnapshot: captureIsochroneAnalysis,
                getAnalysisId: () => currentOwnedAnalysisId(
                    savedAnalysisCoordinator.surfaces.export,
                    'isochrone',
                ),
                saveSnapshot: payload => historyManager.saveAnalysisPayload(payload),
                onSaved: (analysisId, snapshot) => {
                    // Never attach an older save to zones edited while the request ran.
                    if (JSON.stringify(captureIsochroneAnalysis()) === JSON.stringify(snapshot)) {
                        assignIsochroneFolderToDisplayedZones('', {analysisId, source: 'open'});
                    }
                    void savedAnalysisCoordinator.surfaces.export.refresh({quiet: true}).catch(() => {});
                },
            });

            let lastAtelierImportSave = null;
            window.MaplyticsAtelierEntry?.mount({
                button: document.getElementById('importOpenAtelierBtn'),
                dialog: document.getElementById('homeAtelierImportDialog'),
                mode: 'import-table',
                getSnapshot: captureImportAnalysis,
                getAnalysisId: () => {
                    const snapshot = captureImportAnalysis();
                    if (!snapshot?.result_data?.rows?.length) return null;
                    if (lastAtelierImportSave?.key === JSON.stringify(snapshot)) return lastAtelierImportSave.id;
                    return currentOwnedAnalysisId(
                        savedAnalysisCoordinator.surfaces.import,
                        'import-table',
                    );
                },
                saveSnapshot: payload => historyManager.saveAnalysisPayload(payload),
                onSaved: (analysisId, snapshot) => {
                    lastAtelierImportSave = {id: analysisId, key: JSON.stringify(snapshot)};
                    void savedAnalysisCoordinator.surfaces.import.refresh({quiet: true}).catch(() => {});
                },
            });

            // Event listener pour Export PDF Avancé (import-table)
            const importExportAdvancedBtn = document.getElementById('importStatsExportAdvancedBtn');
            if (importExportAdvancedBtn && importExportManager) {
                importExportAdvancedBtn.addEventListener('click', () => {
                    // Récupérer les données depuis importStatsManager
                    const statisticsData = importStatsManager?.currentData || {};
                    importExportManager.showExportModal(statisticsData);
                });
            }
            resolveHomeWorkspaceDraftReady(createHomeWorkspaceDraftController());
        }

        // Initialiser les managers premium après le chargement de tous les scripts
        // On utilise window.addEventListener('load') pour s'assurer que tous les scripts externes sont chargés
        window.addEventListener('load', initPremiumManagers);

        // Initialiser l'onglet Concurrents pour Import-table (après création de importStatsManager)
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => {
                initCompetitorsTab(importCompetitorsManager, '#importZonesManager', 'import');
                if (typeof importStatsManager !== 'undefined' && importStatsManager) {
                    initStatsTab(importStatsManager, '#importZonesManager', 'import');
                }
            });
        } else {
            initCompetitorsTab(importCompetitorsManager, '#importZonesManager', 'import');
            if (typeof importStatsManager !== 'undefined' && importStatsManager) {
                initStatsTab(importStatsManager, '#importZonesManager', 'import');
            }
        }

        // Initialiser les onglets import-table
        function initImportZonesTabs() {
            importZonesManager.initTabs();
            moveImportGridToTab1();
        }

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', initImportZonesTabs);
        } else {
            initImportZonesTabs();
        }

        // Charger un projet/analyse depuis les URL params (liens dashboard)
        (function handleUrlParams() {
            const urlRestoreGeneration = homeWorkspaceResetGeneration;
            const urlParams = new URLSearchParams(window.location.search);
            const loadProjectId = urlParams.get('load_project');
            const loadAnalysisId = urlParams.get('load_analysis');
            const openSavedAnalyses = urlParams.get('saved_analyses') === '1';

            if (loadProjectId && !loadAnalysisId) {
                window.maplyticsPendingLegacyProjectLoad = {
                    projectId: String(loadProjectId),
                    toolType: urlParams.get('tool_type') || 'isochrone',
                };
            }

            if (loadAnalysisId) {
                void window.maplyticsSavedAnalysesReady.then(async () => {
                    if (urlRestoreGeneration !== homeWorkspaceResetGeneration) return;
                    // Ouvrir tab5 (historique)
                    if (typeof zonesManager !== 'undefined' && zonesManager.switchTab) {
                        zonesManager.switchTab('tab5');
                    }
                    try {
                        if (typeof window.maplyticsOpenSavedAnalysis === 'function') {
                            await window.maplyticsOpenSavedAnalysis(loadAnalysisId);
                        }
                    } catch (error) {
                        showAppMessage(
                            'error',
                            'Analyse indisponible',
                            error?.message || 'Cette analyse ne peut pas être ouverte.',
                        );
                    }
                });
                window.history.replaceState({}, '', window.location.pathname);
            }

            if (openSavedAnalyses && !loadAnalysisId) {
                void window.maplyticsSavedAnalysesReady.then((surfaces) => {
                    activateToolPanel('exportPanel', { load: true });
                    revealResultsPanel('export');
                    zonesManager?.switchTab?.('tab5');

                    const surface = surfaces?.export;
                    surface?.root?.scrollIntoView?.({ block: 'start', behavior: 'auto' });
                    window.requestAnimationFrame(() => {
                        surface?.searchInput?.focus?.({ preventScroll: true });
                    });
                }).catch(() => {
                    showAppMessage(
                        'error',
                        'Mes analyses indisponibles',
                        'Rechargez la page pour retrouver vos analyses.',
                    );
                });

                const cleanUrl = new URL(window.location.href);
                cleanUrl.searchParams.delete('saved_analyses');
                cleanUrl.searchParams.delete('comparison');
                window.history.replaceState(
                    {},
                    '',
                    `${cleanUrl.pathname}${cleanUrl.search}${cleanUrl.hash}`,
                );
            }
        })();

        // Event listeners pour les boutons de persistence
        const saveZonesBtn = document.getElementById('saveZonesBtn');
        if (saveZonesBtn) {
            saveZonesBtn.addEventListener('click', async () => {
                zonesManager.switchTab('tab5');
                try {
                    const surfaces = await window.maplyticsSavedAnalysesReady;
                    await surfaces?.export?.openSaveFlow?.();
                } catch (error) {
                    showAppMessage(
                        'error',
                        'Mes analyses indisponibles',
                        error?.message || 'Rechargez la page avant de réessayer.',
                    );
                }
            });
        }

        const resetZonesBtn = document.getElementById('resetZonesBtn');
        if (resetZonesBtn) {
            resetZonesBtn.addEventListener('click', async () => {
                await zonesManager.resetZones();
            });
        }

        // Token de l'utilisateur connecté
        // IMPORTANT: Initialisé par Jinja2 pour être disponible IMMÉDIATEMENT (pas d'attente AJAX)
        // Ces valeurs sont injectées par pages.py et APP_CONFIG (ligne 4697)
        let connectedUserToken = MAPLYTICS_BOOTSTRAP.userToken || null;
        let connectedUserIsPremium = Boolean(MAPLYTICS_BOOTSTRAP.userIsPremium);
        window.getMaplyticsExportToken = () => (
            connectedUserToken
            || localStorage.getItem('maplytics_token')
            || getOrCreateToken()
        );

        // Log pour debug
        (window.debugLog || (()=>{}))('[Features Init] connectedUserFeatures:', connectedUserFeatures.length, 'features loaded from Jinja2');

        function isCurrentUserAuthenticated() {
            return Boolean(connectedUserToken || (window.APP_CONFIG && window.APP_CONFIG.userId));
        }

        function showFallbackMessage(title, message) {
            let region = document.getElementById('maplytics-app-fallback-message');
            if (!region) {
                region = document.createElement('div');
                region.id = 'maplytics-app-fallback-message';
                region.setAttribute('role', 'alert');
                region.setAttribute('aria-live', 'assertive');
                region.className = 'app-fallback-message';
                document.body.appendChild(region);
            }
            region.textContent = `${title || ''} ${message || ''}`.trim();
        }

        function showAccessNotice(options = {}) {
            if (window.MaplyticsNotice && typeof window.MaplyticsNotice.accessDenied === 'function') {
                window.MaplyticsNotice.accessDenied({
                    authRequired: options.authRequired ?? !isCurrentUserAuthenticated(),
                    title: options.title,
                    message: options.message,
                    ctaLabel: options.ctaLabel,
                    ctaUrl: options.ctaUrl || '/pricing',
                });
                return;
            }
            showFallbackMessage(
                options.title || 'Accès requis',
                options.message || 'Cette fonctionnalité nécessite un accès supérieur.',
            );
        }

        function showPremiumNotice(featureLabel = 'cette fonctionnalité', message = '') {
            showAccessNotice({
                authRequired: false,
                title: 'Fonctionnalité incluse dans un autre plan',
                message: message || `Passez à une offre adaptée pour utiliser ${featureLabel}.`,
                ctaLabel: 'Voir les offres',
                ctaUrl: '/pricing',
            });
        }

        function showAuthNotice(message = 'Connectez-vous pour utiliser cette fonctionnalité et conserver vos résultats.') {
            showAccessNotice({
                authRequired: true,
                title: 'Connexion requise',
                message,
            });
        }

        function showAppMessage(type, title, message) {
            if (window.MaplyticsNotice && typeof window.MaplyticsNotice.show === 'function') {
                window.MaplyticsNotice.show({ type, title, message });
            } else {
                showFallbackMessage(title, message);
            }
        }

        function handleAppApiError(response, errorData = {}, fallbackMessage = 'Une erreur est survenue') {
            if (window.MaplyticsNotice && typeof window.MaplyticsNotice.handleApiResponse === 'function') {
                return window.MaplyticsNotice.handleApiResponse(response, errorData, fallbackMessage);
            }
            const detail = errorData.detail || errorData.error || errorData.message || fallbackMessage;
            if (response.status === 401) {
                showAuthNotice(detail);
            } else if (response.status === 403) {
                showPremiumNotice('cette fonctionnalité', detail);
            } else {
                showFallbackMessage('Action indisponible', detail);
            }
            return true;
        }

        // Fonction pour générer/créer un token unique
        // Priorité : token utilisateur connecté > token localStorage
        const getOrCreateToken = () => {
            // Si l'utilisateur est connecté, utiliser son token
            if (connectedUserToken) {
                return connectedUserToken;
            }
            // Sinon, utiliser/créer un identifiant pseudonyme de navigateur
            const tokenTtlMs = 13 * 31 * 24 * 60 * 60 * 1000;
            const lastActivityKey = 'maplytics_token_last_activity';
            const now = Date.now();
            let token = localStorage.getItem('maplytics_token');
            const lastActivity = Number(localStorage.getItem(lastActivityKey) || 0);
            if (token && lastActivity && now - lastActivity > tokenTtlMs) {
                localStorage.removeItem('maplytics_token');
                localStorage.removeItem(lastActivityKey);
                token = null;
            }
            if (!token) {
                token = 'user_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
                localStorage.setItem('maplytics_token', token);
            }
            localStorage.setItem(lastActivityKey, String(now));
            return token;
        };

        const exportTerritoryTargets = () => currentZoneProjectionRefs()
            .filter((zoneRef) => zoneRef?.source && zoneRef?.zone_id)
            .map((zoneRef) => ({
                key: String(zoneRef.zone_id),
                label: String(zoneRef.name || zoneRef.zone_id),
                zoneRef,
            }));

        const importTerritoryTargets = () => {
            const workbook = importDetailedExportAdapter?.getWorkbookSnapshot?.();
            const sourceRef = Array.isArray(workbook?.sourceRefs)
                ? workbook.sourceRefs[0]
                : null;
            if (!sourceRef?.job_id) return [];
            const catalog = Array.isArray(workbook?.zoneCatalog)
                ? workbook.zoneCatalog[0]
                : null;
            const zoneId = String(
                sourceRef.dataset_ref
                || catalog?.dataset_ref
                || `import-${sourceRef.job_id}`,
            );
            return [{
                key: zoneId,
                label: String(catalog?.label || workbook?.title || 'Import actif'),
                zoneRef: {
                    zone_id: zoneId,
                    name: String(catalog?.label || workbook?.title || 'Import actif'),
                    source: {
                        kind: sourceRef.kind || 'job',
                        job_id: sourceRef.job_id,
                    },
                },
            }];
        };

        const createHomeTerritoryController = ({surface, rootSelector, tabSelector}) => (
            window.MaplyticsHomeTerritoryContext?.create?.({
                surface,
                root: rootSelector,
                tab: tabSelector,
                getTargets: surface === 'import'
                    ? importTerritoryTargets
                    : exportTerritoryTargets,
                getUsageToken: getOrCreateToken,
                ensureMap: () => ensurePanelMap(surface),
                getMapController: () => surface === 'import'
                    ? importMapController
                    : exportMapController,
                onVisualChange: (reason) => {
                    const controller = surface === 'import'
                        ? importMapController
                        : exportMapController;
                    controller?.invalidateVisualExport?.(reason);
                },
                openVisualExport: (_snapshot, trigger) => {
                    const mapId = surface === 'import' ? 'importMap' : 'exportMap';
                    window.openLegendCustomizationPanel?.(mapId, trigger);
                },
            }) || null
        );

        const homeTerritoryControllers = {
            export: createHomeTerritoryController({
                surface: 'export',
                rootSelector: '#territoryContextPanel',
                tabSelector: '#zonesTabTerritory',
            }),
            import: createHomeTerritoryController({
                surface: 'import',
                rootSelector: '#importTerritoryContextPanel',
                tabSelector: '#importZonesTabTerritory',
            }),
        };
        window.maplyticsTerritoryContextControllers = Object.freeze(homeTerritoryControllers);

        document.addEventListener('maplytics:zones-mutated', () => {
            const targets = homeTerritoryControllers.export?.refreshTargets?.('zones-mutated') || [];
            if (!targets.length && document.getElementById('zonesTabTerritory')?.classList.contains('active')) {
                zonesManager.switchTab('tab1');
            }
        });
        document.addEventListener('maplytics:import-export-state-changed', () => {
            const targets = homeTerritoryControllers.import?.refreshTargets?.('import-state-changed') || [];
            if (!targets.length && document.getElementById('importZonesTabTerritory')?.classList.contains('active')) {
                importZonesManager.switchTab('importTab1');
            }
        });

        const importDetailedExcelBtn = document.getElementById('importDetailedExcelBtn');
        if (importDetailedExcelBtn && importDetailedExcelBtn.dataset.detailedExportBound !== '1') {
            importDetailedExcelBtn.dataset.detailedExportBound = '1';
            importDetailedExcelBtn.addEventListener('click', async (event) => {
                event.preventDefault();
                if (importDetailedExcelBtn.disabled) return;
                importDetailedExportBusy = true;
                importDetailedExportError = '';
                syncImportDetailedExportChoices();
                try {
                    await waitForMultiZoneExcelRuntime();
                    if (!window.MaplyticsMultiZoneExcel?.open) {
                        throw new Error('Le moteur Excel n’a pas pu être chargé. Réessayez.');
                    }
                    openMultiZoneExcelDialog(importDetailedExcelBtn, 'import');
                } catch (error) {
                    importDetailedExportError = String(
                        error?.message || 'La préparation Excel a échoué. Réessayez.',
                    );
                } finally {
                    importDetailedExportBusy = false;
                    syncImportDetailedExportChoices();
                }
            });
        }
        syncImportDetailedExportChoices();

        // ============================================
        // PREMIUM GATE — Composant reutilisable
        // 3 niveaux : anonymous / freemium / premium
        // ============================================
        const PremiumGate = {
            check(featureCode) {
                const isConnected = typeof connectedUserToken !== 'undefined' && connectedUserToken !== null;
                const hasFeat = hasFeature(featureCode);

                if (hasFeat) {
                    return { level: 'premium', freeLimit: Infinity, ctaHTML: '' };
                }

                // GA4: track premium gate impressions
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({event: 'premium_gate_view', feature: featureCode, level: isConnected ? 'freemium' : 'anonymous'});

                if (isConnected) {
                    return {
                        level: 'freemium',
                        freeLimit: 3,
                        ctaHTML: `
                            <div class="ui-premium-lock-actions">
                                <a href="/pricing" class="ui-btn ui-btn-primary" data-analytics-event="locked_action_clicked" data-analytics-surface="premium-lock" data-analytics-feature-code="${featureCode}" data-analytics-label="Voir les offres">Voir l'offre Pro</a>
                            </div>
                        `
                    };
                }

                return {
                    level: 'anonymous',
                    freeLimit: 1,
                    ctaHTML: `
                        <div class="ui-premium-lock-actions">
                            <a href="/auth/register" class="ui-btn ui-btn-primary" data-analytics-event="locked_action_clicked" data-analytics-surface="premium-lock" data-analytics-feature-code="${featureCode}" data-analytics-label="Créer un compte gratuit">Créer un compte gratuit</a>
                            <a href="/pricing" class="ui-btn ui-btn-secondary" data-analytics-event="locked_action_clicked" data-analytics-surface="premium-lock" data-analytics-feature-code="${featureCode}" data-analytics-label="Voir les offres">Voir les offres</a>
                        </div>
                    `
                };
            },

            renderLock({ featureCode, title, description, previewHTML = '', freeAlternative = '' }, gate) {
                const safeFeatureCode = String(featureCode || '').replace(/"/g, '&quot;');
                const planCopy = gate.level === 'anonymous'
                    ? 'Connectez-vous pour conserver votre travail et voir les offres adaptées.'
                    : 'Requis : Pro ou offre supérieure selon votre usage.';
                const freeCopy = freeAlternative
                    ? `<p class="ui-premium-lock-free">Disponible sans déblocage : ${freeAlternative}</p>`
                    : '';
                return `
                    <aside class="ui-premium-lock ui-premium-lock--legacy-inline" aria-label="${title} verrouillé" data-feature-code="${safeFeatureCode}" data-analytics-feature-code="${safeFeatureCode}" data-analytics-view-event="locked_action_viewed" data-analytics-surface="premium-lock" data-analytics-label="${title}">
                        <div class="ui-premium-lock-copy">
                            <span class="ui-premium-lock-kicker">Fonction verrouillée</span>
                            <strong>${title}</strong>
                            <div class="ui-premium-lock-description">
                                <p>${description}</p>
                                <p class="ui-premium-lock-plan">${planCopy}</p>
                                ${freeCopy}
                            </div>
                        </div>
                        ${previewHTML ? `<div class="premium-gate__preview">${previewHTML}</div>` : ''}
                        ${gate.ctaHTML}
                    </aside>
                `;
            },

            renderSkeletonRows(count = 5) {
                let html = '';
                for (let i = 0; i < count; i++) {
                    html += `
                        <div class="premium-gate__skeleton-row">
                            <span class="premium-gate__lock-icon">🔒</span>
                            <div style="flex: 1; display: flex; flex-direction: column; gap: 0.375rem;">
                                <div class="premium-gate__skeleton-bar premium-gate__skeleton-bar--name"></div>
                                <div style="display: flex; gap: 0.5rem;">
                                    <div class="premium-gate__skeleton-bar premium-gate__skeleton-bar--address"></div>
                                    <div class="premium-gate__skeleton-bar premium-gate__skeleton-bar--tiny"></div>
                                </div>
                            </div>
                        </div>
                    `;
                }
                return html;
            },

            renderGatedList(items, renderFn, gate) {
                if (gate.level === 'premium') {
                    return items.map((item, i) => renderFn(item, i)).join('');
                }

                const freeItems = items.slice(0, gate.freeLimit);
                const lockedCount = Math.min(items.length - gate.freeLimit, 8);

                let html = freeItems.map((item, i) => renderFn(item, i)).join('');

                if (lockedCount > 0) {
                    html += this.renderLock({
                        featureCode: 'export_results',
                        title: 'Résultats supplémentaires',
                        description: 'Débloquez les lignes restantes, les exports avancés et la consultation complète des résultats.',
                        freeAlternative: 'les premières lignes restent consultables à l’écran',
                        previewHTML: this.renderSkeletonRows(lockedCount),
                    }, gate);
                }

                return html;
            },

            renderSkeletonStats(count = 4) {
                let html = '';
                for (let i = 0; i < count; i++) {
                    html += `
                        <div class="premium-gate__stat-skeleton">
                            <div class="premium-gate__skeleton-bar" style="width: 50%; height: 0.6rem; margin-bottom: 0.375rem;"></div>
                            <div class="premium-gate__skeleton-bar" style="width: 35%; height: 1rem;"></div>
                            <div class="premium-gate__skeleton-bar" style="width: 45%; height: 0.5rem; margin-top: 0.375rem;"></div>
                        </div>
                    `;
                }
                return html;
            }
        };

        // Vérifier l'authentification et récupérer le token utilisateur
        const checkAuthAndSetToken = async () => {
            if (!isCurrentUserAuthenticated()) {
                return null;
            }
            if (connectedUserToken && Array.isArray(connectedUserFeatures) && connectedUserFeatures.length > 0) {
                if (hasFeature('no_ads')) {
                    hideAdsForPremium();
                }
                return {
                    success: true,
                    user: {
                        token: connectedUserToken,
                        features: connectedUserFeatures,
                        is_premium: connectedUserIsPremium
                    }
                };
            }
            try {
                const response = await fetch('/auth/me', {
                    method: 'GET',
                    credentials: 'include'
                });
                if (response.ok) {
                    const data = await response.json();
                    if (data.success && data.user && data.user.token) {
                        connectedUserToken = data.user.token;
                        connectedUserIsPremium = data.user.is_premium || false;
                        connectedUserFeatures = data.user.features || [];
                        (window.debugLog || (() => {}))('Token utilisateur connecté:', connectedUserToken, 'Premium:', connectedUserIsPremium, 'Features:', connectedUserFeatures.length);

                        // Cacher les pubs pour les utilisateurs avec la feature no_ads
                        if (hasFeature('no_ads')) {
                            hideAdsForPremium();
                        }

                        // Mettre à jour le compteur avec le bon token
                        updateUsageCounter();

                        // Mettre à jour l'UI selon les features
                        updateUIBasedOnFeatures();
                    }
                }
            } catch (error) {
                // Erreur réseau ou 401 - utilisateur non connecté, c'est normal
                // Ne pas afficher d'erreur en console pour les 401
                // Les erreurs 401 sont attendues pour les utilisateurs non connectés
            }
        };

        // Fonction pour cacher les publicités pour les utilisateurs premium
        const hideAdsForPremium = () => {
            const headerAd = document.getElementById('headerAd');
            const allAds = document.querySelectorAll('.ad-container, .adsbygoogle');

            if (headerAd) headerAd.style.display = 'none';
            allAds.forEach(ad => ad.style.display = 'none');

            (window.debugLog || (() => {}))('Publicités masquées pour utilisateur premium');
        };

        // Fonction pour mettre à jour l'UI selon les features de l'utilisateur
        const updateUIBasedOnFeatures = () => {
            const setPremiumLinkState = (elementId, featureCode) => {
                const link = document.getElementById(elementId);
                if (!link) return;
                const allowed = hasFeature(featureCode);
                link.classList.toggle('premium-disabled', !allowed);
                link.setAttribute('aria-disabled', allowed ? 'false' : 'true');
                link.style.pointerEvents = 'auto';
                link.dataset.premiumFeature = featureCode;
                if (link.dataset.premiumNoticeBound !== '1') {
                    link.dataset.premiumNoticeBound = '1';
                    link.addEventListener('click', (event) => {
                        if (!link.classList.contains('premium-disabled')) return;
                        event.preventDefault();
                        event.stopPropagation();
                        const label = featureCode === 'export_pdf' ? 'l’export PDF' : 'l’export Excel';
                        showPremiumNotice(label, `${label.charAt(0).toUpperCase()}${label.slice(1)} est inclus à partir du plan Étudiant.`);
                    });
                }
                if (!allowed) {
                    link.style.cursor = 'not-allowed';
                } else {
                    link.style.cursor = 'pointer';
                }
            };

            const setPremiumButtonState = (elementId, featureCode) => {
                const button = document.getElementById(elementId);
                if (!button) return;
                const allowed = hasFeature(featureCode);
                button.classList.toggle('premium-disabled', !allowed);
                button.setAttribute('aria-disabled', allowed ? 'false' : 'true');
                if (button.dataset.premiumNoticeBound !== '1') {
                    button.dataset.premiumNoticeBound = '1';
                    button.addEventListener('click', (event) => {
                        if (!button.classList.contains('premium-disabled')) return;
                        event.preventDefault();
                        event.stopPropagation();
                        showPremiumNotice('la sélection complète du tableau', 'La sélection complète du tableau est incluse à partir du plan Étudiant.');
                    });
                }
                button.title = allowed
                    ? 'Sélectionner toutes les données du tableau'
                    : 'Fonctionnalité incluse à partir du plan Étudiant.';
            };

            setPremiumLinkState('exportExcelLink', 'export_excel');
            setPremiumLinkState('importExcelLink', 'export_excel');
            setPremiumButtonState('exportSelectAllBtn', 'export_excel');
            syncImportDetailedExportChoices();

            // Protéger le bouton "Ajouter une zone" (multi_zones)
            syncAddZoneButtonState();

            // Protéger les modes de transport premium
            const transportBike = document.getElementById('transportBike');
            const transportWalking = document.getElementById('transportWalking');
            const transportTruck = document.getElementById('transportTruck');

            // Mode vélo (Starter+)
            if (transportBike) {
                if (!hasFeature('transport_bike')) {
                    transportBike.disabled = true;
                    transportBike.textContent = APP_CONFIG.appShellV2 ? 'Vélo - Starter+' : '🚴 Vélo 🔒 Starter+';
                } else {
                    transportBike.disabled = false;
                    transportBike.textContent = APP_CONFIG.appShellV2 ? 'Vélo' : '🚴 Vélo';
                }
            }

            // Mode piéton (Starter+)
            if (transportWalking) {
                if (!hasFeature('transport_walking')) {
                    transportWalking.disabled = true;
                    transportWalking.textContent = APP_CONFIG.appShellV2 ? 'Piéton - Starter+' : '🚶 Piéton 🔒 Starter+';
                } else {
                    transportWalking.disabled = false;
                    transportWalking.textContent = APP_CONFIG.appShellV2 ? 'Piéton' : '🚶 Piéton';
                }
            }

            // Mode poids lourds (Pro+)
            if (transportTruck) {
                if (!hasFeature('transport_truck')) {
                    transportTruck.disabled = true;
                    transportTruck.textContent = APP_CONFIG.appShellV2 ? 'Poids lourds - Pro+' : '🚛 Poids lourds 🔒 Pro+';
                } else {
                    transportTruck.disabled = false;
                    transportTruck.textContent = APP_CONFIG.appShellV2 ? 'Poids lourds' : '🚛 Poids lourds';
                }
            }

            statsManager?.syncExportChoices?.();
            (window.debugLog || (() => {}))('UI mise à jour selon les features');
        };

        // Fonction pour mettre à jour le compteur d'utilisation
        const updateUsageCounter = async () => {
            const token = getOrCreateToken();
            try {
                const usageRequest = new FormData();
                usageRequest.append('token', token);
                const response = await fetch('/api/usage', {
                    method: 'POST',
                    body: usageRequest,
                });
                if (response.ok) {
                    const usage = await response.json();
                    const countEl = document.getElementById('usageCount');
                    const counterCard = document.getElementById('usageCounter');
                    const setCounterState = (state, title, legacyBackground) => {
                        if (!counterCard) return;
                        counterCard.title = title;
                        counterCard.classList.remove('nav-credit-badge--premium', 'nav-credit-badge--warning', 'nav-credit-badge--limit');
                        if (APP_CONFIG.appShellV2 && counterCard.classList.contains('nav-credit-badge')) {
                            counterCard.style.background = '';
                            if (state) counterCard.classList.add(`nav-credit-badge--${state}`);
                            return;
                        }
                        counterCard.style.background = legacyBackground;
                    };
                    if (countEl) {
                        if (usage.is_premium || usage.limit === -1) {
                            countEl.textContent = 'Illimité';
                            setCounterState('premium', 'Compte payant actif - Calculs illimités', 'linear-gradient(135deg, #10b981 0%, #059669 100%)');
                        } else {
                            const isAnonymousQuota = Number(usage.limit) === 5;
                            const freeSignupUrl = '/auth/register?next=/';
                            const paidUpgradeUrl = '/pricing?limit_reached=true';
                            if (counterCard) {
                                counterCard.dataset.upgradeUrl = isAnonymousQuota ? freeSignupUrl : paidUpgradeUrl;
                            }
                            countEl.textContent = `${usage.usage_count} / ${usage.limit}`;
                            if (usage.usage_count >= usage.limit) {
                                setCounterState(
                                    'limit',
                                    isAnonymousQuota
                                        ? 'Limite sans compte atteinte. Creez un compte gratuit pour 10 calculs par jour'
                                        : 'Limite du compte gratuit atteinte. Cliquez pour voir les offres',
                                    'linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)'
                                );
                            } else if (usage.usage_count >= usage.limit * 0.8) {
                                setCounterState(
                                    'warning',
                                    isAnonymousQuota
                                        ? 'Presque a la limite sans compte. Creez un compte gratuit pour 10 calculs par jour'
                                        : 'Presque a la limite du compte gratuit. Cliquez pour voir les offres',
                                    'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)'
                                );
                            } else {
                                setCounterState(
                                    '',
                                    APP_CONFIG.enableLegacyAdminPanel
                                        ? 'Cliquez pour ouvrir la zone admin'
                                        : isAnonymousQuota
                                            ? '5 calculs sans compte. Creez un compte gratuit pour passer a 10/jour'
                                            : 'Compte gratuit: 10 calculs par jour. Voir les offres Maplytics',
                                    'linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)'
                                );
                            }
                            // Quota bar inline sous les résultats
                            const qBar = document.getElementById('quotaBar');
                            const qText = document.getElementById('quotaBarText');
                            const qFill = document.getElementById('quotaBarFill');
                            if (qBar && usage.usage_count > 0) {
                                qBar.style.display = 'block';
                                const pct = Math.min(100, Math.round((usage.usage_count / usage.limit) * 100));
                                if (qText) {
                                    let quotaLabel = usage.usage_count + '/' + usage.limit + ' calculs aujourd\'hui';
                                    if (isAnonymousQuota && usage.usage_count >= 3 && usage.usage_count < usage.limit) {
                                        quotaLabel += ' - compte gratuit: 10/jour';
                                    }
                                    qText.textContent = quotaLabel;
                                }
                                if (qFill) qFill.style.width = pct + '%';
                                if (pct >= 100) {
                                    qBar.style.background = '#fef2f2'; qBar.style.borderColor = '#fecaca'; qBar.style.color = '#dc2626';
                                    if (qFill) qFill.style.background = '#dc2626';
                                } else if (pct >= 80) {
                                    qBar.style.background = '#fffbeb'; qBar.style.borderColor = '#fde68a'; qBar.style.color = '#d97706';
                                    if (qFill) qFill.style.background = '#f59e0b';
                                } else {
                                    qBar.style.background = '#f0f9ff'; qBar.style.borderColor = '#bae6fd'; qBar.style.color = '#0369a1';
                                    if (qFill) qFill.style.background = '#2563eb';
                                }
                            }
                        }
                    }
                    // Masquer la barre quota pour les premium
                    if (usage.is_premium || usage.limit === -1) {
                        const qBar = document.getElementById('quotaBar');
                        if (qBar) qBar.style.display = 'none';
                    }
                }
            } catch (error) {
                console.warn('Compteur usage indisponible');
            }
        };

        window.MaplyticsHomeCalc.configure({
            setFormLoading: (form, loading) => {
                setFormLoading(form, loading);
                if (form === exportForm && !loading) {
                    setExportCalculationBusy(false);
                }
            },
            getOrCreateToken,
            updateUsageCounter,
            showLimitModal: (...args) => window.showLimitModal?.(...args),
        });
        const {
            pollJob,
            startAsyncJob,
            normalizeToolError,
            showDurationTooLargeNotice,
        } = window.MaplyticsHomeCalc;
        let communeImportReview = null;
        const getActiveImportSource = () => {
            const mode = importInputPanel?.dataset.activeMode || 'file';
            if (mode === 'file') return { mode, fieldId: 'importFile', field: importFileInput };
            if (mode === 'grid') {
                const editor = getImportGridEditor();
                return {
                    mode,
                    fieldId: editor?.id || 'importGridWrapper',
                    field: editor || document.getElementById('importGridWrapper'),
                };
            }
            return { mode, fieldId: 'importData', field: importDataTextarea };
        };
        const revealImportJourneyInput = () => {
            importZonesManager.switchTab('importTab1');
            window.revealResultsPanel?.('import');
            window.revealAppShellV2Results?.('zones', {
                scrollIntoView: true,
                scrollReason: 'user-click',
            });
        };
        const navigateImportJourney = (step) => {
            if (step === 'results') {
                // The guided action promises the result, not the map or the
                // export controls. On mobile, mount the existing result card
                // in its sheet before moving focus; never resubmit the form.
                window.revealAppShellV2Results?.('results', { scrollIntoView: false });
                window.requestAnimationFrame(() => {
                    const summary = document.getElementById('importSummary');
                    summary?.scrollIntoView({ block: 'nearest' });
                    summary?.focus({ preventScroll: true });
                });
                return;
            }
            if (step === 'method' || step === 'data') {
                revealImportJourneyInput();
                const target = step === 'method'
                    ? importModeTabs.find((button) => button.getAttribute('aria-selected') === 'true')
                    : getActiveImportSource().field;
                window.requestAnimationFrame(() => target?.focus?.({ preventScroll: true }));
                return;
            }
            if (step === 'validation') {
                const launcher = Array.from(
                    document.querySelectorAll('[data-commune-review-open]'),
                ).find((button) => !button.hidden);
                if (launcher && communeImportReview?.getState?.().fingerprint) {
                    launcher.click();
                    return;
                }
                revealImportJourneyInput();
                document.getElementById('importJourneyStatus')?.focus({ preventScroll: true });
                return;
            }
            if (step === 'visualization') {
                window.setAppShellV2ResultsSheet?.('map');
                const map = document.getElementById('importMap');
                if (map) {
                    map.tabIndex = -1;
                    window.requestAnimationFrame(() => map.focus({ preventScroll: true }));
                }
                invalidateMapControllerWhenVisible(importMapController, 100);
                return;
            }
            if (step === 'exploitation') {
                window.revealAppShellV2Results?.('more', {
                    scrollIntoView: true,
                    scrollReason: 'user-click',
                });
                window.requestAnimationFrame(() => {
                    document.getElementById('importDetailedExportChoices')
                        ?.focus({ preventScroll: true });
                });
            }
        };
        let importJourney = null;
        const initializeImportWorkspaceControllers = () => {
            if (!communeImportReview) {
                const reviewFactory = window.MaplyticsCommuneImportReview?.create;
                if (typeof reviewFactory !== 'function') {
                    throw new Error('Contrôleur de validation des communes indisponible.');
                }
                communeImportReview = reviewFactory({
                    form: importForm,
                    getToken: getOrCreateToken,
                    showMessage: showAppMessage,
                    onInvalidate: () => importDetailedExportAdapter?.invalidate?.(
                        'import-revalidation',
                        {hard: true},
                    ),
                });
            }
            if (!importJourney) {
                const journeyFactory = window.MaplyticsImportJourney?.create;
                if (typeof journeyFactory !== 'function') {
                    throw new Error('Contrôleur du parcours Import indisponible.');
                }
                importJourney = journeyFactory({
                    onNavigate: (step) => navigateImportJourney(step),
                    onRetry: (snapshot) => {
                        if (snapshot.state === 'technical_error') {
                            importForm.requestSubmit();
                            return;
                        }
                        navigateImportJourney('data');
                    },
                });
                window.maplyticsImportJourney = importJourney;
            }
            return { communeImportReview, importJourney };
        };
        const syncImportToolGuide = (snapshot = {}) => {
            const state = String(snapshot.state || 'waiting');
            const validationCopies = {
                waiting: 'Ajoutez une source à vérifier',
                file_selected: 'Données prêtes à vérifier',
                validating: 'Vérification du référentiel en cours',
                validation_ready: 'Validation à confirmer',
                running: 'Validation confirmée · calcul en cours',
                success: 'Import validé',
                partial: 'Import partiel à contrôler',
                rejected: 'Données à corriger',
                technical_error: 'Traitement interrompu',
                empty: 'Aucun résultat exploitable',
                export_unavailable: 'Résultat sans export détaillé',
                export_available: 'Résultat et exports disponibles',
            };
            if (importGuidedValidationStatus) {
                importGuidedValidationStatus.textContent = (
                    validationCopies[state] || snapshot.title || 'État à vérifier'
                );
            }
            const resultAvailable = new Set([
                'success',
                'partial',
                'export_unavailable',
                'export_available',
            ]).has(state);
            if (importGuidedResult) importGuidedResult.hidden = !resultAvailable;
            if (importGuidedResultSummary && resultAvailable) {
                importGuidedResultSummary.textContent = String(
                    snapshot.message || 'Le dernier import validé est prêt.',
                );
            }
            if (importGuidedResultsBtn) {
                importGuidedResultsBtn.disabled = !resultAvailable;
            }
        };
        const setImportJourneyState = (state, options = {}) => {
            const snapshot = importJourney?.setState?.(state, options) || {
                state,
                title: options.title || '',
                message: options.message || '',
            };
            syncImportToolGuide(snapshot);
            return snapshot;
        };
        window.maplyticsSetImportJourneyState = setImportJourneyState;
        importGuidedModeButtons.forEach((button) => {
            button.addEventListener('click', () => {
                const mode = button.dataset.importGuidedMode || 'file';
                revealImportJourneyInput();
                setImportInputMode(mode);
            });
        });
        importGuidedResultsBtn?.addEventListener('click', () => {
            if (!importGuidedResultsBtn.disabled) navigateImportJourney('results');
        });
        const importJourneyFailureState = (errorInfo = {}) => {
            const code = String(
                errorInfo.error_code || errorInfo.data?.error_code || '',
            ).trim();
            const rejectedCodes = new Set([
                'invalid_import_table',
                'invalid_commune_resolutions',
                'no_calculable_commune',
                'stale_validation_fingerprint',
                'validation_required',
                'validation_incomplete',
            ]);
            return rejectedCodes.has(code) ? 'rejected' : 'technical_error';
        };
        const importJourneyFailurePresentation = (errorInfo = {}, fieldId = null) => {
            const status = Number(errorInfo.status || errorInfo.data?.status || 0);
            const accessBlocked = Boolean(
                errorInfo.data?.feature_required
                || errorInfo.data?.limit_reached
                || [401, 403, 429].includes(status)
            );
            if (accessBlocked) {
                const limitReached = Boolean(errorInfo.data?.limit_reached);
                return {
                    state: 'rejected',
                    options: {
                        step: 'exploitation',
                        title: limitReached ? 'Limite atteinte' : 'Accès requis',
                        message: errorInfo.message,
                        retry: false,
                        fieldInvalid: false,
                    },
                };
            }
            const state = importJourneyFailureState(errorInfo);
            return {
                state,
                options: {
                    fieldId: state === 'rejected' ? fieldId : null,
                    fieldInvalid: state === 'rejected',
                    title: state === 'rejected'
                        ? 'Données à corriger'
                        : 'Import interrompu',
                    message: errorInfo.message,
                },
            };
        };
        setImportJourneyState('waiting');

        const originAdjustmentConfirmations = new Map();
        const originConfirmationFingerprint = (formData, transportMode) => JSON.stringify({
            lat: String(formData.get('latitude') || '').trim(),
            lng: String(formData.get('longitude') || '').trim(),
            transport_mode: String(transportMode || 'driving-car'),
        });
        const applyOriginAdjustmentConfirmation = (formData, surface, transportMode) => {
            const fingerprint = originConfirmationFingerprint(formData, transportMode);
            if (originAdjustmentConfirmations.get(surface) === fingerprint) {
                formData.set('origin_adjustment_confirmed', 'true');
                return true;
            }
            originAdjustmentConfirmations.delete(surface);
            formData.delete('origin_adjustment_confirmed');
            return false;
        };
        const requestOriginAdjustmentConfirmation = ({
            errorInfo,
            surface,
            form,
            formData,
            transportMode,
            onUse,
            onChooseOther,
        }) => {
            if (errorInfo?.error_code !== 'origin_access_confirmation_required') {
                return false;
            }
            const resolution = errorInfo.data?.resolution || {};
            const distance = Number(resolution.distance_m);
            const rounded = Number.isFinite(distance) ? Math.max(1, Math.round(distance)) : null;
            const message = rounded === null
                ? errorInfo.message
                : `Le point choisi n'est pas relié à une voie accessible pour ce mode. Un accès utilisable se trouve à ${rounded} m. Votre adresse d'origine sera conservée.`;
            const useAccess = () => {
                originAdjustmentConfirmations.set(
                    surface,
                    originConfirmationFingerprint(formData, transportMode),
                );
                onUse?.();
                form.requestSubmit();
            };
            const chooseAnother = () => {
                originAdjustmentConfirmations.delete(surface);
                onChooseOther?.();
            };
            if (window.MaplyticsNotice?.show) {
                let actionChosen = false;
                window.MaplyticsNotice.show({
                    type: 'warning',
                    title: 'Départ routier à confirmer',
                    message,
                    persistent: true,
                    focus: true,
                    actions: [
                        {
                            label: 'Utiliser cet accès',
                            onClick: () => {
                                actionChosen = true;
                                useAccess();
                            },
                        },
                        {
                            label: 'Choisir un autre point',
                            variant: 'secondary',
                            onClick: () => {
                                actionChosen = true;
                                chooseAnother();
                            },
                        },
                    ],
                    onClose: () => {
                        if (!actionChosen) chooseAnother();
                    },
                });
            } else if (window.confirm(`${message}\n\nUtiliser cet accès ?`)) {
                useAccess();
            } else {
                chooseAnother();
            }
            return true;
        };

        exportForm.addEventListener('submit', async (event) => {
            event.preventDefault();
            if (exportCalculationInProgress) {
                return;
            }
            const calculationJobGeneration = ++exportJobGeneration;
            const calculationCreationRequest = zonesManager.consumeCreationRequest();
            activeExportCreationRequest = calculationCreationRequest;
            const rejectCreationRequest = (message, code = 'calculation_failed') => {
                if (calculationCreationRequest) {
                    const error = new Error(message);
                    error.code = code;
                    calculationCreationRequest.reject(error);
                }
                if (activeExportCreationRequest === calculationCreationRequest) {
                    activeExportCreationRequest = null;
                }
            };
            setExportCalculationBusy(true);
            setFormLoading(exportForm, true);
            const releaseExportSubmitLock = () => {
                setFormLoading(exportForm, false);
                setExportCalculationBusy(false);
            };

            const latInput = document.getElementById('exportLatitude');
            const lonInput = document.getElementById('exportLongitude');
            const queryInput = document.getElementById('exportQuery');

            if (!isValidExportAddressCoordinates(latInput?.value, lonInput?.value)) {
                const hasQuery = Boolean(queryInput?.value.trim());
                const addressNotFound = exportAddressStatus?.textContent?.trim()
                    === 'Adresse introuvable';
                if (latInput?.value || lonInput?.value) {
                    clearExportAddressCoordinates();
                }
                if (addressNotFound) {
                    setExportAddressStatus('error', 'Adresse introuvable');
                    exportLogs.textContent = 'Adresse introuvable. Sélectionnez une suggestion ou placez le point sur la carte.';
                } else {
                    setExportAddressStatus(
                        'error',
                        hasQuery
                            ? 'Sélectionnez une suggestion ou placez le point sur la carte'
                            : 'Saisissez une adresse ou placez le point sur la carte',
                    );
                    exportLogs.textContent = hasQuery
                        ? 'Sélectionnez une suggestion valide avant de lancer le calcul.'
                        : 'Saisissez une adresse puis sélectionnez une suggestion avant de lancer le calcul.';
                }
                releaseExportSubmitLock();
                rejectCreationRequest('Le point sélectionné est invalide.', 'invalid_origin');
                queryInput?.focus();
                return;
            }
            if (
                !zonesManager.editingZoneId
                && zonesManager.zones.size >= 1
                && typeof hasFeature === 'function'
                && !hasFeature('multi_zones')
            ) {
                releaseExportSubmitLock();
                rejectCreationRequest(
                    'La création de plusieurs zones nécessite le plan Starter ou supérieur.',
                    'multi_zones_required',
                );
                if (window.MaplyticsNotice && typeof window.MaplyticsNotice.show === 'function') {
                    window.MaplyticsNotice.show({
                        type: 'warning',
                        title: 'Une seule zone active avec votre offre',
                        message: 'Remplacez la zone affichée pour relancer le calcul, ou découvrez le plan Starter pour comparer plusieurs zones.',
                        persistent: true,
                        focus: true,
                        actions: [
                            {
                                label: 'Remplacer la zone',
                                onClick: () => {
                                    zonesManager.clearAllZones();
                                    exportMapController.clearGeoJson?.();
                                    exportForm.requestSubmit();
                                },
                            },
                            {
                                label: 'Voir Starter',
                                href: '/pricing?feature=multi_zones#starter-plan',
                                variant: 'secondary',
                            },
                        ],
                    });
                } else {
                    showPremiumNotice(
                        'la comparaison multi-zones',
                        'Remplacez la zone affichée ou choisissez le plan Starter.'
                    );
                }
                return;
            }
            const calculationEditZoneId = zonesManager.editingZoneId;
            const existingZoneCountInput = document.getElementById('exportExistingZoneCount');
            if (existingZoneCountInput) {
                existingZoneCountInput.value = String(
                    zonesManager.zones.size - (calculationEditZoneId ? 1 : 0)
                );
            }
            const calculationOrigin = calculationCreationRequest?.context?.point
                || zonesManager.captureCurrentOrigin('calculation');
            if (!calculationEditZoneId) {
                window.maplyticsClearOpenedAnalysis?.('isochrone');
            }
            const calculationRequestFormData = new FormData(exportForm);
            const calculationTransportMode = document.getElementById('exportTransportMode')?.value
                || 'driving-car';
            applyOriginAdjustmentConfirmation(
                calculationRequestFormData,
                'export',
                calculationTransportMode,
            );

            // GA4: track calculation start
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({event: 'calculation_start', method: 'isochrone'});
            window.MaplyticsPublicActions?.track?.('free_calculation_started', { target: '/run-async', surface: 'home-tool' });
            trackHomeFunnelEvent('isochrone_calculation_start', {
                target: '/run-async',
                transport_mode: calculationTransportMode,
                minutes: parseInt(exportForm.querySelector('[name="minutes"]')?.value, 10) || null,
                zone_type: document.querySelector('input[name="zone_type"]:checked')?.value || 'isochrone',
            });

            // Utiliser requestAnimationFrame puis setTimeout pour rendre le traitement vraiment asynchrone
            requestAnimationFrame(() => {
                if (calculationJobGeneration !== exportJobGeneration) return;
                setTimeout(() => {
                if (calculationJobGeneration !== exportJobGeneration) return;
                exportLogs.textContent = 'Calcul en cours...';
                revealAppShellV2Results('results', { scrollIntoView: false });
                // Ne pas réinitialiser si on ajoute une zone
                if (zonesManager.zones.size === 0) {
                    exportSummary.textContent = '';
                    hideToolBridge('export');
                    resetTable(exportTable);
                    tableControllers.export.container.hidden = true;
                    tableControllers.export.search.hidden = true;
                    tableControllers.export.actions.hidden = true;
                    document.getElementById('exportStats').hidden = true;
                    document.getElementById('exportFilters').hidden = true;
                    exportDownload.hidden = true;
                    exportDownload.removeAttribute('href');
                    exportIsoLink.hidden = true;
                    exportIsoLink.removeAttribute('href');
                    if (exportMapController && exportMapController.clearGeoJson) {
                        exportMapController.clearGeoJson();
                    }
                }
                updateProgress(exportProgress, 0.02, 'Préparation du calcul...');
                activeExportJob = startAsyncJob({
                form: exportForm,
                requestFormData: calculationRequestFormData,
                url: '/run-async',
                onProgress: (data) => {
                    if (calculationJobGeneration !== exportJobGeneration) return;
                    // Utiliser requestAnimationFrame pour éviter les blocages de rendu
                    requestAnimationFrame(() => {
                        if (calculationJobGeneration !== exportJobGeneration) return;
                        exportLogs.textContent = (data.logs || []).join('\n') || 'Aucun log retourné.';
                        updateProgress(exportProgress, data.percent, data.logs?.slice(-1)[0] || '');
                    });
                },
                onComplete: (data, calculationLifecycle = {}) => {
                    if (calculationJobGeneration !== exportJobGeneration) return;
                    activeExportJob = null;
                    // Utiliser requestAnimationFrame pour éviter les blocages de rendu sur mobile
                    requestAnimationFrame(() => {
                        if (calculationJobGeneration !== exportJobGeneration) return;
                        const calculationScrollPosition = capturePageScrollPosition();
                        const durationText = data.duration ? ` (terminé en ${formatDuration(data.duration)})` : '';
                        markResultsPanelHasUpdate('export');
                        const submittedValues = calculationLifecycle.submitted || {};
                        const minutes = parseInt(
                            submittedValues.minutes
                            || exportForm.querySelector('[name="minutes"]').value
                        ) || 15;
                        const currentZoneType = submittedValues.zone_type
                            || document.querySelector('input[name="zone_type"]:checked')?.value
                            || 'isochrone';
                        const submittedTransportMode = submittedValues.transport_mode
                            || document.getElementById('exportTransportMode')?.value
                            || 'driving-car';
                        const originResolution = originResolutionFromResult(
                            data,
                            calculationLifecycle,
                        );
                        const resolvedCalculationOrigin = originWithResolution(
                            calculationOrigin,
                            originResolution,
                        );

                        const previousOpacity = calculationEditZoneId
                            ? exportMapController?.zonesLayers?.get(calculationEditZoneId)?.opacity
                            : null;
                        const zone = calculationEditZoneId
                            ? zonesManager.replaceZone(
                                calculationEditZoneId,
                                minutes,
                                data,
                                data.map_geojson,
                                submittedTransportMode,
                                currentZoneType,
                                { origin: resolvedCalculationOrigin },
                            )
                            : zonesManager.addZone(
                                minutes,
                                data,
                                data.map_geojson,
                                submittedTransportMode,
                                currentZoneType,
                                {
                                    origin: resolvedCalculationOrigin,
                                    color: calculationCreationRequest?.context?.color,
                                    folder: calculationCreationRequest?.context?.folder,
                                    name: calculationCreationRequest?.context?.name,
                                    batchId: calculationCreationRequest?.context?.batchId,
                                    batchOrder: calculationCreationRequest?.context?.batchOrder,
                                },
                            );

                        // Bug #3 Fix: Vérifier que la zone a bien été créée
                        // addZone() retourne null si: plan insuffisant pour multi_zones OU limite de 6 zones atteinte
                        if (!zone) {
                            console.warn('[Bug #3] Zone non créée - vérifiez votre plan ou la limite de zones');
                            exportSummary.textContent = 'Zone non créée. Vérifiez votre plan ou le nombre maximum de zones (6).';
                            rejectCreationRequest(
                                'Zone non créée. Vérifiez votre offre ou la limite de six zones.',
                                'zone_not_created',
                            );
                            hideProgress(exportProgress);
                            setExportCalculationBusy(false);
                            restorePageScrollPosition(calculationScrollPosition, 'calculation-complete');
                            return;
                        }
                        clearHomeWorkspaceReset('isochrone', {
                            scopes: ['zones', 'origin'],
                        });
                        announceOriginResolution(originResolution);

                        // GA4: track zone creation + calculation complete
                        window.dataLayer.push({event: 'calculation_complete', zones_count: zonesManager.zones.size});
                        window.dataLayer.push({
                            event: calculationEditZoneId ? 'zone_updated' : 'zone_created'
                        });
                        window.MaplyticsPublicActions?.track?.('free_calculation_completed', { target: '/run-async', surface: 'home-tool' });
                        trackHomeFunnelEvent('isochrone_calculation_success', {
                            target: '/run-async',
                            zones_count: zonesManager.zones.size,
                            result_rows: Number(data.total_rows || 0),
                        });
                        trackHomeFunnelEventOnce('free_result_view', {
                            target: '/run-async',
                            zones_count: zonesManager.zones.size,
                        });
                        if (!calculationEditZoneId) {
                            window.dispatchEvent(new CustomEvent('maplytics:zdc-created', {
                                detail: {source: 'export'},
                            }));
                        }

                        // Afficher sur la carte avec la couleur de la zone (dans un autre frame pour éviter les blocages)
                        if (data.map_geojson) {
                            requestAnimationFrame(() => {
                                if (
                                    calculationJobGeneration !== exportJobGeneration
                                    || zonesManager.zones.get(zone.id) !== zone
                                ) return;
                                exportMapController.renderGeoJson(data.map_geojson, zone.id, zone.color, zone.name);
                                if (Number.isFinite(previousOpacity)) {
                                    exportMapController.updateZoneOpacity(zone.id, previousOpacity);
                                }
                                zonesManager.renderZoneCenter(zone);
                                zonesManager.applyStoredZoneVisibility(zone.id);
                            });
                        }

                        // Mettre à jour le tableau avec toutes les zones
                        zonesManager.updateTableWithZones();
                        zonesManager.updateZoneFilter();

                        // Mettre à jour le résumé
                        if (zonesManager.zones.size === 1) {
                            exportSummary.textContent = `${data.total_rows} communes trouvées dans la zone ${zone.name}${durationText}.`;
                        } else {
                            const totalCommunes = zonesManager.getAggregatedRowsForZones().length;
                            exportSummary.textContent = `${totalCommunes} communes au total dans ${zonesManager.zones.size} zones${durationText}.`;
                        }

                        // Mettre à jour aussi via la méthode dédiée pour cohérence
                        if (zonesManager.updateExportSummary) {
                            zonesManager.updateExportSummary();
                        }
                        const bridgeContext = buildToolBridgeContext('export', data, zone);
                        showToolBridge('export', bridgeContext, {
                            usage: data.usage,
                            allowAutoScroll: false,
                        });

                        // Afficher les éléments de tableau
                        tableControllers.export.container.hidden = false;
                        tableControllers.export.search.hidden = false;
                        tableControllers.export.actions.hidden = false;
                        const exportStatsEl = document.getElementById('exportStats');
                        if (exportStatsEl) {
                            exportStatsEl.hidden = false;
                            // Initialiser le toggle des statistiques
                            const statsToggle = document.getElementById('exportStatsToggle');
                            const statsContent = document.getElementById('exportStatsContent');
                            const statsToggleText = document.getElementById('exportStatsToggleText');
                            if (statsToggle && statsContent && statsToggleText) {
                                // Supprimer les anciens listeners en clonant
                                const newStatsToggle = statsToggle.cloneNode(true);
                                statsToggle.parentNode.replaceChild(newStatsToggle, statsToggle);
                                const newStatsToggleText = document.getElementById('exportStatsToggleText');

                                newStatsToggle.addEventListener('click', (e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                const isExpanded = statsContent.classList.contains('expanded');
                                if (isExpanded) {
                                    statsContent.classList.remove('expanded');
                                    if (newStatsToggleText) newStatsToggleText.textContent = 'Afficher';
                                    } else {
                                        statsContent.classList.add('expanded');
                                        if (newStatsToggleText) newStatsToggleText.textContent = 'Masquer';
                                    }
                                });
                                const expandStatsByDefault = !window.matchMedia('(max-width: 768px)').matches;
                                statsContent.classList.toggle('expanded', expandStatsByDefault);
                                if (newStatsToggleText) {
                                    newStatsToggleText.textContent = expandStatsByDefault ? 'Masquer' : 'Afficher';
                                }
                            }
                        }
                        document.getElementById('exportFilters').hidden = false;

                        // Calculer et afficher les statistiques globales
                        const allRows = zonesManager.getAllAggregatedRows();
                        const stats = calculateStatistics(allRows);
                        const statsEl = document.getElementById('exportStats');
                        const statsGridEl = document.getElementById('exportStatsGrid');
                        const sourceDistEl = document.getElementById('exportSourceDistribution');
                        // Les données démographiques suivent leur droit précis,
                        // indépendamment du statut générique du job.
                        const isPremium = hasFeature('demographic_data');
                        tableControllers.export.isPremium = isPremium;
                        renderStatistics(statsEl, statsGridEl, sourceDistEl, stats, isPremium);

                        // Fonction pour mettre à jour les stats lors du filtrage
                        tableControllers.export.updateStats = (newStats) => {
                            // Utiliser le statut premium stocké dans le controller
                            const isPremiumForStats = tableControllers.export.isPremium || false;
                            renderStatistics(statsEl, statsGridEl, sourceDistEl, newStats, isPremiumForStats);
                        };

                        // Mettre à jour les liens de téléchargement (dernière zone)
                        // CSV et GeoJSON sont toujours disponibles (gratuit et premium)
                        if (data.file) {
                            exportDownload.hidden = false;
                            bindFilteredExportLink(exportDownload, 'csv', 'export');
                            // GA4: track export availability
                            window.dataLayer.push({event: 'export_click', format: 'csv'});
                        }
                        if (data.iso_file) {
                            exportIsoLink.hidden = false;
                            bindFilteredExportLink(exportIsoLink, 'geojson', 'export');
                        }
                        updateExportBridgeActions({ usage: data.usage });

                        // Le même élément et le même listener survivent aux mises à jour.
                        exportExcelLink = bindMultiZoneExcelLink(exportExcelLink);

                        // Gérer le bouton "Sélectionner tout le tableau" (premium)
                        const exportSelectAllBtn = document.getElementById('exportSelectAllBtn');
                        if (exportSelectAllBtn) {
                            if (hasFeature('export_excel')) {
                                exportSelectAllBtn.disabled = false;
                                exportSelectAllBtn.classList.remove('premium-disabled');
                                exportSelectAllBtn.setAttribute('aria-disabled', 'false');
                            } else {
                                exportSelectAllBtn.disabled = false;
                                exportSelectAllBtn.classList.add('premium-disabled');
                                exportSelectAllBtn.setAttribute('aria-disabled', 'true');
                            }
                        }

                        saveToolResultSnapshot('export', {
                            data,
                            zone,
                            context: latestToolBridgeContext.export,
                            usage: data.usage,
                            table: collectCurrentToolRows('export'),
                            map_geojson: data.map_geojson,
                        });

                        hideProgress(exportProgress);
                        setExportCalculationBusy(false);
                        calculationCreationRequest?.resolve({ zone, data });
                        if (activeExportCreationRequest === calculationCreationRequest) {
                            activeExportCreationRequest = null;
                        }
                        restorePageScrollPosition(calculationScrollPosition, 'calculation-complete');
                        requestAnimationFrame(() => {
                            requestAnimationFrame(() => {
                                calculationLifecycle.markRendered?.();
                            });
                        });
                    });
                },
                onError: (error) => {
                    if (calculationJobGeneration !== exportJobGeneration) return;
                    activeExportJob = null;
                    const errorInfo = normalizeToolError(error);
                    if (errorInfo.error_code === 'origin_access_confirmation_required') {
                        exportSummary.textContent = errorInfo.message;
                        hideProgress(exportProgress);
                        setExportCalculationBusy(false);
                        requestOriginAdjustmentConfirmation({
                            errorInfo,
                            surface: 'export',
                            form: exportForm,
                            formData: calculationRequestFormData,
                            transportMode: calculationTransportMode,
                            onUse: () => {
                                if (calculationCreationRequest) {
                                    zonesManager.pendingCreationRequest = calculationCreationRequest;
                                }
                            },
                            onChooseOther: () => {
                                rejectCreationRequest(
                                    'Choisissez un autre point de départ.',
                                    'origin_access_confirmation_cancelled',
                                );
                                queryInput?.focus?.({preventScroll: true});
                            },
                        });
                        return;
                    }
                    rejectCreationRequest(
                        errorInfo.message || 'Le calcul de ce seuil a échoué.',
                        errorInfo.error_code || 'calculation_failed',
                    );
                    const calculationScrollPosition = capturePageScrollPosition();
                    window.MaplyticsPublicActions?.track?.('free_calculation_failed', { target: '/run-async', surface: 'home-tool', error_code: errorInfo.error_code || 'unknown' });
                    trackHomeFunnelEvent('isochrone_calculation_error', {
                        target: '/run-async',
                        error_code: errorInfo.error_code || 'unknown',
                    });
                    exportSummary.textContent = errorInfo.message;
                    if (errorInfo.error_code === 'duration_too_large') {
                        showDurationTooLargeNotice(errorInfo);
                    }
                    if (calculationEditZoneId) {
                        zonesManager.cancelEdit({ restoreForm: true });
                        showAppMessage(
                            'error',
                            'Zone inchangée',
                            errorInfo.message,
                        );
                    }
                    hideProgress(exportProgress);
                    setExportCalculationBusy(false);
                    if (activeExportCreationRequest === calculationCreationRequest) {
                        activeExportCreationRequest = null;
                    }
                    restorePageScrollPosition(calculationScrollPosition, 'calculation-complete');
                },
                });
                }, 0);
            });
        });

        let importDraftDirty = false;
        let importJobGeneration = 0;
        let activeImportJob = null;

        const invalidateActiveImportRun = () => {
            importJobGeneration += 1;
            activeImportJob?.cancel?.();
            activeImportJob = null;
            setFormLoading(importForm, false);
            hideProgress(importProgress);
        };

        document.addEventListener('maplytics:simple-map-rendered', (event) => {
            if (event.detail?.surface !== 'import') return;
            importDetailedExportAdapter?.markMapReady?.();
            syncImportDetailedExportChoices();
        });

        const syncImportJourneyExportState = () => {
            const rows = Array.isArray(tableControllers.import.allRows)
                ? tableControllers.import.allRows
                : [];
            if (!rows.length) return;
            const protectedResultStates = new Set([
                'partial',
                'empty',
                'rejected',
                'technical_error',
            ]);
            if (protectedResultStates.has(importJourney?.getState?.().state)) return;
            const availability = syncImportDetailedExportChoices();
            const primaryDownloadAvailable = [importDownload, importIsoLink].some(
                (link) => Boolean(link && !link.hidden && link.getAttribute('href')),
            );
            const detailedExportAvailable = Boolean(
                availability?.excel?.available || availability?.visual?.available,
            );
            setImportJourneyState(
                primaryDownloadAvailable || detailedExportAvailable
                    ? 'export_available'
                    : 'export_unavailable',
            );
        };
        document.addEventListener('maplytics:import-export-state-changed', () => {
            syncImportJourneyExportState();
        });

        const readImportGridEntries = () => Array.from(
            importGridBody.querySelectorAll('tr'),
        ).map((row) => {
            const cells = row.querySelectorAll('td');
            return [
                (cells[0]?.textContent || '').trim(),
                (cells[1]?.textContent || '').trim(),
                (cells[2]?.textContent || '').trim(),
            ].join(',');
        }).filter((line) => line.replace(/,/g, '').trim() !== '');
        const serializeImportGridSource = () => {
            const entries = readImportGridEntries();
            importDataTextarea.value = entries.length
                ? ['nom_commune,code_postal,code_insee', ...entries].join('\n')
                : '';
            importInputPanel.dataset.gridPrepared = String(entries.length > 0);
            return entries.length > 0;
        };
        const importSourceHasData = () => {
            const source = getActiveImportSource();
            if (source.mode === 'file') return Boolean(importFileInput?.files?.length);
            if (source.mode === 'grid') return readImportGridEntries().length > 0;
            return Boolean(importDataTextarea?.value.trim());
        };

        const markImportDraftDirty = (reason = 'import-source-edited') => {
            invalidateActiveImportRun();
            importDraftDirty = true;
            importDetailedExportAdapter?.invalidate?.(reason, {hard: true});
            const source = getActiveImportSource();
            setImportJourneyState(
                importSourceHasData() ? 'file_selected' : 'waiting',
                { fieldId: source.fieldId },
            );
        };
        importInputPanel?.addEventListener('maplytics:import-mode-changed', () => {
            communeImportReview?.invalidate?.();
            markImportDraftDirty('import-method-changed');
        });

        const clearImportResults = ({
            summary = 'Résultats effacés. Vous pouvez lancer un nouvel import.',
        } = {}) => {
            importDetailedExportAdapter?.invalidate?.('import-results-cleared', {hard: true});
            importMapController?.clearGeoJson?.();
            resetTable(importTable);
            tableControllers.import.allRows = [];
            tableControllers.import.filteredRows = [];
            tableControllers.import.columns = [];
            tableControllers.import.currentPage = 1;
            tableControllers.import.updateStats = null;
            tableControllers.import.container.hidden = true;
            tableControllers.import.search.hidden = true;
            tableControllers.import.actions.hidden = true;
            const stats = document.getElementById('importStats');
            const statsGrid = document.getElementById('importStatsGrid');
            const sourceDistribution = document.getElementById('importSourceDistribution');
            const filters = document.getElementById('importFilters');
            if (stats) stats.hidden = true;
            if (statsGrid) statsGrid.replaceChildren();
            if (sourceDistribution) sourceDistribution.replaceChildren();
            if (filters) filters.hidden = true;
            updateUnmatchedList(importUnmatched, []);
            unmatchedDownload.hidden = true;
            unmatchedDownload.removeAttribute('href');
            importDownload.hidden = true;
            importDownload.removeAttribute('href');
            importExcelLink.hidden = true;
            importExcelLink.removeAttribute('data-job-id');
            importIsoLink.hidden = true;
            importIsoLink.removeAttribute('href');
            hideToolBridge('import');
            latestToolBridgeContext.import = null;
            const snapshot = readToolResultSnapshot();
            if (snapshot?.panelType === 'import') {
                sessionStorage.removeItem(TOOL_RESULT_SNAPSHOT_KEY);
            }
            importLogs.textContent = '';
            importSummary.textContent = summary;
            if (importClearResultsBtn) importClearResultsBtn.hidden = true;
            hideProgress(importProgress);
            setResultsRailStatus('import', 'empty');
        };

        const resetImportWorkspace = () => {
            if (
                importDraftDirty
                && !window.confirm(
                    'Effacer la saisie en cours et réinitialiser uniquement cet import ?'
                )
            ) {
                return false;
            }

            invalidateActiveImportRun();
            communeImportReview?.invalidate?.();
            importFileInput.value = '';
            importDataTextarea.value = '';
            importGridBody.innerHTML = importGridInitialHtml;
            importInputPanel.dataset.gridPrepared = 'false';
            attachGridHandlers();
            importDraftDirty = false;
            clearImportResults({ summary: "Aucun calcul lancé pour l'instant." });
            setImportInputMode('file', { notify: false });
            setImportJourneyState('waiting');
            return true;
        };

        importFileInput?.addEventListener('change', () => markImportDraftDirty('import-file-changed'));
        importDataTextarea?.addEventListener('input', () => markImportDraftDirty('import-paste-edited'));
        importGridBody?.addEventListener('input', () => {
            importInputPanel.dataset.gridPrepared = 'false';
            markImportDraftDirty('import-grid-edited');
            communeImportReview?.invalidate?.();
        });
        importResetBtn?.addEventListener('click', resetImportWorkspace);

        importForm.addEventListener('submit', async (event) => {
            event.preventDefault();
            // Ne pas utiliser stopPropagation ni stopImmediatePropagation pour permettre la navigation
            try {
                await ensureImportWorkspaceLoaded();
            } catch (error) {
                showAppMessage(
                    'error',
                    'Import indisponible',
                    error?.message || 'Le module Import n’a pas pu être chargé.',
                );
                return;
            }
            const activeSource = getActiveImportSource();
            if (activeSource.mode === 'grid') serializeImportGridSource();
            if (!importSourceHasData()) {
                setImportInputMode(activeSource.mode);
                if (importSummary) {
                    importSummary.textContent = 'Ajoutez un fichier ou collez une liste de communes avant de lancer le calcul.';
                }
                setImportJourneyState('rejected', {
                    fieldId: activeSource.fieldId,
                    title: 'Données manquantes',
                    message: 'Ajoutez une source dans la méthode sélectionnée avant de lancer le calcul.',
                });
                showAppMessage(
                    'warning',
                    'Données manquantes',
                    'Ajoutez une source dans la méthode sélectionnée avant de lancer le calcul.',
                );
                return;
            }
            const submissionGeneration = ++importJobGeneration;
            activeImportJob?.cancel?.();
            activeImportJob = null;
            setFormLoading(importForm, true);
            setImportJourneyState('validating', { fieldId: activeSource.fieldId });
            let reviewedFormData;
            try {
                reviewedFormData = await communeImportReview.prepare();
            } catch (error) {
                if (submissionGeneration !== importJobGeneration) return;
                setFormLoading(importForm, false);
                const payload = error?.payload || {};
                const message = payload.error || payload.detail || error?.message
                    || 'La validation des communes a échoué.';
                const errorInfo = normalizeToolError({
                    message,
                    status: error?.status || null,
                    error_code: error?.error_code || payload.error_code || payload.code || null,
                    data: payload,
                });
                const failure = importJourneyFailurePresentation(
                    errorInfo,
                    activeSource.fieldId,
                );
                importSummary.textContent = message;
                setImportJourneyState(failure.state, failure.options);
                showAppMessage(
                    failure.state === 'rejected' ? 'warning' : 'error',
                    failure.options.title,
                    message,
                );
                return;
            }
            if (submissionGeneration !== importJobGeneration) return;
            if (!reviewedFormData) {
                setFormLoading(importForm, false);
                importSummary.textContent = 'Validation terminée. Vérifiez les communes avant de lancer le calcul.';
                const reviewCounts = communeImportReview.getState().counts;
                if (reviewCounts.total > 0 && reviewCounts.calculate === 0 && reviewCounts.pending === 0) {
                    setImportJourneyState('rejected', {
                        fieldId: activeSource.fieldId,
                        message: 'Aucune commune exploitable n’a été trouvée. Corrigez ou remplacez la source.',
                    });
                } else {
                    setImportJourneyState('validation_ready', {
                        message: reviewCounts.pending > 0
                            ? `${reviewCounts.pending} ligne${reviewCounts.pending > 1 ? 's' : ''} à confirmer avant le calcul.`
                            : `${reviewCounts.calculate} commune${reviewCounts.calculate > 1 ? 's' : ''} prête${reviewCounts.calculate > 1 ? 's' : ''} à calculer.`,
                    });
                }
                return;
            }
            applyOriginAdjustmentConfirmation(
                reviewedFormData,
                'import',
                'driving-car',
            );
            window.maplyticsClearOpenedAnalysis?.('import-table');
            communeImportReview.markSubmitted();
            importDraftDirty = false;
            setImportJourneyState('running', {
                progress: 0,
                message: 'Validation confirmée. Préparation du calcul…',
            });

            // Utiliser requestAnimationFrame puis setTimeout pour rendre le traitement vraiment asynchrone
            requestAnimationFrame(() => {
                setTimeout(() => {
                if (submissionGeneration !== importJobGeneration) return;
                importLogs.textContent = 'Calcul en cours...';
                clearImportResults({ summary: '' });
                importLogs.textContent = 'Calcul en cours...';
                importExcelLink.classList.add('premium-disabled');
                updateProgress(importProgress, 0.02, 'Préparation du calcul...');
                let importRunTerminal = false;
                activeImportJob = startAsyncJob({
                form: importForm,
                requestFormData: reviewedFormData,
                url: '/import-table-async',
                onLimit: (data) => {
                    if (submissionGeneration !== importJobGeneration) return;
                    importRunTerminal = true;
                    activeImportJob = null;
                    const message = data.error || data.message
                        || 'La limite de calcul est atteinte pour votre offre actuelle.';
                    importSummary.textContent = message;
                    setImportJourneyState('rejected', {
                        step: 'exploitation',
                        title: 'Limite atteinte',
                        message,
                        retry: false,
                        fieldInvalid: false,
                    });
                    hideProgress(importProgress);
                },
                onProgress: (data) => {
                    if (submissionGeneration !== importJobGeneration || importRunTerminal) return;
                    // Utiliser requestAnimationFrame pour éviter les blocages de rendu
                    requestAnimationFrame(() => {
                        if (submissionGeneration !== importJobGeneration || importRunTerminal) return;
                        importLogs.textContent = (data.logs || []).join('\n') || 'Aucun log retourné.';
                        updateProgress(importProgress, data.percent, data.logs?.slice(-1)[0] || '');
                        const progressPercent = Math.round(
                            Math.max(0, Math.min(1, Number(data.percent) || 0)) * 100,
                        );
                        setImportJourneyState('running', {
                            progress: progressPercent,
                            message: `Calcul en cours : ${progressPercent} %. ${data.logs?.slice(-1)[0] || ''}`,
                        });
                    });
                },
                onComplete: (data, calculationLifecycle = {}) => {
                    if (submissionGeneration !== importJobGeneration) return;
                    importRunTerminal = true;
                    activeImportJob = null;
                    communeImportReview.complete();
                    markResultsPanelHasUpdate('import');
                    const durationText = data.duration ? ` (terminé en ${formatDuration(data.duration)})` : '';
                    const importOriginResolution = originResolutionFromResult(
                        data,
                        calculationLifecycle,
                    );
                    announceOriginResolution(importOriginResolution);
                    importSummary.textContent = `${data.total_rows} communes trouvées${durationText}.`;
                    const resultRows = Array.isArray(data.rows) ? data.rows : [];
                    const unmatchedRows = Array.isArray(data.unmatched) ? data.unmatched : [];
                    const resultState = resultRows.length === 0
                        ? 'empty'
                        : unmatchedRows.length > 0
                            ? 'partial'
                            : 'success';
                    setImportJourneyState(resultState, {
                        message: resultState === 'partial'
                            ? `${resultRows.length} ligne${resultRows.length > 1 ? 's' : ''} exploitable${resultRows.length > 1 ? 's' : ''}, ${unmatchedRows.length} introuvable${unmatchedRows.length > 1 ? 's' : ''}.`
                            : importSummary.textContent,
                    });
                    showToolBridge('import', buildToolBridgeContext('import', data), { usage: data.usage });
                    const isPremium = hasFeature('demographic_data');
                    const currentJobId = data.id || data.job_id || '';
                    importDetailedExportAdapter?.activate?.({
                        jobId: currentJobId,
                        rows: data.rows || [],
                        columns: data.columns || [],
                        mapGeojson: data.map_geojson || null,
                        origin: {
                            latitude: document.getElementById('importLatitude')?.value,
                            longitude: document.getElementById('importLongitude')?.value,
                            label: document.getElementById('importQuery')?.value,
                            address: document.getElementById('importQuery')?.value,
                            origin_resolution: importOriginResolution,
                            requested_origin: importOriginResolution?.requested_origin || null,
                            effective_origin: importOriginResolution?.effective_origin || null,
                        },
                        title: `Import — ${document.getElementById('importQuery')?.value?.trim() || 'communes validées'}`,
                    });
                    tableControllers.import.isPremium = isPremium;
                    populateTable(importTable, data.columns, data.rows);
                    syncImportDetailedExportChoices();

                    // Afficher les éléments de tableau
                    tableControllers.import.container.hidden = false;
                    tableControllers.import.search.hidden = false;
                    tableControllers.import.actions.hidden = false;

                    // Mettre à jour la visibilité des onglets Concurrents et Statistiques
                    // Attendre un peu pour que populateTable termine (elle utilise requestAnimationFrame)
                    setTimeout(() => {
                        if (typeof importZonesManager !== 'undefined' && importZonesManager.updateTabVisibility) {
                            importZonesManager.updateTabVisibility();
                        }
                    }, 100);
                    const statsEl = document.getElementById('importStats');
                    const statsGridEl = document.getElementById('importStatsGrid');
                    const sourceDistEl = document.getElementById('importSourceDistribution');
                    if (statsEl) {
                        statsEl.hidden = false;
                        // Initialiser le toggle des statistiques
                        const statsToggle = document.getElementById('importStatsToggle');
                        const statsContent = document.getElementById('importStatsContent');
                        const statsToggleText = document.getElementById('importStatsToggleText');
                        if (statsToggle && statsContent && statsToggleText) {
                            // Supprimer les anciens listeners en clonant
                            const newStatsToggle = statsToggle.cloneNode(true);
                            statsToggle.parentNode.replaceChild(newStatsToggle, statsToggle);
                            const newStatsToggleText = document.getElementById('importStatsToggleText');

                            newStatsToggle.addEventListener('click', (e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                const isExpanded = statsContent.classList.contains('expanded');
                                if (isExpanded) {
                                    statsContent.classList.remove('expanded');
                                    if (newStatsToggleText) newStatsToggleText.textContent = 'Afficher';
                                } else {
                                    statsContent.classList.add('expanded');
                                    if (newStatsToggleText) newStatsToggleText.textContent = 'Masquer';
                                }
                            });
                            // Afficher par défaut
                            statsContent.classList.add('expanded');
                        }
                    }
                    document.getElementById('importFilters').hidden = false;

                    // Calculer et afficher les statistiques globales
                    const allRows = data.rows || [];
                    const stats = calculateStatistics(allRows);
                    // Les données démographiques suivent leur droit précis,
                    // même si le job ne renvoie pas de snapshot d'usage.
                    renderStatistics(statsEl, statsGridEl, sourceDistEl, stats, isPremium);

                    // Fonction pour mettre à jour les stats lors du filtrage
                    tableControllers.import.updateStats = (newStats) => {
                        // Utiliser le statut premium stocké dans le controller
                        const isPremiumForStats = tableControllers.import.isPremium || false;
                        renderStatistics(statsEl, statsGridEl, sourceDistEl, newStats, isPremiumForStats);
                    };

                    updateUnmatchedList(importUnmatched, data.unmatched || []);
                    if (data.unmatched_file) {
                        unmatchedDownload.hidden = false;
                        unmatchedDownload.href = `/download/${data.unmatched_file}`;
                    }
                    if (data.map_geojson) {
                        importMapController.renderGeoJson(
                            data.map_geojson,
                            null,
                            null,
                            null,
                            { progressive: true }
                        );
                    }

                    // Mettre à jour les liens de téléchargement
                    // CSV et GeoJSON sont les sorties propriétaires du job.
                    // Les exports filtrés restent disponibles sur les surfaces
                    // d'analyse dédiées, mais ne doivent pas masquer ces fichiers.
                    if (data.file) {
                        importDownload.hidden = false;
                        importDownload.href = `/download/${data.file}`;
                    }
                    if (data.iso_file) {
                        importIsoLink.hidden = false;
                        importIsoLink.href = `/download/${data.iso_file}`;
                    }

                    // La copie du tableau visible reste distincte du droit d'export Excel.
                    const importSelectAllBtn = document.getElementById('importSelectAllBtn');
                    if (importSelectAllBtn) {
                        importSelectAllBtn.disabled = false;
                        importSelectAllBtn.classList.remove('premium-disabled');
                        importSelectAllBtn.setAttribute('aria-disabled', 'false');
                    }

                    // Stocker le job_id pour les exports (doit être disponible globalement)
                    // Stocker dans un attribut data pour pouvoir le récupérer plus tard
                    importExcelLink.setAttribute('data-job-id', currentJobId);

                    // Afficher l'export Excel avancé. Le PDF reste disponible
                    // depuis la surface d'export dédiée, pas dans l'import.
                    importExcelLink.hidden = false;

                    // Configurer les handlers selon le statut d'accès
                    // Supprimer les anciens event listeners en clonant les éléments
                    const newImportExcelLink = importExcelLink.cloneNode(true);
                    importExcelLink.parentNode.replaceChild(newImportExcelLink, importExcelLink);
                    importExcelLink = newImportExcelLink;

                    if (hasFeature('export_excel')) {
                        newImportExcelLink.classList.remove('premium-disabled');
                        newImportExcelLink.style.pointerEvents = 'auto';
                        newImportExcelLink.style.cursor = 'pointer';
                        newImportExcelLink.setAttribute('data-job-id', currentJobId);
                        newImportExcelLink.addEventListener('click', async function(e) {
                            e.preventDefault();
                            e.stopPropagation();
                            await waitForMultiZoneExcelRuntime();
                            openMultiZoneExcelDialog(newImportExcelLink, 'import');
                        });
                    } else {
                        newImportExcelLink.classList.add('premium-disabled');
                        newImportExcelLink.style.pointerEvents = 'auto';
                        newImportExcelLink.style.cursor = 'not-allowed';
                        newImportExcelLink.addEventListener('click', function(e) {
                            e.preventDefault();
                            e.stopPropagation();
                            showPremiumNotice('l’export Excel', 'L’export Excel est inclus à partir du plan Étudiant.');
                        });
                    }

                    saveToolResultSnapshot('import', {
                        data,
                        context: latestToolBridgeContext.import,
                        usage: data.usage,
                        table: {
                            columns: data.columns || tableControllers.import.columns || [],
                            rows: data.rows || tableControllers.import.allRows || [],
                            isPremium,
                        },
                        map_geojson: data.map_geojson,
                    });
                    if (importClearResultsBtn) importClearResultsBtn.hidden = false;

                    hideProgress(importProgress);
                    requestAnimationFrame(() => {
                        if (submissionGeneration !== importJobGeneration) return;
                        syncImportJourneyExportState();
                    });
                },
                onError: (error) => {
                    if (submissionGeneration !== importJobGeneration) return;
                    importRunTerminal = true;
                    activeImportJob = null;
                    const errorInfo = normalizeToolError(error);
                    if (errorInfo.error_code === 'origin_access_confirmation_required') {
                        importSummary.textContent = errorInfo.message;
                        setImportJourneyState('validation_ready', {
                            message: errorInfo.message,
                            retry: true,
                            fieldInvalid: false,
                        });
                        hideProgress(importProgress);
                        requestOriginAdjustmentConfirmation({
                            errorInfo,
                            surface: 'import',
                            form: importForm,
                            formData: reviewedFormData,
                            transportMode: 'driving-car',
                            onChooseOther: () => {
                                communeImportReview.handleCalculationError(errorInfo);
                                document.getElementById('importQuery')?.focus?.({preventScroll: true});
                            },
                        });
                        return;
                    }
                    communeImportReview.handleCalculationError(errorInfo);
                    importSummary.textContent = errorInfo.message;
                    const failure = importJourneyFailurePresentation(
                        errorInfo,
                        activeSource.fieldId,
                    );
                    setImportJourneyState(failure.state, failure.options);
                    hideProgress(importProgress);
                },
                });
                }, 0);
            });
        });

        importClearResultsBtn?.addEventListener('click', () => {
            clearImportResults();
            const source = getActiveImportSource();
            setImportJourneyState(
                importSourceHasData() ? 'file_selected' : 'waiting',
                { fieldId: source.fieldId },
            );
        });

        importHeadersBtn.addEventListener('click', () => {
            communeImportReview?.invalidate?.();
            importDataTextarea.value = 'nom_commune,code_postal,code_insee\nRiom,63200,63300\nLyon,,69123';
            markImportDraftDirty();
        });
        importSampleBtn.addEventListener('click', () => {
            communeImportReview?.invalidate?.();
            importDataTextarea.value = [
                'nom_commune,code_postal,code_insee',
                'Charbonnières-les-Varennes,63410,63091',
                'Gerzat,63360,63164',
                'Sayat,63530,63417',
            ].join('\n');
            markImportDraftDirty();
        });

        gridAddRowBtn.addEventListener('click', () => {
            addEditableRow();
            markImportDraftDirty();
        });
        gridClearBtn.addEventListener('click', () => {
            communeImportReview?.invalidate?.();
            importGridBody.innerHTML = '';
            addEditableRow();
            markImportDraftDirty();
        });
        gridApplyBtn.addEventListener('click', () => {
            communeImportReview?.invalidate?.();
            serializeImportGridSource();
            markImportDraftDirty();

            // S'assurer que la carte est visible après avoir appliqué le tableau
            invalidateMapControllerWhenVisible(importMapController, 100);
        });

        // Initialiser: d'abord vérifier auth pour récupérer le token utilisateur, puis mettre à jour le compteur
        const homeBootstrapGeneration = homePageLifecycleGeneration;
        const isHomeBootstrapCurrent = () => homeBootstrapGeneration === homePageLifecycleGeneration;
        window.maplyticsHomeBootstrapReady = checkAuthAndSetToken().then(async () => {
            if (!isHomeBootstrapCurrent()) return false;
            const workspaceDraft = await homeWorkspaceDraftReady;
            if (!isHomeBootstrapCurrent()) return false;
            updateUsageCounter();
            updateUIBasedOnFeatures();
            const pendingProjectLoad = window.maplyticsPendingLegacyProjectLoad;
            const pendingProjectTool = String(pendingProjectLoad?.toolType || '');
            const loadPendingProject = async (manager, tabManager, tabId) => {
                if (!pendingProjectLoad || !connectedUserToken || !manager?.loadProject) {
                    return false;
                }
                const loaded = await manager.loadProject(pendingProjectLoad.projectId);
                if (!isHomeBootstrapCurrent()) return false;
                if (loaded && window.maplyticsPendingLegacyProjectLoad === pendingProjectLoad) {
                    window.maplyticsPendingLegacyProjectLoad = null;
                    tabManager?.switchTab?.(tabId);
                    window.history.replaceState({}, '', window.location.pathname);
                }
                return Boolean(loaded);
            };
            // Mettre à jour la visibilité des onglets après récupération du statut Premium
            if (typeof zonesManager !== 'undefined' && zonesManager.updateTabVisibility) {
                zonesManager.updateTabVisibility();
            }
            if (typeof importZonesManager !== 'undefined' && importZonesManager.updateTabVisibility) {
                importZonesManager.updateTabVisibility();
            }
            showLegacyZonesRecoveryPrompt();
            // Charger les zones sauvegardées (depuis localStorage d'abord, puis serveur si connecté)
            if (typeof zonesManager !== 'undefined' && zonesManager.loadZones) {
                if (connectedUserToken) {
                    const loaded = await zonesManager.loadZones({ automatic: true });
                    if (!isHomeBootstrapCurrent()) return false;
                    if (loaded) {
                        (window.debugLog || (() => {}))('Zones sauvegardées chargées depuis serveur avec succès');
                    }
                } else if (zonesManager.loadZonesFromLocalStorage) {
                    zonesManager.loadZonesFromLocalStorage({ automatic: true });
                }
            }

            // Une ouverture de projet explicite gagne toujours. Sinon, restaurer
            // le compagnon local uniquement s'il correspond exactement à la ZDC,
            // puis utiliser la sauvegarde serveur comme repli connecté.
            let explicitIsochroneProjectLoaded = false;
            if (pendingProjectTool === 'isochrone') {
                explicitIsochroneProjectLoaded = await loadPendingProject(
                    competitorsManager,
                    zonesManager,
                    'tab2',
                );
                if (!isHomeBootstrapCurrent()) return false;
            }
            if (!explicitIsochroneProjectLoaded) {
                const localWorkspaceRestored = Boolean(workspaceDraft?.restore?.());
                if (
                    !localWorkspaceRestored
                    && typeof competitorsManager !== 'undefined'
                    && competitorsManager.loadCompetitors
                    && connectedUserToken
                ) {
                    const loaded = await competitorsManager.loadCompetitors({ automatic: true });
                    if (!isHomeBootstrapCurrent()) return false;
                    if (loaded) {
                        workspaceDraft?.persist?.();
                        (window.debugLog || (() => {}))('Concurrents sauvegardés chargés avec succès (Isochrone)');
                    }
                }
            }

            if (typeof importCompetitorsManager !== 'undefined' && importCompetitorsManager.loadCompetitors && connectedUserToken) {
                const explicitImportProjectLoaded = pendingProjectTool === 'import-table'
                    ? await loadPendingProject(
                        importCompetitorsManager,
                        importZonesManager,
                        'importTab2',
                    )
                    : false;
                if (!isHomeBootstrapCurrent()) return false;
                if (!explicitImportProjectLoaded) {
                    const loaded = await importCompetitorsManager.loadCompetitors({ automatic: true });
                    if (!isHomeBootstrapCurrent()) return false;
                    if (loaded) {
                        (window.debugLog || (() => {}))('Concurrents sauvegardés chargés avec succès (Import-table)');
                    }
                }
            }

            // The bridge restore is the final bootstrap authority.  Waiting for
            // it gives project loads, browser drafts and tests one deterministic
            // readiness boundary instead of racing a detached timer.
            await new Promise((resolve) => window.setTimeout(resolve, 250));
            if (!isHomeBootstrapCurrent()) return false;
            await restoreToolResultSnapshot().catch((error) => {
                console.warn('[Tool bridge] restauration impossible:', error);
            });
            return isHomeBootstrapCurrent();
        });
        window.maplyticsHomeBootstrapReady.catch((error) => {
            console.error('[Home bootstrap] initialisation impossible:', error);
        });

        window.addEventListener('pageshow', (event) => {
            if (event.persisted) {
                const restoreOpenSequence = historyManager?.openIntentSequence || 0;
                if (restoreOpenSequence > 0) return;
                const snapshot = readToolResultSnapshot();
                if (snapshot?.scrollY !== undefined) {
                    requestAnimationFrame(() => {
                        if ((historyManager?.openIntentSequence || 0) !== restoreOpenSequence) {
                            return;
                        }
                        window.scrollTo({
                            top: Number(snapshot.scrollY || 0),
                            behavior: 'auto',
                        });
                    });
                }
                return;
            }
            // A normal navigation is already covered by the bootstrap promise.
            // Running a second delayed restore here could overwrite a newer
            // project or user mutation.  Only bfcache restores need pageshow.
        });

        // Afficher les publicités uniquement sur desktop ET si pas la feature no_ads
        function checkAdDisplay() {
            // Si feature no_ads, ne jamais afficher les pubs
            if (hasFeature('no_ads')) {
                const headerAd = document.getElementById('headerAd');
                if (headerAd) headerAd.style.display = 'none';
                return;
            }

            if (window.innerWidth >= 1200) {
                const headerAd = document.getElementById('headerAd');
                if (headerAd) headerAd.style.display = 'block';
            } else {
                const headerAd = document.getElementById('headerAd');
                if (headerAd) headerAd.style.display = 'none';
            }
        }
        window.addEventListener('resize', checkAdDisplay);
        checkAdDisplay();

        if (!APP_CONFIG.enableLegacyAdminPanel) {
            const publicUsageCounterCard = document.getElementById('usageCounter');
            if (publicUsageCounterCard && publicUsageCounterCard.dataset.pricingBound !== '1') {
                publicUsageCounterCard.dataset.pricingBound = '1';
                publicUsageCounterCard.addEventListener('click', () => {
                    window.location.href = publicUsageCounterCard.dataset.upgradeUrl || '/pricing';
                });
            }
        }

        if (APP_CONFIG.enableLegacyAdminPanel) {
        // Zone Admin legacy
        const adminPanel = document.getElementById('adminPanel');
        const usageCounterCard = document.getElementById('usageCounter');
        const adminCode = document.getElementById('adminCode');
        const adminResetToken = document.getElementById('adminResetToken');
        const adminResetAll = document.getElementById('adminResetAll');
        const adminStats = document.getElementById('adminStats');
        const adminClose = document.getElementById('adminClose');
        const adminResult = document.getElementById('adminResult');

        // Afficher/masquer la zone admin en cliquant sur la carte "Calculs gratuits"
        // Toujours permettre l'accès au panneau admin, même si limite atteinte
        if (usageCounterCard) {
            usageCounterCard.addEventListener('click', async () => {
                // Toujours ouvrir la zone admin (même si limite atteinte)
                adminPanel.style.display = adminPanel.style.display === 'none' ? 'block' : 'none';
                if (adminPanel.style.display === 'block') {
                    adminCode.focus();
                }
            });
        }

        // Raccourci clavier Ctrl+Shift+A
        document.addEventListener('keydown', (e) => {
            if (e.ctrlKey && e.shiftKey && e.key === 'A') {
                e.preventDefault();
                adminPanel.style.display = adminPanel.style.display === 'none' ? 'block' : 'none';
                if (adminPanel.style.display === 'block') {
                    adminCode.focus();
                }
            }
        });

        // Réinitialiser le token actuel
        if (adminResetToken) {
            adminResetToken.addEventListener('click', async () => {
                const code = adminCode.value.trim();
                if (!code) {
                    adminResult.textContent = '❌ Entrez le code admin';
                    adminResult.style.display = 'block';
                    adminResult.style.background = '#fee2e2';
                    return;
                }

                const token = getOrCreateToken();
                const formData = new FormData();
                formData.append('token', token);
                formData.append('admin_code', code);

                try {
                    const response = await fetch('/backoffice-rtbr/reset-token', {
                        method: 'POST',
                        body: formData
                    });
                    const data = await response.json();

                    if (data.success) {
                        adminResult.textContent = `✅ ${data.message}`;
                        adminResult.style.display = 'block';
                        adminResult.style.background = '#d1fae5';
                        updateUsageCounter();
                    } else {
                        adminResult.textContent = `❌ ${data.error}`;
                        adminResult.style.display = 'block';
                        adminResult.style.background = '#fee2e2';
                    }
                } catch (error) {
                    adminResult.textContent = `❌ Erreur: ${error.message}`;
                    adminResult.style.display = 'block';
                    adminResult.style.background = '#fee2e2';
                }
            });
        }

        // Réinitialiser tous les tokens
        if (adminResetAll) {
            adminResetAll.addEventListener('click', async () => {
                const code = adminCode.value.trim();
                if (!code) {
                    adminResult.textContent = '❌ Entrez le code admin';
                    adminResult.style.display = 'block';
                    adminResult.style.background = '#fee2e2';
                    return;
                }

                if (!confirm('Êtes-vous sûr de vouloir réinitialiser TOUS les compteurs ?')) {
                    return;
                }

                const formData = new FormData();
                formData.append('admin_code', code);

                try {
                    const response = await fetch('/backoffice-rtbr/reset-all', {
                        method: 'POST',
                        body: formData
                    });
                    const data = await response.json();

                    if (data.success) {
                        adminResult.textContent = `✅ ${data.message}`;
                        adminResult.style.display = 'block';
                        adminResult.style.background = '#d1fae5';
                        updateUsageCounter();
                    } else {
                        adminResult.textContent = `❌ ${data.error}`;
                        adminResult.style.display = 'block';
                        adminResult.style.background = '#fee2e2';
                    }
                } catch (error) {
                    adminResult.textContent = `❌ Erreur: ${error.message}`;
                    adminResult.style.display = 'block';
                    adminResult.style.background = '#fee2e2';
                }
            });
        }

        // Voir les stats
        if (adminStats) {
            adminStats.addEventListener('click', async () => {
                const code = adminCode.value.trim();
                if (!code) {
                    adminResult.textContent = '❌ Entrez le code admin';
                    adminResult.style.display = 'block';
                    adminResult.style.background = '#fee2e2';
                    return;
                }

                try {
                    const response = await fetch(`/backoffice-rtbr/stats?admin_code=${encodeURIComponent(code)}`);
                    const data = await response.json();

                    if (data.success) {
                        const stats = data.stats;
                        adminResult.innerHTML = `
                            <strong>📊 Statistiques</strong><br>
                            Utilisateurs totaux: ${stats.total_users}<br>
                            Calculs totaux: ${stats.total_usage}<br>
                            Utilisateurs à la limite: ${stats.users_at_limit}<br>
                            Limite: ${stats.limit} calculs/jour
                        `;
                        adminResult.style.display = 'block';
                        adminResult.style.background = '#e0e7ff';
                    } else {
                        adminResult.textContent = `❌ ${data.error}`;
                        adminResult.style.display = 'block';
                        adminResult.style.background = '#fee2e2';
                    }
                } catch (error) {
                    adminResult.textContent = `❌ Erreur: ${error.message}`;
                    adminResult.style.display = 'block';
                    adminResult.style.background = '#fee2e2';
                }
            });
        }

        // Activer Premium pour le token actuel
        const adminSetPlan = document.getElementById('adminSetPlan');
        if (adminSetPlan) {
            adminSetPlan.addEventListener('click', async () => {
                const code = adminCode.value.trim();
                const planSelect = document.getElementById('adminPlanSelect');
                const planId = planSelect.value;

                if (!code) {
                    adminResult.textContent = '❌ Entrez le code admin';
                    adminResult.style.display = 'block';
                    adminResult.style.background = '#fee2e2';
                    return;
                }

                if (!planId) {
                    adminResult.textContent = '❌ Sélectionnez un plan';
                    adminResult.style.display = 'block';
                    adminResult.style.background = '#fee2e2';
                    return;
                }

                const token = getOrCreateToken();
                const formData = new FormData();
                formData.append('token', token);
                formData.append('plan_id', planId);
                formData.append('admin_code', code);

                try {
                    const response = await fetch('/backoffice-rtbr/set-user-plan', {
                        method: 'POST',
                        body: formData
                    });

                    // Vérifier si la réponse est OK avant de parser JSON
                    if (!response.ok) {
                        const errorText = await response.text();
                        adminResult.textContent = `❌ Erreur ${response.status}: ${errorText.substring(0, 100)}`;
                        adminResult.style.display = 'block';
                        adminResult.style.background = '#fee2e2';
                        return;
                    }

                    const data = await response.json();

                    if (data.success) {
                        adminResult.textContent = `✅ ${data.message}`;
                        adminResult.style.display = 'block';
                        adminResult.style.background = '#d1fae5';
                        updateUsageCounter();
                    } else {
                        adminResult.textContent = `❌ ${data.error || 'Erreur inconnue'}`;
                        adminResult.style.display = 'block';
                        adminResult.style.background = '#fee2e2';
                    }
                } catch (error) {
                    adminResult.textContent = `❌ Erreur: ${error.message}`;
                    adminResult.style.display = 'block';
                    adminResult.style.background = '#fee2e2';
                }
            });
        }

        // Fermer la zone admin
        if (adminClose) {
            adminClose.addEventListener('click', () => {
                adminPanel.style.display = 'none';
                adminCode.value = '';
                adminResult.style.display = 'none';
            });
        }
        }
